/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "dist/js";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(10);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var nativeError = console.error;
	//导入框架包
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var Provider = __webpack_require__(13).Provider;
	var RemotePreviewHelp = __webpack_require__(45);
	var envHelper = __webpack_require__(48);
	var storeHelper = __webpack_require__(49);
	var IOSWarning = __webpack_require__(50);
	var AppError = __webpack_require__(52);
	var i18n = __webpack_require__(46);
	var logHelper = __webpack_require__(53);
	var Preview;
	var appPath;
	__webpack_require__(54);
	
	var configHelper = __webpack_require__(58);
	var projectLoadHelper = __webpack_require__(68);
	
	var AppStore = __webpack_require__(126);
	var Authorization = __webpack_require__(131);
	
	if (window.isDev || location.href.indexOf('isDev=true') !== -1) {} else {
	  console.log = function () {};
	  console.warn = function () {};
	  // console.error = function (e) {
	  //   logHelper.error(e, true);
	  //   nativeError.apply(this, arguments);
	  // };
	}
	
	// window.onerror = function (msg, url, lineNo, columnNo, error) {
	//   var string = msg.toLowerCase();
	//   var substring = 'script error';
	//   if (string.indexOf(substring) > -1) {
	//     console.log('see browser console for details');
	//     logHelper.onerror('see browser console for detailssee browser console for details');
	//   } else {
	//     logHelper.onerror(msg, url, lineNo, columnNo, error);
	//   }
	// };
	
	//判断设备，设置路径参数
	if (envHelper.isMobileDevice()) {
	  // if (true) {
	  Preview = __webpack_require__(132);
	  appPath = 'data/项目.mp';
	} else {
	  Preview = __webpack_require__(332);
	  // appPath = storeHelper.get('path') || window.path || 'data/test9.mt';
	  appPath = 'data/test12.mp';
	  // appPath = 'data/11.17测试.mp';
	  // appPath = 'data/双重福利活动需求2017-11-08.mp';
	  // appPath = 'data/avatar.mp';
	}
	
	function renderWeChatGuide(name, logo) {
	  ReactDOM.render(React.createElement(
	    IOSWarning,
	    { name: name, logo: logo, arrowClassName: 'top-right' },
	    React.createElement(
	      'p',
	      null,
	      i18n.get('CLICK_MENU')
	    ),
	    React.createElement(
	      'p',
	      null,
	      i18n.get('OPEN_IN_SAFARI')
	    )
	  ), document.getElementById('container'));
	}
	
	function renderQQGuide(name, logo) {
	  ReactDOM.render(React.createElement(
	    IOSWarning,
	    { name: name, logo: logo, arrowClassName: 'top-right' },
	    React.createElement(
	      'p',
	      null,
	      i18n.get('CLICK_MENU')
	    ),
	    React.createElement(
	      'p',
	      null,
	      i18n.get('OPEN_IN_SAFARI')
	    )
	  ), document.getElementById('container'));
	}
	
	function renderSafariGuide(name, logo) {
	  ReactDOM.render(React.createElement(
	    IOSWarning,
	    { name: name, logo: logo, arrowClassName: 'bottom-center' },
	    React.createElement(
	      'p',
	      null,
	      i18n.get('CLICK_DOWN'),
	      ' ',
	      React.createElement('img', {
	        src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAA1CAQAAACHdlEQAAAAiklEQVR4Ae3RQQrCQAyF4X+kd+hp5jyB8fZ6gLiSh8hAmBRRm3/RVfh4TAllGAc1cJxxHCUuT4nLUld9GVkKHAdxCeqJiUtQwsStU8IWuJ37y7kwcTd2gnUMphgYnYWEBboQ74exDWde4z3/1DItCDa79f/5m4UVVlhhG5FavVlhhRV2LqzhX7rsATJGRfK0Ul+XAAAAAElFTkSuQmCC',
	        width: '20',
	        alt: 'share' }),
	      ' ',
	      i18n.get('CLICK_DOWN2')
	    ),
	    React.createElement(
	      'p',
	      null,
	      i18n.get('ADD_HOME')
	    )
	  ), document.getElementById('container'));
	}
	
	function renderRemoteWarning() {
	  ReactDOM.render(React.createElement(RemotePreviewHelp, null), document.getElementById('container'));
	}
	
	//渲染预览界面
	function renderPreview(app, config) {
	  var store = AppStore({
	    app: app,
	    config: config
	  });
	  ReactDOM.render(React.createElement(
	    Provider,
	    { store: store },
	    React.createElement(Preview, { path: appPath })
	  ), document.getElementById('container'));
	}
	
	function renderError(err) {
	  console.error(err);
	  ReactDOM.render(React.createElement(AppError, { error: err }), document.getElementById('container'));
	}
	
	function createIcon(icon) {
	  var link = document.createElement('link');
	  link.rel = 'apple-touch-icon';
	  link.href = icon;
	  document.getElementsByTagName('head')[0].appendChild(link);
	}
	
	function isNotMobileProject(platform) {
	  return platform !== 'MtMobile' && platform !== 'MtPad';
	}
	
	function previewApp(app) {
	  window.document.title = app.name;
	  var platform = app.params.projectParam.platform;
	  if (envHelper.isMobileDevice() && isNotMobileProject(platform) && window.location.href.indexOf('force=1') === -1) {
	    return renderError(new Error(i18n.get('NOT_AVAILABLE_ON_MOBILE')));
	  }
	  configHelper.getConfig(function (err, config) {
	    if (err) {
	      return renderError(err);
	    }
	    if (isNotMobileProject(platform)) {
	      config.showQRCode = true; // 非移动项目, 不显示二维码
	    }
	    createIcon(config.logo);
	    if (envHelper.isiOS() && !envHelper.isStandalone() && configHelper.notForceUseCurrentBrowser() && config.iOSGuide && !envHelper.isWxMiniApp()) {
	      if (envHelper.isWeChat()) {
	        return renderWeChatGuide(app.name, config.logo);
	      } else if (envHelper.isQQ()) {
	        return renderQQGuide(app.name, config.logo);
	      }
	      return renderSafariGuide(app.name, config.logo);
	    }
	    return renderPreview(app, config);
	  });
	}
	
	function authorization() {
	  ReactDOM.render(React.createElement(Authorization, null), document.getElementById('container'));
	}
	
	/*
	 * 执行
	 * */
	if (window.remote && document.location.protocol.indexOf('http') !== 0) {
	  // 是远程加载,但是该页面却不是 http/https 的
	  renderRemoteWarning();
	} else {
	  projectLoadHelper.loadApp(appPath, function (err, app, statusCode) {
	    if (err) {
	      if (statusCode === 401) {
	        return authorization();
	      }
	      return renderError(err);
	    }
	    previewApp(app);
	  });
	}

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = React;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = ReactDOM;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(14);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(20);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(11);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(18);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(16)();
	}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(17);
	
	function emptyFunction() {}
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(11);
	
	var _storeShape = __webpack_require__(18);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(21);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(22);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(25);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(43);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(44);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(23);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(24);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(38);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(40);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(41);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(42);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(25);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(35);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(26),
	    getPrototype = __webpack_require__(32),
	    isObjectLike = __webpack_require__(34);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(27),
	    getRawTag = __webpack_require__(30),
	    objectToString = __webpack_require__(31);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(28);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(29);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(27);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(33);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(37);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(36)(module)))

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(24);
	
	var _isPlainObject = __webpack_require__(25);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(42);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var i18n = __webpack_require__(46);
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'remote-preview-help' },
	      React.createElement(
	        'p',
	        null,
	        i18n.get('REMOTE_1'),
	        ' ',
	        React.createElement(
	          'a',
	          { href: 'index.html' },
	          i18n.get('REMOTE_2'),
	          ' index.html'
	        ),
	        i18n.get('REMOTE_3')
	      ),
	      React.createElement(
	        'p',
	        null,
	        i18n.get('REMOTE_4'),
	        ' ',
	        React.createElement(
	          'a',
	          { href: 'README.txt' },
	          'README.txt'
	        ),
	        i18n.get('REMOTE_3')
	      )
	    );
	  }
	});

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var runtimeHelper = __webpack_require__(47);
	var envHelper = __webpack_require__(48);
	
	var cn = {
	  LOADING: '数据载入中...',
	  FAIL_TO_LOAD: '抱歉，加载数据失败。',
	  REMOTE_1: '错误：不能直接在本地打开此页面, 如果你需要在本地预览, 请',
	  REMOTE_2: '查看 ',
	  REMOTE_3: '。',
	  REMOTE_4: '如需帮助请查看',
	  ALWAYS_SHOW_LINK: '始终显示链接',
	  HOVER_SHOW_LINK: '鼠标滑过时，显示链接',
	  HOVER_SHOW_REMARK: '鼠标滑过时，显示备注',
	  SHOW_REMARKS: '显示批注',
	  SETTINGS: '控制面板',
	  RIGHT_PANEL: runtimeHelper.canReview() ? '评论及备注' : '备注',
	  HOME: '首页',
	  PREV: '后退',
	  NEXT: '前进',
	  PLAYBACK: '回放',
	  QRCODE: '推荐使用微信扫码',
	  ERROR: '错误：',
	  HELP: '',
	  INSTALL: '添加到主屏幕',
	  CLICK_DOWN: '请点击屏幕下方的',
	  CLICK_DOWN2: '',
	  ADD_HOME: '选择“添加到主屏幕”',
	  CLICK_MENU: '请点击屏幕右上角菜单',
	  SKIP_INSTALL: '添加后可以获得最佳体验。暂时不想添加？',
	  OPEN_NOW: '直接打开',
	  OPEN_IN_SAFARI: '选择“在Safari中打开”',
	  SITE_MAP_ERROR: '\u54E6\u55EC\uFF0C\u51FA\u9519\u4E86\uFF01\n\xA0\n\u7AD9\u70B9\u5730\u56FE\u7684\u8282\u70B9\u914D\u7F6E\u4E0D\u6B63\u786E\uFF0C\u4F60\u5E94\u8BE5\u50CF\u8FD9\u6837\u914D\u7F6E\uFF1A\n\xA0\n\u9996\u9875\n-\u516C\u53F8\n-\u4EA7\u54C1...',
	  NOT_AVAILABLE_ON_MOBILE: '不支持在移动设备上查看此项目。',
	  ENTER_PASSWORD: '请输入访问密码',
	  PASSWORD: '访问密码',
	  VALIDATE: '验证',
	  PASSWORD_CANNOT_BE_EMPTY: '密码不能为空。',
	  WRONG_PASSWORD: '密码错误。',
	  RIGHT_PASSWORD: '验证成功。',
	
	  COMMENT_HINT: '说点什么...',
	  SIGN_HINT: '请输入你的名字',
	  SIGN_LABEL: '签名',
	  SUBMIT: '发表',
	  ENTER_SIGN: '请输入签名后再评论。',
	  BUTTON_SURE: '确定',
	  NO_REMARK: '暂无备注。',
	  NO_REVIEW: '暂无审阅信息。',
	  PAINT_TIP: '标注了页面。',
	  REVIEW_LOADING: '正在加载...',
	  NET_ERROR: '网络错误。',
	  LOAD_REVIEW_FAILED: '加载数据失败。',
	  SIGN_ALERT_MSG: '请输入你的签名',
	  SIGN_TIP: '*此签名用于识别团队成员。',
	  SAVING: '正在保存数据...',
	  SAVE_ALERT_MSG: '你还有修改未保存，是否保存？',
	  BUTTON_SAVE: '保存',
	  BUTTON_CANCEL: '放弃',
	  SAVE_FAILED_MSG: '条数据保存失败！',
	
	  REMARK: '备注',
	  COMMENT: '评论',
	  VIEW_COMMENT: '查看评论',
	  VIEW_MARK: '查看标注',
	  HIDDEN_MARK: '隐藏标注',
	
	  MARK: '标注',
	
	  IMAGE: '图片',
	
	  COPIED_PAGE_LINK: '当前页面的链接已复制。',
	  REQUEST_SOURCE_ERROR: '加载资源失败，请检查你的网络连接，建议将 DNS 设置为 223.5.5.5 然后重试。'
	};
	
	var en = {
	  LOADING: 'Loading...',
	  FAIL_TO_LOAD: 'Sorry, failed to load data.',
	  REMOTE_1: 'Error: This page cannot be opened directly from local. If you would like to preview it offline, please ',
	  REMOTE_2: 'view ',
	  REMOTE_3: '.',
	  REMOTE_4: 'Read this for help',
	  ALWAYS_SHOW_LINK: 'Always show link',
	  HOVER_SHOW_LINK: 'Show link when mouse over',
	  HOVER_SHOW_REMARK: 'Show remark when mouse over',
	  SHOW_REMARKS: 'Show markup',
	  SETTINGS: 'Control panel',
	  RIGHT_PANEL: runtimeHelper.canReview() ? 'Comment & Remark' : 'Remark',
	  HOME: 'Home',
	  PREV: 'Back',
	  NEXT: 'Forward',
	  PLAYBACK: 'Playback',
	  QRCODE: 'Scan QR code to view on mobile',
	  ERROR: 'Error:',
	  HELP: 'If you need assistance, please shoot us an email at support@jongde.com.',
	  INSTALL: 'Install This Prototype',
	  CLICK_DOWN: 'Tap the below share button',
	  CLICK_DOWN2: '',
	  ADD_HOME: 'Then choose “Add to Home Screen”',
	  CLICK_MENU: 'Tap the menu at the upper right corner',
	  SKIP_INSTALL: 'Install now to get the best experience. Install later?',
	  OPEN_NOW: 'Open directly',
	  OPEN_IN_SAFARI: 'Then choose “Open in Safari”',
	  SITE_MAP_ERROR: 'Errors!\n\xA0\nNodes configured for site map are false and you should configure therm as follows:\n\xA0\nHome\n-Company\n-Product...',
	  NOT_AVAILABLE_ON_MOBILE: 'This project cannot be viewed on mobile device.',
	  ENTER_PASSWORD: 'Please enter password',
	  PASSWORD: 'Password',
	  VALIDATE: 'Validate',
	  PASSWORD_CANNOT_BE_EMPTY: 'Password can\'t be empty.',
	  WRONG_PASSWORD: 'Wrong password, please try again.',
	  RIGHT_PASSWORD: 'Verified successfully!',
	  COMMENT_HINT: 'Write down your comments...',
	  SIGN_HINT: 'Please enter your name',
	  SIGN_LABEL: 'Name',
	  SUBMIT: 'Submit',
	  ENTER_SIGN: 'Please enter your name before submitting the comment. ',
	  BUTTON_SURE: 'OK',
	  NO_REMARK: 'No remark now.',
	  NO_REVIEW: 'No review information now.',
	  PAINT_TIP: 'Marked up the page.',
	  REVIEW_LOADING: 'Loading...',
	  NET_ERROR: 'Network Error.',
	  LOAD_REVIEW_FAILED: 'Failed to load data.',
	  SIGN_ALERT_MSG: 'Please enter your name',
	  SIGN_TIP: '*This name is used to identify the team member. ',
	  SAVING: 'Saving...',
	  SAVE_ALERT_MSG: 'Some changes haven\'t been saved. Save now?',
	  BUTTON_SAVE: 'Save',
	  BUTTON_CANCEL: 'Cancel',
	  SAVE_FAILED_MSG: ' piece(s) of data failed to save!',
	  REMARK: 'Remark',
	  COMMENT: 'Comment',
	  VIEW_COMMENT: 'View comment',
	  VIEW_MARK: 'Show markup',
	  HIDDEN_MARK: 'Hide markup',
	  MARK: 'Markup',
	  IMAGE: 'Image',
	  COPIED_PAGE_LINK: 'The current page link was copied.',
	  REQUEST_SOURCE_ERROR: 'Failed to load data. Please check your network connection. It is recommended to set your DNS to 8.8.8.8 and try again.'
	};
	
	var jp = {
	  LOADING: 'データを読み込み中...',
	  FAIL_TO_LOAD: '申し訳ございませんが、データの読み込みに失敗しました。',
	  REMOTE_1: 'エラー：ローカルでこのページを開くことができないため、ローカルでプレビューしたい場合、次を',
	  REMOTE_2: 'チェックしてください ',
	  REMOTE_3: '。',
	  REMOTE_4: 'ヘルプが必要である場合、次をチェックしてください',
	  ALWAYS_SHOW_LINK: 'リンクを常時に表示',
	  HOVER_SHOW_LINK: 'マウスオーバーの場合は、リンクを表示',
	  HOVER_SHOW_REMARK: 'マウスオーバーの場合は、備考を表示',
	  SHOW_REMARKS: 'コメントを表示',
	  SETTINGS: 'コントロールパネル',
	  RIGHT_PANEL: runtimeHelper.canReview() ? 'コメントおよび備考' : '備考',
	  HOME: 'ホームページ',
	  PREV: '前のページ',
	  NEXT: '次のページ',
	  PLAYBACK: 'プレイバック',
	  QRCODE: '二次元コードをスキャンして、携帯にチェックしてください',
	  ERROR: 'エラー：',
	  HELP: '',
	  INSTALL: 'このアプリをインストール',
	  CLICK_DOWN: '画面下部にある',
	  CLICK_DOWN2: 'をクリックしてください',
	  ADD_HOME: '「メインスクリーンに追加」を選択',
	  CLICK_MENU: 'スクリーンの右上にあるメニューをクリックしてください',
	  SKIP_INSTALL: 'インストール後にベスト体験を受けることができます。まだインストールを決めていない場合',
	  OPEN_NOW: '直接開く',
	  OPEN_IN_SAFARI: '「Safariで開く」を選択',
	  SITE_MAP_ERROR: '\u3042\u3089\u3001\u30A8\u30E9\u30FC\u304C\u767A\u751F\u307E\u3057\u305F\uFF01\n\xA0\n\u30B5\u30A4\u30C8\u5730\u56F3\u306E\u30CE\u30FC\u30C9\u306F\u6B63\u3057\u304F\u914D\u7F6E\u3057\u306A\u3044\u3001\u6B21\u306E\u3088\u3046\u306B\u914D\u7F6E\u3055\u308C\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\uFF1A\n\xA0\n\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\n-\u4F1A\u793E\n-\u88FD\u54C1...',
	  NOT_AVAILABLE_ON_MOBILE: 'モバイルディバイスでこのプロジェクトをチェックすることはサポートされません。',
	  ENTER_PASSWORD: 'パスワードを入力してください',
	  PASSWORD: 'パスワード',
	  VALIDATE: '認証',
	  PASSWORD_CANNOT_BE_EMPTY: 'パスワードは空欄にできません。',
	  WRONG_PASSWORD: 'パスワードが間違っています。',
	  RIGHT_PASSWORD: '認証成功。',
	  COMMENT_HINT: '何か言ってみましょう...',
	  SIGN_HINT: 'お名前を入力してください',
	  SIGN_LABEL: 'サイン',
	  SUBMIT: '提出',
	  ENTER_SIGN: 'サインを入力してから、コメントをしてください。',
	  BUTTON_SURE: '確定',
	  NO_REMARK: '備考はありません。',
	  NO_REVIEW: 'レビューはありません。',
	  PAINT_TIP: 'ページをマークしました。',
	  REVIEW_LOADING: '読み込み中...',
	  NET_ERROR: 'ネットワークエラー。',
	  LOAD_REVIEW_FAILED: 'データの読み込みに失敗しました。',
	  SIGN_ALERT_MSG: 'あなたのサインを入力してください',
	  SIGN_TIP: '*このサインはチームメンバの識別に使用されます。',
	  SAVING: 'データ保存中...',
	  SAVE_ALERT_MSG: '未保存の修正データがあります。保存しますか？',
	  BUTTON_SAVE: '保存',
	  BUTTON_CANCEL: '取り消す',
	  SAVE_FAILED_MSG: 'データ保存に失敗しました！',
	  REMARK: '備考',
	  COMMENT: 'コメント',
	  VIEW_COMMENT: 'コメントをチェック',
	  VIEW_MARK: 'マークアップを表示',
	  HIDDEN_MARK: 'マークアップを隠し',
	  MARK: 'マークアップ',
	  IMAGE: '画像',
	  COPIED_PAGE_LINK: '現在ページのリンクがコピーされました。',
	  REQUEST_SOURCE_ERROR: 'リソースの読み込みに失敗しました。ネットワークの接続をチェックしてください。DNS を 223.5.5.5 に設定してから再試行することをお勧めします。'
	};
	
	var LANGS = {
	  cn: cn,
	  jp: jp,
	  en: en
	};
	
	var currentLang = LANGS[envHelper.lang];
	if (!currentLang) {
	  currentLang = LANGS.cn;
	}
	
	exports.get = function (n) {
	  return currentLang[n];
	};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	var MBX_EXTENSION = window.mockplus ? '.mbx' : '.xml';
	var MPK_EXTENSION = window.mockplus ? '.mpk' : '.xml';
	
	var LoadMethod;
	if (window.zip) {
	  LoadMethod = 'zip'; // 加载整个 mp 文件
	} else if (window.enterprise) {
	  LoadMethod = 'enterprise';
	  MBX_EXTENSION = ".mbx";
	  MPK_EXTENSION = ".mpk";
	} else if (window.remote) {
	  LoadMethod = 'remote'; // 异步加载
	} else if (window.mockplus) {
	  LoadMethod = 'mockplus'; // Mockplus 自用, 这种情况下, 资源文件从根目录下读取
	} else {
	  LoadMethod = 'dom'; // 从页面上获取数据
	}
	
	/**
	 * 是从 zip 中读取数据
	 * @returns {boolean}
	 */
	exports.isLoadFromZip = function () {
	  return LoadMethod === 'zip';
	};
	
	var _isLoadFromEnterprise = function _isLoadFromEnterprise() {
	  return LoadMethod === 'enterprise';
	};
	
	exports.isLoadFromEnterprise = _isLoadFromEnterprise;
	
	exports.getMBXExtension = function () {
	  return MBX_EXTENSION;
	};
	
	exports.getMPKExtension = function () {
	  return MPK_EXTENSION;
	};
	
	exports.isLoadFromRemote = function () {
	  return window.remote;
	};
	
	exports.isLoadFromMockplus = function () {
	  return LoadMethod === 'remote';
	};
	
	exports.isEnterprise = function () {
	  return window.enterprise;
	};
	
	exports.canReview = function () {
	  var host = window.location.host;
	  return ['localhost:3000', 'run.mockplus.cn', 'run.mockplus.com', 'jprun.mockplus.com'].indexOf(host) !== -1;
	};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	var ua = window.navigator.userAgent;
	
	/**
	 * 判断设备是移动设备
	 * @returns {boolean}
	 */
	function isMobileDevice() {
	  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
	  );
	}
	
	/**
	 * 判断是否是微信
	 * @returns {boolean}
	 */
	function isWeChat() {
	  return (/MicroMessenger/i.test(ua)
	  );
	}
	
	function isMobileQQBrowser() {
	  return (/MQQBrowser/i.test(ua)
	  );
	}
	
	function isQQ() {
	  return (/QQ/i.test(ua) && !isMobileQQBrowser()
	  );
	}
	
	function getDeviceRatio() {
	  return window.devicePixelRatio || 1;
	}
	
	function isWebkit() {
	  return (/WebKit/i.test(ua)
	  );
	}
	
	/**
	 * is CriOS: ios chrome ua 中包含
	 */
	function isCriOS() {
	  return (/CriOS/i.test(ua)
	  );
	}
	
	function isUC() {
	  return (/UCBrowser/i.test(ua)
	  );
	}
	
	/**
	 * 判断设备是否是 ios
	 */
	function isiOS() {
	  return (/iPhone|iPad|iPod/i.test(ua) && window.navigator.standalone !== undefined
	  ); // may be use standalone is not a good habit
	}
	
	/**
	 * 判断是否是 ios safari
	 */
	function isiOSSafari() {
	  return (/(iPad|iPhone|iPod)/gi.test(ua) && !isCriOS() && !/FxiOS/.test(ua) && !/OPiOS/.test(ua) && !/mercury/.test(ua) && !isUC() && !isQQ() && !isMobileQQBrowser()
	  );
	}
	
	function isStandalone() {
	  return isiOSSafari() && window.navigator.standalone;
	}
	
	function isMac() {
	  return ua.indexOf('Macintosh') !== -1;
	}
	
	var UX2017Pattern = /^https:\/\/run\.mockplus\.cn\/[a-z]{5}\//i;
	
	function isUX2017Work() {
	  return UX2017Pattern.test(window.location.href);
	}
	
	var isEn = window.lang === 'en' || window.en;
	var isJp = window.lang === 'jp';
	var isCn = !isEn && !isJp;
	var isEnOrJp = isEn || isJp;
	var lang;
	if (isEn) {
	  lang = 'en';
	} else if (isJp) {
	  lang = 'jp';
	} else {
	  lang = 'cn';
	}
	
	function isIEOrEdge() {
	  return ua.indexOf('MSIE ') > 0 || !!ua.match(/Trident.*rv\:11\./) || ua.indexOf('Edge') > -1;
	}
	
	// 判断是否为小程序
	function isWxMiniApp() {
	  return window.__wxjs_environment === 'miniprogram';
	}
	
	module.exports = {
	  isMobileDevice: isMobileDevice,
	  isWeChat: isWeChat,
	  isQQ: isQQ,
	  getDeviceRatio: getDeviceRatio,
	  isiOS: isiOS,
	  isStandalone: isStandalone,
	  isMac: isMac,
	  isUX2017Work: isUX2017Work,
	  isIEOrEdge: isIEOrEdge,
	  isWxMiniApp: isWxMiniApp,
	  isJp: window.lang === 'jp',
	  isEn: isEn,
	  isEnOrJp: isEnOrJp,
	  isCn: isCn,
	  lang: lang
	};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/*
	 * 存储相关函数
	 * */
	'use strict';
	
	var LOCAL_STORE = {};
	
	exports.get = function (k) {
	  try {
	    var storage = window.localStorage || {};
	    return storage[k];
	  } catch (e) {
	    console.error(e);
	    return LOCAL_STORE[k];
	  }
	};
	
	exports.set = function (k, v) {
	  try {
	    window.localStorage[k] = v;
	  } catch (e) {
	    console.error(e);
	    LOCAL_STORE[k] = v;
	  }
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var _ = __webpack_require__(51);
	var i18n = __webpack_require__(46);
	
	var IOSWarning = React.createClass({
	  displayName: 'IOSWarning',
	
	  propTypes: {
	    logo: React.PropTypes.string.isRequired,
	    name: React.PropTypes.string.isRequired,
	    arrowClassName: React.PropTypes.string.isRequired
	  },
	  render: function render() {
	    var logo, name, arrowClassName;
	    logo = this.props.logo;
	    name = this.props.name;
	    arrowClassName = 'arrow ' + this.props.arrowClassName;
	    return React.createElement(
	      'div',
	      { className: 'ios-warning' },
	      React.createElement(
	        'div',
	        { className: 'content' },
	        React.createElement(
	          'div',
	          { className: 'header' },
	          React.createElement(
	            'div',
	            { className: 'logo' },
	            React.createElement('img', { src: logo, alt: name, width: '64', height: '64' })
	          ),
	          React.createElement(
	            'h2',
	            null,
	            name
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'how-to-install' },
	          React.createElement(
	            'h3',
	            null,
	            i18n.get('INSTALL')
	          ),
	          this.props.children,
	          React.createElement(
	            'p',
	            { className: 'open-now' },
	            i18n.get('SKIP_INSTALL'),
	            ' ',
	            React.createElement('br', null),
	            React.createElement(
	              'a',
	              { href: window.location.href + '?force=1' },
	              i18n.get('OPEN_NOW')
	            )
	          )
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: arrowClassName },
	        React.createElement('img', { className: 'top-right-arrow',
	          src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAvNJREFUeJzt3MlOVEEcRvHjGOPDIKKIiCPO8zw+nC58CZY+hnFh4tp5QlCjLhrSmFtA3+66VQ3/80s6IRBuVfKdhAXJBUmSJEmSJEmSJEmSJEmSJEmSJGkL2Vv7AqpnAngDzNe+iMqbAN4Cf4FF4Gzd66ikA8A7euOvfhaBczUvpTJS4xtBEJOsP/7aCM7XuqC6Mwm8pz/0AvB65esl4Oman/3ACLaVgzTH3we8pB/ATpoRXKhxWeU1RXp8+D8ASEdwseRlldcU8IH0+NAMANIRXCpxWeV1iI3Hh3QA0IxgCSPYUgYZH9YPANIRXO7issrrMPCRzceHjQOAdARXcl5WeU0z+PiweQCQjuBqjssqr2ngE4OPD4MFAM0IljGCsXKE9uPD4AFAOoJrw1xWec0w3PjQLgBIR3C9zWWV1wzwmeHGh/YBQDqCGy1+X5kcZbTxYbgAwAiqm2X08WH4AKAZwU/g5hDPUUuzwBdGHx9GCwDSEdwa8lkawDHyjQ+jBwDpCG6P8DytY46840OeACAdwZ0Rn6k15oCv5B0f8gUAzQh+YQRZHKeb8SFvAJCO4G6mZ4d0gu7Gh/wBQDqCexmfH0bX40M3AUA6gvuZz9jWTgLf6HZ86C4ASEfwoINztp1S40O3AYARtHaKcuND9wGAEQys9PhQJgBoRvAbeNjxmVvKaeA7ZceHcgFAOoJHBc4de2eoMz6UDQDSETwudPZYmqfe+FA+AEhH8KTg+WPlOfXGhzoBQDOCFyvfC2cX8Iw640O9AKAfwQKwv8L5Y2MH9d7TUzMA6EWwp9LZDbsrnbv679OI/qx8xkLIv0HqM4DgDCA4AwjOAIIzgOAMIDgDCM4AgjOA4AwgOAMIzgCCM4DgDCA4AwjOAIIzgOAMIDgDCM4AgjOA4AwgOAMIzgCCM4DgDCA4AwjOAIIzgOAMIDgDCM4AgjOA4AwgOAMIrtZLomp6Re9Fjcu1LyJJkiRJkiRJkiRJkiRJkiRJkiRJktTWPyLpXQ2aP1sQAAAAAElFTkSuQmCC',
	          width: '64',
	          height: '64',
	          alt: 'click here' }),
	        React.createElement('img', {
	          className: 'bottom-center-arrow',
	          src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAtRJREFUeJzt3DdzU0EYRuGDWzKycQ5DY+j4sfwZGnKOJudQMhRUVFCY4toz9nJlK9zdlfydZ0YzbqRdzXsKN1cgSZIkSZIkSZIkSZIkSZIkSZKkqXSs9gUq2aT57n+BL5Xvogp+A9vA59oXqW2m9gVUlwEEZwDBGUBwBhCcAQRnAMEZQHAGEJwBBGcAwRlAcAYQnAEEZwDBGUBwBhCcAQRnAMEZQHAGEJwBBGcAwRlAcAYQnAEEZwDBGUBwBhCcAQRnAMEZQHAGEJwBBGcAwRlAcAYQXM0ANoHViufXdBFYrn2Jmi4DP2l+pq1GBDV/Ju4S8AP4ClyocH51M8AWzQC7I5SOoFYAu+Pvfverhc+fGBvAd+pFUCOAdPyXwFzB8yfOBvCNOhGUDsDx+1inTgQlA0jHfwHMFjh3aqzT/ENUMoJSAaTjb+H4rdYoG0GJANrG72U8b+qt0fx0e4kIcgeQjv8cxx/IKmUiyBlAOv4zHH8oqzTD5IwgVwBt45/r+IwQVsgbQY4A0vGf4vhjWQE+kSeCrgNw/EyWyRNBlwGk4z8BznbwudqxDHyk2wi6CiAd/zGOn0XXEXQRQNv4Z8b4PB1iie4iGDcAx69kCfjA+BGME0A6/iMcv6guIhg1gHT8hzh+FYvAe0aPYJQA2sY/PcT71bFF4B2jRTBsAOn4D3D8ibDAaBEME0A6/n0cf6IsAG8ZLoJBA2gb/9Q4l1Ue8wwXwSABpOPfw/En2jzwhsEiOCyAdPy7OP5UGDSCgwJoG/9kjssqj/PAaw6OoF8A6fh3cPypdB54Rf8I2gJIx7+N40+1OfpHkAbg+EfUHM1DGGkEewNIx78FnKhxWeXRFsGfnb9/sX/8mzj+kTRL80TO9gEvxz/iZtn/VPLe1w3geLWbqZge/0dwHccPpUfzpM42cA3HD6kHXMHxJUmSJEmSJEmSJEmSJEmSJEmSJEnSlPkHpRVX9BeF6C8AAAAASUVORK5CYII=',
	          width: '64',
	          height: '64',
	          alt: 'click here' })
	      )
	    );
	  }
	});
	
	module.exports = IOSWarning;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {//     Underscore.js 1.9.1
	//     http://underscorejs.org
	//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = typeof self == 'object' && self.self === self && self ||
	            typeof global == 'object' && global.global === global && global ||
	            this ||
	            {};
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for their old module API. If we're in
	  // the browser, add `_` as a global object.
	  // (`nodeType` is checked to ensure that `module`
	  // and `exports` are not HTML elements.)
	  if (typeof exports != 'undefined' && !exports.nodeType) {
	    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.9.1';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  var builtinIteratee;
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
	    return _.property(value);
	  };
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only argCount argument.
	  _.iteratee = builtinIteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  var restArguments = function(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var shallowProperty = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  var has = function(obj, path) {
	    return obj != null && hasOwnProperty.call(obj, path);
	  }
	
	  var deepGet = function(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = shallowProperty('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  var createReduce = function(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  };
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (_.isFunction(path)) {
	      func = path;
	    } else if (_.isArray(path)) {
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return _.map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection.
	  _.shuffle = function(obj) {
	    return _.sample(obj, Infinity);
	  };
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = _.random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (_.isString(obj)) {
	      // Keep surrogate pair characters together
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null || array.length < 1) return n == null ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null || array.length < 1) return n == null ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, Boolean);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, output) {
	    output = output || [];
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        // Flatten current level of array or arguments object.
	        if (shallow) {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        } else {
	          flatten(value, shallow, strict, output);
	          idx = output.length;
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = restArguments(function(array, otherArrays) {
	    return _.difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = restArguments(function(arrays) {
	    return _.uniq(flatten(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = restArguments(function(array, rest) {
	    rest = flatten(rest, true, true);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  });
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = restArguments(_.unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of _.pairs.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions.
	  var createPredicateIndexFinder = function(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  };
	
	  // Returns the first index on an array-like that passes a predicate test.
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions.
	  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  };
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  _.chunk = function(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments.
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = restArguments(function(func, context, args) {
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  _.partial = restArguments(function(func, boundArgs) {
	    var placeholder = _.partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  _.partial.placeholder = _;
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = restArguments(function(obj, keys) {
	    keys = flatten(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = _.bind(obj[key], obj);
	    }
	  });
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, result;
	
	    var later = function(context, args) {
	      timeout = null;
	      if (args) result = func.apply(context, args);
	    };
	
	    var debounced = restArguments(function(args) {
	      if (timeout) clearTimeout(timeout);
	      if (immediate) {
	        var callNow = !timeout;
	        timeout = setTimeout(later, wait);
	        if (callNow) result = func.apply(this, args);
	      } else {
	        timeout = _.delay(later, wait, this, args);
	      }
	
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = null;
	    };
	
	    return debounced;
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  _.restArguments = restArguments;
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  var collectNonEnumProps = function(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  };
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object.
	  // In contrast to _.map it returns an object.
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = _.keys(obj),
	        length = keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of _.object.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`.
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test.
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Internal pick helper function to determine if `obj` has key `key`.
	  var keyInObj = function(value, key, obj) {
	    return key in obj;
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (_.isFunction(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = _.allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the blacklisted properties.
	  _.omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = _.map(flatten(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  });
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq, deepEq;
	  eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  deepEq = function(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`?
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && isNaN(obj);
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, path) {
	    if (!_.isArray(path)) {
	      return has(obj, path);
	    }
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (obj == null || !hasOwnProperty.call(obj, key)) {
	        return false;
	      }
	      obj = obj[key];
	    }
	    return !!length;
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indexes.
	  _.property = function(path) {
	    if (!_.isArray(path)) {
	      return shallowProperty(path);
	    }
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  };
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    if (obj == null) {
	      return function(){};
	    }
	    return function(path) {
	      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  _.result = function(obj, path, fallback) {
	    if (!_.isArray(path)) path = [path];
	    var length = path.length;
	    if (!length) {
	      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = _.isFunction(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var chainResult = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_, args));
	      };
	    });
	    return _;
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return chainResult(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(36)(module)))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	* error 提示
	* */
	
	'use strict';
	
	var React = __webpack_require__(11);
	var i18n = __webpack_require__(46);
	var storeHelper = __webpack_require__(49);
	
	var AppError = React.createClass({
	  displayName: 'AppError',
	
	  propTypes: {
	    error: React.PropTypes.object
	  },
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'app-error' },
	      React.createElement(
	        'h1',
	        null,
	        i18n.get('FAIL_TO_LOAD')
	      ),
	      React.createElement(
	        'p',
	        null,
	        i18n.get('ERROR'),
	        ' ',
	        this.props.error.message
	      ),
	      React.createElement(
	        'p',
	        null,
	        i18n.get('HELP')
	      ),
	      window.isDev && React.createElement(
	        'button',
	        { onClick: this.refresh },
	        '\u5237\u65B0'
	      )
	    );
	  },
	  refresh: function refresh() {
	    storeHelper.set('path', '');
	    window.location.reload();
	  }
	});
	
	module.exports = AppError;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(51);
	
	function localError(e, suppress) {}
	
	function localOnError(msg) {
	  console.error(msg);
	}
	
	var logURL = window.en ? 'http://log.mockplus.cn/js/en' : 'http://log.mockplus.cn/js/cn';
	
	exports.error = window.mockplus ? function (err) {
	  // if (_.isString(err) && err.indexOf('Warning') === 0) { // ignore react warning
	  //   return;
	  // }
	  // if (_.isString(err)) {
	  //   return $.ajax({
	  //     type: "POST",
	  //     url: logURL,
	  //     data: JSON.stringify({
	  //       message: err,
	  //       stack: '',
	  //       error: ''
	  //     }),
	  //     success: function () {
	  //
	  //     },
	  //     dataType: "json"
	  //   });
	  // }
	  // $.ajax({
	  //   type: "POST",
	  //   url: logURL,
	  //   data: JSON.stringify({
	  //     message: err.message,
	  //     stack: err.stack,
	  //     error: err
	  //   }),
	  //   success: function () {
	  //
	  //   },
	  //   dataType: "json"
	  // });
	} : localError;
	
	exports.onerror = window.mockplus ? function (msg, url, lineNo, columnNo, error) {
	  // $.ajax({
	  //   type: "POST",
	  //   url: logURL,
	  //   data: JSON.stringify({
	  //     file: url,
	  //     message: msg,
	  //     stack: '',
	  //     line_no: lineNo,
	  //     column_no: columnNo,
	  //     error: JSON.stringify(error)
	  //   }),
	  //   success: function () {
	  //
	  //   },
	  //   dataType: "json"
	  // });
	} : localOnError;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(55);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(57)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../node_modules/_autoprefixer-loader@3.2.0@autoprefixer-loader/index.js!../../node_modules/_less-loader@2.2.3@less-loader/index.js!./style.less", function() {
				var newContent = require("!!../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../node_modules/_autoprefixer-loader@3.2.0@autoprefixer-loader/index.js!../../node_modules/_less-loader@2.2.3@less-loader/index.js!./style.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(56)();
	// imports
	
	
	// module
	exports.push([module.id, ".scroll-view{overflow:hidden;width:100%;height:100%;position:relative}.scroll-view .scroll-content{width:100%;height:100%;overflow:auto;position:absolute;top:0;left:0;bottom:-20px;right:-20px;padding-right:20px;padding-bottom:20px}.scroll-view .track{position:absolute}.scroll-view .track .thumb{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:rgba(0,0,0,.5);position:absolute;border-radius:3px;z-index:999}.scroll-view .track .thumb:hover{background-color:rgba(0,0,0,.7)}.scroll-view .scroll-bar-vertical{height:100%;width:8px;top:0;right:0}.scroll-view .scroll-bar-vertical .thumb{width:8px;height:20%}.scroll-view .scroll-bar-horizontal{width:100%;height:8px;left:0;bottom:0}.scroll-view .scroll-bar-horizontal .thumb{width:20%;height:8px}.logs{bottom:20px}.logs table{font-size:12px}.logs .reset{float:right;cursor:pointer}.logs .reset:hover{color:#d73300}.logs,.projects-list{position:fixed;right:20px;background-color:#ddd;padding:10px;z-index:1000;overflow:auto;font-size:12px}.logs .scroll-area,.projects-list .scroll-area{max-height:300px;overflow:auto}.logs h3,.projects-list h3{margin:5px 0;font-size:16px}.logs h4,.projects-list h4{margin:5px 0;font-size:14px}.logs tr,.projects-list tr{line-height:1.4em}.logs td,.projects-list td{padding:2px 5px}.logs .segment{list-style:none;margin:0;padding:0}.logs .segment li{display:inline;padding:3px 5px;cursor:pointer}.logs .segment li.current{background:#0088d8;color:#fff}.projects-list{top:110px;max-height:300px;overflow:auto}.projects-list ul{padding:0;margin:0;list-style:none}.projects-list ul li{line-height:1.4em;cursor:pointer}.projects-list ul li:hover{color:#d73300}.linkArea{position:absolute;left:0;top:0;width:100%;height:100%;z-index:800}.linkArea .interactive-link,.linkArea .page-link{position:absolute;cursor:pointer}.linkArea .interactive-link,.linkArea .page-link{background-color:hsla(0,0%,100%,.01)}.always-show-links .page-link{background-color:rgba(255,0,0,.3)}.always-show-links .interactive-link{background-color:rgba(0,0,255,.3)}.hover-show-links .page-link:hover{background-color:rgba(255,0,0,.3)}.hover-show-links .interactive-link:hover{background-color:rgba(0,0,255,.3)}.click-show-links .page-link{animation:myPageColor .8s}.click-show-links .interactive-link{animation:myComponentColor .8s}.componentColor .page-link{animation:myPageColor .3s}.componentColor .interactive-link{animation:myComponentColor .3s}.show-remark-flag .component-with-remark:before{content:\"\";display:inline-block;position:absolute;left:0;top:0;width:12px;height:12px;z-index:999;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKTWlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVN3WJP3Fj7f92UPVkLY8LGXbIEAIiOsCMgQWaIQkgBhhBASQMWFiApWFBURnEhVxILVCkidiOKgKLhnQYqIWotVXDjuH9yntX167+3t+9f7vOec5/zOec8PgBESJpHmomoAOVKFPDrYH49PSMTJvYACFUjgBCAQ5svCZwXFAADwA3l4fnSwP/wBr28AAgBw1S4kEsfh/4O6UCZXACCRAOAiEucLAZBSAMguVMgUAMgYALBTs2QKAJQAAGx5fEIiAKoNAOz0ST4FANipk9wXANiiHKkIAI0BAJkoRyQCQLsAYFWBUiwCwMIAoKxAIi4EwK4BgFm2MkcCgL0FAHaOWJAPQGAAgJlCLMwAIDgCAEMeE80DIEwDoDDSv+CpX3CFuEgBAMDLlc2XS9IzFLiV0Bp38vDg4iHiwmyxQmEXKRBmCeQinJebIxNI5wNMzgwAABr50cH+OD+Q5+bk4eZm52zv9MWi/mvwbyI+IfHf/ryMAgQAEE7P79pf5eXWA3DHAbB1v2upWwDaVgBo3/ldM9sJoFoK0Hr5i3k4/EAenqFQyDwdHAoLC+0lYqG9MOOLPv8z4W/gi372/EAe/tt68ABxmkCZrcCjg/1xYW52rlKO58sEQjFu9+cj/seFf/2OKdHiNLFcLBWK8ViJuFAiTcd5uVKRRCHJleIS6X8y8R+W/QmTdw0ArIZPwE62B7XLbMB+7gECiw5Y0nYAQH7zLYwaC5EAEGc0Mnn3AACTv/mPQCsBAM2XpOMAALzoGFyolBdMxggAAESggSqwQQcMwRSswA6cwR28wBcCYQZEQAwkwDwQQgbkgBwKoRiWQRlUwDrYBLWwAxqgEZrhELTBMTgN5+ASXIHrcBcGYBiewhi8hgkEQcgIE2EhOogRYo7YIs4IF5mOBCJhSDSSgKQg6YgUUSLFyHKkAqlCapFdSCPyLXIUOY1cQPqQ28ggMor8irxHMZSBslED1AJ1QLmoHxqKxqBz0XQ0D12AlqJr0Rq0Hj2AtqKn0UvodXQAfYqOY4DRMQ5mjNlhXIyHRWCJWBomxxZj5Vg1Vo81Yx1YN3YVG8CeYe8IJAKLgBPsCF6EEMJsgpCQR1hMWEOoJewjtBK6CFcJg4Qxwicik6hPtCV6EvnEeGI6sZBYRqwm7iEeIZ4lXicOE1+TSCQOyZLkTgohJZAySQtJa0jbSC2kU6Q+0hBpnEwm65Btyd7kCLKArCCXkbeQD5BPkvvJw+S3FDrFiOJMCaIkUqSUEko1ZT/lBKWfMkKZoKpRzame1AiqiDqfWkltoHZQL1OHqRM0dZolzZsWQ8ukLaPV0JppZ2n3aC/pdLoJ3YMeRZfQl9Jr6Afp5+mD9HcMDYYNg8dIYigZaxl7GacYtxkvmUymBdOXmchUMNcyG5lnmA+Yb1VYKvYqfBWRyhKVOpVWlX6V56pUVXNVP9V5qgtUq1UPq15WfaZGVbNQ46kJ1Bar1akdVbupNq7OUndSj1DPUV+jvl/9gvpjDbKGhUaghkijVGO3xhmNIRbGMmXxWELWclYD6yxrmE1iW7L57Ex2Bfsbdi97TFNDc6pmrGaRZp3mcc0BDsax4PA52ZxKziHODc57LQMtPy2x1mqtZq1+rTfaetq+2mLtcu0W7eva73VwnUCdLJ31Om0693UJuja6UbqFutt1z+o+02PreekJ9cr1Dund0Uf1bfSj9Rfq79bv0R83MDQINpAZbDE4Y/DMkGPoa5hpuNHwhOGoEctoupHEaKPRSaMnuCbuh2fjNXgXPmasbxxirDTeZdxrPGFiaTLbpMSkxeS+Kc2Ua5pmutG003TMzMgs3KzYrMnsjjnVnGueYb7ZvNv8jYWlRZzFSos2i8eW2pZ8ywWWTZb3rJhWPlZ5VvVW16xJ1lzrLOtt1ldsUBtXmwybOpvLtqitm63Edptt3xTiFI8p0in1U27aMez87ArsmuwG7Tn2YfYl9m32zx3MHBId1jt0O3xydHXMdmxwvOuk4TTDqcSpw+lXZxtnoXOd8zUXpkuQyxKXdpcXU22niqdun3rLleUa7rrStdP1o5u7m9yt2W3U3cw9xX2r+00umxvJXcM970H08PdY4nHM452nm6fC85DnL152Xlle+70eT7OcJp7WMG3I28Rb4L3Le2A6Pj1l+s7pAz7GPgKfep+Hvqa+It89viN+1n6Zfgf8nvs7+sv9j/i/4XnyFvFOBWABwQHlAb2BGoGzA2sDHwSZBKUHNQWNBbsGLww+FUIMCQ1ZH3KTb8AX8hv5YzPcZyya0RXKCJ0VWhv6MMwmTB7WEY6GzwjfEH5vpvlM6cy2CIjgR2yIuB9pGZkX+X0UKSoyqi7qUbRTdHF09yzWrORZ+2e9jvGPqYy5O9tqtnJ2Z6xqbFJsY+ybuIC4qriBeIf4RfGXEnQTJAntieTE2MQ9ieNzAudsmjOc5JpUlnRjruXcorkX5unOy553PFk1WZB8OIWYEpeyP+WDIEJQLxhP5aduTR0T8oSbhU9FvqKNolGxt7hKPJLmnVaV9jjdO31D+miGT0Z1xjMJT1IreZEZkrkj801WRNberM/ZcdktOZSclJyjUg1plrQr1zC3KLdPZisrkw3keeZtyhuTh8r35CP5c/PbFWyFTNGjtFKuUA4WTC+oK3hbGFt4uEi9SFrUM99m/ur5IwuCFny9kLBQuLCz2Lh4WfHgIr9FuxYji1MXdy4xXVK6ZHhp8NJ9y2jLspb9UOJYUlXyannc8o5Sg9KlpUMrglc0lamUycturvRauWMVYZVkVe9ql9VbVn8qF5VfrHCsqK74sEa45uJXTl/VfPV5bdra3kq3yu3rSOuk626s91m/r0q9akHV0IbwDa0b8Y3lG19tSt50oXpq9Y7NtM3KzQM1YTXtW8y2rNvyoTaj9nqdf13LVv2tq7e+2Sba1r/dd3vzDoMdFTve75TsvLUreFdrvUV99W7S7oLdjxpiG7q/5n7duEd3T8Wej3ulewf2Re/ranRvbNyvv7+yCW1SNo0eSDpw5ZuAb9qb7Zp3tXBaKg7CQeXBJ9+mfHvjUOihzsPcw83fmX+39QjrSHkr0jq/dawto22gPaG97+iMo50dXh1Hvrf/fu8x42N1xzWPV56gnSg98fnkgpPjp2Snnp1OPz3Umdx590z8mWtdUV29Z0PPnj8XdO5Mt1/3yfPe549d8Lxw9CL3Ytslt0utPa49R35w/eFIr1tv62X3y+1XPK509E3rO9Hv03/6asDVc9f41y5dn3m978bsG7duJt0cuCW69fh29u0XdwruTNxdeo94r/y+2v3qB/oP6n+0/rFlwG3g+GDAYM/DWQ/vDgmHnv6U/9OH4dJHzEfVI0YjjY+dHx8bDRq98mTOk+GnsqcTz8p+Vv9563Or59/94vtLz1j82PAL+YvPv655qfNy76uprzrHI8cfvM55PfGm/K3O233vuO+638e9H5ko/ED+UPPR+mPHp9BP9z7nfP78L/eE8/sl0p8zAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAADoSURBVHjafNG9SkNBEIbhZ082SIKiYGlto40X4wUIuYfYWYudrSDY2VjmNgI22ngTinLM7zkWmQ0xRT4Ydpl9v5nZ3YQKHeTxqKpf34HBsDnCMmIRa1vg7u11qi/OVvDVJY931Sf62EM3uJTQG4+qNfz04p8Gw+YENaaYZ+QCl+pFYe5vjLbMyPD2sYIenltwf5OKr49ZxDzHbM5PbYNFm3eo1oYdHQrcQcolu6PDplJGu/0yW1qgQYs24Rj7OMQBetF+iV984ws/qHNUmMYhzOP3G0wiPy2dcgBl8Fl8UjHMA57EvvkbAMbNTZAKj4GyAAAAAElFTkSuQmCC) no-repeat}.component-Base,canvas{width:100%;height:100%}.component-Base{position:absolute;overflow:hidden}.component-VolumeSlider .content{overflow:hidden}.component-VolumeSlider .content img{float:left}.component-VolumeSlider .content:after{display:inline-block;content:\"\";width:100%;height:1px;background-color:#333;margin-left:69px;float:left;position:relative;top:-8px}.component-Chart-Coord{border:none;border-left:1px solid #000;border-bottom:1px solid #000;box-sizing:border-box}.component-LineChart .border{box-sizing:border-box;height:100%;width:100%;border-left:2px solid gray;border-bottom:2px solid gray}.component-VideoPlayer .video-player-content{border:2px solid #444;position:relative;width:100%;height:100%;background:#fff;pointer-events:none;box-sizing:border-box}.component-VideoPlayer .video-player-content .bottom{width:100%;height:27px;border-top:1px solid #444;position:absolute;bottom:0}.component-VideoPlayer .video-player-content img{position:absolute;bottom:0}.component-TextField .text-field-content{position:relative}.component-TextField .text-field-content input{position:absolute;bottom:0;left:2px;outline:none;border:none}.component-TextField .text-field-content .under-line{position:absolute;bottom:0;left:0}.component-TextField .text-field-content .send{position:absolute;bottom:0;right:0}.component-ScopeBar .scopebar-content{text-align:center;border:none}.component-ScopeBar .scopebar-content .scopebar-item{border-top:1px solid #000;border-bottom:1px solid #000;position:absolute;overflow:hidden}.component-ScopeBar .scopebar-content .scopebar-item:first-child{border-top-left-radius:4px;border-bottom-left-radius:4px;border-left:1px solid #000}.component-ScopeBar .scopebar-content .scopebar-item:last-child{border-top-right-radius:4px;border-bottom-right-radius:4px;border-right:1px solid #000}.component-Spinner{position:relative}.component-Spinner .spinner-content{overflow:hidden}.component-Spinner .spinner-content:after{content:\"\";display:inline-block;height:1px;width:100%;background-color:#000;position:absolute;bottom:0}.component-Spinner .spinner-content label{position:absolute;bottom:2px;left:0;white-space:nowrap;overflow:hidden}.component-Spinner .spinner-content img{position:absolute;bottom:0;right:0}.component-AlarmIcon .alarm-icon-content .round-rect{border:1px solid #000;border-radius:10px;position:absolute;left:0;bottom:0;background:#fff}.component-AlarmIcon .alarm-icon-content .alarm-text{position:absolute;top:0;right:0;background-color:red;display:inline-block;text-align:center;border-radius:50%;color:#fff;font-size:12px}.component-AlarmIcon .alarm-icon-content .alarm-icon{position:absolute}.component-StatusBar_Android_ .android-status-bar-content img{position:absolute;right:0;top:50%;transform:translateY(-50%)}.component-StatusBar_IOS_ .ios-status-bar-content img{width:100%;position:absolute;top:50%;transform:translateY(-50%)}.component-NavigationBar .navigation-bar-content img{position:absolute;top:50%;transform:translateY(-50%)}.component-Link{overflow:hidden}.component-Link label{white-space:nowrap}.component-LinkBar .LinkBar-Item{width:auto;padding:0;box-sizing:border-box;position:absolute;white-space:nowrap;text-decoration:inherit}.component-Avatar_Mobile_ .avatar-content{width:100%;height:100%;overflow:hidden;position:absolute}.component-Avatar_Mobile_ .avatar-content .background{width:100%;height:100%;box-sizing:border-box;border:2px solid gray;position:absolute}.component-Avatar_Mobile_ .avatar-content .background img{width:100%;height:100%;border:none;background:#fff}.component-Avatar_Mobile_ .avatar-content .triangle{position:absolute;right:-12px;bottom:0;border-left:12px solid transparent;border-right:12px solid transparent;border-bottom:12px solid #41c7d6}.component-Accordion .AccordionModule-Box{top:30px;left:0;width:100%;border-width:0;border-style:none;border-bottom:1px solid #000;box-sizing:border-box;overflow:hidden;position:absolute}.component-Accordion .AccordionModule{width:100%;overflow:hidden;box-sizing:border-box;position:relative;border:none}.component-Accordion .AccordionItem{padding:0;height:30px;width:100%;border-style:none;border-width:0;border-bottom-width:1px;box-sizing:border-box;pointer-events:auto;white-space:nowrap;overflow:hidden;position:absolute}.component-Alert{margin:0;left:0;top:0;background-color:#fff;border:1px solid #444;border-radius:4px;pointer-events:auto;box-sizing:border-box;padding:0}.component-Alert .content{margin-bottom:12px;margin-top:8px;left:12px;right:12px;text-decoration:inherit;pointer-events:none;word-break:normal;word-wrap:break-word;position:absolute}.component-Alert .title{text-align:center;text-decoration:inherit;pointer-events:none;white-space:nowrap;overflow:hidden;left:6px;right:6px;top:6px;position:relative;padding-bottom:8px}.component-Alert .bottom{text-align:center;width:100%}.component-Alert .bottom,.component-Alert .button{position:absolute;height:30px;text-decoration:inherit}.component-Alert .button{border:1px solid;border-radius:4px;line-height:30px;box-sizing:border-box}.component-AlertWindow{left:0;top:0;width:0;height:0}.component-AlertWindow .popup-background{left:0;top:0;position:absolute;opacity:0;z-index:0}.component-Phone .top{height:40px;width:100%;top:0;border:none;border-bottom:1px solid #000;position:absolute}.component-Phone .bottom{height:40px;bottom:0;width:100%;border:none;border-top:1px solid #000;position:absolute}.component-BarChart .content{width:100%;height:100%;border:2px solid gray;border-right:none;border-top:none}.component-BarChart .chart-item{border:1px solid #666;border-left:none;box-sizing:border-box}.component-BarChart .chart-one{width:50%;background-color:#ddd}.component-BarChart .chart-one,.component-BarChart .chart-two{position:absolute;height:14.29%;left:2px;border:1px solid #444;border-left:none;box-sizing:border-box}.component-BarChart .chart-two{width:62.5%;background-color:#999}.component-BarChart .chart-three{width:87.5%;background-color:#ddd}.component-BarChart .chart-four,.component-BarChart .chart-three{position:absolute;left:2px;height:14.29%;border:1px solid #444;border-left:none;box-sizing:border-box}.component-BarChart .chart-four{width:75%;background-color:#999}.component-ColumnChart .content{width:100%;height:100%;border:2px solid #666;border-right:none;border-top:none}.component-ColumnChart .chart-item{border:1px solid #666;border-bottom:none;box-sizing:border-box}.component-ColumnChart .chart-one{height:50%;background-color:#ddd}.component-ColumnChart .chart-one,.component-ColumnChart .chart-two{position:absolute;width:14.29%;bottom:0;border:1px solid #444;border-bottom:none;box-sizing:border-box}.component-ColumnChart .chart-two{height:62.5%;background-color:#999}.component-ColumnChart .chart-three{height:87.5%;background-color:#ddd}.component-ColumnChart .chart-four,.component-ColumnChart .chart-three{position:absolute;bottom:0;width:14.29%;border:1px solid #444;border-bottom:none;box-sizing:border-box}.component-ColumnChart .chart-four{height:75%;background-color:#999}.component-BrowserWindow .bg{left:0;top:72px;width:100%;position:absolute;z-index:1;text-decoration:inherit}.component-BrowserWindow .img-bg{width:100%;height:100%;top:0;left:0;position:absolute;z-index:2}.component-BrowserWindow .title{left:2px;top:2px;height:30px;position:absolute;line-height:30px;text-align:center;z-index:3;text-decoration:inherit}.component-BrowserWindow .url{left:145px;top:43px;height:20px;position:absolute;line-height:20px;text-align:left;font-size:12px;z-index:4;text-decoration:inherit;overflow:hidden}.component-Group{margin:0;padding:0}.component-Group,.component-HorizontalSplitter{left:0;top:0;width:100%;height:100%;box-sizing:border-box}.component-HorizontalSplitter{border:none;border-top:1px solid;border-bottom:1px solid}.component-HorizontalSplitter ul{height:2px;width:auto;padding-top:3px;float:left;list-style:none}.component-HorizontalSplitter ul li{background-color:#000;border-radius:1px;width:2px;height:2px;margin-right:3px;float:left;list-style:none;display:inline-block;line-height:3px}.component-VerticalSplitter{left:0;top:0;width:100%;height:100%;border:none;border-left:1px solid;border-right:1px solid;box-sizing:border-box}.component-VerticalSplitter ul{width:2px;height:auto;padding-left:3px;float:none;list-style:none}.component-VerticalSplitter ul li{background-color:#000;border-radius:1px;width:2px;height:2px;margin-bottom:3px;line-height:3px}.component-HorizontalTabBar{width:100%;height:100%;left:0;top:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;box-sizing:border-box}.component-HorizontalTabBar .bar{width:100%;position:absolute;display:block;z-index:2}.component-HorizontalTabBar .item-text{height:100%;position:absolute;white-space:nowrap;z-index:5;text-decoration:inherit}.component-HorizontalTabBar .bar-ex{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;z-index:2}.component-HorizontalTabBar .bar-item{margin-left:-1px;overflow:hidden;text-align:center}.component-HorizontalTabBar .bar-item-text{padding:6px}.component-HorizontalTabBar .content-ex{-ms-flex-positive:1;flex-grow:1;z-index:1}.component-HotSport{left:0;top:0;width:100%;height:100%;background-color:transparent}.component-HRule{width:100%;height:2px;left:0;top:50%;box-sizing:border-box}.component-VRule{width:2px;height:100%;left:50%;top:0;box-sizing:border-box}.component-HSlider .track{width:100%;height:2px;left:0;position:absolute}.component-HSlider .slide{top:0;width:8px;height:15px;overflow:hidden;position:absolute}.component-HSlider .slide.incisive .slide-shape{top:0;left:-11px;width:0;height:0;border-top:none;border-left:15px solid transparent;border-right:15px solid transparent;border-bottom-style:solid;border-bottom-width:15px;position:absolute}.component-HSlider .slide.square{width:20px;height:20px}.component-HSlider .slide.square .slide-shape{width:14px;height:14px;position:absolute;top:0;left:0}.component-HSlider .slide.circle{width:20px;height:20px}.component-HSlider .slide.circle .slide-shape{width:14px;height:14px;border-radius:100%;top:0;left:0;position:absolute;background:red}.component-VSlider{width:100%;height:100%}.component-VSlider .track{height:100%;width:2px;top:0;position:absolute}.component-VSlider .slide{left:0;height:8px;width:15px;overflow:hidden;position:absolute}.component-VSlider .slide.incisive .slide-shape{left:0;top:-11px;width:0;height:0;border-right:none;border-top:15px solid transparent;border-bottom:15px solid transparent;border-left:15px solid;position:absolute}.component-VSlider .slide.square{width:20px;height:20px}.component-VSlider .slide.square .slide-shape{width:14px;height:14px;position:absolute;top:0;left:0}.component-VSlider .slide.circle{width:20px;height:20px}.component-VSlider .slide.circle .slide-shape{width:14px;height:14px;border-radius:100%;top:0;left:0;position:absolute;background:red}.component-ImageCarousel .indicator{left:0;top:0;width:0;height:0;position:relative;z-index:100}.component-ImageCarousel .go-left{left:20px;border-left:5px solid hsla(0,0%,100%,.5);border-bottom:5px solid hsla(0,0%,100%,.5);z-index:101}.component-ImageCarousel .go-left,.component-ImageCarousel .go-right{width:30px;height:30px;opacity:0;position:absolute;transform:rotate(45deg)}.component-ImageCarousel .go-right{right:20px;border-right:5px solid hsla(0,0%,100%,.5);border-top:5px solid hsla(0,0%,100%,.5);z-index:102}.component-ImageCarousel .imgBackground{width:100%;height:100%;left:0;top:0;pointer-events:none}.component-ImageCarousel img{width:auto;height:auto;left:0;top:0;position:absolute}.component-IOSStatusBar{width:100%;height:100%}.component-IOSStatusBar .time{width:100%;height:100%;position:absolute;text-align:center}.component-IOSStatusBar label{width:100%}.component-IPad{width:100%;height:100%}.component-IPad img{left:0;top:0;position:absolute}.component-IPhone .top{height:40px;width:100%;border:none;border-bottom:1px solid #000;position:absolute}.component-IPhone .status-bar{width:100%;height:20px}.component-IPhone .bottom{bottom:0;height:40px;width:100%;border:none;border-top:1px solid #000;position:absolute}.component-Keyboard{width:100%;height:100%}.component-Label{width:auto}.component-Label .context{width:100%;height:100%;position:absolute}.component-LabelTextInput{width:100%;height:100%;padding:0}.component-LabelTextInput .contents-layout{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.component-LabelTextInput .contents-layout.vatop .title{-ms-flex-pack:start;justify-content:flex-start}.component-LabelTextInput .contents-layout.vabottom .title{-ms-flex-pack:end;justify-content:flex-end}.component-LabelTextInput .contents-layout.vabottom .content{position:relative;top:100%;transform:translateY(-100%)}.component-LabelTextInput .contents-layout.vamiddle .title{-ms-flex-pack:center;justify-content:center}.component-LabelTextInput .contents-layout.vamiddle .content{position:relative;top:50%;transform:translateY(-50%)}.component-LabelTextInput .contents-layout .title{display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-line-pack:center;align-content:center;overflow:hidden;-ms-flex-negative:0;flex-shrink:0}.component-LabelTextInput .contents-layout .title label{display:block}.component-LabelTextInput .contents-layout .input-rect{position:relative;width:100%;height:100%}.component-LabelTextInput .title{width:auto;white-space:nowrap}.component-LabelTextInput .paragraph{width:100%;padding:0;margin:0}.component-LabelTextInput .content{width:100%;height:auto;text-decoration:inherit;word-wrap:break-word}.component-LabelTextInput p{margin:4px}.component-LetterNavigation label{width:100%;left:0;position:absolute;overflow:hidden;text-align:center}.component-Line{width:100%;height:100%;pointer-events:none}.component-Line .text{position:absolute;white-space:nowrap;transform:translate(-50%,-50%);border-radius:3px;font-size:12px;border:1px solid;padding:1px 5px;pointer-events:none;box-sizing:border-box}.component-Line canvas{width:100%;height:100%;left:0;top:0;position:absolute}.component-Line p{margin:0}.component-Arrow{pointer-events:none}.component-Chart-Coord,.component-SimpleCom{width:100%;height:100%;left:0;top:0;position:absolute}.component-Chart-Coord{border:1px solid #666;border-right:none;border-top:none}.chart-item{border:1px solid gray}.component-Menu .border{border:1px solid;width:100%;height:100%;position:absolute;overflow:hidden;box-sizing:border-box}.component-Menu .item{margin-left:0;margin-right:4px;position:absolute;width:100%;height:100%;pointer-events:none;text-decoration:inherit}.component-Menu .toggle{width:30px;height:100%;position:absolute;left:0;top:0}.component-Menu .toggle-radio{position:absolute;pointer-events:none;text-decoration:inherit;width:10px;height:10px;left:5px;border-radius:50%;background-color:#000}.component-Menu .toggle-check{width:16px;height:8px;left:4px;border:1px solid;border-left:none;border-bottom:none;position:absolute;transform:rotate(135deg)}.component-Menu label{position:absolute;top:0;text-decoration:inherit;width:100%}.component-Menu .menu-text{left:25px;text-align:left}.component-Menu .menu-short{right:25px;text-align:right}.component-Menu img{position:absolute;right:6px;top:50%;transform:translateY(-50%)}.component-MenuBar{border-color:#000;z-index:0}.component-MenuBar .item-bg{height:100%;float:left;overflow:hidden;white-space:nowrap;text-decoration:inherit;text-align:center;padding:0 15px}.component-NumericStepper .border{border:1px solid #444;width:100%;height:100%;left:0;top:0;overflow:hidden;position:absolute}.component-NumericStepper .right{right:0;position:absolute;width:21px;height:100%;border:none;border-left:1px solid;box-sizing:border-box;background-color:#fff;z-index:0}.component-NumericStepper .upTriangle{border-bottom:6px solid #000}.component-NumericStepper .downTriangle,.component-NumericStepper .upTriangle{width:0;height:0;left:4px;position:absolute;border-left:6px solid transparent;border-right:6px solid transparent}.component-NumericStepper .downTriangle{border-top:6px solid #000}.component-NumericStepper .text{white-space:nowrap;overflow:hidden;text-align:right;z-index:1}.component-NumericStepper .text,.component-NumericStepper label{left:0;top:0;height:100%;position:absolute}.component-PageControl{width:100%;height:100%}.component-PageControl ul{width:100%;height:100%;padding:0;float:left;list-style-type:circle}.component-PageControl li{background-color:#ddd;border-radius:50%;width:12px;height:12px;margin-right:4px;float:left;display:inline-block;line-height:12px;box-sizing:border-box}.component-PageControl li.stSolidCircle{border-radius:50%}.component-PageControl li.stSolidRect{border-radius:0}.component-PageControl li.stHollowRect{border-radius:0;background-color:#fff!important}.component-PageControl li.stHollowRect span{border-radius:0;margin:0 auto}.component-PageControl li.stHollowCircle{border-radius:50%;background-color:#fff!important}.component-PageControl li.stHollowCircle span{border-radius:50%;margin:0 auto}.component-PageControlEx{width:100%;height:100%}.component-PageControlEx ul{width:100%;height:100%;padding:0;float:left;list-style-type:circle;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:distribute;justify-content:space-around;-ms-flex-align:center;align-items:center}.component-PageControlEx li{background-color:#ddd;border-radius:50%;width:12px;height:12px;margin:0;float:left;display:inline-block;line-height:12px;box-sizing:border-box}.component-PageControlEx li.stSolidCircle{border-radius:50%}.component-PageControlEx li.stSolidRect{border-radius:0}.component-PageControlEx li.stHollowRect{border-radius:0;background-color:#fff!important}.component-PageControlEx li.stHollowRect span{border-radius:0;margin:0 auto}.component-PageControlEx li.stHollowCircle{border-radius:50%;background-color:#fff!important}.component-PageControlEx li.stHollowCircle span{border-radius:50%;margin:0 auto}.component-PointyButton .menu{width:0;height:0;right:10px;position:absolute;border:5px solid transparent}.popup-control{left:0;top:0;width:0;height:0;position:absolute}.popup-control .background{left:0;top:0;opacity:1;z-index:0;pointer-events:none;position:absolute}.popup-control .content{position:absolute;overflow:hidden;z-index:1}.component-ProgressBar .track{width:100%;height:100%;top:0;left:0;border:inherit;position:absolute}.component-ProgressBar .indicator{left:0;top:0;height:100%;box-sizing:border-box}.component-ProgressBar .stripe{width:100%;height:100%;background-repeat:repeat-x;background-size:25px 100%;-webkit-background-size:25px 100%}.component-Slider{position:absolute;width:100%;height:100%}.component-Slider .track-left{position:absolute;left:0;height:2px;z-index:0}.component-Slider .track-right{position:absolute;height:2px;background:#000;z-index:1}.component-Slider .slider{position:absolute;z-index:2}.component-Slider .slider-outer{position:absolute;left:0;top:0;width:100%;height:100%;border-radius:50%;opacity:.7}.component-Slider .slider-inner{width:10px;height:10px;position:absolute;border-radius:5px}.component-Switch .border{border:1px solid #444;box-sizing:border-box;text-align:center;color:#fff;font-size:16px}.component-Switch .off{z-index:1}.component-Switch .off,.component-Switch .on{width:50%;height:100%;border:none;position:absolute;pointer-events:none}.component-Switch .on{left:50%;z-index:0}.component-SwitchIOS .border{border:1px solid #444;box-sizing:border-box;position:absolute}.component-SwitchIOS .button{border-top-left-radius:50% 50%;border-top-right-radius:50% 50%;border-bottom-left-radius:50% 50%;border-bottom-right-radius:50% 50%;position:absolute;background-color:#fff;border:1px solid #444;box-sizing:border-box;pointer-events:none;top:0}.component-DataGrid .border{height:100%;width:100%;box-sizing:border-box;overflow:hidden;word-wrap:break-word;word-spacing:0;border-width:1px;border-color:#444}.component-DataGrid table{width:100%;height:100%;position:absolute;left:0;top:0}.component-DataGrid p{margin:0;padding:0;height:inherit;overflow:hidden}.component-DataGrid td{border:1px none;white-space:pre-wrap;overflow:hidden;box-sizing:border-box;padding:0;padding-left:2px;padding-right:2px;margin:0}.component-Table .texts{display:block;width:100%}.component-Table .texts p{line-height:1.3em;margin:0;word-wrap:break-word}.component-Table canvas{pointer-events:none}.component-TabletPC{width:100%;height:100%}.component-TabletPC img{position:absolute;left:0;top:0}.component-TableView{width:100%;height:100%}.component-TableView .item{width:100%;text-decoration:inherit;box-sizing:border-box}.component-TableView .item-border{left:10px;top:0;height:100%;position:relative;pointer-events:none;text-decoration:inherit}.component-TableView .item-text{left:0;top:0;height:100%;position:absolute;text-decoration:inherit;overflow:hidden}.component-TableView .item-icon{padding-top:0;position:absolute}.component-TableView img{position:absolute}.component-TitleWindow .title{left:0;top:0;width:100%;background:#ddd;border:none;border-bottom:1px solid #444;position:absolute;text-decoration:inherit}.component-TitleWindow .content{left:0;width:100%;overflow:hidden;position:absolute}.component-TitleWindow .status-bar{left:0;bottom:0;width:100%;background:#ddd;border:none;border-top:1px solid #444;position:absolute}.component-TitleWindow label{position:absolute;margin-left:5px}.component-TitleWindow .win-icon{margin:0 auto;margin-left:5px;padding:0;width:auto;height:auto}.component-TitleWindow .icon-box{width:auto;height:auto;position:absolute;right:5px;bottom:0;vertical-align:middle;padding:0;margin:0;border:none;overflow:hidden;box-sizing:border-box}.component-Tooltip canvas{position:absolute}.component-TopActionBar{width:100%;height:100%;position:absolute;border:none;box-sizing:border-box}.component-TopActionBar .back{position:absolute;left:14px;top:0;width:24px}.component-TopActionBar .back-icon{position:absolute;width:16px;height:16px;left:4px;transform:rotate(45deg);border:1px solid;border-right:none;border-top:none}.component-TopActionBar .menu{position:absolute;right:15px;width:24px;height:24px;box-sizing:border-box}.component-TopActionBar .menu-line{width:3px;height:3px;border:1px solid;margin-left:10px;margin-bottom:6px}.component-TopActionBar .menu-line:last-child{margin-bottom:0}.component-Tree .tree-label{float:left;margin-left:6px;height:100%;position:absolute;white-space:nowrap;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}.component-VCurly canvas{top:0;position:absolute}.component-VerticalTabBar .component-verticalTabBar{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.component-VerticalTabBar .component-verticalTabBar.bar-at-left .bar{position:relative;z-index:2;right:-1px}.component-VerticalTabBar .component-verticalTabBar.bar-at-right .bar{position:relative;left:-1px}.component-VerticalTabBar .bar{top:20px;overflow:hidden;text-decoration:inherit;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0}.component-VerticalTabBar .bar .item{width:auto;padding-left:6px;padding-right:6px;border:1px solid #000;margin-bottom:-1px;text-decoration:inherit;box-sizing:border-box}.component-VerticalTabBar .content{width:calc(100% - 1px);height:100%;box-sizing:border-box}.component-StickyNote p{margin:0;padding:0;word-wrap:break-word}.component-Image .border{border:1px none #444;overflow:hidden;box-sizing:content-box}.component-Image .border,.component-Image canvas{left:0;top:0;width:100%;height:100%;position:absolute}.component-Image img{width:100%;height:100%;position:absolute;visibility:hidden}.component-Image .grayImage{filter:grayscale(100%);-moz-filter:grayscale(100%);-o-filter:grayscale(100%);-ms-filter:grayscale(100%)}.component-Icon .mac-ios-icon-transform-C{transform:translateY(11%)}.component-Icon .mac-ios-icon-transform-D{transform:translateY(7%)}.component-Tabs .content{white-space:nowrap}.component-List label{overflow:hidden;left:0;height:100%;position:absolute}.component-Search label{white-space:nowrap;left:30px;right:10px;top:1px;bottom:1px;position:absolute;overflow:hidden}.component-Search input{border:none;outline:none}.component-SelectComp .select-item-box{position:absolute;left:0;z-index:800;background:#fff}.component-SelectComp .select-item-cover{position:absolute;left:0;top:0;width:100%;height:100%;opacity:0;z-index:800}.component-SelectComp .select-item-text{margin-left:10px;position:absolute;left:0;top:0;overflow:hidden;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}label{white-space:nowrap}.sub-word-spacing{word-spacing:-1px}.shell{width:100%;height:100%;margin:auto;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.shell img{-webkit-user-drag:none}.shell svg{float:left}.shell img{width:auto;height:auto}.shell .shell-whole{width:100%;height:100%;display:block;float:left}.shell .shell-home,.shell .shell-top{position:absolute;left:50%;transform:translateX(-50%)}.shell .shell-top{top:0}.shell .shell-home{bottom:0}.shell .screen-placeholder{background-color:#fff;position:absolute}.shell.horizontal .shell-home,.shell.horizontal .shell-top{top:50%;transform:translateY(-50%)}.shell.horizontal .shell-top{left:0}.shell.horizontal .shell-home{right:0;bottom:auto;left:auto}.desktop-shell{background-color:#505050;border-radius:6px}.desktop-shell .content-area{position:absolute;left:8px;top:30px;background-color:#fff}.desktop-shell .title{width:100%;height:30px;text-align:center;position:absolute;left:8px;top:0;line-height:30px;color:#fff;font-size:14px}.desktop-shell .close-btn{width:20px;height:20px;position:absolute;right:28px;top:5px}.error-message{z-index:1000000;width:100%;height:100%;position:absolute;background:hsla(0,0%,50%,.5)}.error-message .error-message-dialog{width:390px;height:180px;background:#fff;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);border:#999;border-radius:6px;text-align:center}.error-message .error-message-dialog .content{margin:60px 10px 40px}.error-message .error-message-dialog button{border-radius:2px;background:#d73300;outline:none;border:none;color:#fff;width:100px;height:30px;cursor:pointer}.error-message .error-message-dialog .close{position:absolute;right:10px;top:10px;cursor:pointer}.error-message.error-message-nothing{display:none}.paint{width:100%;height:100%;overflow:auto}.paint .full-page{position:relative;margin:80px auto 30px;outline:1px dashed gray}.paint .paint-wrapper{position:absolute;top:0;left:0;width:100%;background:#fff;overflow:auto}.commentMode .preview-container-commentMode{-ms-flex-positive:1;flex-grow:1;width:100%;height:100%;position:absolute;z-index:2;overflow:auto;padding:70px 0 0;box-sizing:border-box}.commentMode .preview-container-commentMode .device-scroll-view{position:relative;width:100%;height:100%;overflow:auto;display:-ms-flexbox;display:flex}.commentMode .preview-container-commentMode .device-scroll-view .device{width:300px;height:400px;margin:auto;position:relative;transform-origin:top}.pop-alert-cover{position:fixed;height:100%;width:100%;top:0;left:0;background:hsla(0,0%,50%,.5);z-index:10000000}.pop-alert-cover .pop-alert{position:absolute;width:300px;height:140px;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#fff;padding:20px;border:1px solid #999;border-radius:6px}.pop-alert-cover .pop-alert .close{position:absolute;right:10px;top:10px;cursor:pointer}.pop-alert-cover .pop-alert .content{font-size:14px;text-align:center;margin:30px}.pop-alert-cover .pop-alert .btns{text-align:center}.pop-alert-cover .pop-alert .btns input[type=button]{height:30px;border:none;outline:none;margin:10px;border-radius:2px}.pop-alert-cover .pop-alert .btns .save{width:100px;background:#d73300;color:#fff}.pop-alert-cover .pop-alert .btns .cancel{width:100px;background:#a0a09b;color:#fff}.pop-alert-cover .pop-alert .btns .sure{width:150px;background:#d73300;color:#fff}.pop-alert-cover .pop-alert .process-back{width:100%;height:2px;margin-bottom:20px;background-color:#c7edf1}.pop-alert-cover .pop-alert .process-back .process-value{height:2px;background-color:#2cbdcd}.pop-alert-cover .sign-alert{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:400px;background-color:#fff;border:1px solid #999;border-radius:6px}.pop-alert-cover .sign-alert .close{position:absolute;right:10px;top:10px;cursor:pointer}.pop-alert-cover .sign-alert .top-box{padding:10px 10px 0}.pop-alert-cover .sign-alert .top-box .text{font-size:18px;text-align:center;padding-bottom:10px;margin:0;border-bottom:1px solid #dcdcdc}.pop-alert-cover .sign-alert .bottom-box{margin:40px 40px 50px;text-align:center}.pop-alert-cover .sign-alert .bottom-box .sign-text{width:230px;height:25px;margin-right:10px;border-radius:2px;outline:none}.pop-alert-cover .sign-alert .bottom-box .sign-button{height:30px;border:none;outline:none;border-radius:2px;width:70px;background:#d73300;color:#fff;font-family:微软雅黑}.pop-alert-cover .sign-alert .msg{position:absolute;left:43px;bottom:28px;color:gray;font-size:12px}.pop-alert-cover .loading{position:absolute;width:100px;height:18px;top:50%;left:50%;transform:translate(-50%,-50%)}.commentMode-popWindow{top:0;z-index:10000;position:absolute;overflow:hidden}.commentMode-popWindow.painting canvas{cursor:crosshair}.commentMode-popWindow .paint-toolbar{position:fixed;z-index:3;top:0;left:0;background:#cdcdcd;height:50px;width:100%;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding:0 20px;box-sizing:border-box}.commentMode-popWindow .paint-toolbar .page-title{font-size:16px;line-height:16px;color:#333}.commentMode-popWindow .paint-toolbar span{margin:0 8px;width:26px;height:26px;display:inline-block;cursor:default;position:relative;box-sizing:border-box}.commentMode-popWindow .paint-toolbar span img{position:absolute;left:0;right:0;top:0;bottom:0;margin:auto}.commentMode-popWindow .paint-toolbar span.current{border:1px solid #707070;border-radius:4px}.commentMode-popWindow .paint-toolbar span:hover{border:1px solid #a0a0a0;border-radius:4px}.commentMode-popWindow .paint-toolbar .tools{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-align:center;align-items:center}.commentMode-popWindow .paint-toolbar .tools .tools-left{height:28px;border-right:1px solid #828282;padding-right:10px}.commentMode-popWindow .paint-toolbar .tools .tools-right{height:28px;padding-left:10px}.commentMode-popWindow .paint-toolbar .tools .tool-background{background-color:#bcbcbc;border:1px solid #707070;border-radius:2px}.commentMode-popWindow .paint-toolbar .tool-exit{cursor:default}.commentMode-popWindow .input-text{position:absolute;zIndex:4;display:none;resize:none;padding:10px;overflow:hidden;border:none;outline:none;font-family:微软雅黑;line-height:1em;word-break:break-all;wrap:physical;override:hidden}.commentMode-popWindow .style-picker-box{position:fixed;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center;top:50px;width:245px;height:38px;background-color:#e5e5e5;border:1px solid #333}.commentMode-popWindow .style-picker-box .font-box{width:72px;height:30px}.commentMode-popWindow .style-picker-box .font-box,.commentMode-popWindow .style-picker-box .font-box .font-check-box{margin-left:4px;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-align:center;align-items:center}.commentMode-popWindow .style-picker-box .font-box .font-check-box{width:45px;height:22px;-ms-flex-positive:1;flex-grow:1;background-color:#fff;border:1px solid #c6c6c6}.commentMode-popWindow .style-picker-box .font-box select::-ms-expand{display:none}.commentMode-popWindow .style-picker-box .font-box .font-check-style{width:90%;height:80%;margin-left:4px;border:none;outline:none;appearance:none;-moz-appearance:none;-webkit-appearance:none;-ms-appearance:none;background:url(\"http://ourjs.github.io/static/2015/arrow.png\") no-repeat scroll 100% transparent;padding-right:14px}.commentMode-popWindow .style-picker-box .font-box .font-icon-style{font-size:22px}.commentMode-popWindow .style-picker-box .line-width-check{width:72px;height:100%;margin-left:4px;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-align:center;align-items:center}.commentMode-popWindow .style-picker-box .line-width-check .line-check-box{width:23px;height:23px}.commentMode-popWindow .style-picker-box .line-width-check .line-width{border-radius:50%;background-color:#000}.commentMode-popWindow .style-picker-box .color-box{width:158px;height:30px;margin-left:6px;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center}.commentMode-popWindow .style-picker-box .color-box .checked-color{width:26px;height:26px;border:1px solid #333}.commentMode-popWindow .style-picker-box .color-box .checked-color-box{width:28px;height:28px}.commentMode-popWindow .style-picker-box .color-box .checked-color-box .back-checked-color{width:20px;height:16px;left:8px;top:-6px;z-index:10003;position:relative}.commentMode-popWindow .style-picker-box .color-box .checked-color-box .front-checked-color{width:20px;height:16px;left:0;top:0;z-index:10004;position:relative}.commentMode-popWindow .style-picker-box .color-box .color-check-box{width:128px;height:30px;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;margin-left:2px}.commentMode-popWindow .style-picker-box .color-box .color-check-box .color-item{width:11px;height:11px;margin-left:3px;margin-top:1px;border:1px solid #707070}.commentMode-popWindow .style-picker-box .color-box .range-box{width:60px;height:100%;flex-gorw:1;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-align:center;align-items:center;margin-left:4px;box-sizing:border-box;position:relative}.commentMode-popWindow .style-picker-box .color-box .range-box input{padding:0;margin:0;width:60px;height:4px;background-color:#505050;line-height:normal;color:inherit;font:inherit;border:initial;-moz-appearance:none;appearance:none;-webkit-appearance:none}.commentMode-popWindow .style-picker-box .color-box .range-box input[type=range]{-webkit-appearance:none;border-radius:6px;outline:none}.commentMode-popWindow .style-picker-box .color-box .range-box input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;border:1px solid #999;height:14px;width:14px;border-radius:50%;background:#eee;cursor:pointer}.commentMode-popWindow .style-picker-box .color-box .range-box input[type=range]::-moz-range-thumb{-moz-appearance:none;border:1px solid #999;height:14px;width:14px;border-radius:50%;background:#eee;cursor:pointer}.commentMode-popWindow .style-picker-box .color-box .range-box input[type=range]::-ms-thumb{-ms-appearance:none;border:1px solid #999;height:14px;width:14px;border-radius:50%;background:#fff;cursor:pointer}.commentMode-popWindow .style-picker-box .color-box .range-box input[type=range]::-ms-track{width:100%;cursor:pointer;background:transparent;border-color:transparent;color:transparent}.commentMode-popWindow .style-picker-box .color-box .range-box input[type=range]::-ms-fill-lower{height:22px;border-radius:10px;background:transparent}.commentMode-popWindow .style-picker-box .color-box .alpha-range{-webkit-appearance:none;width:53px;height:5px;background:gray;border:none;outline:none}.page-remark{position:fixed;right:0;top:0;width:320px;height:100%;background:#333;z-index:100;box-sizing:border-box;transition:all .2s;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap}.page-remark .tab-bar{margin:10px;text-align:center;border-bottom:1px solid #666}.page-remark .tab-bar span{width:110px;display:inline-block;color:#fff;text-align:center;margin:0 5px;cursor:pointer;padding:10px 0}.page-remark .tab-bar .current{border-bottom:2px solid #e0e0e0}.page-remark .page-remark-content{color:#b0b0b0;font-size:12px;overflow:auto;padding:10px}.page-remark .page-comments{display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-positive:10;flex-grow:10;overflow:hidden}.page-remark .page-comments .comment-list{padding:10px;color:#b0b0b0;font-size:12px;border-bottom:1px solid #505050;-ms-flex-positive:1;flex-grow:1;position:relative}.page-remark .page-comments .comment-list .item{margin:15px 40px 15px 0;padding:2px}.page-remark .page-comments .comment-list .item .title .author,.page-remark .page-comments .comment-list .item .title .time{color:#909090;font-size:12px}.page-remark .page-comments .comment-list .item .title .author{margin-right:10px;color:#ddd}.page-remark .page-comments .comment-list .item .title .time{color:#909090}.page-remark .page-comments .comment-list .item .content{margin:5px 0;background:#444;padding:3px 5px;border-radius:2px;color:#fff;display:inline-block;word-break:break-all;line-height:1.4em;text-align:left;white-space:pre-line;word-wrap:break-word}.page-remark .page-comments .comment-list .item .content p{line-height:1.4em;margin:0}.page-remark .page-comments .comment-list .item-mine{margin:15px 0 15px 40px;text-align:right}.page-remark .page-comments .comment-list .item-mine .content-mine{background:#e0e0e0;color:#000}.page-remark .page-comments .comment-list .item-mine .right-time{color:#909090}.page-remark .page-comments .new-comment{background:#505050;padding:10px}.page-remark .page-comments .new-comment textarea{width:100%;height:80px;border-radius:2px;font-size:12px;font-family:微软雅黑;resize:none}.page-remark .page-comments .new-comment input,.page-remark .page-comments .new-comment textarea{background:#e0e0e0;color:#000;border-radius:2px;border:none;box-sizing:border-box;outline:none;font-size:12px}.page-remark .page-comments .new-comment ::-webkit-input-placeholder{color:#888}.page-remark .page-comments .new-comment :-moz-placeholder,.page-remark .page-comments .new-comment ::-moz-placeholder{color:#888}.page-remark .page-comments .new-comment :-ms-input-placeholder{color:#888}.page-remark .page-comments .new-comment .submit{margin:10px 0;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:justify;justify-content:space-between}.page-remark .page-comments .new-comment .submit .sign{-ms-flex-positive:1;flex-grow:1;line-height:26px;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.page-remark .page-comments .new-comment .submit .sign .lab{margin-right:10px}.page-remark .page-comments .new-comment .submit .sign .name{margin-right:5px}.page-remark .page-comments .new-comment .submit .sign span{color:#fff;font-size:12px}.page-remark .page-comments .new-comment .submit .sign img{cursor:pointer;vertical-align:middle}.page-remark .page-comments .new-comment .submit .sign input{-ms-flex-positive:1;flex-grow:1;width:100px;height:26px;line-height:1em}.page-remark .page-comments .new-comment .submit button{background:#d73300;border:none;color:#fff;width:50px;outline:none;border-radius:2px;height:27px;margin-left:10px}.page-remark .page-comments .new-comment .submit button.disabled{color:#b0b0b0;background:#606060}.page-remark .close{cursor:pointer;position:absolute;top:0;right:0}.page-remark.no-comments .current{border-bottom:none}.page-remark.no-comments .tab-bar{text-align:left}.page-remark.no-comments .tab-bar span{text-align:left;margin:0 10px}.app-reviews{position:absolute;width:100%;height:100%;z-index:99999;background:hsla(0,0%,50%,.5)}.app-reviews .app-reviews-dialog{width:800px;height:600px;overflow:hidden;max-width:80%;max-height:80%;background:#333;position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;border-radius:5px}.app-reviews .app-reviews-dialog .close{position:absolute;top:10px;right:10px;cursor:pointer}.app-reviews .app-reviews-dialog h2{text-align:center;color:#fff;border-bottom:1px solid #505050;padding:10px 0;margin:0;font-weight:400}.app-reviews .app-reviews-dialog .no-data{color:#fff;text-align:center}.app-reviews .app-reviews-dialog .revisions-and-reviews{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-positive:1;flex-grow:1}.app-reviews .app-reviews-dialog .revisions-and-reviews .scroll-box{overflow:auto;width:100%;height:100%;position:relative}.app-reviews .app-reviews-dialog .revisions-and-reviews .revisions{width:150px;min-width:150px;border-right:1px solid #505050;min-height:100%;overflow:auto}.app-reviews .app-reviews-dialog .revisions-and-reviews .revisions .revision{cursor:pointer;text-align:center;border-bottom:1px solid #505050;padding:10px 0}.app-reviews .app-reviews-dialog .revisions-and-reviews .revisions .revision .time,.app-reviews .app-reviews-dialog .revisions-and-reviews .revisions .revision .title{margin:0;padding:3px 0;font-size:12px}.app-reviews .app-reviews-dialog .revisions-and-reviews .revisions .revision .title{color:#fff}.app-reviews .app-reviews-dialog .revisions-and-reviews .revisions .revision .time{color:#929292}.app-reviews .app-reviews-dialog .revisions-and-reviews .revisions .revision.current{background:#505050}.app-reviews .app-reviews-dialog .revisions-and-reviews .reviews{overflow:auto;-ms-flex-positive:1;flex-grow:1;padding:0 20px;color:#fff;font-size:12px}.app-reviews .app-reviews-dialog .revisions-and-reviews .reviews .review{margin:10px 0}.app-reviews .app-reviews-dialog .revisions-and-reviews .reviews .review .title .name{margin-right:10px}.app-reviews .app-reviews-dialog .revisions-and-reviews .reviews .review .title .time{color:#929292}.app-reviews .app-reviews-dialog .revisions-and-reviews .reviews .review .content{background:#e0e0e0;color:#000;display:inline-block;padding:3px;border-radius:2px;margin:5px 0;word-break:break-all}.app-reviews .app-reviews-dialog .revisions-and-reviews .reviews .review a{color:#f37b49}@media only screen and (min-device-width:1440px){.clearfix:after{content:\" \";display:block;height:0;clear:both}body{scrollbar-base-color:silver;scrollbar-face-color:#999;scrollbar-3dlight-color:#999;scrollbar-highlight-color:#ddd;scrollbar-track-color:#ddd;scrollbar-arrow-color:#222;scrollbar-shadow-color:#ddd;scrollbar-dark-shadow-color:#ddd}.pages .tree::-webkit-scrollbar-track{background:rgba(0,0,0,.2)}.pages .tree::-webkit-scrollbar-thumb{background:hsla(0,0%,100%,.4);border-radius:2px}.pages .tree::-webkit-scrollbar-corner{background:none}.pages .tree::-webkit-scrollbar{width:4px;height:4px}}body,html{width:100%;height:100%;font-size:14px;font-family:Microsoft YaHei,Segoe UI,lucida grande,lucida sans unicode,lucida,helvetica,Hiragino Sans GB,sans-serif;overflow-x:hidden;overflow-y:auto;-webkit-tap-highlight-color:rgba(0,0,0,0)}.stage,body,html{padding:0;margin:0}.stage{list-style:none;position:absolute;background:#fff}.stage .page-list-item{position:absolute;background-color:#fff;will-change:left,top,opacity}.stage .page-list-item,.stage .page-list-item .page{overflow:hidden;width:100%;height:100%}.stage .page-list-item .page .page-bottom,.stage .page-list-item .page .page-middle,.stage .page-list-item .page .page-top{position:absolute;width:100%;overflow:hidden}.stage .page-list-item .page .page-top{top:0;z-index:2}.stage .page-list-item .page .page-bottom{z-index:2}.stage .page-list-item .page .page-bottom .page-container{position:relative}.stage .page-list-item .page .page-middle{z-index:1}.stage .page-list-item .page .page-middle .page-container{position:relative;width:100%;overflow:hidden}.comments{position:absolute;z-index:2}.component{position:absolute;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-select:none}.component label,.component p{-moz-user-select:text;-ms-user-select:text;user-select:text;-webkit-user-select:text}.component-render-error{color:#fff;background:red;font-size:12px}.remark{z-index:999;display:none;position:fixed;pointer-events:none;border:1px solid #333;background-color:#facf4e;border-radius:5px;padding:5px;max-width:300px}.common-multi-line-text p,.remark{word-wrap:break-word;word-break:break-word}.common-multi-line-text p{margin:0;font-size:14px}.preview-loading{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.preview-loading img{width:120px;height:120px}.mobile-preview .scale-container{transform-origin:top left}.mobile-preview .mobile-preview-panel{padding:10px;transition:margin-left .2s;margin-left:0;z-index:3;position:absolute;left:0;width:200px;height:100%;overflow:auto;box-sizing:border-box;display:block}.mobile-preview .mobile-preview-panel .mobile-panel-wrap{position:relative;height:100%;overflow:auto}.mobile-preview .mobile-preview-panel .mobile-panel-wrap .header{position:absolute;left:0;right:0;top:0;height:26px}.mobile-preview .mobile-preview-panel .mobile-panel-wrap .pages{position:absolute;top:26px;left:0;width:100%}.mobile-preview .mobile-preview-panel .mobile-panel-wrap .back-btn{position:absolute;left:0;bottom:10px;width:100%;height:35px;border:none;color:#fff;background-color:#f95555}.mobile-preview .mobile-preview-panel h1{font-size:12px;font-weight:700;margin:0 0 10px}.mobile-preview .mobile-preview-panel-background{position:absolute;width:100%;height:100%;left:0;top:0;z-index:2}.mobile-preview .control-ball{position:fixed;z-index:20;background-color:#d73300;width:80px;height:80px;border-radius:40px;text-align:center;line-height:60px;color:#fff;font-size:24px;box-shadow:0 6px 6px 0 rgba(0,0,0,.3)}.mobile-preview .control-ball img{display:block;width:68px;height:68px;margin:6px auto}.mobile-preview .control-ball.edge{opacity:.3;box-shadow:none}.mobile-preview .finishing{transition:all .2s}.animation-stage-container{position:absolute;overflow:hidden}.animation-stage-container .stage{position:absolute;width:100%;height:100%;left:0;top:0}.animation-stage-container .stage .one,.animation-stage-container .stage .two{position:absolute;left:0;top:0;width:100%;height:100%;overflow:hidden}.animation-stage-container .stage .one{z-index:1}.animation-stage-container .stage .two{z-index:0}#container{width:100%;height:100%}#container .app{height:100%}#container .app,#container .app .top-bar{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;width:100%}#container .app .top-bar{position:fixed;top:0;left:0;height:40px;box-sizing:border-box;z-index:2;opacity:0;padding:0 24px;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}#container .app .top-bar:hover{opacity:1}#container .app .top-bar>span{cursor:pointer;display:inline-block;width:32px;height:32px}#container .app .top-bar .navigation{float:right}#container .app .navigation-bar{position:absolute;height:47px;box-sizing:border-box;border:1px solid #000;box-shadow:0 0 0 1px #fff;background-color:rgba(0,0,0,.3);z-index:10000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#container .app .navigation-bar .navigation-bar-title{height:13px;background-color:rgba(0,0,0,.8);color:#fff;text-align:right;font-size:10px;line-height:10px;padding:0;cursor:default}#container .app .navigation-bar .navigation-bar-title img{position:relative;top:1px;right:2px;cursor:pointer}#container .app .navigation-bar .navigation-bar-title img:hover{background-color:#606060}#container .app .navigation-bar .navigation-actions{height:34px;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding:0 5px;min-width:30px}#container .app .navigation-bar .navigation-actions .navs,#container .app .navigation-bar .navigation-actions .panel{height:24px}#container .app .navigation-bar .navigation-actions .panel-left{padding-right:5px}#container .app .navigation-bar .navigation-actions .action{margin:0 4px;position:relative}#container .app .navigation-bar .navigation-actions .action img{cursor:pointer;width:24px;height:24px}#container .app .navigation-bar .navigation-actions .action img:hover{box-shadow:0 0 1px 1px rgba(0,0,0,.2);background-color:rgba(0,0,0,.2)}#container .app .navigation-bar .navigation-actions .action .tooltip{display:none;position:absolute;top:20px;left:-5px;background:#facf4e;border:1px solid #725603;padding:1px 5px;white-space:nowrap;font-size:12px}#container .app .navigation-bar .navigation-actions .action:hover .tooltip{display:block}#container .app .navigation-bar .navigation-actions .panel-right{border-left:1px solid #666}#container .app .pc-preview-panel{width:260px;min-width:260px;padding:10px;position:relative;transition:margin-left .2s;box-sizing:border-box;z-index:3;font-size:12px}#container .app .pc-preview-panel .preview-options-section{padding-bottom:12px}#container .app .pc-preview-panel .preview-options-section .preview-controls{margin:5px 0}#container .app .pc-preview-panel .preview-options-section .preview-controls span{margin-right:10px;cursor:pointer}#container .app .pc-preview-panel .preview-options-section .preview-controls span:hover{color:#d73300}#container .app .pc-preview-panel .preview-options-section .option>div{margin:5px 0}#container .app .pc-preview-panel .preview-options-section .preview-options span{cursor:pointer}#container .app .pc-preview-panel .preview-options-section .bg-colors,#container .app .pc-preview-panel .preview-options-section .shell{margin:10px 0}#container .app .pc-preview-panel .preview-options-section .bg-colors .bg-color{display:inline-block;width:18px;height:18px;margin-right:8px;cursor:pointer;border:1px solid #333}#container .app .pc-preview-panel .scale-and-control{padding:12px 0;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-align:center;align-items:center}#container .app .pc-preview-panel .scale-and-control .reset{cursor:pointer;padding:0 10px}#container .app .pc-preview-panel .scale-and-control .toggle-options{cursor:pointer;padding:0 5px}#container .app .preview-container{-ms-flex-positive:1;flex-grow:1;width:0;height:100%;z-index:1;overflow:auto;padding:0;box-sizing:border-box}#container .app .preview-container .device-scroll-view{position:relative;width:100%;height:100%;overflow:auto;display:-ms-flexbox;display:flex}#container .app .preview-container .device-scroll-view .device-scroll-content{-ms-flex-negative:1;flex-shrink:1;margin:auto}#container .app .preview-container .device-scroll-view .device-scroll-content .paint-stage{position:absolute;left:0;top:0}#container .app .preview-container .device-scroll-view .device{width:300px;height:400px;margin:auto;position:relative;transform-origin:top}#container .app .preview-container .device-scroll-view .device .shell{width:100%;height:100%;margin:auto;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#container .app .preview-container .device-scroll-view .device .shell img{-webkit-user-drag:none}#container .app .preview-container .device-scroll-view .device .shell svg{float:left}#container .app .preview-container .device-scroll-view .device .shell img{width:auto;height:auto}#container .app .preview-container .device-scroll-view .device .shell .shell-whole{width:100%;height:100%;display:block;float:left}#container .app .preview-container .device-scroll-view .device .shell .shell-home,#container .app .preview-container .device-scroll-view .device .shell .shell-top{position:absolute;left:50%;transform:translateX(-50%)}#container .app .preview-container .device-scroll-view .device .shell .shell-top{top:0}#container .app .preview-container .device-scroll-view .device .shell .shell-home{bottom:0}#container .app .preview-container .device-scroll-view .device .shell .screen-placeholder{background-color:#fff;position:absolute}#container .app .preview-container .device-scroll-view .device .shell.horizontal .shell-home,#container .app .preview-container .device-scroll-view .device .shell.horizontal .shell-top{top:50%;transform:translateY(-50%)}#container .app .preview-container .device-scroll-view .device .shell.horizontal .shell-top{left:0}#container .app .preview-container .device-scroll-view .device .shell.horizontal .shell-home{right:0;bottom:auto;left:auto}.page-popup{position:absolute;z-index:2;left:0;top:0;width:100%}.preview-panel{background-color:#333;color:#b0b0b0;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.preview-panel .header,.preview-panel .page-name,.preview-panel .preview-options-section,.preview-panel .scale-and-control{-ms-flex-negative:0;flex-shrink:0}.preview-panel .header{position:relative}.preview-panel .header .app-name{padding:6px 0;margin:0 20px 0 0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-size:14px;display:inline;float:left;max-width:70%}.preview-panel .header .message{float:left;margin-top:6px;cursor:pointer}.preview-panel .header .close{cursor:pointer;position:absolute;top:50%;right:0;transform:translateY(-50%)}.preview-panel .page-name-box{border-bottom:1px solid #505050;padding:10px 0}.preview-panel .page-name-box .copy-page-link{width:11px;height:11px;cursor:pointer;margin-top:1px;vertical-align:middle}.preview-panel .page-name-box .page-name{width:210px;display:inline-block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-size:12px;padding:10px 0;margin:0 0 0 10px;vertical-align:middle}.preview-panel .pages{-ms-flex-positive:10;flex-grow:10;-ms-flex-negative:1;flex-shrink:1;padding:20px 0;color:#b0b0b0;background:#333;border-top:1px solid #505050;font-weight:400;overflow:hidden}.preview-panel .pages .tree{padding:0 0 0 2px;float:left;position:relative}.preview-panel .pages .tree .root{padding-left:10px}.preview-panel .pages .tree .root>.node-name{padding-left:13px!important}.preview-panel .pages .tree .root>.node-name>img{margin-right:3px}.preview-panel .pages .tree .root:after,.preview-panel .pages .tree .root:before{display:none}.preview-panel .pages .tree .root>.status{left:-7px}.preview-panel .pages .tree .root>.status img{left:0;top:-12px}.preview-panel .pages .tree .root>.status:before{left:4px}.preview-panel .pages .tree .root>.status:after{display:none}.preview-panel .pages .tree ul{list-style:none;padding:0;margin:0;position:relative}.preview-panel .pages .tree li{position:relative;padding-left:20px;margin-left:5px;font-size:12px;line-height:24px;cursor:default}.preview-panel .pages .tree li:before{content:\"\";width:1px;height:100%;position:absolute;background-color:#505050;left:-18px;top:7px}.preview-panel .pages .tree li:after{content:\"\";width:29px;height:1px;position:absolute;background-color:#505050;left:-18px;top:13px}.preview-panel .pages .tree li.module:after{width:20px}.preview-panel .pages .tree li.module-without-children:after{width:29px}.preview-panel .pages .tree li:last-child:before{height:7px}.preview-panel .pages .tree .status{position:absolute;top:10px;left:2px;width:11px;height:11px;display:inline-block;z-index:1}.preview-panel .pages .tree .status.closed:before{display:none}.preview-panel .pages .tree .status.mobile{width:20px;height:20px}.preview-panel .pages .tree .status.mobile:before{height:23px}.preview-panel .pages .tree .status img{position:relative;top:-10px;left:2px}.preview-panel .pages .tree .status:before{content:\"\";width:1px;height:15px;position:absolute;background:#505050;top:10px;left:5px}.preview-panel .pages .tree .module>.node-name,.preview-panel .pages .tree .parent-li>.node-name{position:relative;left:-14px;padding:0 14px;margin-right:-14px}.preview-panel .pages .tree .node-name{display:block}.preview-panel .pages .tree .node-name img{position:relative;right:5px;top:2px;z-index:1}.preview-panel .pages .tree .node-name span{padding-right:32px}.preview-panel .pages .tree .module{white-space:nowrap}.preview-panel .pages .tree .module>.module-name .node-name{font-size:14px}.preview-panel .pages .tree .current{font-weight:700;color:#fff}.preview-panel .pages .scroll{float:right;width:4px;height:200px;position:relative;background-color:red}.preview-panel .pages .scroll .scrollBar{display:block;position:absolute;top:29px;left:0;width:4px;height:100px;background-color:#444;border-radius:2px}.preview-panel .my-qr-code{text-align:center;border-top:1px solid #505050}.preview-panel .my-qr-code .toggle-qr-box{text-align:right;margin-top:12px}.preview-panel .my-qr-code .toggle-QRCode{padding:0 5px;cursor:pointer}.preview-panel .my-qr-code .desc{width:160px;margin:auto;padding-top:10px}.preview-panel .advertisement{margin:5px auto;text-align:center}.preview-panel .advertisement .link_home{color:#b0b0b0}.contents-layout{left:0;top:0;width:100%;height:100%;position:absolute}.select-style{border:1px solid #999;width:175px;border-radius:3px;overflow:hidden;box-sizing:border-box}.select-style select{padding:5px 8px;box-sizing:border-box;width:175px;border:none;box-shadow:none;background:transparent;background-image:none;border-radius:0;-webkit-appearance:none}.select-style select:focus{outline:none}.checkbox-control{height:19px;position:relative;line-height:19px}.checkbox-control-input{visibility:hidden}.checkbox-control label{cursor:pointer;position:absolute;width:12px;height:12px;top:3px;left:0;background:#eee;border:1px solid hsla(0,0%,60%,0)}.checkbox-control label:after{opacity:0;content:\"\";position:absolute;width:11px;height:5px;background:transparent;top:1px;left:0;border:1px solid #1e1e1e;border-top:none;border-right:none;transform:rotate(-50deg)}.checkbox-control label:hover:after{opacity:0}.checkbox-control input[type=checkbox]:checked+label:after{opacity:1}.custom-resizer{width:172px;height:23px;padding:2px 5px;background-color:#333;box-sizing:border-box;position:relative}.custom-resizer input{margin:0 6px;padding:0;width:150px;height:4px;background-color:#505050;line-height:normal;color:inherit;font:inherit;border:initial;-webkit-appearance:none}.custom-resizer input[type=range]{-webkit-appearance:none;border-radius:6px;outline:none}.custom-resizer input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;border:1px solid #999;height:14px;width:14px;border-radius:50%;background:#eee;cursor:pointer}.custom-resizer input[type=range]::-moz-range-thumb{border:1px solid #999;height:14px;width:14px;border-radius:50%;background:#eee;cursor:pointer}.custom-resizer input[type=range]::-ms-thumb{border:1px solid #999;height:14px;width:14px;border-radius:50%;background:#eee;cursor:pointer}.custom-resizer input[type=range]::-ms-track{width:100%;cursor:pointer;background:transparent;border-color:transparent;color:transparent}.custom-resizer input[type=range]::-ms-fill-lower{height:22px;border-radius:10px;background:transparent}.remote-preview-help{font-size:14px;padding:40px}.remote-preview-help a{color:#d73300}@keyframes dance-up-down{0%{transform:translateY(0)}to{transform:translateY(20px)}}.app-error{padding:40px}.ios-warning{position:relative;width:100%;height:100%}.ios-warning .content{text-align:center;position:relative;top:50%;transform:translateY(-50%)}.ios-warning .content .header{margin-bottom:20px}.ios-warning .content .header h2{font-size:1.5em;margin:0}.ios-warning .content .header:after{content:\"\";display:inline-block;width:80%;height:1px;background-color:#ddd}.ios-warning .content .how-to-install{font-size:1em}.ios-warning .content .how-to-install h3{font-size:1.2em;color:#aaa;margin:0}.ios-warning .content .how-to-install .open-now{margin-top:60px;color:#666}.ios-warning .content .how-to-install .open-now a{color:#444}.ios-warning .arrow{width:100%;position:fixed}.ios-warning .arrow img{display:none;animation:.8s dance-up-down;animation-timing-function:linear;animation-iteration-count:infinite;animation-direction:alternate}.ios-warning .arrow.top-right{top:0}.ios-warning .arrow.top-right .top-right-arrow{display:inline;position:absolute;right:0}.ios-warning .arrow.bottom-center{bottom:0;text-align:center}.ios-warning .arrow.bottom-center .bottom-center-arrow{display:inline-block}.authorization{border:1px solid #999;width:400px;padding:30px;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center;box-sizing:border-box;font-family:Microsoft YaHei,Segoe UI,lucida grande,lucida sans unicode,lucida,helvetica,Hiragino Sans GB,sans-serif;font-size:14px}.authorization h3{border-bottom:1px solid #ccc;padding-bottom:10px;margin:0;font-weight:400;font-size:14px}.authorization .verify{margin-top:40px;font-size:14px}.authorization .verify .pwd-input{display:inline-block}.authorization .verify .pwd-input input{width:200px;height:30px;padding:5px 2px;box-sizing:border-box;outline:none;border:1px solid #999}.authorization .verify .pwd-input input:focus{border:1px solid #333}.authorization .verify .pwd-input button{width:100px;height:30px;box-sizing:border-box;border:none;background:#bd3a00;margin-left:10px;color:#fff;position:relative;top:-2px;outline:none}.authorization .verify .pwd-input .error{color:red;text-align:left;margin:5px 0}@media only screen and (max-device-width:1000px){.authorization{width:100%;border:none}.authorization .verify .pwd-input button,.authorization .verify .pwd-input input{display:block;margin:auto}.authorization .verify .pwd-input input{margin-bottom:20px}.authorization .verify .pwd-input .error{text-align:center}.preview-panel .pages .tree li{line-height:36px}}.maskBg{left:0;top:0;z-index:1;height:100%;width:100%;opacity:0}.maskBg,.ux2017-work{position:fixed;background:#fff}.ux2017-work{right:20px;bottom:150px;z-index:9999;padding:20px;border:1px solid #fc6863;border-radius:10px}.ux2017-work a{color:#fc6863}.ux2017-work p{margin:10px 0}.ux2017-work .close{background-image:url(\"data:image/png;base64,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\");background-size:100% 100%;display:inline-block;width:16px;height:16px;position:absolute;right:10px;top:10px;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(51);
	var request = __webpack_require__(59);
	var assetsHelper = __webpack_require__(65);
	
	var defaulgConfig = window.isDev ? {
	  iOSGuide: true,
	  logo: assetsHelper.getAsset('logo_for_ios.png'),
	  showControlPanel: true, // 显示控制面板
	  shell: '', // 外壳
	  background: '#F0F0F0', // 背景色
	  alwaysShowLinks: true, // 始终显示链接
	  hoverShowLinks: false, // 鼠标滑过时显示链接
	  hoverShowRemarks: true, //鼠标滑过时，显示备注
	  showComments: true, // 显示批注
	  showQRCode: true, // 显示二维码
	  hintLinks: false, // 闪烁提示链接
	  scrollRemarks: true, // 链接自动滚动
	  isShowAllPageNode: true, //是否显示被隐藏的节点
	  isShowPreviewTools: true, //是否显示导航工具栏
	  showRemarkFlag: true // 是否显示备注的小图标
	} : {
	  iOSGuide: true,
	  logo: assetsHelper.getAsset('logo.png'),
	  showControlPanel: true, // 显示控制面板
	  shell: '', // 外壳
	  background: '#F0F0F0', // 背景色
	  alwaysShowLinks: false, // 始终显示链接
	  hoverShowLinks: false, // 鼠标滑过时显示链接
	  hoverShowRemarks: true, //鼠标滑过时，显示备注
	  showComments: true, // 显示批注
	  showQRCode: true, // 显示二维码
	  hintLinks: false, // 闪烁提示链接
	  scrollRemarks: true, // 链接自动滚动
	  isShowAllPageNode: false, //是否显示被隐藏的节点
	  isShowPreviewTools: true, //是否显示导航工具栏
	  showRemarkFlag: true // 是否显示备注的小图标
	};
	
	var config = _.extend(defaulgConfig, window.config);
	
	// 导出时中的设置有时候 logo 可能为空，此时忽略掉，使用默认配置
	if (window.config && !window.config.logo) {
	  config.logo = defaulgConfig.logo;
	}
	
	exports.getConfig = function (cb) {
	  if (window.mockplus || window.enterprise) {
	    return request.get('config.json?rnd=' + Math.random()).end(function (err, res) {
	      var newConfig;
	      if (err) {
	        return cb(null, config);
	      }
	      try {
	        console.log(res.body);
	        newConfig = _.extend(config, res.body);
	        console.log(newConfig);
	        if (!newConfig.logo) {
	          newConfig.logo = assetsHelper.getAsset('logo.png');
	        }
	        cb(null, newConfig);
	      } catch (e) {
	        cb(null, config);
	      }
	    });
	  }
	  cb(null, config);
	};
	
	exports.notForceUseCurrentBrowser = function () {
	  return window.location.href.indexOf('force=1') === -1;
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(60);
	var reduce = __webpack_require__(61);
	var requestBase = __webpack_require__(62);
	var isObject = __webpack_require__(63);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  root = this;
	}
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Expose `request`.
	 */
	
	var request = module.exports = __webpack_require__(64).bind(null, Request);
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pushEncodedKeyValuePair(pairs, key, obj[key]);
	        }
	      }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (Array.isArray(val)) {
	    return val.forEach(function(v) {
	      pushEncodedKeyValuePair(pairs, key, v);
	    });
	  }
	  pairs.push(encodeURIComponent(key)
	    + '=' + encodeURIComponent(val));
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    if (err) {
	      return self.callback(err, res);
	    }
	
	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }
	
	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;
	
	    self.callback(new_err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter` and `requestBase`.
	 */
	
	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr && this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and 
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * @deprecated
	 */
	Response.prototype.parse = function serialize(fn){
	  if (root.console) {
	    console.warn("Client-side parse() method has been renamed to serialize(). This method is not compatible with superagent v2.0");
	  }
	  this.serialize(fn);
	  return this;
	};
	
	Response.prototype.serialize = function serialize(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = 'download';
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._parser || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(63);
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Force given parser
	 *
	 * Sets the body parser no matter type.
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Faux promise support
	 *
	 * @param {Function} fulfill
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	exports.then = function then(fulfill, reject) {
	  return this.end(function(err, res) {
	    err ? reject(err) : fulfill(res);
	  });
	}
	
	/**
	 * Allow for extension
	 */
	
	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	exports.getHeader = exports.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	  this._getFormData().append(name, val);
	  return this;
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null != obj && 'object' == typeof obj;
	}
	
	module.exports = isObject;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }
	
	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }
	
	  return new RequestConstructor(method, url);
	}
	
	module.exports = request;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var path = __webpack_require__(66);
	var envHelper = __webpack_require__(48);
	var prefix = '';
	
	// 如果是 mockplus 的, 要到根目录下面去找
	if (window.mockplus) {
	  prefix = '/';
	}
	
	if (window.CDN && !envHelper.isIEOrEdge()) {
	  // IE 下面不能使用 CDN，会导致图标不显示
	  prefix = window.CDN;
	}
	
	// 开发的时候,到 dist/ 目录下面去找
	if (window.isDev) {
	  prefix = 'dist/';
	}
	
	/*  验证文件修改
	 var sourceStr = "avatar(mobile).png@statusbar(android).png@statusbar(ios).png@top actionbar.png" +
	 "@CheckMark.png@Dot.png@HLine_1.png@HRule.png@rectangleUp.png@roundRectangle.png@VLine_1.png" +
	 "@ace, card, cards, game, hazard, heart, playing.png@aid, ambulance, bandage, bandaid, care, doctor.png@aid, capsule, care, chemistry, doctor, dose, drug.png@alcohol, beer, beverage, bottle, drink, glass.png@ambulance, care, chemistry, cure, doctor, dope.png@american, fast food, hamburger, line, meal.png@and, fruits, lemon, vegetables.png@angel, christmas, decoration, winter.png@appliance, bread, food, toast, toaster.png@apron, pocket.png@arrow, streamline, target.png@awareness ribbon, health, healthcare, hospital.png@badminton, birdie, racquetball, sport.png@bag, shopping, streamline.png@ball, baseball, game, sport, stick.png@ball, basketball, education, game, school, sport.png@ball, christmas, crystal, decoration, snow globe.png@ball, christmas, decoration, winter.png@ball, education, football, game, handball, school.png@ball, pool, rounded, sport.png@ball, rounded, soccer, sport.png@barbecue, eat, food, streamline.png@basic, bowling, game, play.png@bathroom, charming, clean up, paper, restroom.png@beaker, chemistry, health, healthcare, hospital.png@beauty in nature, cartoon, christmas, christmas.png@bee, honey, jar, sweet.png@bicycle, bike, biking, cycling, fitness, sport.png@bodybuilding, muscle, sport.png@bomb, bug.png@boot, christmas, decoration, sock, winter.png@bottle, drink, milk.png@bottle, food, honey, jar.png@brush, paint, streamline.png@business, chess, finance, financial, game, horse.png@cake, candy, christmas, cookies.png@camera, streamline, video.png@candle, christmas, decoration.png@candy, christmas, decoration, winter.png@candy, christmas, sweet.png@candy, lollipop, lollypop, sugar, sweet.png@capsule, care, chemistry, dose, drug, health.png@care, health, heart, medical, pulse.png@case, cross, doctor, health, healthcare, medicine.png@champion, gold, praise, reward, sport, winner.png@chaplin, hat, streamline.png@chess, game, piece, rook, strategy.png@chicken, drumstick, food.png@chips, deep-fried, fast, food, french, fries, potato.png@christmas, cold, freeze, frost, frozen, snow.png@christmas, crown, decoration, winter, wreath.png@christmas, deer, reindeer, rudolf, winter.png@christmas, sled, sledge, sleigh.png@christmas, snow, snowman, winter.png@claus, hat, santa.png@coffee, streamline.png@cold, cone, cream, ice.png@console, controller, game, tool.png@cream, dessert, food, ice.png@cup, tea.png@dashboard, speed, streamline.png@design, graphic tablet, streamline, tablet.png@dumbbell, kettlebell, sport, weight.png@earth, globe, streamline.png@education, football, game, play, school, soccer.png@envellope, mail, streamline.png@female,woman.png@first aid, medecine, shield, streamline.png@flash drive, memory stick, usb, usb key.png@food, hood, kitchen.png@fridge, refrigerator.png@google+.png@guitar, instrument, music.png@hair dryer, service, vacation.png@health, healthcare, hospital, medical, medicine.png@ink, pen, streamline.png@ipod, mini, music, streamline.png@ipod, music, streamline.png@japan, streamline, tea.png@knife, lettuce.png@machine, sewing.png@male,man.png@microwave, oven.png@music, radio.png@notebook, streamline.png@paint bucket, streamline.png@painting, roll, streamline.png@picture, streamline.png@receipt, shopping, streamline.png@remote control, streamline.png@settings, streamline.png@stamp, streamline.png";
	 var targetStr = "avatar_mobile_.png@statusbar_android_.png@statusbar_ios_.png@top_actionbar.png" +
	 "@checkmark.png@dot.png@hline_1.png@hrule.png@rectangleup.png@roundrectangle.png@vline_1.png" +
	 "@ace_card_cards_game_hazard_heart_playing.png@aid_ambulance_bandage_bandaid_care_doctor.png@aid_capsule_care_chemistry_doctor_dose_drug.png@alcohol_beer_beverage_bottle_drink_glass.png@ambulance_care_chemistry_cure_doctor_dope.png@american_fast_food_hamburger_line_meal.png@and_fruits_lemon_vegetables.png@angel_christmas_decoration_winter.png@appliance_bread_food_toast_toaster.png@apron_pocket.png@arrow_streamline_target.png@awareness_ribbon_health_healthcare_hospital.png@badminton_birdie_racquetball_sport.png@bag_shopping_streamline.png@ball_baseball_game_sport_stick.png@ball_basketball_education_game_school_sport.png@ball_christmas_crystal_decoration_snow_globe.png@ball_christmas_decoration_winter.png@ball_education_football_game_handball_school.png@ball_pool_rounded_sport.png@ball_rounded_soccer_sport.png@barbecue_eat_food_streamline.png@basic_bowling_game_play.png@bathroom_charming_clean_up_paper_restroom.png@beaker_chemistry_health_healthcare_hospital.png@beauty_in_nature_cartoon_christmas_christmas.png@bee_honey_jar_sweet.png@bicycle_bike_biking_cycling_fitness_sport.png@bodybuilding_muscle_sport.png@bomb_bug.png@boot_christmas_decoration_sock_winter.png@bottle_drink_milk.png@bottle_food_honey_jar.png@brush_paint_streamline.png@business_chess_finance_financial_game_horse.png@cake_candy_christmas_cookies.png@camera_streamline_video.png@candle_christmas_decoration.png@candy_christmas_decoration_winter.png@candy_christmas_sweet.png@candy_lollipop_lollypop_sugar_sweet.png@capsule_care_chemistry_dose_drug_health.png@care_health_heart_medical_pulse.png@case_cross_doctor_health_healthcare_medicine.png@champion_gold_praise_reward_sport_winner.png@chaplin_hat_streamline.png@chess_game_piece_rook_strategy.png@chicken_drumstick_food.png@chips_deep_fried_fast_food_french_fries_potato.png@christmas_cold_freeze_frost_frozen_snow.png@christmas_crown_decoration_winter_wreath.png@christmas_deer_reindeer_rudolf_winter.png@christmas_sled_sledge_sleigh.png@christmas_snow_snowman_winter.png@claus_hat_santa.png@coffee_streamline.png@cold_cone_cream_ice.png@console_controller_game_tool.png@cream_dessert_food_ice.png@cup_tea.png@dashboard_speed_streamline.png@design_graphic_tablet_streamline_tablet.png@dumbbell_kettlebell_sport_weight.png@earth_globe_streamline.png@education_football_game_play_school_soccer.png@envellope_mail_streamline.png@female_woman.png@first_aid_medecine_shield_streamline.png@flash_drive_memory_stick_usb_usb_key.png@food_hood_kitchen.png@fridge_refrigerator.png@google_.png@guitar_instrument_music.png@hair_dryer_service_vacation.png@health_healthcare_hospital_medical_medicine.png@ink_pen_streamline.png@ipod_mini_music_streamline.png@ipod_music_streamline.png@japan_streamline_tea.png@knife_lettuce.png@machine_sewing.png@male_man.png@microwave_oven.png@music_radio.png@notebook_streamline.png@paint_bucket_streamline.png@painting_roll_streamline.png@picture_streamline.png@receipt_shopping_streamline.png@remote_control_streamline.png@settings_streamline.png@stamp_streamline.png";
	 var source = sourceStr.split("@");
	 var target = targetStr.split("@");
	 var e = [];
	 var pass = 0, error = 0;
	 for(var i=0;i<source.length;i++) {
	 if(target[i] == this.changeFile(source[i])) {
	 pass++;
	 }
	 else {
	 error++;
	 e.push(source[i] + "->" + target[i]);
	 }
	 }*/
	function changeFileName(name) {
	
	  name = name.replace(/,|\s|\(|\)/g, '_');
	
	  //去掉重复的下划线
	  name = name.replace(/(_)_*\1/g, "_");
	
	  if (name.indexOf('.png') === -1 && name.indexOf('.jpg') === -1) {
	    name = name + ".png";
	  }
	
	  return name.toLowerCase();
	}
	
	/**
	 * 根据资源的相对路径查找真实路径
	 * @param p
	 * @returns {string}
	 */
	exports.getAsset = function (p) {
	  return path.join(prefix, 'assets', p);
	};
	
	/**
	 * 获取组件的素材
	 * @param name
	 * @returns {string}
	 */
	exports.getComponentAsset = function (name) {
	  if (!name) {
	    return '';
	  }
	  name = changeFileName(name);
	  return path.join(prefix, 'assets/components/wireframe/', name.toLowerCase()); // 这里始终使用线框素材
	};
	
	/**
	 * 获取图标
	 * @param filename
	 * @returns {string}
	 */
	exports.getIcon = function (filename) {
	  if (!filename) {
	    return '';
	  }
	  filename = changeFileName(filename);
	  return path.join(prefix, 'assets/icons/wireframe/', filename.toLowerCase()); // 始终使用线框图标
	};
	
	/**
	 * 获取辅助素材资源
	 * @param filename
	 * @returns {string}
	 */
	exports.getAssistAsset = function (filename) {
	  if (!filename) {
	    return '';
	  }
	  filename = changeFileName(filename);
	  return path.join(prefix, 'assets/components/wireframe/commons/', filename.toLowerCase());
	};
	
	exports.getLogo = function () {
	  return path.join(prefix, 'assets/logo.png');
	};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	//mockplusjszip
	
	var JSZip = __webpack_require__(69);
	// var JSZip = require('JsZip');
	var _ = __webpack_require__(51);
	var toString = Object.prototype.toString;
	var dataHelper = __webpack_require__(113);
	var Reconstruction = __webpack_require__(117);
	var pageHelper = __webpack_require__(119);
	var appTypes = __webpack_require__(115);
	var toolHelper = __webpack_require__(121);
	var runtimeHelper = __webpack_require__(47);
	var urlHelper = __webpack_require__(122);
	var request = __webpack_require__(59);
	var version = new Date().getTime().toString(36);
	var apiHelper = __webpack_require__(123);
	var versionHelper = __webpack_require__(124);
	
	var zip = null;
	var currentProject = null;
	var currentPath = 'app'; // 非 dev 时使用
	
	// 暂时禁用缓存
	var pagesCache = {};
	var masterCache = {};
	var imageCache = {};
	
	var firstPageCache = null;
	
	/**
	 * 配置数组节点, 出现这些节点时, 即使没有同名兄弟节点,也会放到数组中
	 * @type {string[]}
	 */
	var arrayTags = ['page', 'module', 'state', 'link', 'control', 'event', 'behaviour', 'target', 'command', 'param', 'entry', 'row', 'col', 'cell'];
	
	/**
	 * 判断是否是数组
	 * @param obj
	 * @returns {boolean}
	 */
	function isArray(obj) {
	  return toString.call(obj) === '[object Array]';
	}
	
	/**
	 * 将文本转换为 DOM
	 * @param str
	 * @returns {*}
	 */
	function parseTODOM(str) {
	  var xmlDoc;
	  var parser;
	  if (window.DOMParser) {
	    parser = new DOMParser();
	    xmlDoc = parser.parseFromString(str, 'text/xml');
	  } else if (window.ActiveXObject) {
	    xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
	    xmlDoc.async = false;
	    xmlDoc.loadXML(str);
	  } else {
	    throw new Error('cannot parse xml');
	  }
	  return xmlDoc;
	}
	
	/**
	 * 判断是否是文本节点
	 * 规则:
	 * 1. 仅包含一个子节点
	 * 2. 子节点的节点名为 `#text`
	 * @param node
	 * @returns {boolean}
	 */
	function isTextNode(node) {
	  return node.childNodes.length === 1 && node.childNodes[0].nodeName === '#text';
	}
	
	/**
	 * 获取文本节点的值
	 * @param obj
	 * @returns {string}
	 */
	function getTextNode(obj) {
	  return obj.childNodes[0].nodeValue;
	}
	
	function parseNode(xmlNode, result) {
	  var length;
	  var i;
	  var jsonNode;
	  var existing;
	  var attribute;
	
	  if (isTextNode(xmlNode)) {
	    result[xmlNode.nodeName] = dataHelper.convertValue(xmlNode.nodeName, getTextNode(xmlNode));
	    return;
	  }
	
	  if (xmlNode.nodeName === '#text' && xmlNode.nodeValue.trim() === '') {
	    // ignore empty text node
	    return;
	  }
	  jsonNode = {};
	  if (xmlNode.nodeName === 'page' || xmlNode.nodeName === 'module') {
	    jsonNode.isModule = xmlNode.nodeName === 'module';
	    if (!result._pages) {
	      result._pages = [];
	    }
	    result._pages.push(jsonNode);
	  } else {
	    existing = result[xmlNode.nodeName];
	    if (existing) {
	      if (!isArray(existing)) {
	        result[xmlNode.nodeName] = [existing, jsonNode];
	      } else {
	        result[xmlNode.nodeName].push(jsonNode);
	      }
	    } else {
	      if (arrayTags && arrayTags.indexOf(xmlNode.nodeName) != -1) {
	        result[xmlNode.nodeName] = [jsonNode];
	      } else {
	        result[xmlNode.nodeName] = jsonNode;
	      }
	    }
	  }
	
	  if (xmlNode.attributes) {
	    length = xmlNode.attributes.length;
	    for (i = 0; i < length; i++) {
	      attribute = xmlNode.attributes[i];
	      if (xmlNode.nodeName === 'page' && attribute.nodeName === 'isdeleted' && attribute.nodeValue === 'True') {
	        result._pages.pop(); // 移除最后添加的那个页面
	        return;
	      }
	      jsonNode[attribute.nodeName] = dataHelper.convertValue(attribute.nodeName, attribute.nodeValue);
	    }
	  }
	
	  if (jsonNode.isfolder) {
	    jsonNode.isModule = true;
	  }
	
	  length = xmlNode.childNodes.length;
	  for (i = 0; i < length; i++) {
	    parseNode(xmlNode.childNodes[i], jsonNode);
	  }
	}
	
	function parseXMLToObject(str) {
	  var dom = parseTODOM(str);
	  var result = {};
	  if (dom.childNodes.length) {
	    parseNode(dom.childNodes[0], result);
	  }
	  return result;
	}
	
	/**
	 * 递归替换组件controlID
	 * @param comArray
	 * @param idMap
	 */
	function doResetNewComID(comArray, idMap) {
	  var i;
	  var newComID;
	  var com;
	  var l = 0;
	  if (comArray) {
	    l = comArray.length;
	  }
	  for (i = 0; i < l; i++) {
	    com = comArray[i];
	    if (com.items !== undefined) {
	      doResetNewComID(com.items, idMap);
	    }
	
	    // 重置组件ID号
	    newComID = toolHelper.newGuid();
	
	    idMap[comArray[i].controlID] = newComID;
	    comArray[i].controlID = newComID;
	  }
	}
	
	/**
	 * 递归替换组件交互中targetID号
	 * @param comArray
	 * @param idMap
	 */
	function doResetNewTargetID(comArray, idMap) {
	  var i;
	  var com;
	  var interactiveData;
	  var entry;
	  var entrys;
	  var iEntry;
	  var events;
	  var iEvent;
	  var event;
	  var iBehaviour;
	  var behaviour;
	  var iTarget;
	  var target;
	  var oldTargetID;
	  var newTargetID;
	  if (comArray) {
	    for (i = 0; i < comArray.length; i++) {
	      com = comArray[i];
	      if (com.items) {
	        doResetNewTargetID(com.items, idMap);
	      }
	
	      interactiveData = com.interactiveData;
	      if (!interactiveData) continue;
	
	      entrys = interactiveData.entry;
	      if (entrys) {
	        for (iEntry = 0; iEntry < entrys.length; iEntry++) {
	          entry = entrys[iEntry];
	          if (entry.events && entry.events.event) {
	
	            for (iEvent = 0; iEvent < entry.events.event.length; iEvent++) {
	              event = entry.events.event[iEvent];
	
	              for (iBehaviour = 0; iBehaviour < event.behaviour.length; iBehaviour++) {
	                behaviour = event.behaviour[iBehaviour];
	
	                for (iTarget = 0; iTarget < behaviour.target.length; iTarget++) {
	                  target = behaviour.target[iTarget];
	
	                  oldTargetID = target.targetID;
	                  newTargetID = idMap[oldTargetID];
	                  if (newTargetID) {
	                    target.targetID = newTargetID;
	                  }
	                } // for (iTarget = 0)
	              } // for(iBehaviour = 0)
	            } // for (iEvent = 0;)
	          }
	        } // for (iEntry = 0)
	      }
	    }
	  }
	}
	
	/**
	 * 替换组件数组中的所有组件ID号，包括交互数据中targetID
	 * @param comArray
	 */
	function resetNewComID(comArray) {
	  var idMap = {};
	  if (comArray) {
	    doResetNewComID(comArray, idMap);
	
	    // 替换组件内交互组件ID号。
	    doResetNewTargetID(comArray, idMap);
	  }
	}
	
	/**
	 * 获取母版数据
	 * @param masterID
	 * @param cb
	 * @returns {*}
	 */
	function getMaster(masterID, cb) {
	  var master;
	  // if (masterCache[masterID]) { // 优先使用 cache
	  //   return cb(null, masterCache[masterID]);
	  // }
	  if (runtimeHelper.isLoadFromZip()) {
	    try {
	      master = parseXMLToObject(zip.files['Master/' + masterID + '.mbx'].asText().trim());
	      masterCache[masterID] = master;
	      cb(null, master);
	    } catch (e) {
	      cb(e);
	    }
	  } else if (runtimeHelper.isLoadFromEnterprise()) {
	    apiHelper.loadResource('Master/' + masterID + runtimeHelper.getMBXExtension() + '?v=' + version, function (err, text) {
	      if (err) {
	        return cb(err);
	      }
	      master = parseXMLToObject(text);
	      masterCache[masterID] = master;
	      cb(null, master);
	    });
	  } else if (runtimeHelper.isLoadFromRemote() || runtimeHelper.isLoadFromMockplus()) {
	    apiHelper.loadResource('app/Master/' + masterID + runtimeHelper.getMBXExtension() + '?v=' + version, function (err, text) {
	      if (err) {
	        return cb(err);
	      }
	      master = parseXMLToObject(text);
	      masterCache[masterID] = master;
	      cb(null, master);
	    });
	  } else {
	    var node = document.getElementById(masterID);
	    if (!node) {
	      return cb(new Error('cannot find content of master:' + masterID));
	    }
	    var masterContent = node.innerHTML.trim();
	    try {
	      master = parseXMLToObject(masterContent);
	      masterCache[masterID] = master;
	      cb(null, master);
	    } catch (e) {
	      cb(e);
	    }
	  }
	}
	
	/**
	 * 替换页面中所有母版组件
	 * @param comArray 组件列表
	 * @param cb 回调函数
	 */
	function doReplacePageMasterCom(comArray, cb) {
	  var totalCount = 0;
	  var needReplace;
	  var callback;
	  var _updateChildVisible;
	
	  if (comArray.length === 0) {
	    return cb();
	  }
	
	  needReplace = _.filter(comArray, function (com) {
	    return com.controlTypeID === 'Master' && com.items;
	  });
	
	  if (needReplace.length === 0) {
	    return cb();
	  }
	
	  callback = _.after(totalCount, function () {
	    cb();
	  });
	
	  _updateChildVisible = function updateChildVisible(items, isShow) {
	    var com;
	    var i;
	    var l = 0;
	    if (items) {
	      l = items.length;
	      for (i = 0; i < l; i++) {
	        com = items[i];
	        com.isShow = isShow;
	        if (com.items) {
	          _updateChildVisible(com.items, isShow);
	        }
	      }
	    }
	  };
	
	  _.each(needReplace, function (com) {
	    if (com.controlTypeID === 'Master') {
	      com.controlTypeID = '__group__';
	      getMaster(com.masterID, function (err, masterData) {
	        if (!err) {
	          Reconstruction.reconstruction(masterData);
	
	          com.items = masterData.master.controls.control[0].items;
	          if (versionHelper.isPageVersionLowerThan4_9()) {
	            _updateChildVisible(com.items, com.isShow);
	          }
	          resetNewComID(com.items);
	        }
	        callback();
	      });
	    } else {
	      doReplacePageMasterCom(com.items, function () {
	        callback();
	      });
	    }
	  });
	}
	
	// ---------------------------------------------------------------------------------------------------------------------
	
	function doReplaceContentPanelComData(comRootArray, comSourceArray, cb, pageRefTree) {
	  var i;
	  var com;
	  var links;
	  var targetPageID;
	  var link;
	
	  if (!comSourceArray || comSourceArray.length === 0) {
	    return cb();
	  }
	
	  var afterAll = _.after(comSourceArray.length, function () {
	    cb();
	  });
	
	  function loadPageDone(err, pageData) {
	    if (err) {
	      return cb(err);
	    }
	    if (!pageData) {
	      afterAll();
	      return;
	    }
	    Reconstruction.reconstruction(pageData);
	    if (!pageData.controls.control) {
	      // 没有组件
	      return afterAll();
	    }
	    // 首先替换页面数中的所有组件ID号，防止与其他页面中组件ID号冲突
	    resetNewComID(pageData.controls.control);
	    com.items = [];
	    var tree = {};
	    for (var i = 0; i < pageRefTree.refPages.length; i++) {
	      if (pageRefTree.refPages[i].pageId === pageData.ID) {
	        tree = pageRefTree.refPages[i];
	      }
	    }
	    doMergeContentPanelComData(comRootArray, com.items, pageData.controls.control, function (err) {
	      if (err) {
	        return cb(err);
	      }
	
	      afterAll();
	    }, tree);
	  }
	
	  for (i = 0; i < comSourceArray.length; i++) {
	    com = comSourceArray[i];
	
	    links = com.links;
	    /*if (!links || !links.link) {
	      afterAll();
	      continue;
	    }*/
	
	    link = links ? links.link[0] : {};
	    if (links && link.linkType === appTypes.PageLinkType.INCLUDE_PAGE && link.isApplyIncludePage) {
	      targetPageID = link.targetPageID;
	
	      //在引用树种该页面已经被其中某个祖先节点引用，则不循环引用
	      if (!targetPageID || isRefInParent(targetPageID, pageRefTree)) {
	        afterAll();
	        continue;
	      }
	
	      //添加页面引用树
	      var refTree = { pageId: targetPageID, refPages: [], parent: pageRefTree };
	      pageRefTree.refPages.push(refTree);
	
	      loadPage(targetPageID, loadPageDone, refTree);
	    } else {
	      // 遍历子合并子节点
	      if (com.items) {
	        doReplaceContentPanelComData(comRootArray, com.items, afterAll, pageRefTree);
	      } else {
	        afterAll();
	      }
	    }
	  }
	}
	
	function isRefInParent(targetPageId, refTree) {
	  if (typeof refTree.parent === "undefined") {
	    return false;
	  } else if (targetPageId === refTree.parent.pageId) {
	    return true;
	  } else {
	    return isRefInParent(targetPageId, refTree.parent);
	  }
	}
	
	/**
	 * 合并组建内容数据资源
	 * @param comRootArray 带插入的root节点Array
	 * @param comInsertArray 当前带插入的节点的Array
	 * @param comSourceArray 组件列表数据
	 * @param pageRefTree 内容面板的页面引用树
	 */
	function doMergeContentPanelComData(comRootArray, comInsertArray, comSourceArray, cb, pageRefTree) {
	
	  var comList = [];
	  var com;
	  var i;
	
	  for (i = 0; i < comSourceArray.length; i++) {
	    com = comSourceArray[i];
	    comList.push(com);
	
	    if (pageHelper.IsInvisualInteractiveCom(com.controlTypeID)) {
	      comRootArray.push(com);
	    } else {
	      comInsertArray.push(com);
	    }
	  }
	
	  doReplaceContentPanelComData(comRootArray, comList, function (err) {
	    if (err) {
	      return console.error(err);
	    }
	    cb();
	  }, pageRefTree);
	}
	
	/**
	 * 合并生成预览数据，替换组件ID号，合并内容面板数据。
	 *
	 * @param comArray 根节点control对象
	 */
	function mergeContentPanelComData(comArray, cb, pageRefTree) {
	  var comRootArray = [];
	
	  // 第一层节点中，rootArray和InsertArray为同一个。
	  doMergeContentPanelComData(comRootArray, comRootArray, comArray, function (err) {
	    if (err) {
	      return cb(err);
	    }
	    cb(null, comRootArray);
	  }, pageRefTree);
	}
	
	// ---------------------------------------------------------------------------------------------------------------------
	
	/**
	 * 替换页面中的所有母版资源
	 * @param pageData
	 */
	function getRealPageComData(pageData, cb, pageRefTree) {
	  var controlsNode = pageData.mockup.controls;
	  if (!controlsNode.control) {
	    return cb();
	  }
	  // 重新生成组件数据对象
	  mergeContentPanelComData(controlsNode.control, function (err, comRootArray) {
	    if (err) {
	      return cb(err);
	    }
	    controlsNode.control = comRootArray;
	    // 替换页面中母版组件数据
	    doReplacePageMasterCom(controlsNode.control, function (err) {
	      if (err) {
	        return cb(err);
	      }
	      // 重新生成所有组件中组件ID号
	      resetNewComID(controlsNode.control);
	      cb();
	    });
	  }, pageRefTree);
	}
	
	function parseXMLToPage(text, id, cb, pageRefTree) {
	  var page;
	  var obj = parseXMLToObject(text);
	  Reconstruction.reconstruction(obj);
	
	  return getRealPageComData(obj, function (err) {
	    if (err) {
	      return cb(err);
	    }
	
	    page = obj.mockup;
	    page.ID = id; // 有时候页面内的 ID 不是页面的真实 ID
	
	    page.title = getPageTitleByPageID(currentProject.modules, id);
	    page = pageHelper.afterLoadPrepareDataStructure(page);
	    pagesCache[id] = JSON.parse(JSON.stringify(page)); // 保存副本
	    cb(null, page);
	  }, pageRefTree);
	}
	
	/**
	 * 加载页面数据
	 * @param id
	 * @param cb
	 * @returns {*}
	 */
	function loadPage(id, cb, pageRefTree) {
	  if (id === 'command:back') {
	    return cb(null);
	  }
	  var node;
	  var xml;
	
	  //被内容面板引用的情况下，会传入引用节点参数pageRefTree
	  //构建页面引用树，不是被内容面板引用的情况下初始化一个默认引用树
	  var refTree = { pageId: id, refPages: [] };
	  if (typeof pageRefTree !== "undefined") {
	    refTree = pageRefTree;
	  }
	  if (pagesCache[id]) {
	    return cb(null, JSON.parse(JSON.stringify(pagesCache[id]))); // 克隆一份使用
	  }
	
	  if (runtimeHelper.isLoadFromRemote() || runtimeHelper.isLoadFromMockplus()) {
	    apiHelper.loadResource('app/MBX/' + id + runtimeHelper.getMBXExtension() + '?v=' + version, function (err, text) {
	      if (err) {
	        return cb(err);
	      }
	      parseXMLToPage(text, id, cb, refTree);
	    });
	  } else if (runtimeHelper.isLoadFromEnterprise()) {
	    apiHelper.loadResource('MBX/' + id + runtimeHelper.getMBXExtension() + '?v=' + version, function (err, text) {
	      if (err) {
	        return cb(err);
	      }
	      parseXMLToPage(text, id, cb, refTree);
	    });
	  } else if (runtimeHelper.isLoadFromZip()) {
	    setTimeout(function () {
	      // 用于模拟线上异步加载的, 不要去掉
	      try {
	        xml = zip.files['MBX/' + id + '.mbx'].asText().trim();
	        parseXMLToPage(xml, id, cb, refTree);
	      } catch (e) {
	        console.error('fail to load page', id);
	        cb(e);
	      }
	    }, 100);
	  } else {
	    node = document.getElementById(id);
	    if (!node) {
	      return cb(new Error('cannot find content of page:' + id));
	    }
	    xml = node.innerHTML.trim();
	    parseXMLToPage(xml, id, cb, refTree);
	  }
	}
	
	/**
	 * 载入单个页面文件
	 * @param id
	 * @param cb
	 */
	exports.loadPage = loadPage;
	
	/**
	 * 载入图片
	 * @param name
	 * @returns {*}
	 */
	exports.loadImage = function (name) {
	  var file;
	  if (imageCache[name]) {
	    return imageCache[name];
	  }
	  if (runtimeHelper.isLoadFromZip()) {
	    try {
	      file = zip.files['0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name];
	      if (file) {
	        imageCache[name] = URL.createObjectURL(new Blob([file.asArrayBuffer()], { type: 'image/png' }));
	        return imageCache[name];
	      }
	      console.warn('image', name, 'not exists');
	    } catch (e) {
	      console.error(e);
	    }
	    return null;
	  }
	  if (runtimeHelper.isLoadFromEnterprise()) {
	    imageCache[name] = '0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
	    return '0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
	  }
	  imageCache[name] = currentPath + '/0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
	  return currentPath + '/0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
	};
	
	exports.loadSVG = function (name) {
	  var file;
	  if (!name) {
	    return;
	  }
	  if (imageCache[name]) {
	    return imageCache[name];
	  }
	  if (runtimeHelper.isLoadFromZip()) {
	    try {
	      file = zip.files['0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name];
	      if (file) {
	        imageCache[name] = URL.createObjectURL(new Blob([file.asArrayBuffer()], { type: 'image/svg+xml' }));
	        return imageCache[name];
	      }
	      console.warn('svg', name, 'not exists');
	    } catch (e) {
	      console.error(e);
	    }
	    return null;
	  }
	  if (runtimeHelper.isLoadFromEnterprise()) {
	    imageCache[name] = '0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
	    return '0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
	  }
	  imageCache[name] = currentPath + '/0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
	  return currentPath + '/0EDCD3EB-42DB-412B-9411-E5DD751EB4BA/' + name;
	};
	
	/**
	 * 根据页面ID号获取页面标题
	 * @param modules 所有页面Module数据信息
	 * @param ID 页面ID号
	 * @returns 返回页面标题
	 */
	function getPageTitleByPageID(modules, ID) {
	  var i;
	  var node;
	
	  for (i = 0; i < modules._pages.length; i++) {
	    node = modules._pages[i];
	    if (node.ID === ID) {
	      return node.name;
	    }
	
	    if (node._pages && node._pages.length) {
	      var pageTitle = getPageTitleByPageID(node, ID);
	      if (pageTitle !== undefined) {
	        return pageTitle;
	      }
	    }
	  }
	}
	
	if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    position = position || 0;
	    return this.substr(position, searchString.length) === searchString;
	  };
	}
	
	function getGoToPage() {
	  var search = window.location.search;
	  var searches = search.split(/[?@]/g);
	  for (var i = 0; i < searches.length; i++) {
	    var item = searches[i];
	    if (item.startsWith('to=')) {
	      return item.substring(3);
	    }
	  }
	  return '';
	}
	
	function doGetAppFirstPage(module) {
	  var i;
	  var _page;
	  var l;
	  var rsPage;
	
	  if (!module._pages) {
	    return;
	  }
	  for (i = 0, l = module._pages.length; i < l; i++) {
	    _page = module._pages[i];
	    if (!_page.isModule) {
	      return _page;
	    } else {
	      rsPage = doGetAppFirstPage(_page);
	      if (rsPage) {
	        return rsPage;
	      }
	    }
	  }
	}
	
	/**
	 * 获取项目第一个页面数据对象
	 * @param modules
	 */
	function getAppFirstPage(modules) {
	  return doGetAppFirstPage(modules);
	}
	
	/**
	 * 获取第一个加载的页面ID
	 * @returns {*}
	 */
	exports.getAppFirstPage = function () {
	  var goToPage = urlHelper.getQueryString('to');
	  if (goToPage) {
	    return goToPage;
	  }
	  firstPageCache = firstPageCache || getAppFirstPage(currentProject.modules);
	  return firstPageCache && firstPageCache.ID;
	};
	
	/**
	 * 将 XML 文本转换为对象
	 * @type {parseXMLToObject}
	 */
	exports.parseXMLToObject = parseXMLToObject;
	
	function parseXMLToApp(text, cb) {
	  var obj = parseXMLToObject(text);
	  if (obj && obj.html && obj.html.body && obj.html.body.parsererror && obj.html.body.parsererror.div) {
	    return cb(new Error(obj.html.body.parsererror.div));
	  }
	  if (obj.project.parsererror) {
	    return cb(new Error(obj.project.parsererror.div));
	  }
	  if (obj.project.pages) {
	    obj.project.modules = obj.project.pages;
	  }
	  normalizeAppDataAndCache(obj);
	  cb(null, obj.project);
	}
	
	/**
	 * 载入项目文件
	 * @param path 项目文件路径
	 * @param cb
	 */
	exports.loadApp = function (path, cb) {
	  var html;
	  // 加载项目时清理 cache
	  masterCache = {};
	  pagesCache = {};
	  firstPageCache = null;
	
	  if (runtimeHelper.isLoadFromZip()) {
	    JSZipUtils.getBinaryContent(path + '?v=' + Math.random(), function (err, data) {
	      if (err) {
	        cb(err);
	        return;
	      }
	      zip = new JSZip(data);
	      html = zip.files['Main.mpk'].asText().trim();
	      parseXMLToApp(html, cb);
	    });
	  } else if (runtimeHelper.isLoadFromEnterprise()) {
	    apiHelper.loadResource('Main' + runtimeHelper.getMPKExtension() + '?v=' + version, function (err, text, statusCode) {
	      if (err) {
	        console.error(err);
	        cb(err, null, statusCode);
	        return;
	      }
	      parseXMLToApp(text, cb);
	    });
	  } else if (runtimeHelper.isLoadFromRemote() || runtimeHelper.isLoadFromMockplus()) {
	    apiHelper.loadResource('app/Main' + runtimeHelper.getMPKExtension() + '?v=' + version, function (err, text, statusCode) {
	      if (err) {
	        console.error(err);
	        cb(err, null, statusCode);
	        return;
	      }
	      parseXMLToApp(text, cb);
	    });
	  } else {
	    var node = document.getElementById('main');
	    if (!node) {
	      return cb(new Error('cannot find content of app'));
	    }
	    html = node.innerHTML.trim();
	    parseXMLToApp(html, cb);
	  }
	};
	
	/**
	 * 处理 app 数据
	 */
	function normalizeAppDataAndCache(obj) {
	  currentProject = obj.project; // cache current project;
	  countChildPages(obj.project.modules);
	  obj.project.modules.isModule = true;
	  obj.project.modules.childCount = countANode(obj.project.modules);
	}
	
	function countANode(node) {
	  if (node.childCount) {
	    return node.childCount;
	  }
	  if (node._pages) {
	    var childCount = _.reduce(node._pages, function (memo, item) {
	      return memo + countANode(item);
	    }, 0);
	    return node.isModule ? childCount : childCount + 1;
	  }
	  return node.isModule ? 0 : 1;
	}
	
	function countChildPages(node) {
	  _.each(node._pages, function (item) {
	    item.childCount = countANode(item);
	    countChildPages(item);
	  });
	}
	
	exports.auth = function (pwd, cb) {
	  request.post('/auth').send("id=" + getAppID()).send("password=" + pwd).end(function (err, res) {
	    cb(err, res);
	  });
	};
	
	function getAppID() {
	  var re = /\/([^\/]+)\/index.html/i;
	  var match = re.exec(window.location.href);
	  if (match) {
	    return match[1];
	  }
	  return '';
	}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64 = __webpack_require__(70);
	
	/**
	Usage:
	   zip = new JSZip();
	   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
	   zip.folder("images").file("smile.gif", base64Data, {base64: true});
	   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
	   zip.remove("tempfile");
	
	   base64zip = zip.generate();
	
	**/
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
	 * @param {Object=} options the options for creating this objects (optional).
	 */
	function JSZip(data, options) {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZip)) return new JSZip(data, options);
	
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    this.files = {};
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    if (data) {
	        this.load(data, options);
	    }
	    this.clone = function() {
	        var newObj = new JSZip();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZip.prototype = __webpack_require__(71);
	JSZip.prototype.load = __webpack_require__(104);
	JSZip.support = __webpack_require__(72);
	JSZip.defaults = __webpack_require__(99);
	
	/**
	 * @deprecated
	 * This namespace will be removed in a future version without replacement.
	 */
	JSZip.utils = __webpack_require__(112);
	
	JSZip.base64 = {
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    encode : function(input) {
	        return base64.encode(input);
	    },
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    decode : function(input) {
	        return base64.decode(input);
	    }
	};
	JSZip.compressions = __webpack_require__(78);
	module.exports = JSZip;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	'use strict';
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    while (i < input.length) {
	
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        }
	        else if (isNaN(chr3)) {
	            enc4 = 64;
	        }
	
	        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
	
	    }
	
	    return output;
	};
	
	// public method for decoding
	exports.decode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output = output + String.fromCharCode(chr1);
	
	        if (enc3 != 64) {
	            output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	            output = output + String.fromCharCode(chr3);
	        }
	
	    }
	
	    return output;
	
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var support = __webpack_require__(72);
	var utils = __webpack_require__(77);
	var crc32 = __webpack_require__(97);
	var signature = __webpack_require__(98);
	var defaults = __webpack_require__(99);
	var base64 = __webpack_require__(70);
	var compressions = __webpack_require__(78);
	var CompressedObject = __webpack_require__(100);
	var nodeBuffer = __webpack_require__(96);
	var utf8 = __webpack_require__(101);
	var StringWriter = __webpack_require__(102);
	var Uint8ArrayWriter = __webpack_require__(103);
	
	/**
	 * Returns the raw data of a ZipObject, decompress the content if necessary.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getRawData = function(file) {
	    if (file._data instanceof CompressedObject) {
	        file._data = file._data.getContent();
	        file.options.binary = true;
	        file.options.base64 = false;
	
	        if (utils.getTypeOf(file._data) === "uint8array") {
	            var copy = file._data;
	            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
	            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
	            file._data = new Uint8Array(copy.length);
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            if (copy.length !== 0) {
	                file._data.set(copy, 0);
	            }
	        }
	    }
	    return file._data;
	};
	
	/**
	 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getBinaryData = function(file) {
	    var result = getRawData(file),
	        type = utils.getTypeOf(result);
	    if (type === "string") {
	        if (!file.options.binary) {
	            // unicode text !
	            // unicode string => binary string is a painful process, check if we can avoid it.
	            if (support.nodebuffer) {
	                return nodeBuffer(result, "utf-8");
	            }
	        }
	        return file.asBinary();
	    }
	    return result;
	};
	
	/**
	 * Transform this._data into a string.
	 * @param {function} filter a function String -> String, applied if not null on the result.
	 * @return {String} the string representing this._data.
	 */
	var dataToString = function(asUTF8) {
	    var result = getRawData(this);
	    if (result === null || typeof result === "undefined") {
	        return "";
	    }
	    // if the data is a base64 string, we decode it before checking the encoding !
	    if (this.options.base64) {
	        result = base64.decode(result);
	    }
	    if (asUTF8 && this.options.binary) {
	        // JSZip.prototype.utf8decode supports arrays as input
	        // skip to array => string step, utf8decode will do it.
	        result = out.utf8decode(result);
	    }
	    else {
	        // no utf8 transformation, do the array => string step.
	        result = utils.transformTo("string", result);
	    }
	
	    if (!asUTF8 && !this.options.binary) {
	        result = utils.transformTo("string", out.utf8encode(result));
	    }
	    return result;
	};
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	    this.unixPermissions = options.unixPermissions;
	    this.dosPermissions = options.dosPermissions;
	
	    this._data = data;
	    this.options = options;
	
	    /*
	     * This object contains initial values for dir and date.
	     * With them, we can check if the user changed the deprecated metadata in
	     * `ZipObject#options` or not.
	     */
	    this._initialMetadata = {
	      dir : options.dir,
	      date : options.date
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Return the content as UTF8 string.
	     * @return {string} the UTF8 string.
	     */
	    asText: function() {
	        return dataToString.call(this, true);
	    },
	    /**
	     * Returns the binary content.
	     * @return {string} the content as binary.
	     */
	    asBinary: function() {
	        return dataToString.call(this, false);
	    },
	    /**
	     * Returns the content as a nodejs Buffer.
	     * @return {Buffer} the content as a Buffer.
	     */
	    asNodeBuffer: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("nodebuffer", result);
	    },
	    /**
	     * Returns the content as an Uint8Array.
	     * @return {Uint8Array} the content as an Uint8Array.
	     */
	    asUint8Array: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("uint8array", result);
	    },
	    /**
	     * Returns the content as an ArrayBuffer.
	     * @return {ArrayBuffer} the content as an ArrayBufer.
	     */
	    asArrayBuffer: function() {
	        return this.asUint8Array().buffer;
	    }
	};
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "",
	        i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Transforms the (incomplete) options from the user into the complete
	 * set of options to create a file.
	 * @private
	 * @param {Object} o the options from the user.
	 * @return {Object} the complete set of options.
	 */
	var prepareFileAttrs = function(o) {
	    o = o || {};
	    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
	        o.binary = true;
	    }
	    o = utils.extend(o, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) o.compression = o.compression.toUpperCase();
	
	    return o;
	};
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} o the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, o) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	    o = prepareFileAttrs(o);
	
	    if (typeof o.unixPermissions === "string") {
	        o.unixPermissions = parseInt(o.unixPermissions, 8);
	    }
	
	    // UNX_IFDIR  0040000 see zipinfo.c
	    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
	        o.dir = true;
	    }
	    // Bit 4    Directory
	    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
	        o.dir = true;
	    }
	
	    if (o.dir) {
	        name = forceTrailingSlash(name);
	    }
	
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    if (o.dir || data === null || typeof data === "undefined") {
	        o.base64 = false;
	        o.binary = false;
	        data = null;
	        dataType = null;
	    }
	    else if (dataType === "string") {
	        if (o.binary && !o.base64) {
	            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
	            if (o.optimizedBinaryString !== true) {
	                // this is a string, not in a base64 format.
	                // Be sure that this is a correct "binary string"
	                data = utils.string2binary(data);
	            }
	        }
	    }
	    else { // arraybuffer, uint8array, ...
	        o.base64 = false;
	        o.binary = true;
	
	        if (!dataType && !(data instanceof CompressedObject)) {
	            throw new Error("The data of '" + name + "' is in an unsupported format !");
	        }
	
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = utils.transformTo("uint8array", data);
	        }
	    }
	
	    var object = new ZipObject(name, data, o);
	    this.files[name] = object;
	    return object;
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) == '/') {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf('/');
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	
	/**
	 * Returns the path with a slash at the end.
	 * @private
	 * @param {String} path the path to check.
	 * @return {String} the path with a trailing slash.
	 */
	var forceTrailingSlash = function(path) {
	    // Check the name ends with a /
	    if (path.slice(-1) != "/") {
	        path += "/"; // IE doesn't like substr(-1)
	    }
	    return path;
	};
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;
	
	    name = forceTrailingSlash(name);
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	 * Generate a JSZip.CompressedObject for a given zipOject.
	 * @param {ZipObject} file the object to read.
	 * @param {JSZip.compression} compression the compression to use.
	 * @param {Object} compressionOptions the options to use when compressing.
	 * @return {JSZip.CompressedObject} the compressed result.
	 */
	var generateCompressedObjectFrom = function(file, compression, compressionOptions) {
	    var result = new CompressedObject(),
	        content;
	
	    // the data has not been decompressed, we might reuse things !
	    if (file._data instanceof CompressedObject) {
	        result.uncompressedSize = file._data.uncompressedSize;
	        result.crc32 = file._data.crc32;
	
	        if (result.uncompressedSize === 0 || file.dir) {
	            compression = compressions['STORE'];
	            result.compressedContent = "";
	            result.crc32 = 0;
	        }
	        else if (file._data.compressionMethod === compression.magic) {
	            result.compressedContent = file._data.getCompressedContent();
	        }
	        else {
	            content = file._data.getContent();
	            // need to decompress / recompress
	            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content), compressionOptions);
	        }
	    }
	    else {
	        // have uncompressed data
	        content = getBinaryData(file);
	        if (!content || content.length === 0 || file.dir) {
	            compression = compressions['STORE'];
	            content = "";
	        }
	        result.uncompressedSize = content.length;
	        result.crc32 = crc32(content);
	        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content), compressionOptions);
	    }
	
	    result.compressedSize = result.compressedContent.length;
	    result.compressionMethod = compression.magic;
	
	    return result;
	};
	
	
	
	
	/**
	 * Generate the UNIX part of the external file attributes.
	 * @param {Object} unixPermissions the unix permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
	 *
	 * TTTTsstrwxrwxrwx0000000000ADVSHR
	 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
	 *     ^^^_________________________ setuid, setgid, sticky
	 *        ^^^^^^^^^________________ permissions
	 *                 ^^^^^^^^^^______ not used ?
	 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
	 */
	var generateUnixExternalFileAttr = function (unixPermissions, isDir) {
	
	    var result = unixPermissions;
	    if (!unixPermissions) {
	        // I can't use octal values in strict mode, hence the hexa.
	        //  040775 => 0x41fd
	        // 0100664 => 0x81b4
	        result = isDir ? 0x41fd : 0x81b4;
	    }
	
	    return (result & 0xFFFF) << 16;
	};
	
	/**
	 * Generate the DOS part of the external file attributes.
	 * @param {Object} dosPermissions the dos permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * Bit 0     Read-Only
	 * Bit 1     Hidden
	 * Bit 2     System
	 * Bit 3     Volume Label
	 * Bit 4     Directory
	 * Bit 5     Archive
	 */
	var generateDosExternalFileAttr = function (dosPermissions, isDir) {
	
	    // the dir flag is already set for compatibility
	
	    return (dosPermissions || 0)  & 0x3F;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {string} name the file name.
	 * @param {ZipObject} file the file content.
	 * @param {JSZip.CompressedObject} compressedObject the compressed object.
	 * @param {number} offset the current offset from the start of the zip file.
	 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
	 * @param {Function} encodeFileName the function to encode the file name / comment.
	 * @return {object} the zip parts.
	 */
	var generateZipParts = function(name, file, compressedObject, offset, platform, encodeFileName) {
	    var data = compressedObject.compressedContent,
	        useCustomEncoding = encodeFileName !== utf8.utf8encode,
	        encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
	        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	        comment = file.comment || "",
	        encodedComment = utils.transformTo("string", encodeFileName(comment)),
	        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	        useUTF8ForComment = utfEncodedComment.length !== comment.length,
	        o = file.options,
	        dosTime,
	        dosDate,
	        extraFields = "",
	        unicodePathExtraField = "",
	        unicodeCommentExtraField = "",
	        dir, date;
	
	
	    // handle the deprecated options.dir
	    if (file._initialMetadata.dir !== file.dir) {
	        dir = file.dir;
	    } else {
	        dir = o.dir;
	    }
	
	    // handle the deprecated options.date
	    if(file._initialMetadata.date !== file.date) {
	        date = file.date;
	    } else {
	        date = o.date;
	    }
	
	    var extFileAttr = 0;
	    var versionMadeBy = 0;
	    if (dir) {
	        // dos or unix, we set the dos dir flag
	        extFileAttr |= 0x00010;
	    }
	    if(platform === "UNIX") {
	        versionMadeBy = 0x031E; // UNIX, version 3.0
	        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
	    } else { // DOS or other, fallback to DOS
	        versionMadeBy = 0x0014; // DOS, version 2.0
	        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
	    }
	
	    // date
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html
	
	    dosTime = date.getHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getSeconds() / 2;
	
	    dosDate = date.getFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(encodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(this.crc32(encodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    // set bit 11 if utf8
	    header += !useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
	    // compression method
	    header += compressedObject.compressionMethod;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(compressedObject.crc32, 4);
	    // compressed size
	    header += decToHex(compressedObject.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(compressedObject.uncompressedSize, 4);
	    // file name length
	    header += decToHex(encodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	    // version made by (00: DOS)
	    decToHex(versionMadeBy, 2) +
	    // file header (common to file and central directory)
	    header +
	    // file comment length
	    decToHex(encodedComment.length, 2) +
	    // disk number start
	    "\x00\x00" +
	    // internal file attributes TODO
	    "\x00\x00" +
	    // external file attributes
	    decToHex(extFileAttr, 4) +
	    // relative offset of local header
	    decToHex(offset, 4) +
	    // file name
	    encodedFileName +
	    // extra field
	    extraFields +
	    // file comment
	    encodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord,
	        compressedObject: compressedObject
	    };
	};
	
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * Read an existing zip and merge the data in the current JSZip object.
	     * The implementation is in jszip-load.js, don't forget to include it.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
	     * @param {Object} options Options for loading the stream.
	     *  options.base64 : is the stream in base64 ? default : false
	     * @return {JSZip} the current JSZip object
	     */
	    load: function(stream, options) {
	        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [],
	            filename, relativePath, file, fileClone;
	        for (filename in this.files) {
	            if (!this.files.hasOwnProperty(filename)) {
	                continue;
	            }
	            file = this.files[filename];
	            // return a new object, don't let the user mess with our internal objects :)
	            fileClone = new ZipObject(file.name, file._data, utils.extend(file.options));
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
	            search(relativePath, fileClone)) { // and the file matches the function
	                result.push(fileClone);
	            }
	        }
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (utils.isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && relativePath === name;
	                })[0] || null;
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (utils.isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) != "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Generate the complete zip file
	     * @param {Object} options the options to generate the zip file :
	     * - base64, (deprecated, use type instead) true to generate base64.
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
	     */
	    generate: function(options) {
	        options = utils.extend(options || {}, {
	            base64: true,
	            compression: "STORE",
	            compressionOptions : null,
	            type: "base64",
	            platform: "DOS",
	            comment: null,
	            mimeType: 'application/zip',
	            encodeFileName: utf8.utf8encode
	        });
	
	        utils.checkSupport(options.type);
	
	        // accept nodejs `process.platform`
	        if(
	          options.platform === 'darwin' ||
	          options.platform === 'freebsd' ||
	          options.platform === 'linux' ||
	          options.platform === 'sunos'
	        ) {
	          options.platform = "UNIX";
	        }
	        if (options.platform === 'win32') {
	          options.platform = "DOS";
	        }
	
	        var zipData = [],
	            localDirLength = 0,
	            centralDirLength = 0,
	            writer, i,
	            encodedComment = utils.transformTo("string", options.encodeFileName(options.comment || this.comment || ""));
	
	        // first, generate all the zip parts.
	        for (var name in this.files) {
	            if (!this.files.hasOwnProperty(name)) {
	                continue;
	            }
	            var file = this.files[name];
	
	            var compressionName = file.options.compression || options.compression.toUpperCase();
	            var compression = compressions[compressionName];
	            if (!compression) {
	                throw new Error(compressionName + " is not a valid compression method !");
	            }
	            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
	
	            var compressedObject = generateCompressedObjectFrom.call(this, file, compression, compressionOptions);
	
	            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength, options.platform, options.encodeFileName);
	            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
	            centralDirLength += zipPart.dirRecord.length;
	            zipData.push(zipPart);
	        }
	
	        var dirEnd = "";
	
	        // end of central dir signature
	        dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(zipData.length, 2) +
	        // total number of entries in the central directory
	        decToHex(zipData.length, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(encodedComment.length, 2) +
	        // .ZIP file comment
	        encodedComment;
	
	
	        // we have all the parts (and the total length)
	        // time to create a writer !
	        var typeName = options.type.toLowerCase();
	        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
	            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
	        }else{
	            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
	        }
	
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].fileRecord);
	            writer.append(zipData[i].compressedObject.compressedContent);
	        }
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].dirRecord);
	        }
	
	        writer.append(dirEnd);
	
	        var zip = writer.finalize();
	
	
	
	        switch(options.type.toLowerCase()) {
	            // case "zip is an Uint8Array"
	            case "uint8array" :
	            case "arraybuffer" :
	            case "nodebuffer" :
	               return utils.transformTo(options.type.toLowerCase(), zip);
	            case "blob" :
	               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip), options.mimeType);
	            // case "zip is a string"
	            case "base64" :
	               return (options.base64) ? base64.encode(zip) : zip;
	            default : // case "string" :
	               return zip;
	         }
	
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    crc32: function (input, crc) {
	        return crc32(input, crc);
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8encode: function (string) {
	        return utils.transformTo("string", utf8.utf8encode(string));
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8decode: function (input) {
	        return utf8.utf8decode(input);
	    }
	};
	module.exports = out;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
	// Browserify will provide a Buffer implementation for browsers, which is
	// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob('application/zip').size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73).Buffer))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(74)
	var ieee754 = __webpack_require__(75)
	var isArray = __webpack_require__(76)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var support = __webpack_require__(72);
	var compressions = __webpack_require__(78);
	var nodeBuffer = __webpack_require__(96);
	/**
	 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
	 * @param {string} str the string to transform.
	 * @return {String} the binary string.
	 */
	exports.string2binary = function(str) {
	    var result = "";
	    for (var i = 0; i < str.length; i++) {
	        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
	    }
	    return result;
	};
	exports.arrayBuffer2Blob = function(buffer, mimeType) {
	    exports.checkSupport("blob");
		mimeType = mimeType || 'application/zip';
	
	    try {
	        // Blob constructor
	        return new Blob([buffer], {
	            type: mimeType
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            return builder.getBlob(mimeType);
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    var chunk = 65536;
	    var result = [],
	        len = array.length,
	        type = exports.getTypeOf(array),
	        k = 0,
	        canUseApply = true;
	      try {
	         switch(type) {
	            case "uint8array":
	               String.fromCharCode.apply(null, new Uint8Array(0));
	               break;
	            case "nodebuffer":
	               String.fromCharCode.apply(null, nodeBuffer(0));
	               break;
	         }
	      } catch(e) {
	         canUseApply = false;
	      }
	
	      // no apply : slow and painful algorithm
	      // default browser on android 4.*
	      if (!canUseApply) {
	         var resultStr = "";
	         for(var i = 0; i < array.length;i++) {
	            resultStr += String.fromCharCode(array[i]);
	         }
	    return resultStr;
	    }
	    while (k < len && chunk > 1) {
	        try {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        catch (e) {
	            chunk = Math.floor(chunk / 2);
	        }
	    }
	    return result.join("");
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodeBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodeBuffer.test(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this browser");
	    }
	};
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = '',
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	exports.findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!compressions.hasOwnProperty(method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	exports.isRegExp = function (object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	exports.extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	exports.STORE = {
	    magic: "\x00\x00",
	    compress: function(content, compressionOptions) {
	        return content; // no compression
	    },
	    uncompress: function(content) {
	        return content; // no compression
	    },
	    compressInputType: null,
	    uncompressInputType: null
	};
	exports.DEFLATE = __webpack_require__(79);


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');
	
	var pako = __webpack_require__(80);
	exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	exports.compress = function(input, compressionOptions) {
	    return pako.deflateRaw(input, {
	        level : compressionOptions.level || -1 // default compression
	    });
	};
	exports.uncompress =  function(input) {
	    return pako.inflateRaw(input);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = __webpack_require__(81).assign;
	
	var deflate   = __webpack_require__(82);
	var inflate   = __webpack_require__(90);
	var constants = __webpack_require__(94);
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	function _has(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (_has(source, p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_deflate = __webpack_require__(83);
	var utils        = __webpack_require__(81);
	var strings      = __webpack_require__(88);
	var msg          = __webpack_require__(87);
	var ZStream      = __webpack_require__(89);
	
	var toString = Object.prototype.toString;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_SYNC_FLUSH    = 2;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overridden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
	 * push a chunk with explicit flush (call [[Deflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	function Deflate(options) {
	  if (!(this instanceof Deflate)) return new Deflate(options);
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	
	  if (opt.dictionary) {
	    var dict;
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      // If we need to compress text, change encoding to utf8.
	      dict = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      dict = new Uint8Array(opt.dictionary);
	    } else {
	      dict = opt.dictionary;
	    }
	
	    status = zlib_deflate.deflateSetDictionary(this.strm, dict);
	
	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }
	
	    this._dict_set = true;
	  }
	}
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
	 *   converted to utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the compression context.
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === Z_SYNC_FLUSH) {
	    this.onEnd(Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate algorithm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 * - dictionary
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils   = __webpack_require__(81);
	var trees   = __webpack_require__(84);
	var adler32 = __webpack_require__(85);
	var crc32   = __webpack_require__(86);
	var msg     = __webpack_require__(87);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils = __webpack_require__(81);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It isn't worth it to make additional optimizations as in original.
	// Small size is preferable.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// String encode/decode helpers
	'use strict';
	
	
	var utils = __webpack_require__(81);
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safari
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var q = 0; q < 256; q++) {
	  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	}
	_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // use fallback for big arrays to avoid stack overflow
	  if (len < 65537) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for (var i = 0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function (buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function (str) {
	  var buf = new utils.Buf8(str.length);
	  for (var i = 0, len = buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len * 2);
	
	  for (out = 0, i = 0; i < len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function (buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max - 1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means buffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_inflate = __webpack_require__(91);
	var utils        = __webpack_require__(81);
	var strings      = __webpack_require__(88);
	var c            = __webpack_require__(94);
	var msg          = __webpack_require__(87);
	var ZStream      = __webpack_require__(89);
	var GZheader     = __webpack_require__(95);
	
	var toString = Object.prototype.toString;
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overridden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
	 * push a chunk with explicit flush (call [[Inflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	function Inflate(options) {
	  if (!(this instanceof Inflate)) return new Inflate(options);
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new GZheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	}
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var dictionary = this.options.dictionary;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	  var dict;
	
	  // Flag to properly process Z_BUF_ERROR on testing inflate call
	  // when we check that all output data was flushed.
	  var allowBufError = false;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status === c.Z_NEED_DICT && dictionary) {
	      // Convert data if needed
	      if (typeof dictionary === 'string') {
	        dict = strings.string2buf(dictionary);
	      } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
	        dict = new Uint8Array(dictionary);
	      } else {
	        dict = dictionary;
	      }
	
	      status = zlib_inflate.inflateSetDictionary(this.strm, dict);
	
	    }
	
	    if (status === c.Z_BUF_ERROR && allowBufError === true) {
	      status = c.Z_OK;
	      allowBufError = false;
	    }
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	
	    // When no more input data, we should check that internal inflate buffers
	    // are flushed. The only way to do it when avail_out = 0 - run one more
	    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
	    // Here we set flag to process this error properly.
	    //
	    // NOTE. Deflate does not return error in this case and does not needs such
	    // logic.
	    if (strm.avail_in === 0 && strm.avail_out === 0) {
	      allowBufError = true;
	    }
	
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === c.Z_SYNC_FLUSH) {
	    this.onEnd(c.Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called either after you tell inflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 aligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils         = __webpack_require__(81);
	var adler32       = __webpack_require__(85);
	var crc32         = __webpack_require__(86);
	var inflate_fast  = __webpack_require__(92);
	var inflate_table = __webpack_require__(93);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	      case HEAD:
	        if (state.wrap === 0) {
	          state.mode = TYPEDO;
	          break;
	        }
	        //=== NEEDBITS(16);
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = FLAGS;
	          break;
	        }
	        state.flags = 0;           /* expect zlib header */
	        if (state.head) {
	          state.head.done = false;
	        }
	        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	          strm.msg = 'incorrect header check';
	          state.mode = BAD;
	          break;
	        }
	        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	        len = (hold & 0x0f)/*BITS(4)*/ + 8;
	        if (state.wbits === 0) {
	          state.wbits = len;
	        }
	        else if (len > state.wbits) {
	          strm.msg = 'invalid window size';
	          state.mode = BAD;
	          break;
	        }
	        state.dmax = 1 << len;
	        //Tracev((stderr, "inflate:   zlib header ok\n"));
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = hold & 0x200 ? DICTID : TYPE;
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        break;
	      case FLAGS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.flags = hold;
	        if ((state.flags & 0xff) !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        if (state.flags & 0xe000) {
	          strm.msg = 'unknown header flags set';
	          state.mode = BAD;
	          break;
	        }
	        if (state.head) {
	          state.head.text = ((hold >> 8) & 1);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = TIME;
	        /* falls through */
	      case TIME:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.time = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC4(state.check, hold)
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          hbuf[2] = (hold >>> 16) & 0xff;
	          hbuf[3] = (hold >>> 24) & 0xff;
	          state.check = crc32(state.check, hbuf, 4, 0);
	          //===
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = OS;
	        /* falls through */
	      case OS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.xflags = (hold & 0xff);
	          state.head.os = (hold >> 8);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = EXLEN;
	        /* falls through */
	      case EXLEN:
	        if (state.flags & 0x0400) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length = hold;
	          if (state.head) {
	            state.head.extra_len = hold;
	          }
	          if (state.flags & 0x0200) {
	            //=== CRC2(state.check, hold);
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            state.check = crc32(state.check, hbuf, 2, 0);
	            //===//
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        else if (state.head) {
	          state.head.extra = null/*Z_NULL*/;
	        }
	        state.mode = EXTRA;
	        /* falls through */
	      case EXTRA:
	        if (state.flags & 0x0400) {
	          copy = state.length;
	          if (copy > have) { copy = have; }
	          if (copy) {
	            if (state.head) {
	              len = state.head.extra_len - state.length;
	              if (!state.head.extra) {
	                // Use untyped array for more convenient processing later
	                state.head.extra = new Array(state.head.extra_len);
	              }
	              utils.arraySet(
	                state.head.extra,
	                input,
	                next,
	                // extra field is limited to 65536 bytes
	                // - no need for additional size check
	                copy,
	                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	                len
	              );
	              //zmemcpy(state.head.extra + len, next,
	              //        len + copy > state.head.extra_max ?
	              //        state.head.extra_max - len : copy);
	            }
	            if (state.flags & 0x0200) {
	              state.check = crc32(state.check, input, copy, next);
	            }
	            have -= copy;
	            next += copy;
	            state.length -= copy;
	          }
	          if (state.length) { break inf_leave; }
	        }
	        state.length = 0;
	        state.mode = NAME;
	        /* falls through */
	      case NAME:
	        if (state.flags & 0x0800) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            // TODO: 2 or 1 bytes?
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.name_max*/)) {
	              state.head.name += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.name = null;
	        }
	        state.length = 0;
	        state.mode = COMMENT;
	        /* falls through */
	      case COMMENT:
	        if (state.flags & 0x1000) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.comm_max*/)) {
	              state.head.comment += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.comment = null;
	        }
	        state.mode = HCRC;
	        /* falls through */
	      case HCRC:
	        if (state.flags & 0x0200) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.check & 0xffff)) {
	            strm.msg = 'header crc mismatch';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        if (state.head) {
	          state.head.hcrc = ((state.flags >> 9) & 1);
	          state.head.done = true;
	        }
	        strm.adler = state.check = 0;
	        state.mode = TYPE;
	        break;
	      case DICTID:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        strm.adler = state.check = zswap32(hold);
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = DICT;
	        /* falls through */
	      case DICT:
	        if (state.havedict === 0) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          return Z_NEED_DICT;
	        }
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = TYPE;
	        /* falls through */
	      case TYPE:
	        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case TYPEDO:
	        if (state.last) {
	          //--- BYTEBITS() ---//
	          hold >>>= bits & 7;
	          bits -= bits & 7;
	          //---//
	          state.mode = CHECK;
	          break;
	        }
	        //=== NEEDBITS(3); */
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.last = (hold & 0x01)/*BITS(1)*/;
	        //--- DROPBITS(1) ---//
	        hold >>>= 1;
	        bits -= 1;
	        //---//
	
	        switch ((hold & 0x03)/*BITS(2)*/) {
	          case 0:                             /* stored block */
	            //Tracev((stderr, "inflate:     stored block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = STORED;
	            break;
	          case 1:                             /* fixed block */
	            fixedtables(state);
	            //Tracev((stderr, "inflate:     fixed codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = LEN_;             /* decode codes */
	            if (flush === Z_TREES) {
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	              break inf_leave;
	            }
	            break;
	          case 2:                             /* dynamic block */
	            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = TABLE;
	            break;
	          case 3:
	            strm.msg = 'invalid block type';
	            state.mode = BAD;
	        }
	        //--- DROPBITS(2) ---//
	        hold >>>= 2;
	        bits -= 2;
	        //---//
	        break;
	      case STORED:
	        //--- BYTEBITS() ---// /* go to byte boundary */
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	          strm.msg = 'invalid stored block lengths';
	          state.mode = BAD;
	          break;
	        }
	        state.length = hold & 0xffff;
	        //Tracev((stderr, "inflate:       stored length %u\n",
	        //        state.length));
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = COPY_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case COPY_:
	        state.mode = COPY;
	        /* falls through */
	      case COPY:
	        copy = state.length;
	        if (copy) {
	          if (copy > have) { copy = have; }
	          if (copy > left) { copy = left; }
	          if (copy === 0) { break inf_leave; }
	          //--- zmemcpy(put, next, copy); ---
	          utils.arraySet(output, input, next, copy, put);
	          //---//
	          have -= copy;
	          next += copy;
	          left -= copy;
	          put += copy;
	          state.length -= copy;
	          break;
	        }
	        //Tracev((stderr, "inflate:       stored end\n"));
	        state.mode = TYPE;
	        break;
	      case TABLE:
	        //=== NEEDBITS(14); */
	        while (bits < 14) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	        if (state.nlen > 286 || state.ndist > 30) {
	          strm.msg = 'too many length or distance symbols';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracev((stderr, "inflate:       table sizes ok\n"));
	        state.have = 0;
	        state.mode = LENLENS;
	        /* falls through */
	      case LENLENS:
	        while (state.have < state.ncode) {
	          //=== NEEDBITS(3);
	          while (bits < 3) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	          //--- DROPBITS(3) ---//
	          hold >>>= 3;
	          bits -= 3;
	          //---//
	        }
	        while (state.have < 19) {
	          state.lens[order[state.have++]] = 0;
	        }
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        //state.next = state.codes;
	        //state.lencode = state.next;
	        // Switch to use dynamic table
	        state.lencode = state.lendyn;
	        state.lenbits = 7;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	        state.lenbits = opts.bits;
	
	        if (ret) {
	          strm.msg = 'invalid code lengths set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, "inflate:       code lengths ok\n"));
	        state.have = 0;
	        state.mode = CODELENS;
	        /* falls through */
	      case CODELENS:
	        while (state.have < state.nlen + state.ndist) {
	          for (;;) {
	            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          if (here_val < 16) {
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            state.lens[state.have++] = here_val;
	          }
	          else {
	            if (here_val === 16) {
	              //=== NEEDBITS(here.bits + 2);
	              n = here_bits + 2;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              if (state.have === 0) {
	                strm.msg = 'invalid bit length repeat';
	                state.mode = BAD;
	                break;
	              }
	              len = state.lens[state.have - 1];
	              copy = 3 + (hold & 0x03);//BITS(2);
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	            }
	            else if (here_val === 17) {
	              //=== NEEDBITS(here.bits + 3);
	              n = here_bits + 3;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 3 + (hold & 0x07);//BITS(3);
	              //--- DROPBITS(3) ---//
	              hold >>>= 3;
	              bits -= 3;
	              //---//
	            }
	            else {
	              //=== NEEDBITS(here.bits + 7);
	              n = here_bits + 7;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 11 + (hold & 0x7f);//BITS(7);
	              //--- DROPBITS(7) ---//
	              hold >>>= 7;
	              bits -= 7;
	              //---//
	            }
	            if (state.have + copy > state.nlen + state.ndist) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            while (copy--) {
	              state.lens[state.have++] = len;
	            }
	          }
	        }
	
	        /* handle error breaks in while */
	        if (state.mode === BAD) { break; }
	
	        /* check for end-of-block code (better have one) */
	        if (state.lens[256] === 0) {
	          strm.msg = 'invalid code -- missing end-of-block';
	          state.mode = BAD;
	          break;
	        }
	
	        /* build code tables -- note: do not change the lenbits or distbits
	           values here (9 and 6) without reading the comments in inftrees.h
	           concerning the ENOUGH constants, which depend on those values */
	        state.lenbits = 9;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.lenbits = opts.bits;
	        // state.lencode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid literal/lengths set';
	          state.mode = BAD;
	          break;
	        }
	
	        state.distbits = 6;
	        //state.distcode.copy(state.codes);
	        // Switch to use dynamic table
	        state.distcode = state.distdyn;
	        opts = { bits: state.distbits };
	        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.distbits = opts.bits;
	        // state.distcode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid distances set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, 'inflate:       codes ok\n'));
	        state.mode = LEN_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case LEN_:
	        state.mode = LEN;
	        /* falls through */
	      case LEN:
	        if (have >= 6 && left >= 258) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          inflate_fast(strm, _out);
	          //--- LOAD() ---
	          put = strm.next_out;
	          output = strm.output;
	          left = strm.avail_out;
	          next = strm.next_in;
	          input = strm.input;
	          have = strm.avail_in;
	          hold = state.hold;
	          bits = state.bits;
	          //---
	
	          if (state.mode === TYPE) {
	            state.back = -1;
	          }
	          break;
	        }
	        state.back = 0;
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if (here_bits <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_op && (here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.lencode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        state.length = here_val;
	        if (here_op === 0) {
	          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	          //        "inflate:         literal '%c'\n" :
	          //        "inflate:         literal 0x%02x\n", here.val));
	          state.mode = LIT;
	          break;
	        }
	        if (here_op & 32) {
	          //Tracevv((stderr, "inflate:         end of block\n"));
	          state.back = -1;
	          state.mode = TYPE;
	          break;
	        }
	        if (here_op & 64) {
	          strm.msg = 'invalid literal/length code';
	          state.mode = BAD;
	          break;
	        }
	        state.extra = here_op & 15;
	        state.mode = LENEXT;
	        /* falls through */
	      case LENEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", state.length));
	        state.was = state.length;
	        state.mode = DIST;
	        /* falls through */
	      case DIST:
	        for (;;) {
	          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if ((here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.distcode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        if (here_op & 64) {
	          strm.msg = 'invalid distance code';
	          state.mode = BAD;
	          break;
	        }
	        state.offset = here_val;
	        state.extra = (here_op) & 15;
	        state.mode = DISTEXT;
	        /* falls through */
	      case DISTEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	//#ifdef INFLATE_STRICT
	        if (state.offset > state.dmax) {
	          strm.msg = 'invalid distance too far back';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	        state.mode = MATCH;
	        /* falls through */
	      case MATCH:
	        if (left === 0) { break inf_leave; }
	        copy = _out - left;
	        if (state.offset > copy) {         /* copy from window */
	          copy = state.offset - copy;
	          if (copy > state.whave) {
	            if (state.sane) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break;
	            }
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	          }
	          if (copy > state.wnext) {
	            copy -= state.wnext;
	            from = state.wsize - copy;
	          }
	          else {
	            from = state.wnext - copy;
	          }
	          if (copy > state.length) { copy = state.length; }
	          from_source = state.window;
	        }
	        else {                              /* copy from output */
	          from_source = output;
	          from = put - state.offset;
	          copy = state.length;
	        }
	        if (copy > left) { copy = left; }
	        left -= copy;
	        state.length -= copy;
	        do {
	          output[put++] = from_source[from++];
	        } while (--copy);
	        if (state.length === 0) { state.mode = LEN; }
	        break;
	      case LIT:
	        if (left === 0) { break inf_leave; }
	        output[put++] = state.length;
	        left--;
	        state.mode = LEN;
	        break;
	      case CHECK:
	        if (state.wrap) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            // Use '|' instead of '+' to make sure that result is signed
	            hold |= input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          _out -= left;
	          strm.total_out += _out;
	          state.total += _out;
	          if (_out) {
	            strm.adler = state.check =
	                /*UPDATE(state.check, put - _out, _out);*/
	                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	          }
	          _out = left;
	          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	            strm.msg = 'incorrect data check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   check matches trailer\n"));
	        }
	        state.mode = LENGTH;
	        /* falls through */
	      case LENGTH:
	        if (state.wrap && state.flags) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.total & 0xffffffff)) {
	            strm.msg = 'incorrect length check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   length matches trailer\n"));
	        }
	        state.mode = DONE;
	        /* falls through */
	      case DONE:
	        ret = Z_STREAM_END;
	        break inf_leave;
	      case BAD:
	        ret = Z_DATA_ERROR;
	        break inf_leave;
	      case MEM:
	        return Z_MEM_ERROR;
	      case SYNC:
	        /* falls through */
	      default:
	        return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils = __webpack_require__(81);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  /* process all codes and make table entries */
	  for (;;) {
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	module.exports = function(data, encoding){
	    return new Buffer(data, encoding);
	};
	module.exports.test = function(b){
	    return Buffer.isBuffer(b);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73).Buffer))

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	
	var table = [
	    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
	    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
	    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
	    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
	    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
	    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
	    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
	    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
	    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
	    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
	    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
	    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
	    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
	    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
	    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
	    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
	    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
	    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
	    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
	    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
	    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
	    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
	    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
	    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
	    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
	    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
	    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
	    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
	    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
	    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
	    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
	    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
	    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
	    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
	    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
	    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
	    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
	    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
	    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
	    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
	    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
	    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
	    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
	    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
	    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
	    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
	    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
	    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
	    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
	    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
	    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
	    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
	];
	
	/**
	 *
	 *  Javascript crc32
	 *  http://www.webtoolkit.info/
	 *
	 */
	module.exports = function crc32(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if (typeof(crc) == "undefined") {
	        crc = 0;
	    }
	    var x = 0;
	    var y = 0;
	    var b = 0;
	
	    crc = crc ^ (-1);
	    for (var i = 0, iTop = input.length; i < iTop; i++) {
	        b = isArray ? input[i] : input.charCodeAt(i);
	        y = (crc ^ b) & 0xFF;
	        x = table[y];
	        crc = (crc >>> 8) ^ x;
	    }
	
	    return crc ^ (-1);
	};
	// vim: set shiftwidth=4 softtabstop=4:


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ }),
/* 99 */
/***/ (function(module, exports) {

	'use strict';
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = false;
	exports.date = null;
	exports.compression = null;
	exports.compressionOptions = null;
	exports.comment = null;
	exports.unixPermissions = null;
	exports.dosPermissions = null;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	'use strict';
	function CompressedObject() {
	    this.compressedSize = 0;
	    this.uncompressedSize = 0;
	    this.crc32 = 0;
	    this.compressionMethod = null;
	    this.compressedContent = null;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Return the decompressed content in an unspecified format.
	     * The format will depend on the decompressor.
	     * @return {Object} the decompressed content.
	     */
	    getContent: function() {
	        return null; // see implementation
	    },
	    /**
	     * Return the compressed content in an unspecified format.
	     * The format will depend on the compressed conten source.
	     * @return {Object} the compressed content.
	     */
	    getCompressedContent: function() {
	        return null; // see implementation
	    }
	};
	module.exports = CompressedObject;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	var support = __webpack_require__(72);
	var nodeBuffer = __webpack_require__(96);
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var str, i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodeBuffer(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    // return buf2string(buf);
	    // Chrome prefers to work with "small" chunks of data
	    // for the method buf2string.
	    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
	    var result = [], k = 0, len = buf.length, chunk = 65536;
	    while (k < len) {
	        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
	        if (support.uint8array) {
	            result.push(buf2string(buf.subarray(k, nextBoundary)));
	        } else {
	            result.push(buf2string(buf.slice(k, nextBoundary)));
	        }
	        k = nextBoundary;
	    }
	    return result.join("");
	
	};
	// vim: set shiftwidth=4 softtabstop=4:


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	
	/**
	 * An object to write any content to a string.
	 * @constructor
	 */
	var StringWriter = function() {
	    this.data = [];
	};
	StringWriter.prototype = {
	    /**
	     * Append any content to the current string.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        input = utils.transformTo("string", input);
	        this.data.push(input);
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {string} the generated string.
	     */
	    finalize: function() {
	        return this.data.join("");
	    }
	};
	
	module.exports = StringWriter;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	
	/**
	 * An object to write any content to an Uint8Array.
	 * @constructor
	 * @param {number} length The length of the array.
	 */
	var Uint8ArrayWriter = function(length) {
	    this.data = new Uint8Array(length);
	    this.index = 0;
	};
	Uint8ArrayWriter.prototype = {
	    /**
	     * Append any content to the current array.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        if (input.length !== 0) {
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            input = utils.transformTo("uint8array", input);
	            this.data.set(input, this.index);
	            this.index += input.length;
	        }
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {Uint8Array} the generated array.
	     */
	    finalize: function() {
	        return this.data;
	    }
	};
	
	module.exports = Uint8ArrayWriter;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var base64 = __webpack_require__(70);
	var utf8 = __webpack_require__(101);
	var utils = __webpack_require__(77);
	var ZipEntries = __webpack_require__(105);
	module.exports = function(data, options) {
	    var files, zipEntries, i, input;
	    options = utils.extend(options || {}, {
	        base64: false,
	        checkCRC32: false,
	        optimizedBinaryString : false,
	        createFolders: false,
	        decodeFileName: utf8.utf8decode
	    });
	    if (options.base64) {
	        data = base64.decode(data);
	    }
	
	    zipEntries = new ZipEntries(data, options);
	    files = zipEntries.files;
	    for (i = 0; i < files.length; i++) {
	        input = files[i];
	        this.file(input.fileNameStr, input.decompressed, {
	            binary: true,
	            optimizedBinaryString: true,
	            date: input.date,
	            dir: input.dir,
	            comment : input.fileCommentStr.length ? input.fileCommentStr : null,
	            unixPermissions : input.unixPermissions,
	            dosPermissions : input.dosPermissions,
	            createFolders: options.createFolders
	        });
	    }
	    if (zipEntries.zipComment.length) {
	        this.comment = zipEntries.zipComment;
	    }
	
	    return this;
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var StringReader = __webpack_require__(106);
	var NodeBufferReader = __webpack_require__(108);
	var Uint8ArrayReader = __webpack_require__(109);
	var ArrayReader = __webpack_require__(110);
	var utils = __webpack_require__(77);
	var sig = __webpack_require__(98);
	var ZipEntry = __webpack_require__(111);
	var support = __webpack_require__(72);
	var jszipProto = __webpack_require__(71);
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(data, loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	    if (data) {
	        this.load(data);
	    }
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the speficied signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        var signature = this.reader.readString(4);
	        if (signature !== expectedSignature) {
	            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Check if the given signature is at the given index.
	     * @param {number} askedIndex the index to check.
	     * @param {string} expectedSignature the signature to expect.
	     * @return {boolean} true if the signature is here, false otherwise.
	     */
	    isSignature: function(askedIndex, expectedSignature) {
	        var currentIndex = this.reader.index;
	        this.reader.setIndex(askedIndex);
	        var signature = this.reader.readString(4);
	        var result = signature === expectedSignature;
	        this.reader.setIndex(currentIndex);
	        return result;
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        var zipComment = this.reader.readData(this.zipCommentLength);
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded unless specified otherwise.
	        var decodeContent = utils.transformTo(decodeParamType, zipComment);
	        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.versionMadeBy = this.reader.readString(2);
	        this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readString(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	            file.processAttributes();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	
	        if (this.centralDirRecords !== this.files.length) {
	            if (this.centralDirRecords !== 0 && this.files.length === 0) {
	                // We expected some records but couldn't find ANY.
	                // This is really suspicious, as if something went wrong.
	                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
	            } else {
	                // We found some records but not all.
	                // Something is wrong but we got something for the user: no error here.
	                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
	            }
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset < 0) {
	            // Check if the content is a truncated zip or complete garbage.
	            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
	            // extractible zip for example) but it can give a good hint.
	            // If an ajax request was used without responseType, we will also
	            // get unreadable data.
	            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);
	
	            if (isGarbage) {
	                throw new Error("Can't find end of central directory : is this a zip file ? " +
	                                "If it is, see http://stuk.github.io/jszip/documentation/howto/read_zip.html");
	            } else {
	                throw new Error("Corrupted zip : can't find end of central directory");
	            }
	        }
	        this.reader.setIndex(offset);
	        var endOfCentralDirOffset = offset;
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset < 0) {
	                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
	                // console.warn("ZIP64 end of central directory not where expected.");
	                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
	                    throw new Error("Corrupted zip : can't find the ZIP64 end of central directory");
	                }
	            }
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	
	        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
	        if (this.zip64) {
	            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
	            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
	        }
	
	        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;
	
	        if (extraBytes > 0) {
	            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
	            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
	                // The offsets seem wrong, but we have something at the specified offset.
	                // So… we keep it.
	            } else {
	                // the offset is wrong, update the "zero" of the reader
	                // this happens if data has been prepended (crx files for example)
	                this.reader.zero = extraBytes;
	            }
	        } else if (extraBytes < 0) {
	            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
	        }
	    },
	    prepareReader: function(data) {
	        var type = utils.getTypeOf(data);
	        utils.checkSupport(type);
	        if (type === "string" && !support.uint8array) {
	            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
	        }
	        else if (type === "nodebuffer") {
	            this.reader = new NodeBufferReader(data);
	        }
	        else if (support.uint8array) {
	            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
	        } else if (support.array) {
	            this.reader = new ArrayReader(utils.transformTo("array", data));
	        } else {
	            throw new Error("Unexpected error: unsupported type '" + type + "'");
	        }
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(107);
	var utils = __webpack_require__(77);
	
	function StringReader(data, optimizedBinaryString) {
	    this.data = data;
	    if (!optimizedBinaryString) {
	        this.data = utils.string2binary(this.data);
	    }
	    this.length = this.data.length;
	    this.index = 0;
	    this.zero = 0;
	}
	StringReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(this.zero + i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig) - this.zero;
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(77);
	
	function DataReader(data) {
	    this.data = null; // type : see implementation
	    this.length = 0;
	    this.index = 0;
	    this.zero = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specifed index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < this.zero + newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function(i) {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function(size) {
	        // see implementations
	    },
	    /**
	     * Find the last occurence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurence, -1 if not found.
	     */
	    lastIndexOfSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(
	        ((dostime >> 25) & 0x7f) + 1980, // year
	        ((dostime >> 21) & 0x0f) - 1, // month
	        (dostime >> 16) & 0x1f, // day
	        (dostime >> 11) & 0x1f, // hour
	        (dostime >> 5) & 0x3f, // minute
	        (dostime & 0x1f) << 1); // second
	    }
	};
	module.exports = DataReader;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Uint8ArrayReader = __webpack_require__(109);
	
	function NodeBufferReader(data) {
	    this.data = data;
	    this.length = this.data.length;
	    this.index = 0;
	    this.zero = 0;
	}
	NodeBufferReader.prototype = new Uint8ArrayReader();
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayReader = __webpack_require__(110);
	
	function Uint8ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	        this.zero = 0;
	    }
	}
	Uint8ArrayReader.prototype = new ArrayReader();
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(107);
	
	function ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	        this.zero = 0;
	
	        for(var i = 0; i < this.data.length; i++) {
	            data[i] = data[i] & 0xFF;
	        }
	    }
	}
	ArrayReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	ArrayReader.prototype.byteAt = function(i) {
	    return this.data[this.zero + i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i - this.zero;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readData
	 */
	ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        return [];
	    }
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = ArrayReader;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var StringReader = __webpack_require__(106);
	var utils = __webpack_require__(77);
	var CompressedObject = __webpack_require__(100);
	var jszipProto = __webpack_require__(71);
	var support = __webpack_require__(72);
	
	var MADE_BY_DOS = 0x00;
	var MADE_BY_UNIX = 0x03;
	
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Prepare the function used to generate the compressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
	     */
	    prepareCompressedContent: function(reader, from, length) {
	        return function() {
	            var previousIndex = reader.index;
	            reader.setIndex(from);
	            var compressedFileData = reader.readData(length);
	            reader.setIndex(previousIndex);
	
	            return compressedFileData;
	        };
	    },
	    /**
	     * Prepare the function used to generate the uncompressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @param {JSZip.compression} compression the compression used on this file.
	     * @param {number} uncompressedSize the uncompressed size to expect.
	     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
	     */
	    prepareContent: function(reader, from, length, compression, uncompressedSize) {
	        return function() {
	
	            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
	            var uncompressedFileData = compression.uncompress(compressedFileData);
	
	            if (uncompressedFileData.length !== uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	
	            return uncompressedFileData;
	        };
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        this.fileName = reader.readData(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
	        }
	
	        compression = utils.findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " +  utils.transformTo("string", this.fileName) + ")");
	        }
	        this.decompressed = new CompressedObject();
	        this.decompressed.compressedSize = this.compressedSize;
	        this.decompressed.uncompressedSize = this.uncompressedSize;
	        this.decompressed.crc32 = this.crc32;
	        this.decompressed.compressionMethod = this.compressionMethod;
	        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
	        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);
	
	        // we need to compute the crc32...
	        if (this.loadOptions.checkCRC32) {
	            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
	            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
	                throw new Error("Corrupted zip : CRC32 mismatch");
	            }
	        }
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readInt(2);
	        this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        this.fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        this.fileName = reader.readData(this.fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readData(this.fileCommentLength);
	    },
	
	    /**
	     * Parse the external file attributes and get the unix/dos permissions.
	     */
	    processAttributes: function () {
	        this.unixPermissions = null;
	        this.dosPermissions = null;
	        var madeBy = this.versionMadeBy >> 8;
	
	        // Check if we have the DOS directory flag set.
	        // We look for it in the DOS and UNIX permissions
	        // but some unknown platform could set it as a compatibility flag.
	        this.dir = this.externalFileAttributes & 0x0010 ? true : false;
	
	        if(madeBy === MADE_BY_DOS) {
	            // first 6 bits (0 to 5)
	            this.dosPermissions = this.externalFileAttributes & 0x3F;
	        }
	
	        if(madeBy === MADE_BY_UNIX) {
	            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
	            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
	        }
	
	        // fail safe : if the name ends with a / it probably means a folder
	        if (!this.dir && this.fileNameStr.slice(-1) === '/') {
	            this.dir = true;
	        }
	    },
	
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function(reader) {
	
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = new StringReader(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var start = reader.index,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        this.extraFields = this.extraFields || {};
	
	        while (reader.index < start + this.extraFieldsLength) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readString(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        if (this.useUTF8()) {
	            this.fileNameStr = jszipProto.utf8decode(this.fileName);
	            this.fileCommentStr = jszipProto.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileNameStr = upath;
	            } else {
	                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
	                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
	            }
	
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileCommentStr = ucomment;
	            } else {
	                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
	                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = new StringReader(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = new StringReader(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(77);
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2binary = function(str) {
	    return utils.string2binary(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Uint8Array = function(str) {
	    return utils.transformTo("uint8array", str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.uint8Array2String = function(array) {
	    return utils.transformTo("string", array);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Blob = function(str) {
	    var buffer = utils.transformTo("arraybuffer", str);
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.arrayBuffer2Blob = function(buffer) {
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.transformTo = function(outputType, input) {
	    return utils.transformTo(outputType, input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.getTypeOf = function(input) {
	    return utils.getTypeOf(input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.checkSupport = function(type) {
	    return utils.checkSupport(type);
	};
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;
	
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.pretty = function(str) {
	    return utils.pretty(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.findCompression = function(compressionMethod) {
	    return utils.findCompression(compressionMethod);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.isRegExp = function (object) {
	    return utils.isRegExp(object);
	};
	


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var style = 'wireframe';
	var colorHelper = __webpack_require__(114);
	var appTypes = __webpack_require__(115);
	var utils = __webpack_require__(116);
	
	function convertTextStyle(v) {
	  var t = { fontWeight: 'normal', fontStyle: 'normal', textDecoration: 'none' };
	  //[fsBold,fsItalic,fsUnderline,fsStrikeOut]
	  if (typeof v === 'string') {
	    if (v.indexOf('fsBold') !== -1) {
	      t.fontWeight = 'bold';
	    }
	    if (v.indexOf('fsItalic') !== -1) {
	      t.fontStyle = 'italic';
	    }
	    if (v.indexOf('fsUnderline') !== -1 && v.indexOf('fsStrikeOut') !== -1) {
	      t.textDecoration = 'underline line-through';
	    } else {
	      if (v.indexOf('fsUnderline') !== -1) {
	        t.textDecoration = 'underline';
	      }
	      if (v.indexOf('fsStrikeOut') !== -1) {
	        t.textDecoration = 'line-through';
	      }
	    }
	  }
	  return t;
	}
	
	var noCoverColorPropName = ['isAutoTextColor', 'IsAutoTextColor', 'avatarColorStyle'];
	
	exports.convertValue = function (k, v) {
	  if (k === 'dashMode') {
	    return appTypes.DashMode[v] || 'solid';
	  }
	  if (k === 'text' || k === 'textFontFamily' || k === 'caption' || k === 'remarkText' || k === 'placeHolder') {
	    try {
	      return _decodeURIComponent(v.replace(/\+/g, '%20'));
	    } catch (e) {
	      console.error(e);
	      return "";
	    }
	  }
	
	  if (k.toLowerCase().indexOf('color') !== -1 && noCoverColorPropName.indexOf(k) === -1) {
	    return utils.Color.toHTMLColor(v);
	  }
	
	  if (k === 'textStyles') {
	    return convertTextStyle(v);
	  }
	
	  if (v === 'true' || v === 'True') {
	    return true;
	  }
	  if (v === 'false' || v === 'False') {
	    return false;
	  }
	  if (k === 'selectedIndex' || k === 'gap' || k === 'thickness' || k === 'itemHeight') {
	    return parseInt(v, 10);
	  }
	  return v;
	};
	
	exports.getAsset = function (name) {
	  return '/src/assets/components/' + style + '/' + name + '.png';
	};
	
	exports.isLightColor = function (color) {
	  var rgb = colorHelper.getRGBA(color);
	  return rgb.R * 0.299 + rgb.G * 0.578 + rgb.B * 0.114 > 128;
	
	  //Result := GetR(C) * 0.299 + GetG(C) * 0.587 + GetB(C) * 0.114 > 128;
	};
	
	function _decodeURI(txt) {
	  try {
	    return decodeURI(txt);
	  } catch (e) {
	    console.error(new Error("decodeURI " + txt + " error:" + e.message));
	  }
	  return txt;
	}
	
	exports.decodeURI = _decodeURI;
	
	function _decodeURIComponent(txt) {
	  try {
	    return decodeURIComponent(txt);
	  } catch (e) {
	    console.error(new Error("decodeURIComponent " + txt + " error:" + e.message));
	  }
	  return txt;
	}
	
	exports.decodeURIComponent = _decodeURIComponent;
	
	exports.isHttpURL = function () {
	  var search = 'http';
	  return window.location.href.substr(0, search.length) === search;
	};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	'use strict';
	
	function isLight(color) {
	  var c = color.substring(1);
	  var rgb = parseInt(c, 16);
	  var r = rgb >> 16 & 0xff;
	  var g = rgb >> 8 & 0xff;
	  var b = rgb >> 0 & 0xff;
	  return r * 0.299 + g * 0.587 + b * 0.114 > 128;
	}
	
	exports.isLight = isLight;
	
	exports.getTopBarBackgroundColor = function (color) {
	  if (isLight(color)) {
	    return 'rgba(0, 0, 0, 0.2)';
	  }
	  return 'rgba(255, 255, 255, 0.2)';
	};
	
	/**
	 * 获取颜色的RGBA值
	 * @author mengxiaojiang
	 * @createDate 2016-7-4
	 * @param color {String('#XXX'|'#XXXXXX'|'rgba(r,g,b,a))}
	 * @returns {{R: number, G: number, B: number, A : number}}
	 */
	exports.getRGBA = function (color) {
	  var r = 0;
	  var g = 0;
	  var b = 0;
	  var a = 1;
	  var c;
	  var l;
	  if (color) {
	    if (color.indexOf('rgba') != -1) {
	      c = color.replace('rgba', '').replace('(', '').replace(')', '');
	      c = c.split(',');
	      r = parseInt(c[0].trim(), 10);
	      g = parseInt(c[1].trim(), 10);
	      b = parseInt(c[2].trim(), 10);
	      a = parseInt(c[3].trim(), 10);
	    } else if (color.indexOf('#') != -1) {
	      c = color.replace('#', '').split('');
	      l = c.length;
	      if (l <= 3) {
	        b = c.pop();
	        b = parseInt(b + b, 16);
	        l = c.length;
	        if (l) {
	          g = c.pop();
	          g = parseInt(g + g, 16);
	        }
	        l = c.length;
	        if (l) {
	          r = c.pop();
	          r = parseInt(r + r, 16);
	        }
	      } else {
	        b = c.pop();
	        if (c.length) {
	          b = c.pop() + b;
	        }
	        b = parseInt(b, 16);
	        if (c.length) {
	          g = c.pop();
	        }
	        if (c.length) {
	          g = c.pop() + g;
	        }
	        if (g) {
	          g = parseInt(g, 16);
	        }
	        if (c.length) {
	          r = c.pop();
	        }
	        if (c.length) {
	          r = c.pop() + r;
	        }
	        if (r) {
	          r = parseInt(r, 16);
	        }
	      }
	    }
	  }
	  return {
	    R: r,
	    G: g,
	    B: b,
	    A: a
	  };
	};

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	/**
	 * Created by Marsh on 2016.5.11.
	 */
	
	'use strict';
	
	module.exports = {
	
	  /**
	   * 常用的几种颜色值
	   */
	  Color: {
	    // 禁用时颜色值
	    MODEL_DISABLE: '#CCCCCC',
	
	    // 黑色颜色值
	    MODEL_BLACK: '#000'
	  },
	
	  /**
	   * 程序项目类型
	   */
	  AppPlatformType: {
	    MOBILE: 'MtMobile',
	    PAD: 'MtPad',
	    DESKTOP: 'MtDesktop',
	    WEB: 'MtWeb',
	    BLANK: 'MtBlank',
	    CUSTOM: 'MtCustom'
	  },
	
	  /**
	   * 手机和Pad项目类型中，app屏幕方向
	   */
	  ScreenOrientation: {
	    PORTRAIT: 'MoPortrait',
	    LANDSCAPE: 'MoLandscape'
	  },
	
	  DashMode: {
	    SdSolid: 'solid',
	    SdDash: 'dashed',
	    SdDot: 'dotted',
	    SdDashDot: 'dash-dot',
	    SdDashDotDot: 'dash-dot-dot'
	  },
	  /**
	   * 页面链接类型
	   */
	  PageLinkType: {
	    PAGE_LINK: 'ltPageLink',
	    INCLUDE_PAGE: 'ltIncludePage'
	  },
	
	  /**
	   * 页面链接动画
	   */
	  PageLinkAnimateType: {
	    NONE: 'AmNone',
	    PUSH_LEFT: 'AmPushLeft',
	    PUSH_RIGHT: 'AmPushRight',
	    PUSH_UP: 'AmPushUp',
	    PUSH_DOWN: 'AmPushDown',
	    SLIDE_LEFT: 'AmSlideLeft',
	    SLIDE_RIGHT: 'AmSlideRight',
	    SLIDE_UP: 'AmSlideUp',
	    SLIDE_DOWN: 'AmSlideDown',
	    FADE: 'AmFade',
	    IRIS: 'AmIris'
	  },
	
	  /**
	   * 提示框组件Yes和No枚举， 对应：TMockYesAndNo
	   */
	  AlertYesAndNo: {
	    NONE: 'MBNone',
	    YES: 'MBYes',
	    NO: 'MBNo',
	    index: { 0: 'NONE', 1: 'YES', 2: 'NO' }
	  },
	
	  /**
	   * 内部布局方向， 对应：TInternalLayout
	   */
	  InternalLayout: {
	    VERTICAL: 'vertical',
	    HORIZONTAL: 'horizontal'
	  },
	
	  /**
	   * 文字布局方向， 对应：TMockTextDirection
	   */
	  TextDirection: {
	    LEFT: 'tdLeft',
	    RIGHT: 'tdRight'
	  },
	
	  HorizontalDirection: {
	    LEFT: 'HdLeft',
	    RIGHT: 'HdRight'
	  },
	
	  VerticalDirection: {
	    TOP: 'VdTop',
	    BOTTOM: 'VdBottom'
	  },
	
	  Direction: {
	    HORIZONTAL: 'SmHori',
	    VERTICAL: 'SmVert'
	  },
	
	  ButtonStatus: {
	    NORMAL: 'BsNormal',
	    SELECTED: 'BsSelected',
	    FOCUSED: 'BsFocused'
	  },
	  /**
	   * 组件状态，对应：TMockComStatus
	   */
	  ComStatus: {
	    ENABLE: 'MfEnabled',
	    SELECTED: 'MfSelected',
	    DISABLED: 'MfDisabled',
	    SELECTED_AND_DISABLED: 'MfSelectedAndDisabled',
	    isSelected: function isSelected(state) {
	      return state === this.SELECTED || state === this.SELECTED_AND_DISABLED;
	    },
	    isDisabled: function isDisabled(state) {
	      return state === this.DISABLED || state === this.SELECTED_AND_DISABLED;
	    }
	  },
	
	  /**
	   * 组件状态，对应TMockComStatus1
	   */
	  ComStatus1: {
	    ENABLE: 'CsEnabled',
	    FOCUS: 'CsInFocus',
	    DISABLED: 'CsDisabled'
	  },
	
	  /**
	   * 组件状态，对应：TMockComStatus2
	   */
	  ComStatus2: {
	    ENABLE: 'MsEnabled',
	    DISABLE: 'MsDisabled'
	  },
	
	  /**
	   * 形状组件类型， 对应：TShapeType
	   */
	  ShapeType: {
	    ELLIPSE: 'SbEllipse',
	    RECTANGLE: 'SbRectangle',
	    DIAMOND: 'SbDiamond',
	    STAR: 'SbStar',
	    PARALLELOGRAM: 'SbParallelogram',
	    TRIANGLE: 'SbTriangle'
	  },
	
	  /**
	   * 组件旋转角度类型， 对应：TRotationAngle
	   */
	  RotationAngle: {
	    ZERO: 'TdZero',
	    NINETY: 'TdNinety',
	    ONE_HUNDRED_EIGHTY: 'TdOneHundredEighty',
	    TWO_HUNDRED_SEVENTY: 'TdTwoHundredSeventy'
	  },
	
	  /**
	   * 交互事件中所支持的交互类型，没有对应枚举类
	   */
	  StateEventType: {
	    MOUSE_OVER: 'state_mouseOver',
	    MOUSE_OUT: 'state_mouseOut',
	    MOUSE_DOWN: 'state_mouseDown',
	    MOUSE_UP: 'state_mouseUp'
	  },
	
	  /**
	   * 字体居中属性，对应：THoriAlign
	   */
	  HoriAlign: {
	    LEFT: 'HaLeft',
	    CENTER: 'HaCenter',
	    RIGHT: 'HaRight'
	  },
	
	  /**
	   * 字体垂直属性，对应： TVertAlign
	   */
	  VertAlign: {
	    TOP: 'VaTop',
	    MIDDLE: 'VaMiddle',
	    BOTTOM: 'VaBottom'
	  },
	
	  /**
	   * 图片滤镜属性，对应： TImageFilter
	   */
	  ImageFilter: {
	    NONE: 'MfNone',
	    PENCIL: 'MfPencil',
	    SKETCH: 'MfSketch',
	    MONO: 'MfMono'
	  },
	
	  ImageFitMode: {
	    //字符加数字的方式做数据精简后的兼容
	    Fit: 'fmFit-0',
	    Fill: 'fmFill-1',
	    STRETCH: 'fmStretch-2',
	    TILE: 'fmTile-3',
	    CENTER: 'fmCenter-4'
	  },
	  /**
	   * 弹出面板定位策略
	   */
	  PositionPolicy: {
	    FREE: 'ppFree',
	    SCREEN: 'ppScreenFix',
	    SOURCE_COM: 'ppSourceCom'
	  },
	
	  /**
	   * 弹出面板相对于屏幕定位的方式
	   */
	  PositionScreenMode: {
	    TOP: 'psTop',
	    CENTER: 'psCenter',
	    BOTTOM: 'psBottom'
	  },
	
	  /**
	   * 弹出面板相对于源组件的定位方式
	   */
	  PositionComMode: {
	    TOP: 'pcTop',
	    BOTTOM: 'pcBottom',
	    LEFT: 'pcLeft',
	    RIGHT: 'pcRight',
	    //后面几种临时扩充的。目前PC端还没有
	    TOP_LEFT: 'pcTopLeft',
	    TOP_RIGHT: 'pcTopRight',
	    BOTTOM_LEFT: 'pcBottomLeft',
	    BOTTOM_RIGHT: 'pcBottomRight'
	  },
	
	  PopupPanelClosePolicy: {
	    NONE: 'cmNone',
	    ALL: 'cmClickAllArea',
	    OUT_AREA: 'cmClickOutSizeArea'
	  },
	
	  /*移动项目中弹出面板弹出动画*/
	  PopupPanelAniType_Mobile: {
	    NONE: 'aniNone',
	    FADE: 'aniFade',
	    ZOOM_IN: 'aniZoomIn',
	    MOVE_UP: 'aniMoveUp',
	    MOVE_DOWN: 'aniMoveDown',
	    MOVE_LEFT: 'aniMoveLeft',
	    MOVE_RIGHT: 'aniMoveRight',
	    EXPAND_DOWN: 'aniExpandDown',
	    EXPAND_RIGHT: 'aniExpandRight',
	    EXPAND_LEFT: 'aniExpandLeft',
	    EXPAND_UP: 'aniExpandUp'
	  },
	
	  /*弹出面板弹出动画*/
	  PopupPanelAniType: {
	    NONE: 'dnNone',
	    FADE: 'dnFade',
	    ZOOM_IN: 'dnZoomIn'
	  },
	
	  /**
	   * 切换面板切换动画类型
	   */
	  StackPanelAniType: {
	    NONE: 'spaNone',
	    PUSH: 'spaPush',
	    SLIDE: 'spaSlide',
	    FADE: 'spaFade'
	  },
	
	  CarouselIndicatorType: {
	    RECTANGLE: 'SiRectangle',
	    CIRCLE: 'SiCircle',
	    NUMBER: 'SiNumber'
	  },
	  CarouselIndicatorDirection: {
	    TOP: 'sidTop',
	    LEFT: 'sidLeft',
	    BOTTOM: 'sidBottom',
	    RIGHT: 'sidRight'
	  },
	
	  /**
	   * 图片轮播中图片的填充方式
	   */
	  ImageCarouselFitMode: {
	    AUTO: 'fmAutoFit',
	    STRETCH: 'fmStretchFit'
	  },
	
	  PhoneType: {
	    ALLWHITE: 'PtAllWhite',
	    TOPONLY: 'PtTopOnly',
	    TOPANDBOTTOM: 'PtTopAndBottom',
	    ALLBLACK: 'PtAllBlack'
	  },
	
	  /**
	   * 进度条组件样式，对应：TMockProgressStyle
	   */
	  ProgressBarStyle: {
	    BAR: 'MfBar',
	    STRIPE: 'MfStripe'
	  },
	
	  /**
	   * 提示角度方向， 对应：TAroundDirection
	   */
	  ToolTipDirection: {
	    LEFT_TOP: 'AdLeftTop',
	    TOP: 'AdTop',
	    RIGHT_TOP: 'AdRightTop',
	    RIGHT: 'AdRight',
	    RIGHT_BOTTOM: 'AdRightBottom',
	    BOTTOM: 'AdBottom',
	    LEFT_BOTTOM: 'AdLeftBottom',
	    LEFT: 'AdLeft'
	  },
	
	  /**
	   * 垂直花括号方向
	   */
	  VCurlyDirection: {
	    LEFT: 'DrLeft',
	    RIGHT: 'DrRight'
	  },
	
	  /**
	   * 水平花括号方向
	   */
	  HCurlyDirection: {
	    TOP: 'DrTop',
	    BOTTOM: 'DrBottom'
	  },
	
	  /**
	   * 图标按钮风格，
	   */
	  IconButtonStyle: {
	    CIRCLE: 'ISCircle',
	    RECTANGLE: 'ISRectangle',
	    ROUND_RECTANGLE: 'ISRoundRectangle'
	  },
	
	  /**
	   * 图标按钮方向
	   */
	  IconLabelDirection: {
	    TEXT_BOTTOM: 'MiTextBottom',
	    TEXT_LEFT: 'MiTextLeft',
	    TEXT_RIGHT: 'MiTextRight'
	  },
	
	  /**
	   * 用户行为发生后，需要响应的交互类型
	   */
	  ActionResponseType: {
	    LINK: 'page-link',
	    INTERACTIVE: 'interactive-link',
	    OUTER: 'url-link',
	    STATE: 'state-link',
	    NONE: 'none'
	  },
	
	  CUSTOM_EVENT: {
	    ON_RESIZE: 'onResize',
	    ON_PAINT: 'onPaint',
	    ON_PROPS_CHANGE: 'onPropsChange'
	  },
	
	  TAB_BAR_STYLE: {
	    SQUARE: 'csSquare',
	    LEAN: 'csLean'
	  },
	  AVATAR_SHAPE_STYLE: {
	    RECTANGLE: 'asRect',
	    CIRCLE: 'asCircle'
	  },
	
	  AVATAR_COLOR_STYLE: {
	    NORMAL: 'asNormal',
	    BLACK: 'asBlack',
	    GRAY: 'asGray'
	  },
	
	  SHAPE_TYPE: {
	    RECTANGLE: 'Rectangle',
	    ECLIPSE: 'Eclipse'
	  }
	};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ = __webpack_require__(51);
	
	/**
	 *
	 * @type {{
	 *    Rect: {
	 *      create: module.exports.Rect.create,
	 *      inflate: module.exports.Rect.inflate,
	 *      shrink: module.exports.Rect.shrink,
	 *      overturn: module.exports.Rect.overturn,
	 *     offset: module.exports.Rect.offset,
	 *     setLocation: module.exports.Rect.setLocation,
	 *     setSize: module.exports.Rect.setSize,
	 *     topLeft: module.exports.Rect.topLeft,
	 *     bottomRight: module.exports.Rect.bottomRight,
	 *     topRight: module.exports.Rect.topRight,
	 *     bottomLeft: module.exports.Rect.bottomLeft,
	 *     center: module.exports.Rect.center,
	 *     init: module.exports.Rect.init,
	 *     strToRect: module.exports.Rect.strToRect,
	 *     rectToStr: module.exports.Rect.rectToStr,
	 *     empty: module.exports.Rect.empty,
	 *     compareTo: module.exports.Rect.compareTo,
	 *     contain: module.exports.Rect.contain,
	 *     scale: module.exports.Rect.scale
	 *   },
	 *   Point: {
	 *     create: module.exports.Point.create,
	 *     strToPoint: module.exports.Point.strToPoint,
	 *     zero: module.exports.Point.zero,
	 *     offset: module.exports.Point.offset,
	 *     setLocation: module.exports.Point.setLocation,
	 *     scale:module.exports.Point.scale
	 *   },
	 *   Size: {
	 *     create: module.exports.Size.create,
	 *     scale: module.exports.Size.scale,
	 *     overturn: module.exports.Size.overturn
	 *   },
	 *   Text: {
	 *     DM_COMMA: string,
	 *     DM_RETURN: string,
	 *     delimitText: module.exports.Text.delimitText,
	 *     delimitToParagraphs: module.exports.Text.delimitToParagraphs,
	 *     delimitToWords: module.exports.Text.delimitToWords,
	 *     convertSpaceToNbsp: module.exports.Text.convertSpaceToNbsp,
	 *     replaceIndentSpace : module.exports.Text.replaceIndentSpace,
	 *     ansiStartsStr: module.exports.Text.ansiStartsStr,
	 *     ansiEndsStr: module.exports.Text.ansiEndsStr,
	 *     trimRight: module.exports.Text.trimRight,
	 *     removeLastEmptyRow: module.exports.Text.removeLastEmptyRow,
	 *     compareTo: module.exports.Text.compareTo,
	 *     replaceLast: module.exports.Text.replaceLast,
	 *     isMultiLineText: module.exports.Text.isMultiLineText,
	 *     decode : module.exports.Text.decode
	 *   },
	 *   Color: {
	 *     toHex: module.exports.Color.toHex,
	 *     toRGBA: module.exports.Color.toRGBA,
	 *     isLight: module.exports.Color.isLight,
	 *     toGay: module.exports.Color.toGay,
	 *     rgbaToString: module.exports.Color.rgbaToString,
	 *     toHTMLColor: module.exports.Color.toHTMLColor,
	 *     setOpacity: module.exports.Color.setOpacity
	 *   },
	 *   Bitmap: {
	 *     gay: module.exports.Bitmap.gay,
	 *     invert: module.exports.Bitmap.invert,
	 *     dodgeColor: module.exports.Bitmap.dodgeColor,
	 *     gaussBlur: module.exports.Bitmap.gaussBlur,
	 *     dissolve: module.exports.Bitmap.dissolve,
	 *     hardMix: module.exports.Bitmap.hardMix,
	 *     replacecolor: module.exports.Bitmap.replacecolor
	 *   },
	 *   Number: {
	 *     toInt: module.exports.Number.toInt,
	 *     toFloat: module.exports.Number.toFloat,
	 *     decimalPlaces: module.exports.Number.decimalPlaces
	 *   },
	 *   Path: {
	 *     Curve: {
	 *       T: undefined,
	 *       curvePointList: Array,
	 *       create: module.exports.Path.Curve.create,
	 *       isPointIn: module.exports.Path.Curve.isPointIn
	 *     },
	 *     PathData: module.exports.Path.PathData
	 *   },
	 *   Util: {
	 *     map: module.exports.Util.map
	 *   },
	 *   Int: module.exports.Int,
	 *   Float: module.exports.Float,
	 *   clone: module.exports.clone,
	 *   depthClone : module.exports.depthClone
	 * }}
	 */
	module.exports = {
	  /**
	   * 区域处理
	   */
	  Rect: {
	    create: function create(left, top, width, height) {
	      var rect = this.empty();
	      this.setLocation(rect, left, top);
	      this.setSize(rect, width, height);
	      return rect;
	    },
	    /**
	     * 扩展区域
	     * @param rect
	     * @param x
	     * @param y
	     */
	    combo: function combo(target, source) {
	      target.left = Math.min(target.left, source.left);
	      target.top = Math.min(target.top, source.top);
	      target.right = Math.max(target.right, source.right);
	      target.bottom = Math.max(target.bottom, source.bottom);
	      target.width = target.right - target.left;
	      target.height = target.bottom - target.top;
	    },
	
	    /**
	     * 扩展区域
	     * @param rect
	     * @param x
	     * @param y
	     */
	    inflate: function inflate(rect, x, y) {
	      if (x) {
	        rect.left -= x;
	        rect.width += x * 2;
	        rect.right += x;
	      }
	      if (y) {
	        rect.top -= y;
	        rect.height += y * 2;
	        rect.bottom += y;
	      }
	    },
	
	    /**
	     * 收缩区域
	     * @param rect
	     * @param x
	     * @param y
	     */
	    shrink: function shrink(rect, x, y) {
	      if (x) {
	        x = -x;
	      }
	      if (y) {
	        y = -y;
	      }
	      this.inflate(rect, x, y);
	    },
	
	    overturn: function overturn(r) {
	      var l, t, w, h;
	      l = r.top;
	      t = r.left;
	      w = r.height;
	      h = r.width;
	      this.setLocation(r, l, t);
	      this.setSize(r, w, h);
	    },
	
	    /**
	     * 偏移区域
	     * @param rect
	     * @param x
	     * @param y
	     */
	    offset: function offset(rect, x, y) {
	      this.init(rect);
	      if (x) {
	        rect.left += x;
	        rect.right += x;
	      }
	      if (y) {
	        rect.top += y;
	        rect.bottom += y;
	      }
	    },
	
	    /**
	     * 设置区域坐标
	     * @param rect
	     * @param x
	     * @param y
	     */
	    setLocation: function setLocation(rect, x, y) {
	      var offsetX = 0;
	      var offsetY = 0;
	      if (x) {
	        offsetX = x - rect.left;
	      }
	      if (y) {
	        offsetY = y - rect.top;
	      }
	      this.offset(rect, offsetX, offsetY);
	    },
	
	    /**
	     * 设置区域尺寸
	     * @param rect
	     * @param w
	     * @param h
	     */
	    setSize: function setSize(rect, w, h) {
	      this.init(rect);
	      if (!_.isUndefined(w)) {
	        rect.width = w;
	        rect.right = rect.left + w;
	      }
	      if (!_.isUndefined(h)) {
	        rect.height = h;
	        rect.bottom = rect.top + h;
	      }
	    },
	
	    /**
	     * 返回左上角坐标
	     * @param rect
	     * @returns {{x: (number|*), y: (number|*)}}
	     */
	    topLeft: function topLeft(rect) {
	      return {
	        x: rect.left,
	        y: rect.top
	      };
	    },
	
	    /**
	     * 返回右下角坐标
	     * @param rect
	     * @returns {{x: (number|*), y: (number|*)}}
	     */
	    bottomRight: function bottomRight(rect) {
	      return {
	        x: rect.right,
	        y: rect.bottom
	      };
	    },
	
	    topRight: function topRight(rect) {
	      return {
	        x: rect.right,
	        y: rect.top
	      };
	    },
	
	    bottomLeft: function bottomLeft(rect) {
	      return {
	        x: rect.left,
	        y: rect.bottom
	      };
	    },
	
	    /**
	     * 返回区域的中心点坐标
	     * @param rect
	     * @returns {{x: *, y: *}}
	     */
	    center: function center(rect) {
	      return {
	        x: rect.left + rect.width / 2,
	        y: rect.top + rect.height / 2
	      };
	    },
	
	    init: function init(rect) {
	      if (_.isUndefined(rect)) {
	        rect = this.empty();
	      }
	      if (_.isUndefined(rect.left)) {
	        rect.left = 0;
	      }
	      if (_.isUndefined(rect.top)) {
	        rect.top = 0;
	      }
	      if (_.isUndefined(rect.right)) {
	        rect.right = rect.left || 0;
	      }
	      if (_.isUndefined(rect.bottom)) {
	        rect.bottom = rect.top || 0;
	      }
	      rect.width = rect.right - rect.left;
	      rect.height = rect.bottom - rect.top;
	      rect.center = {
	        x: (rect.left + rect.right) / 2,
	        y: (rect.top + rect.bottom) / 2
	      };
	      return rect;
	    },
	    /**
	     * 字符串转换为区域
	     * @param str {string{'{number,number,number,number}' or '(number,number,number,number)' or '{left:number,top:number,right:number,bottom:number}'} or object{left:number,top:number,right:number,bottom:number}}
	     * @returns {*}
	     */
	    strToRect: function strToRect(str) {
	      var rect = this.empty();
	      var temp;
	      if (typeof str === 'string') {
	        try {
	          temp = JSON.parse(str);
	        } catch (e) {}
	        if (temp && temp.left && temp.right && temp.bottom && temp.top) {
	          rect = temp;
	        } else {
	          str = str.replace(/\{|\}|\(|\)/g, '').split(',');
	          if (str.length > 0) rect.left = parseInt(str[0].trim(), 10) || 0;
	          if (str.length > 1) rect.top = parseInt(str[1].trim(), 10) || 0;
	          if (str.length > 2) rect.right = parseInt(str[2].trim(), 10) || 0;
	          if (str.length > 3) rect.bottom = parseInt(str[3].trim(), 10) || 0;
	        }
	        rect.width = rect.right - rect.left;
	        rect.height = rect.bottom - rect.top;
	      } else {
	        rect = str;
	      }
	      return rect;
	    },
	
	    /**
	     * 把区域转换为字符串,这里转换后的字符串不是一个json结构的字符串
	     * @param rect
	     * @returns {‘{number,number,number,number}’}
	     */
	    rectToStr: function rectToStr(rect) {
	      return '{1,2,3,4}'.replace('1', rect.left).replace('2', rect.top).replace('3', rect.right).replace('4', rect.bottom);
	    },
	    /**
	     * 返回一个空白区域
	     * @returns {{left: number, top: number, width: number, height: number, right: number, bottom: number}}
	     */
	    empty: function empty() {
	      var rect = {};
	      rect.left = rect.top = rect.right = rect.bottom = rect.width = rect.height = 0;
	      return rect;
	    },
	
	    /**
	     * 两个区域是否完全重合
	     * @param r1
	     * @param r2
	     * @returns {boolean}
	     */
	    compareTo: function compareTo(r1, r2) {
	      return r1.left === r2.left && r1.top === r2.top && r1.right === r2.right && r1.bottom === r2.bottom;
	    },
	    /**
	     * 区域中是否包含某个点或另一个区域
	     * @param rect
	     * @param r {rect or point}
	     * @returns {boolean}
	     */
	    contain: function contain(rect, r) {
	      if (!_.isUndefined(r.x) && !_.isUndefined(r.y)) {
	        return r.x > rect.left && r.y > rect.top && r.x < rect.right && r.y < rect.bottom;
	      } else {
	        return r.left > rect.left && r.top > rect.top && r.left < rect.right && r.top < rect.bottom && r.right > rect.left && r.right < rect.right && r.bottom > rect.top && r.bottom < rect.bottom;
	      }
	    },
	
	    scale: function scale(rect, scaleX, scaleY, lockPoint) {
	      var x = rect.left;
	      var y = rect.top;
	      var w = rect.width;
	      var h = rect.height;
	      if (_.isUndefined(w)) {
	        this.init(rect);
	        w = rect.width;
	        h = rect.height;
	      }
	      var sx = scaleX;
	      var sy = scaleY;
	      if (!scaleX) {
	        return;
	      }
	      if (typeof scaleY === 'undefined' || typeof scaleY === 'null') {
	        sy = scaleX;
	      }
	      if (typeof scaleY === 'boolean') {
	        sy = scaleX;
	        lockPoint = scaleY;
	      }
	      x *= sx;
	      w *= sx;
	      y *= sy;
	      h *= sy;
	      if (!lockPoint) this.setLocation(rect, x, y);
	      this.setSize(rect, w, h);
	    }
	  },
	  /**
	   * 坐标处理
	   */
	  Point: {
	    create: function create(x, y) {
	      var point = this.zero();
	      this.setLocation(point, x, y);
	      return point;
	    },
	    strToPoint: function strToPoint(str) {
	      var p = this.zero();
	      var temp;
	      if (typeof str === 'string') {
	        try {
	          temp = JSON.parse(str);
	        } catch (e) {}
	        if (temp && temp.x && temp.y) {
	          p = temp;
	        } else {
	          if (str.toLowerCase().indexOf('e') !== -1) {
	            // 这TM是科学计数法，不服能行？
	            str = str.replace(/\{|\}|\(|\)/g, '').split(',');
	            if (str.length > 0) {
	              p.x = Math.round(Number(str[0].trim()) || 0);
	            }
	            if (str.length > 1) {
	              p.y = Math.round(Number(str[1].trim()) || 0);
	            }
	          } else {
	            str = str.replace(/\{|\}|\(|\)/g, '').split(',');
	            if (str.length > 0) {
	              p.x = parseInt(str[0].trim(), 10) || 0;
	            }
	            if (str.length > 1) {
	              p.y = parseInt(str[1].trim(), 10) || 0;
	            }
	          }
	        }
	      } else {
	        p = str;
	      }
	      return p;
	    },
	
	    zero: function zero() {
	      return {
	        x: 0,
	        y: 0
	      };
	    },
	
	    offset: function offset(point, x, y) {
	      if (point) {
	        point.x = point.x + (x || 0);
	        point.y = point.y + (y || 0);
	      } else {
	        console.error('point is invalid');
	      }
	    },
	
	    setLocation: function setLocation(point, x, y) {
	      if (!point) {
	        console.error('point is invalid');
	      } else {
	        point.x = x;
	        point.y = y;
	      }
	    },
	
	    scale: function scale(point, ratio) {
	      point.x = point.x * ratio;
	      point.y = point.y * ratio;
	    }
	  },
	
	  Size: {
	    create: function create(w, h) {
	      return {
	        width: w,
	        height: h
	      };
	    },
	    scale: function scale(size, scaleX, scaleY) {
	      if (!scaleX) {
	        return;
	      }
	      if (!scaleY) {
	        scaleY = scaleX;
	      }
	      size.wdith *= scaleX;
	      size.height *= scaleY;
	    },
	
	    overturn: function overturn(size) {
	      var t;
	      t = size.width;
	      size.width = size.height;
	      size.height = t;
	    }
	  },
	
	  /**
	   * 文字处理
	   */
	  Text: {
	    DM_COMMA: ',',
	    DM_RETURN: '\n',
	    /**
	     * 文字拆分
	     * @param str
	     * @param dmMode
	     * @param isAllowZHComma
	     * @returns {Array}
	     */
	    delimitText: function delimitText(str, dmMode, isAllowZHComma) {
	      var arr = [];
	      if (str) {
	        if (dmMode === this.DM_COMMA) {
	          if (isAllowZHComma === undefined) {
	            isAllowZHComma = true;
	          }
	          arr = str.split(dmMode);
	          if (isAllowZHComma && arr.length === 1) {
	            arr = str.split('，');
	          }
	        } else {
	          arr = str.split(dmMode);
	        }
	      }
	      return arr;
	    },
	
	    delimitToParagraphs: function delimitToParagraphs(str) {
	      return this.delimitText(str, this.DM_RETURN);
	    },
	
	    delimitToWords: function delimitToWords(str, isAllowZHComma) {
	      return this.delimitText(str, this.DM_COMMA, isAllowZHComma);
	    },
	    /**
	     * 空格替换
	     * @param text
	     * @returns {*}
	     */
	    convertSpaceToNbsp: function convertSpaceToNbsp(text) {
	      if (text) {
	        //text = text.replace(/\n/g,'\u000a');
	        return text.replace(/\s\s/g, ' \xA0');
	      }
	      return text;
	    },
	
	    replaceIndentSpace: function replaceIndentSpace(text) {
	      var i;
	      var str;
	      var indent;
	      var c;
	      if (text) {
	        indent = '';
	        i = 0;
	        c = 0;
	        while (true) {
	          str = text.charAt(i);
	          if (str === ' ' || str === '\xA0') {
	            indent += '\xA0';
	            c++;
	          } else {
	            break;
	          }
	          i++;
	        }
	        if (c) {
	          for (i = 0; i < Math.ceil(c / 3); i++) {
	            indent += '\xA0';
	          }
	          text = indent + text.substring(c);
	        }
	      }
	      return text;
	    },
	
	    /**
	     * 是否以某段字符开头
	     * @param text
	     * @param str
	     * @returns {boolean}
	     */
	    ansiStartsStr: function ansiStartsStr(text, str) {
	      if (text && str) return text.indexOf(str) === 0;
	      return text;
	    },
	    /**
	     * 是否以某段字符结尾
	     * @param text
	     * @param str
	     * @returns {*|boolean}
	     */
	    ansiEndsStr: function ansiEndsStr(text, str) {
	      var newStr;
	      var newText;
	      if (str) newStr = str.split('').reverse().join('');
	      if (text) newText = text.split('').reverse().join('');
	      if (newText && newStr) return this.ansiStartsStr(newText, newStr);
	      return text;
	    },
	    /**
	     * 清除末尾空格
	     * @param text
	     * @returns {string}
	     */
	    trimRight: function trimRight(text) {
	      var temp;
	      if (text) {
	        temp = 'temp' + text;
	        temp = temp.trim();
	        temp = temp.substring(4);
	        return temp;
	      }
	      return text;
	    },
	
	    /**
	     * 删除最后一个空行，不论末尾有多少个空行，都只删除最后一个
	     * @param text
	     * @returns {*}
	     */
	    removeLastEmptyRow: function removeLastEmptyRow(text) {
	      var a = this.delimitText(text, this.DM_RETURN);
	      var i = a.length - 1;
	      var arr = [];
	      var s = a[i];
	      if (s !== '') {
	        arr.push(s);
	      }
	      i--;
	      for (i; i >= 0; i--) {
	        s = a[i];
	        arr.push(s);
	      }
	      arr.reverse();
	      return arr.join('\n');
	    },
	    /**
	     * 比较两段文字是否相同
	     * @param text
	     * @param str
	     * @param ignoreEmpty
	     * @returns {boolean}
	     */
	    compareTo: function compareTo(text, str, ignoreEmpty) {
	      if (text && str) {
	        if (ignoreEmpty) {
	          return text.trim() === str;
	        } else {
	          return text === str;
	        }
	      } else if (!text && !str) {
	        return true;
	      }
	      return false;
	    },
	
	    replaceLast: function replaceLast(text, cfg) {
	      function reverse(c) {
	        return c.split('').reverse().join('');
	      }
	
	      if (!text || !cfg) {
	        return text;
	      }
	
	      var newCfg;
	      var i;
	      var l1 = text.length;
	      var l2 = cfg.length;
	      var endStr;
	      if (typeof cfg === 'string') {
	        endStr = text.substring(l1 - l2);
	        if (endStr === cfg) {
	          return text.substring(0, l1 - l2);
	        }
	      } else if (typeof cfg == 'array') {
	        for (i = 0; i < cfg.length; i++) {
	          newCfg = cfg[i];
	          l2 = newCfg.length;
	          endStr = text.substring(l1 - l2);
	          if (endStr === newCfg) {
	            return text.substring(0, l1 - l2);
	          }
	        }
	        return text;
	      } else {
	        return text;
	      }
	    },
	
	    isMultiLineText: function isMultiLineText(str) {
	      if (_.isUndefined(str) || _.isEmpty(str)) {
	        return false;
	      }
	      var a = this.delimitToParagraphs(str);
	      return a.length > 1;
	    },
	
	    decode: function decode(text) {
	      var t;
	      var i;
	      if (text) {
	        text = text.replace(/\+/g, '%20');
	        try {
	          text = decodeURIComponent(text);
	        } catch (e) {
	          text = decodeURI(text);
	        }
	      }
	      if (this.isMultiLineText(text)) {
	        t = this.delimitToParagraphs(text);
	        for (i = 0; i < t.length; i++) {
	          t[i] = this.convertSpaceToNbsp(t[i]);
	        }
	        text = t.join('\n');
	      } else {
	        text = this.convertSpaceToNbsp(text);
	      }
	      return text;
	    },
	    decodeFontFamily: function decodeFontFamily(font) {
	      return font && font.replace(/\+/g, ' ');
	    }
	  },
	  /**
	   * 颜色处理
	   */
	  Color: {
	    /**
	     * 转换为十六进制颜色
	     * @param color
	     * @returns {string}
	     */
	    toHex: function toHex(color) {
	      if (color.indexOf('#') === 0) {
	        return color;
	      }
	      var c = parseInt(color, 10);
	      if (c) {
	        color = '#' + c.toString(16);
	      }
	      return color;
	    },
	
	    toRGB: function toRGB(color) {
	      var c;
	      var r, g, b;
	      var rgb;
	      if (color.indexOf('rgb') === 0) {
	        c = color.replace(/\(|\)/g, '').replace('rgb', '').split(',');
	        rgb = {
	          r: parseInt(c[0].trim(), 10),
	          g: parseInt(c[1].trim(), 10),
	          b: parseInt(c[2].trim(), 10)
	        };
	        return rgb;
	      } else {
	        if (color.indexOf('#') === 0) {
	          color = color.replace('#', '');
	          c = parseInt(color, 16);
	          r = c >> 16 & 0xff;
	          g = c >> 8 & 0xff;
	          b = c >> 0 & 0xff;
	          rgb = {
	            r: r,
	            g: g,
	            b: b
	          };
	          return rgb;
	        }
	      }
	    },
	
	    /**
	     * 转换为RGBA格式对象
	     * @param color
	     * @returns {{r:number,g:number,b:number,a:number}}
	     */
	    toRGBA: function toRGBA(color) {
	      var c;
	      var r;
	      var g;
	      var b;
	      var a;
	      var rgba;
	      if (typeof color === 'string') {
	        if (color.indexOf('rgba') === 0) {
	          c = color.replace(/\(|\)/g, '').replace('rgba', '').split(',');
	          rgba = {
	            r: parseInt(c[0].trim(), 10),
	            g: parseInt(c[1].trim(), 10),
	            b: parseInt(c[2].trim(), 10),
	            a: parseFloat(c[3].trim())
	          };
	          return rgba;
	        } else {
	          if (color.indexOf('#') === 0) {
	            color = color.replace('#', '');
	            c = parseInt(color, 16);
	          } else if (color.indexOf('0x') === 0) {
	            color = color.replace('0x', '');
	            c = parseInt(color, 16);
	          } else {
	            c = parseInt(color, 10);
	          }
	        }
	      } else if ((typeof color === 'undefined' ? 'undefined' : _typeof(color)) === 'object') {
	        return _.extend({}, color);
	      } else {
	        c = parseInt(color, 10);
	      }
	      if (color) {}
	      r = c >> 16 & 0xff;
	      g = c >> 8 & 0xff;
	      b = c >> 0 & 0xff;
	      a = c >> 24 & 0xff;
	      rgba = {
	        r: r,
	        g: g,
	        b: b,
	        a: a / 255
	      };
	      return rgba;
	    },
	
	    /**
	     * 是否明亮色
	     * @param color
	     * @returns {boolean}
	     */
	    isLight: function isLight(color) {
	      var c = this.toRGBA(color);
	      c = this.toGay(c);
	      return c.r + c.g + c.b > 128;
	    },
	
	    /**
	     * 转换为灰色
	     * @param color
	     * @returns {{r:number,g:number,b:number,a:number}}
	     */
	    toGay: function toGay(color) {
	      var c = this.toRGBA(color);
	      c.r *= 0.299;
	      c.g *= 0.587;
	      c.b *= 0.114;
	      return c;
	    },
	
	    /**
	     * 转换为RGBA格式HTML颜色
	     * @param color
	     * @returns {string('rgba(r,g,b,a))}
	     */
	    rgbaToString: function rgbaToString(color) {
	      return 'rgba(%d1,%d2,%d3,%d4)'.replace('%d1', color.r).replace('%d2', color.g).replace('%d3', color.b).replace('%d4', color.a);
	    },
	
	    /**
	     * 转换为HTML颜色
	     * @param color
	     * @returns {string('rgba(r,g,b,a)')}
	     */
	    toHTMLColor: function toHTMLColor(color) {
	      return this.rgbaToString(this.toRGBA(color));
	    },
	
	    setOpacity: function setOpacity(color, opacity) {
	      var c = this.toRGBA(color);
	      c.a = opacity || 1;
	      return this.toHTMLColor(c);
	    }
	  },
	  /**
	   * 图像处理
	   */
	  Bitmap: {
	    /**
	     * 灰度
	     * @param pixes
	     */
	    gay: function gay(pixes) {
	      for (var i = 0; i < pixes.length; i += 4) {
	        pixes[i] = pixes[i + 1] = pixes[i + 2] = pixes[i] * 0.299 + pixes[i + 1] * 0.587 + pixes[i + 2] * 0.114;
	      }
	    },
	
	    /**
	     * 反相
	     * @param pixes
	     */
	    invert: function invert(pixes) {
	      for (var i = 0; i < pixes.length; i += 4) {
	        pixes[i] = 255 - pixes[i];
	        pixes[i + 1] = 255 - pixes[i + 1];
	        pixes[i + 2] = 255 - pixes[i + 2];
	      }
	    },
	
	    /**
	     * 颜色减淡
	     * @param basePixes
	     * @param mixPixes
	     */
	    dodgeColor: function dodgeColor(basePixes, mixPixes) {
	      for (var i = 0, len = basePixes.length; i < len; i += 4) {
	        basePixes[i] = basePixes[i] + basePixes[i] * mixPixes[i] / (255 - mixPixes[i]);
	        basePixes[i + 1] = basePixes[i + 1] + basePixes[i + 1] * mixPixes[i + 1] / (255 - mixPixes[i + 1]);
	        basePixes[i + 2] = basePixes[i + 2] + basePixes[i + 2] * mixPixes[i + 2] / (255 - mixPixes[i + 2]);
	      }
	    },
	    /**
	     * 高斯模糊
	     * @param pixes
	     * @param width
	     * @param height
	     * @param radius
	     */
	    gaussBlur: function gaussBlur(pixes, width, height, radius) {
	      var sigma;
	      var gaussMatrix = [];
	      var gaussSum = 0;
	      var x;
	      var y;
	      var r;
	      var g;
	      var b;
	      var a;
	      var i;
	      var j;
	      var k;
	      var len;
	
	      radius = Math.floor(radius) || 3;
	      sigma = radius / 3;
	
	      a = 1 / (Math.sqrt(2 * Math.PI) * sigma);
	      b = -1 / (2 * sigma * sigma);
	      //生成高斯矩阵
	      for (i = 0, x = -radius; x <= radius; x++, i++) {
	        g = a * Math.exp(b * x * x);
	        gaussMatrix[i] = g;
	        gaussSum += g;
	      }
	      //归一化, 保证高斯矩阵的值在[0,1]之间
	      for (i = 0, len = gaussMatrix.length; i < len; i++) {
	        gaussMatrix[i] /= gaussSum;
	      }
	      //x 方向一维高斯运算
	      for (y = 0; y < height; y++) {
	        for (x = 0; x < width; x++) {
	          r = g = b = a = 0;
	          gaussSum = 0;
	          for (j = -radius; j <= radius; j++) {
	            k = x + j;
	            if (k >= 0 && k < width) {
	              //确保 k 没超出 x 的范围
	              //r,g,b,a 四个一组
	              i = (y * width + k) * 4;
	              r += pixes[i] * gaussMatrix[j + radius];
	              g += pixes[i + 1] * gaussMatrix[j + radius];
	              b += pixes[i + 2] * gaussMatrix[j + radius];
	              // a += pixes[i + 3] * gaussMatrix[j];
	              gaussSum += gaussMatrix[j + radius];
	            }
	          }
	          i = (y * width + x) * 4;
	          // 除以 gaussSum 是为了消除处于边缘的像素, 高斯运算不足的问题
	          // console.log(gaussSum)
	          pixes[i] = r / gaussSum;
	          pixes[i + 1] = g / gaussSum;
	          pixes[i + 2] = b / gaussSum;
	          // pixes[i + 3] = a ;
	        }
	      }
	      //y 方向一维高斯运算
	      for (x = 0; x < width; x++) {
	        for (y = 0; y < height; y++) {
	          r = g = b = a = 0;
	          gaussSum = 0;
	          for (j = -radius; j <= radius; j++) {
	            k = y + j;
	            if (k >= 0 && k < height) {
	              //确保 k 没超出 y 的范围
	              i = (k * width + x) * 4;
	              r += pixes[i] * gaussMatrix[j + radius];
	              g += pixes[i + 1] * gaussMatrix[j + radius];
	              b += pixes[i + 2] * gaussMatrix[j + radius];
	              // a += pixes[i + 3] * gaussMatrix[j];
	              gaussSum += gaussMatrix[j + radius];
	            }
	          }
	          i = (y * width + x) * 4;
	          pixes[i] = r / gaussSum;
	          pixes[i + 1] = g / gaussSum;
	          pixes[i + 2] = b / gaussSum;
	        }
	      }
	    },
	
	    /**
	     * 溶解
	     * @param pixes
	     */
	    dissolve: function dissolve(pixes, step) {
	      var a;
	      for (var i = 0, len = pixes.length; i < len; i += 4) {
	        a = Math.random() * 255;
	        if (a < 150) {
	          a = 0;
	        }
	        pixes[i + 3] = a;
	      }
	    },
	
	    /**
	     * 实色混合
	     * @param basePixes
	     * @param mixPixes
	     */
	    hardMix: function hardMix(basePixes, mixPixes) {
	      var r;
	      var len = basePixes.length;
	      for (var i = 0; i < len; i++) {
	        if ((i + 1) % 4 !== 0) {
	          r = basePixes[i] + mixPixes[i];
	          if (r < 255) {
	            r = 0;
	          }
	          if (r > 255) {
	            r = 255;
	          }
	          basePixes[i] = r;
	        }
	      }
	    },
	
	    /**
	     * 替换颜色
	     * @param pixes
	     * @param color
	     */
	    replacecolor: function replacecolor(pixes, color) {
	      var c = exports.util.Color.toRGBA(color);
	      for (var i = 0; i < pixes.length; i += 4) {
	        pixes[i] = c.R;
	        pixes[i + 1] = c.G;
	        pixes[i + 2] = c.B;
	        if (pixes[i + 3]) pixes[i + 3] = c.A * 255;
	      }
	    }
	  },
	
	  Number: {
	    toInt: function toInt(value) {
	      var defaultValue = value || arguments.length > 1 ? arguments[1] : 0;
	      var reg = new RegExp('^[0-9]+$');
	      if (!_.isUndefined(value) && reg.test(value)) return parseInt(value, 10);
	      return defaultValue;
	    },
	
	    toFloat: function toFloat(value) {
	      var defaultValue = value || arguments.length > 1 ? arguments[1] : 0;
	      var reg = new RegExp('^-?[0-9]+(\.[0-9]+)?$');
	      if (!_.isUndefined(value) && reg.test(value)) {
	        try {
	          return parseFloat(value);
	        } catch (e) {
	          return defaultValue;
	        }
	      } else {
	        return defaultValue;
	      }
	    },
	
	    /**
	     * 保留小数点位数
	     * @param value
	     * @param c
	     * @returns {number}
	     */
	    decimalPlaces: function decimalPlaces(value, c) {
	      var s = 1;
	      var i = 0;
	      var v;
	      if (!c) {
	        c = 0;
	      } else {
	        c = this.toInt(c);
	      }
	      for (i; i < c; i++) {
	        s += '0';
	      }
	      s = this.toInt(s);
	      v = this.toFloat(value);
	      return Math.round(v * s) / s;
	    }
	  },
	
	  Path: {
	    Curve: {
	      T: undefined,
	      curvePointList: [],
	      create: function create(startPoint, endPoint, controlPoint) {
	        var x1 = startPoint.x;
	        var x2 = endPoint.x;
	        var cx = controlPoint.x;
	        var y1 = startPoint.y;
	        var y2 = endPoint.y;
	        var cy = controlPoint.y;
	
	        var t1 = Math.sqrt(Math.pow(Math.abs(cx - x1), 2) + Math.pow(Math.abs(cy - y1), 2));
	        var t2 = Math.sqrt(Math.pow(Math.abs(cx - x2), 2) + Math.pow(Math.abs(cy - y2), 2));
	        this.T = Math.ceil(t1 + t2);
	
	        var i;
	        var px;
	        var py;
	        var s = 1 / this.T;
	        var t = 0;
	
	        for (i = 0; i < this.T; i++) {
	          px = Math.pow(1 - t, 2) * startPoint.x + 2 * t * (1 - t) * controlPoint.x + Math.pow(t, 2) * endPoint.x;
	          py = Math.pow(1 - t, 2) * startPoint.y + 2 * t * (1 - t) * controlPoint.y + Math.pow(t, 2) * endPoint.y;
	          t += s;
	          this.curvePointList.push({ x: px, y: py });
	        }
	      },
	
	      isPointIn: function isPointIn(x, y, offset) {
	        var i = 0;
	        var p;
	        var r;
	        offset = offset || 0;
	        for (i; i < this.curvePointList.length; i++) {
	          p = this.curvePointList[i];
	          r = { left: p.x - offset, top: p.y - offset, right: p.x + offset, bottom: p.y + offset };
	          if (r.left < x && r.right > x && r.top < y && r.bottom > y) {
	            return true;
	          }
	        }
	        return false;
	      }
	    },
	    PathData: function PathData() {
	      var data = [];
	      var lastMoveCmd;
	      var doClose = false;
	      this.moveTo = function (x, y) {
	        var cmd = { cmd: 'moveTo', params: [x, y] };
	        lastMoveCmd = cmd;
	        data.push(cmd);
	        return this;
	      };
	
	      this.lineTo = function (x, y) {
	        data.push({ cmd: 'lineTo', params: [x, y] });
	        return this;
	      };
	
	      this.curveTo = function (cx, cy, x, y) {
	        data.push({ cmd: 'quadraticCurveTo', params: [cx, cy, x, y] });
	        return this;
	      };
	
	      this.arc = function (rx, ry, r, startAngle, endAngle) {
	        data.push({ cmd: 'arc', params: [rx, ry, r, startAngle, endAngle] });
	        return this;
	      };
	
	      this.close = function () {
	        if (lastMoveCmd) {
	          //this.lineTo(lastMoveCmd.params.x, lastMoveCmd.params.y);
	          this['lineTo'].apply(this, lastMoveCmd.params);
	        }
	        doClose = true;
	        return this;
	      };
	
	      this.clear = function () {
	        data = [];
	        lastMoveCmd = undefined;
	        doClose = false;
	        return this;
	      };
	
	      this.print = function () {
	        //console.log(data)
	      };
	
	      this.stroke = function (graphics, doFill) {
	        var i;
	        var cmd;
	        var func;
	        var params;
	        if (doClose) graphics.beginPath();
	        for (i = 0; i < data.length; i++) {
	          cmd = data[i];
	          func = cmd.cmd;
	          params = cmd.params;
	          graphics[func].apply(graphics, params);
	        }
	        if (doClose) graphics.closePath();
	        if (doFill) {
	          graphics.fill();
	        }
	        graphics.stroke();
	      };
	    }
	
	  },
	
	  Util: {
	    map: function map(count, func, children) {
	      var a = [];
	      var i;
	      var o;
	      if (count) {
	        if (func) {
	          for (i = 0; i < count; i++) {
	            if (children) {
	              if (children[i]) {
	                o = children[i];
	              } else {
	                o = undefined;
	              }
	            }
	            a.push(func(o, i));
	          }
	        }
	      }
	      return a;
	    }
	  },
	
	  Int: function Int(value) {
	    var defaultValue = value || arguments.length > 1 ? arguments[1] : 0;
	    return this.Number.toInt(value, defaultValue);
	  },
	
	  Float: function Float(value) {
	    var defaultValue = value || arguments.length > 1 ? arguments[1] : 0;
	    return this.Number.toFloat(value, defaultValue);
	  },
	
	  clone: function clone(obj) {
	    var s;
	    var o;
	    try {
	      s = JSON.stringify(obj);
	      o = JSON.parse(s);
	    } catch (e) {
	      o = null;
	    }
	    return o;
	  },
	
	  depthClone: function depthClone(source) {
	    function getType(o) {
	      return Object.prototype.toString.call(o).replace('[', '').replace(']', '').replace('object', '').trim().toLowerCase();
	    }
	
	    function getCloneValue(o) {
	      var i;
	      var t = getType(o);
	      var r;
	      if (t === 'number' || t === 'string' || t === 'boolean' || t === 'null' || t === 'undefined') {
	        return o;
	      } else if (t === 'object') {
	        return doClone(o);
	      } else if (t === 'function') {
	        return o;
	      } else if (t === 'array') {
	        r = [];
	        for (i = 0; i < o.length; i++) {
	          r.push(getCloneValue(o[i]));
	        }
	        return r;
	      }
	      return o;
	    }
	
	    function doClone(o) {
	      var k;
	      var item;
	      var r = {};
	      for (k in o) {
	        item = o[k];
	        r[k] = getCloneValue(item);
	      }
	      return r;
	    }
	
	    return getCloneValue(source);
	  },
	
	  /**
	   * 把目标元素推到顶层显示
	   */
	  pushToTop: function pushToTop(targetComp) {
	    var domIndexArray = [];
	
	    function changeZIndex(jDom) {
	      var index = jDom.css('z-index');
	      if (index !== 'auto') {
	        jDom.css({ 'z-index': 2147483646 });
	        domIndexArray.push({ jDom: jDom, zIndex: index });
	      }
	    }
	
	    changeZIndex(targetComp);
	    targetComp.parents().map(function () {
	      changeZIndex($(this));
	    });
	    return domIndexArray;
	  },
	
	  resetDomIndex: function resetDomIndex(domIndexArray) {
	    if (domIndexArray === null) {
	      return;
	    }
	    for (var i = 0; i < domIndexArray.length; i++) {
	      var domIndex = domIndexArray[i];
	      domIndex.jDom.css({ 'z-index': domIndex.zIndex });
	    }
	  }
	};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by mengxiaojiang on 2016/5/10.
	 */
	
	var _ = __webpack_require__(51);
	var dataHelper = __webpack_require__(113);
	var CompTemplete = __webpack_require__(118);
	
	/**
	 * 中英文字体对应表
	 * 直接使用中文字体名称可能会有问题, 应该使用英文名称
	 */
	var fontFamilyMap = {
	  '微软雅黑': 'Microsoft Yahei',
	  '宋体': 'SimSun'
	};
	
	function doMakeComp(comp) {
	
	  CompTemplete.initComp(comp);
	  if (!_.isUndefined(comp.controlProperties)) {
	    var properties = comp.controlProperties;
	    if (!_.isUndefined(properties.basic)) {
	      _.extend(comp, properties.basic);
	    }
	    if (!_.isUndefined(properties.textSet)) {
	      _.extend(comp, properties.textSet);
	      if (!comp.text || _.isEmpty(comp.text)) {
	        comp.text = ''; // 组件保存时，如果字符串为空，该属性未保存。
	      }
	    }
	    if (!_.isUndefined(properties.scrollbar)) {
	      //_.extend(comp, properties.scrollbar);
	      comp.verticalScrollbarShow = properties.scrollbar.verticalScrollbar.isShow;
	      comp.verticalScrollbarProgress = properties.scrollbar.verticalScrollbar.progress;
	      comp.horizontalScrollbarShow = properties.scrollbar.horizontalScrollbar.isShow;
	      comp.horizontalScrollbarProgress = properties.scrollbar.horizontalScrollbar.progress;
	    }
	    if (!_.isUndefined(properties.filter)) {
	      _.extend(comp, properties.filter);
	    }
	    _.extend(comp, properties);
	
	    comp.links = properties.links;
	    comp.states = properties.states;
	    comp.interactiveData = properties.interactiveData;
	    comp.x = parseInt(comp.x, 10);
	    comp.y = parseInt(comp.y, 10);
	    comp.h = parseInt(comp.h, 10);
	    comp.w = parseInt(comp.w, 10);
	
	    if (comp.remarkText) {
	      if (_.isEmpty(comp.remarkText)) {
	        comp.remarkText = '';
	      }
	
	      comp.remarkText = dataHelper.decodeURI(comp.remarkText);
	    }
	    if (_.isEmpty(comp.externalURL)) {
	      comp.externalURL = '';
	    }
	    if (_.isEmpty(comp.URL)) {
	      comp.URL = '';
	    }
	
	    delete comp.controlProperties;
	    delete comp.basic;
	    delete comp.textSet;
	  }
	
	  if (!_.isUndefined(comp.groupChildrenDescriptors)) {
	    comp.items = comp.groupChildrenDescriptors.control;
	    if (comp.items) {
	      comp.items.map(doMakeComp);
	    }
	    delete comp.groupChildrenDescriptors;
	  }
	  if (comp.textFontFamily) {
	    comp.textFontFamily = fontFamilyMap[comp.textFontFamily] || comp.textFontFamily;
	  }
	
	  return comp;
	}
	
	exports.reconstruction = function (pageData) {
	  var rootData;
	  var i;
	
	  if (pageData.mockup) {
	    rootData = pageData.mockup;
	  } else if (pageData.master) {
	    rootData = pageData.master;
	  } else {
	    rootData = pageData;
	  }
	
	  if (!rootData) {
	    console.dir(pageData);
	  }
	
	  if (!rootData.controls.control) {
	    // 空白页面
	    return;
	  }
	
	  for (i = 0; i < rootData.controls.control.length; i++) {
	    doMakeComp(rootData.controls.control[i]);
	  }
	};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Created by allen on 2017/8/1.
	 */
	
	var _ = __webpack_require__(51);
	var dataHelper = __webpack_require__(113);
	
	var templete = {
	  "ComBase": {
	    "color": "0xFFFFFFFF",
	    "borderColor": "0xFF666666",
	    "borderVisible": true,
	    "status": "MsEnabled",
	    "opacity": 1,
	    "isAutoSize": false,
	    "locked": false,
	    "sizeLocked": false,
	    "canMove": true,
	    "remarkText": "",
	    "externalURL": "",
	    "isCommentCom": false,
	    "isShow": true,
	    "alias": "",
	    "caption": "",
	    "verticalScrollbarShow": false,
	    "verticalScrollbarProgress": 0,
	    "horizontalScrollbarShow": false,
	    "horizontalScrollbarProgress": 0,
	    "rotation": 0
	  },
	  "ComTextBase": {
	    "textFontFamily": "",
	    "useDefaultTextSize": true,
	    "textStyles": "[]",
	    "textAlign": "HaLeft",
	    "textVAlign": "VaMiddle",
	    "textColor": "0xFF000000",
	    "textSize": 12,
	    "selectedIndex": 0,
	    "selectedColor": "0xFF41C7DB",
	    //"isAutoTextColor": true,
	    "lineSpacingMultiple": 1,
	    "text": "",
	    "textWordWrap": true,
	    "textPadding": 0
	  },
	  "Button": {
	    "BaseID": "ComTextBase",
	    "textAlign": "HaCenter",
	    "textSize": 14,
	    "radius": 6,
	    "radiusIsPercent": false,
	    "buttonStatus": "BsNormal",
	    "thickness": 1,
	    "isAutoTextColor": false
	  },
	  "Shape": {
	    "BaseID": "ComTextBase",
	    "dashMode": "SdSolid",
	    "shapeBorderType": "SbRectangle",
	    "triangleType": "TdZero",
	    "thickness": 1,
	    "radiusIsPercent": false,
	    "radius": 0,
	    "textAlign": "HaCenter",
	    "borderMode": "[bmLeft,bmTop,bmRight,bmBottom]"
	  },
	  "Circle": {
	    "BaseID": "Shape"
	  },
	  "Polygon": {},
	  "Triangle": {
	    "triangleType": "ttNormal",
	    "triangleDirection": "TdZero",
	    "thickness": 1,
	    "dashMode": "SdSolid"
	  },
	  "Icon": {
	    "color": "0xFF666666",
	    "URL": "",
	    "flipHorizontal": false,
	    "flipVertical": false,
	    "rotationAngle": "TdZero"
	  },
	  "Image": {
	    "borderVisible": false,
	    "flipHorizontal": false,
	    "flipVertical": false,
	    "rotationAngle": "TdZero",
	    "URL": "",
	    "fitMode": "fmStretch",
	    "clipShapeType": "SbRectangle",
	    "showText": true,
	    "radius": 0,
	    "radiusIsPercent": false
	  },
	  "CoverFlow": {
	    "URL": ""
	  },
	  "Gif": {
	    "URL": ""
	  },
	  "Label": {
	    "BaseID": "ComTextBase",
	    "isAutoSize": true,
	    "textSize": 14,
	    "color": "0x00000000"
	  },
	  "TextInput": {
	    "BaseID": "ComTextBase",
	    "canInput": true,
	    "inputModel": "emText",
	    "placeHolder": "",
	    "textVAlign": "VaMiddle",
	    "textSize": 14,
	    "radiusIsPercent": false
	  },
	  "LabelTextInput": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "textDirection": "tdLeft"
	  },
	  "TextArea": {
	    "BaseID": "ComTextBase",
	    "textSize": 14,
	    "textVAlign": "VaTop",
	    "borderVisible": false,
	    "color": "0x00FFFFFF"
	  },
	  "RadioButton": {
	    "BaseID": "ComTextBase",
	    "textSize": 14,
	    "textVAlign": "VaTop",
	    "textDirection": "tdRight",
	    "state": "MfSelected",
	    "size": 15
	  },
	  "RadioButtonGroup": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "textDirection": "tdRight",
	    "rowGap": 10,
	    "columnGap": 10,
	    "columnCount": 1,
	    "size": 13,
	    "itemHeight": 16
	  },
	  "CheckBox": {
	    "BaseID": "ComTextBase",
	    "state": "MfSelected",
	    "textDirection": "tdRight",
	    "gap": 0,
	    "size": 0,
	    "textSize": 14
	  },
	  "CheckBoxGroup": {
	    "BaseID": "ComTextBase",
	    "textSize": 14,
	    "rowGap": 10,
	    "columnGap": 10,
	    "textDirection": "tdRight",
	    "size": 0,
	    "itemHeight": 19,
	    "columnCount": 1,
	    "selectedIndex": -1,
	    "textVAlign": "VaTop"
	  },
	  "IconButton": _defineProperty({
	    "size": 24,
	    "buttonStyle": "buttonStyle",
	    "iconColor": "0xFF444444",
	    "rotationAngle": "TdZero",
	    "FlipHorizontal": false
	  }, 'FlipHorizontal', false),
	  "IconLabel": _defineProperty({
	    "BaseID": "ComTextBase",
	    "iconDirection": "MiTextBottom",
	    "size": 24,
	    "rotationAngle": "TdZero",
	    "FlipHorizontal": false
	  }, 'FlipHorizontal', false),
	  "AlarmIcon": _defineProperty({
	    "size": 28,
	    "rotationAngle": "TdZero",
	    "FlipHorizontal": false
	  }, 'FlipHorizontal', false),
	  "HSlider": {
	    "sliderColor": "0xFF666666",
	    "trackColor": "0xFF666666",
	    "progress": 30,
	    "sliderShapeType": "SIncisive",
	    "state": "MsEnabled"
	  },
	  "VSlider": {
	    "sliderColor": "0xFF666666",
	    "trackColor": "0xFF666666",
	    "progress": 30,
	    "sliderShapeType": "SIncisive",
	    "state": "MsEnabled"
	  },
	  "Tree": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "borderStyle": false,
	    "iconSize": 13,
	    "iconColor": "0xFF666666",
	    "iconStyle": "isSquare",
	    "iconVisible": true,
	    "itemHeight": 32,
	    "checkboxvisible": false,
	    "treelinevisible": false
	  },
	  "IPad2": {
	    "direction": "SmVert",
	    "color": "0xFFF8F9F9",
	    "borderColor": "0xFF999999"
	  },
	  "TabletPC2": {
	    "direction": "SmVert",
	    "color": "0xFFF8F9F9",
	    "borderColor": "0xFF999999"
	  },
	  "IPhone2": {
	    "direction": "SmVert",
	    "color": "0xFFF8F9F9",
	    "borderColor": "0xFF999999",
	    "isTransparent": false,
	    "fullScreen": false
	  },
	  "Android": {
	    "direction": "SmVert",
	    "color": "0xFFF8F9F9",
	    "borderColor": "0xFF999999",
	    "isTransparent": false,
	    "fullScreen": false
	  },
	  "IPad": {
	    "direction": "SmVert"
	  },
	  "TabletPC": {
	    "direction": "SmVert"
	  },
	  "IPhone": {
	    "direction": "SmVert",
	    "phoneType": "PtAllWhite",
	    "isTransparent": false,
	    "fullScreen": false
	  },
	  "Phone": {
	    "direction": "SmVert",
	    "phoneType": "PtAllWhite",
	    "isTransparent": false,
	    "fullScreen": false
	  },
	  "PageControl": {},
	  "PageControlEx": {
	    "gap": 30,
	    "size": 10,
	    "columnCount": 5,
	    "selectedIndex": 3,
	    "shapeType": "stRound",
	    "color": "0xFF999999",
	    "selectedColor": "0xFF41C7DB",
	    "borderVisible": false
	  },
	  "ColumnChart": {},
	  "ColumnChartEx": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "axisvisible": true,
	    "borderStyle": true
	  },
	  "BarChart": {},
	  "BarChartEx": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "axisvisible": true,
	    "borderStyle": true
	  },
	  "PieChart": {},
	  "PieChartEx": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "axisvisible": true,
	    "borderStyle": true
	  },
	  "LineChart": {},
	  "LineChartEx": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "axisvisible": true,
	    "borderStyle": true
	  },
	  "Graffiti": {
	    "color": "0xFFFF0000",
	    "isCommentCom": true,
	    "strokeThickness": 6,
	    "pointList": ""
	  },
	  "Line": {
	    "BaseID": "ComTextBase",
	    "color": "0xFF666666",
	    "textAlign": "HaCenter",
	    "textVAlign": "VaTop",
	    "controlPoint": "",
	    "startPoint": "",
	    "endPoint": "",
	    "thickness": 1,
	    "dashMode": "SdSolid",
	    "textBackgroundColor": "0xFFFFFFFF",
	    "textBorderColor": "0xFF666666",
	    "showStartArrow": 0,
	    "showEndArrow": 0,
	    "isCurved": true,
	    "isTextPosCenter": true
	  },
	  "Arrow": {
	    "BaseID": "ComTextBase",
	    "isCommentCom": true,
	    "color": "0xFF666666",
	    "textAlign": "HaCenter",
	    "textVAlign": "VaTop",
	    "controlPoint": "",
	    "startPoint": "",
	    "endPoint": "",
	    "thickness": 1,
	    "dashMode": "SdSolid",
	    "textBackgroundColor": "0xFFFFFFFF",
	    "textBorderColor": "0xFF666666",
	    "showStartArrow": 0,
	    "showEndArrow": 0,
	    "isCurved": false,
	    "isTextPosCenter": true
	  },
	  "StickyNote": {
	    "BaseID": "ComTextBase",
	    "color": "0xFFF1C232",
	    "isCommentCom": true,
	    "textVAlign": "VaTop",
	    "isShowTabBar": true
	  },
	  "CallOut": {
	    "BaseID": "ComTextBase",
	    "isCommentCom": true,
	    "textVAlign": "VaTop"
	  },
	  "HCurly": {
	    "BaseID": "ComTextBase",
	    "color": "0xFF666666",
	    "isCommentCom": true,
	    "textAlign": "HaCenter",
	    "textVAlign": "VaTop",
	    "direction": "DrTop"
	  },
	  "VCurly": {
	    "BaseID": "ComTextBase",
	    "color": "0xFF666666",
	    "isCommentCom": true,
	    "textAlign": "HaCenter",
	    "textVAlign": "VaTop",
	    "direction": "DrLeft"
	  },
	  "RedX": {
	    "isCommentCom": true
	  },
	  "ScratchOut": {
	    "isCommentCom": true
	  },
	  "DataGrid": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "showVLine": true,
	    "showHLine": false,
	    "showHeader": true,
	    "interlaceColor": "0xFFEEEEEE",
	    "itemHeight": 25,
	    "isInterlace": true,
	    "separatorColor": "0xFF666666",
	    "headerHeight": 22,
	    "headerColor": "0xFF999999",
	    "headerTextColor": "0xFF000000",
	    "columnRatio": "",
	    "selectedTextColor": "0xFF000000"
	  },
	  "HotSpot": {},
	  "BreadCrumbs": {
	    "BaseID": "ComTextBase",
	    "textColor": "0xFF256BA9",
	    "textVAlign": "VaTop",
	    "gap": 12
	  },
	  "List": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "textPadding": 10,
	    "itemHeight": 25,
	    "isInterlace": false,
	    "interlaceColor": "0xFFEEEEEE",
	    "separatorColor": "0xFF666666",
	    "showSeparator": false
	  },
	  "ToolTip": {
	    "BaseID": "ComTextBase",
	    "textAlign": "HaCenter",
	    "tipCornerDirection": "AdLeftBottom"
	  },
	  "Link": {
	    "BaseID": "ComTextBase",
	    "isAutoSize": true,
	    "textColor": "0xFF0E6C9C",
	    "textVAlign": "VaTop",
	    "textStyles": "[fsUnderline]"
	  },
	  "LinkBar": {
	    "BaseID": "ComTextBase",
	    "color": "0xFF666666",
	    "textColor": "0xFF085394",
	    "textVAlign": "VaTop",
	    "gap": 12
	  },
	  "ModalScreen": {
	    "color": "0x66000000"
	  },
	  "ColorPicker": {
	    "color": "0xFF2B78E4"
	  },
	  "NumericStepper": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop"
	  },
	  "DateTimePicker": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop"
	  },
	  "Menu": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "itemHeight": 25,
	    "separatorColor": "0xFF666666"
	  },
	  "MenuBar": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop"
	  },
	  "SiteMap": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop"
	  },
	  "CircleProgressBar": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "value": 70,
	    "thickness": 5,
	    "indicatorColor": "0xFF41C7DB",
	    "trackColor": "0xFFDDDDDD"
	  },
	  "ProgressBar": {
	    "BaseID": "ComTextBase",
	    "progress": 30,
	    "barStyle": "MfBar",
	    "indicatorColor": "0xFF999999",
	    "trackColor": "0xFFFFFFFF"
	  },
	  "ButtonBar": {
	    "BaseID": "ComTextBase",
	    "color": "0x00FFFFFF",
	    "textVAlign": "VaTop",
	    "thickness": 1,
	    "showHover": false,
	    "hoveredColor": "0x4041C7D6",
	    "selectedTextColor": "0xFF000000"
	  },
	  "Search": {
	    "BaseID": "ComTextBase",
	    "state": "CsEnabled",
	    "radius": "100",
	    "radiusIsPercent": true
	  },
	  "Alert": {
	    "BaseID": "ComTextBase",
	    "textAlign": "HaCenter",
	    "textVAlign": "VaTop",
	    "selection": "MBNone"
	  },
	  "ComboBox": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "state": "MsEnabled",
	    "unfolded": false,
	    "baseHeight": 36
	  },
	  "CompositeComboBox": {
	    "rowCount": 5,
	    "canInput": false,
	    "baseHeight": 39,
	    "textColor": "0xFF000000",
	    "textSize": 12,
	    "textStyles": "[]"
	  },
	  "Form": {
	    "BaseID": "ComTextBase",
	    "gap": 10
	  },
	  "QRCode": {},
	  "Calendar": {},
	  "VolumeSlider": {},
	  "VideoPlayer": {},
	  "Media_Control": {},
	  "FormattingToolbar": {},
	  "EditToolbar": {},
	  "Map": {},
	  "HSplitter": {},
	  "VSplitter": {},
	  "HRule": {
	    "color": "0xFF666666",
	    "thickness": 2
	  },
	  "VRule": {
	    "color": "0xFF666666",
	    "thickness": 2
	  },
	  "VerticalScrollbar": {
	    "progress": 0
	  },
	  "HorizontalScrollBar": {
	    "progress": 0
	  },
	  "GroupBox": {
	    "BaseID": "ComTextBase"
	  },
	  "Tab": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "selectedColor": "0xFFFFFFFF",
	    "direction": "VdTop",
	    "tabPosition": "HaLeft",
	    "tabStyle": "csSquare",
	    "radius": 0,
	    "tabColor": "0xFFDDDDDD",
	    "tabEdge": "0",
	    "tabHeight": 18,
	    "selectedTextColor": "0xFF000000"
	  },
	  "VerticalTabBar": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "selectedColor": "0xFFFFFFFF",
	    "direction": "HdLeft",
	    "tabDirection": "SmHori",
	    "radius": 0,
	    "tabColor": "0xFFDDDDDD",
	    "tabEdge": "0",
	    "tabHeight": 25,
	    "selectedTextColor": "0xFF000000"
	  },
	  "Accordion": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "itemHeight": 29,
	    "separatorColor": "0xFF666666",
	    "showSeparator": true
	  },
	  "TitleWindow": {
	    "BaseID": "ComTextBase",
	    "showMin": false,
	    "showMax": false,
	    "showClose": false,
	    "showDrag": false,
	    "topHeight": 30,
	    "bottomHeight": 24
	  },
	  "BrowserWindow": {},
	  "Switch": {
	    "isOpen": true,
	    "onColor": "0xFF41C7DB",
	    "offColor": "0xFFC0C0C0"
	  },
	  "SwitchIOS": {
	    "borderVisible": false,
	    "isOpen": true,
	    "onColor": "0xFF4AD662",
	    "offColor": "0xFFDDDDDD"
	  },
	  "Avatar(Mobile)": {},
	  "StatusBar(IOS)": {
	    "color": "0xFF000000",
	    "ForegroundColor": "0xFFFFFFFF",
	    "IsAutoTextColor": true
	  },
	  "StatusBar(Android)": {
	    "color": "0xFF000000",
	    "ForegroundColor": "0xFFFFFFFF",
	    "IsAutoTextColor": true
	  },
	  "NavigationBar": {
	    "color": "0xFF000000",
	    "ForegroundColor": "0xFFFFFFFF",
	    "IsAutoTextColor": true
	  },
	  "Keyboard": {
	    "direction": "SmVert",
	    "keyboardType": "ktLetter"
	  },
	  "TimePicker": {},
	  "TimePicker2": {},
	  "QuickContact": {},
	  "Top ActionBar": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "showMenu": true,
	    "showBack": true,
	    "iconColor": "0xFF000000"
	  },
	  "Contexual ActionBar": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop"
	  },
	  "Slider": {
	    "color": "0xFF41C7DB",
	    "progress": 30
	  },
	  "LetterNavigation": {},
	  "Control PopOver": {
	    "BaseID": "ComTextBase"
	  },
	  "Spinner": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop"
	  },
	  "ScopeBar": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "thickness": 1,
	    "radius": 100,
	    "radiusIsPercent": true,
	    "showHover": false,
	    "hoveredColor": "0x4041C7D6",
	    "selectedTextColor": "0xFF000000"
	  },
	  "TextField": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaBottom",
	    "showIcon": true,
	    "canInput": true,
	    "placeHolder": "",
	    "inputModel": "emText"
	  },
	  "TableView": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "borderStyle": true,
	    "itemHeight": 36,
	    "iconSize": 24,
	    "separatorColor": "0xFF666666",
	    "showSeparator": true,
	    "iconColor": "0xFF666666"
	  },
	  "Tabs": {
	    "BaseID": "ComTextBase",
	    "color": "0x00FFFFFF",
	    "textVAlign": "VaTop",
	    "thickness": 1,
	    "indicatorPercentWidth": 100,
	    "indicatorHeight": 3,
	    "dividerPercentHeight": 50,
	    "dividerColor": "0xFF666666",
	    "selectedTextColor": "0xFF000000"
	  },
	  "PointyButton": {
	    "BaseID": "ComTextBase",
	    "textVAlign": "VaTop",
	    "showMenu": false,
	    "direction": 2
	  },
	  "Webcam": {},
	  "AvatarEx": {
	    "color": "0x70000000",
	    "style": "ibsNone",
	    "textDirection": "MiTextBottom",
	    "iconSize": 24,
	    "showText": true,
	    "showAlarm": false,
	    "AlarmColor": 0,
	    "AlarmText": "",
	    "avatartype": "Contact",
	    "colorstyle": "asNormal",
	    "avatarshapestyle": "asRect",
	    "avatarbordcolor": "0xFF999999",
	    "avatarcolor": "0xFFFFFFFF",
	    "avatarcolorsetisenabled": false,
	    "avatarshapestyleiscircle": false
	  },
	  "AvatarEx2": {
	    "avatarType": "Contact",
	    "avatarBackgroundColor": "0xFF999999",
	    "avatarColorStyle": "asNormal",
	    "avatarShapeStyle": "asRect",
	    "avatarColor": "0xFFFFFFFF",
	    "thickness": 2,
	    "URL": ""
	  },
	  "IconButton2": {
	    "color": "0xFF666666",
	    "style": "ibsCircle",
	    "textDirection": "MiTextBottom",
	    "iconSize": 24,
	    "showText": false,
	    "showAlarm": false,
	    "AlarmColor": 0,
	    "AlarmText": ""
	  },
	  "IconLabel2": {
	    "color": "0xFF666666",
	    "style": "ibsNone",
	    "textDirection": "MiTextBottom",
	    "iconSize": 24,
	    "showText": true,
	    "showAlarm": false,
	    "AlarmColor": 0,
	    "AlarmText": ""
	  },
	  "AlarmIcon2": {
	    "color": "0xFF666666",
	    "style": "ibsNone",
	    "textDirection": "MiTextBottom",
	    "iconSize": 24,
	    "showText": false,
	    "showAlarm": true,
	    "AlarmColor": 0,
	    "AlarmText": ""
	  },
	  "PopupPanel": {
	    "color": "0x70000000",
	    "borderVisible": false,
	    "isBackgroundFade": false,
	    "aniType_Mobile": "aniFade",
	    "aniType": "dnNone",
	    "closeByClickMode": "cmClickOutSizeArea",
	    "closeByKeyModes": "[kmEsc,kmEnter]",
	    "isShowBackground": false,
	    "delayBeforePopup": 0,
	    "aniDuration": 200,
	    "positionPolicy": "ppFree",
	    "positionMargin": 0,
	    "positionScreenMode": "psCenter",
	    "positionComMode": "pcBottom"
	  },
	  "Panel": {
	    "thickness": 1,
	    "dashMode": "SdSolid"
	  },
	  "Border": {
	    "locked": true,
	    "thickness": 1,
	    "dashMode": "SdSolid"
	  },
	  "PopupPanelContent": {
	    "locked": true,
	    "borderVisible": false
	  },
	  "PopupMenu": {
	    "color": "0x70000000",
	    "borderVisible": false,
	    "isBackgroundFade": false,
	    "aniType_Mobile": "aniNone",
	    "aniType": "dnNone",
	    "closeByClickMode": "cmClickAllArea",
	    "closeByKeyModes": "[kmEsc,kmEnter]",
	    "isShowBackground": false,
	    "delayBeforePopup": 0,
	    "aniDuration": 200,
	    "positionPolicy": "ppFree",
	    "positionMargin": 0,
	    "positionScreenMode": "psCenter",
	    "positionComMode": "pcBottom"
	  },
	  "AlertWindow": {
	    "color": "0x70000000",
	    "borderVisible": false,
	    "isBackgroundFade": true,
	    "aniType_Mobile": "aniFade",
	    "aniType": "dnNone",
	    "closeByClickMode": "cmClickOutSizeArea",
	    "closeByKeyModes": "[kmEsc,kmEnter]",
	    "isShowBackground": true,
	    "delayBeforePopup": 0,
	    "aniDuration": 200,
	    "positionPolicy": "ppFree",
	    "positionMargin": 0,
	    "positionScreenMode": "psCenter",
	    "positionComMode": "pcBottom"
	  },
	  "SlidingDrawer": {
	    "color": "0x70000000",
	    "borderVisible": false,
	    "isBackgroundFade": true,
	    "aniType_Mobile": "aniFade",
	    "aniType": "dnNone",
	    "closeByClickMode": "cmClickOutSizeArea",
	    "closeByKeyModes": "[kmEsc,kmEnter]",
	    "isShowBackground": true,
	    "delayBeforePopup": 0,
	    "aniDuration": 200,
	    "positionPolicy": "ppFree",
	    "positionMargin": 0,
	    "positionScreenMode": "psCenter",
	    "positionComMode": "pcBottom",
	    "drawerSlideDirection": "sdLeft"
	  },
	  "ImageSlider": {
	    "isAbandon": true,
	    "aniType": "spaNone",
	    "playInterval": 6000,
	    "indicatorType": "SiRectangle",
	    "indicatorDirection": "sidTop",
	    "animate": "spaNone",
	    "isAutoPlay": false
	  },
	  "ImageCarousel": {
	    "color": "0x00FFFFFF",
	    "borderVisible": false,
	    "selectedIndex": 0,
	    "aniType": "spaNone",
	    "playInterval": 6000,
	    "isAutoPlay": true,
	    "indicatorDirection": "sidBottom",
	    "indicatorType": "SiCircle",
	    "indicatorColor": "0xFFFFFFFF",
	    "isShowIndicator": true,
	    "fitMode": "fmAutoFit"
	  },
	  "ImageBackground": {
	    "color": "0x00000000",
	    "borderVisible": false,
	    "canMove": false,
	    "URL": ""
	  },
	  "StackPanel": {
	    "aniType": "spaNone"
	  },
	  "ContentPanel": {
	    "borderVisible": false,
	    "selectedIndex": 0,
	    "aniType": "spaNone",
	    "playInterval": 6000,
	    "contentLayout": "clAbsolute",
	    "canHoriScroll": false,
	    "canVertScroll": true,
	    "showScrollBars": true
	  },
	  "ScrollArea": {
	    "borderVisible": false
	  },
	  "ScrollViewPort": {
	    "color": "0x00000000",
	    "borderVisible": false,
	    "canMove": false
	  },
	  "ScrollView": {
	    "canHoriScroll": false,
	    "canVertScroll": true,
	    "showScrollBars": true
	  },
	  "ScrollViewContentPanel": {
	    "color": "0x00000000",
	    "locked": true,
	    "borderVisible": false,
	    "borderColor": "0xFF000000"
	  },
	  "Repeater": {
	    "borderVisible": false,
	    "horiGap": 20,
	    "vertGap": 20,
	    borderColor: "#000000"
	  },
	  "Timer": {
	    interval: 1000
	  },
	  "Tabel": {
	    "textWordWrap": true
	  }
	};
	
	function getTempleteByID(controlTypeID) {
	  var prop = {};
	  var propIDChain = [];
	  var currentPropID = controlTypeID;
	  var currentProp;
	  var i;
	
	  while (currentPropID && templete[currentPropID]) {
	
	    propIDChain.push(currentPropID);
	    currentProp = templete[currentPropID];
	    currentPropID = currentProp.BaseID;
	  }
	
	  propIDChain.push("ComBase"); //推入所有组件的基属性
	
	  for (i = propIDChain.length - 1; i >= 0; i--) {
	    _.extend(prop, templete[propIDChain[i]]);
	  }
	
	  delete prop.BaseID;
	  return prop;
	};
	
	exports.initComp = function (comp) {
	  var templete;
	
	  comp.x = parseInt(comp.x, 10);
	  comp.y = parseInt(comp.y, 10);
	  comp.h = parseInt(comp.h, 10);
	  comp.w = parseInt(comp.w, 10);
	
	  if (!comp.text || _.isEmpty(comp.text)) {
	    comp.text = ''; // 组件保存时，如果字符串为空，该属性未保存。
	  }
	  if (comp.remarkText) {
	    if (_.isEmpty(comp.remarkText)) {
	      comp.remarkText = '';
	    }
	
	    comp.remarkText = dataHelper.decodeURI(comp.remarkText);
	  }
	  if (_.isEmpty(comp.externalURL)) {
	    comp.externalURL = '';
	  }
	  if (_.isEmpty(comp.URL)) {
	    comp.URL = '';
	  }
	
	  if (comp) {
	    templete = getTempleteByID(comp.controlTypeID);
	    for (var key in templete) {
	      if (_.isUndefined(comp[key])) {
	        comp[key] = dataHelper.convertValue(key, templete[key]);
	      }
	    }
	  }
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var appTypes = __webpack_require__(115);
	var deviceShellHelper = __webpack_require__(120);
	var _ = __webpack_require__(51);
	var util = __webpack_require__(116);
	
	function doFindComID(controlsNode, ID) {
	  var i;
	  var itemNode;
	  var childNodeResult;
	
	  for (i = 0; i < controlsNode.length; i++) {
	    itemNode = controlsNode[i];
	    if (itemNode.controlID === ID) {
	      return itemNode;
	    }
	
	    if (itemNode.items !== undefined) {
	      childNodeResult = doFindComID(itemNode.items, ID); //这里必须要传ID
	      if (childNodeResult !== null) {
	        return childNodeResult;
	      }
	    }
	  }
	
	  return null;
	}
	
	exports.findComInGroupByID = function (groupNode, comID) {
	  if (groupNode && groupNode.items) {
	    return doFindComID(groupNode.items, comID);
	  }
	  return null;
	};
	
	exports.findComInGroupByAlias = function (groupNode, alias) {
	  var fx = function fx(groupNode, alias) {
	    var item;
	    var i = 0;
	    var l = groupNode.items.length;
	    for (i; i < l; i++) {
	      item = groupNode.items[i];
	      if (item.alias === alias) {
	        return item;
	      } else {
	        if (item.items) {
	          return fx(item, alias);
	        }
	      }
	    }
	    return null;
	  };
	  if (groupNode.items) {
	    return fx(groupNode, alias);
	  }
	  return null;
	};
	
	/**
	 * 根据组件ID号获取组件json数据
	 * @param pageData 页面文档根节点数据
	 * @param ID 带查找的组件ID
	 */
	function getControlDataByComID(pageData, ID) {
	  var controlsNode = pageData.controls;
	  if (controlsNode.control === undefined || ID === '') {
	    return null;
	  }
	
	  return doFindComID(controlsNode.control, ID);
	}
	
	exports.getComAbsoluteRect = function (pageData, comp) {
	
	  function getChildByID(_comp, childID) {
	    var c;
	    var i = 0;
	    if (_comp.items) {
	      for (i; i < _comp.items.length; i++) {
	        c = _comp.items[i];
	        if (c.controlID === childID) {
	          return c;
	        }
	      }
	    }
	    return null;
	  }
	
	  function doGet(_comp) {
	    if (_comp) {
	      rect.left += parseInt(_comp.x, 10);
	      rect.top += parseInt(_comp.y, 10);
	      rect.right = rect.left + parseInt(_comp.w, 10);
	      rect.bottom = rect.top + parseInt(_comp.h, 10);
	      index++;
	      if (index < pathStr.length) {
	        _comp = getChildByID(_comp, pathStr[index]);
	        doGet(_comp);
	      }
	    }
	  }
	
	  var path = comp.parentPath;
	  var rect;
	  var pathStr;
	  var index = 0;
	  if (!path) {
	    path = comp.controlID;
	  } else {
	    path += ',' + comp.controlID;
	  }
	  if (path) {
	    rect = {
	      left: 0,
	      top: 0,
	      right: 0,
	      bottom: 0
	    };
	    pathStr = path.split(',');
	    doGet(getControlDataByComID(pageData, pathStr[0]));
	  }
	  return rect;
	};
	
	exports.updatePageComData = function (pageData, newComData) {
	  function doUpdate(controls) {
	    var i;
	    var controlNode;
	
	    for (i = 0; i < controls.length; i++) {
	      controlNode = controls[i];
	      if (controlNode.controlID === newComData.controlID) {
	        controls[i] = newComData;
	        return;
	      } else {
	        if (controlNode.items) {
	          doUpdate(controlNode.items);
	        }
	      }
	    }
	  }
	
	  if (pageData.controls) {
	    doUpdate(pageData.controls.control);
	  }
	};
	
	exports.updateComData = function (pageData, comID, propertyName, value) {
	  var com = getControlDataByComID(pageData, comID);
	  if (com) {
	    com[propertyName] = value;
	  }
	};
	
	exports.getControlDataByComID = getControlDataByComID;
	
	/**
	 * 判断当前组件是否为交互数据中不可见组件
	 * @param typeID
	 * @constructor
	 * @return {boolean}
	 */
	function IsInvisualInteractiveCom(typeID) {
	
	  //
	  // 目前包含5个组件为不可见交互类型组件，弹出面板，提示面板，弹出面板，抽屉。
	  //
	
	  return typeID === 'PopupPanel' || typeID === 'HoverPanel' || typeID === 'AlertWindow' || typeID === 'PopupMenu' || typeID === 'SlidingDrawer';
	}
	
	exports.IsInvisualInteractiveCom = IsInvisualInteractiveCom;
	
	function isStatusBar(typeID) {
	  return typeID === 'StatusBar(Android)' || typeID === 'StatusBar(IOS)';
	}
	
	exports.isStatusBar = isStatusBar;
	
	function doGetSkipPageID(comArray, pageIDs) {
	  var i;
	  var com;
	  var links;
	  var link;
	  var iLink;
	
	  for (i = 0; i < comArray.length; i++) {
	    com = comArray[i];
	    if (com.links && com.links.link) {
	      links = com.links.link;
	      for (iLink = 0; iLink < links.length; iLink++) {
	        link = links[iLink];
	        if (link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
	          if (pageIDs.indexOf(link.targetPageID) === -1) pageIDs.push(link.targetPageID);
	        }
	      }
	    }
	
	    if (com.items) {
	      doGetSkipPageID(com.items, pageIDs);
	    }
	  }
	}
	
	/**
	 * 获取页面中所有目标页面ID
	 * @param controls ：页面controls根节点
	 */
	exports.getAllSkipPageID = function (controls) {
	  var resultPageIDs = [];
	  var comArray;
	
	  if (controls) {
	    comArray = controls.control;
	    if (comArray) {
	      doGetSkipPageID(comArray, resultPageIDs);
	    }
	  }
	
	  return resultPageIDs;
	};
	
	exports.getPageDeviceMetaInfo = function (page, projectMeta, shell) {
	  var isHorizontal;
	  var shellSize;
	  var shellWidth;
	  var shellHeight;
	  var pagePosition;
	  var defaultPageSize;
	
	  defaultPageSize = util.Point.strToPoint(projectMeta.pageSize);
	
	  if (['iPhone', 'Android', 'Tablet', 'iPad'].indexOf(shell) !== -1) {
	    isHorizontal = page.screenOrientation !== appTypes.ScreenOrientation.PORTRAIT;
	    if (page.screenOrientation !== projectMeta.orientation) {
	      defaultPageSize = {
	        x: defaultPageSize.y,
	        y: defaultPageSize.x
	      };
	    }
	
	    shellSize = deviceShellHelper.getShellComponentSize(shell, isHorizontal);
	    shellWidth = defaultPageSize.x * shellSize.width / shellSize.screenWidth;
	    shellHeight = defaultPageSize.y * shellSize.height / shellSize.screenHeight;
	
	    // 页面相对于device Position位置
	    pagePosition = {
	      x: (shellWidth - defaultPageSize.x) / 2,
	      y: (shellHeight - defaultPageSize.y) / 2
	    };
	  } else if (shell === 'desktop') {
	
	    defaultPageSize = {
	      x: parseInt(page.measureW, 10),
	      y: parseInt(page.measureH, 10)
	    };
	
	    // 桌面项目，上边距30个像素，左，右，下，8个像素
	    shellWidth = defaultPageSize.x + 2 * 8;
	    shellHeight = defaultPageSize.y + 8 + 30;
	
	    pagePosition = {
	      x: 8,
	      y: 30
	    };
	  } else {
	    // 计算自由项目，网页项目，空白项目工作区尺寸宽度与高度。
	    // 目前的方式中，还包含了桌面项目的，此时桌面项目没有包含外边边框。
	
	    shellWidth = defaultPageSize.x;
	    shellHeight = defaultPageSize.y;
	
	    pagePosition = {
	      x: 0,
	      y: 0
	    };
	  }
	
	  if (projectMeta.platform === 'MtWeb' || projectMeta.platform === 'MtCustom') {
	    shellWidth = parseInt(page.measureW, 10);
	    shellHeight = parseInt(page.measureH, 10);
	    defaultPageSize = {
	      x: shellWidth,
	      y: shellHeight
	    };
	  }
	
	  return {
	    width: Math.round(shellWidth),
	    height: Math.round(shellHeight),
	    position: {
	      x: Math.round(pagePosition.x),
	      y: Math.round(pagePosition.y)
	    },
	    pageSize: {
	      x: Math.round(defaultPageSize.x),
	      y: Math.round(defaultPageSize.y)
	    },
	    isHorizontal: isHorizontal
	  };
	};
	
	exports.getPageDeviceMetaInfoForFullPage = function (page, projectMeta, shell) {
	  var isHorizontal;
	  var shellSize;
	  var shellWidth;
	  var shellHeight;
	  var pagePosition;
	  var defaultPageSize;
	
	  defaultPageSize = util.Point.strToPoint(page.measureW + ',' + page.measureH);
	
	  if (['iPhone', 'Android', 'Tablet', 'iPad'].indexOf(shell) !== -1) {
	    isHorizontal = page.screenOrientation !== appTypes.ScreenOrientation.PORTRAIT;
	    if (page.screenOrientation !== projectMeta.orientation) {
	      defaultPageSize = {
	        x: defaultPageSize.y,
	        y: defaultPageSize.x
	      };
	    }
	
	    shellSize = deviceShellHelper.getShellComponentSize(shell, isHorizontal);
	    shellWidth = defaultPageSize.x * shellSize.width / shellSize.screenWidth;
	    shellHeight = defaultPageSize.y * shellSize.height / shellSize.screenHeight;
	
	    // 页面相对于device Position位置
	    pagePosition = {
	      x: (shellWidth - defaultPageSize.x) / 2,
	      y: (shellHeight - defaultPageSize.y) / 2
	    };
	  } else if (shell === 'desktop') {
	
	    defaultPageSize = {
	      x: parseInt(page.measureW, 10),
	      y: parseInt(page.measureH, 10)
	    };
	
	    // 桌面项目，上边距30个像素，左，右，下，8个像素
	    shellWidth = defaultPageSize.x + 2 * 8;
	    shellHeight = defaultPageSize.y + 8 + 30;
	
	    pagePosition = {
	      x: 8,
	      y: 30
	    };
	  } else {
	    // 计算自由项目，网页项目，空白项目工作区尺寸宽度与高度。
	    // 目前的方式中，还包含了桌面项目的，此时桌面项目没有包含外边边框。
	
	    shellWidth = defaultPageSize.x;
	    shellHeight = defaultPageSize.y;
	
	    pagePosition = {
	      x: 0,
	      y: 0
	    };
	  }
	
	  if (projectMeta.platform === 'MtWeb' || projectMeta.platform === 'MtCustom') {
	    shellWidth = parseInt(page.measureW, 10);
	    shellHeight = parseInt(page.measureH, 10);
	    defaultPageSize = {
	      x: shellWidth,
	      y: shellHeight
	    };
	  }
	
	  return {
	    width: Math.round(shellWidth),
	    height: Math.round(shellHeight),
	    position: {
	      x: Math.round(pagePosition.x),
	      y: Math.round(pagePosition.y)
	    },
	    pageSize: {
	      x: Math.round(defaultPageSize.x),
	      y: Math.round(defaultPageSize.y)
	    },
	    isHorizontal: isHorizontal
	  };
	};
	
	exports.getMobileDeviceMetaInfo = function (page, projectMeta) {
	
	  var isHorizontal;
	  var defaultPageSize;
	
	  defaultPageSize = util.Point.strToPoint(projectMeta.pageSize);
	
	  if (projectMeta.platform === appTypes.AppPlatformType.PAD || projectMeta.platform === appTypes.AppPlatformType.MOBILE) {
	    isHorizontal = page.screenOrientation !== appTypes.ScreenOrientation.PORTRAIT;
	    if (page.screenOrientation !== projectMeta.orientation) {
	      defaultPageSize = {
	        x: defaultPageSize.y,
	        y: defaultPageSize.x
	      };
	    }
	  }
	
	  return {
	    pageSize: defaultPageSize,
	    isHorizontal: isHorizontal
	  };
	};
	
	function getLinkAreaArray(componentData) {
	  var i;
	  var link;
	  var linkItem;
	  var resultLinkArray = [];
	
	  var entry;
	  var events;
	
	  /*if (componentData.link && componentData.links.link) {
	      for (i = 0; i < componentData.links.link.length; i++) {
	      link = componentData.links.link[i];
	      linkItem = {};
	        if (link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
	        linkItem.index = i;
	        linkItem.linkCoords = link.area.coores;
	      }
	        if (componentData.interactiveData) {
	        entry = componentData.interactiveData.entry[i];
	        if (entry) {
	          events = entry.events;
	          if (events && events.event && events.event.length) {
	            linkItem.index = i;
	            linkItem.interactiveCoords = entry.area.coords;
	          }
	        }
	      }
	  
	      if (!_.isEmpty(linkItem)) {
	        resultLinkArray.push(linkItem);
	      }
	      } // for
	  }*/
	
	  if (componentData.interactive && componentData.interactive.entry) {
	    for (i = 0; i < componentData.interactive.entry.length; i++) {
	      linkItem = {};
	      entry = componentData.interactive.entry[i];
	      if (entry) {
	        events = entry.events;
	        if (events && events.event && events.event.length) {
	          if (this.isChecked(entry)) {
	            linkItem.index = i;
	            linkItem.interactiveCoords = entry.area.coords;
	          }
	        }
	      }
	
	      resultLinkArray.push(linkItem);
	    }
	  }
	
	  if (componentData.links && componentData.links.link) {
	
	    for (i = 0; i < componentData.links.link.length; i++) {
	      link = componentData.links.link[i];
	      linkItem = resultLinkArray[i] || {};
	
	      if (link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
	        linkItem.index = i;
	        linkItem.linkCoords = link.area.coords;
	      }
	
	      if (!resultLinkArray[i]) {
	        resultLinkArray.push(linkItem);
	      }
	    }
	  }
	
	  return resultLinkArray;
	}
	
	function parseSingleComponentLinkArray(componentData) {
	  var i;
	  var itemsArray;
	  var itemLength;
	
	  componentData.linkArrays = getLinkAreaArray(componentData);
	
	  if (componentData.items) {
	
	    itemsArray = componentData.items;
	    itemLength = itemsArray.length;
	
	    for (i = 0; i < itemLength; i++) {
	      itemsArray[i] = parseSingleComponentLinkArray(componentData.items[i]);
	    }
	  }
	
	  return componentData;
	}
	
	exports.afterLoadPrepareDataStructure = function (page) {
	  var i = 0;
	  var arrayLength;
	
	  if (page.controls.control) {
	    arrayLength = page.controls.control.length;
	
	    for (i = 0; i < arrayLength; i++) {
	      page.controls.control[i] = parseSingleComponentLinkArray(page.controls.control[i]);
	    }
	  }
	
	  return page;
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assetsHelper = __webpack_require__(65);
	
	/**
	 * 获取外壳组件
	 * @param style
	 * @param style.type 风格类型
	 * @param style.name 风格名称
	 * @param isHorizontal 是否是横向
	 * @returns {*}
	 */
	function getShellComponents(style, isHorizontal) {
	  if (style.type === 'wireframe') {
	    if (isHorizontal) {
	      return {
	        top: assetsHelper.getAsset('shell' / +style.name + '/h_top_center_wireframe.png'),
	        bottom: assetsHelper.getAsset('shell/' + style.name + '/h_bottom_center_wireframe.png')
	      };
	    }
	    return {
	      top: assetsHelper.getAsset('shell/' + style.name + '/top_center_wireframe.png'),
	      bottom: assetsHelper.getAsset('shell/' + style.name + '/bottom_center_wireframe.png')
	    };
	  }
	  if (isHorizontal) {
	    return {
	      whole: assetsHelper.getAsset('shell/' + style.name + '/h_whole.png'),
	      top: assetsHelper.getAsset('shell/' + style.name + '/h_top_center.png'),
	      bottom: assetsHelper.getAsset('shell/' + style.name + '/h_bottom_center.png')
	    };
	  }
	  return {
	    whole: assetsHelper.getAsset('shell/' + style.name + '/whole.png'),
	    top: assetsHelper.getAsset('shell/' + style.name + '/top_center.png'),
	    bottom: assetsHelper.getAsset('shell/' + style.name + '/bottom_center.png')
	  };
	}
	
	/**
	 * 获取外壳组件的尺寸
	 * @param styleName
	 * @param isHorizontal
	 * @returns {*}
	 */
	function getShellComponentSize(styleName, isHorizontal) {
	  var config;
	  switch (styleName) {
	    case 'iPhone':
	      config = {
	        width: 854,
	        height: 1771,
	        screenWidth: 760,
	        screenHeight: 1350,
	        xR: 6,
	        yR: 6
	      };
	      break;
	    case 'iPad':
	      config = {
	        width: 1404,
	        height: 2000,
	        screenWidth: 1251,
	        screenHeight: 1666,
	        radius: 16,
	        xR: 16,
	        yR: 16
	      };
	      break;
	    case 'Android':
	      config = {
	        width: 756,
	        height: 1434,
	        screenWidth: 685,
	        screenHeight: 1230,
	        xR: 6,
	        yR: 8
	      };
	      break;
	    case 'Tablet':
	      config = {
	        width: 1009,
	        height: 1633,
	        screenWidth: 892,
	        screenHeight: 1298,
	        xR: 16,
	        yR: 16
	      };
	      break;
	    default:
	      config = {
	        width: 1,
	        height: 1,
	        screenWidth: 1,
	        screenHeight: 1,
	        xR: 1,
	        yR: 1
	      };
	  }
	  if (isHorizontal) {
	    return {
	      width: config.height,
	      height: config.width,
	      screenWidth: config.screenHeight,
	      screenHeight: config.screenWidth,
	      xR: config.yR,
	      yR: config.xR
	    };
	  }
	  return config;
	}
	
	function getShellInfoByPlatform(platform, shell) {
	
	  switch (platform) {
	    case 'MtMobile':
	      if (['iPhone', 'Android'].indexOf(shell) !== -1) {
	        return shell;
	      }
	      return 'iPhone';
	    case 'MtPad':
	      if (['iPad', 'Tablet'].indexOf(shell) !== -1) {
	        return shell;
	      }
	      return 'iPad';
	    case 'MtDesktop':
	      return 'desktop';
	    default:
	      return '';
	  }
	}
	
	module.exports = {
	  getShellComponents: getShellComponents,
	  getShellComponentSize: getShellComponentSize,
	  getShellInfoByPlatform: getShellInfoByPlatform
	};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.newGuid = function () {
	  var n;
	  var i;
	  var guidArray = [];
	
	  for (i = 1; i <= 32; i++) {
	    n = Math.floor(Math.random() * 16.0).toString(16);
	    guidArray.push(n);
	
	    if (i == 8 || i == 12 || i == 16 || i == 20) guidArray.push('-');
	  }
	
	  return guidArray.join('');
	};
	
	exports.extendObj = function (destination) {
	  var resultObj = {};
	  var key;
	  var index;
	  var source;
	
	  if (destination) {
	    for (key in destination) {
	      resultObj[key] = destination[key];
	    }
	  }
	
	  var length = arguments.length;
	  if (length >= 2) {
	    for (index = 1; index < length; index++) {
	      source = arguments[index];
	      for (key in source) {
	        if (source[key] !== undefined) {
	          resultObj[key] = source[key];
	        }
	      }
	    }
	  }
	
	  return resultObj;
	};
	
	var getVertThumb = function getVertThumb(dom) {
	  var scrollView = $(dom).children('.scroll-view').get(0);
	  var track = $(scrollView).children('.scroll-bar-vertical').get(0);
	  var thumb = $(track).children('.thumb').get(0);
	  return thumb;
	};
	
	var getHoriThumb = function getHoriThumb(dom) {
	  var scrollView = $(dom).children('.scroll-view').get(0);
	  var track = $(scrollView).children('.scroll-bar-horizontal').get(0);
	  var thumb = $(track).children('.thumb').get(0);
	  return thumb;
	};
	
	exports.setThumbOpaicty = function (dom, opacity) {
	
	  var vertThumb = getVertThumb(dom);
	  var horiThumb = getHoriThumb(dom);
	
	  if (vertThumb) {
	    $(vertThumb).css('opacity', opacity);
	  }
	  if (horiThumb) {
	    $(horiThumb).css('opacity', opacity);
	  }
	};
	
	exports.getVertThumb = getVertThumb;
	exports.getHoriThumb = getHoriThumb;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.getQueryString = function (k) {
	  var search = window.location.search;
	  if (!search) {
	    return '';
	  } else {
	    search = search.substr(search.indexOf('?') + 1);
	  }
	  console.log(search);
	  var searches = search.split('&');
	  console.log(searches);
	  for (var i = 0; i < searches.length; i++) {
	    var items = searches[i].split('=');
	    if (items.length !== 2) {
	      continue;
	    }
	    if (items[0] === k) {
	      return items[1];
	    }
	  }
	  return '';
	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var i18n = __webpack_require__(46);
	var envHelper = __webpack_require__(48);
	
	var API_BASEURL = 'https://api.mockplus.cn/v7';
	if (envHelper.isEn) {
	  API_BASEURL = 'https://api.mockplus.com/v6';
	} else if (envHelper.isJp) {
	  API_BASEURL = 'http://jpapi.mockplus.com/v6';
	}
	
	if (window.isDev) {
	  API_BASEURL = "http://192.168.2.88:8081/v3";
	}
	
	function get(url, data, onSuccess, onFailed) {
	  $.get(API_BASEURL + url, data).done(function (res) {
	    onSuccess(res);
	  }).fail(function (res) {
	    console.error(res);
	    if (onFailed) {
	      onFailed('Network Error!');
	    }
	    // actionHelper.dispatchAjaxFail(res, dispatch);
	  });
	}
	
	function post(url, data, onSuccess, onFailed) {
	  $.ajax({
	    url: API_BASEURL + url,
	    type: 'POST',
	    contentType: 'application/json',
	    data: JSON.stringify(data),
	    dataType: 'json'
	  }).done(onSuccess).fail(function (res) {
	    console.log(res);
	  }).fail(function (res) {
	    console.log(res);
	    if (onFailed) {
	      onFailed('Network Error!');
	    }
	    // actionHelper.dispatchAjaxFail(res, dispatch);
	  });
	}
	
	function loadResource(path, cb, disableFollow) {
	
	  var params;
	  if (envHelper.isEnOrJp) {
	    // AWS 使用 withCredentials 的时候有问题，所以需要区分开
	    params = {
	      url: path,
	      dataType: 'text'
	    };
	  } else {
	    params = {
	      url: path,
	      dataType: 'text',
	      xhrFields: {
	        withCredentials: true
	      }
	    };
	  }
	  $.ajax(params).done(function (data, status, jqXHR) {
	    if (jqXHR.status === 201) {
	      if (!disableFollow) {
	        loadResource(data, cb, true);
	      } else {
	        cb('Sorry, fail to load data.', '', jqXHR.status);
	      }
	    } else {
	      cb(null, data, jqXHR.status);
	    }
	  }).fail(function (jqXHR) {
	    cb({ message: i18n.get('REQUEST_SOURCE_ERROR') }, '', jqXHR.status);
	  });
	}
	
	module.exports = {
	  get: get,
	  post: post,
	  loadResource: loadResource
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 版本号比较
	// 例如： 1.0 应该小于 2.0
	// 1.0 应该小于 1.0.1
	// 注意：1.0 应该小于 1.0.0
	
	var cacheHelper = __webpack_require__(125);
	
	function compareVersion(v1, v2) {
	  var v1Arr = v1.split('.');
	  var v2Arr = v2.split('.');
	  var a, b;
	
	  if (v1Arr.length > v2Arr.length) {
	    return 1;
	  }
	  if (v1Arr.length < v2Arr.length) {
	    return -1;
	  }
	
	  for (var i = 0; i < v1Arr.length; i++) {
	    a = parseInt(v1Arr[i], 10);
	    b = parseInt(v2Arr[i], 10);
	
	    if (a === b) {
	      // 此位相等，进行下一轮
	      continue;
	    }
	    return a - b;
	  }
	}
	
	/**
	 * src 版本是否低于 dest 版本
	 * @param src
	 * @param dest
	 */
	exports.isLowerThan = function (src, dest) {
	  return compareVersion(src, dest) < 0;
	};
	
	/**
	 * src 版本是否高于 dest 版本
	 * @param src
	 * @param dest
	 */
	exports.isGreatterThan = function (src, dest) {
	  return compareVersion(src, dest) > 0;
	};
	
	/**
	 * 当前页面版本号是否小于 4.3
	 * 此版本位桌面端的 2.2.9 版本，对多个组件属性进行了调整，并且修改了 iPhone, Android, iPad, Tablet 几个组件的渲染效果
	 */
	exports.isPageVersionLowerThan4_3 = function () {
	  var ver = cacheHelper.cache(cacheHelper.keys.PAGE_VERSION);
	  return compareVersion(ver, '4.3') < 0;
	};
	/**
	 * 当前页面版本号是否小于 4.5
	 * 此版本位桌面端的 2.3.8 版本，扩展了图表和树组件
	 */
	exports.isPageVersionLowerThan4_5 = function () {
	  var ver = cacheHelper.cache(cacheHelper.keys.PAGE_VERSION);
	  return compareVersion(ver, '4.5') < 0;
	};
	/**
	 * 当前页面版本号是否小于 4.9
	 * 此版本位桌面端的 3.2.6 版本，此版本修改了母版可见性问题
	 */
	exports.isPageVersionLowerThan4_9 = function () {
	  var ver = cacheHelper.cache(cacheHelper.keys.PAGE_VERSION);
	  return compareVersion(ver, '4.9') < 0;
	};
	
	/**
	 * 判断是否是移动项目
	 * @returns {boolean}
	 */
	exports.isMobileApp = function () {
	  var platform = cacheHelper.cache(cacheHelper.keys.PLATFORM);
	  return platform === 'MtMobile' || platform === 'MtPad';
	};

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	'use strict';
	
	/// 缓存管理
	
	var cache = {};
	
	exports.cache = function (k, v) {
	  if (v === undefined) {
	    return cache[k];
	  }
	  cache[k] = v;
	  return v;
	};
	
	exports.keys = {
	  PROJECT_VERSION: 'PROJECT_VERSION',
	  PAGE_VERSION: 'PAGE_VERSION',
	  PLATFORM: 'PLATFORM'
	};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Redux = __webpack_require__(23);
	var thunk = __webpack_require__(127);
	
	var AppReducer = __webpack_require__(128);
	
	var createStoreWithMiddleware = Redux.applyMiddleware(thunk)(Redux.createStore);
	
	var configureStore = function configureStore(initialState) {
	  return createStoreWithMiddleware(AppReducer, initialState);
	};
	
	module.exports = configureStore;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	'use strict';
	
	function thunkMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function (action) {
	      return typeof action === 'function' ? action(dispatch, getState) : next(action);
	    };
	  };
	}
	
	module.exports = thunkMiddleware;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ActionTypes = __webpack_require__(129);
	var storeHelper = __webpack_require__(49);
	
	function app(state, action) {
	  var payload = action.payload;
	  switch (action.type) {
	    case ActionTypes.PROJECT_LOAD_DONE:
	      return payload;
	    default:
	      return state || null;
	  }
	}
	
	function current(state, action) {
	  var payload = action.payload;
	  switch (action.type) {
	    case ActionTypes.PAGE_LOAD_DONE:
	      return payload;
	    case ActionTypes.FINISH_OPEN_PAGE:
	      return payload;
	    default:
	      return state || null;
	  }
	}
	
	function animation(state, action) {
	  var payload = action.payload;
	  switch (action.type) {
	    case ActionTypes.PAGE_REDIRECT_DONE:
	      return payload.animation;
	    case ActionTypes.PAGE_LOAD_DONE:
	      // 如果是要求打开页面了, 那么动画应该置为空了
	      return null;
	    case ActionTypes.FINISH_OPEN_PAGE:
	      return null;
	    default:
	      return state;
	  }
	}
	
	function target(state, action) {
	  var payload = action.payload;
	  switch (action.type) {
	    case ActionTypes.PAGE_REDIRECT_DONE:
	      return payload.page;
	    case ActionTypes.PAGE_LOAD_DONE:
	      // 如果是要求打开页面了, 那么目标页面就应该置为空了
	      return null;
	    case ActionTypes.FINISH_OPEN_PAGE:
	      return null;
	    default:
	      return state;
	  }
	}
	
	function config(state, action) {
	  return state;
	}
	
	function review(state, action) {
	  var payload = action.payload;
	  switch (action.type) {
	    case ActionTypes.LOAD_REVIEW_DATA_REQUEST:
	      storeHelper.set('loadState', 'wait');
	      return [];
	    case ActionTypes.LOAD_REVIEW_DATA_DONE:
	      storeHelper.set('loadState', 'done');
	      return payload;
	    case ActionTypes.LOAD_REVIEW_DATA_FAIL:
	      storeHelper.set('loadState', 'failed');
	      return [];
	    case ActionTypes.ADD_REVIEW_REQUEST:
	      storeHelper.set('saveState', 'wait');
	      return state || [];
	    case ActionTypes.ADD_REVIEW_DONE:
	      storeHelper.set('saveState', 'done');
	      state.push(payload);
	      return state;
	    case ActionTypes.ADD_REVIEW_FAIL:
	      storeHelper.set('saveState', 'failed');
	      return state || [];
	    case ActionTypes.UPDATE_REVIEW_REQUEST:
	      storeHelper.set('saveState', 'wait');
	      return state || [];
	    case ActionTypes.UPDATE_REVIEW_DONE:
	      storeHelper.set('saveState', 'done');
	      for (var i = 0; i < state.length; i++) {
	        if (state[i].id === payload.id) {
	          state[i] = payload;
	          break;
	        }
	      }
	      return state;
	    case ActionTypes.UPDATE_REVIEW_FAIL:
	      storeHelper.set('saveState', 'failed');
	      return state || [];
	    case ActionTypes.REMOVE_REVIEW_REQUEST:
	      storeHelper.set('saveState', 'wait');
	      return state || [];
	    case ActionTypes.REMOVE_REVIEW_DONE:
	      storeHelper.set('saveState', 'done');
	      for (var i = 0; i < state.length; i++) {
	        if (state[i].id === payload) {
	          state.splice(i, 1);
	          break;
	        }
	      }
	      return state;
	    case ActionTypes.REMOVE_REVIEW_FAIL:
	      storeHelper.set('saveState', 'failed');
	      return state || [];
	  }
	  return state || [];
	}
	
	function comments(state, action) {
	  var payload = action.payload;
	  switch (action.type) {
	    case ActionTypes.LOAD_COMMENT_DATA_FAIL:
	      return [];
	    case ActionTypes.LOAD_COMMENT_DATA_DONE:
	      return payload;
	    case ActionTypes.LOAD_COMMENT_DATA_REQUEST:
	      return [];
	    case ActionTypes.ADD_COMMENT_DONE:
	      state.push(payload);
	      return state;
	  }
	  return state || [];
	}
	
	function error(state, action) {
	  var payload = action.payload;
	  storeHelper.set('netState', 'init');
	  switch (action.type) {
	    case ActionTypes.CONNECT_NET_FAIL:
	      storeHelper.set('netState', 'failed');
	      return payload;
	    case ActionTypes.ERROR:
	      return payload;
	    case ActionTypes.CLEAR_ERROR:
	      return '';
	  }
	  return state;
	}
	
	function appReviews(state, action) {
	  var payload = action.payload;
	  switch (action.type) {
	    case ActionTypes.LOAD_PROJECT_REVIEWS_DONE:
	      return payload;
	    case ActionTypes.LOAD_PROJECT_REVIEWS_REQUEST:
	      return [];
	    case ActionTypes.LOAD_PROJECT_REVIEWS_FAIL:
	      return [];
	  }
	  return state || [];
	}
	
	module.exports = function (state, action) {
	  return {
	    app: app(state.app, action),
	    current: current(state.current, action),
	    target: target(state.target, action),
	    animation: animation(state.animation, action),
	    config: config(state.config, action),
	    review: review(state.review, action),
	    comments: comments(state.comments, action),
	    error: error(state.error, action),
	    appReviews: appReviews(state.appReviews, action)
	  };
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keyMirror = __webpack_require__(130);
	
	var ActionTypes = keyMirror({
	  PROJECT_LOAD: null,
	  PROJECT_LOAD_REQUEST: null,
	  PROJECT_LOAD_DONE: null,
	  PROJECT_LOAD_FAIL: null,
	
	  PAGE_LOAD: null,
	  PAGE_LOAD_REQUEST: null,
	  PAGE_LOAD_DONE: null,
	  PAGE_LOAD_FAIL: null,
	
	  FINISH_OPEN_PAGE: null,
	
	  PAGE_REDIRECT: null,
	  PAGE_REDIRECT_REQUEST: null,
	  PAGE_REDIRECT_DONE: null,
	  PAGE_REDIRECT_FAIL: null,
	
	  CONNECT_NET_FAIL: null,
	
	  LOAD_REVIEW_DATA_REQUEST: null,
	  LOAD_REVIEW_DATA_DONE: null,
	  LOAD_REVIEW_DATA_FAIL: null,
	
	  ADD_REVIEW_REQUEST: null,
	  ADD_REVIEW_DONE: null,
	  ADD_REVIEW_FAIL: null,
	
	  ADD_COMMENT_REQUEST: null,
	  ADD_COMMENT_DONE: null,
	  ADD_COMMENT_FAIL: null,
	
	  LOAD_COMMENT_DATA_REQUEST: null,
	  LOAD_COMMENT_DATA_DONE: null,
	  LOAD_COMMENT_DATA_FAIL: null,
	
	  UPDATE_REVIEW_REQUEST: null,
	  UPDATE_REVIEW_DONE: null,
	  UPDATE_REVIEW_FAIL: null,
	
	  REMOVE_REVIEW_REQUEST: null,
	  REMOVE_REVIEW_DONE: null,
	  REMOVE_REVIEW_FAIL: null,
	
	  ERROR: null,
	  CLEAR_ERROR: null,
	
	  LOAD_PROJECT_REVIEWS: null,
	  LOAD_PROJECT_REVIEWS_REQUEST: null,
	  LOAD_PROJECT_REVIEWS_DONE: null,
	  LOAD_PROJECT_REVIEWS_FAIL: null
	});
	
	module.exports = ActionTypes;

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 */
	
	"use strict";
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  if (!(obj instanceof Object && !Array.isArray(obj))) {
	    throw new Error('keyMirror(...): Argument must be an object.');
	  }
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var projectLoadHelper = __webpack_require__(68);
	var i18n = __webpack_require__(46);
	
	var Authorization = React.createClass({
	  displayName: 'Authorization',
	
	  getInitialState: function getInitialState() {
	    return {
	      error: ''
	    };
	  },
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'authorization' },
	      React.createElement(
	        'h3',
	        null,
	        i18n.get('ENTER_PASSWORD')
	      ),
	      React.createElement(
	        'div',
	        { className: 'verify' },
	        React.createElement(
	          'div',
	          { className: 'pwd-input' },
	          React.createElement('input', { ref: 'pwd', type: 'text', placeholder: i18n.get('PASSWORD') }),
	          React.createElement(
	            'button',
	            { onClick: this.auth },
	            i18n.get('VALIDATE')
	          ),
	          React.createElement(
	            'p',
	            { className: 'error' },
	            this.state.error,
	            '\xA0'
	          )
	        )
	      )
	    );
	  },
	  auth: function auth() {
	    var pwdInput = ReactDOM.findDOMNode(this.refs.pwd);
	    var pwd = pwdInput.value;
	    var self = this;
	    if (!pwd) {
	      this.setState({
	        error: i18n.get('PASSWORD_CANNOT_BE_EMPTY')
	      });
	      return;
	    }
	
	    this.setState({
	      error: ''
	    }, function () {
	      projectLoadHelper.auth(pwd, function (err, res) {
	        if (err) {
	          self.setState({
	            error: res.statusCode === 401 ? i18n.get('WRONG_PASSWORD') : err.message
	          });
	          return;
	        }
	        self.setState({
	          error: i18n.get('RIGHT_PASSWORD')
	        }, function () {
	          setTimeout(function () {
	            window.location.reload();
	          }, 100);
	        });
	      });
	    });
	  }
	});
	
	module.exports = Authorization;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var connect = __webpack_require__(13).connect;
	var Actions = __webpack_require__(133);
	var domHelper = __webpack_require__(135);
	var pageHelper = __webpack_require__(119);
	var PreviewMixin = __webpack_require__(137);
	var _ = __webpack_require__(51);
	
	var MainStage = __webpack_require__(138);
	var MobilePreviewPanel = __webpack_require__(328);
	var ControlBall = __webpack_require__(331);
	var cacheHelper = __webpack_require__(125);
	
	var MobilePreview = React.createClass({
	  displayName: 'MobilePreview',
	
	  propTypes: {
	    current: React.PropTypes.object,
	    target: React.PropTypes.object,
	    animation: React.PropTypes.object,
	    path: React.PropTypes.string.isRequired,
	    onOpenPage: React.PropTypes.func.isRequired,
	    onFinishOpenPage: React.PropTypes.func.isRequired
	  },
	  mixins: [PreviewMixin],
	  getInitialState: function getInitialState() {
	    var config = this.props.config;
	    var platform = this.props.app.params.projectParam.platform;
	    return _.extend(config, {
	      domSize: domHelper.getDocumentSize(),
	      showPanel: false,
	      canFix: platform === 'MtMobile' || platform === 'MtPad'
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.props.onLoadApp(this.props.app);
	    domHelper.onDocumentResize(this.onDomSizeChange);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    domHelper.offDocumentResize(this.onDomSizeChange);
	  },
	  onDomSizeChange: function onDomSizeChange() {
	    this.setState({
	      domSize: domHelper.getDocumentSize()
	    });
	  },
	  render: function render() {
	    var currentPage;
	    var pageMetaInfo;
	    var scale;
	    var previewStyle;
	    var toHeight;
	    var previewPanelBackgroundStyle = {};
	    if (!this.props.current) {
	      return React.createElement(
	        'div',
	        { className: 'preview-loading' },
	        React.createElement('img', { width: '120', height: '120', src: this.state.logo, alt: 'Mockplus' })
	      );
	    }
	
	    currentPage = this.props.current;
	    pageMetaInfo = pageHelper.getMobileDeviceMetaInfo(currentPage, this.props.meta);
	
	    scale = this.state.domSize.width / pageMetaInfo.pageSize.x;
	    // scale = 1;
	    toHeight = this.state.domSize.height / scale;
	    previewStyle = {
	      transform: 'scale(' + scale + ')',
	      left: 0,
	      top: 10
	    };
	
	    if (!this.state.showPanel) {
	      previewPanelBackgroundStyle.display = 'none';
	    }
	    return React.createElement(
	      'div',
	      { className: 'mobile-preview', onClick: this._onPreviewClick },
	      React.createElement('div', { style: previewPanelBackgroundStyle, className: 'mobile-preview-panel-background',
	        onClick: this.onTogglePanel }),
	      React.createElement(MobilePreviewPanel, {
	        app: this.props.app,
	        current: this.props.current,
	        showPanel: this.state.showPanel,
	        onOpenPage: this.onOpenPageFromPanel
	      }),
	      this.props.config.isShowPreviewTools && React.createElement(ControlBall, { onTogglePanel: this.onTogglePanel, domSize: this.state.domSize }),
	      React.createElement(
	        'div',
	        { className: 'scale-container', style: previewStyle },
	        React.createElement(MainStage, {
	          current: this.props.current,
	          target: this.props.target,
	          onOpenPage: this.openPage,
	          onFinishOpenPage: this.onFinishOpenPage,
	          onRedirectTo: this.redirectTo,
	          animation: this.props.animation,
	          canFix: this.state.canFix,
	          size: {
	            width: pageMetaInfo.pageSize.x,
	            height: toHeight
	          },
	          domSize: {
	            width: pageMetaInfo.pageSize.x,
	            height: toHeight
	          },
	          showComments: false,
	          onShowRemark: this.fakeMethod,
	          orientation: this.props.meta.orientation,
	          pageNeedRerender: true
	        })
	      )
	    );
	  },
	  /**
	   * 点击空白处，闪烁提示链接
	   * @private
	   */
	  _onPreviewClick: function _onPreviewClick(e) {
	    if (this.props.config.hintLinks) {
	      var $this = $(ReactDOM.findDOMNode(this));
	      $this.addClass('click-show-links');
	      setTimeout(function () {
	        $this.removeClass('click-show-links');
	      }, 800);
	    }
	  },
	  onTogglePanel: function onTogglePanel() {
	    this.setState({
	      showPanel: !this.state.showPanel
	    });
	  },
	  onOpenPageFromPanel: function onOpenPageFromPanel(pageID) {
	    var self = this;
	    this.setState({
	      showPanel: false
	    }, function () {
	      setTimeout(function () {
	        self.props.onOpenPage(pageID);
	      }, 200);
	    });
	  },
	  fakeMethod: function fakeMethod() {},
	  onFinishOpenPage: function onFinishOpenPage() {
	    this.props.onFinishOpenPage(this.props.target);
	  }
	});
	
	function mapStateToProps(state) {
	  cacheHelper.cache(cacheHelper.keys.PROJECT_VERSION, state.app && state.app.params.projectParam.version);
	  cacheHelper.cache(cacheHelper.keys.PAGE_VERSION, state.app && state.app.params.pageParam.version);
	  cacheHelper.cache(cacheHelper.keys.PLATFORM, state.app && state.app.params.projectParam.platform);
	  return {
	    app: state.app,
	    meta: state.app && state.app.params.projectParam,
	    current: state.current,
	    target: state.target,
	    animation: state.animation,
	    config: state.config
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    onLoadApp: function onLoadApp(path) {
	      dispatch(Actions.loadApp(path));
	    },
	    onOpenPage: function onOpenPage(id) {
	      dispatch(Actions.openPage(id));
	    },
	    onFinishOpenPage: function onFinishOpenPage(targetPage) {
	      dispatch(Actions.finishOpenPage(targetPage));
	    },
	    onRedirectTo: function onRedirectTo(id, animation) {
	      dispatch(Actions.redirectPage(id, animation));
	    }
	  };
	}
	
	module.exports = connect(mapStateToProps, mapDispatchToProps)(MobilePreview);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ActionTypes = __webpack_require__(129);
	var projectLoadHelper = __webpack_require__(68);
	var _ = __webpack_require__(51);
	var logHelper = __webpack_require__(134);
	var apiHelper = __webpack_require__(123);
	
	function preLoadPage(id, cb) {
	  projectLoadHelper.loadPage(id, function (err, page) {
	    cb();
	    if (err) {
	      console.log(err);
	      return;
	    }
	    if (!page) {
	      console.warn('Cannot find this page', id);
	    }
	  });
	}
	
	function preLoadPages(IDs) {
	  if (IDs.length === 0) {
	    return;
	  }
	  var toLoadPageID = IDs.shift();
	  preLoadPage(toLoadPageID, function () {
	    setTimeout(function () {
	      preLoadPages(IDs);
	    }, 50);
	  });
	}
	
	function findAllPageIDs(pages) {
	  var IDs = [];
	  _.each(pages, function (page) {
	    if (!page.isModule) {
	      IDs.push(page.ID);
	    }
	    if (page._pages) {
	      IDs = IDs.concat(findAllPageIDs(page._pages));
	    }
	  });
	  return IDs;
	}
	
	function preLoadAppPages(app) {
	  var IDs = findAllPageIDs(app.modules._pages);
	  preLoadPages(IDs);
	}
	
	function loadApp(app) {
	  return function (dispatch) {
	    dispatch(openPage(projectLoadHelper.getAppFirstPage(), function () {
	      preLoadAppPages(app);
	    }));
	  };
	}
	
	function openPage(id, cb) {
	  var start = Date.now();
	  return function (dispatch) {
	    dispatch(openPageRequest(id));
	    projectLoadHelper.loadPage(id, function (err, page) {
	      if (err) {
	        dispatch(openPageFail(err));
	        return;
	      }
	      if (!page) {
	        alert('Cannot find this page');
	      }
	      page.ID = id;
	      logHelper.logPageRead(id, page.title, Date.now() - start);
	      dispatch(openPageDone(page));
	      if (cb) {
	        cb(err, page);
	      }
	    });
	  };
	}
	
	function openPageRequest(id) {
	  return {
	    type: ActionTypes.PAGE_LOAD_REQUEST,
	    payload: id
	  };
	}
	
	function openPageDone(page) {
	  return {
	    type: ActionTypes.PAGE_LOAD_DONE,
	    payload: page
	  };
	}
	
	function openPageFail(err) {
	  return {
	    type: ActionTypes.PAGE_LOAD_FAIL,
	    payload: err
	  };
	}
	
	function finishOpenPage(targetPage) {
	  return {
	    type: ActionTypes.FINISH_OPEN_PAGE,
	    payload: targetPage
	  };
	}
	
	function redirectPage(id, animation) {
	  return function (dispatch) {
	    dispatch(redirectPageRequest(id));
	    projectLoadHelper.loadPage(id, function (err, page) {
	      if (err) {
	        console.log(err);
	        dispatch(redirectPageFail(err));
	        return;
	      }
	      if (!page) {
	        alert('Cannot find this page');
	      }
	      page.ID = id;
	      dispatch(redirectPageDone(page, animation));
	    });
	  };
	}
	
	function redirectPageRequest(id) {
	  return {
	    type: ActionTypes.PAGE_REDIRECT_REQUEST,
	    payload: id
	  };
	}
	
	function redirectPageDone(page, animation) {
	  return {
	    type: ActionTypes.PAGE_REDIRECT_DONE,
	    payload: {
	      page: page,
	      animation: animation
	    }
	  };
	}
	
	function redirectPageFail(err) {
	  return {
	    type: ActionTypes.PAGE_REDIRECT_FAIL,
	    payload: err
	  };
	}
	
	function addComment(syncID, syncVersion, pageID, pageName, author, content) {
	  return function (dispatch) {
	    dispatch(addCommentRequest());
	    apiHelper.post('/review/addcomment', {
	      syncID: syncID,
	      syncVersion: syncVersion,
	      pageID: pageID,
	      pageName: pageName,
	      author: author,
	      content: content
	    }, function (res) {
	      if (res.code === 0) {
	        dispatch(addCommentDone(res.payload));
	        return;
	      }
	      dispatch(addCommentFail(res.message));
	    }, function (msg) {
	      dispatch(connectNetFail(msg));
	    });
	  };
	}
	
	function addCommentRequest() {
	  return {
	    type: ActionTypes.ADD_COMMENT_REQUEST,
	    payload: {}
	  };
	}
	
	function addCommentDone(payload) {
	  return {
	    type: ActionTypes.ADD_COMMENT_DONE,
	    payload: payload
	  };
	}
	
	function addCommentFail(error) {
	  return {
	    type: ActionTypes.ADD_COMMENT_FAIL,
	    payload: error
	  };
	}
	
	function connectNetFail(error) {
	  return {
	    type: ActionTypes.CONNECT_NET_FAIL,
	    payload: error
	  };
	}
	
	function loadReviewData(syncID, syncVersion, pageID) {
	  return function (dispatch) {
	    dispatch(loadReviewDataRequest());
	    apiHelper.get('/review/getreviewdata', {
	      syncID: syncID,
	      syncVersion: syncVersion,
	      pageID: pageID
	    }, function (res) {
	      if (res.code === 0) {
	        return dispatch(loadReviewDataDone(res.payload));
	      }
	      return dispatch(loadReviewdataFail(res.message));
	    }, function (msg) {
	      return dispatch(connectNetFail(msg));
	    });
	  };
	}
	
	function loadReviewDataRequest() {
	  return {
	    type: ActionTypes.LOAD_REVIEW_DATA_REQUEST,
	    payload: {}
	  };
	}
	
	function loadReviewDataDone(data) {
	  return {
	    type: ActionTypes.LOAD_REVIEW_DATA_DONE,
	    payload: data
	  };
	}
	
	function loadReviewdataFail(error) {
	  return {
	    type: ActionTypes.LOAD_REVIEW_DATA_FAIL,
	    payload: error
	  };
	}
	
	function addReview(syncID, syncVersion, pageID, pageName, author, data) {
	  return function (dispatch) {
	    dispatch(addReviewRequest());
	    apiHelper.post('/review/addreview', {
	      syncID: syncID,
	      syncVersion: syncVersion,
	      pageID: pageID,
	      pageName: pageName,
	      author: author,
	      data: data
	    }, function (res) {
	      if (res.code === 0) {
	        return dispatch(addReviewDone(res.payload));
	      }
	      return dispatch(addReviewFail(res.message));
	    }, function (msg) {
	      return dispatch(connectNetFail(msg));
	    });
	  };
	}
	
	function addReviewRequest() {
	  return {
	    type: ActionTypes.ADD_REVIEW_REQUEST,
	    payload: {}
	  };
	}
	
	function addReviewDone(data) {
	  return {
	    type: ActionTypes.ADD_REVIEW_DONE,
	    payload: data
	  };
	}
	
	function addReviewFail(error) {
	  return {
	    type: ActionTypes.ADD_REVIEW_FAIL,
	    payload: error
	  };
	}
	
	function loadComment(syncID, syncVersion, pageID) {
	  return function (dispatch) {
	    dispatch(loadCommentRequest());
	    apiHelper.get('/review/getcomments', {
	      syncID: syncID,
	      syncVersion: syncVersion,
	      pageID: pageID
	    }, function (res) {
	      if (res.code === 0) {
	        dispatch(loadCommentDone(res.payload));
	        return;
	      }
	      return dispatch(loadCommentFail(res.message));
	    });
	  };
	}
	
	function loadCommentRequest() {
	  return {
	    type: ActionTypes.LOAD_COMMENT_DATA_REQUEST,
	    payload: {}
	  };
	}
	
	function loadCommentDone(payload) {
	  return {
	    type: ActionTypes.LOAD_COMMENT_DATA_DONE,
	    payload: payload
	  };
	}
	
	function loadCommentFail(error) {
	  return {
	    type: ActionTypes.LOAD_COMMENT_DATA_FAIL,
	    payload: error
	  };
	}
	
	function updateReview(syncID, syncVersion, pageID, author, id, data) {
	  return function (dispatch) {
	    dispatch(updateReviewRequest());
	    apiHelper.post('/review/updatereview', {
	      syncID: syncID,
	      syncVersion: syncVersion,
	      pageID: pageID,
	      author: author,
	      reviewID: id,
	      data: data
	    }, function (res) {
	      if (res.code === 0) {
	        dispatch(updateReviewDone(res.payload));
	        return;
	      }
	      dispatch(updateReviewFail());
	      //return dispatch(addReviewFail('test error'));
	    }, function (msg) {
	      return dispatch(connectNetFail(msg));
	    });
	  };
	}
	
	function updateReviewRequest() {
	  return {
	    type: ActionTypes.UPDATE_REVIEW_REQUEST,
	    payload: {}
	  };
	}
	
	function updateReviewDone(payload) {
	  return {
	    type: ActionTypes.UPDATE_REVIEW_DONE,
	    payload: payload
	  };
	}
	
	function updateReviewFail() {
	  return {
	    type: ActionTypes.UPDATE_REVIEW_FAIL,
	    payload: {}
	  };
	}
	
	function removeReview(syncID, syncVersion, pageID, author, id) {
	  return function (dispatch) {
	    dispatch(removeReviewRequest());
	    apiHelper.post('/review/remove', {
	      syncID: syncID,
	      syncVersion: syncVersion,
	      pageID: pageID,
	      author: author,
	      reviewID: id
	    }, function (res) {
	      if (res.code === 0) {
	        return dispatch(removeReviewDone(id));
	      }
	      dispatch(removeReviewFail());
	    }, function (msg) {
	      return dispatch(connectNetFail(msg));
	    });
	  };
	}
	
	function removeReviewRequest() {
	  return {
	    type: ActionTypes.REMOVE_REVIEW_REQUEST,
	    payload: {}
	  };
	}
	
	function removeReviewDone(id) {
	  return {
	    type: ActionTypes.REMOVE_REVIEW_DONE,
	    payload: id
	  };
	}
	
	function removeReviewFail() {
	  return {
	    type: ActionTypes.REMOVE_REVIEW_FAIL,
	    payload: {}
	  };
	}
	
	function showError(error) {
	  return {
	    type: ActionTypes.ERROR,
	    payload: error
	  };
	}
	
	function clearError() {
	  return {
	    type: ActionTypes.CLEAR_ERROR,
	    payload: {}
	  };
	}
	
	function loadProjectReviews(syncID) {
	  return function (dispatch) {
	    dispatch(loadProjectReviewsRequest());
	    apiHelper.get('/review/allreviews', {
	      id: syncID
	    }, function (res) {
	      if (res.code === 0) {
	        dispatch(loadProjectReviewsDone(res.payload));
	        return;
	      }
	      dispatch(loadProjecReviewsFail(res.message));
	    });
	  };
	}
	
	function loadProjectReviewsRequest() {
	  return {
	    type: ActionTypes.LOAD_PROJECT_REVIEWS_REQUEST,
	    payload: {}
	  };
	}
	
	function loadProjectReviewsDone(payload) {
	  return {
	    type: ActionTypes.LOAD_PROJECT_REVIEWS_DONE,
	    payload: payload
	  };
	}
	
	function loadProjecReviewsFail(error) {
	  return {
	    type: ActionTypes.LOAD_PROJECT_REVIEWS_FAIL,
	    payload: error
	  };
	}
	
	module.exports = {
	  loadApp: loadApp,
	  openPage: openPage,
	  finishOpenPage: finishOpenPage,
	  redirectPage: redirectPage,
	  loadReviewData: loadReviewData,
	  addReview: addReview,
	  addComment: addComment,
	  loadComment: loadComment,
	  updateReview: updateReview,
	  removeReview: removeReview,
	  showError: showError,
	  clearError: clearError,
	  loadProjectReviews: loadProjectReviews
	};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(51);
	
	var componentRenderLogs = {};
	var pageRenderLogs = {};
	var pageReadLogs = {};
	
	var callbacks = [];
	var timer = null;
	
	function notify() {
	  if (!window.debug) {
	    return;
	  }
	  clearTimeout(timer);
	  timer = setTimeout(function () {
	    var sortedComponentRenderLogs = sortLogsByAverageTime(componentRenderLogs);
	    var sortedPageRenderLogs = sortLogsByAverageTime(pageRenderLogs);
	    var sortedPageReadLogs = sortLogsByTime(pageReadLogs);
	    _.each(callbacks, function (cb) {
	      cb(sortedComponentRenderLogs, sortedPageRenderLogs, sortedPageReadLogs);
	    });
	  }, 100);
	}
	
	function sortLogsByAverageTime(arr) {
	  var res = [];
	  _.each(arr, function (v, k) {
	    res.push([k, v.count, Math.floor(v.time / v.count), v.name]);
	  });
	  return res.sort(function (a, b) {
	    return b[2] - a[2];
	  });
	}
	
	function sortLogsByTime(arr) {
	  var res = [];
	  _.each(arr, function (v, k) {
	    res.push([k, v.count, v.time, v.name]);
	  });
	  return res.sort(function (a, b) {
	    return b[2] - a[2];
	  });
	}
	
	exports.reset = function () {
	  componentRenderLogs = {};
	  pageRenderLogs = {};
	  pageReadLogs = {};
	  notify();
	};
	
	exports.addCallback = function (cb) {
	  callbacks.push(cb);
	};
	
	exports.removeCallback = function (cb) {
	  callbacks.splice(callbacks.indexOf(cb), 1);
	};
	
	exports.logComponentRender = function (controlTypeID, time) {
	  if (!window.debug) {
	    return;
	  }
	  if (componentRenderLogs[controlTypeID]) {
	    componentRenderLogs[controlTypeID].time = componentRenderLogs[controlTypeID].time + time;
	    componentRenderLogs[controlTypeID].count++;
	  } else {
	    componentRenderLogs[controlTypeID] = {
	      time: time,
	      count: 1
	    };
	  }
	  notify();
	};
	
	exports.logPageRender = function (pageID, pageName, time) {
	  if (!window.debug) {
	    return;
	  }
	  if (!pageRenderLogs[pageID]) {
	    pageRenderLogs[pageID] = {
	      name: pageName,
	      time: 0,
	      count: 0
	    };
	  }
	  pageRenderLogs[pageID].time += time;
	  pageRenderLogs[pageID].count++;
	  notify();
	};
	
	exports.logPageRead = function (pageID, pageName, time) {
	  if (!window.debug) {
	    return;
	  }
	  if (!pageReadLogs[pageID]) {
	    pageReadLogs[pageID] = {
	      name: pageName,
	      time: 0,
	      count: 0
	    };
	  }
	  if (time > pageReadLogs[pageID].time) {
	    pageReadLogs[pageID].time = time;
	  }
	  pageReadLogs[pageID].count++;
	  notify();
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var optimizeCall = __webpack_require__(136);
	
	var optimizedResizeCall = optimizeCall();
	window.addEventListener('resize', optimizedResizeCall.call);
	
	exports.getDocumentSize = function () {
	  return {
	    width: document.documentElement.clientWidth,
	    height: document.documentElement.clientHeight
	  };
	};
	
	exports.getScreenAvailSize = function () {
	  return {
	    width: window.screen.availWidth || window.screen.width,
	    height: window.screen.availWidth || window.screen.height
	  };
	};
	
	exports.onDocumentResize = function (cb) {
	  optimizedResizeCall.add(cb);
	};
	
	exports.offDocumentResize = function (cb) {
	  optimizedResizeCall.remove(cb);
	};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	/**
	 * 高频事件调用帮助方法,将高频调用进行缓冲
	 */
	'use strict';
	
	function optimizeCall() {
	  var callbacks = [];
	  var running = false;
	  var callArgu;
	
	  // fired on resize event
	  function call() {
	    if (!running) {
	      running = true;
	      callArgu = arguments;
	      if (window.requestAnimationFrame) {
	        window.requestAnimationFrame(runCallbacks);
	      } else {
	        setTimeout(runCallbacks, 66);
	      }
	    }
	  }
	
	  // run the actual callbacks
	  function runCallbacks() {
	    callbacks.forEach(function (callback) {
	      callback.apply(null, callArgu);
	    });
	    callArgu = null;
	    running = false;
	  }
	
	  // adds callback to loop
	  function addCallback(callback) {
	
	    if (callback) {
	      callbacks.push(callback);
	    }
	  }
	
	  function removeCallback(callback) {
	    if (callback) {
	      callbacks.splice(callbacks.indexOf(callback), 1);
	    }
	  }
	
	  return {
	    add: addCallback,
	    remove: removeCallback,
	    call: call
	  };
	}
	
	module.exports = optimizeCall;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var projectLoadHelper = __webpack_require__(68);
	var directToNext = false;
	
	var Preview = {
	  untoStack: [],
	  redoStack: [],
	  onOpenHome: function onOpenHome() {
	    var firstPageID = projectLoadHelper.getAppFirstPage();
	    if (firstPageID) {
	      this.onOpenPage(firstPageID);
	    }
	  },
	  onOpenPrev: function onOpenPrev() {
	    var prev = this.untoStack.pop();
	    if (prev) {
	      this.props.onOpenPage(prev);
	      this.redoStack.push(this.props.current.ID);
	    }
	    directToNext = true;
	  },
	  onOpenNext: function onOpenNext() {
	    var next = this.redoStack.pop();
	    if (next) {
	      this.props.onOpenPage(next);
	      this.untoStack.push(this.props.current.ID);
	    }
	    directToNext = false;
	  },
	  onOpenPage: function onOpenPage(id, animation) {
	    if (id === 'command:back') {
	      this.onOpenPrev();
	      return;
	    }
	    this.untoStack.push(this.props.current.ID);
	    this.props.onOpenPage(id, animation);
	  },
	  onRedirectTo: function onRedirectTo(id, animation) {
	    if (id === 'command:back') {
	      this.onOpenPrev();
	      return;
	    }
	    this.untoStack.push(this.props.current.ID);
	    this.props.onRedirectTo(id, animation);
	  },
	  openPage: function openPage(id) {
	    var currentID = this.props.current && this.props.current.ID;
	    // if(id !== currentID) {
	    this.wantToOpenOrRedirect = true;
	    this.onOpenPage(id);
	    // }
	  },
	  redirectTo: function redirectTo(id, animation) {
	    // var currentID = this.props.current && this.props.current.ID;
	    // if(id !== currentID) {
	    this.wantToOpenOrRedirect = true;
	    this.onRedirectTo(id, animation);
	    // }
	  },
	  onPlayback: function onPlayback() {
	    if (directToNext) {
	      return this.onOpenNext();
	    }
	    this.onOpenPrev();
	  }
	};
	
	module.exports = Preview;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var Animation = __webpack_require__(139);
	
	var Page = __webpack_require__(140);
	var optimizeCall = __webpack_require__(136);
	
	var MainStage = React.createClass({
	  displayName: 'MainStage',
	
	  propTypes: {
	    size: React.PropTypes.shape({
	      width: React.PropTypes.number,
	      height: React.PropTypes.number
	    }).isRequired,
	    domSize: React.PropTypes.shape({
	      width: React.PropTypes.number,
	      height: React.PropTypes.number
	    }),
	    current: React.PropTypes.object,
	    target: React.PropTypes.object,
	    animation: React.PropTypes.object,
	    showComments: React.PropTypes.bool.isRequired,
	    canFix: React.PropTypes.bool.isRequired,
	    orientation: React.PropTypes.string,
	    onRedirectTo: React.PropTypes.func.isRequired,
	    onOpenPage: React.PropTypes.func.isRequired,
	    onFinishOpenPage: React.PropTypes.func.isRequired,
	    onPageScroll: React.PropTypes.func,
	    onShowRemark: React.PropTypes.func.isRequired,
	    pageNeedRerender: React.PropTypes.bool.isRequired
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.scrollCall = optimizeCall();
	    this.scrollCall.add(this._callScroll);
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return !this.isScrolling && nextProps.pageNeedRerender; // 如果正在滚动, 禁止重新渲染
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.scrollingTimer); // 在 unmount 之前一定要清理掉 timer
	  },
	
	  isAnimation: false,
	  componentDidUpdate: function componentDidUpdate() {
	    var current = this.props.current;
	    var target = this.props.target;
	    var animation = this.props.animation;
	    var _this = this;
	    if (this.props.target && !this.isAnimation) {
	      if (animation && animation.name) {
	        new Animation({
	          stage: ReactDOM.findDOMNode(this.refs.stage),
	          one: ReactDOM.findDOMNode(this.refs[current.ID + '_0']),
	          two: ReactDOM.findDOMNode(this.refs[target.ID + '_1']),
	          onStart: function onStart() {
	            _this.isAnimation = true;
	          },
	          onEnd: function onEnd() {
	            _this.props.onFinishOpenPage();
	            _this.isAnimation = false;
	          }
	        }).animate(animation.name, animation.duration, animation.timing);
	      } else {
	        this.props.onFinishOpenPage();
	      }
	    }
	  },
	  render: function render() {
	    var position = this.props.position || { x: 0, y: 0 };
	    var style = {
	      left: position.x,
	      top: position.y,
	      width: this.props.size.width,
	      height: this.props.size.height
	    };
	    var current = this.props.current;
	    var target = this.props.target;
	    var pageList = [];
	    var size = this.props.size;
	    if (current) {
	      var currentKey = current.ID + '_0';
	      pageList.push(React.createElement(
	        'li',
	        { className: 'page-list-item',
	          style: { zIndex: 1 },
	          key: currentKey,
	          ref: currentKey },
	        React.createElement(Page, { page: current,
	          size: size,
	          isLoaded: !target,
	          domSize: this.props.domSize,
	          canFix: this.props.canFix,
	          appOrientation: this.props.orientation,
	          onLinkClick: this._onLinkClick,
	          onShowRemark: this.props.onShowRemark,
	          alwaysShowLinks: this.props.alwaysShowLinks
	        })
	      ));
	    }
	    if (target) {
	      var targetKey = target.ID + '_1';
	      pageList.push(React.createElement(
	        'li',
	        { className: 'page-list-item',
	          style: { zIndex: 2 },
	          key: targetKey,
	          ref: targetKey },
	        React.createElement(Page, { page: target,
	          size: size,
	          domSize: this.props.domSize,
	          canFix: this.props.canFix,
	          appOrientation: this.props.orientation,
	          onLinkClick: this._onLinkClick,
	          onShowRemark: this.props.onShowRemark,
	          onPageScroll: this.props.onPageScroll
	        })
	      ));
	    }
	    return React.createElement(
	      'div',
	      { className: 'stage-container animation-stage-container main-stage-container', style: style },
	      React.createElement(
	        'ul',
	        { ref: 'stage',
	          className: 'stage',
	          onScroll: this.props.showComments && this._onScroll },
	        pageList
	      )
	    );
	  },
	
	  _onLinkClick: function _onLinkClick(targetID, animation) {
	    if (targetID === 'command:back') {
	      // 直接打开前个页面
	      this.props.onOpenPage(targetID);
	      return;
	    }
	    this.props.onRedirectTo(targetID, animation);
	    //this.startSkipPage(targetID, animation);
	  },
	
	  _onScroll: function _onScroll(e) {
	    this.scrollTop = e.target.scrollTop;
	    this.scrollCall.call(e);
	  },
	  _callScroll: function _callScroll(e) {
	    var self = this;
	    this.isScrolling = true;
	    clearTimeout(this.scrollingTimer);
	    this.scrollingTimer = setTimeout(function () {
	      self.isScrolling = false;
	    }, 200); // 200ms 内不允许 rerender
	    if (this.props.onPageScroll) {
	      this.props.onPageScroll(this.scrollTop);
	    }
	  }
	});
	
	module.exports = MainStage;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	;(function (global) {
	    'use strict';
	    var AnimationConfig = {
	        'slide-left': {
	            pre: {two: {'z-index': 2, x: '100%'}},
	            trans: {two: {x: 0}}
	        },
	        'slide-right': {
	            pre: {two: {'z-index': 2, x: '-100%'}},
	            trans: {two: {x: 0}}
	        },
	        'slide-up': {
	            pre: {two: {'z-index': 2, y: '100%'}},
	            trans: {two: {y: 0}}
	        },
	        'slide-down': {
	            pre: {two: {'z-index': 2, y: '-100%'}},
	            trans: {two: {y: 0}}
	        },
	        'push-left': {
	            pre: {two: {x: '100%'}},
	            trans: {stage: {x: '-100%'}}
	        },
	        'push-right': {
	            pre: {two: {x: '-100%'}},
	            trans: {stage: {x: '100%'}}
	        },
	        'push-up': {
	            pre: {two: {y: '100%'}},
	            trans: {stage: {y: '-100%'}}
	        },
	        'push-down': {
	            pre: {two: {y: '-100%'}},
	            trans: {stage: {y: '100%'}}
	        },
	        'flip-left': {
	            pre: {
	                stage: {'transform-style': 'preserve-3d'},
	                one: {'backface-visibility': 'hidden'},
	                two: {'backface-visibility': 'hidden', rotateY: '180deg'}
	            },
	            trans: {
	                perspective: 800,
	                stage: {rotateY: '-180deg'}
	            }
	        },
	        'flip-right': {
	            pre: {
	                stage: {'transform-style': 'preserve-3d'},
	                one: {'backface-visibility': 'hidden'},
	                two: {'backface-visibility': 'hidden', rotateY: '180deg'}
	            },
	            trans: {
	                stage: {'perspective': 800, rotateY: '180deg'}
	            }
	        },
	        'flip-up': {
	            pre: {
	                stage: {'transform-style': 'preserve-3d'},
	                one: {'backface-visibility': 'hidden'},
	                two: {'backface-visibility': 'hidden', rotateX: '180deg'}
	            },
	            trans: {
	                stage: {'perspective': 800, rotateX: '180deg'}
	            }
	        },
	        'flip-down': {
	            pre: {
	                stage: {'transform-style': 'preserve-3d'},
	                one: {'backface-visibility': 'hidden'},
	                two: {'backface-visibility': 'hidden', rotateX: '180deg'}
	            },
	            trans: {
	                stage: {'perspective': 800, rotateX: '-180deg'}
	            }
	        },
	        'zoom-out': {
	            pre: {two: {opacity: 0}},
	            trans: {
	                one: {width: 0, height: 0, opacity: 0, left: '50%', top: '50%'},
	                two: {opacity: 1}
	            }
	        },
	        'zoom-in': {
	            pre: {
	                two: {width: 0, height: 0, left: '50%', top: '50%'}
	            },
	            trans: {
	                one: {duration: 500, opacity: 0},
	                two: {width: '100%', height: '100%', left: 0, top: 0}
	            }
	        },
	        'fade': {
	            pre: {
	                one: {opacity: 1},
	                two: {opacity: 0}
	            },
	            trans: {
	                one: {opacity: 0},
	                two: {opacity: 1}
	            }
	        },
	        'none': {
	            pre: {two: {opacity: 0.8, 'z-index': 2}},
	            trans: {two: {opacity: 1}}
	        }
	    };
	
	    function Animation(options) {
	        this.onStart = options.onStart;
	        this.onEnd = options.onEnd;
	        this.animating = false;
	
	        this.cachedStyle = {};
	        this.$stage = $(options.stage);
	        this.$one = $(options.one);
	        this.$two = $(options.two);
	    }
	
	    Animation.prototype.animate = function (animateName, durationMs, timingFunc) {
	        if (this.animating) {
	            return;
	        }
	        var $stage, $one, $two,
	            config, preSettings, trans,
	            createOnComplete, self, calledTimes,
	            duration, timing;
	
	        $stage = this.$stage;
	        $one = this.$one;
	        $two = this.$two;
	
	        config = AnimationConfig[animateName];
	
	        duration = durationMs || 500;
	        timing = timingFunc || 'ease';
	
	        this.cachedStyle = {
	            stage: $stage.attr('style') || '',
	            one: $one.attr('style') || '',
	            two: $two.attr('style') || ''
	        };
	
	        self = this;
	        calledTimes = 0;
	        createOnComplete = function () {
	            calledTimes++;
	            return function () {
	                calledTimes--;
	                if (calledTimes === 0) {
	                    self.reset();
	                    self.onEnd();
	                }
	            }
	        };
	
	        if (config) {
	            this.onStart();
	            this.animating = true;
	            preSettings = config.pre;
	            trans = config.trans;
	            if (preSettings) {
	                preSettings.stage && $stage.css(preSettings.stage);
	                preSettings.one && $one.css(preSettings.one);
	                preSettings.two && $two.css(preSettings.two);
	            }
	            trans.stage && $stage.transition(trans.stage, duration, timing, createOnComplete());
	            trans.one && $one.transition(trans.one, duration, timing, createOnComplete());
	            trans.two && $two.transition(trans.two, duration, timing, createOnComplete());
	        }
	    };
	
	    Animation.prototype.reset = function () {
	        if (!this.animating) {
	            return;
	        }
	        this.animating = false;
	        var $stage, $one, $two, styleCached;
	
	        styleCached = this.cachedStyle;
	
	        $stage = this.$stage;
	        $one = this.$one;
	        $two = this.$two;
	
	        // there is a bug in transit, must reset these properties, should make an issue
	        var resetCssProperties = {
	            x: 0,
	            y: 0,
	            rotateX: 0,
	            rotateY: 0
	        };
	        $one.css(resetCssProperties);
	        $two.css(resetCssProperties);
	        $stage.css(resetCssProperties);
	
	        styleCached.stage ? $stage.attr('style', styleCached.stage) : $stage.removeAttr('style');
	        styleCached.one ? $one.attr('style', styleCached.one) : $one.removeAttr('style');
	        styleCached.two ? $two.attr('style', styleCached.two) : $two.removeAttr('style');
	    };
	
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Animation;
	    } else {
	        global.Animation = Animation;
	    }
	}(this));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	
	var Top = __webpack_require__(141);
	var Bottom = __webpack_require__(324);
	var Middle = __webpack_require__(325);
	var Popup = __webpack_require__(326);
	var SelectComp = __webpack_require__(177);
	
	var PopupHelper = __webpack_require__(156);
	var interactiveManager = __webpack_require__(150);
	
	var appTypes = __webpack_require__(115);
	var InteractiveType = __webpack_require__(151);
	var pageHelper = __webpack_require__(119);
	var linkHelper = __webpack_require__(327);
	var comHelper = __webpack_require__(155);
	var dataHelper = __webpack_require__(113);
	var styleHelper = __webpack_require__(145);
	
	var timeLogHelper = __webpack_require__(134);
	var RunTimeOptions = __webpack_require__(153);
	
	var propConst = __webpack_require__(147);
	
	var Page = React.createClass({
	  displayName: 'Page',
	
	  propTypes: {
	    page: React.PropTypes.object.isRequired,
	    size: React.PropTypes.shape({
	      width: React.PropTypes.number,
	      height: React.PropTypes.number
	    }).isRequired,
	    domSize: React.PropTypes.shape({
	      width: React.PropTypes.number,
	      height: React.PropTypes.number
	    }),
	    canFix: React.PropTypes.bool.isRequired,
	    appOrientation: React.PropTypes.string,
	    onLinkClick: React.PropTypes.func.isRequired,
	    onShowRemark: React.PropTypes.func.isRequired
	  },
	  getInitialState: function getInitialState() {
	    return {
	      page: this.props.page,
	      isShowSelectExpand: false,
	      pageScrollTop: 0
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.startMount = Date.now();
	  },
	
	  oldPageID: null,
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.oldPageID !== nextProps.page.ID) {
	      //切换页面时，重置弹出面板的载入交互数组
	      this.loadedPopupArray = [];
	      this.oldPageID = nextProps.page.ID;
	    }
	    this.setState({
	      page: nextProps.page
	    });
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.state.transitions) {
	      this.state.transitions.forEach(function (transition) {
	        $('#' + transition.id).css({
	          left: 0,
	          top: 100
	        }).transition(transition.animation);
	      });
	    }
	    // this.startAllLoadInteractive(false);
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  isLoaded: false,
	  isLoadInteractiveStart: false,
	
	  startAllLoadInteractive: function startAllLoadInteractive(isCreate) {
	    this.isLoaded = this.props.isLoaded;
	    if (this.isLoaded && !this.isLoadInteractiveStart) {
	      this.isLoadInteractiveStart = true;
	    } else {
	      return;
	    }
	    if (!this.state.page.controls.control) {
	      return;
	    }
	    /*var self = this;
	     var fx = function (items) {
	      var comp;
	      var i;
	      for (i = 0; i < items.length; i++) {
	        comp = items[i];
	        if (pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)) {
	          comp.onOpened = self.doPopupOpened;
	          continue;
	        }
	        self.doStartCompLoadInteractive(comp);
	        if (comp.items) {
	          fx(comp.items);
	        }
	      }
	    };*/
	
	    interactiveManager.reset();
	
	    this.startControlLoadInteractive(this.state.page.controls.control, false);
	  },
	
	  startControlLoadInteractive: function startControlLoadInteractive(items) {
	    var comp;
	    var i;
	    for (i = 0; i < items.length; i++) {
	      comp = items[i];
	
	      this.startCompLoadInteractive(comp);
	    }
	  },
	
	  startLoadContentInteractive: function startLoadContentInteractive(contentPanel) {
	    var index = styleHelper.getInt(contentPanel, propConst.SELECTED_INDEX);
	    this.startCompLoadInteractive(contentPanel.items[index]);
	  },
	
	  startCompLoadInteractive: function startCompLoadInteractive(comp) {
	    var isLoadContent = false;
	    if (comp.controlTypeID === 'ContentPanel') {
	      isLoadContent = true;
	    }
	    if (pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)) {
	      comp.onOpened = this.doPopupOpened;
	      return;
	    }
	    this.doStartCompLoadInteractive(comp);
	    if (isLoadContent) {
	      this.startLoadContentInteractive(comp);
	    } else if (comp.items) {
	      this.startControlLoadInteractive(comp.items);
	    }
	  },
	
	  loadedPopupArray: [],
	  doPopupOpened: function doPopupOpened(comp) {
	    if (this.loadedPopupArray.indexOf(comp.controlID) === -1) {
	      //载入时交互仅执行一次
	      this.doStartPopupChildCompLoadInteractive(comp);
	      this.loadedPopupArray.push(comp.controlID);
	    }
	  },
	
	  /*
	   * 开始弹出交互
	   * */
	  doStartPopupChildCompLoadInteractive: function doStartPopupChildCompLoadInteractive(comp) {
	    var i;
	    var c;
	    if (comp.items && comp.items.length) {
	      for (i = 0; i < comp.items.length; i++) {
	        c = comp.items[i];
	        this.doStartCompLoadInteractive(c);
	        if (c.items && c.items.length) {
	          this.doStartPopupChildCompLoadInteractive(c);
	        }
	      }
	    }
	  },
	
	  doStartCompLoadInteractive: function doStartCompLoadInteractive(comp) {
	    //var index;
	    //var e;
	    //var entries;
	    //var hasLoadInteractive = false;
	    //if (comp.interactiveData) {
	    //  entries = comp.interactiveData.entry;
	    //  for (index = 0; index < entries.length; index++) {
	    //    e = comHelper.findEventByType(comp, index, 'atLoad');   //查找指定事件类型的交互事件数据
	    //    if (e) {
	    //      this.interceptSelfLoad(comp, appTypes.ActionResponseType.INTERACTIVE, index);
	    //      hasLoadInteractive = true;
	    //    }
	    //  }
	    //}
	    //if (hasLoadInteractive) {
	    //  this.startLoadInteractiveCount++;
	    //}
	
	    //--------------------------------------------------
	    // matt 2017-10-18
	    // 这里改为用对像来管理组件自带延迟执行交互属性的情况
	    var fun = function fun(comp) {
	      this.loadFun = null;
	      this.hasLoadInteractive = function () {
	        var entries;
	        var e;
	        var index;
	        if (comp.interactiveData) {
	          entries = comp.interactiveData.entry;
	          for (index = 0; index < entries.length; index++) {
	            e = comHelper.findEventByType(comp, index, 'atLoad'); //查找指定事件类型的交互事件数据
	            if (e) {
	              return true;
	            }
	          }
	        }
	        return false;
	      };
	      this.doStart = function () {
	        var index;
	        var e;
	        var entries;
	        if (comp.interactiveData) {
	          entries = comp.interactiveData.entry;
	          for (index = 0; index < entries.length; index++) {
	            e = comHelper.findEventByType(comp, index, 'atLoad'); //查找指定事件类型的交互事件数据
	            if (e) {
	              this.loadFun(comp, appTypes.ActionResponseType.INTERACTIVE, index);
	            }
	          }
	        }
	      };
	      this.start = function () {
	        var interval = parseInt(comp.interval, 10) || 0;
	        var self = this;
	        console.log(interval);
	        if (interval) setTimeout(function () {
	          self.doStart();
	        }, interval);else this.doStart();
	      };
	    };
	
	    var f = new fun(comp);
	    f.page = this;
	    f.loadFun = this.interceptSelfLoad;
	    if (f.hasLoadInteractive()) {
	      this.startLoadInteractiveCount++;
	      f.start();
	    }
	    //--------------------------------------------------
	  },
	
	  render: function render() {
	    var page = this.state.page;
	    var sizeAndFix = this.computeSizeAndFix();
	    var domSize = this.props.domSize;
	    var normalComponents = _.filter(page.controls.control, function (comp) {
	      return !comp.isCommentCom && !pageHelper.IsInvisualInteractiveCom(comp.controlTypeID);
	    });
	    var i;
	    var comp;
	    var popupComponents = [];
	    if (page.controls.control) {
	      for (i = 0; i < page.controls.control.length; i++) {
	        comp = page.controls.control[i];
	        if (pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)) {
	          if (comp.popup || comp.isPopupClosing) {
	            //Allen: 未执行完弹出面板关闭前，要显示弹出面板
	            //if (comp.popup) {
	            comp.onOpened = this.doPopupOpened; //执行弹出面板的载入时交互
	            popupComponents.push(comp);
	          }
	        }
	      }
	    }
	    this.popupComponentsCount = popupComponents.length;
	    var events = {
	      doSelfClick: this.interceptSelfClick,
	      doSelfDbClick: this.interceptSelfDbClick,
	      doSelfRightClick: this.interceptSelfRightClick,
	      doSelfLoad: this.interceptSelfLoad,
	      doSelfChecked: this.interceptSelfChecked,
	      doSelfLongPress: this.interceptSelfLongPress,
	      onTransit: this.onTransit,
	      onShowRemark: this.props.onShowRemark,
	      switchOn: this.switchOn,
	      switchOff: this.switchOff,
	      triggerSelectExpand: this.triggerSelectExpand,
	      startCompLoadInteractive: this.startCompLoadInteractive,
	      startControlLoadInteractive: this.startControlLoadInteractive
	    };
	    var screenSize;
	    var screenOrientation = this.props.page.screenOrientation;
	    var appOrientation = this.props.appOrientation;
	    if (screenOrientation && appOrientation && screenOrientation !== appOrientation) {
	      screenSize = {
	        width: page.defaultH,
	        height: page.defaultW
	      };
	    } else {
	      screenSize = {
	        width: page.defaultW,
	        height: page.defaultH
	      };
	    }
	    this.toLoad = 1;
	    if (sizeAndFix.top > 0) {
	      this.toLoad += 1;
	    }
	    if (sizeAndFix.bottom > 0) {
	      this.toLoad += 1;
	    }
	    return React.createElement(
	      'div',
	      { className: 'page', id: this.props.page.ID,
	        style: {
	          backgroundColor: this.props.page.param ? this.props.page.param[0].backgroundColor : '#fff'
	        },
	        onClick: this.onPageClick },
	      sizeAndFix.top > 0 && React.createElement(Top, {
	        components: normalComponents,
	        top: sizeAndFix.top,
	        events: events,
	        onLinkClick: this.props.onLinkClick,
	        onLoad: this.onLoad
	      }),
	      React.createElement(Middle, {
	        components: normalComponents,
	        screenSize: screenSize,
	        pageSize: {
	          width: sizeAndFix.width,
	          height: sizeAndFix.height
	        },
	        canFix: this.props.canFix,
	        domSize: domSize,
	        top: sizeAndFix.top,
	        bottom: sizeAndFix.bottom,
	        events: events,
	        onLinkClick: this.props.onLinkClick,
	        onLoad: this.onLoad,
	        onPageScroll: this.onPageScroll
	      }),
	      sizeAndFix.bottom > 0 && React.createElement(Bottom, {
	        components: normalComponents,
	        pageSize: {
	          width: sizeAndFix.width,
	          height: sizeAndFix.height
	        },
	        bottom: sizeAndFix.bottom,
	        events: events,
	        onLinkClick: this.props.onLinkClick,
	        onLoad: this.onLoad
	      }),
	      popupComponents.length > 0 && React.createElement(Popup, {
	        components: popupComponents,
	        pageSize: {
	          width: page.defaultW,
	          height: page.defaultH
	        },
	        height: page.defaultH,
	        events: events,
	        onLinkClick: this.props.onLinkClick,
	        onLoad: this.onLoad,
	        pageScrollTop: this.state.pageScrollTop || 0
	      }),
	      this.state.isShowSelectExpand && React.createElement(SelectComp, this.state.selectProps)
	    );
	  },
	
	  onPageScroll: function onPageScroll(top, left) {
	    this.setState({ pageScrollTop: top });
	    if (this.props.onPageScroll) {
	      this.props.onPageScroll(top, left);
	    }
	  },
	
	  onLoad: function onLoad() {
	    this.toLoad--;
	    if (this.toLoad === 0) {
	      PopupHelper.init();
	      delete RunTimeOptions.eventTargetCom;
	      this.startAllLoadInteractive(true);
	      $(ReactDOM.findDOMNode(this)).bind('onScreenClick', this.onScreenClick);
	      timeLogHelper.logPageRender(this.props.page.ID, this.props.page.title, Date.now() - this.startMount);
	    }
	  },
	
	  onPageClick: function onPageClick(e) {
	    if (this.popupComponentsCount > 0) {
	      e.stopPropagation();
	      e.preventDefault();
	      e.nativeEvent.stopPropagation();
	      PopupHelper.mousePoint = {
	        x: e.pageX,
	        y: e.pageY
	      };
	      this.doTriggerClosePopup(e);
	    }
	  },
	
	  onScreenClick: function onScreenClick(e, me) {
	    this.doTriggerClosePopup(e);
	    //$('.popup-control').trigger(PopupHelper.CLOSE_POPUP_EVENT, {
	    //  callback: this.doClosePopup
	    //});
	  },
	
	  doTriggerClosePopup: function doTriggerClosePopup(e, call, noClosePopups) {
	    var i;
	    var c;
	    var comp;
	    var controls;
	    var self = this;
	    var finishCount = 0;
	    var popupCount;
	    var func = function func() {
	      finishCount++;
	      if (finishCount !== popupCount) {
	        return;
	      }
	      if (call) {
	        call();
	      }
	    };
	    var noClosePopupID;
	    var idStr = '';
	    if (noClosePopups && noClosePopups.length) {
	      noClosePopupID = [];
	      for (i = 0; i < noClosePopups.length; i++) {
	        noClosePopupID.push(noClosePopups[i].controlID);
	      }
	      idStr = noClosePopupID.join(',');
	    }
	    if (this.state.page.controls) {
	      controls = this.state.page.controls.control;
	      if (controls && controls.length) {
	
	        //c = $('.popup-control');
	        //popupCount = c.length;
	        //if (c.length) {
	        //  for (i = 0; i < c.length; i++) {
	        //    $(c[i]).trigger(PopupHelper.CLOSE_POPUP_EVENT, {
	        //      callback: function (popupID) {
	        //        self.doClosePopup(popupID, func)
	        //      },
	        //      mousePoint: {
	        //        x: e.pageX,
	        //        y: e.pageY
	        //      }
	        //    });
	        //  }
	        //} else {
	        //  if (call) {
	        //    call();
	        //  }
	        //}
	
	        //popupCount = 0;
	        //for(i = 0;i<controls.length;i++){
	        //  comp = controls[i];
	        //  if(pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)){
	        //    if(comp.closeWithTrigger){
	        //      continue;
	        //    }
	        //    if(comp.popup)
	        //      popupCount ++;
	        //  }
	        //}
	
	        popupCount = $('.popup-control').length;
	        if (noClosePopupID) {
	          popupCount -= noClosePopupID.length;
	        }
	        if (popupCount > 0) {
	          for (i = 0; i < controls.length; i++) {
	            comp = controls[i];
	            if (pageHelper.IsInvisualInteractiveCom(comp.controlTypeID)) {
	              if (idStr.indexOf(comp.controlID) !== -1) {
	                continue;
	              }
	              c = $('#' + comp.controlID);
	              if (c.length) {
	                c.trigger(PopupHelper.CLOSE_POPUP_EVENT, {
	                  callback: function callback(popupID) {
	                    self.doClosePopup(popupID, func);
	                  },
	                  mousePoint: {
	                    x: e.pageX,
	                    y: e.pageY
	                  },
	                  controlID: comp.controlID
	                });
	              }
	            }
	          }
	        } else {
	          if (call) {
	            call();
	          }
	        }
	      }
	    }
	    /*
	     * todo mxj 下一步考虑弹出组件关闭的策略为，
	     * 任何时候的点击事件，先主动冒泡到Page或者Screen中的某个事件，
	     * 然后触发弹出组件的全局点击事件来关闭，而交互组件的点击需要在这个动作之后，
	     * 减小回调的可能
	     弹出组件中，该事件还未处理
	     */
	    //$('.popup-control').trigger('onScreenClick',{event:e,callback:this.doClosePopup});
	  },
	
	  doClosePopup: function doClosePopup(popupID, call) {
	    var data = this.state.page;
	    var comp;
	    if (popupID) {
	      comp = this.findComByID(popupID);
	      if (comp) {
	        comp.popup = false;
	        delete comp.closeWithTrigger;
	        pageHelper.updatePageComData(data, comp);
	        this.refresh(data);
	      }
	    }
	    if (call) {
	      call();
	    }
	  },
	
	  computeSizeAndFix: function computeSizeAndFix() {
	    var page = this.state.page;
	    var clipArea = page.clipArea;
	    var size = this.props.size;
	    var width = parseInt(page.measureW, 10);
	    var height = parseInt(page.measureH, 10);
	    var arr;
	    if (!this.props.canFix) {
	      return {
	        top: 0,
	        bottom: 0,
	        width: width,
	        height: height
	      };
	    }
	    if (!clipArea || clipArea === '(0,0,0,0)') {
	      return {
	        width: width,
	        height: height,
	        top: 0,
	        bottom: 0
	      };
	    }
	    arr = clipArea.split(',');
	    return {
	      width: width,
	      height: height,
	      top: parseInt(arr[1], 10),
	      bottom: height - parseInt(arr[3], 10)
	    };
	  },
	
	  getPopupTargetsBy: function getPopupTargetsBy(comp, index, eventType, linkKey) {
	    var interactiveData = comp.interactiveData;
	    var entries;
	    var entry;
	    var events;
	    var event;
	    var behaviour;
	    var target;
	    var i;
	    var targets = [];
	    if (linkKey === appTypes.ActionResponseType.INTERACTIVE) {
	      if (interactiveData) {
	        entries = interactiveData.entry;
	        entry = entries[index];
	        events = entry.events;
	        if (events.event) {
	          for (i = 0; i < events.event.length; i++) {
	            event = events.event[i];
	            if (event.eventType === eventType) {
	              behaviour = event.behaviour[0];
	            }
	          }
	        }
	        if (behaviour) {
	          if (behaviour.target) {
	            for (i = 0; i < behaviour.target.length; i++) {
	              target = behaviour.target[i];
	              target = this.findComByID(target.targetID);
	              if (target && pageHelper.IsInvisualInteractiveCom(target.controlTypeID)) {
	                if (target.popup) {
	                  targets.push(target);
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	    return targets;
	  },
	
	  interceptSelfClick: function interceptSelfClick(evt, componentData, linkKey, index) {
	    var self = this;
	    this.doTriggerClosePopup(evt, function () {
	      self.doStartInteractiveOrSkipPage(componentData, linkKey, index);
	    }, this.getPopupTargetsBy(componentData, index, InteractiveType.InteractiveTypes.EventType.CLICK, linkKey));
	  },
	
	  switchOn: function switchOn(evt, componentData, linkKey, index) {
	    var self = this;
	    this.doTriggerClosePopup(evt, function () {
	      self.doStartInteractiveOrSkipPage(componentData, 'atSwitchOn', index);
	    }, this.getPopupTargetsBy(componentData, index, InteractiveType.InteractiveTypes.EventType.SWITCH_ON, linkKey));
	  },
	
	  switchOff: function switchOff(evt, componentData, linkKey, index) {
	    var self = this;
	    this.doTriggerClosePopup(evt, function () {
	      self.doStartInteractiveOrSkipPage(componentData, 'atSwitchOff', index);
	    }, this.getPopupTargetsBy(componentData, index, InteractiveType.InteractiveTypes.EventType.SWITCH_OFF, linkKey));
	  },
	
	  triggerSelectExpand: function triggerSelectExpand(comboComp, props) {
	    var context = this;
	    if (this.expandId === props.id) {
	      return;
	    }
	    var fun = function fun() {
	      context.expandId = props.id;
	      var rect = context.getTargetEventComAbsoluteRect(comboComp);
	      var itemHeight = parseInt(props.itemHeight, 10);
	      var height = itemHeight * props.dataSet.length;
	      var bottomDistance = context.props.size.height - rect.bottom;
	      if (height > bottomDistance) {
	        //下面有空间在下方显示，没有空间在空间较大一侧显示
	        if (bottomDistance > rect.top) {
	          props.boxStyle.top = rect.top + itemHeight;
	          props.boxStyle.borderTop = 'none';
	        } else {
	          props.boxStyle.top = rect.top - height - 1;
	          props.boxStyle.borderBottom = 'none';
	        }
	      } else {
	        props.boxStyle.top = rect.top + itemHeight;
	        props.boxStyle.borderTop = 'none';
	      }
	      props.boxStyle.height = height;
	      props.boxStyle.left = rect.left;
	      props.closeSelectList = context.closeSelectList;
	      context.setState({ isShowSelectExpand: true, selectProps: props });
	    };
	    if (this.isClosing) {
	      //等待其他下拉列表先关闭
	      setTimeout(fun, 5);
	    } else {
	      fun();
	    }
	  },
	
	  isClosing: false,
	  expandId: undefined,
	  closeSelectList: function closeSelectList() {
	    var context = this;
	    this.isClosing = true;
	    setTimeout(function () {
	      //延迟，等待选中事件响应
	      context.setState({ isShowSelectExpand: false });
	      context.isClosing = false;
	      context.expandId = undefined;
	    }, 5);
	  },
	
	  doStartInteractiveOrSkipPage: function doStartInteractiveOrSkipPage(componentData, linkKey, index) {
	    if (linkKey === appTypes.ActionResponseType.LINK) {
	      this.interceptLinkClick(componentData.links, index);
	    } else if (linkKey === appTypes.ActionResponseType.INTERACTIVE) {
	      this.interceptInteractiveEvent(componentData, InteractiveType.InteractiveTypes.EventType.CLICK, index);
	    } else if (linkKey === appTypes.ActionResponseType.OUTER) {
	      this.interceptExternalLinkEvent(componentData);
	    } else {
	      this.interceptInteractiveEvent(componentData, linkKey, index);
	    }
	  },
	
	  interceptSelfLongPress: function interceptSelfLongPress(evt, comData, index) {
	    var self = this;
	    this.doTriggerClosePopup(evt, function () {
	      self.interceptInteractiveEvent(comData, InteractiveType.InteractiveTypes.EventType.LONG_PRESS, index);
	    });
	  },
	
	  interceptSelfChecked: function interceptSelfChecked(evt, componentData, isChecked, linkKey, index) {
	    var eventType;
	    if (_.isUndefined(index)) {
	      index = 0;
	    }
	    var self = this;
	    this.doTriggerClosePopup(evt, function () {
	      if (linkKey !== appTypes.ActionResponseType.INTERACTIVE) {
	        self.interceptSelfClick(evt, componentData, linkKey, index);
	      } else {
	        eventType = isChecked ? InteractiveType.InteractiveTypes.EventType.CHECK_TRUE : InteractiveType.InteractiveTypes.EventType.CHECK_FALSE;
	        self.interceptInteractiveEvent(componentData, eventType, index);
	      }
	    });
	  },
	
	  interceptSelfDbClick: function interceptSelfDbClick(evt, comDatas, index) {
	    this.interceptInteractiveEvent(comDatas, InteractiveType.InteractiveTypes.EventType.DOUBLE_CLICK, index);
	  },
	
	  interceptSelfRightClick: function interceptSelfRightClick(evt, comDatas, index) {
	    this.interceptInteractiveEvent(comDatas, InteractiveType.InteractiveTypes.EventType.RIGHT_CLICK, index);
	  },
	
	  interceptSelfLoad: function interceptSelfLoad(comDatas) {
	    this.interceptInteractiveEvent(comDatas, InteractiveType.InteractiveTypes.EventType.LOAD);
	  },
	
	  interceptExternalLinkEvent: function interceptExternalLinkEvent(componentData) {
	    if (componentData.externalURL) {
	      var externalURL = componentData.externalURL;
	      externalURL = dataHelper.decodeURIComponent(externalURL);
	      if (externalURL.indexOf('http://') === -1 && externalURL.indexOf('https://') === -1) {
	        externalURL = 'http://' + externalURL;
	      }
	      window.open(externalURL);
	    }
	  },
	
	  /**
	   * 拦截组件链接点击事件
	   * @param links: 链接对象
	   * @param index： 当前点击的链接索引序号
	   */
	  interceptLinkClick: function interceptLinkClick(links, index) {
	    var link;
	    var targetPageID;
	    var animateType;
	    var animateDuration;
	
	    if (links && index !== undefined) {
	      link = links.link[index];
	
	      if (link && link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
	
	        targetPageID = link.targetPageID;
	        animateType = linkHelper.getLinkAnimateBySaveLinkAnimate(links.animate);
	        animateDuration = parseInt(links.animateDuration, 10);
	        this.setState({ page: this.props.page });
	
	        this.props.onLinkClick(targetPageID, {
	          name: animateType,
	          duration: animateDuration,
	          timing: 'linear'
	        });
	      }
	    }
	  },
	
	  /**
	   * 拦截交互事件，同时派发组件交互事件
	   * @param comDatas 组件数据
	   * @param eventType 事件类型
	   * @param entryIndex 响应用户事件的入口索引
	   */
	  interceptInteractiveEvent: function interceptInteractiveEvent(comDatas, eventType, entryIndex) {
	    this.dispatchInteractive(comDatas, eventType, entryIndex);
	  },
	
	  /***
	   * 派发一个交互事件，并执行
	   * @param sourceNode
	   * @param eventType
	   * @param entryIndex
	   */
	  dispatchInteractive: function dispatchInteractive(sourceNode, eventType, entryIndex) {
	    interactiveManager.start(this, sourceNode, eventType, entryIndex);
	  },
	
	  refresh: function refresh(newPage) {
	    this.setState({ page: newPage });
	  },
	
	  /**
	   * 根据组件ID查找组件数据，该数据是从当前页面的状态数据中查找，而不是原始数据
	   * @param comID 组件ID
	   */
	  findComByID: function findComByID(comID) {
	    return pageHelper.getControlDataByComID(this.state.page, comID);
	  },
	
	  /***
	   * 获取事件源组件相对于页面的绝对区域
	   * @param targetDom
	   * @returns {{left: number, top: number, right: number, bottom: number}}
	   */
	  getTargetEventComAbsoluteRect: function getTargetEventComAbsoluteRect(targetDom) {
	    var rect = {
	      left: 0,
	      top: 0,
	      right: 0,
	      bottom: 0
	    };
	    if (!targetDom) {
	      return rect;
	    }
	
	    var pageDom = ReactDOM.findDOMNode(this); //$('#' + this.props.page.ID)[0];
	
	    var parentDom = targetDom.parentElement;
	
	    rect.top = targetDom.offsetTop;
	    rect.left = targetDom.offsetLeft;
	
	    //根据Dom来获取相对于page的绝对坐标
	    while (parentDom !== pageDom) {
	      //此处为改弹窗相对组件定位问题注释掉的，需观察是否有副作用
	      //parentDom = parentDom.parentElement;
	      if (parentDom) {
	        rect.top += parentDom.offsetTop - parentDom.scrollTop;
	        rect.left += parentDom.offsetLeft - parentDom.scrollLeft;
	        parentDom = parentDom.parentElement;
	      } else {
	        break;
	      }
	    }
	    rect.right = rect.left + targetDom.clientWidth;
	    rect.bottom = rect.top + targetDom.clientHeight;
	    return rect;
	  },
	
	  onTransit: function onTransit(transitions) {
	    if (!_.isArray(transitions)) {
	      transitions = [transitions];
	    }
	    this.setState({
	      transitions: transitions
	    });
	  },
	
	  getClipAreaScrollView: function getClipAreaScrollView() {
	    var controls = this.state.page.controls;
	    var c;
	    var i;
	    if (controls) {
	      if (controls.control) {
	        for (i = 0; i < controls.control.length; i++) {
	          c = controls.control[i];
	          if (c.alias === '__________________________ClidArea_______________________0000000000000000000000') {
	            return c;
	          }
	        }
	      }
	    }
	    return null;
	  }
	});
	
	module.exports = Page;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Components = __webpack_require__(142);
	var _ = __webpack_require__(51);
	
	var Top = React.createClass({
	  displayName: 'Top',
	
	  propTypes: {
	    components: React.PropTypes.array.isRequired,
	    top: React.PropTypes.number.isRequired,
	    events: React.PropTypes.object.isRequired,
	    onLinkClick: React.PropTypes.func.isRequired,
	    onLoad: React.PropTypes.func.isRequired
	  },
	  render: function render() {
	    var top = this.props.top;
	    var shouldRenderComponents = _.filter(this.props.components, function (item) {
	      if (item.controlTypeID === 'ImageCarousel') {
	        return top - item.y > 5;
	      }
	      return item.y <= top;
	    });
	    return React.createElement(
	      'div',
	      { key: 'top-page', className: 'page-top', style: { height: this.props.top } },
	      React.createElement(Components, { components: shouldRenderComponents, events: this.props.events, onLoad: this.props.onLoad })
	    );
	  }
	});
	
	module.exports = Top;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	* 组件数组 视图内容输出
	* */
	
	'use strict';
	
	var React = __webpack_require__(11);
	var compHelper = __webpack_require__(143);
	var LazyLoad = __webpack_require__(161);
	var styleHelper = __webpack_require__(145);
	
	var Components = React.createClass({
	  displayName: 'Components',
	
	  propTypes: {
	    events: React.PropTypes.object,
	    components: React.PropTypes.array.isRequired,
	    onLoad: React.PropTypes.func
	  },
	  componentWillMount: function componentWillMount() {
	    this.loadingCount = this.props.components.length;
	  },
	  render: function render() {
	    var events = this.props.events;
	    return React.createElement(
	      'div',
	      { className: 'components' },
	      this.props.components.map(function (comp) {
	        var order = styleHelper.getOrder(comp);
	        return React.createElement(
	          LazyLoad,
	          { key: comp.controlID,
	            onLoad: this.onLoadComponent,
	            order: order
	          },
	          compHelper.makeComp(comp, events)
	        );
	      }, this)
	    );
	  },
	  onLoadComponent: function onLoadComponent() {
	    this.loadingCount--;
	    if (this.loadingCount === 0 && this.props.onLoad) {
	      this.props.onLoad();
	    }
	  }
	});
	
	module.exports = Components;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var Component = __webpack_require__(144);
	var _ = __webpack_require__(51);
	var util = __webpack_require__(116);
	var logHelper = __webpack_require__(53);
	var envHelper = __webpack_require__(48);
	var pageHelper = __webpack_require__(119);
	var LazyLoad = __webpack_require__(161);
	
	/*所有功能组件集合*/
	var Components = {
	  '__group__': __webpack_require__(162),
	
	  'Alert': __webpack_require__(163),
	  'AlertWindow': __webpack_require__(165),
	
	  'Button': __webpack_require__(166),
	
	  'CheckBox': __webpack_require__(169),
	  'CheckBoxGroup': __webpack_require__(173),
	
	  'CompositeComboBox': __webpack_require__(175),
	  'ComboBox': __webpack_require__(179),
	  'CircleProgressBar': __webpack_require__(180),
	  'ContentPanel': __webpack_require__(181),
	  'Canvas': __webpack_require__(182),
	
	  'Graffiti': __webpack_require__(185),
	  'GroupBox': __webpack_require__(187),
	
	  'HotSpot': __webpack_require__(188),
	
	  'Image': __webpack_require__(189),
	  'ImageBackground': __webpack_require__(190),
	  'ImageCarousel': __webpack_require__(191),
	  'Gif': __webpack_require__(192),
	  'Svg': __webpack_require__(193),
	
	  'Label': __webpack_require__(194),
	  'Link': __webpack_require__(195),
	  'Line': __webpack_require__(196),
	  'Arrow': __webpack_require__(196),
	  'List': __webpack_require__(198),
	  'LabelTextInput': __webpack_require__(200),
	  'LinkBar': __webpack_require__(201),
	
	  'ModalScreen': __webpack_require__(202),
	
	  'Panel': __webpack_require__(203),
	  'ProgressBar': __webpack_require__(205),
	
	  'RadioButton': __webpack_require__(206),
	  'RadioButtonGroup': __webpack_require__(209),
	
	  'Shape': __webpack_require__(210),
	  'Triangle': __webpack_require__(212),
	  'ScrollView': __webpack_require__(213),
	  'ScrollArea': __webpack_require__(217),
	  'ScopeBar': __webpack_require__(218),
	  'SlidingDrawer': __webpack_require__(219),
	
	  'TextArea': __webpack_require__(220),
	  'TextInput': __webpack_require__(221),
	  'TitleWindow': __webpack_require__(222),
	
	  'PopupPanel': __webpack_require__(223),
	  'PopupPanelContent': __webpack_require__(224),
	  'PopupMenu': __webpack_require__(225),
	
	  'SwitchIOS': __webpack_require__(226),
	  'Switch': __webpack_require__(227),
	  'PointyButton': __webpack_require__(228),
	  'Tree': __webpack_require__(229),
	
	  'LineChart': __webpack_require__(230),
	  'LineChartEx': __webpack_require__(231),
	  'Icon': __webpack_require__(232),
	
	  'Accordion': __webpack_require__(235),
	  //'DataGrid': require('./DataGrid'),
	  'DataGrid': __webpack_require__(236),
	  'Table': __webpack_require__(237),
	
	  'VerticalTabBar': __webpack_require__(239),
	  'Tab': __webpack_require__(240),
	
	  'VerticalScrollbar': __webpack_require__(242),
	  'HorizontalScrollBar': __webpack_require__(243),
	  'Slider': __webpack_require__(244),
	  'TableView': __webpack_require__(245),
	  'StatusBar(IOS)': __webpack_require__(246),
	  'VRule': __webpack_require__(247),
	
	  'HRule': __webpack_require__(248),
	  'VSplitter': __webpack_require__(249),
	  'HSplitter': __webpack_require__(250),
	  'PageControl': __webpack_require__(251),
	  'PageControlEx': __webpack_require__(252),
	  'BrowserWindow': __webpack_require__(253),
	  'IPhone': __webpack_require__(254),
	  'Phone': __webpack_require__(255),
	  'IPad': __webpack_require__(257),
	  'TabletPC': __webpack_require__(258),
	
	  'IPhone2': __webpack_require__(259),
	  'Android': __webpack_require__(259),
	  'IPad2': __webpack_require__(259),
	  'TabletPC2': __webpack_require__(259),
	  'Tabs': __webpack_require__(260),
	  'ButtonBar': __webpack_require__(261),
	  'Menu': __webpack_require__(262),
	  'MenuBar': __webpack_require__(263),
	  'NumericStepper': __webpack_require__(264),
	  'DateTimePicker': __webpack_require__(265),
	  'ColorPicker': __webpack_require__(266),
	  'HSlider': __webpack_require__(267),
	  'VSlider': __webpack_require__(268),
	  'HSlider2': __webpack_require__(267),
	  'VSlider2': __webpack_require__(268),
	  'Search': __webpack_require__(269),
	  'BreadCrumbs': __webpack_require__(270),
	  'ToolTip': __webpack_require__(271),
	  'StickyNote': __webpack_require__(272),
	  'CallOut': __webpack_require__(273),
	  'HCurly': __webpack_require__(274),
	  'VCurly': __webpack_require__(275),
	  'RedX': __webpack_require__(276),
	  'ScratchOut': __webpack_require__(277),
	  'QRCode': __webpack_require__(278),
	  'Calendar': __webpack_require__(279),
	  'Webcam': __webpack_require__(280),
	  'AvatarEx': __webpack_require__(281),
	  'AvatarEx2': __webpack_require__(282),
	  'ColumnChart': __webpack_require__(284),
	  'ColumnChartEx': __webpack_require__(285),
	  'BarChart': __webpack_require__(286),
	  'BarChartEx': __webpack_require__(287),
	  'Form': __webpack_require__(288),
	
	  'TextField': __webpack_require__(289),
	  'Spinner': __webpack_require__(290),
	  'AlarmIcon': __webpack_require__(291),
	  'StatusBar(Android)': __webpack_require__(256),
	  'NavigationBar': __webpack_require__(292),
	  'Keyboard': __webpack_require__(293),
	
	  'VolumeSlider': __webpack_require__(294),
	  'VideoPlayer': __webpack_require__(295),
	  'Media_Control': __webpack_require__(296),
	  'PieChart': __webpack_require__(297),
	  'PieChartEx': __webpack_require__(298),
	  'Map': __webpack_require__(299),
	  'CoverFlow': __webpack_require__(300),
	  'EditToolbar': __webpack_require__(301),
	  'FormattingToolbar': __webpack_require__(302),
	  'HelpButton': __webpack_require__(303),
	  'QuickContact': __webpack_require__(304),
	  'Avatar(Mobile)': __webpack_require__(305),
	  'LetterNavigation': __webpack_require__(306),
	  'TimePicker': __webpack_require__(307),
	  'TimePicker2': __webpack_require__(308),
	  'IconButton': __webpack_require__(309),
	  'IconLabel': __webpack_require__(310),
	  'Top ActionBar': __webpack_require__(311),
	  'Contexual ActionBar': __webpack_require__(312),
	  'Control PopOver': __webpack_require__(313),
	  'SiteMap': __webpack_require__(314),
	  'Subtitle': __webpack_require__(194),
	  'BigTitle': __webpack_require__(194),
	  'IconButton2': __webpack_require__(315),
	  'IconLabel2': __webpack_require__(317),
	  'AlarmIcon2': __webpack_require__(318),
	  'IconButtonCommon': __webpack_require__(319),
	  'IconBar': __webpack_require__(320),
	
	  'Timer': __webpack_require__(321),
	  'Repeater': __webpack_require__(322),
	  'RepeaterItem': __webpack_require__(323)
	};
	
	/*视图类型*/
	function isInvisualInteractiveCom(controlTypeID) {
	  var isInvisualCom = false;
	  var typeID = controlTypeID;
	  if (typeID === 'PopupPanel' || typeID === 'HoverPanel' || typeID === 'AlertWindow' || typeID === 'PopupMenu' || typeID === 'SlidingDrawer') {
	    isInvisualCom = true;
	  }
	  return isInvisualCom;
	}
	
	/*链接类型*/
	var LinkAreaLayout = {
	  NONE: 'none',
	  VERTICAL: 'vertical',
	  HORIZONTAL: 'horizontal',
	  CLIENT: 'client',
	  V_AVG: 'v_avg',
	  H_AVG: 'h_avg',
	  CUSTOM: 'custom'
	};
	
	/*组件布局类型绑定*/
	var LinkFitMode = {
	  Button: LinkAreaLayout.CLIENT,
	  Label: LinkAreaLayout.CLIENT,
	  TextArea: LinkAreaLayout.CLIENT,
	  Shape: LinkAreaLayout.CLIENT,
	  Triangle: LinkAreaLayout.CLIENT,
	  Icon: LinkAreaLayout.CLIENT,
	  Image: LinkAreaLayout.CLIENT,
	  TextInput: LinkAreaLayout.CLIENT,
	  Line: LinkAreaLayout.CLIENT,
	  HotSpot: LinkAreaLayout.CLIENT,
	  HRule: LinkAreaLayout.CLIENT,
	  VRule: LinkAreaLayout.CLIENT,
	  CheckBox: LinkAreaLayout.CLIENT,
	  CheckBoxGroup: LinkAreaLayout.NONE,
	  LabelTextInput: LinkAreaLayout.CLIENT,
	  RadioButton: LinkAreaLayout.CLIENT,
	  RadioButtonGroup: LinkAreaLayout.NONE,
	  CompositeComboBox: LinkAreaLayout.CLIENT,
	  List: LinkAreaLayout.HORIZONTAL,
	  ButtonBar: LinkAreaLayout.H_AVG,
	  Menu: LinkAreaLayout.HORIZONTAL,
	  MenuBar: LinkAreaLayout.NONE,
	  ToolTip: LinkAreaLayout.CLIENT,
	  NumericStepper: LinkAreaLayout.CLIENT,
	  DateTimePicker: LinkAreaLayout.CLIENT,
	  ColorPicker: LinkAreaLayout.CLIENT,
	  IconButton: LinkAreaLayout.CLIENT,
	  IconButton2: LinkAreaLayout.CLIENT,
	  IconLabel: LinkAreaLayout.CLIENT,
	  IconLabel2: LinkAreaLayout.CLIENT,
	  VSlider: LinkAreaLayout.CLIENT,
	  HSlider: LinkAreaLayout.CLIENT,
	  VSlider2: LinkAreaLayout.CLIENT,
	  HSlider2: LinkAreaLayout.CLIENT,
	  ModalScreen: LinkAreaLayout.CLIENT,
	  ProgressBar: LinkAreaLayout.CLIENT,
	  CircleProgressBar: LinkAreaLayout.CLIENT,
	  Search: LinkAreaLayout.CLIENT,
	  Alert: LinkAreaLayout.NONE,
	  LinkBar: LinkAreaLayout.H_AVG,
	  BreadCrumbs: LinkAreaLayout.NONE,
	  Tree: LinkAreaLayout.HORIZONTAL,
	
	  SiteMap: LinkAreaLayout.NONE,
	  Gif: LinkAreaLayout.CLIENT,
	  Svg: LinkAreaLayout.CLIENT,
	  DataGrid: LinkAreaLayout.HORIZONTAL,
	  NewTable: LinkAreaLayout.HORIZONTAL,
	  VSplitter: LinkAreaLayout.CLIENT,
	  HSplitter: LinkAreaLayout.CLIENT,
	  GroupBox: LinkAreaLayout.CLIENT,
	  __group__: LinkAreaLayout.CLIENT,
	  VerticalScrollbar: LinkAreaLayout.CLIENT,
	  HorizontalScrollBar: LinkAreaLayout.CLIENT,
	  PageControl: LinkAreaLayout.NONE,
	  VerticalTabBar: LinkAreaLayout.NONE,
	  Tab: LinkAreaLayout.NONE,
	  Accordion: LinkAreaLayout.HORIZONTAL,
	  TitleWindow: LinkAreaLayout.CLIENT,
	  BrowserWindow: LinkAreaLayout.CLIENT,
	  IPhone: LinkAreaLayout.CLIENT,
	  IPad: LinkAreaLayout.CLIENT,
	  Phone: LinkAreaLayout.CLIENT,
	  TabletPC: LinkAreaLayout.CLIENT,
	  Iphone: LinkAreaLayout.CLIENT,
	  Android: LinkAreaLayout.CLIENT,
	  Ipad2: LinkAreaLayout.CLIENT,
	  TabletPC2: LinkAreaLayout.CLIENT,
	  TableView: LinkAreaLayout.HORIZONTAL,
	  TextField: LinkAreaLayout.CLIENT,
	  Tabs: LinkAreaLayout.H_AVG,
	  Switch: LinkAreaLayout.CLIENT,
	  SwitchIOS: LinkAreaLayout.CLIENT,
	  Slider: LinkAreaLayout.CLIENT,
	  ScopeBar: LinkAreaLayout.H_AVG,
	  Spinner: LinkAreaLayout.CLIENT,
	  AlarmIcon: LinkAreaLayout.CLIENT,
	  AlarmIcon2: LinkAreaLayout.CLIENT,
	  'Top ActionBar': LinkAreaLayout.CUSTOM,
	  'Contexual ActionBar': LinkAreaLayout.CLIENT,
	  'Control PopOver': LinkAreaLayout.H_AVG,
	  'StatusBar(IOS)': LinkAreaLayout.CLIENT,
	  'StatusBar(Android)': LinkAreaLayout.CLIENT,
	  Keyboard: LinkAreaLayout.CLIENT,
	  PointyButton: LinkAreaLayout.CLIENT,
	  TimePicker: LinkAreaLayout.CLIENT,
	  LetterNavigation: LinkAreaLayout.CLIENT,
	  'Avatar(Mobile)': LinkAreaLayout.CLIENT,
	  QuickContact: LinkAreaLayout.CLIENT,
	  QRCode: LinkAreaLayout.CLIENT,
	  Calendar: LinkAreaLayout.CLIENT,
	  Webcam: LinkAreaLayout.CLIENT,
	  AvatarEx: LinkAreaLayout.CLIENT,
	  VolumeSlider: LinkAreaLayout.CLIENT,
	  Media_Control: LinkAreaLayout.CLIENT,
	  VideoPlayer: LinkAreaLayout.CLIENT,
	  BarChart: LinkAreaLayout.CLIENT,
	  BarChartEx: LinkAreaLayout.CLIENT,
	  ColumnChart: LinkAreaLayout.CLIENT,
	  ColumnChartEx: LinkAreaLayout.CLIENT,
	  LineChart: LinkAreaLayout.CLIENT,
	  LineChartEx: LinkAreaLayout.CLIENT,
	  PieChart: LinkAreaLayout.CLIENT,
	
	  Map: LinkAreaLayout.CLIENT,
	  CoverFlow: LinkAreaLayout.CLIENT,
	  EditToolbar: LinkAreaLayout.CLIENT,
	  FormattingToolbar: LinkAreaLayout.CLIENT,
	  StickyNote: LinkAreaLayout.CLIENT,
	  Arrow: LinkAreaLayout.CLIENT,
	  CallOut: LinkAreaLayout.CLIENT,
	  HCurly: LinkAreaLayout.CLIENT,
	  VCurly: LinkAreaLayout.CLIENT,
	  RedX: LinkAreaLayout.CLIENT,
	  Graffiti: LinkAreaLayout.CLIENT,
	  ScratchOut: LinkAreaLayout.CLIENT,
	  Panel: LinkAreaLayout.CLIENT,
	  BigTitle: LinkAreaLayout.CLIENT,
	  Subtitle: LinkAreaLayout.CLIENT,
	  Canvas: LinkAreaLayout.CLIENT,
	  ScrollView: LinkAreaLayout.CLIENT,
	  ContentPanel: LinkAreaLayout.CLIENT,
	  ImageCarousel: LinkAreaLayout.CLIENT,
	
	  Timer: LinkAreaLayout.NONE,
	  Repeater: LinkAreaLayout.CLIENT,
	  RepeaterItem: LinkAreaLayout.CLIENT
	};
	
	/*链接坐标等遍历判断*/
	function updateLinkCoords(comp) {
	  var rect;
	
	  if (LinkFitMode[comp.controlTypeID] === LinkAreaLayout.HORIZONTAL) {
	    // 链接宽度始终与组件的宽度相等
	    if (comp.links && comp.links.link) {
	      _.each(comp.links.link, function (link) {
	        rect = util.Rect.strToRect(link.area.coords);
	        util.Rect.setSize(rect, comp.currentW || comp.w);
	        link.area.coords = rect;
	      });
	    }
	    if (comp.interactiveData && comp.interactiveData.entry) {
	      _.each(comp.interactiveData.entry, function (entry) {
	        rect = util.Rect.strToRect(entry.area.coords);
	        util.Rect.setSize(rect, comp.currentW || comp.w);
	        entry.area.coords = rect;
	      });
	    }
	  } else if (LinkFitMode[comp.controlTypeID] === LinkAreaLayout.VERTICAL) {
	    //链接高度始终与组件高度相等
	    if (comp.links && comp.links.link) {
	      _.each(comp.links.link, function (link) {
	        rect = util.Rect.strToRect(link.area.coords);
	        util.Rect.setSize(rect, rect.width, comp.currentH || comp.h);
	        link.area.coords = rect;
	      });
	    }
	    if (comp.interactiveData) {
	      _.each(comp.interactiveData.entry, function (entry) {
	        rect = util.Rect.strToRect(entry.area.coords);
	        util.Rect.setSize(rect, rect.width, comp.currentH || comp.h);
	        entry.area.coords = rect;
	      });
	    }
	  } else if (LinkFitMode[comp.controlTypeID] === LinkAreaLayout.CLIENT) {
	    //链接与组件尺寸相同
	    if (comp.links && comp.links.link) {
	      _.each(comp.links.link, function (link) {
	        rect = util.Rect.strToRect(link.area.coords);
	        util.Rect.setSize(rect, comp.currentW || comp.w, comp.currentH || comp.h);
	        link.area.coords = rect;
	      });
	    }
	    if (comp.interactiveData) {
	      _.each(comp.interactiveData.entry, function (entry) {
	        rect = util.Rect.strToRect(entry.area.coords);
	        util.Rect.setSize(rect, comp.currentW || comp.w, comp.currentH || comp.h);
	        entry.area.coords = rect;
	      });
	    }
	  } else if (LinkFitMode[comp.controlTypeID] === LinkAreaLayout.H_AVG) {
	    //链接水平等分组件
	    if (comp.links && comp.links.link) {
	      var left = 0;
	      var count = comp.links.link.length || 1;
	      var itemW = (comp.currentW || comp.w) / count;
	      _.each(comp.links.link, function (link) {
	        rect = util.Rect.strToRect(link.area.coords);
	        util.Rect.setLocation(rect, left);
	        util.Rect.setSize(rect, itemW, comp.currentH || comp.h);
	        link.area.coords = rect;
	        left += itemW;
	      });
	    }
	    if (comp.interactiveData) {
	      left = 0;
	      _.each(comp.interactiveData.entry, function (entry) {
	        rect = util.Rect.strToRect(entry.area.coords);
	        util.Rect.setLocation(rect, left);
	        util.Rect.setSize(rect, itemW, comp.currentH || comp.h);
	        entry.area.coords = rect;
	        left += itemW;
	      });
	    }
	  } else if (LinkFitMode[comp.controlTypeID] === LinkAreaLayout.CUSTOM) {
	    var link;
	    var entry;
	    if (comp.links && comp.links.link) {
	      link = comp.links.link[0];
	      rect = util.Rect.strToRect(link.area.coords);
	      util.Rect.setLocation(rect, rect.left, ((comp.currentH || comp.h) - rect.height) / 2);
	      link.area.coords = rect;
	
	      link = comp.links.link[1];
	      rect = util.Rect.strToRect(link.area.coords);
	      util.Rect.setLocation(rect, (comp.currentW || comp.w) - 15 - rect.width, ((comp.currentH || comp.h) - rect.height) / 2);
	      link.area.coords = rect;
	    }
	    if (comp.interactiveData) {
	
	      entry = comp.interactiveData.entry[0];
	      rect = util.Rect.strToRect(entry.area.coords);
	      util.Rect.setLocation(rect, rect.left, ((comp.currentH || comp.h) - rect.height) / 2);
	      entry.area.coords = rect;
	
	      entry = comp.interactiveData.entry[1];
	      rect = util.Rect.strToRect(entry.area.coords);
	      util.Rect.setLocation(rect, (comp.currentW || comp.w) - 15 - rect.width, ((comp.currentH || comp.h) - rect.height) / 2);
	      entry.area.coords = rect;
	    }
	  } else {
	    if (comp.links && comp.links.link) {
	      _.each(comp.links.link, function (link) {
	        rect = util.Rect.strToRect(link.area.coords);
	        link.area.coords = rect;
	      });
	    }
	    if (comp.interactiveData) {
	      _.each(comp.interactiveData.entry, function (entry) {
	        rect = util.Rect.strToRect(entry.area.coords);
	        entry.area.coords = rect;
	      });
	    }
	  }
	}
	
	function isCompositeCom(typeID) {
	  return typeID === 'IconButton2' || typeID === 'IconLabel2' || typeID === 'AlarmIcon2';
	}
	
	function isIgnoreCom(typeID) {
	  return typeID === 'Border' || typeID === 'ScrollViewPort' || typeID === 'ScrollViewContentPanel';
	}
	
	function replaceComTypeID(comp) {
	  if (comp.controlTypeID === 'Circle') {
	    comp.controlTypeID = 'Shape';
	  }
	}
	
	function makeComp(comp, comEvents) {
	  try {
	    var c = comp;
	    var Comp;
	
	    updateLinkCoords(c);
	
	    replaceComTypeID(c);
	
	    if (isIgnoreCom(c.controlTypeID)) {
	      return undefined;
	    }
	    //手机设备下，忽略掉状态栏组件
	    // if(envHelper.isMobileDevice() && pageHelper.isStatusBar(c.controlTypeID)) {
	    //   return undefined;
	    // }
	    Comp = Components[c.controlTypeID];
	
	    if (Comp) {
	      Comp.key = c.controlID; // react
	      c.events = comEvents;
	      if (c.controlTypeID === 'CompositeComboBox' && c.hasOwnProperty('baseHeight')) {
	        c.h = c.baseHeight;
	      } else if (isCompositeCom(c.controlTypeID)) {
	        c.textColor = c.items[2].textColor;
	      } else if (c.controlTypeID === 'Timer') {
	        c.interval = c.interval || 1000;
	      }
	      //包含有子组件的情况
	      if (c.items) {
	        //所有非可视化组件
	        if (isInvisualInteractiveCom(c.controlTypeID)) {
	          //其它弹出组件，它们的Content是一个组类型的组件
	          //这里直接忽略掉背景这一层组件
	          if (c.items[1].items) {
	            return React.createElement(
	              Comp,
	              c,
	              c.items[1].items.map(function (_comp) {
	                return makeComp(_comp, comEvents);
	              })
	            );
	          } else {
	            return React.createElement(
	              Comp,
	              c,
	              makeComp(c.items[1], comEvents)
	            );
	          }
	        } else if (c.controlTypeID === 'ContentPanel') {
	          return React.createElement(
	            Comp,
	            _extends({ key: c.controlID }, c),
	            c.items.map(function (_comp, index) {
	              _comp.h = c.h;
	              _comp.w = c.w;
	              _comp.y = 0;
	              _comp.x = 0;
	              _comp.contentLayout = c.contentLayout;
	              _comp.canHoriScroll = c.canHoriScroll;
	              _comp.canVertScroll = c.canVertScroll;
	              _comp.showScrollBars = c.showScrollBars;
	              return React.createElement(
	                LazyLoad,
	                { disabled: c.selectedIndex === index, key: index },
	                React.createElement(
	                  'div',
	                  { key: index, ref: index, id: 'content-' + index, style: {
	                      width: c.w,
	                      height: c.h,
	                      left: 0,
	                      top: 0,
	                      position: 'absolute'
	                    } },
	                  makeComp(_comp, comEvents)
	                )
	              );
	            })
	          );
	        } else {
	          if (c.controlTypeID === 'ImageCarousel') {
	            delete c.links;
	            delete c.interactiveData;
	          }
	          return React.createElement(
	            Component,
	            _extends({ key: '_' + c.controlID }, c),
	            React.createElement(
	              Comp,
	              c,
	              c.items.map(function (_comp, index) {
	                //图片轮播组件把组件本身的填充模式传递到内层图片组件上
	                //这里之所以要把内层图片解析成组件，是考虑到以后图片轮播中可以添加其它组件，可以设置交互等
	                if (c.controlTypeID === 'ImageCarousel') {
	                  _comp.fitMode = c.fitMode;
	                  _comp.color = c.color;
	                  _comp.w = c.w;
	                  _comp.h = c.h;
	                  _comp.currentW = c.currentW;
	                  _comp.currentH = c.currentH;
	                }
	
	                //滚动区中内容层不再创建为一个组件
	                if (_comp.controlTypeID === 'ScrollViewContentPanel' || _comp.controlTypeID == 'ScrollViewPort') {
	                  if (_comp.items) {
	                    if (c.controlTypeID === 'ScrollArea') {
	                      c.viewPortSize = adjustContentPanelChildPosition(_comp.items, c.contentLayout);
	                    }
	                    return _comp.items.map(function (itm) {
	
	                      return makeComp(itm, comEvents);
	                    });
	                  }
	                }
	
	                //对所有组件中如果包含的有边框层的话，都进行忽略
	                if (_comp.controlTypeID !== 'Border') {
	                  return makeComp(_comp, comEvents);
	                }
	              })
	            )
	          );
	        }
	      }
	      //普通组件，不包含子组件
	      return React.createElement(
	        Component,
	        _extends({ key: '_' + c.controlID }, c),
	        React.createElement(Comp, c)
	      );
	    }
	    //拦截显示红字母版丢失
	    if (c.controlTypeID === 'Master') {
	      return React.createElement('div', null);
	    }
	    console.warn('Cannot find component for ' + c.controlTypeID);
	    return React.createElement(
	      'div',
	      { style: {
	          color: 'red'
	        } },
	      'Component ',
	      c.controlTypeID,
	      ' is missing.'
	    );
	  } catch (e) {
	    logHelper.error(e);
	    return React.createElement(
	      'div',
	      { style: {
	          color: 'red'
	        } },
	      'Error in render ',
	      comp.controlTypeID,
	      '.'
	    );
	  }
	}
	
	function adjustContentPanelChildPosition(items, layout) {
	  var x;
	  var y;
	  var w = 0;
	  var h = 0;
	  var i;
	  var item;
	  var l;
	  if (layout === 'clRelatively') {
	    if (items && items.length) {
	      x = items[0].x;
	      y = items[0].y;
	      i = 1;
	      l = items.length;
	      if (l > i) {
	        for (i; i < l; i++) {
	          item = items[i];
	          x = Math.min(x, item.x);
	          y = Math.min(y, item.y);
	        }
	      }
	      i = 0;
	      x -= 1; //补偿左上角1像素的边界
	      y -= 1;
	      for (i; i < l; i++) {
	        item = items[i];
	        item.x -= x;
	        item.y -= y;
	        w = Math.max(w, item.x + item.w);
	        h = Math.max(h, item.y + item.h);
	      }
	    }
	  } else {
	    l = items ? items.length : 0;
	    for (i = 0; i < l; i++) {
	      item = items[i];
	      w = Math.max(w, item.x + item.w);
	      h = Math.max(h, item.y + item.h);
	    }
	  }
	  return {
	    w: w + 2, //补偿两个像素的边界
	    h: h + 2
	  };
	}
	
	exports.makeComp = makeComp;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var styleHelper = __webpack_require__(145);
	var appTypes = __webpack_require__(115);
	var mouseHelper = __webpack_require__(149);
	var versionHelper = __webpack_require__(124);
	var interactiveManager = __webpack_require__(150);
	var LinkArea = __webpack_require__(157);
	var RuntimeOptions = __webpack_require__(153);
	var Log = __webpack_require__(159);
	var util = __webpack_require__(116);
	
	var stateInteractive = __webpack_require__(160);
	
	var Component = React.createClass({
	  displayName: 'Component',
	
	  propTypes: {
	    controlID: React.PropTypes.string.isRequired
	  },
	  mixins: [Log],
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	  render: function render() {
	    if (this.state.error) {
	      return React.createElement(
	        'div',
	        {
	          id: this.props.controlID,
	          key: this.props.controlID,
	          style: this.getCommonStyle(),
	          className: 'component component-render-error component-' + this.props.controlTypeID.replace(/[()]/g, '_')
	        },
	        'Error in render ',
	        this.props.controlTypeID,
	        '.'
	      );
	    }
	    var _props = _.extend({}, this.props, this.state);
	    var style = this.getCommonStyle();
	    var className = 'component component-' + this.props.controlTypeID.replace(/[()]/g, '_');
	    if (!_.isEmpty(this.props.remarkText)) {
	      className += ' component-with-remark';
	    }
	    return React.createElement(
	      'div',
	      { id: this.props.controlID,
	        key: this.props.controlID,
	        className: className,
	        style: style,
	        onClick: this._onClick,
	        onMouseUp: this._onMouseUp,
	        onMouseDown: this._onMouseDown,
	        onMouseOver: this._onMouseOver,
	        onMouseOut: this._onMouseOut,
	        onMouseMove: this._onMouseMove,
	        onMouseEnter: this._onMouseEnter,
	        onMouseLeave: this._onMouseLeave },
	      this.renderChildren(_props),
	      this.props.controlTypeID !== 'Accordion' && this.props.controlTypeID !== '__group__' && this.props.controlTypeID !== 'Panel' && this.props.controlTypeID !== 'Tree' && this.props.controlTypeID !== 'TextInput' && this.props.controlTypeID !== 'Timer' && React.createElement(LinkArea, {
	        k: this.props.controlID + 'linkArea',
	        links: this.props.links,
	        interactive: this.props.interactiveData,
	        size: {
	          width: _.isUndefined(this.props.currentW) ? this.props.w : this.props.currentW,
	          height: _.isUndefined(this.props.currentH) ? this.props.h : this.props.currentH
	        },
	        externalURL: this.props.externalURL,
	        onLinkEvent: this._onLinkEvent,
	        onLongPressEvent: this._onLongPress,
	        onDblClick: this._onDblClick,
	        onRightClick: this._onRightClick
	      })
	    );
	  },
	
	  _onLinkEvent: function _onLinkEvent(evt, linkKey, index) {
	    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
	    if (this.props.controlTypeID === 'CheckBox') {
	      $(ReactDOM.findDOMNode(this).children[0]).trigger('checkedChange', { key: linkKey, nativeEvent: evt });
	      return;
	    } else if (this.props.controlTypeID === 'CheckBoxGroup') {
	      $(ReactDOM.findDOMNode(this).children[0]).trigger('checkedChange', {
	        key: linkKey,
	        index: index,
	        nativeEvent: evt
	      });
	      return;
	    }
	    this.props.events.doSelfClick(evt, this.props, linkKey, index);
	    //当组件上有交互或者页面链接时，会创建出一个LinkArea的层，它会阻挡住多链接组件中项目切换时的点击事件
	    //通过这种方式派发到组件本身上面
	    //需要在组件本身的componentDidMount中，绑定一个itemClick事件
	    $(ReactDOM.findDOMNode(this).children[0]).trigger('itemClick', [index, linkKey, evt]);
	    evt.stopPropagation();
	  },
	
	  _onClick: function _onClick(e) {
	    //此处当组件上没有链接或交互时，LinkArea尺寸为0，则点击不上，故在此处响应外部链接的点击
	    if (this.props.externalURL) {
	      this._onLinkEvent(e, 'url-link');
	    }
	  },
	
	  _onLongPress: function _onLongPress(evt, index) {
	    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
	    if (this.props.events.doSelfLongPress) this.props.events.doSelfLongPress(evt, this.props, index);
	  },
	
	  _onRightClick: function _onRightClick(evt, index) {
	    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
	    if (this.props.events.doSelfRightClick) {
	      this.props.events.doSelfRightClick(evt, this.props, index);
	    }
	  },
	
	  _onDblClick: function _onDblClick(evt, index) {
	    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
	    if (this.props.events.doSelfDbClick) {
	      this.props.events.doSelfDbClick(evt, this.props, index);
	    }
	
	    //兼容组件内部双击交互事件，比如树组件的收缩展开
	    $(ReactDOM.findDOMNode(this).children[0]).trigger('itemDbClick', index);
	  },
	
	  renderChildren: function renderChildren(props) {
	    var _this = this;
	    return React.Children.map(props.children, function (child) {
	      return React.cloneElement(child, _this.state);
	    });
	  },
	
	  getCommonStyle: function getCommonStyle() {
	    var interactiveState = interactiveManager.getInteractiveState();
	    if (interactiveState.isRuning(this.props.controlID)) {
	      //执行交互过程中使用原css，让jquery执行，react先不引起更新
	      return this.historyCss;
	    }
	
	    var opacity = styleHelper.getOpacity(this);
	    var isShow = styleHelper.getVisible(this);
	    var order = styleHelper.getOrder(this.props);
	    var css = {
	      left: styleHelper.getX(this.props),
	      top: styleHelper.getY(this.props),
	      width: styleHelper.getWidth(this.props, this.state),
	      height: styleHelper.getHeight(this.props, this.state),
	      padding: 0,
	      opacity: opacity,
	      zIndex: order
	    };
	    if (!isShow) {
	      css.visibility = 'hidden';
	      css.pointerEvents = 'none';
	      if (!versionHelper.isPageVersionLowerThan4_9()) {
	        css.opacity = 0;
	      }
	    }
	    this.historyCss = css;
	    return css;
	  },
	
	  getInteractiveWorkingStyle: function getInteractiveWorkingStyle() {
	    var opacity = styleHelper.getOpacity(this);
	
	    var css = {
	      left: this.props.x,
	      top: this.props.y,
	      width: this.props.w,
	      height: this.props.h,
	      padding: 0,
	      //overflow: 'visible',
	
	      pointerEvents: this.props.isShow ? 'auto' : 'none', //Allen:组件隐藏是点击事件穿透到下方
	      opacity: this.props.isShow ? opacity : 0,
	      zIndex: this.props.zOrder
	    };
	    return css;
	  },
	
	  /**
	   * 是否可见
	   * @returns {string}‘visible’or 'hidden'
	   */
	  isVisible: function isVisible() {
	    return _.isUndefined(this.props.isShow) || this.props.isShow;
	  },
	
	  componentDidUpdate: function componentDidUpdate(newProps) {
	    if (this.state.showRemark && !this.listeningOnMouseMove) {
	      this.listeningOnMouseMove = true;
	      mouseHelper.onMove(this._onMouseMove);
	    }
	
	    if (!this.state.showRemark && this.listeningOnMouseMove) {
	      // 不需要再显示备注了
	      this.listeningOnMouseMove = null;
	      mouseHelper.offMove(this._onMouseMove);
	    }
	
	    var componentDom = ReactDOM.findDOMNode(this);
	    var isShow = styleHelper.getVisible(this);
	    //this.updateChildDomVisible(componentDom, isShow);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.state.showRemark) {
	      // 如果正在显示备注
	      this.listeningOnMouseMove = null;
	      mouseHelper.offMove(this._onMouseMove);
	      this.props.events.onShowRemark(0, 0, '');
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.stateInteractiveManaer = new stateInteractive(this);
	    var componentDom = ReactDOM.findDOMNode(this);
	    $(componentDom).css({ transform: 'scaleX(1) scaleY(1)' });
	
	    var isShow = styleHelper.getVisible(this);
	    //this.updateChildDomVisible(componentDom, isShow);
	  },
	
	  domVisibleArray: [],
	  //此处更新子元素可见性不是一个好的方案
	  updateChildDomVisible: function updateChildDomVisible(dom, isShow) {
	    if (!isShow) {
	      var children = $(dom).children();
	      for (var i = 0; i < children.length; i++) {
	        var child = children[i];
	        var className = $(child).attr("class");
	        if (className === undefined || className.indexOf('component component-') === -1) {
	          var v = $(child).css('visibility');
	          if (v && v !== "hidden") {
	            var node = {
	              dom: child,
	              value: v
	            };
	            this.domVisibleArray.push(node);
	            $(child).css({ visibility: 'hidden' });
	          }
	
	          this.updateChildDomVisible(child, isShow);
	        }
	      }
	    } else {
	      for (var i = 0; i < this.domVisibleArray.length; i++) {
	        var node = this.domVisibleArray[i];
	        $(node.dom).css({ visibility: node.value });
	      }
	      this.domVisibleArray = [];
	    }
	  },
	  /**
	   * 判断当前组件上是否有交互
	   * @returns {boolean}
	   */
	  hasLinkOrInteractive: function hasLinkOrInteractive() {
	    var links;
	    var link;
	    var interactiveData;
	    var entry;
	    var event;
	    var i = 0;
	    var result = false;
	    links = this.props.links;
	    interactiveData = this.props.interactiveData;
	    for (i; i < links.length; i++) {
	      link = links[i];
	      if (link.targetPageID && link.linkType === 'ltPageLink') {
	        return true;
	      }
	    }
	
	    //todo : mengxiaojiang 多入口是否有交互判断还未完成
	    //i = 0;
	    //for(i ; i< interactiveData.entry.length;i++){
	    //
	    //}
	  },
	
	  displayLinkArea: function displayLinkArea(isShow, isAnimate) {
	    var linkArea;
	    var toOpacity = 0.4;
	    var fromOpacity = 0;
	    if (!isShow) {
	      fromOpacity = toOpacity;
	      toOpacity = 0;
	    }
	    if ((this.props.showLinkAreaInMouseHover || this.props.displayLinkArea) && this.state.hasLinkOrInteractive) {
	      linkArea = $('#linkArea_' + this.props.controlID);
	      if (isAnimate) {
	        linkArea.css({ opacity: fromOpacity }).transition({ opacity: toOpacity, duration: 400 });
	      } else {
	        linkArea.css({ opacity: toOpacity });
	      }
	    }
	  },
	
	  _onMouseUp: function _onMouseUp(e) {
	    this.mousePress = false;
	    var isShow = styleHelper.getVisible(this);
	    if (isShow) {
	      this.stateInteractiveManaer.mouseUp(e);
	      this.displayLinkArea(false);
	    }
	  },
	
	  _onMouseDown: function _onMouseDown(e) {
	    this.mousePress = true;
	    //this.doTriggerStates(appTypes.StateEventType.MOUSE_DOWN, true);
	
	    this.stateInteractiveManaer.mouseDown(e);
	    this.displayLinkArea(true);
	  },
	
	  _onMouseOver: function _onMouseOver(e) {
	    this.stateInteractiveManaer.mouseEnter(e);
	  },
	
	  _onMouseOut: function _onMouseOut(e) {
	    // var isShow = styleHelper.getVisible(this);
	    // if (isShow) {
	    //   //this.stateInteractiveManaer.mouseLeave(e);
	    //   this.displayLinkArea(false);
	    // }
	    var isShow = styleHelper.getVisible(this);
	    if (isShow) {
	      this.stateInteractiveManaer.mouseLeave(e);
	      this.displayLinkArea(false);
	    }
	    //var isShow = styleHelper.getVisible(this);
	    //if (isShow) {
	    //  this.stateInteractiveManaer.mouseLeave(e);
	    //  this.displayLinkArea(false);
	    //}
	  },
	
	  _onMouseEnter: function _onMouseEnter(e) {
	    var self = this;
	    e.cancelBubble = true;
	    this.stateInteractiveManaer.mouseEnter(e);
	    this.displayLinkArea(true);
	    //this.stateInteractiveManaer.mouseEnter(e);
	    //this.displayLinkArea(true);
	    this.stateInteractiveManaer.mouseEnter(e);
	    //this.displayLinkArea(true);
	    if (!_.isEmpty(this.props.remarkText)) {
	      var rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
	      this.setState({
	        showRemark: true
	      }, function () {
	        if (self.props.events && self.props.events.onShowRemark) {
	          self.props.events.onShowRemark(rect.left + rect.width, rect.top + rect.height, this.props.remarkText);
	        }
	      });
	    }
	  },
	
	  _onMouseLeave: function _onMouseLeave(e) {
	    var self = this;
	    var isShow = styleHelper.getVisible(this);
	    if (isShow) {
	      this.stateInteractiveManaer.mouseLeave(e);
	      this.displayLinkArea(false);
	    }
	    //var isShow = styleHelper.getVisible(this);
	    //if (isShow) {
	    //  this.stateInteractiveManaer.mouseLeave(e);
	    //  this.displayLinkArea(false);
	    //}
	    var isShow = styleHelper.getVisible(this);
	    if (isShow) {
	      this.stateInteractiveManaer.mouseLeave(e);
	      this.displayLinkArea(false);
	    }
	    if (this.state.showRemark) {
	      this.setState({
	        showRemark: false
	      }, function () {
	        if (self.props.events && self.props.events.onShowRemark) {
	          self.props.events.onShowRemark(0, 0, '');
	        }
	      });
	    }
	  },
	
	  /**
	   * 监听 mouse move 事件
	   * @param e
	   * @private
	   */
	  _onMouseMove: function _onMouseMove(e) {
	    //this._onMouseOver(e);
	    this._onMouseOver(e);
	  }
	});
	
	module.exports = Component;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(51);
	var convertHelper = __webpack_require__(146);
	var dataHelper = __webpack_require__(113);
	var appTypes = __webpack_require__(115);
	var propConst = __webpack_require__(147);
	var util = __webpack_require__(116);
	var measureHelper = __webpack_require__(148);
	var versionHelper = __webpack_require__(124);
	
	exports.getPropertyValue = function (props, name) {
	  var v;
	  var stateProperties = props.stateProperties;
	  var upperName = name.charAt(0).toUpperCase() + name.substring(1);
	  var currentPName = 'current' + upperName;
	  if (stateProperties && stateProperties.hasOwnProperty(name)) {
	    v = stateProperties[name];
	  } else {
	    if (props.hasOwnProperty(currentPName)) {
	      v = props[currentPName];
	    }
	    if (_.isUndefined(v)) {
	      v = props[name];
	      if (_.isUndefined(v)) {
	        v = props[upperName];
	      }
	    }
	  }
	  return v;
	};
	
	exports.getStateProperty = function (props, name) {
	  var v = undefined;
	  if (props.stateProperties) {
	    if (props.stateProperties.hasOwnProperty(name)) {
	      v = props.stateProperties[name];
	    }
	  }
	  return v;
	};
	
	exports.getOriginalProperty = function (props, name) {
	  return props[name];
	};
	
	exports.getInt = function (props, name) {
	  var v = this.getPropertyValue(props, name);
	  if (_.isUndefined(v)) {
	    return 0;
	  }
	  return parseInt(v, 10);
	};
	
	exports.getFloat = function (props, name) {
	  var v = this.getPropertyValue(props, name);
	  if (_.isUndefined(v)) {
	    return 0;
	  }
	  return parseFloat(v);
	};
	
	exports.getOrder = function (props) {
	  if (_.isUndefined(props.currentOrder)) return props.zOrder;
	  return props.currentOrder;
	};
	
	/**
	 * 获取组件的透明度
	 * @param comp React.CreateElement的对象
	 * @returns {*} float (0-1)
	 */
	exports.getOpacity = function (comp) {
	  var props = comp.props;
	  var state = comp.state;
	
	  if (state) {
	    if (state.stateProperties) {
	      if (!_.isUndefined(state.stateProperties.opacity)) {
	        return parseInt(state.stateProperties.opacity, 10) / 100;
	      }
	    }
	  }
	  if (!_.isUndefined(props.currentOpacity)) {
	    return parseInt(props.currentOpacity, 10) / 100;
	  }
	  if (_.isUndefined(props.opacity)) {
	    return 1;
	  }
	  return parseFloat(props.opacity);
	};
	
	/**
	 * 获取组件的可见状态
	 * @param comp React.CreateElement 的对象
	 * @returns {*} bool
	 */
	exports.getVisible = function (comp) {
	  var props = comp.props;
	  var state = comp.state;
	  if (state) {
	    if (state.stateProperties) {
	      if (!_.isUndefined(state.stateProperties.isShow)) {
	        return state.stateProperties.isShow;
	      }
	    }
	  }
	
	  if (!_.isUndefined(props.currentVisible)) {
	    return props.currentVisible;
	  }
	
	  if (_.isUndefined(props.isShow)) {
	    return true;
	  }
	  return props.isShow;
	};
	
	exports.getTextColor = function (props) {
	  var c = this.getPropertyValue(props, 'textColor');
	
	  if (props.isAutoTextColor) {
	    if (dataHelper.isLightColor(props.color)) {
	      return '#000';
	    } else {
	      return '#fff';
	    }
	  }
	
	  return c || '#000';
	};
	
	exports.getSelectedTextColor = function (props) {
	  return this.getPropertyValue(props, propConst.SELECTED_TEXT_COLOR);
	};
	
	exports.getWidth = function (props, state) {
	  if (state && state.stateProperties && !_.isUndefined(state.stateProperties.Width)) {
	    return state.stateProperties.Width;
	  }
	  if (props.stateProperties && !_.isUndefined(props.stateProperties.Width)) {
	    return props.stateProperties.Width;
	  }
	  if (_.isUndefined(props.currentW)) return props.w;
	  return props.currentW;
	};
	
	exports.getX = function (props) {
	  return this.getPropertyValue(props, 'x');
	};
	
	exports.getY = function (props) {
	  return this.getPropertyValue(props, 'y');
	};
	
	exports.getPoint = function (props) {
	  return {
	    x: this.getX(props),
	    y: this.getY(props)
	  };
	};
	exports.getHeight = function (props, state) {
	  if (state && state.stateProperties && !_.isUndefined(state.stateProperties.Height)) {
	    return state.stateProperties.Height;
	  }
	  if (props.stateProperties && !_.isUndefined(props.stateProperties.Height)) {
	    return props.stateProperties.Height;
	  }
	  if (_.isUndefined(props.currentH)) return props.h;
	  return props.currentH;
	};
	
	exports.getSize = function (props) {
	  return {
	    width: this.getWidth(props),
	    height: this.getHeight(props)
	  };
	};
	
	exports.getText = function (props) {
	  var t = props.currentText || props.text;
	  if (props.stateProperties) {
	    if (props.stateProperties.hasOwnProperty(propConst.TEXT)) {
	      t = props.stateProperties[propConst.TEXT];
	    } else if (props.stateProperties.hasOwnProperty(propConst.MULTI_LINE_TEXT)) {
	      t = props.stateProperties[propConst.MULTI_LINE_TEXT];
	    }
	  }
	  return t;
	};
	
	exports.getBackgroundColor = function (props) {
	  var c = props.currentColor || props.color;
	  if (props.stateProperties) {
	    if (props.stateProperties.color) {
	      c = props.stateProperties.color;
	    }
	  }
	  return c;
	};
	
	exports.getFontSize = function (props) {
	  var s = props.textSize;
	  if (props.stateProperties && props.stateProperties.textSize) {
	    s = props.stateProperties.textSize;
	  }
	  return parseInt(s, 10) || 14;
	};
	
	exports.getBorderWidth = function (props) {
	  return this.getPropertyValue(props, propConst.THICKNESS) || 1;
	};
	
	exports.getBorderVisible = function (props) {
	  return this.getPropertyValue(props, propConst.BORDER_VISIBLE);
	};
	
	exports.parseDashMode = function (v) {
	  var value = appTypes.DashMode[v];
	  if (value) {
	    return value;
	  }
	  return v;
	};
	
	exports.getSelectedColor = function (props) {
	  return this.getPropertyValue(props, propConst.SELECTED_COLOR);
	};
	
	exports.getRadius = function (props) {
	  var radius = 0;
	  var w = this.getWidth(props);
	  var h = this.getHeight(props);
	  var r = this.getPropertyValue(props, 'radius') || this.getPropertyValue(props, 'borderRadius') || 0;
	  if (_.isUndefined(props.radiusIsPercent) || props.radiusIsPercent) {
	    radius = Math.min(r * 0.005, 0.5) * Math.min(w, h);
	  } else {
	    radius = Math.min(r, Math.min(w, h) / 2);
	  }
	  return radius;
	};
	
	exports.getBorderColor = function (props) {
	  return this.getPropertyValue(props, propConst.BORDER_COLOR);
	};
	
	exports.builderTextStyle = function (props, style) {
	  if (!props.controlTypeID) {
	    // 说明这不是一个组件
	    return style;
	  }
	  if (!style) {
	    style = {};
	  }
	  style.fontSize = this.getPropertyValue(props, 'textSize');
	
	  if (props.textStyles) {
	    style.fontWeight = props.textStyles.fontWeight;
	    style.fontStyle = props.textStyles.fontStyle;
	    style.textDecoration = props.textStyles.textDecoration;
	  } else {
	    style.textDecoration = 'inherit';
	  }
	
	  // 4.3 版本开始，使用了新的字体策略
	  if (versionHelper.isPageVersionLowerThan4_3()) {
	    style.fontFamily = props.textFontFamily;
	  } else {
	    style.fontFamily = dataHelper.decodeURIComponent(props.font.family.replace(/\+/g, '%20'));
	    style.fontWeight = props.font.weight;
	  }
	
	  style.color = this.getTextColor(props);
	
	  return style;
	};
	
	exports.builderBackgroundStyle = function (props, style) {
	  if (!style) {
	    style = {};
	  }
	  style.backgroundColor = this.getPropertyValue(props, 'color'); // this.getBackgroundColor(props);
	  return style;
	};
	
	/*
	 临时处理的边框样式
	 */
	var tempBorderMode = {
	  solid: appTypes.DashMode.SdSolid,
	  dashed: appTypes.DashMode.SdDash,
	  dotted: appTypes.DashMode.SdDot,
	  'dash-dot': appTypes.DashMode.SdDash,
	  'dash-dot-dot': appTypes.DashMode.SdDot
	};
	
	exports.builderBorderStyle = function (props, style) {
	  var borderVisible = this.getPropertyValue(props, 'borderVisible');
	  if (!style) {
	    style = {};
	  }
	
	  style.borderRadius = this.getRadius(props);
	  style.borderWidth = this.getPropertyValue(props, 'thickness') || 1; // props.borderWidth || props.thickness || 1;
	  style.borderColor = this.getPropertyValue(props, 'borderColor');
	
	  if (borderVisible) {
	    if (props.dashMode) {
	      style.borderStyle = tempBorderMode[props.dashMode];
	    }
	    if (!style.borderStyle) {
	      style.borderStyle = 'solid';
	    }
	    style.boxSizing = 'border-box';
	  } else {
	    style.borderWidth = 'inherit';
	  }
	
	  return style;
	};
	
	exports.builderTextAlign = function (props, style) {
	  if (!style) {
	    style = {};
	  }
	  if (props.textAlign) {
	    style.textAlign = convertHelper.getTextHorizontalAlign(props.textAlign);
	  }
	
	  return style;
	};
	
	exports.builderBaseStyle = function (props, style) {
	  if (!style) {
	    style = {};
	  }
	  style.width = props.currentW || props.w;
	  style.height = props.currentH || props.h;
	  style.left = 0;
	  style.top = 0;
	  return style;
	};
	
	exports.builderLineHeight = function (props) {
	  var style = this.builderTextStyle(props);
	  var lineHeight = this.getInt(props, propConst.LINE_SPACING);
	  var lineSpacingMultiple = 0;
	  var textHeight;
	  if (!_.isUndefined(props.lineSpacingMultiple)) {
	    lineSpacingMultiple = props.lineSpacingMultiple;
	  }
	  if (!lineHeight) {
	    if (lineSpacingMultiple) {
	      textHeight = Math.floor(measureHelper.measureTextWidth(style, 'dp').height);
	      if (textHeight < 20) {
	        textHeight -= 1;
	      }
	      lineHeight = Math.round(textHeight * lineSpacingMultiple);
	    }
	  }
	  return lineHeight;
	};
	
	/**
	 * 样式构建帮助方法
	 * 使用方式，styleHelper.StyleUtil(this.props,style).size().background().border().text().align().style;
	 * @param props 组件的数据
	 * @param style 初始样式，如果该值为空，则需要在构建完成之后，使用style属性获取构建的结果，如果不为空，以始终使用该值
	 * @returns {exports.StyleUtil}
	 * @constructor
	 */
	exports.StyleUtil = function (props, style) {
	  var self = this;
	  var _style = style;
	
	  function clone() {
	    var k;
	    if (_style) {
	      for (k in self.style) {
	        _style[k] = self.style[k];
	      }
	    }
	  }
	  this.background = function () {
	    exports.builderBackgroundStyle(props, self.style);
	    clone();
	    return self;
	  };
	  this.border = function () {
	    exports.builderBorderStyle(props, self.style);
	    clone();
	    return self;
	  };
	  this.text = function () {
	    exports.builderTextStyle(props, self.style);
	    clone();
	    return self;
	  };
	
	  this.wrap = function (isWrap) {
	    if (_.isUndefined(isWrap)) {
	      isWrap = props.textWordWrap;
	    }
	    if (isWrap) {
	      self.style.whiteSpace = 'normal';
	      self.style.wordWrap = 'break-word';
	    } else {
	      self.style.whiteSpace = 'nowrap';
	      self.style.wordWrap = 'nowrap';
	    }
	    clone();
	    return self;
	  };
	
	  this.align = function () {
	    exports.builderTextAlign(props, self.style);
	    clone();
	    return self;
	  };
	  this.lineHeight = function (isWrap) {
	    var h = props.h;
	    var t = props.text;
	    if (_.isUndefined(isWrap)) {
	      if (!_.isUndefined(props.textWordWrap)) {
	        isWrap = false;
	      } else {
	        isWrap = props.textWordWrap;
	      }
	    }
	    if (isWrap) {
	      h = props.textSize * 1.33;
	    }
	    self.style.lineHeight = h + 'px';
	    clone();
	    return self;
	  };
	  this.size = function () {
	    self.style.width = props.currentW || props.w;
	    self.style.height = props.currentH || props.h;
	    clone();
	    return self;
	  };
	  this.point = function () {
	    self.style.left = props.currentX || props.x;
	    self.style.top = props.currentY || props.y;
	    clone();
	    return self;
	  };
	
	  this.bounds = function () {
	    self.point().size();
	    return self;
	  };
	
	  this.default = function (style) {
	    _style = style;
	    if (self.style && style) {
	      _.extend(self.style, style);
	    }
	    clone();
	    return self;
	  };
	
	  this.base = function () {
	    if (_.isUndefined(self.style.left)) self.style.left = 0;
	    if (_.isUndefined(self.style.top)) self.style.top = 0;
	    if (_.isUndefined(self.style.width)) self.style.width = '100%';
	    if (_.isUndefined(self.style.height)) self.style.height = '100%';
	
	    self.style.position = 'absolute';
	    self.style.overflow = 'hidden';
	    self.style.boxSizing = 'border-box';
	    self.style.zIndex = parseInt(props.zOrder, 10);
	    clone();
	    return self;
	  };
	  //这里不清理的话，会造成该值永远存在
	  delete this.style;
	
	  this.default(style);
	
	  if (!this.style) {
	    this.style = {};
	  }
	  return this;
	};
	
	/**
	 * 较正字号样式，当字号小于12号时，浏览器会强制限制到12号，此时需要通过对呈现文字的label,p等标签应用缩放样式。
	 * 注意，这个较正后的样式只能应用到最终呈现文字的标签上。
	 * @param style
	 */
	exports.adjustTextSizeStyle = function (style) {
	  var fontSize = parseInt(style.fontSize, 10);
	  var scale;
	  if (fontSize < 12) {
	    scale = fontSize / 12;
	    style.position = 'absolute';
	    style.transform = 'scale(' + scale + ')';
	    style.WebkitTransformOriginY = 0;
	    style.WebkitTransformOriginX = 0;
	  }
	};
	
	exports.calculeTextSize = function (size, fontSize) {
	  var scale = 1;
	  if (fontSize < 12) {
	    scale = fontSize / 12;
	  }
	  util.Size.scale(size, scale);
	  return scale;
	};
	
	exports.shrinkageWordSpacing = function (style) {
	  var fontSize = style.fontSize;
	  if (fontSize) {
	    style.letterSpacing = Math.min(-(fontSize - 14) / 15, 0);
	  }
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Marsh on 2016.5.19.
	 */
	
	'use strict';
	
	var appTypes = __webpack_require__(115);
	
	exports.getTextAlign = function (horizontalAlign, verticalAlign) {
	  var rsStyle = {
	    position: 'absolute'
	  };
	
	  switch (horizontalAlign) {
	    case 'HaLeft':
	      rsStyle.left = '0px';
	      switch (verticalAlign) {
	        case 'VaTop':
	          rsStyle.top = '0px';
	          break;
	        case 'VaMiddle':
	          rsStyle.top = '50%';
	          rsStyle.transform = 'translateY(-50%)';
	          break;
	        case 'VaBottom':
	          rsStyle.bottom = '0px';
	          break;
	      }
	      break;
	    case 'HaCenter':
	      rsStyle.left = '50%';
	      switch (verticalAlign) {
	        case 'VaTop':
	          rsStyle.top = '0px';
	          rsStyle.transform = 'translateX(-50%)';
	          break;
	        case 'VaMiddle':
	          rsStyle.top = '50%';
	          rsStyle.transform = 'translate(-50%,-50%)';
	          break;
	        case 'VaBottom':
	          rsStyle.bottom = '0px';
	          rsStyle.transform = 'translateX(-50%)';
	          break;
	      }
	      break;
	    case 'HaRight':
	      rsStyle.right = '0px';
	      switch (verticalAlign) {
	        case 'VaTop':
	          rsStyle.top = '0px';
	          break;
	        case 'VaMiddle':
	          rsStyle.top = '50%';
	          rsStyle.transform = 'translateY(-50%)';
	          break;
	        case 'VaBottom':
	          rsStyle.bottom = '0px';
	          break;
	      }
	      break;
	  }
	
	  return rsStyle;
	};
	
	exports.getTextHorizontalAlign = function (horizontalAlign) {
	  var rsAlign;
	
	  switch (horizontalAlign) {
	    case 'HaLeft':
	      rsAlign = 'left';
	      break;
	    case 'HaCenter':
	      rsAlign = 'center';
	      break;
	    case 'HaRight':
	      rsAlign = 'right';
	      break;
	    case '0':
	      rsAlign = 'left';
	      break;
	    case '1':
	      rsAlign = 'center';
	      break;
	    case '2':
	      rsAlign = 'right';
	      break;
	  }
	  return rsAlign;
	};
	
	exports.getFlexVerticalAlign = function (verticalAlign) {
	  var rsAlign;
	
	  switch (verticalAlign) {
	    case 'VaTop':
	      rsAlign = 'flex-start';
	      break;
	    case 'VaMiddle':
	      rsAlign = 'center';
	      break;
	    case 'VaBottom':
	      rsAlign = 'flex-end';
	      break;
	    case '0':
	      rsAlign = 'flex-start';
	      break;
	    case '1':
	      rsAlign = 'center';
	      break;
	    case '2':
	      rsAlign = 'flex-end';
	      break;
	  }
	  return rsAlign;
	};
	
	exports.getFlexHorizontalAlign = function (horizontalAlign) {
	  var rsAlign;
	
	  switch (horizontalAlign) {
	    case 'HaLeft':
	      rsAlign = 'flex-start';
	      break;
	    case 'HaCenter':
	      rsAlign = 'center';
	      break;
	    case 'HaRight':
	      rsAlign = 'flex-end';
	      break;
	  }
	  return rsAlign;
	};
	
	/***
	 * 获取通常情况下的文本组件的文本样式
	 * 注意，这里生成的样式是附加到文字所属的容器上的
	 * @author mengxiaojiang
	 * @createDate 2016-6-6
	 * @param props
	 * @param isMultiLineText 是否为多行文本
	 * @returns {{
	 *              left: 0,
	 *              top: 0,
	 *              width: '100%',
	 *              height: '100%',
	 *              fontFamily: (cssKeyMap.textFontFamily|{name, type}),
	 *              fontSize: (cssKeyMap.textSize|{name, type}),
	 *              fontColor: (*|cssKeyMap.textColor|{name, type}),
	 *              textAlign: *,
	 *              fontWeight: *,
	 *              textDecoration: *,
	 *              fontStyle: *,
	 *              lineHeight: string,
	 *              paddingTop: (string|*|number),
	 *              paddingBottom: (string|*|number),
	 *              overflow : 'hidden',
	 *              textOverflow : 'clip',
	 *              position: 'absolute'
	 *          }}
	 */
	exports.getNormalTextCSS = function (props, isMultiLineText) {
	  var textStyles = props.textStyles;
	  var fontFamily = props.textFontFamily;
	  var bold = textStyles.fontWeight;
	  var textDecoration = textStyles.textDecoration;
	  var fontStyle = textStyles.fontStyle;
	  var fontSize = props.textSize;
	  var fontColor = props.textColor;
	  var fontHortAlign = props.textAlign;
	  var lineHeight = props.h + 'px';
	  var vertAlign = props.textVAlign;
	  var height = props.h;
	  var paddingTop = props.paddingTop || 2;
	  var paddingBottom = props.paddingBottom || 2;
	
	  switch (fontHortAlign) {
	    case appTypes.HoriAlign.CENTER:
	      fontHortAlign = 'center';
	      break;
	    case appTypes.HoriAlign.LEFT:
	      fontHortAlign = 'left';
	      break;
	    case appTypes.HoriAlign.RIGHT:
	      fontHortAlign = 'right';
	      break;
	  }
	
	  var CSS = {
	    left: 0,
	    top: 0,
	    width: '100%',
	    height: '100%',
	    fontFamily: fontFamily,
	    fontSize: fontSize,
	    fontColor: fontColor,
	    textAlign: fontHortAlign,
	    fontWeight: bold,
	    textDecoration: textDecoration,
	    fontStyle: fontStyle,
	    paddingTop: paddingTop,
	    paddingBottom: paddingBottom,
	    overflow: 'hidden',
	    textOverflow: 'clip',
	    position: 'relative',
	    verticalAlign: 'middle'
	  };
	  if (!isMultiLineText) {
	    switch (vertAlign) {
	      case appTypes.VertAlign.BOTTOM:
	        lineHeight = (height - paddingBottom - paddingTop) * 2 - fontSize;
	        break;
	      case appTypes.VertAlign.TOP:
	        lineHeight = fontSize + paddingTop;
	        break;
	      case appTypes.VertAlign.MIDDLE:
	        lineHeight = height - paddingBottom - paddingTop;
	        break;
	    }
	  } else {
	    lineHeight = fontSize * (parseFloat(props.lineSpacingMultiple) + 0.33); //0.33为行距为1时的默认最小间距
	    if (props.textWordWrap) {
	      CSS.wordWrap = 'break-word';
	    } else {
	      CSS.whiteSpace = 'nowrap';
	    }
	  }
	  lineHeight += 'px';
	  CSS.lineHeight = lineHeight;
	  return CSS;
	};

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  CONTROL_ID: "controlID",
	  CONTROL_TYPE_ID: "controlTypeID",
	  IS_SHOW: "isShow",
	  CAPTION: "caption",
	  X: "x",
	  Y: "y",
	  W: "w",
	  H: "h",
	  MEASURED_WIDTH: "measuredW",
	  MEASURED_HEIGHT: "measuredH",
	  Z_ORDER: "zOrder",
	  LOCKED: "locked",
	  SIZE_LOCKED: "sizeLocked",
	  COLOR: "color",
	  BORDER_VISIBLE: "borderVisible",
	  BORDER_COLOR: "borderColor",
	  IS_AUTO_SIZE: "isAutoSize",
	  STATUS: "status",
	  OPACITY: "opacity",
	  IS_COMMENT_COM: "isCommentCom",
	  CAN_MOVE: "canMove",
	  ALIAS: "alias",
	  ROTATION: "rotation",
	  VERTICAL_SCROLL_BAR_SHOW: "verticalScrollbarShow",
	  CHAR_DATA: "CharData",
	  VERTICAL_SCROLL_BAR_PROGRESS: "verticalScrollbarProgress",
	  HORIZONTAL_SCROLL_BAR_SHOW: "horizontalScrollbarShow",
	  HORIZONTAL_SCROLL_BAR_PROGRESS: "horizontalScrollbarProgress",
	  TEXT_COLOR: "textColor",
	  TEXT_SIZE: "textSize",
	  TEXT_FONT_FAMILY: "textFontFamily",
	  LINE_SPACING_MULTIPLE: "lineSpacingMultiple",
	  LINE_SPACING: 'lineSpacing',
	  TEXT_ALIGN: "textAlign",
	  TEXT_V_ALIGN: "textVAlign",
	  TEXT_WORDWRAP: "textWordWrap",
	  TEXT_STYLES: "textStyles",
	  SELECTED_INDEX: "selectedIndex",
	  SELECTED_COLOR: "selectedColor",
	  TEXT_PADDING: "textPadding",
	  SHAPE_BORDER_TYPE: "shapeBorderType",
	  TRIANGLE_TYPE: "triangleType",
	  DASH_MODE: "dashMode",
	  RECTANGLE_BORDER_LEFT_VISIBLE: "rectangleBorderLeftVisible",
	  RECTANGLE_BORDER_RIGHT_VISIBLE: "rectangleBorderRightVisible",
	  RECTANGLE_BORDER_TOP_VISIBLE: "rectangleBorderTopVisible",
	  RECTANGLE_BORDER_BOTTOM_VISIBLE: "rectangleBorderBottomVisible",
	  RADIUS: "radius",
	  RADIUS_IS_PERCENT: "radiusIsPercent",
	  THICKNESS: "thickness",
	  TEXT: "text",
	  BUTTON_STATUS: "buttonStatus",
	  IS_AUTO_TEXT_COLOR: "IsAutoTextColor",
	  ROTATION_ANGLE: "rotationAngle",
	  ICON: "icon",
	  ID: "ID",
	  ICON_FONT_NAME: "iconFontName",
	  ICON_CODE: "iconCode",
	  URL: "URL",
	  FLIP_HORIZONTAL: "flipHorizontal",
	  FLIP_VERTICAL: "flipVertical",
	  CLIP_SHAPE_TYPE: "clipShapeType",
	  FILTER_TYPE: "filterType",
	  FILTER_PENCIL_VALUE: "filterPencilValue",
	  FILTER_SKETCH_VALUE: "filterSketchValue",
	  FIT_MODE: "fitMode",
	  CAN_INPUT: "canInput",
	  CONTROL_POINT: "controlPoint",
	  START_POINT: "startPoint",
	  END_POINT: "endPoint",
	  TEXT_BACKGROUND_COLOR: "textBackgroundColor",
	  TEXT_BORDER_COLOR: "textBorderColor",
	  SHOW_START_ARROW: "showStartArrow",
	  SHOW_END_ARROW: "showEndArrow",
	  IS_CURVED: "isCurved",
	  IS_TEXT_POS_CENTER: "isTextPosCenter",
	  ANI_TYPE: "aniType",
	  PLAY_INTERVAL: "playInterval",
	  IS_AUTO_PLAY: "isAutoPlay",
	  INDICATOR_DIRECTION: "indicatorDirection",
	  INDICATOR_TYPE: "indicatorType",
	  INDICATOR_COLOR: "indicatorColor",
	  IS_SHOW_INDICATOR: "isShowIndicator",
	  CONTENT_LAYOUT: "contentLayout",
	  CAN_HORI_SCROLL: "canHoriScroll",
	  CAN_VERT_SCROLL: "canVertScroll",
	  SHOW_SCROLL_BARS: "showScrollBars",
	  //THINKNESS: "thinkness",
	  STATE: "state",
	  TEXT_DIRECTION: "textDirection",
	  GAP: "gap",
	  SIZE: "size",
	  ROW_GAP: "rowGap",
	  COLUMN_GAP: "columnGap",
	  ITEM_HEIGHT: "itemHeight",
	  COLUMN_COUNT: "columnCount",
	  IS_INTERLACE: "isInterlace",
	  INTERLACE_COLOR: "interlaceColor",
	  SHOW_H_LINE: "showHLine",
	  SHOW_H_LINE2: "ShowHLine",
	  ROW_COUNT: "rowCount",
	  BASE_HEIGHT: "baseHeight",
	  SHOW_HOVER: "showHover",
	  HOVERED_COLOR: "hoveredColor",
	  SELECTED_TEXT_COLOR: "selectedTextColor",
	  TIP_CORNER_DIRECTION: "tipCornerDirection",
	  STYLE: "style",
	  ICON_SIZE: "iconSize",
	  SHOW_TEXT: "showText",
	  SHOW_ALARM: "showAlarm",
	  ALARM_COLOR: "AlarmColor",
	  ALARM_TEXT: "AlarmText",
	  PROGRESS: "progress",
	  BAR_STYLE: "barStyle",
	  TRACK_COLOR: "trackColor",
	  VALUE: "value",
	  SELECTION: "selection",
	  BORDER_STYLE: "borderStyle",
	  SHOW_V_LINE: "showVLine",
	  SHOW_V_LINE2: 'ShowVLine',
	  SHOW_HEADER: "showHeader",
	  DIRECTION: "direction",
	  TAB_HEIGHT: "tabHeight",
	  TAB_WIDTH: "tabWidth",
	  TAB_POSITION: "tabPosition",
	  SHOW_MIN: "showMin",
	  SHOW_MAX: "showMax",
	  SHOW_CLOSE: "showClose",
	  SHOW_DRAG: "showDrag",
	  TOP_HEIGHT: "topHeight",
	  BOTTOM_HEIGHT: "bottomHeight",
	  PHONE_TYPE: "phoneType",
	  IS_TRANSPARENT: "isTransparent",
	  FULL_SCREEN: "fullScreen",
	  SHOW_ICON: "showIcon",
	  INDICATOR_PERCENT_WIDTH: "indicatorPercentWidth",
	  INDICATOR_HEIGHT: "indicatorHeight",
	  DIVIDER_PERCENT_HEIGHT: "dividerPercentHeight",
	  DIVIDER_COLOR: "dividerColor",
	  IS_OPEN: "isOpen",
	  OPEN_COLOR: 'onColor',
	  CLOSE_COLOR: 'offColor',
	  BACKGROUND_COLOR: 'color',
	  SHOW_MENU: "showMenu",
	  SHOW_BACK: "showBack",
	  ICON_COLOR: "iconColor",
	  FOREGROUND_COLOR: "ForegroundColor",
	  KEYBOARD_TYPE: "keyboardType",
	  FILTER: "filter",
	  IS_SHOW_TAB_BAR: "isShowTabBar",
	  STROKE_THICKNESS: "strokeThickness",
	  POINT_LIST: "pointList",
	  MULTI_LINE_TEXT: 'multilineText',
	  SHOW_SEPARATOR: 'showSeparator',
	  SEPARATOR_COLOR: 'separatorColor',
	  ICON_STYLE: 'iconStyle',
	  TAB_STYLE: 'tabStyle',
	  TAB_COLOR: 'tabColor',
	  TAB_EDGE: 'tabEdge',
	  TAB_DIRECTION: 'tabDirection',
	  ON_COLOR: 'onColor',
	  OFF_COLOR: 'offColor',
	  COLUMN_RATIO: 'columnRatio'
	};

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	'use strict';
	
	var cachedSize = {};
	
	exports.measureTextWidth = function (style, text) {
	  var domCom;
	  var cacheKey = JSON.stringify(style) + text;
	
	  if (cachedSize[cacheKey]) {
	    return cachedSize[cacheKey];
	  }
	
	  domCom = document.getElementById('measure');
	  domCom.innerText = text;
	  domCom.style.fontSize = style.fontSize + 'px';
	  domCom.style.fontStyle = style.fontStyle;
	  domCom.style.textDecoration = style.textDecoration;
	  domCom.style.fontWeight = style.fontWeight;
	  domCom.style.fontFamily = style.fontFamily;
	
	  cachedSize[cacheKey] = {
	    width: domCom.clientWidth,
	    height: domCom.clientHeight
	  };
	  return {
	    width: domCom.clientWidth,
	    height: domCom.clientHeight
	  };
	};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var optimizeCall = __webpack_require__(136);
	var envHelper = __webpack_require__(48);
	
	var optimizeMouseMoveCall = optimizeCall();
	document.body.addEventListener('mousemove', optimizeMouseMoveCall.call);
	
	var optimizedTouchMoveCall = optimizeCall();
	document.body.addEventListener('touchmove', optimizedTouchMoveCall.call);
	
	function dragDelegatePC(onMove, onEnd) {
	  var startPosition;
	  var delta;
	  var isMoving = false;
	  var onMoveProxy = function onMoveProxy(e) {
	    if (!startPosition) {
	      startPosition = {
	        pageX: e.pageX,
	        pageY: e.pageY
	      };
	    }
	    delta = {
	      x: e.pageX - startPosition.pageX,
	      y: e.pageY - startPosition.pageY
	    };
	    if (!isMoving) {
	      if (Math.abs(delta.x) >= 5 || Math.abs(delta.y) >= 5) {
	        isMoving = true;
	      }
	    }
	    if (isMoving) {
	      onMove(e, delta);
	    }
	  };
	  var onEndProxy = function onEndProxy(e) {
	    document.body.removeEventListener('mouseup', onEndProxy);
	    optimizeMouseMoveCall.remove(onMoveProxy);
	    onEnd(e, delta, isMoving);
	  };
	  document.body.addEventListener('mouseup', onEndProxy);
	  optimizeMouseMoveCall.add(onMoveProxy);
	}
	
	function dragDelegateMobile(onMove, onEnd) {
	  var startPosition;
	  var delta;
	  var isMoving = false;
	  var onMoveProxy = function onMoveProxy(e) {
	    var touch = e.touches[0];
	    if (!startPosition) {
	      startPosition = {
	        pageX: touch.pageX,
	        pageY: touch.pageY
	      };
	    }
	    delta = {
	      x: touch.pageX - startPosition.pageX,
	      y: touch.pageY - startPosition.pageY
	    };
	    if (!isMoving) {
	      if (Math.abs(delta.x) >= 5 || Math.abs(delta.y) >= 5) {
	        isMoving = true;
	      }
	    }
	    if (isMoving) {
	      onMove(e, delta);
	    }
	  };
	  var onEndProxy = function onEndProxy(e) {
	    document.body.removeEventListener('mouseup', onEndProxy);
	    optimizedTouchMoveCall.remove(onMoveProxy);
	    onEnd(e, delta, isMoving);
	  };
	  document.body.addEventListener('mouseup', onEndProxy);
	
	  document.body.addEventListener('touchend', onEndProxy);
	  optimizedTouchMoveCall.add(onMoveProxy);
	}
	
	var dragDelegate = envHelper.isMobileDevice() ? dragDelegateMobile : dragDelegatePC;
	
	module.exports = {
	  dragDelegate: dragDelegate,
	  onMove: function onMove(cb) {
	    optimizeMouseMoveCall.add(cb);
	  },
	  offMove: function offMove(cb) {
	    optimizeMouseMoveCall.remove(cb);
	  }
	};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var InteractiveTypes = __webpack_require__(151);
	InteractiveTypes = InteractiveTypes.InteractiveTypes;
	var parserHelper = __webpack_require__(152);
	var pageHelper = __webpack_require__(119);
	var comHelper = __webpack_require__(155);
	var appTypes = __webpack_require__(115);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var interactiveHelper = __webpack_require__(154);
	var popupHelper = __webpack_require__(156);
	
	/**
	 * 组件运行状态管理
	 * @type {clear: InteractiveRuningComList.clear, add: InteractiveRuningComList.add, remove: InteractiveRuningComList.remove, isRuning: InteractiveRuningComList.isRuning}}
	 */
	var InteractiveRuningComList = {
	  /**
	   * 清空原来的数据
	   */
	  clear: function clear() {
	    this.box = {};
	  },
	  /**
	   * 添加一个正在执行动画的组件
	   * @param comp
	   */
	  add: function add(comp) {
	    if (!this.box) {
	      this.clear();
	    }
	    if (comp) this.box[comp.controlID] = comp;
	  },
	  /**
	   * 完成动画时，移除该组件数据
	   * @param controlID
	   */
	  remove: function remove(controlID) {
	    if (this.box) delete this.box[controlID];
	  },
	
	  /**
	   * 指定ID的组件是否正在执行动画交互
	   * @param controlID
	   * @returns {boolean}
	   */
	  isRuning: function isRuning(controlID) {
	    if (this.box) return !_.isUndefined(this.box[controlID]);
	    return false;
	  }
	};
	
	function clone(source) {
	  if (source) {
	    return JSON.parse(JSON.stringify(source));
	  }
	  return null;
	}
	
	function InteractiveTarget(page, target, onFinish) {
	  //所有需要执行的动画总数
	  var animateCount;
	  //已完成的动画总数
	  var finishCount;
	
	  var dom;
	
	  var targetComp = page.findComByID(target.ID);
	
	  var isTerminate = false;
	
	  this.targetID = target.ID;
	
	  function init() {
	    finishCount = 0;
	    animateCount = 0;
	  }
	
	  function onAnimateStart(animate) {
	    if (animate) {
	      if (animate.props) {
	        //执行显示交互动画之前，需要先将子组件可见状态改为可见
	        if (animate.props.toVisible) {
	          interactiveHelper.updateChildDomVisible(targetComp, true);
	        }
	      }
	    }
	  }
	
	  function onAnimateComplete() {
	    finishCount++;
	    if (finishCount >= animateCount) {
	      if (onFinish) {
	        InteractiveRuningComList.remove(target.ID);
	        onFinish(target);
	      }
	    }
	  }
	
	  function onAnimateDone(animate) {
	    if (animate) {
	      if (animate.props) {
	        if (animate.props.afterCSS) {
	          dom.css(animate.props.afterCSS);
	        }
	        if (animate.props.isResize) {
	          dom.children('.LinkArea').trigger(appTypes.CUSTOM_EVENT.ON_RESIZE);
	        }
	        //执行隐藏交互动画之后，需要将子组件可见状态改为不可见
	        if (animate.props.toVisible !== undefined && !animate.props.toVisible) {
	          interactiveHelper.updateChildDomVisible(targetComp, false);
	          interactiveHelper.doUpdateChildVisible(targetComp, false);
	        }
	      }
	    }
	  }
	
	  function onProgress(animate) {
	    if (dom) {
	      if (animate.props.isResize) {
	        dom.find('canvas').last().trigger(appTypes.CUSTOM_EVENT.ON_PAINT);
	        dom.children().trigger(appTypes.CUSTOM_EVENT.ON_RESIZE);
	      }
	    }
	  }
	
	  function doOpenPopup(dom, popupComp, content, background, callOpened) {
	    var isPopup = popupComp.popup;
	    var command = popupComp.popupCommand;
	    var isToPopup = isPopup && !_.isUndefined(command.contentCommand);
	    var baseOption = command.option;
	    var comp = page.findComByID(popupComp.controlID);
	    var option;
	    var fun = function fun() {
	
	      if (isTerminate) {
	        doTerminate();
	        return;
	      }
	      //dom.css({visibility: 'visible',display:'block'});
	      if (command.contentCommand) {
	        option = command.contentCommand.option;
	      } else if (command.backgroundCommand) {
	        option = command.backgroundCommand.option;
	      }
	      if (!option) {
	        option = {};
	      }
	      option.complete = function () {
	        onAnimateComplete();
	        if (callOpened) {
	          //callOpened();
	        }
	      };
	      if (isPopup && command.contentCommand) {
	        dom.css({ visibility: 'visible', display: 'block' });
	        //todo:mxj 这一段考虑放到弹出管理类中，在这里只管理分发事件
	        if (command.backgroundCommand) {
	          animateCount++;
	        }
	        if (command.contentCommand) {
	          animateCount++;
	        }
	        if (command.backgroundCommand) {
	          background.animate(command.backgroundCommand.params, option);
	        } else if (command.backgroundCSS) {
	          background.css(command.backgroundCSS);
	        }
	        if (command.contentCommand) {
	          if (command.contentCommand.previourCSS) {
	            content.css(command.contentCommand.previourCSS);
	          }
	          content.animate(command.contentCommand.params, option);
	        } else {
	          content.css({ opacity: 1 });
	        }
	      } else {
	        // todo: mengxiaojiang 2016-7-14
	        // 这一段实际上目前并没有执行。需要考虑弹出的机制
	        // 对于交互时写入的popup属性，
	        // 在弹出之前置为ture，使组件先加载到节点中，然后执行动画
	        // 在关闭时，先执行必要的动画之后置再为false，使用组件从节点中移除
	        dom.trigger(popupHelper.CLOSE_POPUP_EVENT, {
	          callback: function callback(comID) {
	            var c = page.findComByID(comID);
	            if (c) {
	              c.popup = false;
	              delete c.popupCommand;
	              delete c.open;
	              pageHelper.updatePageComData(page.state.page, c);
	              page.refresh(page.state.page);
	              InteractiveRuningComList.remove(comID);
	            }
	            onAnimateComplete();
	          },
	          controlID: popupComp.controlID
	        });
	        return;
	      }
	      if (comp) {
	        delete comp.popupCommand;
	        delete comp.open;
	        pageHelper.updatePageComData(page.state.page, comp);
	        page.refresh(page.state.page);
	      }
	    };
	
	    var bindToFront = function bindToFront() {
	      var popupPage = $(ReactDOM.findDOMNode(page)).find('.page-popup');
	      var container = popupPage.children().eq(0);
	      if (!container || !container[0]) {
	        // FIXME: 2016-11-22 杨思柏修改，container[0] 可能为 undefined 不知道什么原因
	        return;
	      }
	      var count = container[0].childElementCount;
	      var i;
	      var maxZIndex = 0;
	      for (i = 0; i < count; i++) {
	        maxZIndex = Math.max(maxZIndex, parseInt(container[0].children[i].style.zIndex, 10));
	      }
	      dom.css({ 'z-index': maxZIndex + 1 });
	    };
	    if (isToPopup) dom.css({ visibility: 'hidden', display: 'none' });
	    bindToFront();
	    //延时弹出
	    if (baseOption.delay) {
	      setTimeout(fun, baseOption.delay);
	    } else {
	      //立即弹出
	      fun();
	    }
	  }
	
	  function doClosePopup(dom, popupComp, content, background) {
	    var isPopup = popupComp.popup;
	    var command = popupComp.popupCommand;
	    if (!command) {
	      return;
	    }
	    var isToPopup = isPopup && !_.isUndefined(command.contentCommand);
	    var baseOption = command.option;
	    var comp = page.findComByID(popupComp.controlID);
	    var fun = function fun() {
	      var duration = 150; //Allen: 此处间隔时间之后需重新考虑
	      content.animate({ opacity: 0 }, {
	        queue: false, duration: duration, complete: function complete() {
	          if (comp) {
	            comp.isPopupClosing = false;
	            comp.isNeedAnimate = false;
	            pageHelper.updatePageComData(page.state.page, comp);
	            page.refresh(page.state.page);
	          }
	        }
	      });
	      background.animate({ opacity: 0 }, { queue: false, duration: duration });
	    };
	
	    if (!isToPopup) dom.css({ visibility: 'visible', display: 'block' });
	    //延时弹出
	    if (baseOption.delay) {
	      setTimeout(fun, baseOption.delay);
	    } else {
	      //立即弹出
	      fun();
	    }
	  }
	
	  function doStack(targetComp, cmd) {
	    var dom = $('#' + targetComp.controlID);
	    dom.trigger('onSwitch', [targetComp.controlID, cmd.params.currentIndex, cmd.params.nextIndex, onAnimateComplete]);
	  }
	
	  function doScroll(targetComp, cmd) {
	    var _dom = $('#' + targetComp.controlID).children();
	    _dom.trigger('onScrollTo', [targetComp.controlID, cmd.params, onAnimateComplete]);
	  }
	
	  function doTerminate() {
	    finishCount = animateCount;
	    onAnimateComplete();
	  }
	
	  /**
	   * 构建一个执行指定命令的函数对象
	   * @param targetComp
	   * @param dom
	   * @param cmd
	   * @returns {fun}
	   */
	  function createCommandFun(targetComp, dom, cmd) {
	    var fun = function fun() {
	      var _dom = dom;
	      var complete;
	      InteractiveRuningComList.add(targetComp);
	      if (cmd.isScrollFire) {
	        doScroll(targetComp, cmd);
	        return;
	      }
	      if (cmd.isStackFire) {
	        doStack(targetComp, cmd);
	        return;
	      }
	      complete = cmd.option.complete;
	      if (cmd.previourCSS) {
	        _dom.css(cmd.previourCSS);
	      }
	      if (cmd.option.delay) {
	        _dom.delay(cmd.option.delay);
	      }
	      if (cmd.option.autoReverse) {
	        delete cmd.option.complete;
	      }
	      _dom.animate(cmd.params, cmd.option);
	      cmd.option.complete = complete;
	      if (cmd.option.autoReverse) {
	        _dom.delay(cmd.option.duration).animate(cmd.recovery, cmd.option);
	        if (cmd.recoveryCSS) {
	          _dom.css(cmd.recoveryCSS);
	        }
	      }
	    };
	    return fun;
	  }
	
	  function doPropsChangeCommand(targetComp, cmd) {
	    var fn = function fn() {
	      var k;
	      var com;
	      var pageData;
	      var callback;
	      var f;
	      var tid;
	      if (isTerminate) {
	        if (tid) {
	          clearTimeout(tid);
	        }
	        doTerminate();
	      }
	      com = page.findComByID(targetComp.controlID);
	      pageData = page.state.page;
	      callback = cmd.option.complete;
	      f = function f() {
	        if (com) {
	          InteractiveRuningComList.add(com);
	          for (k in cmd.params) {
	            com[k] = cmd.params[k];
	            com[interactiveHelper.CurrentPropsMap[k]] = cmd.params[k];
	          }
	          pageHelper.updatePageComData(pageData, com);
	          page.refresh(pageData);
	        }
	        if (callback) {
	          callback();
	        }
	      };
	
	      if (cmd.option && cmd.option.delay) {
	        tid = setTimeout(f, cmd.option.delay);
	      } else {
	        f();
	      }
	    };
	    return fn;
	  }
	
	  function registerAnimateEvent(option) {
	    option.complete = onAnimateComplete;
	    option.done = onAnimateDone;
	    option.progress = onProgress;
	  }
	
	  //同步执行所有命令
	  function doParallelStartCommand() {
	    var cmd;
	    var i;
	    var noDelays;
	    var delays;
	    var commands = target.commands;
	    var fns = [];
	    var commandFunc;
	    var params;
	    //1、遍历所有命令，把所有不延时的动画提前
	    //2、执行所有动画
	    noDelays = [];
	    delays = [];
	    //对不延时的动画，是否需要合并动画属性，如果合并，应考虑改变属性的交互命令的逻辑流程
	    for (i = 0; i < commands.length; i++) {
	      cmd = clone(commands[i]);
	      if (cmd.isChecked) {
	        if (!cmd.option.delay) {
	          noDelays.push(cmd);
	        } else {
	          delays.push(cmd);
	        }
	        animateCount++;
	        if (cmd.option.autoReverse) {
	          //animateCount++;
	        }
	      }
	    }
	
	    i = 0;
	    for (i; i < noDelays.length; i++) {
	      cmd = noDelays[i];
	      cmd.option.queue = false;
	      cmd.option.start = onAnimateStart;
	      cmd.option.complete = onAnimateComplete;
	      cmd.option.done = onAnimateDone;
	      cmd.option.progress = onProgress;
	      if (cmd.isPropsFire) {
	        commandFunc = doPropsChangeCommand(targetComp, cmd);
	      } else {
	        commandFunc = createCommandFun(targetComp, dom, cmd);
	      }
	      if (target.isRecovery && target.shouldRecovery) {
	        fns.unshift(commandFunc); //自动还原时
	      } else {
	        fns.push(commandFunc);
	      }
	    }
	    i = 0;
	    for (i; i < fns.length; i++) {
	      fns[i]();
	    }
	
	    i = 0;
	    fns = [];
	    for (i; i < delays.length; i++) {
	      cmd = delays[i];
	      if (cmd.isPopupFire) {
	        continue;
	      }
	      cmd.option.queue = true;
	      cmd.option.start = onAnimateStart;
	      cmd.option.complete = onAnimateComplete;
	      cmd.option.done = onAnimateDone;
	      cmd.option.progress = onProgress;
	      if (cmd.isPropsFire) {
	        commandFunc = doPropsChangeCommand(targetComp, cmd);
	      } else {
	        commandFunc = createCommandFun(targetComp, dom, cmd);
	      }
	      if (target.isRecovery && target.shouldRecovery) {
	        fns.unshift(commandFunc); //自动还原时
	      } else {
	        fns.push(commandFunc);
	      }
	    }
	
	    i = 0;
	    for (i; i < fns.length; i++) {
	      if (!isTerminate) fns[i]();
	    }
	  }
	
	  //顺序执行所有命令
	  function doSequenceStartCommand() {
	    var option;
	    var cmd;
	    var i;
	    var commands = target.commands;
	    var fns = [];
	    var commandFunc;
	
	    var callback = function callback() {
	      if (!isTerminate) dom.dequeue('cmds');
	    };
	
	    //统计需要执行的动画数量
	    for (i = 0; i < commands.length; i++) {
	      cmd = commands[i];
	      if (cmd.isChecked) {
	        animateCount++;
	        if (cmd.option && cmd.option.autoReverse) {
	          //animateCount++;
	        }
	      }
	    }
	
	    function onComplete() {
	      onAnimateComplete();
	      callback();
	    }
	
	    for (i = 0; i < commands.length; i++) {
	      cmd = clone(commands[i]);
	
	      if (cmd.isChecked) {
	        if (cmd.isPopupFire) {
	          continue;
	        }
	        option = cmd.option;
	        option.queue = true;
	        option.start = onAnimateStart;
	        option.complete = onComplete;
	        option.done = onAnimateDone;
	        option.progress = onProgress;
	        if (cmd.isPropsFire) {
	          commandFunc = doPropsChangeCommand(targetComp, cmd);
	        } else {
	          commandFunc = createCommandFun(targetComp, dom, cmd);
	        }
	        if (target.isRecovery && target.shouldRecovery) {
	          fns.unshift(commandFunc); //自动还原时
	        } else {
	          fns.push(commandFunc);
	        }
	      }
	    }
	
	    if (fns.length) {
	      dom.queue('cmds', fns);
	      callback();
	    }
	  }
	
	  this.terminate = function () {
	    if (dom) {
	      dom.stop('cmds', true, true);
	    }
	    isTerminate = true;
	  };
	
	  //启动目标上的交互
	  this.start = function () {
	    var pageData;
	    init();
	    if (!isTerminate && target.isChecked) {
	      dom = $('#' + target.ID);
	      //弹出组件另行处理,目前弹出组件上本身不会同时存在多个命令运行。故可以不考虑其是否同时工作
	      if (pageHelper.IsInvisualInteractiveCom(targetComp.controlTypeID)) {
	        if (targetComp) {
	          if (!targetComp.popup) {
	            InteractiveRuningComList.remove(targetComp.controlID);
	            if (targetComp.isNeedAnimate) {
	              targetComp.isPopupClosing = true; //Allen: 正在关闭弹出面板标志
	            }
	          } else {
	            InteractiveRuningComList.add(targetComp);
	          }
	          pageData = page.state.page;
	          targetComp.popupCommand = target.commands[0];
	          targetComp.open = doOpenPopup;
	          targetComp.closePopup = doClosePopup;
	          pageHelper.updatePageComData(pageData, targetComp);
	          page.refresh(pageData);
	        } else {
	          onAnimateComplete();
	        }
	      } else {
	        if (target.isParallel) {
	          doParallelStartCommand();
	        } else {
	          doSequenceStartCommand();
	        }
	      }
	    } else {
	      onAnimateComplete();
	    }
	  };
	}
	
	/**
	 * 交互驱动类
	 * @constructor
	 */
	function InteractiveWorker(page, source, onFinish) {
	  var _targets;
	  var _behaviour;
	  var isParallel;
	  var targetCount;
	  var finishCount;
	  var runList;
	
	  var isTerminate = false;
	
	  var interval = parseInt(source.interval, 10) || 0;
	
	  function init() {
	    _targets = [];
	    runList = [];
	    targetCount = 0;
	    finishCount = 0;
	  }
	
	  function builderAllTargets() {
	    var i;
	    var target;
	    for (i = 0; i < _behaviour.target.length; i++) {
	      target = _behaviour.target[i];
	      if (target.isChecked) {
	        targetCount++;
	        _targets.push(new InteractiveTarget(page, target, onAnimateFinish));
	      }
	    }
	  }
	
	  function onAnimateFinish(target) {
	    var targetCom;
	    finishCount++;
	
	    if (isTerminate) {
	      if (finishCount === targetCount) {
	        if (onFinish) {
	          onFinish(source);
	        }
	      }
	      return;
	    }
	    if (target) {
	      runList.push(target.ID);
	      targetCom = page.findComByID(target.ID);
	      if (targetCom) {
	        pageHelper.updatePageComData(page.state.page, targetCom);
	      } else {
	        InteractiveRuningComList.remove(target.ID);
	      }
	    }
	    if (finishCount >= targetCount) {
	      switchShouldRecovery();
	      if (onFinish) {
	        onFinish(source);
	      }
	    } else {
	      if (!isParallel && !isTerminate) {
	        //_targets[finishCount].start();
	        targetStart(_targets[finishCount]);
	      }
	    }
	  }
	
	  function switchShouldRecovery() {
	    var i;
	    var target;
	    for (i = 0; i < _behaviour.target.length; i++) {
	      target = _behaviour.target[i];
	      if (target.isChecked) {
	        if (target.isRecovery) {
	          target.shouldRecovery = !target.shouldRecovery;
	        }
	      }
	    }
	  }
	
	  function targetStart(target) {
	    target.start();
	  }
	
	  function doStart() {
	    var i;
	    if (_targets.length) {
	      if (isParallel) {
	        for (i = 0; i < _targets.length; i++) {
	          if (!isTerminate) {
	            //_targets[i].start();
	            targetStart(_targets[i]);
	          }
	        }
	      } else {
	        if (!isTerminate) {
	          //_targets[finishCount].start();
	          targetStart(_targets[finishCount]);
	        }
	      }
	    } else {
	      onAnimateFinish();
	    }
	  }
	
	  this.terminateAll = function () {
	    var i;
	    var targetWorker;
	    isTerminate = true;
	    if (_targets) {
	      for (i = 0; i < _targets.length; i++) {
	        targetWorker = _targets[i];
	        if (runList.indexOf(targetWorker.ID) === -1) targetWorker.terminate();
	      }
	    }
	    init();
	  };
	
	  function _start() {
	    init();
	    builderAllTargets();
	    doStart();
	  }
	
	  this.start = function (behaviour) {
	    _behaviour = behaviour;
	    isParallel = _behaviour.isParallel;
	    init();
	    builderAllTargets();
	    doStart();
	    //setTimeout(_start,interval);
	  };
	}
	
	/**
	 @Author : mengxiaojiang
	 @CreateDate : 2016-5-3
	 @Descript : 交互管理类，每次启动时，先创建一个InteractiveWorker,然后启动这个worker
	 */
	function InteractiveManager() {
	  var _source;
	  var _eventType;
	  var _entryIndex;
	  var _state = InteractiveTypes.InteractiveWorkerStateType.NONE;
	  var _itemFinishCount = 0;
	  var currentPage = null;
	  var _behaviour = null;
	
	  var worker;
	
	  /**
	   *
	   */
	  function doInit() {
	    _state = InteractiveTypes.InteractiveWorkerStateType.NONE;
	    _itemFinishCount = 0;
	  }
	
	  this.getInteractiveState = function () {
	    return InteractiveRuningComList;
	  };
	
	  /**
	   * 判断源及源的目标是否正在工作中
	   * @param sourceCom
	   * @returns {boolean}
	   */
	  this.isWorking = function (sourceCom) {
	    var targetID;
	    var targetComp;
	    var i = 0;
	    if (InteractiveRuningComList.isRuning(sourceCom.controlID)) {
	      return true;
	    }
	    if (_behaviour && _behaviour.target) {
	      for (i; i < _behaviour.target.length; i++) {
	        targetID = _behaviour.target[i].targetID;
	        targetComp = currentPage.findComByID(targetID);
	        if (pageHelper.IsInvisualInteractiveCom(targetComp.controlTypeID)) {
	          if (!targetComp.popup) {
	            InteractiveRuningComList.remove(targetID);
	            continue;
	          }
	        }
	        if (InteractiveRuningComList.isRuning(targetID)) {
	          return true;
	        }
	      }
	    }
	  };
	
	  /**
	   * 事件源所属的所有交互都完成后的回调
	   * @param source
	   */
	  function onWorkerItemFinish(source) {
	    if (_state != InteractiveTypes.InteractiveWorkerStateType.NONE) {
	      doInit();
	      if (source) {
	        InteractiveRuningComList.remove(source.controlID);
	      }
	      currentPage.refresh(currentPage.state.page);
	    }
	  }
	
	  /**
	   * 查找需要执行的行为
	   * @returns {*}
	   */
	  function findBehaviour() {
	    var event = comHelper.findEventByType(_source, _entryIndex, _eventType);
	    if (event) {
	      return event.behaviour[0];
	    }
	    return null;
	  }
	
	  /**
	   * 解析事件源上的交互数据为可识别的数据格式，并记录到事件源组件上
	   * @returns {{}|*}
	   */
	  function parseSourceInteractiveData() {
	    var data;
	    var entry;
	    var behaviour;
	    var target;
	    var _target;
	    var targetCom;
	    var command;
	    var commandCount;
	    var _cmd;
	    var event;
	    var i;
	    var j;
	    var targetIndex;
	    //var ignoreSourceRuning = false;
	    var pageData = currentPage.state.page;
	    data = _source._interactiveData;
	    if (!data) {
	      data = {};
	    }
	    if (!data.entries) {
	      data.entries = {};
	    }
	    if (!data.entries[_entryIndex]) {
	      entry = data.entries[_entryIndex] = {};
	    } else {
	      entry = data.entries[_entryIndex];
	    }
	    event = entry[_eventType];
	    if (!event) {
	      event = entry[_eventType] = {};
	    }
	    event.isChecked = true; //这里的选中状态，始终是为true的
	    behaviour = event.behaviour ? event.behaviour[0] : {};
	    behaviour.isChecked = _behaviour.isChecked;
	    behaviour.isLoop = _behaviour.isLoop;
	    behaviour.isWait = _behaviour.isWait;
	    behaviour.isParallel = _behaviour.execMode === InteractiveTypes.ExecuteModeType.PARALLEL;
	    if (!event.behaviour) {
	      event.behaviour = [behaviour];
	    }
	    if (!behaviour.target) {
	      behaviour.target = [];
	    }
	    targetIndex = 0;
	    for (i = 0; i < _behaviour.target.length; i++) {
	      _target = _behaviour.target[i];
	      targetCom = clone(currentPage.findComByID(_target.targetID));
	      if (targetCom) {
	        if (_target.isChecked) {
	          //未选中的目标，不进行交互解析
	          if (behaviour.target.length > targetIndex) {
	            target = behaviour.target[targetIndex]; //Allen:原来的代码直接使用i坐下标，有bug，此处未选中targetIndex不自增
	          } else {
	            target = { shouldRecovery: false };
	            behaviour.target.push(target);
	          }
	          targetIndex++;
	          target.isChecked = _target.isChecked;
	          target.isRecovery = _target.isAutoRecovery;
	          target.isLoop = _target.isLoop;
	          target.isWait = _target.isWait;
	          target.isParallel = _target.execMode === InteractiveTypes.ExecuteModeType.PARALLEL;
	          target.ID = _target.targetID;
	
	          if (!target.commands) {
	            target.commands = [];
	          }
	          //对内容面板的命令解析，只认第一个
	          commandCount = _target.command.length;
	          if (commandCount && targetCom.controlTypeID === 'ContentPanel') {
	            commandCount = 1;
	          }
	          for (j = 0; j < commandCount; j++) {
	            _cmd = _target.command[j];
	            if (target.commands.length > j) {
	              command = target.commands[j];
	            } else {
	              command = {};
	              target.commands.push(command);
	            }
	            command.isChecked = _cmd.isChecked;
	
	            command.params = {};
	
	            //todo mxj 弹出命令由于有主动关闭的特点，其在主动关闭时，未通过命令执行关闭，故在解析命令前，如果弹出组件为关闭状态，则其shouldRecovery的值应默认为false。
	            if (pageHelper.IsInvisualInteractiveCom(targetCom.controlTypeID)) {
	              if (!targetCom.popup) {
	                target.shouldRecovery = false;
	              }
	            }
	            if (command.isChecked) {
	              //未选中的交互命令，不进行参数解析
	              if (target.isRecovery && target.shouldRecovery) {
	                //自动还原
	                //--------------------------------------------------
	                // matt 2017-10-18
	                //以之前动画参数作为还原时动画前的样式状态
	                command.previourCSS = clone(command.params);
	                //--------------------------------------------------
	                command.params = command.recovery;
	
	                //todo mxj 如果是弹出组件的自动还原，不可直接修改组件数据的popup为false，根据前期针对弹出命令的执行逻辑，直接在这里清除命令中的contentCommand数据。
	                if (pageHelper.IsInvisualInteractiveCom(targetCom.controlTypeID)) {
	                  delete command.contentCommand;
	                }
	              } else {
	                if (command.isChecked) {
	                  parserHelper.parser(currentPage, command, _cmd, targetCom, _source);
	                }
	              }
	              if (pageHelper.IsInvisualInteractiveCom(targetCom.controlTypeID)) {
	                targetCom.popupCommand = command;
	              }
	              pageHelper.updatePageComData(pageData, targetCom);
	            }
	          }
	          if (target.isRecovery && target.shouldRecovery) {
	            j = target.commands.length - 1;
	            for (j; j >= 0; j--) {
	              recoveryComProps(targetCom, target.commands[j]);
	            }
	          }
	        }
	      }
	    }
	    //这里的Source有可能是同时作为目标的。
	    //这种情况下，如果直接把Source克隆后的数据更新到PageData中后，会有可能覆盖掉针对它上面设置的交互命令数据，从而导致针对它的命令不会被执行
	
	    pageHelper.updateComData(pageData, _source.controlID, '_interactiveData', data);
	    currentPage.refresh(pageData);
	    return behaviour;
	  }
	
	  function recoveryComProps(comp, cmd) {
	    var k;
	    var propsName;
	    var recoveryProps = cmd.recovery;
	    for (k in recoveryProps) {
	      propsName = interactiveHelper.CurrentPropsMap[k];
	      if (propsName) {
	        if (cmd.isPropsFire) {
	          delete comp[propsName];
	        } else {
	          comp[propsName] = recoveryProps[k];
	        }
	      }
	    }
	  }
	
	  this.reset = function () {
	    InteractiveRuningComList.clear();
	    if (worker) {
	      worker.terminateAll();
	    }
	  };
	  /***
	   * 启动一个交互
	   * @param page 当前页面
	   * @param sourceCom 事件源
	   * @param eventType 触发事件
	   * @param entryIndex 入口索引
	   */
	  this.start = function (page, sourceCom, eventType, entryIndex) {
	    var behaviourRec;
	    if (!currentPage || currentPage.props.page.ID !== page.props.page.ID) {
	      InteractiveRuningComList.clear();
	    }
	    currentPage = page;
	    _source = clone(page.findComByID(sourceCom.controlID));
	    _eventType = eventType;
	    _entryIndex = entryIndex;
	    _behaviour = findBehaviour();
	    if (!_behaviour) {
	      return;
	    }
	    if (this.isWorking(sourceCom)) return;
	
	    behaviourRec = parseSourceInteractiveData();
	    doInit();
	    _state = InteractiveTypes.InteractiveWorkerStateType.RUNNING;
	    worker = new InteractiveWorker(page, _source, onWorkerItemFinish);
	    worker.start(behaviourRec);
	  };
	}
	
	function D() {
	  var manager = null;
	  this.reset = function () {
	    if (manager) manager.reset();
	  };
	
	  this.start = function (page, sourceCom, eventType, entryIndex) {
	    manager = new InteractiveManager();
	    manager.startNew(page, sourceCom, eventType, entryIndex);
	  };
	
	  this.getInteractiveState = function () {
	    return InteractiveRuningComList;
	  };
	}
	
	var Instance = new InteractiveManager();
	
	module.exports = Instance;

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	'use strict';
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-5-4
	 @Descript : 交互枚举数据,每个枚举类型中都有一个index的字段，存放的是其除index字段外的键的索引
	 */
	
	var InteractiveTypes = {
	  /*交互运行状态*/
	  InteractiveWorkerStateType: {
	    NONE: 'wsNone',
	    RUNNING: 'wsRunning',
	    index: { 0: 'NONE', 1: 'RUNNING' }
	  },
	  /*同时工作模式*/
	  ExecuteModeType: {
	    SEQUENCE: 'emSequence',
	    PARALLEL: 'emParallel',
	    index: { 0: 'SEQUENCE', 1: 'PARALLEL' }
	  },
	
	  /*动画类型*/
	  AniInterpolationType: {
	    NONE: 'aiNone',
	    LINEAR: 'aiLinear',
	    ACCELERATIVE: 'aiAccelerative',
	    BACK: 'aiBack',
	    ELASTIC: 'aiElastic',
	    BOUNCE: 'aiBounce',
	    index: { 0: 'NONE', 1: 'LINEAR', 2: 'ACCELERATIVE', 3: 'BACK', 4: 'ELASTIC', 5: 'BOUNCE' }
	  },
	  CommandPopupPanelState: {
	    POPUP: 'stPopup',
	    CLOSE: 'stClose',
	    POPUPCLOSE: 'stPopupClose',
	    index: { 0: 'POPUP', 1: 'CLOSE', 2: 'POPUPCLOSE' }
	  },
	  CommandVisibility: {
	    SHOW: 'vbShow',
	    HIDE: 'vbHide',
	    TOGGLE: 'vbToggle',
	    index: { 0: 'SHOW', 1: 'HIDE', 2: 'TOGGLE' }
	  },
	  CommandPopupState: {
	    POPUP: 'psPopup',
	    CLOSE: 'psClose',
	    TOGGLE: 'psToggle',
	    index: { 0: 'popup', 1: 'HIDE', 2: 'TOGGLE' }
	  },
	  CommandMoveMode: {
	    MOVE_BY: 'mmMoveBy',
	    MOVE_TO: 'mmMoveTo',
	    MOVE_PLACE_HORI: 'mmMovePlaceHori',
	    MOVE_PLACE_VERT: 'mmMovePlaceVert',
	    index: { 0: 'MOVE_BY', 1: 'MOVE_TO', 2: 'MOVE_PLACE_HORI', 3: 'MOVE_PLACE_VERT' }
	  },
	  CommandValueMode: {
	    BY: 'mmBy',
	    TO: 'mmTo',
	    index: { 0: 'BY', 1: 'TO' }
	  },
	  CommandResizeDirection: {
	    TOP_LEFT: 'rdTopLeft',
	    TOP_RIGHT: 'rdTopRight',
	    BOTTOM_LEFT: 'rdBottomLeft',
	    BOTTOM_RIGHT: 'rdBottomRight',
	    CENTER: 'rdCenter',
	    LEFT: 'rdLeft',
	    RIGHT: 'rdRight',
	    TOP: 'rdTop',
	    BOTTOM: 'rdBottom',
	    index: {
	      0: 'TOP_LEFT',
	      1: 'TOP_RIGHT',
	      2: 'BOTTOM_LEFT',
	      3: 'BOTTOM_RIGHT',
	      4: 'CENTER',
	      5: 'LEFT',
	      6: 'RIGHT',
	      7: 'TOP',
	      8: 'BOTTOM'
	    }
	  },
	  CommandResizeType: {
	    EXPAND: 'rtExpand',
	    FOLD: 'rdFold',
	    index: { 0: 'EXPAND', 1: 'FOLD' }
	  },
	  CommandScaleDirection: {
	    CENTER: 'smCenter',
	    TOP_LEFT: 'smTopLeft',
	    TOP_RIGHT: 'smTopRight',
	    BOTTOM_LEFT: 'smBottomLeft',
	    BOTTOM_RIGHT: 'smBottomRight',
	    LEFT: 'smLeft',
	    RIGHT: 'smRight',
	    TOP: 'smTop',
	    BOTTOM: 'smBottom',
	    CUSTOM: 'smCustom',
	    index: {
	      0: 'CENTER',
	      1: 'TOP_LEFT',
	      2: 'TOP_RIGHT',
	      3: 'BOTTOM_LEFT',
	      4: 'BOTTOM_RIGHT',
	      5: 'LEFT',
	      6: 'RIGHT',
	      7: 'TOP',
	      8: 'BOTTOM',
	      9: 'CUSTOM'
	    }
	  },
	  CommandRotateDirection: {
	    CLOCKWISE: 'rmClockwise',
	    COUNTER_CLOCKWISE: 'rmCounterClockwise',
	    index: { 0: 'CLOCKWISE', 1: 'COUNTER_CLOCKWISE' }
	  },
	  RotateCenterPoint: {
	    TOP_LEFT: 'cmTopLeft',
	    TOP_RIGHT: 'cmTopRight',
	    BOTTOM_LEFT: 'cmBottomLeft',
	    BOTTOM_RIGHT: 'cmBottomRight',
	    CENTER: 'cmCenter',
	    LEFT: 'cmLeft',
	    RIGHT: 'cmRight',
	    TOP: 'cmTop',
	    BOTTOM: 'cmBottom',
	    CUSTOM: 'cmCustom',
	    index: {
	      0: 'TOP_LEFT',
	      1: 'TOP_RIGHT',
	      2: 'BOTTOM_LEFT',
	      3: 'BOTTOM_RIGHT',
	      4: 'CENTER',
	      5: 'LEFT',
	      6: 'RIGHT',
	      7: 'TOP',
	      8: 'BOTTOM',
	      9: 'CUSTOM'
	    }
	  },
	  PageLinkEventType: {
	    CLICK: 'AtClick',
	    RIGHT_CLICK: 'AtRightClick',
	    DOUBLE_CLICK: 'AtDoubleClick',
	    index: { 0: 'CLICK', 1: 'RIGHT_CLICK', 2: 'DOUBLE_CLICK' }
	  },
	  ScrollPosition: {
	    TOP: 'spTop',
	    CENTER: 'spCenter',
	    BOTTOM: 'spBottom',
	    index: { 0: 'TOP', 1: 'CENTER', 2: 'BOTTOM' }
	  },
	  PosDirection: {
	    LEFT: 'DtLeft',
	    RIGHT: 'DtRight',
	    UP: 'DtUp',
	    DOWN: 'DtDown',
	    index: { '0': 'LEFT', '1': 'RIGHT', '2': 'UP', '3': 'DOWN' }
	  },
	  EventType: {
	    CLICK: 'atClick',
	    RIGHT_CLICK: 'atRightClick',
	    DOUBLE_CLICK: 'atDoubleClick',
	    MOUSE_HOVER: 'atMouseHovered',
	    MOUSE_DOWN: 'atMouseDown',
	    MOUSE_UP: 'atMouseUp',
	    MOUSE_ENTER: 'atMouseEnter',
	    MOUSE_LEAVE: 'atMouseLeave',
	    LONG_PRESS: 'atLongPress',
	    LOAD: 'atLoad',
	    FIRE: 'atFire',
	    CHECK_TRUE: 'atCheckedChangeTrue',
	    CHECK_FALSE: 'atCheckedChangeFalse',
	    SWITCH_ON: 'atSwitchOn',
	    SWITCH_OFF: 'atSwitchOff',
	    SELECTION_CHANGE: 'atSelectionChange'
	  },
	  CommandType: {
	    CMD_TERMINATE: 'Terminate',
	    CMD_VISIBILITY: 'Change Visibility',
	    CMD_MOVE: 'Move',
	    CMD_RESIZE: 'Resize',
	    CMD_SCALE: 'Scale',
	    CMD_ROTATE: 'Rotate',
	    CMD_FADE: 'Fade',
	    CMD_COLOR: 'Set Color',
	    CMD_TEXT: 'Set Text',
	    CMD_IMAGE: 'Set Image',
	    CMD_SCROLL: 'Scroll Position',
	    CMD_HOVER: 'Hover',
	    CMD_POPUP_STATE: 'Popup State Change',
	    CMD_STACKPANEL_SWTICH: 'Switch Stack Panel',
	    CMD_PROPERTY: {
	      TEXT_COLOR: {
	        cmd: 'Set Text Color',
	        property: 'textColor',
	        current: 'currentTextColor'
	      }
	    }
	  },
	  CommandParams: {
	    PARAM_VALUE: 'Value',
	    PARAM_VALUE_FROM_CURRENT: 'ValueFromCurrent',
	    PARAM_FORCE_FROM_INIT_VALUE: 'ForceFromInitValue',
	    PARAM_VALUE_MODE: 'ValueMode',
	    PARAM_FROM_X: 'FromX',
	    PARAM_FROM_Y: 'FromY',
	    PARAM_TO_X: 'ToX',
	    PARAM_TO_Y: 'ToY',
	    PARAM_BY_X: 'ByX',
	    PARAM_BY_Y: 'ByY',
	    PARAM_FROM_SCALE_X: 'FromScaleX',
	    PARAM_FROM_SCALE_Y: 'FromScaleY',
	    PARAM_TO_SCALE_X: 'ToScaleX',
	    PARAM_TO_SCALE_Y: 'ToScaleY',
	    PARAM_FROM_WIDTH: 'FromWidth',
	    PARAM_FROM_HEIGHT: 'FromHeight',
	    PARAM_TO_WIDTH: 'ToWidth',
	    PARAM_TO_HEIGHT: 'ToHeight',
	    PARAM_FROM_ANGLE: 'FromAngle',
	    PARAM_TO_ANGLE: 'ToAngle',
	    PARAM_DELAY: 'Delay',
	    PARAM_ANI_TYPE: 'AniType',
	    PARAM_ANI_INTERPOLATION: 'AniInterpolation',
	    PARAM_ANI_DURATION: 'AniDuration',
	    PARAM_ANI_AUTO_REVERSE: 'AniAutoReverse',
	    PARAM_ANI_LOOP: 'AniLoop',
	    PARAM_ANI_INTERPOLATION_TYPE_OUT: 'AniInterpolationTypeOut',
	    PARAM_TERMINATE_LOOP_BY_CLICK: 'TerminateLoopByClick',
	    PARAM_MOVE_MODE: 'MoveMode',
	    PARAM_MOVE_PLACE_HORI: 'MovePlaceHori',
	    PARAM_MOVE_PLACE_VERT: 'MovePlaceVert',
	    PARAM_SCALE_CENTER_MODE: 'ScaleDirection',
	    PARAM_RESIZE_TYPE: 'ResizeType',
	    PARAM_RESIZE_CENTER_MODE: 'ResizeDirection',
	    PARAM_ROTATE_DIRECTION: 'RotateDirection',
	    PARAM_ROTATE_CENTER_MODE: 'CenterMode',
	    PARAM_ROTATE_CENTER_X: 'RotateCenterX',
	    PARAM_ROTATE_CENTER_Y: 'RotateCenterY',
	    PARAM_SELECTED_INDEX: 'SelecedIndex',
	    PARAM_SCROLL_TO: 'ScrollTo',
	    PARAM_TO_VALUE: 'ToValue',
	    PARAM_FROM_VALUE: 'FromValue'
	  }
	
	};
	
	exports.InteractiveTypes = InteractiveTypes;
	exports.getInteractiveParamValue = function (enumType, value) {
	  if (enumType.hasOwnProperty('index')) {
	    return enumType[enumType.index[value]];
	  }
	};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by mengxiaojiang on 2016/5/10.
	 */
	
	var InteractiveType = __webpack_require__(151);
	var EnumData = InteractiveType.InteractiveTypes;
	var findEnumValue = InteractiveType.getInteractiveParamValue;
	var appTypes = __webpack_require__(115);
	var RuntimeOptions = __webpack_require__(153);
	var dataHelper = __webpack_require__(113);
	var interactiveHelper = __webpack_require__(154);
	var _ = __webpack_require__(51);
	var utils = __webpack_require__(116);
	
	/**
	 * 转换命令参数
	 * @param paramName 要获取的信息数据名称
	 * @param params 参数列表
	 * @return 返回参数值，对于一些特定的属性，会进行转换处理，如x,y,w,h等会转换为数字
	 * */
	function getParamValue(paramName, params) {
	  var value;
	  if (params.hasOwnProperty(paramName)) {
	    value = params[paramName];
	  }
	  switch (paramName) {
	    // 纯数字类型数据
	    case EnumData.CommandParams.PARAM_FROM_X:
	    case EnumData.CommandParams.PARAM_FROM_Y:
	    case EnumData.CommandParams.PARAM_TO_X:
	    case EnumData.CommandParams.PARAM_TO_Y:
	    case EnumData.CommandParams.PARAM_BY_X:
	    case EnumData.CommandParams.PARAM_BY_Y:
	    case EnumData.CommandParams.PARAM_FROM_SCALE_X:
	    case EnumData.CommandParams.PARAM_FROM_SCALE_Y:
	    case EnumData.CommandParams.PARAM_TO_SCALE_X:
	    case EnumData.CommandParams.PARAM_TO_SCALE_Y:
	    case EnumData.CommandParams.PARAM_FROM_WIDTH:
	    case EnumData.CommandParams.PARAM_FROM_HEIGHT:
	    case EnumData.CommandParams.PARAM_TO_WIDTH:
	    case EnumData.CommandParams.PARAM_TO_HEIGHT:
	    case EnumData.CommandParams.PARAM_FROM_ANGLE:
	    case EnumData.CommandParams.PARAM_TO_ANGLE:
	    case EnumData.CommandParams.PARAM_DELAY:
	    case EnumData.CommandParams.PARAM_ANI_DURATION:
	    case EnumData.CommandParams.PARAM_ROTATE_CENTER_X:
	    case EnumData.CommandParams.PARAM_ROTATE_CENTER_Y:
	    case EnumData.CommandParams.PARAM_SELECTED_INDEX:
	      {
	        return parseFloat(value);
	      }
	    //布尔类型数据
	    case EnumData.CommandParams.PARAM_ANI_LOOP:
	    case EnumData.CommandParams.PARAM_ANI_AUTO_REVERSE:
	    case EnumData.CommandParams.PARAM_ANI_INTERPOLATION_TYPE_OUT:
	    case EnumData.CommandParams.PARAM_TERMINATE_LOOP_BY_CLICK:
	    case EnumData.CommandParams.PARAM_FORCE_FROM_INIT_VALUE:
	    case EnumData.CommandParams.PARAM_VALUE_FROM_CURRENT:
	      {
	        return value === 'True' || value;
	      }
	    //移动命令的参数转换
	    case EnumData.CommandParams.PARAM_MOVE_MODE:
	      {
	        return findEnumValue(EnumData.CommandMoveMode, value);
	      }
	    case EnumData.CommandParams.PARAM_MOVE_PLACE_HORI:
	    case EnumData.CommandParams.PARAM_MOVE_PLACE_VERT:
	      {
	        return findEnumValue(EnumData.PosDirection, value);
	      }
	
	    case EnumData.CommandParams.PARAM_VALUE:
	      {
	        return value;
	      }
	
	    case EnumData.CommandParams.PARAM_VALUE_MODE:
	      {
	        return findEnumValue(EnumData.CommandValueMode, value);
	      }
	
	    case EnumData.CommandParams.PARAM_ANI_TYPE:
	      {
	        return value;
	      }
	    case EnumData.CommandParams.PARAM_ANI_INTERPOLATION:
	      {
	        return findEnumValue(EnumData.AniInterpolationType, value);
	      }
	
	    case EnumData.CommandParams.PARAM_SCALE_CENTER_MODE:
	      {
	        return findEnumValue(EnumData.CommandScaleDirection, value);
	      }
	    case EnumData.CommandParams.PARAM_RESIZE_TYPE:
	      {
	        return value;
	      }
	    case EnumData.CommandParams.PARAM_RESIZE_CENTER_MODE:
	      {
	        return findEnumValue(EnumData.CommandResizeDirection, value);
	      }
	    case EnumData.CommandParams.PARAM_ROTATE_DIRECTION:
	      {
	        return findEnumValue(EnumData.CommandRotateDirection, value);
	      }
	    case EnumData.CommandParams.PARAM_ROTATE_CENTER_MODE:
	      {
	        return findEnumValue(EnumData.RotateCenterPoint, value);
	      }
	
	    case EnumData.CommandParams.PARAM_SCROLL_TO:
	      {
	        return findEnumValue(EnumData.ScrollPosition, value);
	      }
	    default:
	      return null;
	  }
	}
	
	/**
	 * 解析移动命令
	 * @param command
	 * @param cmdParams
	 * @param targetComp
	 * @param autoReverse
	 */
	function parseMoveCmd(command, cmdParams, targetComp, autoReverse) {
	  var currentX; //当前视觉上的X坐标
	  var currentY; //当前视觉上的Y坐标
	  var toX; //视觉上的目标点X坐标
	  var toY; //视觉上的目标点Y坐标
	  var byX; //此次动画要偏移X距离
	  var byY; // 此次动画要偏移的Y距离
	  var moveMode; //移动的模式：移动|移动到|水平一个身位|垂直一个身位
	  var moveDirection; // 移动的方向
	  var currentW = parseInt(!_.isUndefined(targetComp.currentW) ? targetComp.currentW : targetComp.w, 10); // 组件当前的宽度
	  var currentH = parseInt(!_.isUndefined(targetComp.currentH) ? targetComp.currentH : targetComp.h, 10); // 组件当前的高度
	
	  toX = getParamValue(EnumData.CommandParams.PARAM_TO_X, cmdParams);
	  toY = getParamValue(EnumData.CommandParams.PARAM_TO_Y, cmdParams);
	  byX = getParamValue(EnumData.CommandParams.PARAM_BY_X, cmdParams);
	  byY = getParamValue(EnumData.CommandParams.PARAM_BY_Y, cmdParams);
	
	  moveMode = getParamValue(EnumData.CommandParams.PARAM_MOVE_MODE, cmdParams);
	
	  moveDirection = null;
	
	  currentX = parseInt(!_.isUndefined(targetComp.currentX) ? targetComp.currentX : targetComp.x, 10);
	  currentY = parseInt(!_.isUndefined(targetComp.currentY) ? targetComp.currentY : targetComp.y, 10);
	  //移动
	  if (moveMode === EnumData.CommandMoveMode.MOVE_BY) {
	    toX = currentX + byX;
	    toY = currentY + byY;
	  }
	  //移动到
	  else if (moveMode === EnumData.CommandMoveMode.MOVE_TO) {}
	    //这里因为已经获取到了终点的X,Y，不需要再时行其它的计算
	
	    //水平移动一个身位
	    else if (moveMode === EnumData.CommandMoveMode.MOVE_PLACE_HORI) {
	        moveDirection = getParamValue(EnumData.CommandParams.PARAM_MOVE_PLACE_HORI, cmdParams);
	        //左移一个身位
	        if (moveDirection === EnumData.PosDirection.LEFT) {
	          toX = currentX - currentW;
	        } else {
	          //右移一个身位
	          toX = currentX + currentW;
	        }
	        toY = currentY;
	      }
	      //垂直移动一个身位
	      else {
	          moveDirection = getParamValue(EnumData.CommandParams.PARAM_MOVE_PLACE_VERT, cmdParams);
	          toX = currentX;
	          //向下移动一个身位
	          if (moveDirection === EnumData.PosDirection.DOWN) {
	            toY = currentY + currentH;
	          } else {
	            //向上移动一个身位
	            toY = currentY - currentH;
	          }
	        }
	
	  command.params = {
	    left: toX,
	    top: toY
	  };
	  //--------------------------------------------------
	  // matt 2017-10-18
	  // 所有命令都需要记录一个动画前的状态，以之后用于自动还原
	  // * 注意数据格式，要符合css的样式规则
	  command.previourCSS = {
	    left: currentX,
	    top: currentY
	  };
	  //--------------------------------------------------
	  command.recovery = {
	    left: currentX,
	    top: currentY
	  };
	
	  if (!autoReverse) {
	    targetComp.currentX = toX;
	    targetComp.currentY = toY;
	  }
	}
	
	/**
	 * 解析旋转命令
	 * @param targetComp
	 * @param cmdParams
	 * @param duration
	 */
	function parseRotateCmd(command, cmdParams, targetComp, autoReverse) {
	  var direction = getParamValue(EnumData.CommandParams.PARAM_ROTATE_DIRECTION, cmdParams);
	  var valueMode = getParamValue(EnumData.CommandParams.PARAM_VALUE_MODE, cmdParams);
	  var centerMode = getParamValue(EnumData.CommandParams.PARAM_ROTATE_CENTER_MODE, cmdParams);
	  var toAngle = getParamValue(EnumData.CommandParams.PARAM_TO_ANGLE, cmdParams);
	  var fromOrigin = undefined;
	  var currentAngle = !_.isUndefined(targetComp.currentAngle) ? targetComp.currentAngle : 0;
	
	  var temp = 1;
	  //反时针旋转
	  if (direction === EnumData.CommandRotateDirection.COUNTER_CLOCKWISE) {
	    temp = -1;
	  }
	  switch (valueMode) {
	    //旋转到
	    case EnumData.CommandValueMode.BY:
	      toAngle = currentAngle + toAngle * temp;
	      break;
	    default:
	      break;
	
	  }
	  switch (centerMode) {
	    case EnumData.RotateCenterPoint.CENTER:
	      fromOrigin = 'center center';
	      break;
	    case EnumData.RotateCenterPoint.TOP_LEFT:
	      fromOrigin = 'left top';
	      break;
	    case EnumData.RotateCenterPoint.TOP:
	      fromOrigin = 'center top';
	      break;
	    case EnumData.RotateCenterPoint.TOP_RIGHT:
	      fromOrigin = 'right top';
	      break;
	    case EnumData.RotateCenterPoint.RIGHT:
	      fromOrigin = 'right center';
	      break;
	    case EnumData.RotateCenterPoint.BOTTOM_RIGHT:
	      fromOrigin = 'right bottom';
	      break;
	    case EnumData.RotateCenterPoint.BOTTOM:
	      fromOrigin = 'center bottom';
	      break;
	    case EnumData.RotateCenterPoint.BOTTOM_LEFT:
	      fromOrigin = 'left bottom';
	      break;
	    case EnumData.RotateCenterPoint.LEFT:
	      fromOrigin = 'left center';
	      break;
	  }
	  command.previourCSS = {
	    transformOrigin: fromOrigin
	  };
	
	  command.params = {
	    rotate: toAngle
	  };
	  command.recovery = {
	    rotate: currentAngle
	  };
	
	  if (!autoReverse) {
	    targetComp.currentAngle = toAngle;
	  }
	}
	
	/**
	 * 解析调整尺寸命令
	 * @param command
	 * @param cmdParams
	 * @param targetComp
	 * @param autoReverse
	 */
	function parseResizeCmd(command, cmdParams, targetComp, autoReverse) {
	  var valueMode = getParamValue(EnumData.CommandParams.PARAM_VALUE_MODE, cmdParams);
	  var currentX = parseInt(!_.isUndefined(targetComp.currentX) ? targetComp.currentX : targetComp.x, 10);
	  var currentY = parseInt(!_.isUndefined(targetComp.currentY) ? targetComp.currentY : targetComp.y, 10);
	  var currentW = parseInt(!_.isUndefined(targetComp.currentW) ? targetComp.currentW : targetComp.w, 10);
	  var currentH = parseInt(!_.isUndefined(targetComp.currentH) ? targetComp.currentH : targetComp.h, 10);
	  var toX;
	  var toY;
	  var toW;
	  var toH;
	  var centerMode;
	
	  toW = getParamValue(EnumData.CommandParams.PARAM_TO_WIDTH, cmdParams);
	  toH = getParamValue(EnumData.CommandParams.PARAM_TO_HEIGHT, cmdParams);
	  //相对
	  if (valueMode === EnumData.CommandValueMode.BY) {
	    toW = currentW + toW;
	    toH = currentH + toH;
	  }
	  centerMode = getParamValue(EnumData.CommandParams.PARAM_RESIZE_CENTER_MODE, cmdParams);
	
	  //根据定位点计算X,Y坐标
	  switch (centerMode) {
	    case EnumData.CommandResizeDirection.LEFT:
	      {
	        toX = currentX;
	        toY = currentY + (currentH - toH) / 2;
	        break;
	      }
	    case EnumData.CommandResizeDirection.RIGHT:
	      {
	        toX = currentX + currentW - toW;
	        toY = currentY + (currentH - toH) / 2;
	        break;
	      }
	    case EnumData.CommandResizeDirection.TOP:
	      {
	        toX = currentX + (currentW - toW) / 2;
	        toY = currentY;
	        break;
	      }
	    case EnumData.CommandResizeDirection.BOTTOM:
	      {
	        toX = currentX + (currentW - toW) / 2;
	        toY = currentY + currentH - toH;
	        break;
	      }
	    case EnumData.CommandResizeDirection.TOP_LEFT:
	      {
	        toX = currentX;
	        toY = currentY;
	        break;
	      }
	    case EnumData.CommandResizeDirection.TOP_RIGHT:
	      {
	        toX = currentX + currentW - toW;
	        toY = currentY;
	        break;
	      }
	    case EnumData.CommandResizeDirection.BOTTOM_LEFT:
	      {
	        toX = currentX;
	        toY = currentY + currentH - toH;
	        break;
	      }
	    case EnumData.CommandResizeDirection.BOTTOM_RIGHT:
	      {
	        toX = currentX + currentW - toW;
	        toY = currentY + currentH - toH;
	        break;
	      }
	    case EnumData.CommandResizeDirection.CENTER:
	      {
	        toX = currentX + (currentW - toW) / 2;
	        toY = currentY + (currentH - toH) / 2;
	        break;
	      }
	    default:
	      {
	        toX = currentX;
	        toY = currentY;
	        break;
	      }
	  }
	
	  command.params = {
	    left: toX,
	    top: toY,
	    width: toW,
	    height: toH,
	    isResize: true
	  };
	
	  command.recovery = {
	    left: currentX,
	    top: currentY,
	    width: currentW,
	    height: currentH,
	    isResize: true
	  };
	
	  //--------------------------------------------------
	  // matt 2017-10-18
	  // 所有命令都需要记录一个动画前的状态，以之后用于自动还原
	  // * 注意数据格式，要符合css的样式规则
	  command.previourCSS = {
	    left: currentX,
	    top: currentY,
	    width: currentW,
	    height: currentH
	  };
	  //--------------------------------------------------
	
	
	  if (!autoReverse) {
	    targetComp.currentX = toX;
	    targetComp.currentY = toY;
	    targetComp.currentW = toW;
	    targetComp.currentH = toH;
	  }
	}
	
	/**
	 * 解析缩放命令
	 * @param command
	 * @param cmdParams
	 * @param targetComp
	 * @param autoReverse
	 */
	function parseScaleCmd(command, cmdParams, targetComp, autoReverse) {
	  var currentScaleX;
	  var currentScaleY;
	  var toScaleX;
	  var toScaleY;
	  var valueModel;
	  var centerMode;
	  var transformOrigin = undefined;
	
	  valueModel = getParamValue(EnumData.CommandParams.PARAM_VALUE_MODE, cmdParams);
	  centerMode = getParamValue(EnumData.CommandParams.PARAM_SCALE_CENTER_MODE, cmdParams);
	
	  currentScaleX = 1;
	  currentScaleY = 1;
	
	  //这里必须要判断不为undefined，因为有可能该值为0；
	  if (!_.isUndefined(targetComp.currentScaleX)) {
	    currentScaleX = targetComp.currentScaleX;
	  }
	  if (!_.isUndefined(targetComp.currentScaleY)) {
	    currentScaleY = targetComp.currentScaleY;
	  }
	
	  toScaleX = getParamValue(EnumData.CommandParams.PARAM_TO_SCALE_X, cmdParams);
	  toScaleY = getParamValue(EnumData.CommandParams.PARAM_TO_SCALE_Y, cmdParams);
	
	  //相对于当前比例进行缩放
	  if (valueModel === EnumData.CommandValueMode.BY) {
	    toScaleX = currentScaleX * toScaleX;
	    toScaleY = currentScaleY * toScaleY;
	  }
	  // 这里默认定位到中心点时，坐标转换值不会变化，但视觉上的坐标全变化
	  switch (centerMode) {
	    case EnumData.CommandScaleDirection.LEFT:
	      transformOrigin = 'left center';
	      break;
	    case EnumData.CommandScaleDirection.RIGHT:
	      transformOrigin = 'right center';
	      break;
	    case EnumData.CommandScaleDirection.TOP:
	      transformOrigin = 'center top';
	      break;
	    case EnumData.CommandScaleDirection.BOTTOM:
	      transformOrigin = 'center bottom';
	      break;
	    case EnumData.CommandScaleDirection.TOP_LEFT:
	      transformOrigin = 'left top';
	      break;
	    case EnumData.CommandScaleDirection.TOP_RIGHT:
	      transformOrigin = 'right top';
	      break;
	    case EnumData.CommandScaleDirection.BOTTOM_LEFT:
	      transformOrigin = 'left bottom';
	      break;
	    case EnumData.CommandScaleDirection.BOTTOM_RIGHT:
	      transformOrigin = 'right bottom';
	      break;
	    case EnumData.CommandScaleDirection.CENTER:
	      transformOrigin = 'center';
	      break;
	    default:
	      transformOrigin = undefined;
	      break;
	  }
	  command.previourCSS = {
	    transformOrigin: transformOrigin
	  };
	  command.params = {
	    scaleX: toScaleX,
	    scaleY: toScaleY
	  };
	
	  command.recovery = {
	    scaleX: currentScaleX,
	    scaleY: currentScaleY
	  };
	
	  if (!autoReverse) {
	    targetComp.currentScaleX = toScaleX;
	    targetComp.currentScaleY = toScaleY;
	  }
	}
	
	/**
	 * 解析滚动命令
	 * @param command
	 * @param cmdParams
	 * @param targetComp
	 */
	function parseScrollToCmd(command, cmdParams, targetComp) {
	  var value = getParamValue(EnumData.CommandParams.PARAM_SCROLL_TO, cmdParams);
	  var top;
	  var portCom = targetComp.items[0];
	  switch (value) {
	    case EnumData.ScrollPosition.TOP:
	      top = 0;
	      break;
	    case EnumData.ScrollPosition.CENTER:
	      top = (targetComp.h - portCom.h) / 2;
	      break;
	    case EnumData.ScrollPosition.BOTTOM:
	      top = targetComp.h - portCom.h;
	      break;
	    default:
	      top = 0;
	      break;
	  }
	  command.params = {
	    top: top,
	    useAnimate: false //暂不支持动画，如果以后有需要，可以扩展
	  };
	  command.isScrollFire = true;
	}
	
	/**
	 * 解析内容面板切换命令
	 * @param command
	 * @param cmdParams
	 * @param targetComp
	 */
	function parseStackCmd(command, cmdParams, targetComp) {
	  var currentIndex = !_.isUndefined(targetComp.currentIndex) ? targetComp.currentIndex : parseInt(targetComp.selectedIndex, 10);
	  var nextIndex = parseInt(cmdParams.SelecedIndex, 10);
	
	  if (currentIndex >= targetComp.items.length) {
	    currentIndex = 0;
	  }
	  //if (currentIndex === nextIndex) {
	  //  return undefined;
	  //}
	  command.params = {
	    nextIndex: nextIndex,
	    currentIndex: currentIndex
	  };
	  command.isStackFire = true;
	  targetComp.currentIndex = nextIndex;
	}
	
	/**
	 * 解析可见性命令
	 * @param command
	 * @param cmdParams
	 * @param targetComp
	 * @param autoReverse
	 */
	function parseVisibleCmd(command, cmdParams, targetComp, autoReverse) {
	  var value = findEnumValue(EnumData.CommandVisibility, cmdParams[EnumData.CommandParams.PARAM_VALUE]);
	  var currentOpacity; // 组件的原始透明度
	  var toOpacity; // 组件的目标透明度
	  var toVisible;
	
	  //当前是否可见
	  var currentVisible = !_.isUndefined(targetComp.currentVisible) ? targetComp.currentVisible : targetComp.isShow; // 组件当前是否可见
	  currentOpacity = parseFloat(targetComp.opacity);
	
	  switch (value) {
	    case EnumData.CommandVisibility.SHOW:
	      toVisible = true;
	      break;
	    case EnumData.CommandVisibility.HIDE:
	      toVisible = false;
	      break;
	    default:
	      toVisible = !currentVisible;
	      break;
	  }
	  toOpacity = toVisible ? currentOpacity : 0;
	
	  command.params = {
	    opacity: toOpacity,
	    afterCSS: {
	      visibility: toVisible ? 'visible' : 'hidden',
	      'pointer-events': toVisible ? 'auto' : 'none',
	      opacity: currentOpacity
	    },
	    toVisible: toVisible
	  };
	  command.previourCSS = {};
	  //只有在即将显示的时候，才把目标预览作隐藏处理
	  if (toVisible) {
	    command.previourCSS = {
	      visibility: 'visible',
	      display: 'block',
	      opacity: 0
	    };
	  }
	  command.recovery = {
	    opacity: toVisible ? 0 : currentOpacity
	  };
	  command.recoveryCSS = {
	    visibility: currentVisible ? 'visible' : 'hidden',
	    opacity: currentVisible ? currentOpacity : 0
	  };
	
	  if (!autoReverse) {
	    targetComp.currentVisible = toVisible;
	  }
	
	  if (toVisible) {
	    interactiveHelper.doUpdateChildVisible(targetComp, toVisible);
	  }
	}
	
	/**
	 * 解析弹出命令
	 * @param page
	 * @param command
	 * @param cmdParams
	 * @param targetComp
	 * @param source
	 */
	//todo:mxj 这个命令之后不再解析弹出组件的弹出参数，仅处理是否弹出，源需要其延时多长时间启动，源组件ID，具体动画参数，由弹出管理类进行解析。这里只负责解析源组件命令中的参数
	function parsePopupCmd(page, command, cmdParams, targetComp, source) {
	  var currentPopupState = targetComp.popup || false;
	  var contentComp = targetComp.items[1];
	  var value = findEnumValue(EnumData.CommandPopupPanelState, cmdParams[EnumData.CommandParams.PARAM_VALUE]);
	  var toPopupState;
	  var isBackgroundFade = targetComp.isBackgroundFade;
	  var isShowBackground = targetComp.isShowBackground;
	  var duration = parseInt(targetComp.aniDuration, 10);
	  var delay = parseInt(targetComp.delayBeforePopup, 10);
	  var platform = page.state.page.platform;
	
	  var contentW = parseInt(contentComp.w, 10);
	  var contentH = parseInt(contentComp.h, 10);
	
	  var positionPolicy = targetComp.positionPolicy;
	  var positionMargin = parseInt(targetComp.positionMargin, 10);
	  var positionScreenMode = targetComp.positionScreenMode;
	  var positionComMode = targetComp.positionComMode;
	  var mobileEff = targetComp.aniType_Mobile;
	  var aniEff = targetComp.aniType;
	  var eff;
	  var isSlidingDrawer = targetComp.controlTypeID === 'SlidingDrawer';
	
	  //这三个数据，必须在命令解析前先好设置好
	  //var pageHeight = parseInt(page.state.page.defaultH, 10);//parseInt(targetComp.pageSize.h, 10);
	  //var pageWidth = parseInt(page.state.page.defaultW, 10);//parseInt(targetComp.pageSize.w, 10);
	
	  var pageWidth = $('.stage-container')[0].clientWidth;
	  var pageHeight = $('.stage-container')[0].clientHeight;
	
	  //var screenOrientation = page.state.page.screenOrientation;
	
	  //consele.log(page)
	  var sourceComAbsoluteBounds;
	  var option = {
	    delay: delay,
	    duration: duration,
	    queue: false
	  };
	
	  //var temp;
	  //if(screenOrientation === 'MoLandscape'){
	  //  temp = pageWidth;
	  //  pageWidth = pageHeight;
	  //  pageHeight = temp;
	  //}
	  //var clipArea;
	
	  targetComp.pageSize = { width: pageWidth, height: pageHeight };
	  if (RuntimeOptions.eventTargetCom) targetComp.sourceBounds = page.getTargetEventComAbsoluteRect(RuntimeOptions.eventTargetCom);
	  targetComp.platform = platform;
	
	  switch (value) {
	    case EnumData.CommandPopupPanelState.CLOSE:
	      toPopupState = false;
	      break;
	    case EnumData.CommandPopupPanelState.POPUP:
	      toPopupState = true;
	      break;
	    default:
	      toPopupState = !currentPopupState;
	      break;
	  }
	  targetComp.currentPopupState = toPopupState;
	  delete targetComp.closeWithTrigger;
	  if (toPopupState) {
	    //doUpdateChildVisible(targetComp, true);
	    //如果是抽屉
	    if (isSlidingDrawer) {
	      //contentComp.y = 0;
	      contentComp.opacity = 1;
	      if (targetComp.drawerSlideDirection === 'sdLeft') {
	        //contentComp.x = -contentW;
	        command.contentCommand = {
	          params: {
	            left: 0
	          }
	        };
	        command.contentCommand.previourCSS = {
	          left: -contentW
	        };
	      } else {
	        //contentComp.x = pageWidth;
	        command.contentCommand = {
	          params: {
	            left: pageWidth - contentW
	          }
	        };
	        command.contentCommand.previourCSS = {
	          left: pageWidth
	        };
	      }
	    } else {
	      //自由定位
	      if (positionPolicy === appTypes.PositionPolicy.FREE) {
	        //移动项目
	        if (platform === appTypes.AppPlatformType.MOBILE || platform === appTypes.AppPlatformType.PAD) {
	          eff = mobileEff;
	          //clipArea = page.getClipAreaScrollView();
	        } else if (platform !== appTypes.AppPlatformType.BLANK) {
	          eff = aniEff;
	        }
	        if (!eff) {
	          eff = appTypes.PopupPanelAniType.NONE;
	        }
	        if (contentComp.h + contentComp.y > pageHeight) {}
	        //contentComp.y = Math.max(0, pageHeight - contentComp.h);
	
	        //TODO : mengxiaojiang 这里还缺少对拉长页面的处理
	        switch (eff) {
	          case appTypes.PopupPanelAniType_Mobile.NONE:
	          case appTypes.PopupPanelAniType.NONE:
	            //contentComp.opacity = 0;
	            command.contentCommand = {
	              params: { opacity: 1 }
	            };
	            break;
	          case appTypes.PopupPanelAniType_Mobile.FADE:
	          case appTypes.PopupPanelAniType.FADE:
	            contentComp.opacity = 0;
	            command.contentCommand = {
	              params: { opacity: 1 }
	            };
	            break;
	          case appTypes.PopupPanelAniType_Mobile.ZOOM_IN:
	          case appTypes.PopupPanelAniType.ZOOM_IN:
	            command.contentCommand = {
	              previourCSS: { scale: 0 },
	              params: { scale: 1 }
	            };
	            break;
	          case appTypes.PopupPanelAniType_Mobile.EXPAND_DOWN:
	            contentComp.h = 0;
	            command.contentCommand = {
	              params: {
	                height: contentH
	              }
	            };
	            break;
	          case appTypes.PopupPanelAniType_Mobile.EXPAND_RIGHT:
	            contentComp.w = 0;
	            command.contentCommand = {
	              params: {
	                width: contentW
	              }
	            };
	            break;
	          case appTypes.PopupPanelAniType_Mobile.MOVE_DOWN:
	            contentComp.y = -contentH;
	            command.contentCommand = {
	              params: {
	                top: 0
	              }
	            };
	            break;
	          case appTypes.PopupPanelAniType_Mobile.MOVE_UP:
	            contentComp.y = pageHeight;
	            contentComp.opacity = 1;
	            command.contentCommand = {
	              params: {
	                top: pageHeight - contentH
	              }
	            };
	            break;
	          case appTypes.PopupPanelAniType_Mobile.MOVE_LEFT:
	            contentComp.x = pageWidth;
	            command.contentCommand = {
	              params: {
	                left: pageWidth - contentW
	              }
	            };
	            break;
	          case appTypes.PopupPanelAniType_Mobile.MOVE_RIGHT:
	            contentComp.x = -contentW;
	            command.contentCommand = {
	              params: {
	                left: 0
	              }
	            };
	            break;
	        }
	      } else if (positionPolicy === appTypes.PositionPolicy.SCREEN) {
	        //相对于屏幕定位
	        if (platform !== appTypes.AppPlatformType.BLANK) {
	          switch (positionScreenMode) {
	            case appTypes.PositionScreenMode.TOP:
	              contentComp.y = positionMargin;
	              break;
	            case appTypes.PositionScreenMode.CENTER:
	              contentComp.y = (pageHeight - contentH) / 2;
	              contentComp.x = (pageWidth - contentW) / 2;
	              break;
	            case appTypes.PositionScreenMode.BOTTOM:
	              contentComp.y = pageHeight - contentH;
	              break;
	          }
	          command.contentCommand = {};
	        }
	      } else {
	        //相对于组件定位
	        sourceComAbsoluteBounds = page.getTargetEventComAbsoluteRect(RuntimeOptions.eventTargetCom);
	        switch (positionComMode) {
	          case appTypes.PositionComMode.LEFT:
	            contentComp.x = sourceComAbsoluteBounds.left - contentW;
	            break;
	          case appTypes.PositionComMode.RIGHT:
	            contentComp.x = sourceComAbsoluteBounds.right;
	            break;
	          case appTypes.PositionComMode.TOP:
	            contentComp.y = sourceComAbsoluteBounds.top - contentH;
	            break;
	          case appTypes.PositionComMode.BOTTOM:
	            contentComp.y = sourceComAbsoluteBounds.bottom;
	            break;
	        }
	        command.contentCommand = {};
	      }
	    }
	    if (command.contentCommand) {
	      command.contentCommand.option = option;
	    }
	    if (isShowBackground) {
	      if (isBackgroundFade) {
	        command.backgroundCommand = {
	          params: {
	            opacity: 1
	          },
	          option: option
	        };
	      } else {
	        command.backgroundCSS = {
	          opacity: 1
	        };
	      }
	    }
	    targetComp.currentX = 0;
	    targetComp.currentY = 0;
	    targetComp.currentW = pageWidth;
	    targetComp.currentH = pageHeight;
	    targetComp.measureWidth = pageWidth;
	    targetComp.measureHeight = pageHeight;
	    targetComp.popup = true;
	    targetComp.currentOrder = getCurrentOrder();
	  } else {
	    targetComp.currentX = targetComp.x;
	    targetComp.currentY = targetComp.y;
	    targetComp.currentW = targetComp.w;
	    targetComp.currentH = targetComp.h;
	    targetComp.closeWithTrigger = true;
	    if (targetComp.popup) {
	      targetComp.isNeedAnimate = true;
	    }
	    targetComp.popup = false;
	  }
	  command.isPopupFire = true;
	}
	
	var currentOrder = 0;
	function getCurrentOrder() {
	  return currentOrder++ + '';
	}
	
	function parseColorCmd(command, cmdParams, targetComp, autoReverse) {
	  var color = cmdParams[EnumData.CommandParams.PARAM_TO_VALUE];
	  color = utils.Color.toHTMLColor(color);
	  var currentColor = !_.isUndefined(targetComp.currentColor) ? targetComp.currentColor : targetComp.color;
	  command.params = {
	    color: color
	  };
	  command.recovery = {
	    color: currentColor
	  };
	  //if (!autoReverse) {
	  //  targetComp.currentColor = color;
	  //}
	  command.isPropsFire = true;
	}
	
	function parseTextCmd(command, cmdParams, targetComp, autoReverse) {
	  var text = cmdParams[EnumData.CommandParams.PARAM_TO_VALUE];
	  text = dataHelper.decodeURI(text);
	  var currentText = !_.isUndefined(targetComp.currentText) ? targetComp.currentText : targetComp.text;
	  command.params = {
	    text: text
	  };
	  command.recovery = {
	    text: currentText
	  };
	  //if (!autoReverse) {
	  //  targetComp.currentText = text;
	  //}
	
	  //Allen:记录下设置文本交互发生的次数
	  targetComp.setTextInteractiveNum = (targetComp.setTextInteractiveNum || 0) + 1;
	
	  command.isPropsFire = true;
	}
	
	function parsePropertyCmd(command, cmdType, cmdParams, targetComp, autoReverse) {
	  var propertyCmdList = EnumData.CommandType.CMD_PROPERTY;
	  var propertyCmdItm;
	  var k;
	  var propertyName = undefined;
	  var currentPropertyName;
	  var oldValue;
	  var fromValue;
	  var toValue;
	  for (k in propertyCmdList) {
	    propertyCmdItm = propertyCmdList[k];
	    if (propertyCmdItm.cmd === cmdType) {
	      propertyName = propertyCmdItm.property;
	      currentPropertyName = propertyCmdItm.current;
	      break;
	    }
	  }
	
	  if (!_.isUndefined(propertyName)) {
	    fromValue = oldValue = targetComp[currentPropertyName] || targetComp[propertyName];
	    toValue = cmdParams[EnumData.CommandParams.PARAM_TO_VALUE];
	    toValue = dataHelper.convertValue(propertyName, toValue);
	    command.params = {};
	    command.params[propertyName] = toValue;
	    command.recovery = {};
	    command.recovery[propertyName] = fromValue;
	    command.isPropsFire = true;
	  }
	}
	/**
	 * 解析命令
	 * @author mengxiaojiang
	 * @date 2016-5-31
	 * @param page 当前页面对象 React创建的页面对象，而不是一个JSON数据对象
	 * @param command 解析后的命令对象，把解析后的结果存放到该对象顺，
	 * @param commandData 原始的命令数据，读取该对象中的数据，并进行解析，不可修改该对象中的数据
	 * @param targetComp 目标数据对象
	 * @param source 事件源数据对象
	 */
	function parseCmd(page, command, commandData, targetComp, source) {
	  var _params = {};
	  var cmdParams = commandData.param;
	  var cmdType = commandData.name;
	  var option;
	  var autoReverse;
	  var i;
	  var interpolation;
	  var duration;
	  var easing = 'swing';
	  for (i = 0; i < cmdParams.length; i++) {
	    _params[cmdParams[i].name] = cmdParams[i].value;
	  }
	  interpolation = getParamValue(EnumData.CommandParams.PARAM_ANI_INTERPOLATION, _params);
	  duration = getParamValue(EnumData.CommandParams.PARAM_ANI_DURATION, _params);
	  //*同名动画，使用jquery中的easeIn...  mxj 2.16-9-28
	  switch (interpolation) {
	    //加速
	    case EnumData.AniInterpolationType.ACCELERATIVE:
	      easing = 'easeInCubic';
	      break;
	    //回退
	    case EnumData.AniInterpolationType.BACK:
	      easing = 'easeInBack';
	      break;
	    //弹跳
	    case EnumData.AniInterpolationType.BOUNCE:
	      easing = 'easeInBounce';
	      break;
	    //伸缩
	    case EnumData.AniInterpolationType.ELASTIC:
	      easing = 'easeInElastic';
	      break;
	    //线性
	    case EnumData.AniInterpolationType.LINEAR:
	      easing = 'linear';
	      break;
	    case EnumData.AniInterpolationType.NONE:
	      duration = 0;
	      break;
	
	  }
	
	  autoReverse = getParamValue(EnumData.CommandParams.PARAM_ANI_AUTO_REVERSE, _params);
	  option = {
	    duration: duration,
	    delay: getParamValue(EnumData.CommandParams.PARAM_DELAY, _params),
	    autoReverse: autoReverse,
	    easing: easing,
	    aniInterpolation: getParamValue(EnumData.CommandParams.PARAM_ANI_INTERPOLATION, _params) //考虑下载JQUERY的动画类型库来实现丰富的动画类型
	  };
	
	  ////Allen: 处理定时器交互动画不执行问题
	  //if(source.controlTypeID === 'Timer') {
	  //  option.delay = source.interval || 1000;
	  //}
	
	  if (!command) {
	    command = {};
	  }
	
	  command.option = option;
	
	  switch (cmdType) {
	    case EnumData.CommandType.CMD_MOVE:
	      parseMoveCmd(command, _params, targetComp, autoReverse);
	      break;
	    case EnumData.CommandType.CMD_POPUP_STATE:
	      parsePopupCmd(page, command, _params, targetComp, source);
	      break;
	    case EnumData.CommandType.CMD_VISIBILITY:
	      parseVisibleCmd(command, _params, targetComp, autoReverse);
	      break;
	    case EnumData.CommandType.CMD_ROTATE:
	      parseRotateCmd(command, _params, targetComp, autoReverse);
	      break;
	    case EnumData.CommandType.CMD_RESIZE:
	      parseResizeCmd(command, _params, targetComp, autoReverse);
	      break;
	    case EnumData.CommandType.CMD_SCALE:
	      parseScaleCmd(command, _params, targetComp, autoReverse);
	      break;
	    case EnumData.CommandType.CMD_SCROLL:
	      parseScrollToCmd(command, _params, targetComp);
	      break;
	    case EnumData.CommandType.CMD_STACKPANEL_SWTICH:
	      parseStackCmd(command, _params, targetComp);
	      break;
	    case EnumData.CommandType.CMD_COLOR:
	      parseColorCmd(command, _params, targetComp, autoReverse);
	      break;
	    case EnumData.CommandType.CMD_TEXT:
	      parseTextCmd(command, _params, targetComp, autoReverse);
	      break;
	    default:
	      parsePropertyCmd(command, cmdType, _params, targetComp, autoReverse);
	      break;
	  }
	  console.log(command);
	}
	
	exports.parser = parseCmd;

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Created by lovely on 2016/6/7.
	 */
	module.exports = {
	  eventTargetCom: undefined
	};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var versionHelper = __webpack_require__(124);
	
	module.exports = {
	  CurrentPropsMap: {
	    color: 'currentColor',
	    text: 'currentText',
	    left: 'currentX',
	    top: 'currentY',
	    width: 'currentW',
	    height: 'currentH',
	    scaleX: 'currentScaleX',
	    scaleY: 'currentScaleY',
	    rotate: 'currentAngle',
	    popup: 'currentPopupState',
	    visible: 'currentVisible',
	    nextIndex: 'currentIndex',
	    textColor: 'currentTextColor'
	  },
	
	  //同步組內組件的可見性
	  updateChildDomVisible: function updateChildDomVisible(groupCom, visible) {
	    var item;
	    var childDom;
	    var i = 0;
	
	    //兼容3.2.6后隐藏策略调整
	    if (!versionHelper.isPageVersionLowerThan4_9()) {
	      return;
	    }
	
	    if (groupCom.items) {
	      for (i; i < groupCom.items.length; i++) {
	        item = groupCom.items[i];
	        childDom = $('#' + item.controlID);
	        childDom.css({ visibility: visible ? 'visible' : 'hidden' });
	        if (item.items) {
	          this.updateChildDomVisible(item, visible);
	        }
	      }
	    }
	  },
	
	  doUpdateChildVisible: function doUpdateChildVisible(groupCom, visible) {
	    var item;
	    var i = 0;
	
	    //兼容3.2.6后隐藏策略调整
	    if (!versionHelper.isPageVersionLowerThan4_9()) {
	      return;
	    }
	
	    if (groupCom.items) {
	      for (i; i < groupCom.items.length; i++) {
	        item = groupCom.items[i];
	        item.currentVisible = visible;
	        if (item.items) {
	          this.doUpdateChildVisible(item, visible);
	        }
	      }
	    }
	  },
	
	  //返回值是所有连接点的交互数据
	  getInteractiveByComp: function getInteractiveByComp(comp) {
	    var i = 0;
	    var links;
	    var entries;
	    var result = [];
	    var l = 0;
	
	    if (props.interactiveData) {
	      entries = props.interactiveData.entry;
	      if (entries) {
	        l = entries.length;
	        for (i = 0; i < l; i++) {
	          if (this.isValidInteractive(entries[i])) {
	            result.push({ entry: entries[i] });
	          } else {
	            result.push({});
	          }
	        }
	      }
	    }
	    if (props.links && props.links.link) {
	      links = props.links.link;
	      l = links.length;
	      for (i = 0; i < l; i++) {
	        if (!result[i]) {
	          result[i] = {};
	        }
	        if (this.isValidLink(links[i])) {
	          result[i].link = links[i];
	        }
	      }
	    }
	
	    return result;
	  },
	
	  isValidLink: function isValidLink(link) {
	    if (link && link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
	      return true;
	    }
	    return false;
	  },
	
	  isValidEntry: function isValidEntry(entry) {
	    if (entry && entry.events && entry.events.event && entry.events.event.length) {
	      return true;
	    }
	    return false;
	  },
	
	  isValidInteractive: function isValidInteractive(entry) {
	    var i;
	    var j;
	    var c = false;
	    var e;
	    var t;
	    var b;
	    if (entry.events && entry.events.event) {
	      for (i = 0; i < entry.events.event.length; i++) {
	        e = entry.events.event[i];
	        if (e.isChecked) {
	          b = e.behaviour[0];
	          for (j = 0; j < b.target.length; j++) {
	            t = b.target[j];
	            if (t && t.isChecked) {
	              c = true;
	              break;
	            }
	          }
	          if (c) {
	            break;
	          }
	        }
	      }
	    }
	    return c;
	  }
	};

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * 查找指定事件类型的交互事件数据
	 * */
	
	exports.findEventByType = function (com, entryIndex, eventType) {
	  var entry;
	  var interactiveData;
	  if (!com) {
	    return null;
	  }
	  if (!entryIndex) {
	    entryIndex = 0;
	  }
	  interactiveData = com.interactiveData;
	  if (interactiveData) {
	    if (entryIndex < interactiveData.entry.length) {
	      entry = interactiveData.entry[entryIndex];
	      if (entry && entry.events && entry.events.event) {
	        for (var i = 0; i < entry.events.event.length; i++) {
	          var evt = entry.events.event[i];
	          if (evt.eventType === eventType) {
	            if (evt.isChecked === 'True' || evt.isChecked) {
	              return evt;
	            } else {
	              break;
	            }
	          }
	        }
	      }
	    }
	  }
	  return null;
	};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	
	var CLOSE_POPUP_EVENT = 'onClosePopup';
	var OPEN_POPUP_EVENT = 'onOpenPopup';
	
	var popupStack = {};
	
	//todo:mxj 弹出与关闭的动画之后由这个函数中来解析。因为这些参数属于组件本身的属性
	function RegisterPopup(popup, manager) {
	  this.manager = manager;
	  var self = this;
	  //todo:mxj 这里未使用的几个变量，函数保留，为之后需要改进时所要使用的
	  var contentOpenBeforeCSS;
	  var contentOpenAnimateParams;
	  var contentCloseAnimateParams;
	  var bgOpenAnimateParams;
	  var bgCloseAnimateParams;
	  var bgAnimateOption;
	  var contentAnimateOption;
	  var showBackground;
	  var props = popup.props;
	  var contentProps = props.items[1];
	  var openFinish;
	  var closeFinish;
	
	  this.dom = ReactDOM.findDOMNode(popup);
	  this.content = $(ReactDOM.findDOMNode(popup.refs.content));
	  this.background = $(ReactDOM.findDOMNode(popup.refs.background));
	  /*
	   function doInitBgAnimate(){
	   if(props.isBackgroundFade) {
	   bgOpenAnimateParams = {opacity: 1};
	   bgCloseAnimateParams = {opacity: 0};
	   }else{
	   bgOpenAnimateParams = {visibility:'visible'};
	   bgCloseAnimateParams = {visibility:'hidden'};
	   }
	   }
	     function doFadeIn(){
	   contentOpenBeforeCSS = {opacity : 0};
	   contentOpenAnimateParams = {opacity : 1};
	   contentCloseAnimateParams = {opacity : 0};
	   }
	     function doMoveToUp(){
	   contentOpenBeforeCSS = {top : props.pageSize.height};
	   contentOpenAnimateParams = {y : props.pageSize.height - contentProps.h};
	   contentCloseAnimateParams = {y: contentOpenBeforeCSS.top};
	   }
	     function doMoveToDown(){
	   contentOpenBeforeCSS = {top : 0 - contentProps.h};
	   contentOpenAnimateParams = {y : 0};
	   contentCloseAnimateParams = {y: contentOpenBeforeCSS.top};
	   }
	     function  doMoveToLeft(){
	   contentOpenBeforeCSS = {left : props.pageSize.width};
	   contentOpenAnimateParams = {x : contentOpenBeforeCSS.left - contentProps.w};
	   contentCloseAnimateParams = {x: contentOpenBeforeCSS.left};
	   }
	     function doMoveToRight(){
	   contentOpenBeforeCSS = {left : 0-contentProps.w};
	   contentOpenAnimateParams = {x : 0};
	   contentCloseAnimateParams = {x: contentOpenBeforeCSS.left};
	   }
	     function doZoomIn(){
	   contentOpenBeforeCSS = {left : props.pageSize.width/2,top:props.pageSize.height/2,scale:0};
	   contentOpenAnimateParams = {x : (props.pageSize.width - contentProps.w)/2,y:(props.pageSize.height - contentProps.h)/2,scale:1};
	   contentCloseAnimateParams = {x: contentOpenBeforeCSS.left,y:contentOpenBeforeCSS.top,scale:0};
	   }
	     function doExpandToUp(){
	   contentOpenBeforeCSS = {top:props.pageSize.height,height : 0};
	   contentOpenAnimateParams = {y : props.pageSize.height - contentProps.h,height:contentProps.h};
	   contentCloseAnimateParams = {y:props.pageSize.height,height:0};
	   }
	     function doExpandToDown(){
	   contentOpenBeforeCSS = {top:0,height:0};
	   contentOpenAnimateParams = {height:contentProps.h};
	   contentCloseAnimateParams = {height:0};
	   }
	     function doExpandToLeft(){
	   contentOpenBeforeCSS = {left:props.pageSize.width,width:0};
	   contentOpenAnimateParams = {x:props.pageSize.width - contentProps.w,width:contentProps.w};
	   contentCloseAnimateParams = {x : props.pageSize.width,width:0};
	   }
	     function doExpandToRight(){
	   contentOpenBeforeCSS = {left:0,width:0};
	   contentOpenAnimateParams = {width:contentProps.w};
	   contentCloseAnimateParams = {width:0};
	   }
	     //isBackgroundFade="False"
	   //aniType_Mobile="aniFade"
	   //aniType="dnNone"
	   //closeByClickMode="cmClickOutSizeArea"
	   //closeByKeyModes="[kmEsc,kmEnter]"
	   //isShowBackground="False"
	   //delayBeforePopup="0"
	   //aniDuration="200"
	   //positionPolicy="ppScreenFix"
	   //positionMargin="0"
	   //positionScreenMode="psCenter"
	   //positionComMode="pcBottom"
	  
	   function doInitAnimateOptions(){
	     }
	     function doShowOrigPoint(){
	   contentOpenBeforeCSS = {visibility : 'visible'};
	   }
	     function doLocationToScreenTop(margin){
	   contentOpenBeforeCSS = {top : margin};
	   }
	     function doLocationToScreenBottom(margin){
	   contentOpenBeforeCSS = {top : props.pageSize.height - contentProps.h - margin};
	   }
	     function doLocationToScreenCenter(){
	   contentOpenBeforeCSS = {top : (props.pageSize.height - contentProps.h)/2};
	   }
	     function doLocationToSourceComTop(margin){
	   contentOpenBeforeCSS = {top : props.sourceBounds.top - contentProps.h - margin};
	   }
	     function doLocationToSourceComBottom(margin){
	   contentOpenBeforeCSS = {top : props.sourceBounds.bottom - margin};
	   }
	     function doLocationToSourceComLeft(margin){
	   contentOpenBeforeCSS = {left : props.sourceBounds.left - contentProps.w - margin};
	   }
	     function doLocationToSourceComRight(margin){
	   contentOpenBeforeCSS = {left : props.sourceBounds.roght + margin};
	   }
	     function doShowInPoint(){}
	     function doLocationToScreen(){
	   var mode = props.positionScreenMode;
	   var margin = parseInt(props.positionMargin,10);
	   switch (mode){
	   case appTypes.PositionScreenMode.TOP:
	   doLocationToScreenTop(margin);
	   break;
	   case appTypes.PositionScreenMode.CENTER:
	   doLocationToScreenCenter();
	   break;
	   case appTypes.PositionScreenMode.BOTTOM:
	   doLocationToScreenBottom(margin);
	   break;
	   }
	   }
	     function doLocationToSourceCom(){
	   var mode = props.positionComMode;
	   var margin = parseInt(props.positionMargin,10);
	   switch(mode){
	   case appTypes.PositionComMode.TOP:
	   doLocationToSourceComTop(margin);
	   break;
	   case appTypes.PositionComMode.BOTTOM:
	   doLocationToSourceComBottom(margin);
	   break;
	   case appTypes.PositionComMode.LEFT:
	   doLocationToSourceComLeft(margin);
	   break;
	   case appTypes.PositionComMode.RIGHT:
	   doLocationToSourceComRight(margin);
	   break;
	   }
	   }
	     function doLocationFree(){
	   var platform = props.platform;
	   var aniType;
	   if (platform === appTypes.AppPlatformType.MOBILE || platform === appTypes.AppPlatformType.PAD) {
	   aniType = props.aniType_Mobile;
	   } else if (platform !== appTypes.AppPlatformType.BLANK) {
	   aniType = props.aniType;
	   }
	   if(!_.isUndefined(props.drawerSlideDirection)){
	   if(props.drawerSlideDirection === 'sdLeft'){
	   doMoveToRight();
	   }else{
	   doMoveToLeft();
	   }
	     return;
	   }
	   console.log(aniType);
	   switch (aniType){
	   case appTypes.PopupPanelAniType.FADE:
	   case appTypes.PopupPanelAniType_Mobile.FADE:
	   doFadeIn();
	   break;
	   case appTypes.PopupPanelAniType.ZOOM_IN:
	   case appTypes.PopupPanelAniType_Mobile.ZOOM_IN:
	   doZoomIn();
	   break;
	   case appTypes.PopupPanelAniType.NONE:
	   case appTypes.PopupPanelAniType_Mobile.NONE:
	   doShowOrigPoint();
	   break;
	   case appTypes.PopupPanelAniType_Mobile.MOVE_UP:
	   doMoveToUp();
	   break;
	   case appTypes.PopupPanelAniType_Mobile.MOVE_DOWN:
	   doMoveToDown();
	   break;
	   case appTypes.PopupPanelAniType_Mobile.MOVE_LEFT:
	   doMoveToLeft();
	   break;
	   case appTypes.PopupPanelAniType_Mobile.MOVE_RIGHT:
	   doMoveToRight();
	   break;
	   case appTypes.PopupPanelAniType_Mobile.EXPAND_DOWN:
	   doExpandToDown();
	   break;
	   case appTypes.PopupPanelAniType_Mobile.EXPAND_RIGHT:
	   doExpandToRight();
	   break;
	   case appTypes.PopupPanelAniType_Mobile.EXPAND_UP:
	   doExpandToUp();
	   break;
	   case appTypes.PopupPanelAniType_Mobile.EXPAND_LEFT:
	   doExpandToLeft();
	   break;
	   }
	   }
	     function builderOpenAnimateParams(){
	   var positionPolicy = props.positionPolicy;
	     contentCloseAnimateParams = contentOpenAnimateParams = contentOpenBeforeCSS = bgOpenAnimateParams = bgCloseAnimateParams = undefined;
	   switch(positionPolicy){
	   case appTypes.PositionPolicy.FREE:
	   doLocationFree();
	   break;
	   case appTypes.PositionPolicy.SCREEN:
	   doLocationToScreen();
	   break;
	   case appTypes.PositionPolicy.SOURCE_COM:
	   doLocationToSourceCom();
	   break;
	   }
	   if(props.isShowBackground) {
	   doInitBgAnimate();
	   }
	   }
	     function openAnimate(){
	   if (self.popup.props.isShowBackground && self.popup.props.isFade) {
	   self.background.animate({opacity:1});
	   }
	   if (openAnimateParams) {
	   if(command.contentCommand.previourCSS){
	   content.css(command.contentCommand.previourCSS);
	   }
	   content.animate(command.contentCommand.params, option);
	   } else {
	   content.css({opacity: 1});
	   }
	   }
	  
	   function doOpen(){
	   builderOpenAnimateParams();
	   console.log('==============================================================');
	   console.log('contentOpenAnimateParams',contentOpenAnimateParams);
	   console.log('contentCloseAnimateParams',contentCloseAnimateParams);
	   console.log('contentOpenBeforeCSS',contentOpenBeforeCSS);
	   console.log('bgOpenAnimateParams',bgOpenAnimateParams);
	   console.log('bgCloseAnimateParams',bgCloseAnimateParams);
	   }
	     function doClose(){}
	     */
	
	  function closeAnimate(ani, callback) {
	    var duration = 10;
	    self.content.animate({ opacity: 0 }, {
	      queue: false, duration: duration, complete: function complete() {
	        callback(true);
	      }
	    });
	    self.background.animate({ opacity: 0 }, { queue: false, duration: duration });
	    $(self.dom).off(CLOSE_POPUP_EVENT);
	    $(self.dom).off(OPEN_POPUP_EVENT);
	    self.popup.isOpen = false;
	    self.popup.popupManager = null;
	    delete self.popup.popupManager;
	    delete popupStack[props.controlID];
	  }
	
	  function startLoadInteractive() {
	    if (self.popup) {
	      if (self.popup.props) {
	        if (self.popup.props.onOpened) {
	          self.popup.props.onOpened(self.popup.props);
	        }
	      }
	    }
	  }
	
	  function registerCloseFunction() {
	
	    $(self.dom).off(CLOSE_POPUP_EVENT);
	    $(self.dom).on(CLOSE_POPUP_EVENT, function (e, data) {
	      var pageMouseX;
	      var pageMouseY;
	      var closePolicy = self.popup.props.closeByClickMode;
	      var contentDom;
	      var contentBounds;
	      var comID;
	      self.callback = undefined;
	      if (data) {
	        comID = data.controlID;
	        if (comID === self.popup.props.controlID) {
	          self.callback = data.callback;
	          if (!_.isUndefined(data.mousePoint)) {
	            pageMouseX = data.mousePoint.x;
	            pageMouseY = data.mousePoint.y;
	            if (closePolicy === appTypes.PopupPanelClosePolicy.ALL) {
	              closeAnimate({}, afterClose);
	            } else if (closePolicy === appTypes.PopupPanelClosePolicy.OUT_AREA) {
	              contentDom = self.content[0];
	              contentBounds = contentDom.getBoundingClientRect();
	              if (!(pageMouseX > contentBounds.left && pageMouseX < contentBounds.right && pageMouseY > contentBounds.top && pageMouseY < contentBounds.bottom)) {
	                closeAnimate({}, afterClose);
	              } else {
	                afterClose();
	              }
	            } else {
	              afterClose();
	            }
	          } else {
	            if (closePolicy !== appTypes.PopupPanelClosePolicy.NONE) {
	              closeAnimate({}, afterClose);
	            } else {
	              afterClose(true);
	            }
	          }
	        }
	      }
	    });
	  }
	
	  function onPopup() {
	    startLoadInteractive();
	  }
	
	  function registerOpenFunction() {
	    $(self.dom).off(OPEN_POPUP_EVENT);
	    $(self.dom).on(OPEN_POPUP_EVENT, function () {
	      if (self.popup.props.popupCommand) {
	        if (self.popup.props.open) {
	          self.popup.props.open($(self.dom), self.popup.props, self.content, self.background, onPopup);
	        }
	      }
	    });
	  }
	
	  function registerScreenClick() {
	    $(self.dom).off('onScreenClick');
	    $(self.dom).on('onScreenClick', function (e, data) {
	      /*
	      1、查找此处被点击的最上层组件
	      2、如果找到，判断是否有链接跳转，如果有，不做弹出关闭动作
	      3、如果不满足条件2时，判断源组件是否有交互，如果有，不关闭（可以考虑目标是否包含当前的弹出组件，如果不包含，则也执行4）
	      4、如果3也不满足时，判断点击坐标是否在内容上，并根据条件判断是否关闭
	       */
	
	      //console.log(data)
	    });
	  }
	
	  function afterClose(isRefresh) {
	    if (self.callback) {
	      self.callback(isRefresh ? props.controlID : undefined);
	    }
	  }
	
	  popup.open = function () {
	    if (self.popup.props.popupCommand) {
	      $(self.dom).trigger(OPEN_POPUP_EVENT);
	    }
	  };
	
	  function init() {
	    $(self.dom).off(OPEN_POPUP_EVENT);
	    $(self.dom).off(CLOSE_POPUP_EVENT);
	  }
	
	  this.popup = popup;
	  popup.popupManager = this;
	  init();
	  registerCloseFunction();
	  registerOpenFunction();
	  registerScreenClick();
	}
	
	module.exports = {
	  //注册一个弹出面板对象
	  registerPopup: function registerPopup(popup) {
	    new RegisterPopup(popup, this);
	  },
	
	  init: function init() {},
	
	  //触发一个弹出面板的打开事件
	  //之后改进时的参数必须包含data,
	  //data中必须包含一个callback的回调函数
	  OPEN_POPUP_EVENT: OPEN_POPUP_EVENT,
	  //触发一个弹出面板的关闭事件，分发该事件时，有两个参数onClosePopup(e,data),
	  // 其中data如果不为空时，
	  // 可以包含 callback 的回调函数，它有一个参数CompID
	  // 可以包含mousePoint的参数，该值为页面的鼠标坐标 ｛x,y｝
	  CLOSE_POPUP_EVENT: CLOSE_POPUP_EVENT
	};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var LinkHelper = __webpack_require__(158);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	
	var LinkArea = React.createClass({
	  displayName: 'LinkArea',
	
	  propTypes: {
	    links: React.PropTypes.object,
	    interactive: React.PropTypes.object,
	    size: React.PropTypes.object.isRequired,
	    externalURL: React.PropTypes.string,
	    onLinkEvent: React.PropTypes.func.isRequired,
	    onLongPressEvent: React.PropTypes.func.isRequired,
	    k: React.PropTypes.string
	  },
	
	  longPress: false,
	
	  isLongPress: false,
	
	  getLinkAreaArray: function getLinkAreaArray() {
	    var i;
	    var link;
	    var linkItem;
	    var resultLinkArray = [];
	
	    var entry;
	    var events;
	    var index = 0;
	
	    if (!this.props.links && !this.props.interactive) {
	      return resultLinkArray;
	    }
	
	    /*if (this.props.links.link) {
	        for (i = 0; i < this.props.links.link.length; i++) {
	        link = this.props.links.link[i];
	        linkItem = {};
	          if (link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
	          linkItem.index = i;
	          linkItem.linkCoords = link.area.coords;
	        }
	          if (this.props.interactive) {
	          entry = this.props.interactive.entry[i];
	          if (entry) {
	            events = entry.events;
	            if (events && events.event && events.event.length) {
	              linkItem.index = i;
	              if(this.isChecked(entry))
	                linkItem.interactiveCoords = entry.area.coords;
	            }
	          }
	        }
	            if (!_.isEmpty(linkItem)) {
	          resultLinkArray.push(linkItem);
	        }
	        }
	    }*/
	
	    if (this.props.interactive && this.props.interactive.entry) {
	      for (i = 0; i < this.props.interactive.entry.length; i++) {
	        linkItem = {};
	        entry = this.props.interactive.entry[i];
	        if (entry) {
	          events = entry.events;
	          if (events && events.event && events.event.length) {
	            if (this.isChecked(entry)) {
	              linkItem.index = i;
	              linkItem.interactiveCoords = entry.area.coords;
	            }
	          }
	        }
	
	        resultLinkArray.push(linkItem);
	      }
	    }
	
	    if (this.props.links && this.props.links.link) {
	
	      for (i = 0; i < this.props.links.link.length; i++) {
	        link = this.props.links.link[i];
	        linkItem = resultLinkArray[i] || {};
	
	        if (link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
	          linkItem.index = i;
	          linkItem.linkCoords = link.area.coords;
	        }
	
	        if (!resultLinkArray[i]) {
	          resultLinkArray.push(linkItem);
	        }
	      }
	    }
	
	    return resultLinkArray;
	  },
	
	  isChecked: function isChecked(entry) {
	    var i;
	    var j;
	    var c = false;
	    var e;
	    var t;
	    var b;
	    if (entry.events && entry.events.event) {
	      for (i = 0; i < entry.events.event.length; i++) {
	        e = entry.events.event[i];
	        if (e.isChecked) {
	          b = e.behaviour[0];
	          for (j = 0; j < b.target.length; j++) {
	            t = b.target[j];
	            if (t && t.isChecked) {
	              c = true;
	              break;
	            }
	          }
	          if (c) {
	            break;
	          }
	        }
	      }
	    }
	    return c;
	  },
	
	  /**
	   * 触发页面链接
	   * @param index
	   * @param evt
	   * @private
	   */
	  _onPageLinkEvent: function _onPageLinkEvent(index, evt) {
	    this.props.onLinkEvent(evt, appTypes.ActionResponseType.LINK, index);
	    this._onExternalLinkEvent(evt);
	    evt.stopPropagation();
	  },
	  /**
	   * 触发双击交互
	   * @param index
	   * @param evt
	   * @private
	   */
	  _onDblClick: function _onDblClick(index, evt) {
	    evt.stopPropagation();
	    if (this.props.onDblClick) {
	      this.props.onDblClick(evt, index);
	    }
	  },
	
	  /**
	   * 触发右键点击交互
	   * @param index
	   * @param evt
	   * @private
	   */
	  _onRightClick: function _onRightClick(index, evt) {
	    if (this.props.onRightClick) {
	      this.props.onRightClick(evt, index);
	    }
	  },
	
	  _onMouseDown: function _onMouseDown(index, evt) {
	    if (evt.button === 0) {
	      this.mousePress = true;
	      this.isLongPress = false;
	      this.startListernLongPress(index, evt);
	    } else if (evt.button === 2) {
	      this.rightDownIndex = index;
	    }
	  },
	
	  _onMouseUp: function _onMouseUp(index, evt) {
	    this.mousePress = false;
	    this._stopListernLongPress();
	    if (this.rightDownIndex === index) {
	      delete this.rightDownIndex;
	      this._onRightClick(index);
	    }
	  },
	
	  _onContextMenu: function _onContextMenu(evt) {
	    evt.nativeEvent.returnValue = false;
	    return false;
	  },
	
	  _stopListernLongPress: function _stopListernLongPress() {
	    if (this.timeID) {
	      clearTimeout(this.timeID);
	    }
	    delete this.timeID;
	  },
	
	  /**
	   * 触发长按事件
	   * @param index
	   * @param evt
	   */
	  startListernLongPress: function startListernLongPress(index, evt) {
	    var self = this;
	    if (LinkHelper.hasLongPressEvents(self.props.interactive, index)) {
	      this.timeID = setTimeout(function () {
	        self.isLongPress = true;
	        self._stopListernLongPress();
	        if (self.mousePress) {
	          if (self.props.onLongPressEvent) {
	            self.props.onLongPressEvent(evt, index);
	          }
	        }
	      }, 800);
	    }
	  },
	
	  /**
	   * 触发点击交互
	   * @param index
	   * @param evt
	   * @private
	   */
	  _onInteractiveLinkEvent: function _onInteractiveLinkEvent(index, evt) {
	    //evt.stopPropagation();
	    if (this.isLongPress) {
	      evt.stopPropagation();
	      return;
	    }
	    this.props.onLinkEvent(evt, appTypes.ActionResponseType.INTERACTIVE, index);
	    this._onExternalLinkEvent(evt);
	  },
	
	  /**
	   * 触发外部链接
	   * @param evt
	   * @private
	   */
	  _onExternalLinkEvent: function _onExternalLinkEvent(evt) {
	    if (this.props.externalURL) {
	      this.props.onLinkEvent(evt, appTypes.ActionResponseType.OUTER);
	    }
	  },
	
	  createPageLinkArea: function createPageLinkArea(coordinate, index) {
	    var divStyle = {
	      left: coordinate.left,
	      top: coordinate.top,
	      width: coordinate.width,
	      height: coordinate.height
	    };
	
	    return React.createElement('div', {
	      className: 'page-link',
	      key: index,
	      style: divStyle,
	      onClick: this._onPageLinkEvent.bind(this, index)
	    });
	  },
	
	  createInteractiveLinkArea: function createInteractiveLinkArea(coordinate, index) {
	    var divStyle = {
	      left: coordinate.left,
	      top: coordinate.top,
	      width: coordinate.width,
	      height: coordinate.height
	    };
	
	    return React.createElement('div', {
	      className: 'interactive-link',
	      key: index,
	      style: divStyle,
	      onDoubleClick: this._onDblClick.bind(this, index),
	      onMouseDown: this._onMouseDown.bind(this, index),
	      onMouseUp: this._onMouseUp.bind(this, index),
	      onClick: this._onInteractiveLinkEvent.bind(this, index),
	      onContextMenu: this._onContextMenu
	    });
	  },
	
	  render: function render() {
	    var linkArray = this.getLinkAreaArray();
	    var divStyle;
	    var _this = this;
	
	    if (linkArray && linkArray.length) {
	      divStyle = {
	        width: 0, //this.props.size.w,
	        height: 0 //this.props.size.h
	      };
	      return React.createElement(
	        'div',
	        {
	          className: 'linkArea',
	          onClick: this._onExternalLinkEvent,
	          key: this.props.k,
	          id: this.props.k,
	          style: divStyle },
	        linkArray.map(function (item) {
	          if (item.linkCoords) {
	            return _this.createPageLinkArea(item.linkCoords, item.index);
	          } else if (item.interactiveCoords) {
	            return _this.createInteractiveLinkArea(item.interactiveCoords, item.index);
	          }
	        })
	      );
	    }
	
	    return React.createElement('div', { key: this.props.k, style: {
	        display: 'none'
	      } });
	  }
	});
	
	module.exports = LinkArea;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	var interactiveType = __webpack_require__(151);
	var util = __webpack_require__(116);
	
	module.exports = {
	  parseComInteractive: function parseComInteractive(props) {
	    var i = 0;
	    var links;
	    var entries;
	    var result = [];
	    var externalURL = props.externalURL;
	    var l = 0;
	    var d;
	    if (props.interactiveData) {
	      entries = props.interactiveData.entry;
	      if (entries) {
	        l = entries.length;
	        for (i = 0; i < l; i++) {
	          if (this.isValidEntry(entries[i])) {
	            result.push({ entry: entries[i] });
	          } else {
	            result.push({});
	          }
	        }
	      }
	    }
	    if (props.links && props.links.link) {
	      links = props.links.link;
	      l = links.length;
	      for (i = 0; i < l; i++) {
	        if (!result[i]) {
	          result[i] = {};
	        }
	        if (this.isValidLink(links[i])) {
	          if (result[i]) {
	            result[i].link = links[i];
	          }
	        }
	      }
	    }
	    if (externalURL) {
	      l = result.length;
	      for (i; i < l; i++) {
	        result[i].externalURL = externalURL;
	      }
	    }
	    return result;
	  },
	
	  isValidLink: function isValidLink(link) {
	    if (link && link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
	      return true;
	    }
	    return false;
	  },
	
	  isValidEntry: function isValidEntry(entry) {
	    if (entry && entry.events && entry.events.event && entry.events.event.length) {
	      return true;
	    }
	    return false;
	  },
	
	  isValidExternalURL: function isValidExternalURL(url) {
	    return !_.isEmpty(url);
	  },
	
	  isCanFocus: function isCanFocus(props) {
	    var d = this.parseComInteractive(props);
	    var valid = false;
	    var itm;
	    if (d && d.length) {
	      if (d.length > 1) {
	        return true;
	      } else {
	        itm = d[0];
	      }
	      valid = itm.link !== undefined || itm.entry !== undefined || itm.externalURL !== undefined;
	    }
	    if (!valid) {
	      valid = ['ContentPanel', 'ScrollView', 'ScrollArea', 'Panel'].indexOf(props.controlTypeID) !== -1;
	    }
	    return valid;
	  },
	
	  hasLongPressByEntry: function hasLongPressByEntry(entry) {
	    var r = false;
	    var i;
	    var event;
	    if (entry && entry.events && entry.events.event) {
	      for (i = 0; i < entry.events.event.length; i++) {
	        event = entry.events.event[i];
	        if (event.eventType === interactiveType.InteractiveTypes.EventType.LONG_PRESS) {
	          r = true;
	          break;
	        }
	      }
	    }
	    return r;
	  },
	
	  hasLongPressEvents: function hasLongPressEvents(interactive, index) {
	    var r = false;
	    var entry;
	    if (interactive) {
	      entry = interactive.entry[index];
	      return this.hasLongPressByEntry(entry);
	    }
	    return r;
	  },
	
	  haveAction: function haveAction(item) {//可交互单位是否有交互数据
	
	  },
	
	  checkLink: function checkLink(comp) {
	    var link;
	
	    if (comp.links && comp.links.link) {
	      link = comp.links.link;
	      return link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK;
	    }
	    return false;
	  },
	
	  checkInteractive: function checkInteractive(entry) {
	    var i;
	    var j;
	    var e;
	    var target;
	    var behavior;
	    if (entry.events && entry.events.event) {
	      for (i = 0; i < entry.events.event.length; i++) {
	        e = entry.events.event[i];
	        if (e.isChecked) {
	          behavior = e.behaviour[0];
	          for (j = 0; j < behavior.target.length; j++) {
	            target = behavior.target[j];
	            if (target && target.isChecked) {
	              return true;
	            }
	          }
	        }
	      }
	    }
	    return false;
	  },
	
	  tranItemRect: function tranItemRect(str) {
	    var links;
	    var i;
	
	    if (str) {
	      try {
	        links = JSON.parse(str);
	      } catch (err) {
	        console.log("error");
	      }
	
	      for (i = 0; i < links.length; i++) {
	        var link = links[i];
	        link = util.Rect.init(link);
	      }
	    }
	    return links;
	  }
	};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var timeLogHelper = __webpack_require__(134);
	
	var Log = {
	  componentWillMount: function componentWillMount() {
	    this.mountStart = Date.now();
	  },
	  componentDidMount: function componentDidMount() {
	    timeLogHelper.logComponentRender(this.props.controlTypeID, Date.now() - this.mountStart);
	  }
	  // componentWillUpdate: function () {
	  //   this.updateStart = Date.now();
	  // },
	  // componentDidUpdate: function () {
	  //   timeLogHelper.logComponentRender(this.props.controlTypeID, Date.now() - this.updateStart);
	  // }
	};
	
	module.exports = Log;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(51);
	var util = __webpack_require__(116);
	var propConst = __webpack_require__(147);
	/*
	 <states>
	 <state propName="Color" stateType="state_mouseOver" isChecked="True" value="4293875286" varType="20"/>
	 </states>
	 */
	
	var STATE_TYPE = {
	  MOUSE_DOWN: 'state_mouseDown',
	  MOUSE_UP: 'state_mouseUp',
	  MOUSE_OVER: 'state_mouseOver',
	  MOUSE_OUT: 'state_mouseOut'
	};
	
	var parse = {
	  parseToColor: function parseToColor(value) {
	    return util.Color.toHTMLColor(value);
	  },
	
	  parseToBool: function parseToBool(value) {
	    return value === true || value === 'True';
	  },
	
	  parseToInt: function parseToInt(value) {
	    return util.Int(value);
	  },
	
	  parseToFloat: function parseToFloat(value) {
	    return util.Float(value);
	  },
	
	  parseToText: function parseToText(value) {
	    return util.Text.decode(value);
	  },
	
	  parseValue: function parseValue(v, t) {
	    t = this.parseToInt(t);
	    switch (t) {
	      case 11:
	        return this.parseToBool(v);
	      case 19:
	      case 20:
	      case 21:
	        return this.parseToColor(v);
	      case 4:
	      case 5:
	      case 6:
	        return this.parseToFloat(v);
	      case 2:
	      case 3:
	      case 16:
	      case 17:
	      case 18:
	        return this.parseToInt(v);
	      case 256:
	      case 258:
	        return this.parseToText(v);
	      default:
	        return v;
	    }
	  },
	
	  parseName: function parseName(v) {
	    switch (v) {
	      case 'IsShow':
	      case 'Color':
	      case 'BorderColor':
	      case 'BorderVisible':
	      case 'DashMode':
	      case 'Thickness':
	      case 'Radius':
	      case 'Text':
	      case 'TextSize':
	      case 'TextColor':
	      case 'InterlaceColor':
	      case 'IsOpen':
	      case 'FilterType':
	      case 'FilterSketchValue':
	      case 'FilterPencilValue':
	      case 'Progress':
	      case 'BarStyle':
	      case 'RotationAngle':
	      case 'IconColor':
	      case 'IndicatorColor':
	      case 'Size':
	      case 'Status':
	      case 'ShowIcon':
	      case 'MultilineText':
	        return v.charAt(0).toLowerCase() + v.substring(1);
	      case 'FlipVertical':
	      case 'FlipHorizontal':
	      case 'ForegroundColor':
	        return v;
	      case 'GAP':
	        return propConst.GAP;
	      case 'Alpha100':
	        return propConst.OPACITY;
	      case 'VScrollProgress':
	        return 'verticalScrollbarProgress';
	      case 'HScrollProgress':
	        return 'horizontalScrollbarProgress';
	      case 'CheckBoxStatus':
	        return 'state';
	      case 'IsFullScreen':
	        return 'fullScreen';
	      case 'Transparent':
	        return 'isTransparent';
	      case 'PhoneStatus':
	        return 'phoneType';
	    }
	    return v;
	  }
	};
	
	var state = {
	  createNew: function createNew(reactComp) {
	    return {
	      isStateChange: false,
	      currentState: undefined,
	      doTriggerState: function doTriggerState() {
	        var state = this.findState(this.currentState);
	        if (state) {
	          this.isStateChange = true;
	          this.comp.setState({ stateProperties: state });
	        }
	      },
	
	      doFreeState: function doFreeState() {
	        if (this.isStateChange) {
	          this.comp.setState({ stateProperties: undefined });
	        }
	        this.isStateChange = false;
	      },
	
	      down: function down() {
	        this.currentState = STATE_TYPE.MOUSE_DOWN;
	        this.doTriggerState();
	      },
	      up: function up() {
	        this.doFreeState();
	      },
	
	      hover: function hover() {},
	
	      enter: function enter() {
	        this.currentState = STATE_TYPE.MOUSE_OVER;
	        this.doTriggerState();
	      },
	
	      leave: function leave() {
	        this.doFreeState();
	      },
	      comp: reactComp,
	
	      findState: function findState(stateType) {
	        var o;
	        var i;
	        var state = this.comp.props.states;
	        var item;
	        if (!_.isEmpty(state)) {
	          state = state.state;
	          if (!_.isUndefined(state)) {
	            for (i = 0; i < state.length; i++) {
	              item = state[i];
	              if (item.stateType === stateType) {
	                if (item.isChecked) {
	                  if (!o) {
	                    o = {};
	                  }
	                  o[parse.parseName(item.propName)] = parse.parseValue(item.value, item.varType);
	                }
	              }
	            }
	          }
	        }
	        return o;
	      }
	    };
	  }
	};
	
	/**
	 *
	 * @param reactComp
	 */
	module.exports = function (reactComp) {
	  var _state = state.createNew(reactComp);
	  this.state = function () {
	    return _state;
	  };
	};
	
	module.exports.prototype.mouseDown = function (e) {
	  if (e.button === 0) {
	    this.state().down();
	  }
	};
	
	module.exports.prototype.mouseUp = function (e) {
	  this.state().up();
	};
	module.exports.prototype.mouseEnter = function (e) {
	  this.state().enter();
	};
	module.exports.prototype.mouseLeave = function (e) {
	  this.state().leave();
	};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	var LazyLoad = React.createClass({
	  displayName: 'LazyLoad',
	
	  propTypes: {
	    disabled: React.PropTypes.bool,
	    onLoad: React.PropTypes.func,
	    order: React.PropTypes.string
	  },
	  getInitialState: function getInitialState() {
	    return {
	      load: !!this.props.disabled,
	      loading: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var self = this;
	    if (!this.props.load) {
	      window.requestAnimationFrame(function () {
	        self.setState({
	          load: true,
	          loading: true
	        });
	      });
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.timer);
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.state.loading && this.state.load) {
	      this.props.onLoad && this.props.onLoad();
	      this.setState({
	        loading: false
	      });
	    }
	  },
	  render: function render() {
	    var style = {
	      zIndex: this.props.order
	    };
	    return React.createElement(
	      'div',
	      { style: style },
	      this.state.load && this.props.children
	    );
	  }
	});
	
	module.exports = LazyLoad;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var RuntimeOptions = __webpack_require__(153);
	var linkHelper = __webpack_require__(158);
	var appTypes = __webpack_require__(115);
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-3-29
	 @Descript : 组组件
	 */
	var Group = React.createClass({
	  displayName: 'Group',
	
	  actionData: {},
	  render: function render() {
	    if (this.props.interactiveData || this.props.links) {
	      this.actionData = linkHelper.parseComInteractive(this.props)[0];
	    }
	    var haveAction = this.actionData.externalURL || this.actionData.link || this.actionData.entry;
	    var isLink = this.actionData.externalURL || this.actionData.link;
	    var className = 'no-link';
	    var linkStyle = {
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      userSelect: 'none',
	      position: 'absolute',
	      //此处链接区域应该置于上层
	      //注意检查：改动该属性是否有副作用
	      zIndex: 800,
	      pointerEvents: 'none'
	    };
	    if (haveAction) {
	      if (isLink) {
	        className = 'page-link';
	      } else {
	        className = 'interactive-link';
	      }
	    }
	    return React.createElement(
	      'div',
	      {
	        className: 'component component-Group',
	        style: {
	          cursor: haveAction ? 'pointer' : 'default'
	        },
	        onClick: this._onClick,
	        onMouseDown: this._onMouseDown,
	        onMouseUp: this._onMouseUp,
	        onDoubleClick: this._onDblClick,
	        onContextMenu: this._onContentMenu
	      },
	      haveAction && React.createElement('div', { className: className,
	        style: linkStyle
	
	      }),
	      React.createElement(
	        'div',
	        { style: { position: 'absolute', zIndex: 1 } },
	        this.props.children
	      )
	    );
	  },
	
	  _onContentMenu: function _onContentMenu(e) {
	    e.nativeEvent.returnValue = false;
	    return false;
	  },
	
	  _onLinkEvent: function _onLinkEvent(evt, linkKey) {
	    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
	    this.props.events.doSelfClick(evt, this.props, linkKey, 0);
	  },
	
	  _onClick: function _onClick(e) {
	    var key;
	    if (this.longPress) {
	      return;
	    }
	    if (e.button === 0) {
	      if (this.actionData.externalURL) {
	        key = appTypes.ActionResponseType.OUTER;
	      } else if (this.actionData.link) {
	        key = appTypes.ActionResponseType.LINK;
	      } else if (this.actionData.entry) {
	        key = appTypes.ActionResponseType.INTERACTIVE;
	      }
	      if (key) {
	        this._onLinkEvent(e, key);
	      }
	    }
	  },
	
	  _onLongPress: function _onLongPress(evt) {
	    if (this.props.events.doSelfLongPress) this.props.events.doSelfLongPress(evt, this.props, 0);
	  },
	
	  _onRightClick: function _onRightClick(evt) {
	    if (this.props.events.doSelfRightClick) {
	      this.props.events.doSelfRightClick(evt, this.props, 0);
	    }
	  },
	
	  _onDblClick: function _onDblClick(evt) {
	    if (this.props.events.doSelfDbClick) {
	      this.props.events.doSelfDbClick(evt, this.props, 0);
	    }
	  },
	
	  _onMouseDown: function _onMouseDown(e) {
	    if (e.button === 0) {
	      this.mousePress = true;
	      this._startLongPress(e);
	    } else if (e.button === 2) {
	      this._onRightClick(e);
	    }
	  },
	
	  _onMouseUp: function _onMouseUp(e) {
	    this.mousePress = false;
	    this._stopLongPress();
	  },
	  _startLongPress: function _startLongPress(e) {
	    var self = this;
	    self.longPress = false;
	    if (linkHelper.hasLongPressEvents(this.props.interactiveData, 0)) {
	      this.longPressTimeID = setTimeout(function () {
	        if (self.mousePress) {
	          self.longPress = true;
	          self._onLongPress(e);
	        }
	        self._stopLongPress();
	      }, 800);
	    }
	  },
	
	  _stopLongPress: function _stopLongPress() {
	    if (this.longPressTimeID) {
	      clearTimeout(this.longPressTimeID);
	    }
	    delete this.longPressTimeID;
	  }
	});
	
	module.exports = Group;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	var GlobalConst = __webpack_require__(164);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	var propConst = __webpack_require__(147);
	
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-4-1
	 @Descript : 提示框组件
	 */
	var Alert = React.createClass({
	  displayName: 'Alert',
	
	  render: function render() {
	    var tx = this.props.text.split('\n');
	    var title = '';
	    var context = '';
	    var contextArr;
	    var leftText = '';
	    var rightText = '';
	    var lst = '';
	    var btnTexts;
	    if (tx.length > 0) {
	      title = tx[0];
	    }
	    if (tx.length > 1) {
	      lst = tx[tx.length - 1];
	    }
	
	    context = this.props.text.replace(title, '').replace(lst, '').trim();
	    contextArr = util.Text.delimitText(context, util.Text.DM_RETURN);
	    if (lst) {
	      btnTexts = util.Text.delimitText(lst, util.Text.DM_COMMA, false);
	      leftText = btnTexts[0];
	      if (btnTexts.length > 1) {
	        rightText = btnTexts[1];
	      }
	    }
	
	    this.btnCount = 0;
	    if (!_.isEmpty(leftText)) {
	      this.btnCount++;
	    }
	    if (!_.isEmpty(rightText)) {
	      this.btnCount++;
	    }
	
	    return React.createElement(
	      'div',
	      { style: this.CSS() },
	      React.createElement(
	        'div',
	        { ref: 'title', className: 'title', style: this.titleCSS() },
	        React.createElement(
	          'label',
	          null,
	          title
	        )
	      ),
	      React.createElement(
	        'div',
	        { ref: 'content', className: 'content', style: this.contentCSS() },
	        contextArr.map(function (t, idx) {
	          return React.createElement(
	            'p',
	            { key: idx, style: {
	                padding: 0,
	                margin: 0,
	                height: t.trim() === '' ? this.props.textSize * 1.33 : 'auto'
	              } },
	            t
	          );
	        }, this)
	      ),
	      React.createElement(
	        'div',
	        { ref: 'bottom', className: 'bottom', style: {
	            fontSize: parseInt(this.props.textSize, 10),
	            top: styleHelper.getHeight(this.props) - 35
	          } },
	        leftText && React.createElement(
	          'div',
	          { className: 'button', style: this.btnCSS(0) },
	          React.createElement(
	            'label',
	            null,
	            leftText
	          )
	        ),
	        rightText && React.createElement(
	          'div',
	          { className: 'button', style: this.btnCSS(1) },
	          React.createElement(
	            'label',
	            null,
	            rightText
	          )
	        )
	      )
	    );
	  },
	
	  btnCSS: function btnCSS(index) {
	    var btnPadding = 5;
	    var w = styleHelper.getWidth(this.props);
	    var btnWidth = this.btnCount == 2 ? w / 2 - (btnPadding + 1) * 2 : w - btnPadding * 2;
	    var selMode = this.props.selection;
	    var borderColor = GlobalConst.GLOBAL_COLOR.LIGHT_GRAY_COLOR;
	
	    switch (selMode) {
	      case appTypes.AlertYesAndNo.NO:
	        if (index === 0) {
	          borderColor = GlobalConst.GLOBAL_COLOR.DEFAULT_BORDER_COLOR;
	        }
	        break;
	      case appTypes.AlertYesAndNo.YES:
	        if (index === 1) {
	          borderColor = GlobalConst.GLOBAL_COLOR.DEFAULT_BORDER_COLOR;
	        }
	    }
	    return {
	      borderColor: borderColor,
	      width: btnWidth,
	      overflow: 'hidden',
	      left: (index === 0 ? btnPadding : w - btnPadding - btnWidth) - 1
	    };
	  },
	  contentCSS: function contentCSS() {
	    var fs = parseInt(this.props.textSize, 10);
	    var textStyle = {
	      fontSize: fs,
	      textAlign: this.props.textAlign.toLowerCase().replace('ha', '')
	    };
	    // 原来的老版本数据，有些没有 lineHeight，导致取出来为0，这时不能去设置为 0
	    var lineHeight = styleHelper.builderLineHeight(this.props);
	    if (lineHeight) {
	      textStyle.lineHeight = lineHeight + 'px';
	    } else {
	      textStyle.lineHeight = '1em';
	    }
	    return textStyle;
	  },
	  titleCSS: function titleCSS() {
	    return {
	      fontSize: parseInt(this.props.textSize, 10) + 4,
	      width: styleHelper.getWidth(this.props) - 10
	    };
	  },
	
	  CSS: function CSS() {
	    return styleHelper.StyleUtil(this.props).size().text().style;
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doAdjusContentLayout();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doAdjusContentLayout();
	  },
	
	  doAdjusContentLayout: function doAdjusContentLayout() {
	    var h = styleHelper.getHeight(this.props);
	    var title = ReactDOM.findDOMNode(this.refs.title);
	    var titleText = $(title).children('label');
	    var lbl = titleText[0];
	    var bottom = ReactDOM.findDOMNode(this.refs.bottom);
	    var content = ReactDOM.findDOMNode(this.refs.content);
	    var ph;
	    var child = content.children;
	    var i;
	    var th = title.clientHeight;
	    var tw = lbl.clientWidth || lbl.offsetWidth;
	    var bh = bottom.clientHeight;
	    var ch = h - th - bh - 10;
	    var padding = 0;
	    var valign = styleHelper.getPropertyValue(this.props, propConst.TEXT_V_ALIGN);
	    var p;
	    ph = 0;
	    for (i = 0; i < child.length; i++) {
	      p = child[i];
	      ph += p.clientHeight;
	    }
	    if (valign === appTypes.VertAlign.MIDDLE) {
	      padding = (ch - ph) / 2 - 8;
	    } else if (valign === appTypes.VertAlign.BOTTOM) {
	      padding = ch - ph - 8;
	    } else {
	      padding = 0;
	    }
	    $(content).css({ paddingTop: padding, height: ch - 10, overflow: 'hidden' });
	    if (tw > title.clientWidth) titleText.css({ left: (title.clientWidth - (lbl.clientWidth || lbl.offsetWidth)) / 2, position: 'relative' });
	  }
	});
	
	module.exports = Alert;

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  GLOBAL_COLOR: {
	    DEFAULT_TEXT_COLOR: '#000',
	    DARK_GRAY_COLOR: '#666',
	    LIGHT_GRAY_COLOR: '#DDD',
	    DEFAULT_BORDER_COLOR: '#808080',
	    DEFAULT_BACKGROUND_COLOR: '#FFF',
	    DEFAULT_SELECTION_COLOR: '#41C7D6',
	    TRANSPARENT_COLOR: 'rgba(0,0,0,0)',
	    SYSTEM_BLANK: '#000',
	    SYSTEM_WHITE: '#FFF',
	    SYSTEM_GRAY: '#999'
	  }
	};
	
	/*
	 COLOR_SYS_TEXT = $FF1A1A1A;

	 // 系统文字浅色
	 COLOR_SYS_TEXT_LIGHT = $FF8C8C8C;

	 // 系统选择区颜色
	 COLOR_SYS_SELECT = $FF41C7D6;

	 COLOR_SYS_SELECT_LIGHTER = $FFBEEDF3;

	 // 系统选择区颜色（浅，个别情况下，为突出文字颜色而使用）
	 COLOR_SYS_SELECT_LIGHT = $FF5CD0E0;

	 // 系统选择区颜色深
	 COLOR_SYS_SELECT_DARK = $FF1E828C;

	 // 系统组件的边框颜色
	 COLOR_SYS_CONTROL_BORDER = $FF999999;
	 COLOR_SYS_CONTROL_FACE = $FFF0F0F0;

	 // 系统边框颜色
	 COLOR_SYS_FRAME = $FFB9B9B9; // $FF999999;

	 // 系统边框颜色浅
	 COLOR_SYS_FRAME_LIGHT = $FFE0E0E0;

	 // 系统边框颜色深
	 COLOR_SYS_FRAME_DARK = $FF393939;//和默认menu边框颜色保持一致

	 // 系统边框颜色深
	 COLOR_SYS_FRAME_DARKER = $FF191919;

	 // 系统内容区颜色，如listbox等
	 COLOR_SYS_CONTENT = $FFFAFAFA;

	 // 系统面板颜色（面板如主菜单bar、主工具栏、浮动工具面板等）
	 COLOR_SYS_FACE = $FFE5E5E5;

	 // 系统面板颜色（更浅）
	 COLOR_SYS_FACE_LIGHTER = $FFF9F9F9;

	 // 系统面板颜色（浅）
	 COLOR_SYS_FACE_LIGHT = $FFF3F3F3;

	 // 系统面板颜色深（小工具栏）
	 COLOR_SYS_FACE_DARK = $FFC7C7C7;

	 // 系统面板颜色更深（工作区背景等）
	 COLOR_SYS_FACE_DARKER = $FF949494;

	 // COLOR_SYS_FACE_DARKEST = $FF666666;
	 // COLOR_SYS_FACE_DARKEST = $FF666662;
	 COLOR_SYS_FACE_DARKEST = $FF505050;

	 //
	 COLOR_SYS_FACE_PREVIEW = $FF0D6CB4;

	 // 系统内容工作区颜色（如左右侧列表颜色、原型图工作区默认底色）
	 COLOR_SYS_WORKER_CONTENT = $FFFFFFFF;

	 // 树节点拖动时，拖动标记颜色值。
	 COLOR_SYS_RED = $FFD73300;
	 COLOR_SYS_RED_LIGHT = $FFEB6840;
	 COLOR_LINK_RED = $FFFF461F;

	 COLOR_SYS_BLUE = $FF2E83E9;

	 COLOR_SYS_YELLOW = $FFFACF4E; // $FFFFDC51;
	 COLOR_SYS_YELLOW_DARK = $FF725603;
	 COLOR_SYS_YELLOW_DARKER = $FF403102;

	 COLOR_SYS_LINK = $FFFF461F;
	 COLOR_SYS_LINK_LIGHT = $A0FF461F;
	 */

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var Alert = __webpack_require__(163);
	var _ = __webpack_require__(51);
	var PopupHelper = __webpack_require__(156);
	var util = __webpack_require__(116);
	
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-6-1
	 @Descript : 弹出窗口组件
	 */
	var AlertWindow = React.createClass({
	  displayName: 'AlertWindow',
	
	
	  render: function render() {
	    var bgComp = this.props.items[0];
	    var contentComp = this.props.items[1];
	    var bg = util.Color.setOpacity(bgComp.color, 0.4);
	    var dom = React.createElement(
	      'div',
	      {
	        key: this.props.controlID,
	        id: this.props.controlID,
	        className: 'component component-AlertWindow popup-control',
	        style: {
	          visibility: this.props.popup ? 'visible' : 'hidden',
	          zIndex: this.props.zOrder
	        } },
	      React.createElement('div', { id: this.props.controlID + '-background',
	        ref: 'background',
	        className: 'background',
	        style: {
	          width: this.props.measureWidth || 0,
	          height: this.props.measureHeight || 0,
	          backgroundColor: this.props.isShowBackground ? bg : 0,
	          pointerEvents: this.props.closeByClickMode === appTypes.PopupPanelClosePolicy.NONE ? 'auto' : 'none'
	        } }),
	      React.createElement(
	        'div',
	        { id: this.props.controlID + '-content',
	          className: 'content',
	          ref: 'content',
	          style: {
	            left: contentComp.x,
	            top: contentComp.y,
	            width: contentComp.w + 2,
	            height: contentComp.h + 2,
	            opacity: this.props.popup ? 1 : 0
	          } },
	        this.props.children
	      )
	    );
	    return dom;
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doInitContent();
	    this.doPopup();
	    if (this.props.onOpened) {
	      this.props.onOpened(this.props);
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doInitContent();
	    this.doPopup();
	  },
	  doInitContent: function doInitContent() {
	    var alertDom = ReactDOM.findDOMNode(this.refs.content).children[0];
	    $(alertDom).css({ left: 0, top: 0, opacity: 1 });
	  },
	  doPopup: function doPopup() {
	    PopupHelper.registerPopup(this);
	    if (this.open) {
	      this.open();
	    }
	
	    var dom = $(ReactDOM.findDOMNode(this));
	    var content = $(ReactDOM.findDOMNode(this.refs.content));
	    var background = $(ReactDOM.findDOMNode(this.refs.background));
	    if (this.props.isPopupClosing && this.props.closePopup) {
	      this.props.closePopup(dom, this.props, content, background);
	    }
	  }
	
	});
	
	module.exports = AlertWindow;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Dom = __webpack_require__(12);
	var AutoSizeHelper = __webpack_require__(167);
	var Border = __webpack_require__(168);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	var propConst = __webpack_require__(147);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	
	var Button = React.createClass({
	  displayName: 'Button',
	
	
	  //矫正边界
	  adjustBounds: function adjustBounds() {
	    var com;
	    var parentDom;
	    var size;
	    var txDom;
	    txDom = Dom.findDOMNode(this.refs.wrapText);
	    if (this.props.isAutoSize) {
	      com = Dom.findDOMNode(this);
	      parentDom = com.parentElement;
	
	      while (!parentDom && parentDom.id !== this.props.controlID) {
	        parentDom = parentDom.parentElement;
	      }
	
	      if (parentDom) {
	        size = AutoSizeHelper.getComAutoSize(this.props);
	        $(parentDom).css({ width: size.width + 12, height: size.height + 7 });
	      }
	    }
	
	    if (txDom) {
	      this.doAdjus(txDom);
	    } else {
	      this.doSetLineHeight();
	    }
	  },
	
	  doAdjus: function doAdjus(dom) {
	    var selfDom = Dom.findDOMNode(this);
	    var h = selfDom.clientHeight; // styleHelper.getHeight(this.props);
	    var w = selfDom.clientWidth; // styleHelper.getWidth(this.props);
	    var hAlign = styleHelper.getPropertyValue(this.props, propConst.TEXT_ALIGN);
	    var vAlign = styleHelper.getPropertyValue(this.props, propConst.TEXT_V_ALIGN);
	    var tw = dom.clientWidth;
	    var th = dom.clientHeight - styleHelper.getFontSize(this.props) * 0.2;
	    var tl;
	    var tt;
	    var margin = 2;
	
	    switch (hAlign) {
	      case appTypes.HoriAlign.LEFT:
	        tl = margin;
	        break;
	      case appTypes.HoriAlign.CENTER:
	        tl = (w - tw) / 2;
	        break;
	      case appTypes.HoriAlign.RIGHT:
	        tl = w - tw - margin;
	        break;
	    }
	    switch (vAlign) {
	      case appTypes.VertAlign.TOP:
	        tt = margin;
	        break;
	      case appTypes.VertAlign.MIDDLE:
	        tt = (h - th) / 2 - 2;
	        break;
	      case appTypes.VertAlign.BOTTOM:
	        tt = h - th - margin;
	        break;
	    }
	    $(dom).css({ left: 1, top: tt });
	    this.doSetLineHeight();
	  },
	
	  doSetLineHeight: function doSetLineHeight() {
	    var textSize = styleHelper.getFontSize(this.props);
	    var dom = Dom.findDOMNode(this);
	    var h = dom.clientHeight;
	    var lineHeight = styleHelper.builderLineHeight(this.props);
	    if (!this.isMultiText) {
	      if (this.props.textVAlign === 'VaTop') {
	        lineHeight = textSize * 1 + 8;
	      } else if (this.props.textVAlign === 'VaBottom') {
	        lineHeight = h * 2 - textSize - 8;
	      } else {
	        lineHeight = h;
	      }
	    }
	    // 原来的老版本数据，有些没有 lineHeight，导致取出来为0，这时不能去设置为 0
	    if (lineHeight) {
	      $(dom).css({ lineHeight: lineHeight + 'px' });
	    } else {
	      $(dom).css({
	        lineHeight: '1em'
	      });
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.adjustBounds();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.adjustBounds();
	    $(Dom.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize);
	  },
	
	  onResize: function onResize(e) {
	    this.adjustBounds();
	  },
	
	  isMultiText: false,
	
	  render: function render() {
	    var style;
	    var wrap = this.props.textWordWrap;
	    var text = styleHelper.getText(this.props);
	    var isMultiline = this.props.textWordWrap || util.Text.isMultiLineText(text);
	    var state = styleHelper.getPropertyValue(this.props, propConst.BUTTON_STATUS);
	    style = styleHelper.StyleUtil(this.props).background().border().text().align().base().lineHeight(wrap).wrap(wrap).style;
	    style.overflow = 'hidden';
	    if (isMultiline) {
	      this.isMultiText = true;
	      style.whiteSpace = 'pre-wrap';
	    } else {
	      this.isMultiText = false;
	    }
	    if (state === appTypes.ButtonStatus.SELECTED) {
	      style.backgroundColor = '#41c7d6';
	    }
	
	    if (this.props.isAutoTextColor) {
	      if (util.Color.isLight(style.backgroundColor)) {
	        style.color = '#000';
	      } else {
	        style.color = '#fff';
	      }
	    }
	    var textStyle = {};
	    styleHelper.builderTextStyle(this.props, textStyle);
	    if (isMultiline) {
	      textStyle = _.extend(textStyle, {
	        padding: 0,
	        margin: 0,
	        wordBreak: 'break-word'
	      });
	    }
	    return React.createElement(
	      'diy',
	      { style: style, key: '_', className: 'component component-button' },
	      isMultiline ? React.createElement(
	        'div',
	        { ref: 'wrapText',
	          style: { left: 1, right: 1, top: 0, height: 'auto', position: 'absolute', lineHeight: style.lineHeight } },
	        React.createElement(
	          'p',
	          { style: textStyle },
	          text
	        )
	      ) : React.createElement(
	        'label',
	        { style: textStyle },
	        text
	      )
	    );
	  }
	});
	
	module.exports = Button;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var measureHelper = __webpack_require__(148);
	var styleHelper = __webpack_require__(145);
	
	exports.getComAutoSize = function (props, text) {
	  var measureText = text ? text : styleHelper.getText(props);
	  var textArray = measureText.split('\n');
	  var isMultiLineText = textArray.length > 1;
	  var maxLengthText;
	  var i;
	
	  var measureStyle = {
	    fontSize: styleHelper.getFontSize(props) || 14,
	    fontStyle: props.textStyles ? props.textStyles.fontStyle : 'normal',
	    textDecoration: props.textStyles ? props.textStyles.textDecoration : 'normal',
	    fontWeight: props.textStyles ? props.textStyles.fontWeight : 'normal',
	    fontFamily: props.textFontFamily || ''
	  };
	
	  if (isMultiLineText) {
	    maxLengthText = measureText;
	  } else {
	    maxLengthText = textArray[0];
	    for (i = 1; i < textArray.length; i++) {
	      if (textArray[i].length > maxLengthText.length) {
	        this.maxLengthText = textArray[i];
	      }
	    }
	  }
	
	  return measureHelper.measureTextWidth(measureStyle, maxLengthText);
	};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var tool = __webpack_require__(121);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 只用于组件边框和背景的呈现，不能用于其他地方
	 */
	
	var Border2 = React.createClass({
	  displayName: 'Border2',
	
	
	  protoTypes: {
	    className: React.PropTypes.string,
	    partStyle: React.PropTypes.object
	  },
	
	  initStyle: function initStyle() {
	
	    var borderStyle = {
	      padding: 0,
	      overflow: 'hidden',
	      position: 'relative',
	      boxSizing: 'border-box',
	
	      left: 0,
	      top: 0,
	      width: '100%',
	      height: '100%',
	      backgroundColor: styleHelper.getBackgroundColor(this.props),
	      borderColor: styleHelper.getBorderColor(this.props),
	      borderWidth: this.props.borderWidth || 1,
	      borderStyle: this.props.borderVisible ? 'solid' : 'none',
	      borderRadius: this.props.radius || 0
	    };
	
	    return tool.extendObj(borderStyle, this.props.partStyle);
	  },
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { style: this.initStyle(),
	        key: this.props.k,
	        className: this.props.className || 'Border',
	        onClick: this.props.onClick },
	      this.props.children
	    );
	  }
	});
	
	module.exports = Border2;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	var CheckBoxItem = __webpack_require__(170);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	
	/*
	 * 复选框组件
	 */
	var Checkbox = React.createClass({
	  displayName: 'Checkbox',
	
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('checkedChange', this._onClick);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var newDisabled = appTypes.ComStatus.isDisabled(newProps.state);
	    if (newDisabled !== this.state.disabled) {
	      this.setState({ disabled: newDisabled });
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      checked: appTypes.ComStatus.isSelected(this.props.state),
	      disabled: appTypes.ComStatus.isDisabled(this.props.state)
	    };
	  },
	
	  render: function render() {
	    var state = styleHelper.getPropertyValue(this.props, propConst.STATE);
	    var props = _.extend({}, this.props);
	    props.isChecked = this.state.checked;
	    props.isDisabled = this.state.disabled;
	    props.onChecked = this._onChecked;
	    props.text = styleHelper.getText(this.props);
	    if (props.stateProperties) {
	      props.isChecked = appTypes.ComStatus.isSelected(state);
	      props.isDisabled = appTypes.ComStatus.isDisabled(state);
	    }
	
	    return React.createElement(CheckBoxItem, props);
	  },
	
	  _onClick: function _onClick(e) {
	    var arg = arguments;
	    var linkKey;
	    var evt;
	    var data;
	    //e.stopPropagation();
	    if (arg.length > 1) {
	      data = arg[1];
	      linkKey = data.key;
	      evt = data.nativeEvent;
	    }
	    if (!this.state.disabled) {
	      this.props.events.doSelfChecked(evt, this.props, !this.state.checked, linkKey);
	      this._onChecked(0, !this.state.checked);
	    }
	  },
	
	  _onChecked: function _onChecked(index, isChecked) {
	    if (!this.state.disabled) {
	      this.setState({
	        checked: isChecked
	      });
	    }
	  }
	
	});
	
	module.exports = Checkbox;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var _ = __webpack_require__(51);
	var ReactDOM = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var AutoSizeHelper = __webpack_require__(167);
	var appTypes = __webpack_require__(115);
	var CheckIcon = __webpack_require__(171);
	var propsConst = __webpack_require__(147);
	
	/**
	 * CheckBoxItem
	 * @author mxj
	 * @createDate 2016-8-3
	 **/
	
	var CheckBoxItem = React.createClass({
	  displayName: 'CheckBoxItem',
	  _doPaint: function _doPaint() {
	    var selfDom = ReactDOM.findDOMNode(this);
	    var parentDom;
	    var measureSize;
	
	    parentDom = selfDom.parentElement;
	    while (!parentDom && parentDom.id !== this.props.controlID) {
	      parentDom = parentDom.parentElement;
	    }
	
	    if (parentDom) {
	      measureSize = AutoSizeHelper.getComAutoSize(this.props);
	      parentDom.style.width = measureSize.width + 20 + 'px';
	    }
	  },
	
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.text !== this.props.text) {
	      this.isInvalid = true;
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._doPaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.canFocus = false;
	    this._doPaint();
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      checked: this.props.isChecked
	    };
	  },
	
	  render: function render() {
	    this.isLeftText = this.props.textDirection === appTypes.TextDirection.LEFT;
	    var divStyle;
	    var textStyle;
	
	    var size = styleHelper.getInt(this.props, propsConst.SIZE) || 16;
	    var gap = styleHelper.getInt(this.props, propsConst.GAP) || 0;
	    divStyle = {
	      width: '100%',
	      height: '100%',
	      opacity: this.props.isDisabled ? 0.6 : 1,
	      //overflow:'hidden',
	      pointerEvents: this.props.isDisabled ? 'none' : 'auto'
	    };
	
	    textStyle = {
	      left: this.props.textDirection === appTypes.TextDirection.LEFT ? 0 : size + gap,
	      top: 0,
	      height: styleHelper.getHeight(this.props),
	      width: styleHelper.getWidth(this.props) - size - gap,
	      lineHeight: styleHelper.getHeight(this.props) + 'px',
	      position: 'absolute',
	      textDecoration: 'inherit',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    };
	    styleHelper.StyleUtil(this.props).default(divStyle).text().align();
	    return React.createElement(
	      'div',
	      { style: divStyle, onClick: this._onClick },
	      React.createElement(CheckIcon, {
	        enabled: _.isUndefined(this.props.enabled) ? true : this.props.enabled,
	        size: size,
	        color: this.props.borderColor,
	        left: this.props.textDirection === appTypes.TextDirection.RIGHT ? 0 : styleHelper.getWidth(this.props) - size,
	        top: (styleHelper.getHeight(this.props) - size) / 2,
	        isChecked: this.canFocus ? this.state.checked : this.props.isChecked,
	        borderColor: styleHelper.getBorderColor(this.props)
	      }),
	      React.createElement(
	        'div',
	        { style: textStyle },
	        React.createElement(
	          'label',
	          null,
	          styleHelper.getText(this.props)
	        )
	      )
	    );
	  },
	
	  _onClick: function _onClick(e) {
	    var arg = arguments;
	    var index = 0;
	    e.stopPropagation();
	    this.canFocus = true;
	    this.setState({
	      checked: !this.state.checked
	    });
	
	    if (this.props.onChecked) {
	      if (!_.isUndefined(this.props.index)) {
	        index = this.props.index;
	      }
	      this.props.onChecked(index, this.state.checked);
	    }
	  }
	});
	
	module.exports = CheckBoxItem;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var versionHelper = __webpack_require__(124);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	
	var CheckIcon = React.createClass({
	  displayName: 'CheckIcon',
	
	  propTypes: {
	    isChecked: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.string]),
	    size: React.PropTypes.number,
	    color: React.PropTypes.string,
	    left: React.PropTypes.number,
	    top: React.PropTypes.number,
	    enabled: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.string])
	  },
	
	  render: function render() {
	    var enabled = true;
	    if (this.props.enabled !== undefined) {
	      enabled = this.props.enabled === true || this.props.enabled === 'true';
	    }
	    var style = {
	      width: this.props.size || this.getDefaultSize(),
	      height: this.props.size || this.getDefaultSize(),
	      left: this.props.left || 0,
	      top: this.props.top || 0,
	      position: this.props.position || 'absolute',
	      cursor: 'pointer',
	      pointerEvents: enabled ? 'auto' : 'none'
	    };
	    return React.createElement('canvas', { style: style, width: this.props.size || this.getDefaultSize(), height: this.props.size || this.getDefaultSize(), onClick: this.props.onClick });
	  },
	
	  getDefaultSize: function getDefaultSize() {
	    return versionHelper.isMobileApp() ? 15 : 13;
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.repaint();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.repaint();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  repaint: function repaint() {
	    var canvas = ReactDOM.findDOMNode(this);
	
	    var graphics = canvas.getContext('2d');
	    var self = this;
	    var left;
	    var top;
	    var size = this.props.size || this.getDefaultSize();
	    var isChecked = this.props.isChecked === 'true' || this.props.isChecked === true;
	    var ratio = graphicsHelper.applyDeviceRatio(graphics, size, size);
	
	    this.requestID = window.requestAnimationFrame(function () {
	      graphics.clearRect(0, 0, size * ratio, size * ratio);
	      graphics.fillStyle = '#ffffff';
	      //graphics.strokeStyle = self.props.color || '#000';
	      graphics.strokeStyle = styleHelper.getBorderColor(self.props) || '#000';
	
	      graphics.lineWidth = ratio;
	      graphics.beginPath();
	      graphics.rect(0, 0, size * ratio, size * ratio);
	      graphics.closePath();
	      graphics.fill();
	      graphics.stroke();
	      if (isChecked) {
	        if (size > 20) {
	          graphics.lineWidth = 2 * ratio;
	        }
	        size *= ratio;
	        left = size * 0.1;
	        top = size * 0.55;
	        graphics.moveTo(left, top);
	        left = size * 0.4;
	        top = size * 0.8;
	        graphics.lineTo(left, top);
	        left = size * 0.9;
	        top = size * 0.2;
	        graphics.lineTo(left, top);
	        graphics.stroke();
	      }
	    });
	  }
	});
	
	module.exports = CheckIcon;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by lovely on 2016/6/7.
	 */
	'use strict';
	
	var _ = __webpack_require__(51);
	var appTypes = __webpack_require__(115);
	var colorHelper = __webpack_require__(114);
	var util = __webpack_require__(116);
	
	var MAX_IMGSIZE = 8192;
	
	var colorTemplete = ["FFED5555", "FFFC8D52", "FFFFCE55", "FFA0D468", "FF48CFAE", "FF5D9CEC", "FFAC92ED", "FFEC87BF", "FFFFFFFF", "FFE6E6E6", "FFC0C0C0", "FFA0A0A0"];
	
	/**
	 * 绘制圆角矩形
	 * @param ctx
	 * @param x
	 * @param y
	 * @param width
	 * @param height
	 * @param radius
	 * @param fill
	 * @param stroke
	 */
	function roundRect(ctx, x, y, width, height, radius, fill, stroke, borderVisible) {
	  if (typeof stroke == 'undefined') {
	    stroke = true;
	  }
	  if (typeof radius === 'undefined') {
	    radius = 5;
	  }
	  if (typeof radius === 'number') {
	    radius = { tl: radius, tr: radius, br: radius, bl: radius };
	  } else {
	    var defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
	    for (var side in defaultRadius) {
	      radius[side] = radius[side] || defaultRadius[side];
	    }
	  }
	  ctx.beginPath();
	
	  if (!borderVisible.top) {
	    radius.tl = 0;
	    radius.tr = 0;
	  }
	  if (!borderVisible.right) {
	    radius.tr = 0;
	    radius.br = 0;
	  }
	
	  if (!borderVisible.bottom) {
	    radius.br = 0;
	    radius.bl = 0;
	  }
	
	  if (!borderVisible.left) {
	    radius.bl = 0;
	    radius.tl = 0;
	  }
	
	  if (stroke) {
	    // top
	    if (borderVisible.top) {
	      ctx.moveTo(x + radius.tl, y);
	      ctx.lineTo(x + width - radius.tr, y);
	      ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
	    }
	
	    // right
	    if (borderVisible.right) {
	      ctx.moveTo(x + width, y + radius.tr);
	      ctx.lineTo(x + width, y + height - radius.br);
	      ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
	    }
	
	    // bottom
	    if (borderVisible.bottom) {
	      ctx.moveTo(x + width - radius.br, y + height);
	      ctx.lineTo(x + radius.bl, y + height);
	      ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
	    }
	
	    // left
	    if (borderVisible.left) {
	      ctx.moveTo(x, y + height - radius.bl);
	      ctx.lineTo(x, y + radius.tl);
	      ctx.quadraticCurveTo(x, y, x + radius.tl, y);
	    }
	    ctx.stroke();
	  }
	
	  if (fill) {
	    ctx.beginPath();
	    ctx.moveTo(x + radius.tl, y);
	    ctx.lineTo(x + width - radius.tr, y);
	    ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
	    ctx.lineTo(x + width, y + height - radius.br);
	    ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
	    ctx.lineTo(x + radius.bl, y + height);
	    ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
	    ctx.lineTo(x, y + radius.tl);
	    ctx.quadraticCurveTo(x, y, x + radius.tl, y);
	    ctx.closePath();
	    ctx.fill();
	  }
	}
	
	module.exports = {
	  getImageSize: function getImageSize(img, cb) {
	    var newImg = document.createElement('img');
	    newImg.src = img.src;
	    newImg.style.position = 'absolute';
	    newImg.style.left = '-9999px';
	    newImg.style.top = '-9999px';
	    document.body.appendChild(newImg);
	    newImg.onload = function () {
	      cb(null, {
	        width: this.width || img.naturalWidth || newImg.width,
	        height: this.height || img.naturalHeight || newImg.height
	      }, newImg);
	      document.body.removeChild(newImg);
	    };
	  },
	
	  setDash: function setDash(ctx, dashArr) {
	    if (!dashArr) {
	      dashArr = [];
	    }
	    if (ctx.setLineDash) {
	      ctx.setLineDash(dashArr);
	      ctx.lineDashOffset = 0;
	    } else if (ctx.mozDash) {
	      ctx.mozDash = dashArr;
	      ctx.mozDashOffset = 5;
	    }
	  },
	
	  initContextStyle: function initContextStyle(ctx, thickness, strokeColor, fillColor, lineMode) {
	    var dashArr;
	    var s;
	    var langDadh;
	    var dotDash;
	    var ratio = this.getDeviceRatio(ctx);
	    thickness = thickness || 1;
	    s = Math.max(1, thickness / 2) * ratio;
	    langDadh = 5 * s;
	    dotDash = 1;
	    if (thickness > 1) {
	      dotDash = 0.1;
	    }
	    if (lineMode === 'dashed') {
	      dashArr = [langDadh, langDadh];
	    } else if (lineMode === 'dotted') {
	      dashArr = [dotDash, langDadh];
	    } else if (lineMode === 'dash-dot') {
	      dashArr = [langDadh, langDadh, dotDash, langDadh];
	    } else if (lineMode === 'dash-dot-dot') {
	      dashArr = [langDadh, langDadh, dotDash, langDadh, dotDash, langDadh];
	    }
	    this.setDash(ctx, dashArr);
	    ctx.lineWidth = thickness * ratio;
	    ctx.strokeStyle = strokeColor;
	    ctx.lineCap = 'square';
	    ctx.lineJoin = 'round';
	    if (fillColor) {
	      ctx.fillStyle = fillColor;
	    }
	  },
	
	  drawPath: function drawPath(ctx, pathData, params, ratio) {
	    if (_.isUndefined(ratio)) ratio = 1;
	    var thickness = params.thickness || 1;
	    var dashMode = params.dashMode || 'solid';
	    var borderColor = params.borderColor || '#000';
	    var i = 0;
	    var data = pathData.data();
	    var l = data.length;
	    var p;
	    var offset = 0.5 * ratio;
	    this.initContextStyle(ctx, thickness, borderColor, undefined, dashMode);
	
	    //ctx.clearRect(0, 0, w, h);
	    this.clearRect(ctx);
	    ctx.beginPath();
	    for (i; i < l; i++) {
	      p = data[i];
	      if (p.t === 'M') {
	        ctx.moveTo(p.x * ratio + offset, p.y * ratio - offset);
	        if (i === l - 1 || data[i + 1].t === 'M') {
	          ctx.lineTo(p.x * ratio + offset, p.y * ratio - offset);
	        }
	      } else {
	        ctx.lineTo(p.x * ratio + offset, p.y * ratio - offset);
	      }
	    }
	    ctx.stroke();
	  },
	
	  drawCurveLine: function drawCurveLine(ctx, x1, y1, x2, y2, cx, cy) {
	    ctx.beginPath();
	    ctx.moveTo(x1, y1);
	    if (_.isUndefined(cx) || _.isUndefined(cy)) {
	      ctx.lineTo(x2, y2);
	    } else {
	      ctx.quadraticCurveTo(cx, cy, x2, y2);
	    }
	    ctx.stroke();
	  },
	
	  drawRoundRect: function drawRoundRect(ctx, rect, cpx, cpy, params) {
	    var strokeStyle = params.strokeStyle;
	    var fillStyle = params.color || '#000000';
	    var l;
	    var t;
	    l = rect.left;
	    l += cpx;
	    t = rect.top;
	    ctx.beginPath();
	    ctx.moveTo(l, t);
	    l = rect.right - cpx;
	
	    ctx.strokeStyle = strokeStyle;
	    ctx.fillStyle = fillStyle;
	    ctx.lineWidth = params.thickness || 1;
	    ctx.lineTo(l, t);
	    ctx.quadraticCurveTo(rect.right, rect.top, rect.right, rect.top + cpy);
	    ctx.lineTo(rect.right, rect.bottom - cpy);
	    ctx.quadraticCurveTo(rect.right, rect.bottom, rect.right - cpx, rect.bottom);
	    ctx.lineTo(rect.left + cpx, rect.bottom);
	    ctx.quadraticCurveTo(rect.left, rect.bottom, rect.left, rect.bottom - cpx);
	    ctx.lineTo(rect.left, rect.top + cpy);
	    ctx.quadraticCurveTo(rect.left, rect.top, cpx, rect.top);
	    ctx.closePath();
	    ctx.fill();
	    ctx.stroke();
	  },
	
	  drawRect: function drawRect(ctx, x, y, w, h, params, isFill) {
	    ctx.save();
	    var thickness = params.thickness || 1;
	    var dashMode = params.dashMode || 'solid';
	    var borderColor = params.borderColor || '#000';
	    var fillColor = params.color || 'transparent';
	    var offset = thickness / 2;
	    var ratio = this.applyDeviceRatio(ctx, w, h);
	    this.clearRect(ctx);
	
	    offset *= ratio;
	    this.initContextStyle(ctx, thickness, borderColor, fillColor, dashMode);
	
	    w *= ratio;
	    h *= ratio;
	    x *= ratio;
	    y *= ratio;
	    //ctx.clearRect(x, y, w, h);
	    if (isFill) {
	      ctx.rect(x, y, w, h);
	      ctx.fill();
	    }
	    if (params.borderVisible) {
	      ctx.moveTo(x + offset, y + offset);
	      ctx.lineTo(w - offset, y + offset);
	      // ctx.stroke();
	      ctx.moveTo(w - offset, y + offset);
	      ctx.lineTo(w - offset, h - offset);
	      // ctx.stroke();
	      ctx.moveTo(x + offset, h - offset);
	      ctx.lineTo(w - offset, h - offset);
	      // ctx.stroke();
	      ctx.moveTo(x + offset, y + offset);
	      ctx.lineTo(x + offset, h - offset);
	      ctx.stroke();
	    }
	    ctx.restore();
	  },
	
	  /**
	   * 画椭圆形状
	   * }}
	   */
	  drawEllipse: function drawEllipse(context, w, h, color) {
	    var EllipseProps = this.figureEllipse(w, h);
	    this.clearRect(context);
	    context.strokeStyle = color;
	    context.save();
	    context.scale(EllipseProps["ratioX"], EllipseProps["ratioY"]);
	    context.beginPath();
	    context.arc(EllipseProps["r"], EllipseProps["r"], EllipseProps["r"] - 0.5, 0, 2 * Math.PI);
	    context.stroke();
	    context.restore();
	  },
	
	  /**
	   * 根据角度画椭圆色块
	   * }}
	   */
	  drawEllipseByAngle: function drawEllipseByAngle(context, w, h, startAngle, endAngle, color) {
	
	    var EllipseProps = this.figureEllipse(w, h);
	
	    context.fillStyle = color;
	    context.save();
	    context.scale(EllipseProps["ratioX"], EllipseProps["ratioY"]);
	    context.beginPath();
	    context.moveTo(EllipseProps["a"] / EllipseProps["ratioX"], EllipseProps["b"] / EllipseProps["ratioY"]);
	    context.arc(EllipseProps["r"], EllipseProps["r"], EllipseProps["r"] - 1, startAngle, endAngle, false);
	    context.closePath();
	    context.restore();
	    context.fill();
	  },
	
	  figureEllipse: function figureEllipse(w, h) {
	    var a = w / 2;
	    var b = h / 2;
	    var r = a > b ? a : b;
	    var ratioX = a / r;
	    var ratioY = b / r;
	
	    return { "a": a, "b": b, "r": r, "ratioX": ratioX, "ratioY": ratioY };
	  },
	
	  //对svg的path进行缩放，以适配动态图标尺寸
	  tranSVGStr: function tranSVGStr(str, size, max) {
	    var ratio = size / max;
	    return str.replace(/[0-9]+/g, function (match) {
	      var num = parseInt(parseInt(match, 10) * ratio, 10);
	      if (num > size / 2) {
	        num = num - 0.5;
	      } else {
	        num = num + 0.5;
	      }
	      return num;
	    });
	  },
	
	  /**
	   * svg绘制加减号折叠图标
	   * @param size : 图标尺寸
	   * @param isClose : 是否收拢状态
	   * @param color : 图标颜色
	   */
	  renderIconPlus: function renderIconPlus(size, isClose, color) {
	    var path;
	    var box = "0 0 " + size.toString() + " " + size.toString();
	    if (isClose) {
	      path = 'M2.5 2.5 L10.5 2.5 L10.5 10.5 L2.5 10.5 L2.5 2.5 M4.5 6.5 L8.5 6.5 M6.5 4.5 L6.5 8.5';
	      return React.createElement(
	        'svg',
	        { width: size, height: size, style: { float: 'left' }, viewBox: box },
	        React.createElement('path', { d: path, strokeWidth: '1', stroke: color, fill: 'none' })
	      );
	    } else {
	      path = 'M2.5 2.5 L10.5 2.5 L10.5 10.5 L2.5 10.5 L2.5 2.5 M4.5 6.5 L8.5 6.5';
	      return React.createElement(
	        'svg',
	        { width: size, height: size, style: { float: 'left' }, viewBox: box },
	        React.createElement('path', { d: path, strokeWidth: '1', stroke: color, fill: 'none' })
	      );
	    }
	  },
	
	  /**
	   * svg绘制三角形折叠图标
	   * @param size : 图标尺寸
	   * @param isClose : 是否收拢状态
	   * @param color : 图标颜色
	   */
	  renderIconArrow: function renderIconArrow(size, isClose, color) {
	    var path;
	    var box = "0 0 " + size.toString() + " " + size.toString();
	    if (isClose) {
	      path = 'M6 2 L10.5 6.5 L6 11Z';
	      return React.createElement(
	        'svg',
	        { width: size, height: size, style: { float: 'left', left: 2 }, viewBox: box },
	        React.createElement('path', { d: path, strokeWidth: '0', stroke: color, fill: 'black' })
	      );
	    } else {
	      path = 'M11 4 L11 11 L4 11Z';
	      return React.createElement(
	        'svg',
	        { width: size, height: size, style: { float: 'left' }, viewBox: box },
	        React.createElement('path', { d: path, strokeWidth: '0', stroke: color, fill: 'black' })
	      );
	    }
	  },
	
	  renderCheckIcon: function renderCheckIcon(size, state) {
	    var path;
	    var box = "0 0 " + size.toString() + " " + size.toString();
	    if (state === 'true') {
	      path = 'M0 6 L4 9 L10 1';
	      return React.createElement(
	        'svg',
	        { width: size, height: size, style: { float: 'left', left: 2 }, viewBox: box },
	        React.createElement('path', { d: path, strokeWidth: '1', stroke: 'black', fill: 'none' })
	      );
	    } else if (state === 'half') {
	      path = 'M2 2 L8 2 L8 8 L2 8 Z';
	      return React.createElement(
	        'svg',
	        { width: size, height: size, style: { float: 'left', left: 2 }, viewBox: box },
	        React.createElement('path', { d: path, strokeWidth: '0', stroke: 'black', fill: 'black' })
	      );
	    }
	  },
	
	  /**
	   * svg绘制文件夹图标
	   * @param size : 图标尺寸
	   * @param color : 图标颜色
	   */
	  renderIconDir: function renderIconDir(size, color) {
	    var path = this.tranSVGStr("M 0 208 C 0 208 0 117 125 117 H 350 C 350 117 437 117 437 208 " + "V 276 H 890 C 890 276 1024 276 1024 365 V 826 C 1024 826 1024 890 890 890 H 125 " + "C 125 890 0 890 0 826 V 208", size, 1024);
	    var box = "0 0 " + size.toString() + " " + size.toString();
	    return React.createElement(
	      'svg',
	      { width: size, height: size, style: { float: 'left' }, viewBox: box },
	      React.createElement('path', { d: path, strokeWidth: '1', stroke: color, fill: 'none' })
	    );
	  },
	
	  /**
	   * svg绘制文件图标
	   * @param size : 图标尺寸
	   * @param color : 图标颜色
	   */
	  renderIconFile: function renderIconFile(size, color) {
	    var path = this.tranSVGStr("M 100 0 L 700 0 L 1000 300 L 1000 1100 L 100 1100 Z M 680 20 L 680 320 L 980 320", size, 1200);
	    var box = "0 0 " + size.toString() + " " + size.toString();
	    return React.createElement(
	      'svg',
	      { width: size, height: size, style: { float: 'left' }, viewBox: box },
	      React.createElement('path', { d: path, strokeWidth: '1', fill: 'none', vectorEffect: 'non-scaling-stroke', stroke: color })
	    );
	  },
	
	  /**
	   * svg绘制文件图标
	   * @param size : 图标尺寸
	   * @param color : 图标颜色
	   */
	  renderEmptyIcon: function renderEmptyIcon(size, color) {
	    var path = this.tranSVGStr("M 100 0 L 700 0 L 1000 300 L 1000 1100 L 100 1100 Z M 680 20 L 680 320 L 980 320", size, 1200);
	    var box = "0 0 " + size.toString() + " " + size.toString();
	    return React.createElement(
	      'svg',
	      { width: size, height: size, style: { float: 'left' }, viewBox: box },
	      React.createElement('path', { d: path, strokeWidth: '1', fill: 'none', vectorEffect: 'non-scaling-stroke', stroke: color })
	    );
	  },
	
	  tranWordColor: function tranWordColor(str) {
	
	    //var chartColors = this.props.chartColors;//'454445554,4555444444'
	
	
	    if (str === '白色' || str === '白' || str === 'white' || str === '白' || str === '白色') str = '#ffffff';
	    if (str === '红色' || str === '红' || str === 'red' || str === '紅' || str === '紅色') str = '#ED5555';
	    if (str === '绿色' || str === '绿' || str === 'green' || str === '綠' || str === '綠色') str = '#A0D468';
	    if (str === '蓝色' || str === '蓝' || str === 'blue' || str === '藍' || str === '藍色') str = '#5D9CEC';
	    if (str === '橙色' || str === '橙' || str === 'orange' || str === '橙' || str === '橙色') str = '#FB6E52';
	    if (str === '黄色' || str === '黄' || str === 'yellow' || str === '黃' || str === '黃色') str = '#FFCE55';
	    if (str === '紫色' || str === '紫' || str === 'purple' || str === '紫' || str === '紫色') str = '#AC92ED';
	    if (str === '银灰色' || str === '银灰' || str === 'silver' || str === '銀灰' || str === '銀灰色') str = '#C0C0C0';
	    if (str === '粉色' || str === '粉' || str === 'pink' || str === '粉' || str === '粉色') str = '#EC87BF';
	    if (str === '青色' || str === '青' || str === 'cyan' || str === '青' || str === '青色') str = '#48CFAE';
	    if (str === '浅灰色' || str === '浅灰' || str === 'lightgrey' || str === '淺灰' || str === '淺灰色') str = '#E6E6E6';
	    if (str === '灰色' || str === '灰' || str === 'grey' || str === '灰' || str === '灰色') str = '#808080';
	    if (str === '深灰色' || str === '深灰' || str === 'darkgrey' || str === '深灰色' || str === '深灰') str = '#999999';
	    if (str === '兰色' || str === '兰' || str === '蘭' || str === 'blue' || str === '蘭色') str = '#5D9CEC';
	    return str;
	  },
	
	  tranSimpleColor: function tranSimpleColor(str) {
	    var re0 = new RegExp("^#([0-9a-fA-F]{6})$");
	    var re1 = new RegExp("^#([0-9a-fA-F]{3})$");
	    var re2 = new RegExp("^[#|\$]([0-9a-fA-F]{1})$");
	    var re3 = new RegExp("^[#|\$]([0-9a-fA-F]{8,})$");
	    var re4 = new RegExp("^([0-9a-fA-F]{6})$");
	    var re5 = new RegExp("^([0-9a-fA-F]{3})$");
	    var re6 = new RegExp("^([0-9a-fA-F]{1})$");
	    var re7 = new RegExp("^([0-9a-fA-F]{8,})$");
	
	    if (re0.test(str)) {
	      //6位颜色值
	      str = "ff" + str.substring(1, 7);
	    } else if (re1.test(str)) {
	      //3位颜色值
	      str = "ff" + str.substring(1, 2).repeat(2) + str.substring(2, 3).repeat(2) + str.substring(3, 4).repeat(2);
	    }
	    /*else if(re2.test(str)) {     //1位颜色值
	      str = "ff" + str.substring(1,2).repeat(6);
	    }
	    else if(re3.test(str)) {     //8位以上颜色值
	      str = str.substring(1,9);
	    }
	    else if(re4.test(str)) {     //6位颜色值
	      str = "ff" + str;
	    }
	    else if(re5.test(str)) {     //3位颜色值
	      str = "ff" + str.substring(0,1).repeat(2) +
	        str.substring(1,2).repeat(2) + str.substring(2,3).repeat(2);
	    }
	    else if(re6.test(str)) {     //1位颜色值
	      str = "ff" + str.substring(0,1).repeat(6);
	    }
	    else if(re7.test(str)) {     //8位以上颜色值
	      str = str.substring(0,8);
	    }*/
	    else {
	        str = "empty";
	      }
	    return str;
	  },
	
	  tranColor: function tranColor(str) {
	    if (str) {
	      str = str.toLowerCase();
	    }
	    //将单词形式的颜色转换
	    str = this.tranWordColor(str);
	    //将简写颜色值转换为标准值
	    str = this.tranSimpleColor(str);
	    return str;
	  },
	
	  tranIndex: function tranIndex(i, length) {
	    if (length <= 0) {
	      //长度必须为负数，防御除零错误
	      return null;
	    }
	    i = i % length;
	    if (i < 0) {
	      i = length + i;
	    }
	    return i;
	  },
	
	  getTempleteColor: function getTempleteColor(colors) {
	
	    var index = -1;
	
	    for (var i = 0; i < colors.length; i++) {
	      if (colors[i] === "empty") {
	        //脏数据
	        var pre = colors[this.tranIndex(i - 1, colors.length)].toLowerCase();
	        var next = colors[this.tranIndex(i + 1, colors.length)].toLowerCase();
	        while (true) {
	          //无限循环，找模板中不与前后相同的颜色，理论上最多比较两种颜色
	          index = this.tranIndex(index + 1, colorTemplete.length);
	          if (colorTemplete[index] != pre && colorTemplete[index] != next) {
	            colors[i] = colorTemplete[index]; //修改颜色
	            break;
	          }
	        }
	      }
	    }
	  },
	
	  tranData: function tranData(str, maxValue) {
	    var f = parseFloat(str);
	    if (isNaN(f)) {
	      f = 0;
	    }
	    //if (f < Math.pow(10, str.length - 1)) {      //判断是否所有字符都可装换为数字
	    //  f = 0;
	    //}
	    if (maxValue && f > maxValue) {
	      f = maxValue;
	    }
	    return f;
	  },
	
	  tranToRGBA: function tranToRGBA(colors) {
	    for (var i = 0; i < colors.length; i++) {
	
	      colors[i] = this.toRGBA(colors[i]);
	    }
	  },
	
	  toRGBA: function toRGBA(colorStr) {
	    colorStr = colorStr.toLowerCase();
	    var a = (parseInt(colorStr.substring(0, 2), 16) / 255).toString();
	    var r = parseInt(colorStr.substring(2, 4), 16).toString();
	    var g = parseInt(colorStr.substring(4, 6), 16).toString();
	    var b = parseInt(colorStr.substring(6, 8), 16).toString();
	
	    return "rgba(" + r + "," + g + "," + b + "," + a + ")";
	  },
	
	  /**
	   * 解析图标文本，转换为数据和颜色
	   * }}
	   */
	  parseText: function parseText(text, maxValue) {
	
	    //1、以换行划分文本，取出各区域
	    var lines = text.split(/\s+/);
	    var areas = new Array();
	    var colors = new Array();
	
	    for (var i = 0; i < lines.length; i++) {
	
	      //2、中文逗号转英文，以英文逗号划分比例和颜色
	      var areaAndColors = lines[i].replace("，", ",").split(",");
	
	      //3、按策略转化数组第一个元素为数字
	      var area = this.tranData(areaAndColors[0], maxValue);
	      if (area === 0) {
	        continue;
	      }
	      areas.push(area);
	
	      //5、按策略转化数组第二个元素为标准颜色值
	      var color = this.tranColor(areaAndColors[1]);
	      colors.push(color);
	    }
	
	    //5、遍历colors，找出脏数据，替换成模板颜色
	    this.getTempleteColor(colors);
	    //将颜色转化为rgba格式
	    this.tranToRGBA(colors);
	
	    return { "areas": areas, "colors": colors };
	  },
	
	  /**
	   * 绘制形状
	   * @param graphics
	   * @param props :{
	     * {
	     *  width : number,
	     *  height : number,
	     *  borderType:String，
	     *  triangleType，
	     *  [borderVisible:boolean,]
	     *  [borderColor : string,]
	     *  [fillColor : string,]
	     *  [radius:number,]
	     *  [borderWidth:number,]
	     *  [borderLeft:boolean,]
	     *  [borderRight:boolean,]
	     *  [borderTop:boolean,]
	     *  [borderBottom:boolean,]
	     *  [image:document]
	     * }}
	   */
	  drawShpae: function drawShpae(graphics, props) {
	    var width = props.width;
	    var height = props.height;
	    var borderType = props.borderType;
	    var borderVisible = props.borderVisible || false;
	    var borderColor = props.borderColor || '#000';
	    var fillColor = props.fillColor || '#fff';
	    var radius = props.radius;
	    var borderWidth = props.borderWidth || 1;
	    var triangleType = props.triangleType;
	    var img = props.image;
	    var left = 0;
	    var top = 0;
	
	    if (!borderVisible) {
	      borderWidth = 0;
	    }
	    var ratio = 1;
	    var rect = {};
	    util.Rect.setLocation(rect, left, top);
	    util.Rect.setSize(rect, width, height);
	    ratio = this.applyDeviceRatio(graphics, width, height);
	    this.clearRect(graphics);
	    //graphics.clearRect(0, 0, width, height);
	    graphics.save();
	    if (img) {
	      if (borderType !== appTypes.ShapeType.RECTANGLE) {
	        graphics.rect(rect.left * ratio, rect.top * ratio, rect.width * ratio, rect.height * ratio);
	      }
	    }
	
	    this.initContextStyle(graphics, borderWidth, borderColor, fillColor, props.dashMode);
	
	    createPath(graphics, rect, radius, borderType, triangleType, ratio);
	    if (img) {
	      graphics.drawNineGridImage(img, left, top, width, height);
	      graphics.fill();
	    } else {
	      graphics.fill();
	    }
	
	    util.Rect.shrink(rect, borderWidth / 2, borderWidth / 2);
	    if (borderType === appTypes.ShapeType.RECTANGLE) {
	      roundRect(graphics, 1, 1, rect.width + borderWidth - 1, rect.height + borderWidth - 1, radius, true, false, {
	        left: props.borderLeft,
	        top: props.borderTop,
	        right: props.borderRight,
	        bottom: props.borderBottom
	      }); // 画矩形
	    }
	    if (borderVisible) {
	      if (borderType === appTypes.ShapeType.RECTANGLE) {
	        roundRect(graphics, borderWidth / 2, borderWidth / 2, rect.width, rect.height, radius, false, true, {
	          left: props.borderLeft,
	          top: props.borderTop,
	          right: props.borderRight,
	          bottom: props.borderBottom
	        });
	      } else {
	        createPath(graphics, rect, radius, borderType, triangleType, 1);
	        graphics.stroke();
	      }
	    }
	  },
	
	  drawTriangle: function drawTriangle(graphics, props) {
	    var width = props.width;
	    var height = props.height;
	    var borderVisible = props.borderVisible || false;
	    var borderColor = props.borderColor || '#000';
	    var fillColor = props.fillColor || '#fff';
	    var borderWidth = props.borderWidth || 1;
	    var triangleType = props.triangleType;
	    var triangleDirection = props.triangleDirection;
	    var left = 0;
	    var top = 0;
	
	    if (!borderVisible) {
	      borderWidth = 0;
	    }
	
	    var rect = {};
	    util.Rect.setLocation(rect, left, top);
	    util.Rect.setSize(rect, width, height);
	    graphics.clearRect(0, 0, width, height);
	    graphics.save();
	
	    this.initContextStyle(graphics, borderWidth, borderColor, fillColor, props.dashMode);
	
	    createTrianglePath(graphics, rect, triangleType, triangleDirection);
	
	    graphics.fill();
	
	    util.Rect.shrink(rect, borderWidth / 2, borderWidth / 2);
	
	    if (borderVisible) {
	      createTrianglePath(graphics, rect, triangleType, triangleDirection);
	      graphics.stroke();
	    }
	  },
	
	  drawLine: function drawLine(ctx, props) {
	    var lineWidth = props.lineWidth || 1;
	    var strokeColor = props.strokeColor || '#000';
	    var dashMode = props.dashMode || 'solid';
	
	    this.initContextStyle(ctx, lineWidth, strokeColor, null, dashMode);
	    ctx.beginPath();
	
	    ctx.moveTo(props.startX, props.startY);
	    ctx.lineTo(props.endX, props.endY);
	    ctx.stroke();
	  },
	
	  //绘制矩形内的分割线
	  drawDivision: function drawDivision(ctx, params) {
	
	    var thickness = params.thickness || 1;
	    var dashMode = params.dashMode || 'solid';
	    var lineColor = params.lineColor || '#000';
	    var margin = params.margin || 0;
	    var w = params.width;
	    var h = params.height;
	    var itemWidth = params.itemWidth;
	    var itemHeight = params.itemHeight;
	    var horiGap = params.horiGap || 10;
	    var vertGap = params.vertGap || 10;
	    var col = parseInt(w / itemWidth, 10);
	    var row = parseInt(h / itemHeight, 10);
	    var i;
	
	    this.initContextStyle(ctx, thickness, lineColor, null, dashMode);
	
	    ctx.clearRect(0, 0, w, h);
	    if (params.showSeparator) {
	
	      for (i = 0; i < col; i++) {
	        var baseX = parseInt(itemWidth + horiGap / 2, 10);
	        var offsetX = parseInt(itemWidth + horiGap, 10);
	        var drawX = baseX + offsetX * i + (thickness % 2 === 0 ? 0 : 0.5);
	        ctx.moveTo(drawX, margin);
	        ctx.lineTo(drawX, h - margin);
	        ctx.stroke();
	      }
	
	      for (i = 0; i < row; i++) {
	        var baseY = parseInt(itemHeight + vertGap / 2, 10);
	        var offsetY = parseInt(itemHeight + vertGap, 10);
	        var drawY = baseY + offsetY * i + (thickness % 2 === 0 ? 0 : 0.5);
	        ctx.moveTo(margin, drawY);
	        ctx.lineTo(w - margin, drawY);
	        ctx.stroke();
	      }
	    }
	  },
	
	  /*
	   * 圆角矩形绘制
	   * */
	  // rectRadius: function(graphics, rect, radius, borderLeft, borderTop, borderRight, borderBottom){
	  //     if (borderLeft) {
	  //         graphics.rect(rect.left, rect.top, rect.width, rect.height);
	  //         console.log('borderLeft');
	  //     }
	  //     if (borderTop) {
	  //         console.log('borderTop');
	  //     }
	  //     if (borderRight) {
	  //         console.log('borderRight');
	  //     }
	  //     if (borderBottom) {
	  //         console.log('borderBottom');
	  //     }
	  //     if (borderLeft && borderTop && borderRight && borderBottom) {
	  //
	  //     }
	  // },
	
	
	  /***
	   * 九宫格绘图，4 个参数缺一不可
	   * @author mengxiaojiang
	   * @createDate 2016-7-4
	   * @param graphics canvas.getContext('2d')
	   * @param img  img Document
	   * @param sourceRect9 图片的九宫格裁切区域，格式｛left:number,top:number,right:number,bottom:number｝
	   * @param destRect 绘制的目标区域,格式｛left:number,top:number,right:number,bottom:number｝
	   */
	  drawNineGridImage: function drawNineGridImage(graphics, img, sourceRect9, destRect) {
	    var imgW;
	    var imgH;
	    var sx;
	    var sy;
	    var sw;
	    var sh;
	    var dx;
	    var dy;
	    var dw;
	    var dh;
	    var ratio = 1;
	    var r;
	    if (!graphics || !img || !sourceRect9 || !destRect) {
	      return;
	    }
	
	    imgW = img.naturalWidth;
	    imgH = img.naturalHeight;
	    //左上
	    sx = 0;
	    sy = 0;
	    sw = sourceRect9.left;
	    sh = sourceRect9.top;
	    dx = sx;
	    dy = sy;
	    dw = sw;
	    dh = sh;
	    ratio = this.applyDeviceRatio(graphics, destRect.right, destRect.bottom);
	    this.clearRect(graphics);
	
	    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	    //return;
	    //graphics.clearRect(destRect.left, destRect.top, destRect.right, destRect.bottom);
	    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	    //顶上
	    sx = sourceRect9.left;
	    sw = sourceRect9.right - sx;
	    dx = sx;
	    dw = destRect.right - (imgW - sw);
	    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	
	    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	    //右上
	    sx = sourceRect9.right;
	    sw = imgW - sx;
	    dx = destRect.right - sw;
	    dw = sw;
	    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	    //左
	    sx = 0;
	    sy = sourceRect9.top;
	    sw = sourceRect9.left;
	    sh = sourceRect9.bottom - sy;
	    dx = sx;
	    dy = sy;
	    dw = sw;
	    dh = destRect.bottom - (imgH - sh);
	    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	    //中
	    sx = sourceRect9.left;
	    sw = sourceRect9.right - sx;
	    dx = sx;
	    dw = destRect.right - (imgW - sw);
	    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	    //右
	    sx = sourceRect9.right;
	    sw = imgW - sx;
	    dx = destRect.right - sw;
	    dw = sw;
	    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	    //左下
	    sx = 0;
	    sy = sourceRect9.bottom;
	    sw = sourceRect9.left;
	    sh = imgH - sy;
	    dx = sx;
	    dw = sw;
	    dh = sh;
	    dy = destRect.bottom - dh;
	    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	    //底
	    sx = sourceRect9.left;
	    sw = sourceRect9.right - sx;
	    dx = sx;
	    dw = destRect.right - destRect.left;
	    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	    //右下
	    sx = sourceRect9.right;
	    sw = imgW - sx;
	    dx = destRect.right - sw;
	    dw = sw;
	    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	  },
	
	  /**
	   * 水平三段绘制图片
	   * @author mengxiaojiang
	   * @createDate 2016-7-4
	   * @param graphics
	   * @param img
	   * @param left
	   * @param right
	   * @param destRect
	   */
	  drawHorizontalThreeGridImage: function drawHorizontalThreeGridImage(graphics, img, left, right, destRect) {
	    var sx;
	    var sy;
	    var sw;
	    var sh;
	    var dx;
	    var dy;
	    var dw;
	    var dh;
	    var imgH = img.naturalHeight;
	    var imgW = img.naturalWidth;
	    var ratio = 1;
	    util.Rect.init(destRect);
	
	    sx = 0;
	    sy = 0;
	    sw = left;
	    sh = imgH;
	    dx = destRect.left;
	    dy = destRect.top;
	    dw = sw;
	    dh = destRect.height; // destRect.bottom - dy;
	
	    ratio = this.applyDeviceRatio(graphics, destRect.width, destRect.height);
	
	    this.clearRect(graphics);
	    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	    if (right !== left) {
	      sx = left;
	      sw = right - left;
	      dx = destRect.left + sx;
	      dw = destRect.right - destRect.left - (imgW - sw);
	      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	      sx = right;
	      sw = imgW - sx;
	      dx = destRect.right - sw;
	      dw = sw;
	      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	    } else {
	      sx = left;
	      sw = imgW - sx;
	      dx = destRect.left + sx;
	      dw = destRect.right - left;
	      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh), ratio);
	    }
	  },
	
	  /**
	   * 垂直三段绘制图片
	   * @author mengxiaojiang
	   * @createDate 2016-7-4
	   * @param graphics
	   * @param img
	   * @param top
	   * @param bottom
	   * @param destRect
	   */
	  drawVerticalThreeGridImage: function drawVerticalThreeGridImage(graphics, img, top, bottom, destRect) {
	    var sx;
	    var sy;
	    var sw;
	    var sh;
	    var dx;
	    var dy;
	    var dw;
	    var dh;
	    var imgH = img.naturalHeight;
	    var imgW = img.naturalWidth;
	    var ratio = 1;
	    sx = 0;
	    sy = 0;
	    sw = imgW;
	    sh = top;
	    dx = destRect.left;
	    dy = destRect.top;
	    dw = destRect.right - destRect.left;
	    dh = sh;
	    //graphics.clearRect(0, 0, dw, dh);
	    //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	    ratio = this.applyDeviceRatio(graphics, dw, dh);
	    this.clearRect(graphics);
	    this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh));
	    if (bottom !== top) {
	      sy = top;
	      sh = bottom - top;
	      dy = sy;
	      dh = destRect.bottom - destRect.top - (imgH - sh);
	      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh));
	      sy = bottom;
	      sh = imgH - sy;
	      dy = destRect.bottom - sh;
	      dh = sh;
	      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh));
	    } else {
	      sy = top;
	      sh = imgH - sy;
	      dy = destRect.top + sy;
	      dh = destRect.bottom - top;
	      //graphics.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
	      this.drawImage(graphics, img, util.Rect.create(sx, sy, sw, sh), util.Rect.create(dx, dy, dw, dh));
	    }
	  },
	
	  /**
	   * 绘制图片，此过程是一个比较耗时的过程，不建议在渲染的过程频繁的绘制
	   * @author mengxiaojiang
	   * @createDate 2016-7-4
	   * @param graphics
	   * @param img
	   * @param color {'#FFF'|#FFFFFF'|'rgba(r,g,b,a)'|null}，如果不为null，则会替换图片的颜色
	   * @param sourceRect {{left:(number),right:(number)}|{top:(number),bottom:(number)}|{left:(number),top:(number),right:(number),bottom:(number)}|null}，图片的九宫格拉伸区域
	   * @param destRect {{left:(number),top:(number),right:(number),bottom:(number)}|null} ，图片绘制的目标区域
	   */
	  drawColorImage: function drawColorImage(graphics, img, color, sourceRect, destRect) {
	    var w = img.naturalWidth;
	    var h = img.naturalHeight;
	    var dw;
	    var dh;
	    //var sw;
	    //var sh;
	    //var imgData;
	    //var rgb;
	    var type = 0;
	    var sr = {
	      left: 0,
	      top: 0,
	      right: w,
	      bottom: h
	    };
	    var dr = {
	      left: 0,
	      top: 0,
	      right: w,
	      bottom: h
	    };
	    var self = this;
	    this.getImageSize(img, function (err, size, img) {
	      if (err) {
	        console.error(err);
	        return;
	      }
	      var imgW = size.width;
	      var imgH = size.height;
	      var ratio = 1;
	      if (!imgW || !imgH) {
	        return;
	      }
	      if (sourceRect) {
	        if (!_.isUndefined(sourceRect.left) && !_.isUndefined(sourceRect.right) && !_.isUndefined(sourceRect.top) && !_.isUndefined(sourceRect.bottom)) {
	          type = 1;
	        } else if (!_.isUndefined(sourceRect.left) && !_.isUndefined(sourceRect.right)) {
	          type = 2;
	        } else if (!_.isUndefined(sourceRect.top) && !_.isUndefined(sourceRect.bottom)) {
	          type = 3;
	        }
	        if (!_.isUndefined(sourceRect.left)) {
	          sr.left = sourceRect.left;
	        }
	        if (!_.isUndefined(sourceRect.top)) {
	          sr.top = sourceRect.top;
	        }
	        if (!_.isUndefined(sourceRect.right)) {
	          sr.right = sourceRect.right;
	        }
	        if (!_.isUndefined(sourceRect.bottom)) {
	          sr.bottom = sourceRect.bottom;
	        }
	      }
	
	      if (destRect) {
	        if (!_.isUndefined(destRect.left)) {
	          dr.left = destRect.left;
	        }
	        if (!_.isUndefined(destRect.top)) {
	          dr.top = destRect.top;
	        }
	        if (!_.isUndefined(destRect.right)) {
	          dr.right = destRect.right;
	        }
	        if (!_.isUndefined(destRect.bottom)) {
	          dr.bottom = destRect.bottom;
	        }
	      }
	      if (destRect) {
	        dw = destRect.right - destRect.left;
	        dh = destRect.bottom - destRect.top;
	      } else {
	        dw = imgW;
	        dh = imgH;
	      }
	
	      //if(sourceRect){
	      //  sw = sourceRect.right - sourceRect.left;
	      //  sh = sourceRect.bottom  - sourceRect.top;
	      //}else{
	      //  sw = destRect.right - destRect.left;
	      //  sh = destRect.bottom - destRect.top;
	      //}
	      //graphics.clearRect(0, 0, dw, dh);
	      ratio = self.applyDeviceRatio(graphics, dw, dh);
	      self.clearRect(graphics);
	      graphics.globalCompositeOperation = 'source-over';
	      if (type === 0) {
	        self.drawImage(graphics, img, util.Rect.create(0, 0, imgW, imgH), util.Rect.create(0, 0, dw, dh), ratio);
	      } else if (type === 1) {
	        self.drawNineGridImage(graphics, img, sr, dr);
	      } else if (type === 2) {
	        self.drawHorizontalThreeGridImage(graphics, img, sr.left, sr.right, dr);
	      } else if (type === 3) {
	        self.drawVerticalThreeGridImage(graphics, img, sr.top, sr.bottom, dr);
	      } else {
	        return;
	      }
	      if (color) {
	        //imgData = graphics.getImageData(0,0,dw,dh);
	        //replacecolor(imgData.data,color);
	        //graphics.putImageData(imgData,0,0);
	        graphics.globalCompositeOperation = 'source-in';
	        createPath(graphics, { left: 0, top: 0, right: dw, bottom: dh }, 0, null, null, ratio);
	        graphics.fillStyle = color;
	        graphics.fill();
	      }
	    });
	  },
	
	  applyDeviceRatio: function applyDeviceRatio(graphics, width, height) {
	    var ratio = this.getDeviceRatio(graphics);
	    graphics.canvas.width = width * ratio;
	    graphics.canvas.height = height * ratio;
	    return ratio;
	  },
	
	  getDeviceRatio: function getDeviceRatio(graphics) {
	    var dratio = window.devicePixelRatio || 1;
	    var gratio = graphics.backingStorePixelRatio || graphics.webkitBackingStorePixelRatio || graphics.mozBackingStorePixelRatio || graphics.msBackingStorePixelRatio || graphics.oBackingStorePixelRatio || graphics.backingStorePixelRatio || 1;
	    return dratio / gratio;
	  },
	
	  clearRect: function clearRect(graphics, rect) {
	    if (_.isUndefined(rect)) {
	      rect = util.Rect.create(0, 0, graphics.canvas.width, graphics.canvas.height);
	    }
	    graphics.clearRect(rect.left, rect.top, rect.width, rect.height);
	  },
	  drawImage: function drawImage(graphics, img, srcRect, desRect, ratio) {
	
	    var srcX = srcRect.left;
	    var srcY = srcRect.top;
	    var srcW = srcRect.width;
	    var srcH = srcRect.height;
	    var desX = desRect.left;
	    var desY = desRect.top;
	    var desW = desRect.width;
	    var desH = desRect.height;
	    if (_.isUndefined(ratio)) {
	      ratio = 1;
	    }
	    //var ratio = this.applyDeviceRatio(graphics,desW,desH);
	    graphics.drawImage(img, srcX, srcY, srcW, srcH, desX * ratio, desY * ratio, desW * ratio, desH * ratio);
	  },
	
	  drawFilterImage: function drawFilterImage(graphics, img, destRect, fitMode, filterProps, shapeProps, faildcall) {
	    //var imgData;
	    //var pixes;
	    var width = img.width;
	    var height = img.height;
	    var imgW = img.naturalWidth || img.width;
	    var imgH = img.naturalHeight || img.height;
	
	    var isRepeat = appTypes.ImageFitMode.TILE.indexOf(fitMode) !== -1;
	    var isFilled = appTypes.ImageFitMode.Fill.indexOf(fitMode) !== -1;
	    var isFit = appTypes.ImageFitMode.Fit.indexOf(fitMode) !== -1;
	    var isCenter = appTypes.ImageFitMode.CENTER.indexOf(fitMode) !== -1;
	    var dRect;
	
	    //var copyPixes;
	    //var filterType = filterProps.filterType;
	    //var filterValue = filterProps.filterValue;
	    //var drawBorder = false;
	    var shapeType;
	    var radius;
	    //var triangleType;
	    var rect;
	    //var borderWidth;
	    var pat;
	    //var ratio = 1;
	    if (destRect) {
	      width = destRect.right - destRect.left;
	      height = destRect.bottom - destRect.top;
	    }
	
	    rect = {
	      left: 0,
	      top: 0,
	      right: width,
	      bottom: height
	    };
	
	    //if (!filterValue) {
	    //  filterValue = 3;
	    //} else {
	    //  filterValue = filterValue;
	    //}
	    if (shapeProps) {
	      shapeType = shapeProps.shapeType;
	      radius = shapeProps.radius;
	      //drawBorder = shapeProps.borderVisible;
	      //triangleType = shapeProps.triangleType;
	      //borderWidth = shapeProps.borderWidth;
	      //if (!borderWidth) {
	      //  borderWidth = 1;
	      //}
	    }
	
	    //ratio = graphics.backingStorePixelRatio ||
	    //  graphics.webkitBackingStorePixelRatio ||
	    //  graphics.mozBackingStorePixelRatio ||
	    //  graphics.msBackingStorePixelRatio ||
	    //  graphics.oBackingStorePixelRatio ||
	    //  graphics.backingStorePixelRatio || 1;
	    //
	    //ratio = (window.devicePixelRatio || 1)/ratio;
	    /*
	     "copy"	只绘制新图形，删除其他所有内容。
	     "darker"	在图形重叠的地方，颜色由两个颜色值相减后决定。
	     "destination-atop"	已有的内容只有在它和新的图形重叠的地方保留。新图形绘制于内容之后。
	     "destination-in"	在新图形以及已有画布重叠的地方，已有内容都保留。所有其他内容成为透明的。
	     "destination-out"	在已有内容和新图形不重叠的地方，已有内容保留。所有其他内容成为透明。
	     "destination-over"	新图形绘制于已有内容的后面。
	     "lighter"	在图形重叠的地方，颜色由两种颜色值的加值来决定。
	     "source-atop"	只有在新图形和已有内容重叠的地方，才绘制新图形。
	     "source-in"	在新图形以及已有内容重叠的地方，新图形才绘制。所有其他内容成为透明。
	     "source-out"	只有在和已有图形不重叠的地方，才绘制新图形。
	     "source-over"	新图形绘制于已有图形的顶部。这是默认的行为。
	     "xor"
	     */
	
	    //加入密度的计算
	    //graphics.canvas.width = width * ratio;
	    //graphics.canvas.height = height * ratio;
	    graphics.globalCompositeOperation = 'copy';
	    if (imgW > MAX_IMGSIZE || imgH > MAX_IMGSIZE) {
	      if (faildcall) {
	        //超大图片直接不绘制
	        faildcall();
	      }
	      return;
	    }
	    if (!isRepeat) {
	      //graphics.drawImage(img, 0, 0, imgW , imgH , 0, 0, width * ratio, height * ratio);
	      var ratio = this.applyDeviceRatio(graphics, width, height);
	      var srcRect = util.Rect.create(0, 0, imgW, imgH);
	      dRect = util.Rect.create(0, 0, rect.right - rect.left, rect.bottom - rect.top);
	      //填充模式为填充时，图片等比例充满组件区域
	      if (isFilled) {
	        if (imgW / imgH > width / height) {
	          srcRect = util.Rect.create((imgW - imgH * width / height) / 2, 0, imgH * width / height, imgH);
	        } else if (imgH / imgW > height / width) {
	          srcRect = util.Rect.create(0, (imgH - imgW * height / width) / 2, imgW, imgW * height / width);
	        }
	      }
	      //当填充模式选项为适应时，图片等比例缩放来适应组件宽高
	      if (isFit) {
	        if (imgW / imgH > width / height) {
	          dRect = util.Rect.create(0, (height - width * imgH / imgW) / 2, width, width * imgH / imgW);
	        } else if (imgH / imgW > height / width) {
	          dRect = util.Rect.create((width - height * imgW / imgH) / 2, 0, height * imgW / imgH, height);
	        }
	      }
	      //当填充模式选项为居中时，图片宽高不变，居中显示
	      if (isCenter) {
	        var x = imgW < width ? 0 : (imgW - width) / 2;
	        var y = imgH < height ? 0 : (imgH - height) / 2;
	        var w = Math.min(imgW, width);
	        var h = Math.min(imgH, height);
	        srcRect = util.Rect.create(x, y, w, h);
	        x = imgW < width ? (width - imgW) / 2 : 0;
	        y = imgH < height ? (height - imgH) / 2 : 0;
	        dRect = util.Rect.create(x, y, w, h);
	      }
	
	      this.drawImage(graphics, img, srcRect, dRect, ratio);
	    } else {
	      pat = graphics.createPattern(img, 'repeat');
	      graphics.fillStyle = pat;
	      graphics.rect(0, 0, width, height);
	      graphics.fill();
	    }
	    //获取原图数据
	
	    if (shapeType) {
	      if (radius) {
	        radius = parseInt(radius, 10);
	      }
	      if (shapeType !== appTypes.ShapeType.RECTANGLE || radius) {
	        graphics.globalCompositeOperation = 'destination-in';
	        graphics.fillStyle = 'rgba(255,255,255,1)';
	        createPath(graphics, rect, radius, shapeType, null, ratio);
	        graphics.fill();
	      }
	    }
	  }
	};
	
	/**
	 * 根据需要绘制的形状，生成一个路径区域，该函数不负责区域的填充
	 * @param graphics
	 * @param rect ｛left:number,top:number,right:number,bottom:number｝
	 * @param radius number
	 * @param borderType string
	 * @param triangleType string
	 */
	function createPath(graphics, rect, radius, borderType, triangleType, ratio) {
	  if (_.isUndefined(ratio)) {
	    ratio = 1;
	  }
	  if (rect) {
	    //rect.width = rect.right - rect.left;
	    //rect.height = rect.bottom - rect.top;
	    //rect.center = {
	    //  x: rect.left + rect.width / 2,
	    //  y: rect.top + rect.height / 2
	    //};
	    util.Rect.scale(rect, ratio, true);
	    util.Rect.init(rect);
	  }
	
	  if (!borderType) {
	    borderType = appTypes.ShapeType.RECTANGLE;
	  }
	  graphics.beginPath();
	  if (borderType === appTypes.ShapeType.RECTANGLE) {
	    if (radius) {
	
	      graphics.moveTo(rect.left + radius, rect.top);
	      graphics.lineTo(rect.right - radius, rect.top);
	
	      //graphics.arcTo(rect.right-radius,rect.top,rect.right,rect.top + radius,radius);
	      graphics.arc(rect.right - radius, rect.top + radius, radius, 0, 90);
	
	      graphics.quadraticCurveTo(rect.right, rect.top, rect.right, rect.top + radius);
	      graphics.lineTo(rect.right, rect.bottom - radius);
	      graphics.quadraticCurveTo(rect.right, rect.bottom, rect.right - radius, rect.bottom);
	      graphics.lineTo(rect.left + radius, rect.bottom);
	      graphics.quadraticCurveTo(rect.left, rect.bottom, rect.left, rect.bottom - radius);
	      graphics.lineTo(rect.left, rect.top + radius);
	      graphics.quadraticCurveTo(rect.left, rect.top, rect.left + radius, rect.top);
	    } else {
	      graphics.rect(rect.left, rect.top, rect.width, rect.height);
	    }
	  }
	  //椭圆
	  else if (borderType === appTypes.ShapeType.ELLIPSE) {
	      graphics.moveTo(rect.left, rect.center.y);
	      graphics.bezierCurveTo(rect.left, rect.top + rect.height * 0.22662, rect.left + rect.width * 0.22662, rect.top, rect.center.x, rect.top);
	      graphics.bezierCurveTo(rect.left + rect.width * 0.77338, rect.top, rect.right, rect.top + rect.height * 0.22662, rect.right, rect.center.y);
	      graphics.bezierCurveTo(rect.right, rect.top + rect.height * 0.77338, rect.left + rect.width * 0.77338, rect.bottom, rect.center.x, rect.bottom);
	      graphics.bezierCurveTo(rect.left + rect.width * 0.22662, rect.bottom, rect.left, rect.top + rect.height * 0.77338, rect.left, rect.center.y);
	    }
	    //菱形
	    else if (borderType === appTypes.ShapeType.DIAMOND) {
	        graphics.moveTo(rect.center.x, rect.top);
	        graphics.lineTo(rect.right, rect.center.y);
	        graphics.lineTo(rect.center.x, rect.bottom);
	        graphics.lineTo(rect.left, rect.center.y);
	      }
	      // 平行四边形
	      else if (borderType === appTypes.ShapeType.PARALLELOGRAM) {
	          graphics.moveTo(rect.left + rect.width * 0.2, rect.top);
	          graphics.lineTo(rect.right, rect.top);
	          graphics.lineTo(rect.left + rect.width * 0.8, rect.bottom);
	          graphics.lineTo(rect.left, rect.bottom);
	        }
	        //三角形
	        else if (borderType === appTypes.ShapeType.TRIANGLE) {
	            if (triangleType === appTypes.RotationAngle.TWO_HUNDRED_SEVENTY) {
	              graphics.moveTo(rect.right, rect.top);
	              graphics.lineTo(rect.right, rect.bottom);
	              graphics.lineTo(rect.left, rect.center.y);
	              graphics.lineTo(rect.right, rect.top);
	            } else if (triangleType === appTypes.RotationAngle.NINETY) {
	              graphics.moveTo(rect.left, rect.top);
	              graphics.lineTo(rect.right, rect.center.y);
	              graphics.lineTo(rect.left, rect.bottom);
	              graphics.lineTo(rect.left, rect.top);
	            } else if (triangleType === appTypes.RotationAngle.ONE_HUNDRED_EIGHTY) {
	              graphics.moveTo(rect.left, rect.top);
	              graphics.lineTo(rect.right, rect.top);
	              graphics.lineTo(rect.center.x, rect.bottom);
	              graphics.lineTo(rect.left, rect.top);
	            } else {
	              graphics.moveTo(rect.center.x, rect.top);
	              graphics.lineTo(rect.right, rect.bottom);
	              graphics.lineTo(rect.left, rect.bottom);
	              graphics.lineTo(rect.center.x, rect.top);
	            }
	          }
	          //五角星
	          else if (borderType === appTypes.ShapeType.STAR) {
	              graphics.moveTo(rect.left + rect.width * 0.5, rect.top);
	              graphics.lineTo(rect.left + rect.width * 0.66, rect.top + rect.height * 0.33);
	              graphics.lineTo(rect.left + rect.width, rect.top + rect.height * 0.38);
	              graphics.lineTo(rect.left + rect.width * 0.75, rect.top + rect.height * 0.63);
	              graphics.lineTo(rect.left + rect.width * 0.8, rect.bottom);
	
	              graphics.lineTo(rect.left + rect.width * 0.5, rect.top + rect.height * 0.83);
	              graphics.lineTo(rect.left + rect.width * 0.2, rect.bottom);
	              graphics.lineTo(rect.left + rect.width * 0.25, rect.top + rect.height * 0.63);
	              graphics.lineTo(rect.left, rect.top + rect.height * 0.36);
	              graphics.lineTo(rect.left + rect.width * 0.34, rect.top + rect.height * 0.33);
	
	              graphics.lineTo(rect.left + rect.width * 0.5, rect.top);
	            }
	
	  graphics.closePath();
	}
	
	function createTrianglePath(graphics, rect, triangleType, triangleDirection) {
	  if (rect) {
	    rect.width = rect.right - rect.left;
	    rect.height = rect.bottom - rect.top;
	    rect.center = {
	      x: rect.left + rect.width / 2,
	      y: rect.top + rect.height / 2
	    };
	  }
	
	  graphics.beginPath();
	
	  if (triangleType === 'ttRightAngle') {
	    //等边三角形，绘制路径不一样
	    if (triangleDirection === appTypes.RotationAngle.TWO_HUNDRED_SEVENTY) {
	      graphics.moveTo(rect.left, rect.top);
	      graphics.lineTo(rect.right, rect.top);
	      graphics.lineTo(rect.left, rect.bottom);
	      graphics.lineTo(rect.left, rect.top);
	    } else if (triangleDirection === appTypes.RotationAngle.NINETY) {
	      graphics.moveTo(rect.right, rect.top);
	      graphics.lineTo(rect.right, rect.bottom);
	      graphics.lineTo(rect.left, rect.bottom);
	      graphics.lineTo(rect.right, rect.top);
	    } else if (triangleDirection === appTypes.RotationAngle.ONE_HUNDRED_EIGHTY) {
	      graphics.moveTo(rect.left, rect.top);
	      graphics.lineTo(rect.right, rect.top);
	      graphics.lineTo(rect.right, rect.bottom);
	      graphics.lineTo(rect.left, rect.top);
	    } else {
	      graphics.moveTo(rect.left, rect.top);
	      graphics.lineTo(rect.right, rect.bottom);
	      graphics.lineTo(rect.left, rect.bottom);
	      graphics.lineTo(rect.left, rect.top);
	    }
	  } else {
	    if (triangleDirection === appTypes.RotationAngle.TWO_HUNDRED_SEVENTY) {
	      graphics.moveTo(rect.right, rect.top);
	      graphics.lineTo(rect.right, rect.bottom);
	      graphics.lineTo(rect.left, rect.center.y);
	      graphics.lineTo(rect.right, rect.top);
	    } else if (triangleDirection === appTypes.RotationAngle.NINETY) {
	      graphics.moveTo(rect.left, rect.top);
	      graphics.lineTo(rect.right, rect.center.y);
	      graphics.lineTo(rect.left, rect.bottom);
	      graphics.lineTo(rect.left, rect.top);
	    } else if (triangleDirection === appTypes.RotationAngle.ONE_HUNDRED_EIGHTY) {
	      graphics.moveTo(rect.left, rect.top);
	      graphics.lineTo(rect.right, rect.top);
	      graphics.lineTo(rect.center.x, rect.bottom);
	      graphics.lineTo(rect.left, rect.top);
	    } else {
	      graphics.moveTo(rect.center.x, rect.top);
	      graphics.lineTo(rect.right, rect.bottom);
	      graphics.lineTo(rect.left, rect.bottom);
	      graphics.lineTo(rect.center.x, rect.top);
	    }
	  }
	  graphics.closePath();
	}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var LabelParts = __webpack_require__(174);
	var AutoSizeHelper = __webpack_require__(167);
	var CheckItem = __webpack_require__(170);
	var styleHelper = __webpack_require__(145);
	var LinkHelper = __webpack_require__(158);
	var util = __webpack_require__(116);
	
	/*
	 * 复选框组组件
	 */
	
	var CheckBoxGroup = React.createClass({
	  displayName: 'CheckBoxGroup',
	
	
	  getInitialState: function getInitialState() {
	    var TextUtil = util.Text;
	    var text = TextUtil.removeLastEmptyRow(this.props.text);
	    var items = TextUtil.delimitText(text, util.Text.DM_RETURN);
	    var i;
	    var itemText;
	    var cfg;
	    var state = {};
	    for (i = 0; i < items.length; i++) {
	      itemText = items[i];
	      cfg = this.parseState(itemText);
	      state[i] = { isChecked: cfg.isChecked, isDisabled: cfg.isDisabled };
	    }
	    return state;
	  },
	
	  parseItem: function parseItem(itemText) {
	
	    var item = JSON.parse(JSON.stringify(this.props));
	    var cfg;
	    cfg = this.parseState(itemText);
	    item.text = cfg.text;
	    item.state = cfg.state;
	    item.gap = 5;
	    return item;
	  },
	
	  parseState: function parseState(text) {
	    var state = appTypes.ComStatus.ENABLE;
	    var cutText = '';
	    text = text.trim();
	    if (text.indexOf('[]') === 0) {
	      cutText = '[]';
	      state = appTypes.ComStatus.ENABLE;
	    } else if (text.indexOf('[ ]') === 0) {
	      state = appTypes.ComStatus.ENABLE;
	      cutText = '[ ]';
	      text = text.replace('[ ]', '');
	    } else if (text.indexOf('[x]') === 0) {
	      cutText = '[x]';
	      state = appTypes.ComStatus.SELECTED;
	    } else if (text.indexOf('[X]') === 0) {
	      cutText = '[X]';
	      state = appTypes.ComStatus.SELECTED;
	    } else if (text.charAt(0) === '-' && text.charAt(text.length - 1) === '-') {
	      text = text.substring(1, text.length - 1);
	      state = appTypes.ComStatus.DISABLED;
	      if (text.indexOf('[x]') === 0) {
	        state = appTypes.ComStatus.SELECTED_AND_DISABLED;
	        cutText = '[x]';
	      }if (text.indexOf('[X]') === 0) {
	        state = appTypes.ComStatus.SELECTED_AND_DISABLED;
	        cutText = '[X]';
	      } else if (text.indexOf('[]') === 0) {
	        cutText = '[]';
	      } else if (text.indexOf('[ ]') === 0) {
	        cutText = '[ ]';
	      }
	    }
	    text = text.replace(cutText, '');
	    return {
	      isChecked: appTypes.ComStatus.isSelected(state),
	      isDisabled: appTypes.ComStatus.isDisabled(state),
	      text: text,
	      state: state
	    };
	  },
	
	  parseItems: function parseItems() {
	    var TextUtil = util.Text;
	    var text = TextUtil.removeLastEmptyRow(styleHelper.getText(this.props));
	    var textArray = TextUtil.delimitText(text, TextUtil.DM_RETURN);
	    var i;
	    var itemText;
	    var resultArray = [];
	    var links = LinkHelper.tranItemRect(this.props.itemRect) || this.props.links.link;
	
	    var item;
	    var rect;
	    for (i = 0; i < textArray.length; i++) {
	      itemText = textArray[i].trim();
	      item = this.parseItem(itemText);
	      if (links[i]) {
	        rect = links[i].area ? links[i].area.coords : links[i];
	        item.x = rect.left;
	        item.y = rect.top;
	        item.w = rect.width;
	        item.h = rect.height;
	        delete item.currentX;
	        delete item.currentY;
	        delete item.currentW;
	        delete item.currentH;
	      }
	      resultArray.push(item);
	    }
	
	    return resultArray;
	  },
	
	  render: function render() {
	    var itemArray = this.parseItems();
	    var itemStyle;
	    var style = styleHelper.StyleUtil(this.props).default({ overflow: 'hidden', position: 'absolute' }).size().text().align().style;
	    return React.createElement(
	      'div',
	      { style: style },
	      itemArray.map(function (item, index) {
	        item.isChecked = this.state[index].isChecked;
	        item.isDisabled = this.state[index].isDisabled;
	        item.enabled = !item.isDisabled;
	        itemStyle = styleHelper.StyleUtil(item).default({ position: 'absolute', pointerEvent: item.isDisabled ? 'none' : 'auto' }).bounds().style;
	        return React.createElement(
	          'div',
	          { key: index, style: itemStyle },
	          React.createElement(CheckItem, item)
	        );
	      }, this)
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).on('checkedChange', this.onItemCheckedChange);
	  },
	
	  onItemCheckedChange: function onItemCheckedChange(e, data) {
	    var cfg = this.state[data.index];
	    var state = this.state;
	    var evt = data.nativeEvent;
	    if (!cfg.isDisabled) {
	      this.props.events.doSelfChecked(evt, this.props, !cfg.isChecked, data.key, data.index);
	      cfg.isChecked = !cfg.isChecked;
	      state[data.index] = cfg;
	      this.setState(state);
	    }
	  },
	
	  _onChecked: function _onChecked() {}
	});
	
	module.exports = CheckBoxGroup;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var tool = __webpack_require__(121);
	var convertHelper = __webpack_require__(146);
	var GlobalConst = __webpack_require__(164);
	var styleHelper = __webpack_require__(145);
	
	var LabelParts = React.createClass({
	  displayName: 'LabelParts',
	
	  propTypes: {
	    partStyle: React.PropTypes.object
	  },
	
	  _getTextStyle: function _getTextStyle() {
	
	    var textStyle = {
	      fontStyle: this.props.textStyles ? this.props.textStyles.fontStyle : 'normal',
	      textDecoration: this.props.textStyles ? this.props.textStyles.textDecoration : 'normal',
	      fontWeight: this.props.textStyles ? this.props.textStyles.fontWeight : 'normal',
	      fontFamily: this.props.textFontFamily || '',
	      color: styleHelper.getTextColor(this.props),
	      fontSize: styleHelper.getFontSize(this.props),
	      wordWrap: this.props.textWordWrap ? 'break-word' : 'nowrap',
	      pointerEvents: 'none',
	      textAlign: this.props.textAlign ? convertHelper.getTextHorizontalAlign(this.props.textAlign) : 'left',
	      whiteSpace: 'nowrap'
	    };
	
	    return tool.extendObj(textStyle, this.props.partStyle);
	  },
	
	  render: function render() {
	    return React.createElement(
	      'label',
	      { style: this._getTextStyle() },
	      ' ',
	      styleHelper.getText(this.props),
	      ' '
	    );
	  }
	
	});
	
	module.exports = LabelParts;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var ComboBoxBase = __webpack_require__(176);
	var styleHelper = __webpack_require__(145);
	var linkHelper = __webpack_require__(158);
	var util = __webpack_require__(116);
	var appTypes = __webpack_require__(115);
	
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-3-29
	 @Descript : 下拉列表框组件
	 */
	var CompositeComboBox = React.createClass({
	  displayName: 'CompositeComboBox',
	
	
	  getListControl: function getListControl() {
	    if (!this.props.items) {
	      return null;
	    }
	    var listControl = this.props.items[2];
	    for (var i = 0; i < this.props.items.length; i++) {
	      if (this.props.items[i].controlTypeID === 'List') {
	        listControl = this.props.items[i];
	        break;
	      }
	    }
	    return listControl;
	  },
	
	  parseText: function parseText() {
	    var items = [];
	
	    var listControl = this.getListControl();
	    var arr = [];
	    if (listControl) {
	      arr = util.Text.delimitToParagraphs(styleHelper.getText(listControl).trim());
	    }
	    var haveAction = false;
	    var actionDatas = null;
	    var i;
	
	    if (listControl && listControl.interactiveData && listControl.links) {
	      haveAction = true;
	      actionDatas = linkHelper.parseComInteractive(listControl);
	    }
	
	    for (i = 0; i < arr.length; i++) {
	      var text = util.Text.convertSpaceToNbsp(arr[i]);
	      var linkStyle = 'no-link';
	      if (haveAction) {
	        linkStyle = this.checkLinkStyle(actionDatas[i]);
	      }
	      items.push({ text: text, linkStyle: linkStyle });
	    }
	    return items;
	  },
	
	  checkLinkStyle: function checkLinkStyle(actionData) {
	    if (!actionData) {
	      return '';
	    }
	    this.haveAction = actionData.link !== undefined || actionData.entry !== undefined || actionData.externalURL !== undefined;;
	    this.isLinkAction = actionData.link !== undefined || actionData.externalURL !== undefined;
	    var linkAreaClass = 'no-link';
	    if (this.haveAction) {
	      if (this.isLinkAction) {
	        linkAreaClass = 'page-link';
	      } else {
	        linkAreaClass = 'interactive-link';
	      }
	    }
	    return linkAreaClass;
	  },
	
	  render: function render() {
	    if (!this.getListControl()) {
	      return React.createElement('div', null);
	    }
	    var textItems = this.parseText();
	    var fun = undefined;
	    if (this.props.events) {
	      fun = this.props.events.triggerSelectExpand;
	    }
	
	    var props = {
	      items: textItems,
	      borderColor: this.props.borderColor,
	      borderVisible: this.props.borderVisible,
	      color: this.props.textColor,
	      backgroundColor: this.props.color,
	      fontSize: this.props.textSize,
	      fontFamily: this.props.textFontFamily || decodeURIComponent(this.props.font.family),
	      selectedIndex: this.getListControl().selectedIndex,
	      listControl: this.getListControl(),
	      width: styleHelper.getWidth(this.props),
	      height: styleHelper.getHeight(this.props),
	      canInput: this.props.canInput,
	      onItemClick: this.onItemClick,
	      triggerSelectExpand: fun
	    };
	
	    if (this.props.textStyles) {
	      props.fontWeight = this.props.textStyles.fontWeight;
	      props.fontStyle = this.props.textStyles.fontStyle;
	      props.textDecoration = this.props.textStyles.textDecoration;
	    }
	    return React.createElement(ComboBoxBase, _extends({ ref: 'combobox' }, props));
	  },
	  onItemClick: function onItemClick(e, index) {
	    var props = this.getListControl();
	    var action = this.getAction(index);
	    var selfClick = this.props.events.doSelfClick;
	    selfClick(e, props, action, index);
	  },
	
	  getAction: function getAction(index) {
	    var props = this.getListControl();
	    var link = props.links ? props.links.link[index] : {};
	    var entry = props.interactiveData ? props.interactiveData.entry[index] : {};
	    var action = appTypes.ActionResponseType.NONE;
	    if (props.hasOwnProperty('externalURL') && props.externalURL !== '') {
	      action = appTypes.ActionResponseType.OUTER;
	    } else if (link.targetPageID !== '' && link.linkType === 'ltPageLink') {
	      action = appTypes.ActionResponseType.LINK;
	    } else if (entry.events && entry.events) {
	      action = appTypes.ActionResponseType.INTERACTIVE;
	    }
	    return action;
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize);
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this._onClick);
	  },
	
	  _onClick: function _onClick() {
	    $(ReactDOM.findDOMNode(this).children[0]).trigger('toggleExpand');
	  },
	
	  onResize: function onResize(e) {
	    $(ReactDOM.findDOMNode(this.refs.combobox)).trigger(appTypes.CUSTOM_EVENT.ON_PAINT);
	  }
	
	});
	
	module.exports = CompositeComboBox;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var GlobalConst = __webpack_require__(164);
	var util = __webpack_require__(116);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var SelectComp = __webpack_require__(177);
	
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-3-29
	 @Descript : 下拉列表框组件
	 */
	var ComboBoxBase = React.createClass({
	  displayName: 'ComboBoxBase',
	
	  render: function render() {
	    //var selectedValue = this.props.items[this.props.selectedIndex].text || 0;
	
	    var textBoxStyle = {
	      height: '100%',
	      display: 'flex',
	      alignItems: 'center',
	      backgroundColor: this.props.backgroundColor || '#fff',
	      boxSizing: 'border-box'
	
	    };
	    if (this.props.borderVisible) {
	      textBoxStyle.borderTop = '1px solid ' + this.props.borderColor || '#444';
	      textBoxStyle.borderBottom = '1px solid ' + this.props.borderColor || '#444';
	    }
	
	    return React.createElement(
	      'div',
	      {
	        key: 'select',
	        ref: 'comboBox',
	        style: {
	          width: '100%',
	          height: '100%',
	          fontWeight: this.props.fontWeight,
	          color: this.props.color,
	          fontSize: this.props.fontSize,
	          fontFamily: this.props.fontFamily,
	          fontStyle: this.props.fontStyle,
	          textDecoration: this.props.textDecoration
	        }
	      },
	      React.createElement(
	        'div',
	        { ref: 'combobox',
	          style: {
	            width: '100%',
	            height: '100%',
	            left: 0,
	            top: 0,
	            position: 'absolute',
	            border: 'none',
	            //pointerEvents: 'none',
	            zIndex: 10,
	            textDecoration: 'inherit'
	          },
	          onClick: this.toggleSelectExpand
	        },
	        React.createElement('canvas', { style: { width: '100%', height: '100%' }, ref: 'ctx' }),
	        React.createElement(
	          'div',
	          { ref: 'txt', style: {
	              position: 'absolute',
	              height: '100%',
	              top: 0,
	              left: 5,
	              right: 28,
	              bottom: 0,
	              textDecoration: 'inherit',
	              fontWeight: this.props.fontWeight,
	              color: this.props.color,
	              fontSize: this.props.fontSize,
	              fontFamily: this.props.fontFamily,
	              fontStyle: this.props.fontStyle,
	              whiteSpace: 'nowrap',
	              overflow: 'hidden'
	            } },
	          React.createElement(
	            'div',
	            { style: textBoxStyle, ref: 'back' },
	            React.createElement(
	              'label',
	              null,
	              this.state.value
	            )
	          )
	        )
	      ),
	      this.props.canInput && React.createElement('input', { ref: 'input',
	        style: {
	          right: 26,
	          bottom: 1,
	          left: 1,
	          top: 1,
	          width: this.props.width - 30,
	          position: 'absolute',
	          zIndex: 20,
	          borderStyle: 'none',
	          borderColor: GlobalConst.GLOBAL_COLOR.TRANSPARENT_COLOR,
	          backgroundColor: this.props.backgroundColor,
	          textDecoration: 'inherit',
	          fontWeight: 'inherit',
	          color: 'inherit',
	          fontSize: 'inherit',
	          fontFamily: 'inherit',
	          fontStyle: 'inherit',
	          outline: 'none',
	          textIndent: 5
	        }
	        //onInput={this._onInput}
	      })
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doSelect(this.props.selectedIndex || 0);
	    this.doPaint();
	    $(ReactDOM.findDOMNode(this.refs.combobox)).css({ lineHeight: ReactDOM.findDOMNode(this).getBoundingClientRect().height + 'px' });
	    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_PAINT, this.onPaint);
	    $(ReactDOM.findDOMNode(this)).bind('toggleExpand', this.toggleSelectExpand);
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doPaint();
	  },
	
	  toggleSelectExpand: function toggleSelectExpand() {
	    //this.setState({isExpand: true});
	    var textPadding = parseInt(this.props.listControl.textPadding, 10) || 10;
	    var textStyle = {
	      width: parseInt(this.props.width, 10) - textPadding * 2,
	      fontWeight: this.props.fontWeight,
	      marginLeft: textPadding,
	      fontSize: this.props.fontSize + 'px',
	      fontFamily: this.props.fontFamily,
	      fontStyle: this.props.fontStyle,
	      textDecoration: this.props.textDecoration,
	      lineHeight: this.props.height + 'px'
	    };
	    var listStyle = {
	      selectedColor: this.props.listControl.selectedColor,
	      selectedTextColor: this.props.listControl.selectedTextColor || '#000000',
	      verticalScrollbarShow: this.props.listControl.verticalScrollbarShow,
	      verticalScrollbarProgress: this.props.listControl.verticalScrollbarProgress
	    };
	
	    var boxStyle = {
	      opacity: this.props.listControl.opacity
	    };
	    if (this.props.borderVisible) {
	      boxStyle.border = '1px solid ' + this.props.borderColor;
	    }
	    var props = {
	      checkedIndex: this.state.checkedIndex,
	      selectListItem: this.selectListItem,
	      width: this.props.width,
	      itemHeight: this.props.height,
	      textStyle: textStyle,
	      boxStyle: boxStyle,
	      listStyle: listStyle,
	      dataSet: this.items || this.props.items,
	      id: ReactDOM.findDOMNode(this).getAttribute('data-reactid')
	    };
	    if (this.props.triggerSelectExpand) {
	      this.props.triggerSelectExpand(ReactDOM.findDOMNode(this), props);
	    }
	  },
	
	  selectListItem: function selectListItem(e, index) {
	    this.doSelect(index);
	    if (this.props.onItemClick) {
	      this.props.onItemClick(e, index);
	    }
	  },
	
	  doPaint: function doPaint() {
	    var canvas = ReactDOM.findDOMNode(this.refs.ctx);
	
	    var g = canvas.getContext('2d');
	    var w = canvas.clientWidth;
	    var h = canvas.clientHeight;
	    var iconH = 4;
	    var iconW = 8;
	    var btnW = 24;
	    var thickness = 1;
	    var t;
	    canvas.width = w;
	    canvas.height = h;
	
	    g.clearRect(0, 0, w, h);
	    g.fillStyle = this.props.backgroundColor || '#fff';
	    g.strokeStyle = this.props.borderColor || '#444';
	    g.lineWidth = 1;
	    if (this.props.borderVisible) {
	      g.beginPath();
	      g.rect(thickness / 2, thickness / 2, w - thickness, h - thickness);
	      g.closePath();
	      g.fill();
	      g.stroke();
	    }
	    if (this.props.backgroundColor) {
	      g.fillStyle = this.props.backgroundColor;
	      g.beginPath();
	      g.rect(thickness, thickness, w - thickness * 2, h - thickness * 2);
	      g.closePath();
	      g.fill();
	    }
	    if (this.props.borderVisible) {
	      g.beginPath();
	      g.moveTo(w - btnW - thickness / 2, 0);
	      g.lineTo(w - btnW - thickness / 2, h);
	      g.closePath();
	      g.stroke();
	    }
	
	    g.beginPath();
	    g.fillStyle = '#444'; // g.strokeStyle;
	
	    t = Math.round((h - iconH) / 2);
	    g.moveTo(w - btnW + (btnW - iconW) / 2 - thickness / 2, t);
	    g.lineTo(w - (btnW - iconW) / 2 - thickness / 2, t);
	    g.lineTo(w - btnW / 2 - thickness / 2, t + iconH);
	    g.closePath();
	    g.fill();
	
	    $(ReactDOM.findDOMNode(this.refs.txt)).css({ lineHeight: h + 'px' });
	  },
	
	  getInitialState: function getInitialState() {
	    var value = '';
	    if (this.props.items && this.props.items[this.props.selectedIndex]) {
	      value = this.props.items[this.props.selectedIndex].text || '';
	    }
	    return {
	      value: value,
	      isExpand: false,
	      checkedIndex: 0,
	      items: JSON.parse(JSON.stringify(this.props.items))
	    };
	  },
	
	  onPaint: function onPaint() {
	    this.doPaint();
	  },
	
	  doSelect: function doSelect(index) {
	    var input;
	    var items = this.items || this.state.items;
	
	    var value;
	    if (index >= 0) {
	      value = items[index].text;
	    } else {
	      value = '';
	    }
	    if (this.props.canInput) {
	      input = ReactDOM.findDOMNode(this.refs.input);
	      input.value = value;
	    }
	    this.setState({ value: value, checkedIndex: index, isExpand: false });
	  },
	
	  items: null,
	  _onInput: function _onInput() {
	    var input = ReactDOM.findDOMNode(this.refs.input);
	    if (this.items === null) {
	      this.items = JSON.parse(JSON.stringify(this.state.items));
	    }
	    this.items[this.state.checkedIndex].text = input.value;
	    if (this.state.items) {
	      this.setState({ items: this.items });
	    }
	  }
	});
	
	module.exports = ComboBoxBase;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var runtimeHelper = __webpack_require__(47);
	var util = __webpack_require__(116);
	var VerticalScrollBar = __webpack_require__(178);
	
	var SelectComp = React.createClass({
	  displayName: 'SelectComp',
	
	  propTypes: {
	    checkedIndex: React.PropTypes.number.isRequired,
	    closeSelectList: React.PropTypes.func.isRequired,
	    selectListItem: React.PropTypes.func.isRequired,
	    textStyle: React.PropTypes.object.isRequired,
	    boxStyle: React.PropTypes.object.isRequired,
	    listStyle: React.PropTypes.object.isRequired,
	    dataSet: React.PropTypes.array.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      onItemIndex: this.props.checkedIndex
	    };
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.loadEvent();
	  },
	
	  domIndexArray: null,
	  componentDidMount: function componentDidMount() {
	    this.loadEvent();
	    //this.domIndexArray = util.pushToTop($('.component-SelectComp'));
	  },
	
	  domID: null,
	  loadEvent: function loadEvent() {
	    var context = this;
	    if (!document.onmouseup) {
	      document.onmouseup = function (event) {
	        //util.resetDomIndex(context.domIndexArray);
	        context.props.closeSelectList();
	        //context.domIndexArray = null;
	        document.onmouseup = null;
	      };
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    document.onmouseup = null;
	  },
	
	  render: function render() {
	    var self = this;
	    return React.createElement(
	      'div',
	      { className: 'component-SelectComp' },
	      React.createElement(
	        'div',
	        { style: this.props.boxStyle, className: 'select-item-box' },
	        this.props.dataSet.map(function (data, index) {
	          var itemStyle = {
	            width: this.props.width - 2,
	            height: this.props.itemHeight,
	            position: 'relative'
	          };
	          var textStyle = JSON.parse(JSON.stringify(self.props.textStyle));
	          textStyle.color = '#000000';
	          itemStyle.background = '#ffffff';
	          if (index === self.props.checkedIndex) {
	            //itemStyle.background = '#1E90FF';
	            itemStyle.background = this.props.listStyle.selectedColor || '#41C7D6';
	            textStyle.color = this.props.listStyle.selectedTextColor || '#000000';
	          }
	          return React.createElement(
	            'div',
	            { key: index,
	              style: itemStyle,
	              className: data.linkStyle
	            },
	            React.createElement('div', {
	              id: index,
	              className: 'select-item-cover'
	              //onMouseOver={this.onItem}
	              , onClick: this.checkItem }),
	            React.createElement(
	              'label',
	              { style: textStyle, className: 'select-item-text' },
	              data.text
	            )
	          );
	        }, this),
	        this.props.listStyle.verticalScrollbarShow && React.createElement(VerticalScrollBar, {
	          height: this.props.boxStyle.height - 2,
	          value: util.Int(this.props.listStyle.verticalScrollbarProgress)
	        })
	      )
	    );
	  },
	
	  checkItem: function checkItem(e) {
	    e.stopPropagation();
	    e.preventDefault();
	    e.nativeEvent.stopPropagation();
	    var index = parseInt($(e.target).attr('id'), 10) || 0;
	    this.props.selectListItem(e, index);
	  },
	  onItem: function onItem(e) {
	    var index = parseInt($(e.target).attr('id'), 10);
	    this.setState({ onItemIndex: index });
	  }
	});
	
	module.exports = SelectComp;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Dom = __webpack_require__(12);
	var assetsHelper = __webpack_require__(65);
	var GlobalConst = __webpack_require__(164);
	
	var VerticalScrollBar = React.createClass({
	  displayName: 'VerticalScrollBar',
	
	  propTypes: {
	    value: React.PropTypes.number.isRequired,
	    left: React.PropTypes.number,
	    top: React.PropTypes.number,
	    right: React.PropTypes.number,
	    bottom: React.PropTypes.number,
	    width: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
	    height: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
	    backgroundColor: React.PropTypes.string,
	    zIndex: React.PropTypes.number
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.repaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.repaint();
	  },
	
	  repaint: function repaint() {
	
	    var selfDom = Dom.findDOMNode(this);
	    var clientHeight = selfDom.clientHeight;
	    var clientWidth = selfDom.clientWidth;
	    var contentDom = Dom.findDOMNode(this.refs.content);
	
	    var length1 = 59;
	    var length2 = 21;
	    var barHeight;
	    var actualProgress;
	    var contentStyle;
	    var actualStyle;
	
	    barHeight = clientHeight * length2 / length1;
	    if (this.props.value == 100) {
	      actualProgress = clientHeight - barHeight - 13;
	    } else {
	      actualProgress = (clientHeight - 30 - barHeight) * (this.props.value / 100) + 15;
	    };
	
	    contentStyle = {
	      position: 'absolute',
	      left: '1px',
	      top: Math.round(actualProgress - 1) + 'px',
	      width: parseInt(clientWidth - 2, 10) + 'px',
	      height: Math.round(barHeight) + 'px',
	      backgroundColor: GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
	      border: 'none'
	    };
	
	    contentDom.style.left = contentStyle.left;
	    contentDom.style.top = contentStyle.top;
	    contentDom.style.width = contentStyle.width;
	    contentDom.style.height = contentStyle.height;
	  },
	
	  render: function render() {
	    var topBarStyle;
	    var bottomBarStyle;
	    var contentStyle;
	    var divStyle;
	
	    divStyle = {
	      position: 'absolute',
	      //left: this.props.left || '0px',
	      top: this.props.top || '0px',
	      right: this.props.right || '0px',
	      bottom: this.props.bottom || '0px',
	      width: this.props.width ? this.props.width + 'px' : '12px',
	      height: this.props.height ? this.props.height + 'px' : '100%',
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
	      backgroundColor: this.props.backgroundColor || GlobalConst.GLOBAL_COLOR.LIGHT_GRAY_COLOR,
	      zIndex: this.props.zIndex || undefined
	    };
	
	    topBarStyle = {
	      position: 'absolute',
	      left: '-1px',
	      top: '-1px',
	      width: this.props.width || '12px',
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
	    };
	
	    bottomBarStyle = {
	      position: 'absolute',
	      bottom: '-2px',
	      left: '-1px',
	      width: this.props.width || '12px',
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
	    };
	
	    contentStyle = {
	      position: 'absolute',
	      left: '2px',
	      top: '0px',
	      width: '0px',
	      height: '0px',
	      backgroundColor: GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
	      border: 'none'
	    };
	
	    return React.createElement(
	      'div',
	      { key: 'scrollBar', style: divStyle },
	      React.createElement('img', { style: topBarStyle, src: assetsHelper.getAsset('scrollbar/scrollbar-top.png') }),
	      React.createElement('img', { style: bottomBarStyle, src: assetsHelper.getAsset('scrollbar/scrollbar-bottom.png') }),
	      React.createElement('div', { ref: 'content', style: contentStyle })
	    );
	  }
	});
	
	module.exports = VerticalScrollBar;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ComboBoxBase = __webpack_require__(176);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	
	var ComboBox = React.createClass({
	  displayName: 'ComboBox',
	
	  parseText: function parseText() {
	    var arr = util.Text.delimitToParagraphs(this.props.text);
	    var i;
	    for (i = 0; i < arr.length; i++) {
	      arr[i] = util.Text.convertSpaceToNbsp(arr[i]);
	    }
	    return arr;
	  },
	
	  render: function render() {
	    var textItems = this.parseText();
	    var props = {
	      items: textItems,
	      borderColor: this.props.borderColor,
	      color: this.props.textColor,
	      backgroundColor: this.props.color,
	      fontSize: this.props.textSize,
	      fontFamily: this.props.textFontFamily,
	      selectedIndex: this.props.selectedIndex,
	      width: styleHelper.getWidth(this.props),
	      height: styleHelper.getHeight(this.props),
	      onItemClick: this.onItemClick
	    };
	    if (this.props.textStyles) {
	      props.fontWeight = this.props.textStyles.fontWeight;
	      props.fontStyle = this.props.textStyles.fontStyle;
	      props.textDecoration = this.props.textStyles.textDecoration;
	    }
	    return React.createElement(ComboBoxBase, props);
	  },
	  onItemClick: function onItemClick(e, index) {
	    this.props.events.doSelfClick(e, this.props, appTypes.ActionResponseType.LINK, index);
	  }
	});
	
	module.exports = ComboBox;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * 环形进度条组件
	 */
	
	var React = __webpack_require__(11);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var versionHelper = __webpack_require__(124);
	var graphicsHelper = __webpack_require__(172);
	
	var CircleProgressBar = React.createClass({
	  displayName: 'CircleProgressBar',
	
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.rePaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.rePaint();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  rePaint: function rePaint() {
	    var value;
	    var tw;
	    var x;
	    var textSize;
	    var y;
	    var w;
	    var h;
	    var thickness;
	    var trackColor;
	    var indicatorColor;
	    var value;
	
	    var self = this;
	
	    this.requestID = window.requestAnimationFrame(function () {
	      var canvas = ReactDOM.findDOMNode(self.refs.canvas);
	      if (!canvas) {
	        return;
	      }
	      w = styleHelper.getWidth(self.props);
	      h = styleHelper.getHeight(self.props);
	      thickness = styleHelper.getInt(self.props, propConst.THICKNESS);
	      trackColor = styleHelper.getPropertyValue(self.props, propConst.TRACK_COLOR);
	      indicatorColor = styleHelper.getPropertyValue(self.props, propConst.INDICATOR_COLOR);
	      value = styleHelper.getInt(self.props, propConst.PROGRESS) || styleHelper.getInt(self.props, propConst.VALUE);
	      var ctx = canvas.getContext('2d');
	      var ratio = graphicsHelper.applyDeviceRatio(ctx, w, h);
	      w *= ratio;
	      h *= ratio;
	      thickness *= ratio;
	      var cx = w / 2;
	      var cy = h / 2;
	      var r = (w - thickness) / 2;
	      //ctx.clearRect(0, 0, w, h);
	      graphicsHelper.clearRect(ctx);
	      ctx.beginPath();
	      ctx.arc(cx, cy, r, 0, Math.PI * 2);
	      ctx.closePath();
	      ctx.strokeStyle = trackColor;
	      ctx.lineCap = 'round';
	      ctx.lineWidth = thickness;
	      ctx.stroke();
	      ctx.beginPath();
	      ctx.strokeStyle = indicatorColor;
	      ctx.lineWidth = thickness;
	      ctx.lineCap = 'round';
	      ctx.arc(cx, cy, r, 0 - Math.PI / 2, Math.PI * (value / 100 * 2 - 0.5));
	      ctx.stroke();
	    });
	  },
	  render: function render() {
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var value = styleHelper.getInt(this.props, propConst.PROGRESS) || styleHelper.getInt(this.props, propConst.VALUE);
	    var textStyle = {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      lineHeight: h + 'px',
	      whiteSpace: 'nowrap'
	    };
	    styleHelper.builderTextStyle(this.props, textStyle);
	    if (versionHelper.isPageVersionLowerThan4_3()) {
	      textStyle.fontSize = Math.round(w * 0.215);
	    } else {
	      textStyle.fontSize = parseInt(this.props.textSize, 10);
	    }
	    return React.createElement(
	      'div',
	      { style: textStyle },
	      React.createElement('canvas', { ref: 'canvas',
	        style: {
	          left: 0,
	          top: 0,
	          width: '100%',
	          height: '100%',
	          position: 'absolute'
	        },
	        width: w,
	        height: h }),
	      React.createElement(
	        'label',
	        null,
	        value + '%'
	      )
	    );
	  }
	});
	
	module.exports = CircleProgressBar;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-4-1
	 @Descript : 内容面板组件
	 */
	var ContentPanel = React.createClass({
	  displayName: 'ContentPanel',
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  //记得补充透明度
	  render: function render() {
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var style = {
	      clip: 'rect(1 ' + (w - 1) + ' ' + (h - 1) + ' 1)',
	      border: 'none'
	      // visibility : styleHelper.getVisible(this)?'visible':'hidden'
	    };
	    styleHelper.StyleUtil(this.props).background().base().bounds().default(style);
	    return React.createElement(
	      'div',
	      {
	        className: "component component-" + this.props.controlTypeID,
	        key: this.props.controlID,
	        id: this.props.controlID,
	        style: style },
	      this.props.children
	    );
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.initSelected(this.props.currentIndex);
	    this.doBindEvent();
	  },
	
	  componentDidMount: function componentDidMount() {
	    var index = parseInt(styleHelper.getInt(this.props, propConst.SELECTED_INDEX), 10);
	    this.initSelected(index);
	    this.doBindEvent();
	
	    this.loadedInteractiveIndexArray = [];
	    this.loadedInteractiveIndexArray.push(index);
	  },
	
	  startLoadInteractive: function startLoadInteractive(index) {
	    if (this.props.events && this.props.events.startCompLoadInteractive && this.loadedInteractiveIndexArray.indexOf(index) === -1) {
	      this.loadedInteractiveIndexArray.push(index);
	      this.props.events.startCompLoadInteractive(this.props.items[index]);
	    }
	  },
	
	  doBindEvent: function doBindEvent() {
	    $(ReactDOM.findDOMNode(this)).off('onSwitch');
	    $(ReactDOM.findDOMNode(this)).on('onSwitch', this.onSwitch);
	  },
	
	  loadedInteractiveIndexArray: [],
	  onSwitch: function onSwitch(event, controlID, currentIndex, nextIndex, complete) {
	    var dom;
	    var targetDom;
	    var isReloadInteractive = false;
	    var currentDom;
	    var w;
	    var targetOption;
	    var currentOption;
	    var aniType;
	    var duration = 200;
	    var self = this;
	    var finish = function finish() {
	      if (complete) {
	        complete();
	      }
	      if (isReloadInteractive) {
	        //需要重新加载交互情况下执行下方
	        // $(currentDom).css({display: 'none', visibility: 'hidden'});
	        $(currentDom).css({ display: 'none' });
	        self.startLoadInteractive(nextIndex);
	      }
	    };
	    if (controlID === this.props.controlID) {
	
	      dom = ReactDOM.findDOMNode(this);
	      if (_.isUndefined(nextIndex) || _.isUndefined(currentIndex)) {
	        if (complete) {
	          complete();
	        }
	        return;
	      }
	      if (nextIndex > dom.children.length - 1) {
	        if (complete) {
	          complete();
	        }
	        return;
	      }
	      // targetDom = dom.children[nextIndex];
	      // currentDom = dom.children[currentIndex];
	      targetDom = document.getElementById('content-' + nextIndex);
	      currentDom = document.getElementById('content-' + currentIndex);
	      currentDom = dom.children[currentIndex];
	      if (currentIndex === nextIndex) {
	        finish();
	        return;
	      }
	      isReloadInteractive = true;
	      w = styleHelper.getWidth(this.props);
	      targetOption = {
	        queue: false,
	        duration: duration,
	        complete: finish
	      };
	      currentOption = {
	        queue: false,
	        duration: duration
	      };
	      aniType = styleHelper.getPropertyValue(this.props, propConst.ANI_TYPE);
	      switch (aniType) {
	        case appTypes.StackPanelAniType.FADE:
	          $(currentDom).css({ zIndex: 1 }).animate({ opacity: 0 }, currentOption);
	          $(targetDom).css({ opacity: 0, display: 'block', zIndex: 2 }).animate({ opacity: 1 }, targetOption);
	          break;
	        case appTypes.StackPanelAniType.PUSH:
	          $(currentDom).css({ zIndex: 1 }).animate({ left: -currentDom.clientWidth }, currentOption);
	          $(targetDom).css({ left: w, display: 'block', zIndex: 2 }).animate({ left: 0 }, targetOption);
	          break;
	        case appTypes.StackPanelAniType.SLIDE:
	          $(currentDom).css({ zIndex: 1 });
	          $(targetDom).css({ left: w, display: 'block', zIndex: 2 }).animate({ left: 0 }, targetOption);
	          break;
	        default:
	
	          $(targetDom).css({ display: 'block', zIndex: 1 });
	          finish();
	          break;
	      }
	    }
	  },
	
	  initSelected: function initSelected(selIndex) {
	    if (selIndex === undefined) {
	      return;
	    }
	    var dom = ReactDOM.findDOMNode(this);
	    var list = dom.children;
	    var i;
	    var display;
	    for (i = 0; i < list.length; i++) {
	      if (i === selIndex) {
	        display = 'block';
	      } else {
	        display = 'none';
	      }
	      $(list[i]).css({ display: display });
	    }
	  }
	});
	
	module.exports = ContentPanel;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var helper = __webpack_require__(155);
	var styleHelper = __webpack_require__(145);
	var appTypes = __webpack_require__(115);
	var convertHelper = __webpack_require__(146);
	var ScrollBar = __webpack_require__(183);
	var graphicsHelper = __webpack_require__(172);
	var VerticalScrollBar = __webpack_require__(178);
	var HorizontalScrollBar = __webpack_require__(184);
	var _ = __webpack_require__(51);
	
	var Canvas = React.createClass({
	  displayName: 'Canvas',
	
	
	  paint: function paint(props) {
	    if (this.props.isShow) {
	      var color = this.props.currentColor;
	      if (_.isUndefined(color)) {
	        color = this.props.color;
	      }
	      graphicsHelper.drawShpae(ReactDOM.findDOMNode(this.refs.canvas).getContext('2d'), {
	        width: this.currentW,
	        height: this.currentH,
	        borderType: this.props.shapeBorderType,
	        borderVisible: this.props.borderVisible,
	        borderColor: this.props.borderColor,
	        fillColor: color,
	        radius: parseInt(this.props.radius, 10),
	        borderWidth: parseInt(this.props.thickness, 10),
	        triangleType: this.props.triangleType,
	        borderLeft: this.props.rectangleBorderLeftVisible,
	        borderTop: this.props.rectangleBorderTopVisible,
	        borderRight: this.props.rectangleBorderRightVisible,
	        borderBottom: this.props.rectangleBorderBottomVisible
	      });
	    }
	  },
	
	  doAdjustLinkArea: function doAdjustLinkArea() {
	    var plink = $('#' + this.props.controlID + ' .page-link');
	    var interactiveLink = $('#' + this.props.controlID + ' .interactive-link');
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    if (plink) {
	      plink.css({
	        width: w,
	        height: h
	      });
	    }
	    if (interactiveLink) {
	      interactiveLink.css({
	        width: w,
	        height: h
	      });
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(props) {
	    this.paint(props);
	    this.doAdjustLinkArea();
	  },
	  componentDidMount: function componentDidMount(props) {
	    this.paint(props);
	  },
	
	  render: function render() {
	    this.currentW = styleHelper.getWidth(this.props);
	    this.currentH = styleHelper.getHeight(this.props);
	
	    var isShowScrollBar = this.props.shapeBorderType === appTypes.ShapeType.RECTANGLE && (this.props.verticalScrollbarShow || this.props.horizontalScrollbarShow);
	    var borderVisible = styleHelper.getPropertyValue(this.props, 'borderVisible');
	    var verticalScrollBarHeight;
	    var horizontalScrollBarWidth;
	    var thickness = borderVisible ? styleHelper.getBorderWidth(this.props) : 0;
	    if (isShowScrollBar) {
	      if (this.props.verticalScrollbarShow && this.props.horizontalScrollbarShow) {
	        verticalScrollBarHeight = this.currentH - 12 - 2 * thickness - 4;
	        horizontalScrollBarWidth = this.currentW - 12 - 2 * thickness - 4;
	      }
	    }
	    return React.createElement(
	      'div',
	      {
	        style: {
	          position: 'absolute',
	          width: '100%',
	          height: '100%',
	          left: 0,
	          top: 0
	        },
	        key: this.props.controlID + '-shape' },
	      React.createElement('canvas', {
	        ref: 'canvas',
	        style: {
	          position: 'absolute',
	          left: 0,
	          top: 0,
	          width: '100%',
	          height: '100%'
	        },
	        onChange: this.paint.bind(this, this.props),
	        width: this.currentW,
	        height: this.currentH }),
	      isShowScrollBar && this.props.horizontalScrollbarShow && React.createElement(HorizontalScrollBar, {
	        value: parseInt(this.props.verticalScrollbarProgress, 10),
	        width: horizontalScrollBarWidth
	      }),
	      isShowScrollBar && this.props.verticalScrollbarShow && React.createElement(VerticalScrollBar, {
	        value: parseInt(this.props.verticalScrollbarProgress, 10),
	        height: verticalScrollBarHeight
	      })
	    );
	  }
	});
	
	module.exports = Canvas;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var GlobalConst = __webpack_require__(164);
	
	var VerticalScrollBar = React.createClass({
	  displayName: 'VerticalScrollBar',
	
	  propTypes: {
	    size: React.PropTypes.object.isRequired,
	    value: React.PropTypes.number.isRequired
	  },
	
	  render: function render() {
	    var length1 = 59;
	    var length2 = 21;
	    var contentStyle;
	    var barHeight;
	    var actualProgress;
	    var style;
	    var topBarStyle;
	    var bottomBarStyle;
	
	    style = {
	      width: this.props.size.width,
	      height: this.props.size.height,
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
	      backgroundColor: this.props.backgroundColor
	    };
	
	    topBarStyle = {
	      position: 'absolute',
	      left: '0px',
	      top: '0px',
	      width: '12px',
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
	    };
	
	    bottomBarStyle = {
	      position: 'absolute',
	      bottom: '0px',
	      left: '0px',
	      width: '12px',
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
	    };
	
	    barHeight = this.props.size.height * length2 / length1;
	    if (this.props.value == 100) {
	      actualProgress = this.props.size.height - barHeight - 13;
	    } else {
	      actualProgress = (this.props.size.height - 30 - barHeight) * (this.props.value / 100) + 15;
	    }
	
	    contentStyle = {
	      position: 'absolute',
	      left: '2px',
	      top: actualProgress + 'px',
	      width: parseInt(this.props.size.width - 2, 10) + 'px',
	      height: barHeight,
	      backgroundColor: GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
	      border: 'none'
	    };
	
	    return React.createElement(
	      'div',
	      { style: style },
	      React.createElement('img', { style: topBarStyle, src: assetsHelper.getAsset('scrollbar/scrollbar-top.png') }),
	      React.createElement('img', { style: bottomBarStyle, src: assetsHelper.getAsset('scrollbar/scrollbar-bottom.png') }),
	      React.createElement('div', { style: contentStyle })
	    );
	  }
	});
	
	var HorizontalScrollBar = React.createClass({
	  displayName: 'HorizontalScrollBar',
	
	
	  propTypes: {
	    size: React.PropTypes.object.isRequired,
	    value: React.PropTypes.number.isRequired
	  },
	
	  render: function render() {
	    var style;
	    var leftBarStyle;
	    var rightBarStyle;
	    var contentStyle;
	    var barWidth;
	    var actualProgress;
	    var length1 = 59;
	    var length2 = 21;
	
	    style = {
	      width: this.props.size.width,
	      height: this.props.size.height,
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
	      backgroundColor: this.props.backgroundColor
	    };
	
	    leftBarStyle = {
	      position: 'absolute',
	      left: '0px',
	      top: '0px',
	      height: '12px',
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
	    };
	
	    rightBarStyle = {
	      position: 'absolute',
	      right: '0px',
	      top: '0px',
	      height: '12px',
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
	    };
	
	    barWidth = this.props.size.width * length2 / length1;
	    if (this.props.value == 100) {
	      actualProgress = this.props.size.width - barWidth - 13;
	    } else {
	      actualProgress = (this.props.size.width - 30 - barWidth) * (this.props.value / 100) + 15;
	    }
	
	    contentStyle = {
	      position: 'absolute',
	      top: '2px',
	      left: actualProgress + 'px',
	      width: barWidth + 'px',
	      height: parseInt(this.props.size.height - 2, 10) + 'px',
	      backgroundColor: GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
	      border: 'none'
	    };
	
	    return React.createElement(
	      'div',
	      { style: style },
	      React.createElement('img', { style: leftBarStyle, src: assetsHelper.getAsset('scrollbar/scrollbar-left.png') }),
	      React.createElement('img', { style: rightBarStyle, src: assetsHelper.getAsset('scrollbar/scrollbar-right.png') }),
	      React.createElement('div', { style: contentStyle })
	    );
	  }
	});
	
	/**
	 * 组件滚动条实现
	 */
	var ScrollBar = React.createClass({
	  displayName: 'ScrollBar',
	
	  propTypes: {
	    isHorizontal: React.PropTypes.bool.isRequired,
	    size: React.PropTypes.object.isRequired,
	    value: React.PropTypes.number.isRequired,
	    backgroundColor: React.PropTypes.string.isRequired
	  },
	
	  render: function render() {
	    var barSize = {
	      width: this.props.size.width - 2,
	      height: this.props.size.height - 2
	    };
	    var style = {
	      width: barSize.width,
	      height: barSize.height
	    };
	
	    if (this.props.isHorizontal) {
	      return React.createElement(HorizontalScrollBar, {
	        style: style,
	        size: barSize,
	        value: this.props.value,
	        backgroundColor: this.props.backgroundColor
	      });
	    }
	
	    return React.createElement(VerticalScrollBar, {
	      style: style,
	      size: barSize,
	      value: this.props.value,
	      backgroundColor: this.props.backgroundColor
	    });
	  },
	
	  getContentBound: function getContentBound() {}
	});
	
	module.exports = ScrollBar;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var Dom = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var GlobalConst = __webpack_require__(164);
	
	var HorizontalScrollBar = React.createClass({
	  displayName: 'HorizontalScrollBar',
	
	  propTypes: {
	    value: React.PropTypes.number.isRequired,
	    left: React.PropTypes.number,
	    top: React.PropTypes.number,
	    right: React.PropTypes.number,
	    bottom: React.PropTypes.number,
	    width: React.PropTypes.number,
	    height: React.PropTypes.number,
	    backgroundColor: React.PropTypes.string,
	    zIndex: React.PropTypes.number
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.repaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.repaint();
	  },
	
	  repaint: function repaint() {
	    var selfDom = Dom.findDOMNode(this);
	    var clientHeight = selfDom.clientHeight;
	    var clientWidth = selfDom.clientWidth;
	    var contentDom = Dom.findDOMNode(this.refs.content);
	
	    var barWidth;
	    var actualProgress;
	    var length1 = 59;
	    var length2 = 21;
	    var contentStyle;
	
	    barWidth = clientWidth * length2 / length1;
	    if (this.props.value == 100) {
	      actualProgress = clientWidth - barWidth - 13;
	    } else {
	      actualProgress = (clientWidth - 30 - barWidth) * (this.props.value / 100) + 15;
	    }
	
	    contentStyle = {
	      top: '1px',
	      left: Math.round(actualProgress - 1) + 'px',
	      width: Math.round(barWidth) + 'px',
	      height: parseInt(clientHeight - 2, 10) + 'px'
	    };
	
	    contentDom.style.left = contentStyle.left;
	    contentDom.style.top = contentStyle.top;
	    contentDom.style.width = contentStyle.width;
	    contentDom.style.height = contentStyle.height;
	  },
	
	  render: function render() {
	    var style;
	    var leftBarStyle;
	    var rightBarStyle;
	    var contentStyle;
	
	    style = {
	      position: 'absolute',
	      left: this.props.left || '0px',
	      //top: this.props.top || '0px',
	      bottom: this.props.bottom || '0px',
	      right: this.props.right || '0px',
	      width: this.props.width ? this.props.width + 'px' : '100%',
	      height: this.props.height ? this.props.height + 'px' : '12px',
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
	      backgroundColor: this.props.backgroundColor || GlobalConst.GLOBAL_COLOR.LIGHT_GRAY_COLOR,
	      zIndex: this.props.zIndex || undefined
	    };
	
	    leftBarStyle = {
	      position: 'absolute',
	      left: '-1px',
	      top: '-1px',
	      height: this.props.height || '12px',
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
	    };
	
	    rightBarStyle = {
	      position: 'absolute',
	      right: '-1px',
	      top: '-1px',
	      height: this.props.height || '12px',
	      border: '1px solid ' + GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR
	    };
	
	    contentStyle = {
	      position: 'absolute',
	      top: '2px',
	      left: '0px',
	      width: '0px',
	      height: '0px',
	      backgroundColor: GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR,
	      border: 'none'
	    };
	
	    return React.createElement(
	      'div',
	      { style: style },
	      React.createElement('img', { style: leftBarStyle, src: assetsHelper.getAsset('scrollbar/scrollbar-left.png') }),
	      React.createElement('img', { style: rightBarStyle, src: assetsHelper.getAsset('scrollbar/scrollbar-right.png') }),
	      React.createElement('div', { ref: 'content', style: contentStyle })
	    );
	  }
	});
	
	module.exports = HorizontalScrollBar;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var _ = __webpack_require__(51);
	var styleHelper = __webpack_require__(145);
	var PathData = __webpack_require__(186);
	var graphicsHelper = __webpack_require__(172);
	/*
	 * 涂鸦板组件
	 */
	var Graffiti = React.createClass({
	  displayName: 'Graffiti',
	
	
	  // TODO: 该组件还存在一些绘制问题，需要重新对坐标点进行计算。
	
	  render: function render() {
	    var boxStyle = {
	      width: styleHelper.getWidth(this.props),
	      height: styleHelper.getHeight(this.props),
	      overflow: 'hidden'
	    };
	    return React.createElement(
	      'div',
	      { style: boxStyle },
	      React.createElement('canvas', {
	        ref: 'canvas',
	        style: {
	          width: '100%',
	          height: '100%'
	        },
	        width: styleHelper.getWidth(this.props),
	        height: styleHelper.getHeight(this.props)
	      })
	    );
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.paint();
	  },
	  componentDidMount: function componentDidMount() {
	    this.pathData = new PathData();
	    this.pathData.parseData(this.props.pointList);
	    var bound = this.pathData.getBounds();
	    var dom = ReactDOM.findDOMNode(this.refs.canvas);
	    var w = Math.max(bound.width, styleHelper.getWidth(this.props));
	    var h = Math.max(bound.height, styleHelper.getHeight(this.props));
	    //$(dom).css({left : 0,top:0,width:w,height:h});
	    dom.width = w;
	    dom.height = h;
	    this.paint();
	  },
	
	  paint: function paint() {
	    var params = {
	      thickness: this.props.strokeThickness,
	      borderColor: styleHelper.getBackgroundColor(this.props)
	    };
	    var ctx = ReactDOM.findDOMNode(this.refs.canvas).getContext('2d');
	    var ratio = graphicsHelper.applyDeviceRatio(ctx, styleHelper.getWidth(this.props), styleHelper.getHeight(this.props));
	    graphicsHelper.drawPath(ctx, this.pathData, params, ratio);
	  }
	
	});
	
	module.exports = Graffiti;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Created by lovely on 2016/8/29.
	 */
	
	var _ = __webpack_require__(51);
	
	module.exports = function () {
	  var points;
	
	  this.parseData = function (pointList) {
	    var p;
	    var ps;
	    var i = 0;
	    var l;
	    var s;
	    points = [];
	    if (!_.isEmpty(pointList)) {
	      ps = pointList.replace(/\(/g, '').replace(/\)/g, '').split('|');
	      l = ps.length;
	      for (i; i < l; i++) {
	        s = ps[i].split(',');
	        p = { x: parseInt(s[0], 10), y: parseInt(s[1], 10) };
	        if (parseInt(s[2]) === 1) {
	          p.t = 'M';
	        } else {
	          p.t = 'L';
	        }
	        points.push(p);
	      }
	    }
	  };
	
	  this.getBounds = function () {
	    var i = 0;
	    var l = points.length;
	    var x, y, r, b;
	    var p;
	    var bound = {};
	    if (points.length) {
	      p = points[0];
	      x = p.x;
	      y = p.y;
	      r = x;
	      b = y;
	      for (i = 1; i < l; i++) {
	        p = points[i];
	        x = Math.min(x, p.x);
	        y = Math.min(y, p.y);
	        r = Math.max(r, p.x);
	        b = Math.max(b, p.y);
	      }
	    }
	    bound.left = x;
	    bound.top = y;
	    bound.right = r;
	    bound.bottom = b;
	    bound.width = r - x;
	    bound.height = b - y;
	    return bound;
	  };
	
	  this.data = function () {
	    return points;
	  };
	};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-3-31
	 @Descript : 分组框组件
	 */
	var GroupBox = React.createClass({
	  displayName: 'GroupBox',
	
	  getInitialState: function getInitialState() {
	    return {
	      x: parseInt(this.props.x, 10)
	    };
	  },
	  render: function render() {
	    var style = {
	      width: styleHelper.getWidth(this.props),
	      height: styleHelper.getHeight(this.props),
	      border: 'none',
	      pointerEvent: 'none',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap',
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      boxSizing: 'border-box'
	    };
	
	    var tx = styleHelper.getText(this.props);
	    if (!tx.trim()) {
	      tx = '\xA0';
	    }
	    styleHelper.StyleUtil(this.props, style).text();
	    return React.createElement(
	      'div',
	      { style: style },
	      React.createElement('canvas', { ref: 'ctx', width: style.width, height: style.height,
	        style: { width: '100%', height: '100%', left: 0, top: 0, position: 'absolute', zIndex: 0 } }),
	      React.createElement(
	        'label',
	        { ref: 'tx', style: {
	            left: 20,
	            top: 0,
	            zIndex: 1,
	            textDecoration: 'inherit',
	            position: 'absolute'
	          } },
	        tx
	      )
	    );
	  },
	
	  doAdjustStyle: function doAdjustStyle() {
	    var ctx = ReactDOM.findDOMNode(this.refs.ctx);
	    var g = ctx.getContext('2d');
	    var thickness = 1;
	    var label = ReactDOM.findDOMNode(this.refs.tx);
	    var top = Math.round(label.clientHeight / 2) - thickness / 2;
	    var tw = label.clientWidth;
	    var tx = label.offsetLeft - 2;
	    var tr = Math.min(styleHelper.getWidth(this.props) - thickness / 2, tw + tx) + 4;
	    var left = thickness / 2;
	    var right = styleHelper.getWidth(this.props) - thickness / 2;
	    var bottom = styleHelper.getHeight(this.props) - thickness / 2;
	    var ratio = graphicsHelper.applyDeviceRatio(g, styleHelper.getWidth(this.props), styleHelper.getHeight(this.props));
	
	    thickness *= ratio;
	    tw *= ratio;
	    tx *= ratio;
	    tr *= ratio;
	    left *= ratio;
	    right *= ratio;
	    bottom *= ratio;
	    top *= ratio;
	
	    g.clearRect(0, 0, ctx.width, ctx.height);
	    g.lineWidth = thickness;
	    g.strokeStyle = styleHelper.getBorderColor(this.props) || '#ddd';
	    g.fillStyle = styleHelper.getBackgroundColor(this.props);
	    g.beginPath();
	    g.rect(0, top, ctx.width, ctx.height - top);
	    g.closePath();
	    g.fill();
	
	    g.beginPath();
	    g.moveTo(tx, top);
	    g.lineTo(left, top);
	    g.lineTo(left, bottom);
	    g.lineTo(right, bottom);
	    g.lineTo(right, top);
	    g.lineTo(tr, top);
	    g.stroke();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doAdjustStyle();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doAdjustStyle();
	  }
	});
	
	module.exports = GroupBox;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-3-31
	 @Descript : 热区组件
	 */
	var HotSpot = React.createClass({
	  displayName: 'HotSpot',
	
	
	  render: function render() {
	    return React.createElement('div', { className: 'component-HotSport' });
	  }
	});
	
	module.exports = HotSpot;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var i18n = __webpack_require__(46);
	var propConst = __webpack_require__(147);
	var appType = __webpack_require__(115);
	var projectLoadHelper = __webpack_require__(68);
	var graphicsHelper = __webpack_require__(172);
	var _ = __webpack_require__(51);
	var util = __webpack_require__(116);
	
	/**
	 * Image2
	 * @author mxj
	 * @createDate 2016/9/22
	 **/
	
	var Image = React.createClass({
	  displayName: 'Image',
	
	
	  propTypes: {},
	
	  src: undefined,
	
	  isWrapCanvas: true,
	  render: function render() {
	    /*
	     1、计算出图片摆正时的宽高，然后所有组件默认都以这个尺寸时行显示绘制
	     2、根据当前旋转角度，翻转方向计算出transform，并施加到此组件的 border 上
	     */
	    var style = {
	      left: 0,
	      top: 0
	    };
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var defaultRotateAngle = styleHelper.getOriginalProperty(this.props, propConst.ROTATION_ANGLE);
	    // var rotateAngle = styleHelper.getStateProperty(this.props, propConst.ROTATION_ANGLE);
	    var rotateAngle = styleHelper.getPropertyValue(this.props, propConst.ROTATION_ANGLE);
	    var defaultW = w;
	    var defaultH = h;
	    var flipHorizontal = styleHelper.getPropertyValue(this.props, propConst.FLIP_HORIZONTAL);
	    var flipVertical = styleHelper.getPropertyValue(this.props, propConst.FLIP_VERTICAL);
	    var rx = 0;
	    var ry = 0;
	    var rz = 0;
	    var offset;
	    var transform;
	    var transformOrigin;
	    var rotate3D;
	    var translate;
	    var src;
	    var url = styleHelper.getPropertyValue(this.props, propConst.URL);
	    var canvasStyle = {};
	    if (this.props.radiusIsPercent) {
	      canvasStyle.borderRadius = parseInt(this.props.radius, 10) / 2 + '%';
	    } else {
	      canvasStyle.borderRadius = this.props.radius;
	    }
	
	    this.isEmptyImage = _.isEmpty(url);
	
	    if (!this.isEmptyImage) {
	      if (!this.src) {
	        this.src = src = projectLoadHelper.loadImage(url);
	      } else {
	        src = this.src;
	      }
	    }
	    offset = (defaultH - defaultW) / 2;
	    if (defaultRotateAngle === appType.RotationAngle.NINETY || defaultRotateAngle === appType.RotationAngle.TWO_HUNDRED_SEVENTY) {
	      defaultW = h;
	      defaultH = w;
	    }
	
	    style.width = defaultW;
	    style.height = defaultH;
	
	    if (!rotateAngle || rotateAngle === appType.RotationAngle.ZERO) {
	      switch (defaultRotateAngle) {
	        case appType.RotationAngle.NINETY:
	          transform = 'rotate(90deg)';
	          translate = 'translate(' + offset + 'px, ' + offset + 'px)';
	          break;
	        case appType.RotationAngle.ONE_HUNDRED_EIGHTY:
	          transform = 'rotate(180deg)';
	          translate = '';
	          break;
	        case appType.RotationAngle.TWO_HUNDRED_SEVENTY:
	          transform = 'rotate(270deg)';
	          translate = 'translate(' + -offset + 'px,' + -offset + 'px)';
	          break;
	      }
	      if (!rotateAngle || rotateAngle !== defaultRotateAngle) {
	        if (transform) {
	          transform += ' ' + translate;
	        }
	      }
	    } else {
	      switch (rotateAngle) {
	        case appType.RotationAngle.NINETY:
	          transform = 'rotate(90deg)';
	          translate = 'translate(' + offset + 'px,' + offset + 'px)';
	          break;
	        case appType.RotationAngle.ONE_HUNDRED_EIGHTY:
	          transform = 'rotate(180deg)';
	          translate = '';
	          break;
	        case appType.RotationAngle.TWO_HUNDRED_SEVENTY:
	          transform = 'rotate(270deg)';
	          translate = 'translate(' + -offset + 'px,' + -offset + 'px)';
	          break;
	      }
	      if (defaultRotateAngle) {
	        if (transform && translate) {
	          if (rotateAngle === defaultRotateAngle) transform += ' ' + translate;
	        }
	      }
	    }
	    if (flipHorizontal) {
	      ry = 1;
	    }
	    if (flipVertical) {
	      rx = 1;
	    }
	    if (flipHorizontal && flipVertical) {
	      rz = 1;
	      rx = ry = 0;
	    }
	
	    if (rx || ry || rz) {
	      rotate3D = 'rotate3D(' + [rx, ry, rz, '180deg'].join(',') + ')';
	      //if (transform) {
	      //  transform += (' ' + rotate3D);
	      //} else {
	      //  transform = rotate3D;
	      //}
	      canvasStyle.transformOrigin = 'center center';
	      canvasStyle.transform = rotate3D;
	    }
	
	    if (!_.isUndefined(transform)) {
	      style.transform = transform;
	      transformOrigin = 'center center';
	      style.transformOrigin = transformOrigin;
	    }
	
	    if (this.props.clipShapeType === "SbRectangle" && this.props.fitMode === "fmStretch" && this.props.radius === 0 && this.props.flipHorizontal === false && this.props.flipVertical === false) {
	      if ((defaultW > 1000 || defaultH > 1000) && !this.isEmptyImage) {
	        this.isWrapCanvas = false;
	        style.visibility = "visible";
	        return React.createElement('img', { ref: 'img', style: style, src: src });
	      }
	    }
	    this.isWrapCanvas = true;
	    return React.createElement(
	      'div',
	      { ref: 'border', className: 'border', style: style },
	      React.createElement(
	        'canvas',
	        { ref: 'ctx', width: defaultW, height: defaultH, style: canvasStyle },
	        !this.isEmptyImage && React.createElement('img', { ref: 'img', onLoad: this._onImageLoaded, src: src })
	      )
	    );
	  },
	
	  _onImageLoaded: function _onImageLoaded(e) {
	    this.imageLoaded = true;
	    this.doPaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doPaint();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doPaint();
	  },
	
	  paintEmpty: function paintEmpty(canvas) {
	    var g = canvas.getContext('2d');
	    var w = canvas.width;
	    var h = canvas.height;
	    var caption = styleHelper.getPropertyValue(this.props, propConst.CAPTION) || i18n.get('IMAGE');
	    g.clearRect(0, 0, w, h);
	    g.beginPath();
	    g.strokeStyle = '#444';
	
	    g.fillStyle = '#fff';
	    g.lineWidth = 1;
	
	    var shapeType = styleHelper.getPropertyValue(this.props, 'clipShapeType');
	    if (shapeType === 'SbEllipse') {
	      graphicsHelper.drawEllipse(g, w, h, '#444');
	    } else {
	      g.rect(0.5, 0.5, w - 1, h - 1);
	      g.closePath();
	
	      g.fill();
	      g.stroke();
	    }
	
	    var xLinePadding = 2;
	    var yLinePadding = 2;
	    if (shapeType === 'SbEllipse') {
	      xLinePadding = Math.round(w * 0.2);
	      yLinePadding = Math.round(h * 0.2);
	    }
	    g.moveTo(xLinePadding, yLinePadding);
	    g.lineTo(w - xLinePadding, h - yLinePadding);
	    g.moveTo(xLinePadding, h - yLinePadding);
	    g.lineTo(w - xLinePadding, yLinePadding);
	    g.stroke();
	
	    if (this.props.showText) {
	      var bgSize = 28;
	      var captionSize = g.measureText(caption);
	      var fontSize = 12;
	      if (captionSize.width + 8 < w && fontSize + 5 < h) {
	        g.fillRect(w / 2 - bgSize / 2, h / 2 - bgSize / 2, bgSize, bgSize);
	        g.font = fontSize + 'px Arial';
	        g.fillStyle = '#000';
	        g.fillText(caption, w / 2 - captionSize.width / 2, h / 2 + fontSize / 2);
	      }
	    }
	  },
	
	  doPaint: function doPaint() {
	    if (!this.isWrapCanvas) {
	      return;
	    }
	    var canvas = ReactDOM.findDOMNode(this.refs.ctx);
	    var img;
	    if (this.isEmptyImage) {
	      this.paintEmpty(canvas);
	    } else {
	      img = ReactDOM.findDOMNode(this.refs.img);
	      this.paintImage(canvas, img);
	    }
	  },
	
	  paintImage: function paintImage(canvas, img) {
	    var g = canvas.getContext('2d');
	    //var w = canvas.width;
	    //var h = canvas.height;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var filterType = styleHelper.getPropertyValue(this.props, propConst.FILTER_TYPE);
	    var shapeType = styleHelper.getPropertyValue(this.props, propConst.CLIP_SHAPE_TYPE);
	    var radius = styleHelper.getRadius(this.props);
	    var filterValue;
	
	    var self = this;
	    if (!this.imageLoaded) {
	      return;
	    }
	    if (filterType === appType.ImageFilter.PENCIL) {
	      filterValue = styleHelper.getInt(this.props, propConst.FILTER_PENCIL_VALUE);
	    } else if (filterType === appType.ImageFilter.SKETCH) {
	      filterValue = styleHelper.getInt(this.props, propConst.FILTER_SKETCH_VALUE);
	    }
	
	    graphicsHelper.drawFilterImage(g, img, {
	      left: 0,
	      top: 0,
	      right: w,
	      bottom: h
	    }, this.props.fitMode, {
	      // filterType: filterType,
	      // filterValue: filterValue
	    }, {
	      shapeType: shapeType,
	      radius: radius,
	      borderVisible: styleHelper.getBorderVisible(this.props)
	    }, function () {
	      if (filterType !== appType.ImageFilter.NONE) {
	        // canvas.className = 'grayImage';
	      }
	    });
	  },
	
	  doClipErrorImage: function doClipErrorImage() {
	    var border = ReactDOM.findDOMNode(this.refs.border);
	    var shapeType = styleHelper.getPropertyValue(this.props, propConst.CLIP_SHAPE_TYPE);
	    var radius = styleHelper.getRadius(this.props);
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var style;
	    if (shapeType === appType.ShapeType.RECTANGLE) {
	      style = {
	        'border-radius': radius + 'px',
	        'border': '0px solid'
	      };
	    } else if (shapeType === appType.ShapeType.ELLIPSE) {
	      style = {
	        'border': '0px solid',
	        'border-top-left-radius': w / 2 + 'px ' + h / 2 + 'px'
	      };
	      style['border-top-right-radius'] = style['border-bottom-left-radius'] = style['border-bottom-right-radius'] = style['border-top-left-radius'];
	    }
	    if (style) {
	      $(border).css(style);
	    }
	  } /*,
	      doClipErrorImage : function(){
	    var border = ReactDOM.findDOMNode(this.refs.border);
	    var shapeType = styleHelper.getPropertyValue(this.props, propConst.CLIP_SHAPE_TYPE);
	    var radius = styleHelper.getRadius(this.props);
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var style;
	    if(shapeType === appType.ShapeType.RECTANGLE){
	    style = {
	    'border-radius' : radius + 'px',
	    'border' : '0px solid'
	    }
	    }else if(shapeType === appType.ShapeType.ELLIPSE){
	    style={
	    'border' : '0px solid',
	    'border-top-left-radius' : w/2 + 'px ' + h/2 + 'px'
	    };
	    style['border-top-right-radius'] = style['border-bottom-left-radius'] = style['border-bottom-right-radius'] = style['border-top-left-radius'];
	    }
	    if(style){
	    $(border).css(style)
	    }
	    }*/
	});
	
	module.exports = Image;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var projectLoadHelper = __webpack_require__(68);
	var appTypes = __webpack_require__(115);
	var util = __webpack_require__(116);
	var styleHelper = __webpack_require__(145);
	
	/**
	 @Author : mengxiaojiang
	 @CreateDate :
	 @Descriptor : 图片轮播组件中的各个图片层
	 */
	var ImageBackground = React.createClass({
	  displayName: 'ImageBackground',
	
	
	  render: function render() {
	    var c = this.props.color;
	    //if(util.Color.toRGBA(c).a === 0){
	    //  c = '#fff'
	    //}
	    return React.createElement(
	      'div',
	      { key: this.props.controlID, className: 'imgBackground', style: { backgroundColor: c } },
	      React.createElement('img', {
	        ref: 'img',
	        id: this.props.controlID + '-image',
	        src: projectLoadHelper.loadImage(this.props.URL),
	        onLoad: this.onAdjustImgBoundsWithLoad
	      }),
	      React.createElement('canvas', { ref: 'noImg', style: { width: '100%', height: '100%', position: 'absolute' } })
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doDrawEmptyImg();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.onAdjustImgBoundsWithLoad();
	  },
	
	  doDrawEmptyImg: function doDrawEmptyImg() {
	    var ctx = ReactDOM.findDOMNode(this.refs.noImg);
	    var g = ctx.getContext('2d');
	    ctx.width = ctx.clientWidth;
	    ctx.height = ctx.clientHeight;
	    g.lineWidth = 1;
	    g.strokeStyle = '#000';
	    g.fillStyle = '#fff';
	    g.strokeWidth = 1;
	    g.rect(0.5, 0.5, ctx.width - 1, ctx.height - 1);
	    g.fill();
	    g.moveTo(5, 5);
	    g.lineTo(ctx.width - 5, ctx.height - 5);
	    g.moveTo(5, ctx.height - 5);
	    g.lineTo(ctx.width - 5, 5);
	    g.stroke();
	  },
	
	  imgSize: undefined,
	  /**
	   * 图片加载完成后，根据布局模式调整图片的区域
	   */
	  onAdjustImgBoundsWithLoad: function onAdjustImgBoundsWithLoad() {
	    var fitMode = this.props.fitMode;
	    var img = ReactDOM.findDOMNode(this.refs.img);
	    var imgW;
	    var imgH;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var sx = 1;
	    var sy = 1;
	    var sw;
	    var sh;
	    var left;
	    var top;
	    if (img) {
	      $(ReactDOM.findDOMNode(this.refs.noImg)).css({ visibility: 'hidden' });
	      if (this.imgSize && this.imgSize.width !== 0 && this.imgSize.height !== 0) {
	        imgW = this.imgSize.width;
	        imgH = this.imgSize.height;
	      } else {
	        imgW = img.clientWidth;
	        imgH = img.clientHeight;
	        this.imgSize = {
	          width: imgW,
	          height: imgH
	        };
	      }
	
	      if (imgW !== 0) {
	        sx = w / imgW;
	      }
	      if (imgH !== 0) {
	        sy = h / imgH;
	      }
	
	      if (!imgW) {
	        imgW = w;
	      }
	      if (!imgH) {
	        imgH = h;
	      }
	      if (fitMode === appTypes.ImageCarouselFitMode.AUTO) {
	        sx = Math.max(sx, sy);
	        sy = Math.max(sx, sy);
	      }
	      sw = imgW * sx;
	      sh = imgH * sy;
	      left = (w - sw) / 2;
	      top = (h - sh) / 2;
	      $(img).css({
	        width: sw,
	        height: sh,
	        left: left,
	        top: top
	      });
	    }
	  }
	});
	
	module.exports = ImageBackground;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-4-1
	 @Descript : 图片轮播组件
	 */
	var ImageCarousel = React.createClass({
	  displayName: 'ImageCarousel',
	
	  render: function render() {
	    var indicatorCss = this.initIndicatorCss();
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var borderColor = styleHelper.getBorderColor(this.props);
	    var bgColor = styleHelper.getBackgroundColor(this.props);
	    return React.createElement(
	      'div',
	      {
	        key: '_',
	        className: 'component-ImageCarousel',
	        style: {
	          width: w,
	          height: h,
	          borderColor: borderColor,
	          borderWidth: 1,
	          clip: 'rect(0 0 ' + w + ' ' + h + ')',
	          overflow: 'hidden',
	          borderStyle: this.props.borderVisible ? 'solid' : 'none',
	          backgroundColor: bgColor,
	          position: 'relative'
	        } },
	      this.props.children,
	      !this.props.items && React.createElement('canvas', { ref: 'canvas', width: w, height: h }),
	      this.props.isShowIndicator && React.createElement(
	        'div',
	        { ref: 'indicatorLayer', className: 'indicator', style: { zIndex: 20 } },
	        React.createElement(
	          'ul',
	          { style: indicatorCss.ul },
	          this.props.items && this.props.items.map(function (itm, index) {
	            return React.createElement(
	              'li',
	              { key: index, id: this.props.controlID + '-' + index,
	                style: indicatorCss.li,
	                onClick: this.onIndicatorClick.bind(this, index) },
	              this.props.indicatorType === 'SiNumber' ? index + 1 : ''
	            );
	          }, this)
	        )
	      ),
	      this.props.isShowIndicator && React.createElement('div', { ref: '_left',
	        className: 'go-left',
	        style: { top: this.props.h / 2 - 15 },
	        onClick: this._onSkipClick.bind(this, -1),
	        onMouseOver: this._onMouseOver.bind(this, 0),
	        onMouseOut: this._onMouseOut.bind(this, 0) }),
	      this.props.isShowIndicator && React.createElement('div', { ref: '_right',
	        className: 'go-right',
	        style: {
	          top: this.props.h / 2 - 15 },
	        onClick: this._onSkipClick.bind(this, 1),
	        onMouseOver: this._onMouseOver.bind(this, 1),
	        onMouseOut: this._onMouseOut.bind(this, 1) })
	    );
	  },
	
	  _onMouseOver: function _onMouseOver(value) {
	    var dom;
	    if (value) {
	      dom = $(ReactDOM.findDOMNode(this.refs._right));
	    } else {
	      dom = $(ReactDOM.findDOMNode(this.refs._left));
	    }
	    dom.animate({ opacity: 1 });
	  },
	
	  _onMouseOut: function _onMouseOut(value) {
	    var dom;
	    if (value) {
	      dom = $(ReactDOM.findDOMNode(this.refs._right));
	    } else {
	      dom = $(ReactDOM.findDOMNode(this.refs._left));
	    }
	    dom.animate({ opacity: 0 });
	  },
	
	  _onSkipClick: function _onSkipClick(value) {
	    var index = this.currentIndex + value;
	    if (index >= this.imgs.length || index < 0) {
	      return;
	    }
	    clearTimeout(this.timeOut);
	    this.skipTo(index);
	  },
	
	  initIndicatorCss: function initIndicatorCss() {
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var Direction = appTypes.CarouselIndicatorDirection;
	    var indicatorDirection = this.props.indicatorDirection;
	    var indicatorType = this.props.indicatorType;
	    var size = 12;
	    var float = indicatorDirection === Direction.TOP || indicatorDirection === Direction.BOTTOM ? 'left' : 'none';
	    var color = '#000000';
	    var bgColor = this.props.indicatorColor;
	    var radius = indicatorType === appTypes.CarouselIndicatorType.CIRCLE ? '50%' : 0;
	    var listStyle = 'none';
	    var height = indicatorDirection === Direction.LEFT || indicatorDirection === Direction.RIGHT ? h : size;
	    var width = indicatorDirection === Direction.LEFT || indicatorDirection === Direction.RIGHT ? size + 4 : w;
	    var top = indicatorDirection === Direction.LEFT || indicatorDirection === Direction.RIGHT ? (h - height) / 2 : indicatorDirection === Direction.TOP ? 10 : h - 10 - size;
	    var left = indicatorDirection === Direction.TOP || indicatorDirection === Direction.BOTTOM ? (w - width) / 2 : indicatorDirection === Direction.LEFT ? 10 : w - 10 - size;
	    var mh = indicatorDirection === Direction.TOP || indicatorDirection === Direction.BOTTOM ? 3 : 0;
	    var mv = indicatorDirection === Direction.TOP || indicatorDirection === Direction.BOTTOM ? 0 : 3;
	
	    var pt = 0;
	    if (indicatorDirection === Direction.LEFT || indicatorDirection === Direction.RIGHT) {
	      height = this.props.items ? this.props.items.length * (size + 4 + mv * 2) + mv * 2 : size;
	      top = (h - height) / 2;
	    }
	
	    var lineHeight = size + 'px';
	    var liCss = {
	      width: size,
	      height: size,
	      backgroundColor: bgColor,
	      borderRadius: radius,
	      borderStyle: 'solid',
	      borderWidth: 2,
	      marginLeft: mh,
	      marginRight: mh,
	      marginTop: mv,
	      marginBottom: mv,
	      lineHeight: lineHeight,
	      listStyle: listStyle,
	      display: 'inline-block',
	      textAlign: 'center',
	      overflow: 'hidden'
	    };
	    var ulCss = {
	      left: left,
	      top: top,
	      width: width,
	      height: height,
	      textAlign: 'center',
	      color: color,
	      fontSize: 10,
	      listStyle: listStyle,
	      float: float,
	      margin: 0,
	      padding: 0,
	      position: 'absolute'
	    };
	
	    return {
	      ul: ulCss,
	      li: liCss
	    };
	  },
	
	  initSelLayer: function initSelLayer() {
	    var index = parseInt(this.props.selectedIndex);
	    var i;
	    if (index < this.imgs.length) {
	      for (i = 0; i < this.imgs.length; i++) {
	        if (i === index) {
	          $(this.imgs[i]).css({ visibility: 'visible' });
	        } else {
	          $(this.imgs[i]).css({ visibility: 'hidden' });
	        }
	      }
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.resetCurrentIndex();
	    if (this.timeOut) {
	      clearTimeout(this.timeOut);
	    }
	    var i;
	    var dom;
	    this.imgs = [];
	    if (this.props.items) {
	      $(ReactDOM.findDOMNode(this.refs.indicatorLayer)).show();
	      for (i = 0; i < this.props.items.length; i++) {
	        dom = $('#' + this.props.items[i].controlID);
	        dom.css({ zIndex: 0 });
	        this.imgs.push(dom);
	      }
	      if (this.currentIndex < this.imgs.length) {
	        dom = this.imgs[this.currentIndex];
	      } else {
	        dom = this.imgs[0];
	      }
	      if (dom) {
	        dom.css({ zIndex: 1 });
	      }
	      this.initSelLayer();
	      this.refreshIndicator();
	      this.autoPlay();
	    } else {
	      $(ReactDOM.findDOMNode(this.refs.indicatorLayer)).hide();
	      this.paintEmptyItem();
	    }
	    this.loadedCount = 0;
	  },
	
	  loadedCount: 0,
	
	  onItemLoaded: function onItemLoaded() {
	    this.loadedCount++;
	    if (this.loadedCount && this.loadedCount === this.props.items.length) {
	      //this.refreshIndicator();
	      //this.autoPlay();
	    }
	  },
	
	  resetCurrentIndex: function resetCurrentIndex() {
	    this.currentIndex = parseInt(this.props.selectedIndex, 10);
	  },
	
	  paintEmptyItem: function paintEmptyItem() {
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    var graphics;
	    var self = this;
	    var cx = this.props.w / 2;
	    var cy = this.props.h - 15;
	    var r = 8;
	    var w;
	    var h;
	    if (canvas) {
	      graphics = canvas.getContext('2d');
	      this.requestID = window.requestAnimationFrame(function () {
	        w = styleHelper.getWidth(self.props);
	        h = styleHelper.getHeight(self.props);
	        graphics.clearRect(0, 0, w, h);
	        graphics.beginPath();
	        graphics.strokeStyle = '#444';
	        graphics.lineWidth = 1;
	        graphics.rect(0.5, 0.5, w - 0.5, h - 0.5);
	        graphics.moveTo(5, 5);
	        graphics.lineTo(w - 5, h - 5);
	        graphics.moveTo(5, h - 5);
	        graphics.lineTo(w - 5, 5);
	        graphics.closePath();
	        graphics.stroke();
	
	        graphics.beginPath();
	        graphics.fillStyle = '#C7C7C7';
	        graphics.arc(cx, cy, r, 0, 360);
	        graphics.closePath();
	        graphics.fill();
	
	        graphics.beginPath();
	        cx -= 25;
	        graphics.fillStyle = '#F0F0F0';
	        graphics.arc(cx, cy, r, 0, 360);
	        graphics.closePath();
	        graphics.fill();
	
	        graphics.beginPath();
	        cx += 50;
	        graphics.arc(cx, cy, r, 0, 360);
	        graphics.closePath();
	        graphics.fill();
	      });
	    }
	  },
	
	  refreshIndicator: function refreshIndicator() {
	    var indicator;
	    var i = 0;
	    var l = 0;
	    var opacity = 0.4;
	    var borderColor;
	    var margin;
	    if (this.props.items) {
	      l = this.props.items.length;
	    }
	    for (i; i < l; i++) {
	      indicator = $('#' + this.props.controlID + '-' + i);
	      if (i === this.currentIndex) {
	        opacity = 0.8;
	        borderColor = this.props.indicatorColor;
	      } else {
	        opacity = 0.5;
	        borderColor = 'transparent';
	      }
	      indicator.css({
	        opacity: opacity,
	        borderColor: borderColor
	      });
	    }
	  },
	
	  animateDuration: 400,
	
	  autoPlay: function autoPlay() {
	    var delay = parseInt(this.props.playInterval, 10);
	    var self = this;
	    if (this.props.aniType !== appTypes.StackPanelAniType.NONE) {
	      delay -= this.animateDuration;
	    }
	    if (this.props.isAutoPlay) {
	      this.timeOut = setTimeout(function () {
	        var index = self.currentIndex + 1;
	        if (index >= self.imgs.length) {
	          index = 0;
	        }
	        self.skipTo(index);
	      }, delay);
	    }
	  },
	
	  nextLayer: undefined,
	  previoursLayer: undefined,
	
	  skipTo: function skipTo(index) {
	    var previous;
	    var next;
	    var dom;
	    var aniType = this.props.aniType;
	    var i = 0;
	    var targetOption = {
	      duration: this.animateDuration,
	      queue: false,
	      complete: this.onSkipAnimateFinish
	    };
	    var currentOption = {
	      duration: this.animateDuration,
	      queue: false
	    };
	
	    var max = this.imgs.length;
	    for (i; i < this.imgs.length; i++) {
	      dom = this.imgs[i];
	      if (i != this.currentIndex && i != index) {
	        dom.css({ display: 'none', visibility: 'hidden', zIndex: 0 });
	      } else {
	        dom.css({ display: 'block', visibility: 'visible' });
	        if (i === this.currentIndex) {
	          dom.css({ zIndex: max - 1 });
	        } else if (i === index) {
	          dom.css({ zIndex: max });
	        }
	      }
	    }
	    previous = this.imgs[this.currentIndex];
	    this.currentIndex = index;
	    next = this.imgs[index];
	    previous.css({ 'z-index': 0 });
	    next.css({ 'z-index': 1 });
	    this.nextLayer = next;
	    this.previoursLayer = previous;
	    switch (aniType) {
	      case appTypes.StackPanelAniType.FADE:
	        next.animate({ opacity: 1 }, targetOption);
	        previous.animate({ opacity: 0 }, currentOption);
	        break;
	      case appTypes.StackPanelAniType.PUSH:
	        previous.animate({ left: -this.props.w }, currentOption);
	        next.css({ left: this.props.w }).animate({ left: 0 }, targetOption);
	        break;
	      case appTypes.StackPanelAniType.SLIDE:
	        next.css({ left: this.props.w }).animate({ left: 0 }, targetOption);
	        break;
	      case appTypes.StackPanelAniType.NONE:
	        previous.css({ display: 'none', zIndex: 0 });
	        next.css({ left: 0, display: 'block', zIndex: max });
	        this.onSkipAnimateFinish();
	        break;
	    }
	  },
	
	  onSkipAnimateFinish: function onSkipAnimateFinish() {
	    if (this.previoursLayer) {
	      if (this.nextLayer) {
	        if (this.previoursLayer !== this.nextLayer) {
	          $(this.previoursLayer).css({ display: 'none' });
	        }
	      }
	    }
	    this.refreshIndicator();
	    this.autoPlay();
	  },
	  onIndicatorClick: function onIndicatorClick(index) {
	    if (this.timeOut) {
	      clearTimeout(this.timeOut);
	    }
	    this.skipTo(index);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.timeOut) {
	      clearTimeout(this.timeOut);
	    }
	    cancelAnimationFrame(this.requestID);
	    this.resetCurrentIndex();
	    this.refreshIndicator();
	  }
	
	});
	
	module.exports = ImageCarousel;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var projectLoadHelper = __webpack_require__(68);
	var _ = __webpack_require__(51);
	var util = __webpack_require__(116);
	
	/**
	 * Gif组件
	 * @author Allen
	 * @createDate 2017/7/13
	 **/
	
	var Gif = React.createClass({
	  displayName: 'Gif',
	
	
	  paintEmpty: function paintEmpty() {
	    if (!this.isEmptyImage) {
	      return;
	    }
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    var g = canvas.getContext('2d');
	    var w = canvas.width;
	    var h = canvas.height;
	    var caption = styleHelper.getPropertyValue(this.props, propConst.CAPTION) || this.props.controlTypeID;
	    g.clearRect(0, 0, w, h);
	    g.beginPath();
	    g.strokeStyle = '#444';
	
	    g.fillStyle = '#fff';
	    g.lineWidth = 1;
	
	    g.rect(0.5, 0.5, w - 1, h - 1);
	    g.closePath();
	
	    g.fill();
	    g.stroke();
	
	    var xLinePadding = 2;
	    var yLinePadding = 2;
	
	    g.moveTo(xLinePadding, yLinePadding);
	    g.lineTo(w - xLinePadding, h - yLinePadding);
	    g.moveTo(xLinePadding, h - yLinePadding);
	    g.lineTo(w - xLinePadding, yLinePadding);
	    g.stroke();
	
	    var bgSize = 28;
	    var captionSize = g.measureText(caption);
	    var fontSize = 8;
	    if (captionSize.width + 8 < w && fontSize + 5 < h) {
	      g.fillRect(w / 2 - bgSize / 2, h / 2 - bgSize / 2, bgSize, bgSize);
	      g.font = fontSize + 'px Arial';
	      g.fillStyle = '#000';
	      g.fillText(caption, w / 2 - captionSize.width / 2, h / 2 + fontSize / 2);
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.paintEmpty();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.paintEmpty();
	  },
	
	  isEmptyImage: false,
	  render: function render() {
	
	    var url = styleHelper.getPropertyValue(this.props, propConst.URL);
	    this.isEmptyImage = _.isEmpty(url);
	    if (this.isEmptyImage) {
	      return React.createElement('canvas', {
	        ref: 'canvas',
	        width: styleHelper.getWidth(this.props),
	        height: styleHelper.getHeight(this.props)
	      });
	    } else {
	      url = projectLoadHelper.loadImage(url);
	      var style = {
	        width: styleHelper.getWidth(this.props),
	        height: styleHelper.getHeight(this.props),
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center'
	      };
	      return React.createElement(
	        'div',
	        { style: style },
	        React.createElement('img', { src: url, onLoad: this.drawImage })
	      );
	    }
	  },
	
	  drawImage: function drawImage(e) {
	    var image = new Image();
	    var iwidth = styleHelper.getWidth(this.props); //定义允许图片宽度
	    var iheight = styleHelper.getHeight(this.props); //定义允许图片高度
	    var ImgD = e.target;
	    image.src = ImgD.src;
	    if (image.width > 0 && image.height > 0) {
	      if (image.width / image.height >= iwidth / iheight) {
	        ImgD.width = iwidth;
	        ImgD.height = image.height * iwidth / image.width;
	        /*if (image.width > iwidth) {
	          ImgD.width = iwidth;
	          ImgD.height = (image.height * iwidth) / image.width;
	        } else {
	          ImgD.width = image.width;
	          ImgD.height = image.height;
	        }*/
	        ImgD.alt = image.width + "×" + image.height;
	      } else {
	        ImgD.height = iheight;
	        ImgD.width = image.width * iheight / image.height;
	        /*if (image.height > iheight) {
	          ImgD.height = iheight;
	          ImgD.width = (image.width * iheight) / image.height;
	        } else {
	          ImgD.width = image.width;
	          ImgD.height = image.height;
	        }*/
	        ImgD.alt = image.width + "×" + image.height;
	      }
	    }
	  }
	
	});
	
	module.exports = Gif;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	var propConst = __webpack_require__(147);
	var projectLoadHelper = __webpack_require__(68);
	var _ = __webpack_require__(51);
	var util = __webpack_require__(116);
	
	/**
	 * SVG组件
	 * @author Allen
	 * @createDate 2017/7/13
	 **/
	
	var SVG = React.createClass({
	  displayName: 'SVG',
	
	
	  paintEmpty: function paintEmpty() {
	    if (!this.isEmptyImage) {
	      return;
	    }
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    var g = canvas.getContext('2d');
	    var w = canvas.width;
	    var h = canvas.height;
	    var caption = styleHelper.getPropertyValue(this.props, propConst.CAPTION) || this.props.controlTypeID;
	    g.clearRect(0, 0, w, h);
	    g.beginPath();
	    g.strokeStyle = '#444';
	
	    g.fillStyle = '#fff';
	    g.lineWidth = 1;
	
	    g.rect(0.5, 0.5, w - 1, h - 1);
	    g.closePath();
	
	    g.fill();
	    g.stroke();
	
	    var xLinePadding = 2;
	    var yLinePadding = 2;
	
	    g.moveTo(xLinePadding, yLinePadding);
	    g.lineTo(w - xLinePadding, h - yLinePadding);
	    g.moveTo(xLinePadding, h - yLinePadding);
	    g.lineTo(w - xLinePadding, yLinePadding);
	    g.stroke();
	
	    var bgSize = 28;
	    var captionSize = g.measureText(caption);
	    var fontSize = 8;
	    if (captionSize.width + 8 < w && fontSize + 5 < h) {
	      g.fillRect(w / 2 - bgSize / 2, h / 2 - bgSize / 2, bgSize, bgSize);
	      g.font = fontSize + 'px Arial';
	      g.fillStyle = '#000';
	      g.fillText(caption, w / 2 - captionSize.width / 2, h / 2 + fontSize / 2);
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.paintEmpty();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.paintEmpty();
	    if (!this.isEmptyImage) {
	      this.doPaint();
	    }
	  },
	
	  isEmptyImage: false,
	  render: function render() {
	
	    var url = styleHelper.getPropertyValue(this.props, propConst.URL);
	    this.isEmptyImage = _.isEmpty(url);
	    if (this.isEmptyImage) {
	      return React.createElement('canvas', {
	        ref: 'canvas',
	        width: styleHelper.getWidth(this.props),
	        height: styleHelper.getHeight(this.props)
	      });
	    } else {
	      url = projectLoadHelper.loadSVG(url);
	      var w = styleHelper.getWidth(this.props);
	      var h = styleHelper.getHeight(this.props);
	      var style = {
	        width: w,
	        height: h,
	        display: 'flex',
	        justifyContent: 'center',
	        alignItems: 'center'
	      };
	
	      return React.createElement(
	        'canvas',
	        { ref: 'canvas2', style: style, width: w, height: h },
	        React.createElement('img', { ref: 'imgDom', src: url, onLoad: this.drawImage })
	      );
	    }
	  },
	
	  doPaint: function doPaint() {
	    var iwidth = styleHelper.getWidth(this.props); //定义允许图片宽度
	    var iheight = styleHelper.getHeight(this.props); //定义允许图片高度
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas2);
	    var imgDom = ReactDOM.findDOMNode(this.refs.imgDom);
	    var color = styleHelper.getBackgroundColor(this.props);
	    var context = canvas.getContext('2d');
	    graphicsHelper.drawColorImage(context, imgDom, color, null, { left: 0, top: 0, right: iwidth, bottom: iheight });
	  },
	
	  drawImage: function drawImage(e) {
	    var image = new Image();
	    var iwidth = styleHelper.getWidth(this.props); //定义允许图片宽度
	    var iheight = styleHelper.getHeight(this.props); //定义允许图片高度
	    var ImgD = e.target;
	    image.src = ImgD.src;
	    if (image.width > 0 && image.height > 0) {
	      if (image.width / image.height >= iwidth / iheight) {
	        ImgD.width = iwidth;
	        ImgD.height = image.height * iwidth / image.width;
	        /*if (image.width > iwidth) {
	          ImgD.width = iwidth;
	          ImgD.height = (image.height * iwidth) / image.width;
	        } else {
	          ImgD.width = image.width;
	          ImgD.height = image.height;
	        }*/
	        ImgD.alt = image.width + "×" + image.height;
	      } else {
	        ImgD.height = iheight;
	        ImgD.width = image.width * iheight / image.height;
	        /*if (image.height > iheight) {
	          ImgD.height = iheight;
	          ImgD.width = (image.width * iheight) / image.height;
	        } else {
	          ImgD.width = image.width;
	          ImgD.height = image.height;
	        }*/
	        ImgD.alt = image.width + "×" + image.height;
	      }
	    }
	
	    this.doPaint();
	  }
	
	});
	
	module.exports = SVG;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var Border = __webpack_require__(168);
	var styleHelper = __webpack_require__(145);
	var measureHelper = __webpack_require__(148);
	//var Dom = require('react-dom');
	var LabelParts = __webpack_require__(174);
	var convertHelper = __webpack_require__(146);
	var textHelper = __webpack_require__(116).Text;
	var appTypes = __webpack_require__(115);
	
	var Label = React.createClass({
	  displayName: 'Label',
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    //if (nextProps.text !== this.props.text) {
	    this.isInvalid = true;
	    //}
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.isInvalid) {
	      this.isInvalid = false;
	      this._doPaint();
	    }
	    ;
	    this.doAdjustLinkArea();
	  },
	
	  _doPaint: function _doPaint() {
	    var com;
	    var parentDom;
	    var w;
	    var lineHeight = styleHelper.builderLineHeight(this.props);
	    var textHeight;
	    if (lineHeight) {
	      textHeight = lineHeight + 1;
	      lineHeight += 'px';
	    } else {
	      lineHeight = '1em';
	      textHeight = 14;
	    }
	
	    var style;
	    com = ReactDOM.findDOMNode(this);
	    if (this.props.isAutoSize) {
	      parentDom = com.parentElement;
	      if (parentDom) {
	        style = styleHelper.builderTextStyle(this.props);
	        w = measureHelper.measureTextWidth(style, styleHelper.getText(this.props)).width;
	        if (w) {
	          $(parentDom).css({ width: w, height: textHeight, lineHeight: lineHeight });
	        }
	        ;
	      }
	      ;
	    }
	    ;
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._doPaint();
	    this.doAdjustLinkArea();
	    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize);
	  },
	
	  onResize: function onResize(e) {
	    this.doAdjustLinkArea();
	  },
	
	  doAdjustLinkArea: function doAdjustLinkArea() {
	    var dom = ReactDOM.findDOMNode(this).parentElement;
	    var lbl = ReactDOM.findDOMNode(this.refs.label);
	    var w = dom.clientWidth;
	    var h = dom.clientHeight;
	    if (this.props.isAutoSize) {
	      w = lbl.parentElement.clientWidth;
	    }
	    ;
	    dom = $(dom);
	    var linkArea = dom.children('.linkArea').first();
	    var plink = linkArea.children('.page-link');
	    var ilink = linkArea.children('.interactive-link');
	    linkArea.css({ width: '100%', height: '100%' });
	    linkArea.children().css({ width: '100%', height: '100%' });
	    //plink.css({width:'100%',height:'100%'});
	    //ilink.css({width:'100%',height:'100%'});
	  },
	
	  render: function render() {
	    var text = styleHelper.getText(this.props);
	    var labelBoxStyle;
	    var labelStyle;
	    var bgColor = styleHelper.getBackgroundColor(this.props);
	    var textAlign;
	    var contextStyle = {
	      backgroundColor: bgColor,
	      position: 'absolute',
	      lineHeight: this.props.h + 'px'
	    };
	
	    if (!this.props.isAutoSize) {
	      contextStyle.overflow = 'hidden';
	    }
	
	    text = textHelper.convertSpaceToNbsp(text);
	
	    if (this.props.textAlign === 'HaLeft') {
	      textAlign = 'left';
	    } else if (this.props.textAlign === 'HaCenter') {
	      textAlign = 'center';
	    } else if (this.props.textAlign === 'HaRight') {
	      textAlign = 'right';
	    }
	
	    labelBoxStyle = {
	      width: 'auto',
	      height: 'auto',
	      textAlign: textAlign
	    };
	
	    labelStyle = {
	      whiteSpace: 'nowrap'
	    };
	
	    styleHelper.adjustTextSizeStyle(labelStyle);
	    styleHelper.StyleUtil(this.props, labelStyle).align().text();
	    return React.createElement(
	      'div',
	      {
	        id: this.props.id,
	        className: 'context',
	        style: contextStyle
	      },
	      React.createElement(
	        'div',
	        { style: labelBoxStyle },
	        React.createElement(
	          'div',
	          { style: { width: 'auto', height: 'auto' } },
	          React.createElement(
	            'label',
	            { ref: 'label', style: labelStyle },
	            text
	          )
	        )
	      )
	    );
	  }
	});
	
	module.exports = Label;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var AutoSizeHelper = __webpack_require__(167);
	var styleHelper = __webpack_require__(145);
	
	/*
	 * 链接组件
	 */
	var Link = React.createClass({
	  displayName: 'Link',
	
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.text !== this.props.text) {
	      this.isInvalid = true;
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.isInvalid) {
	      this.isInvalid = false;
	      this._doPaint();
	    }
	  },
	
	  _doPaint: function _doPaint() {
	    var com;
	    var parentDom;
	    var size;
	
	    if (this.props.isAutoSize) {
	      com = ReactDOM.findDOMNode(this);
	      parentDom = com.parentElement;
	
	      while (!parentDom && parentDom.id !== this.props.controlID) {
	        parentDom = parentDom.parentElement;
	      }
	
	      if (parentDom) {
	        size = AutoSizeHelper.getComAutoSize(this.props);
	        parentDom.style.width = size.width + 4 + 'px';
	        parentDom.style.height = size.height + 2 + 'px';
	      }
	    }
	  },
	
	  render: function render() {
	    var style = {
	      width: '100%',
	      height: '100%'
	    };
	    styleHelper.builderTextAlign(this.props, style);
	    styleHelper.StyleUtil(this.props, style).text();
	
	    // 这里为了移除 label 前面的空白部分，将父元素的字号设置为 0，详情见： https://davidwalsh.name/remove-whitespace-inline-block
	    style.fontSize = 0;
	    return React.createElement(
	      'div',
	      { style: style },
	      React.createElement(
	        'label',
	        { style: {
	            lineHeight: '100%',
	            fontSize: this.props.textSize + 'px'
	          } },
	        styleHelper.getText(this.props)
	      )
	    );
	  }
	
	});
	
	module.exports = Link;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var convertHelper = __webpack_require__(146);
	var arrowHelper = __webpack_require__(197);
	var graphicsHelper = __webpack_require__(172);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var util = __webpack_require__(116);
	
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-4-1
	 @Descript : 线段组件
	 */
	var Line = React.createClass({
	  displayName: 'Line',
	
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  paint: function paint() {
	    var _this = this;
	    var startPoint;
	    var endPoint;
	    var controlPoint;
	    var arrowLeftPoints;
	    var arrowRightPoints;
	    var thickness;
	    var ratio = 1;
	    var w;
	    var h;
	    var p;
	    var dash = styleHelper.parseDashMode(styleHelper.getPropertyValue(this.props, propConst.DASH_MODE));
	    startPoint = util.Point.strToPoint(this.props.startPoint);
	    endPoint = util.Point.strToPoint(this.props.endPoint);
	    controlPoint = util.Point.strToPoint(this.props.controlPoint);
	    //thickness = styleHelper.getPropertyValue(_this.props,propConst.THICKNESS);
	
	    //util.Point.offset(startPoint,Math.round(startPoint.x) - startPoint.x + thickness/2,Math.round(startPoint.y) - startPoint.y + thickness/2);
	    //util.Point.offset(endPoint,Math.round(endPoint.x) - endPoint.x + thickness/2,Math.round(endPoint.y) - endPoint.y + thickness/2);
	
	    util.Path.Curve.create(startPoint, endPoint, controlPoint);
	
	    if (this.props.showStartArrow) {
	      arrowLeftPoints = arrowHelper.getArrowPoint(controlPoint, startPoint, 0.5, 10);
	    }
	
	    if (this.props.showEndArrow) {
	      arrowRightPoints = arrowHelper.getArrowPoint(controlPoint, endPoint, 0.5, 10);
	    }
	    if (this.canChange) {
	      this.requestID = window.requestAnimationFrame(function () {
	        var canvas = ReactDOM.findDOMNode(_this.refs.canvas);
	        if (!canvas) {
	          return;
	        }
	        var ctx = canvas.getContext('2d');
	
	        w = styleHelper.getWidth(_this.props);
	        h = styleHelper.getHeight(_this.props);
	        ratio = graphicsHelper.applyDeviceRatio(ctx, w, h);
	        w *= ratio;
	        h *= ratio;
	        util.Point.scale(startPoint, ratio);
	        util.Point.scale(controlPoint, ratio);
	        util.Point.scale(endPoint, ratio);
	        if (arrowLeftPoints) {
	          util.Point.scale(arrowLeftPoints.left, ratio);
	          util.Point.scale(arrowLeftPoints.right, ratio);
	        }
	        if (arrowRightPoints) {
	          util.Point.scale(arrowRightPoints.left, ratio);
	          util.Point.scale(arrowRightPoints.right, ratio);
	        }
	
	        //startPoint.x = startPoint.x * ratio;
	        //startPoint.y = startPoint.y * ratio;
	        //controlPoint.x = controlPoint.x * ratio;
	        //controlPoint.y = controlPoint.y * ratio;
	        //endPoint.x = endPoint.x * ratio;
	        //endPoint.y = endPoint.y * ratio;
	        thickness = styleHelper.getPropertyValue(_this.props, propConst.THICKNESS);
	
	        //ctx.clearRect(0, 0, styleHelper.getWidth(_this.props), styleHelper.getHeight(_this.props));
	        graphicsHelper.clearRect(ctx);
	        graphicsHelper.initContextStyle(ctx, thickness, styleHelper.getBackgroundColor(_this.props), undefined, dash);
	        //ctx.lineCap = 'butt';
	        if (_this.props.isCurved) {
	          graphicsHelper.drawCurveLine(ctx, startPoint.x, startPoint.y, endPoint.x, endPoint.y);
	        } else {
	          graphicsHelper.drawCurveLine(ctx, startPoint.x, startPoint.y, endPoint.x, endPoint.y, controlPoint.x, controlPoint.y);
	        }
	        ctx.stroke();
	        ctx.beginPath();
	        graphicsHelper.setDash(ctx);
	
	        //ctx.beginPath();
	        if (parseInt(_this.props.showStartArrow, 10)) {
	          ctx.moveTo(arrowLeftPoints.left.x, arrowLeftPoints.left.y);
	          ctx.lineTo(startPoint.x, startPoint.y);
	          ctx.lineTo(arrowLeftPoints.right.x, arrowLeftPoints.right.y);
	        }
	
	        if (parseInt(_this.props.showEndArrow, 10)) {
	          ctx.moveTo(arrowRightPoints.left.x, arrowRightPoints.left.y);
	          ctx.lineTo(endPoint.x, endPoint.y);
	          ctx.lineTo(arrowRightPoints.right.x, arrowRightPoints.right.y);
	        }
	
	        ctx.stroke();
	      });
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.paint();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.paint();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    //此处不明作用，猜测是为提升性能比较数据
	    //将其注释掉为解决线条切换页面后再切换回来不显示问题
	    //this.canChange = JSON.stringify(this.props) !== JSON.stringify(newProps);
	    this.canChange = true;
	  },
	
	  canChange: true,
	
	  getCurveCenterPoint: function getCurveCenterPoint() {
	    var startPoint = util.Point.strToPoint(this.props.startPoint);
	    var endPoint = util.Point.strToPoint(this.props.endPoint);
	    var controlPoint = util.Point.strToPoint(this.props.controlPoint);
	
	    var i;
	    var T = 0;
	    var N = 3000;
	    var px;
	    var py;
	    this.getPointsOnLine();
	    if (!this.props.isTextPosCenter) {
	      return this.points[0];
	    } else {
	      return this.points[this.points.length / 2];
	    }
	  },
	
	  getPointsOnLine: function getPointsOnLine() {
	    var startPoint = util.Point.strToPoint(this.props.startPoint);
	    var endPoint = util.Point.strToPoint(this.props.endPoint);
	    var controlPoint = util.Point.strToPoint(this.props.controlPoint);
	
	    var i;
	    var T = 0;
	    var N = 300;
	    var S = 1 / N;
	    var px;
	    var py;
	    this.points = [];
	    for (i = 0; i < N; i++) {
	      px = Math.pow(1 - T, 2) * startPoint.x + 2 * T * (1 - T) * controlPoint.x + Math.pow(T, 2) * endPoint.x;
	      py = Math.pow(1 - T, 2) * startPoint.y + 2 * T * (1 - T) * controlPoint.y + Math.pow(T, 2) * endPoint.y;
	      T += S;
	      this.points.push({ x: px, y: py });
	    }
	  },
	
	  render: function render() {
	    var curvePoint = this.getCurveCenterPoint();
	
	    var isMultiLineText;
	    var textArray;
	    var divStyle;
	    var pStyle;
	    var size = styleHelper.getSize(this.props);
	    var text = styleHelper.getText(this.props);
	
	    if (text) {
	      textArray = util.Text.delimitToParagraphs(text);
	      isMultiLineText = textArray.length > 1;
	    }
	
	    divStyle = {
	      left: Math.round(curvePoint.x),
	      top: Math.round(curvePoint.y),
	      borderColor: styleHelper.getPropertyValue(this.props, propConst.TEXT_BORDER_COLOR),
	      backgroundColor: styleHelper.getPropertyValue(this.props, propConst.TEXT_BACKGROUND_COLOR),
	      color: styleHelper.getTextColor(this.props),
	      fontSize: styleHelper.getFontSize(this.props)
	    };
	
	    pStyle = {
	      textAlign: convertHelper.getTextHorizontalAlign(this.props.textAlign)
	    };
	
	    return React.createElement(
	      'div',
	      { className: 'component-Line' },
	      React.createElement('canvas', {
	        ref: 'canvas',
	        onClick: this.onClick,
	        onMouseEnter: this.onMouseEnter,
	        onMouseDown: this.onMouseDown,
	        style: { width: '100%', height: '100%' },
	        width: size.width,
	        height: size.height
	      }),
	      text && React.createElement(
	        'div',
	        { style: divStyle, className: 'text' },
	        !isMultiLineText && React.createElement(
	          'label',
	          null,
	          text
	        ),
	        isMultiLineText && textArray.map(function (text, idx) {
	          if (text.trim()) {
	            return React.createElement(
	              'p',
	              { key: idx, style: pStyle },
	              text
	            );
	          }
	          return React.createElement('br', { key: idx });
	        })
	      )
	    );
	  },
	
	  checkValidPoint: function checkValidPoint(e) {
	    var x = e.nativeEvent.layerX;
	    var y = e.nativeEvent.layerY;
	    return util.Path.Curve.isPointIn(x, y, 10);
	  },
	
	
	  onMouseDown: function onMouseDown(e) {
	    if (!this.checkValidPoint(e)) {
	      e.stopPropagation();
	    }
	  },
	  onMouseUp: function onMouseUp(e) {},
	
	  onMouseEnter: function onMouseEnter(e) {
	    if (!this.checkValidPoint(e)) {
	      e.bubbles = false;
	      e.stopPropagation();
	      e.cancelBubble = true;
	      e.nativeEvent.stopPropagation();
	    }
	  },
	  onMouseLeave: function onMouseLeave() {},
	
	  onClick: function onClick(e) {
	    if (!this.checkValidPoint(e)) {
	      e.stopPropagation();
	    }
	  }
	});
	
	module.exports = Line;

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 *
	 * @param startPoint 启动坐标
	 * @param endPoint 终点坐标
	 * @param angle 夹角
	 * @param arrowLen 箭头长度
	 */
	
	exports.getArrowPoint = function (startPoint, endPoint, arrowAngle, arrowLen) {
	
	  var lineAngle;
	  var angleC;
	  var angleA;
	  var rimA;
	  var rimB;
	  var rimC;
	  var leftArrowAngle;
	  var rightArrowAngle;
	
	  lineAngle = 0;
	  if (endPoint.x - startPoint.x !== 0) {
	    lineAngle = Math.atan((endPoint.y - startPoint.y) / (endPoint.x - startPoint.x));
	  } else {
	    if (endPoint.y - startPoint.y < 0) {
	      lineAngle = Math.PI / 2;
	    } else {
	      lineAngle = 3 * Math.PI / 2;
	    }
	  }
	
	  if (endPoint.y - startPoint.y >= 0 && endPoint.x - startPoint.x <= 0) {
	    lineAngle = lineAngle + Math.PI;
	  } else if (endPoint.y - startPoint.y <= 0 && endPoint.x - startPoint.x <= 0) {
	    lineAngle = lineAngle + Math.PI;
	  }
	
	  angleC = arrowAngle;
	  rimA = arrowLen;
	  rimB = Math.pow(Math.pow(endPoint.y - startPoint.y, 2) + Math.pow(endPoint.x - startPoint.x, 2), 0.5);
	  rimC = Math.pow(Math.pow(rimA, 2) + Math.pow(rimB, 2) - 2 * rimA * rimB * Math.cos(angleC), 0.5);
	
	  angleA = Math.acos((rimB - rimA * Math.cos(angleC)) / rimC);
	
	  leftArrowAngle = lineAngle + angleA;
	  rightArrowAngle = lineAngle - angleA;
	
	  return {
	    left: {
	      x: Math.round(startPoint.x + rimC * Math.cos(leftArrowAngle)),
	      y: Math.round(startPoint.y + rimC * Math.sin(leftArrowAngle))
	    },
	    right: {
	      x: Math.round(startPoint.x + rimC * Math.cos(rightArrowAngle)),
	      y: Math.round(startPoint.y + rimC * Math.sin(rightArrowAngle))
	    }
	  };
	};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var Border = __webpack_require__(168);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	var convertHelper = __webpack_require__(146);
	var styleHelper = __webpack_require__(145);
	var VerticalScrollBar = __webpack_require__(178);
	var CustomRect = __webpack_require__(199);
	var util = __webpack_require__(116);
	var propConst = __webpack_require__(147);
	
	/*
	 * 列表组件
	 */
	
	var ListItem = React.createClass({
	  displayName: 'ListItem',
	
	
	  propTypes: {
	    selected: React.PropTypes.bool.isRequired,
	    partStyle: React.PropTypes.object,
	    showDivisionLine: React.PropTypes.bool.isRequired,
	    height: React.PropTypes.number.isRequired,
	    isInterlace: React.PropTypes.bool.isRequired,
	    showVerticalScrollBar: React.PropTypes.bool,
	    onClickEvent: React.PropTypes.func,
	    showSeparator: React.PropTypes.bool.isRequired,
	    textPadding: React.PropTypes.number.isRequired,
	    selectedTextColor: React.PropTypes.string
	  },
	
	  render: function render() {
	    var textStyle = {
	      lineHeight: this.props.height + 'px',
	      // marginLeft: this.props.textPadding,
	      paddingLeft: this.props.textPadding,
	      paddingRight: this.props.textPadding
	    };
	    if (this.props.selected) {
	      textStyle.color = this.props.selectedTextColor;
	    }
	
	    return React.createElement(
	      CustomRect,
	      _extends({
	        key: this.props.index
	      }, {
	        top: this.props.top,
	        left: 0,
	        width: this.props.width,
	        height: this.props.height,
	        borderBottomStyle: this.props.showDivisionLine ? 'solid' : 'none',
	        backgroundColor: this.props.selected ? this.props.selectedColor : this.props.isInterlace ? this.props.interlaceColor : this.props.backgroundColor,
	        showSeparator: this.props.showSeparator,
	        separatorColor: this.props.separatorColor
	      }, { onClick: this.props.onClickEvent }),
	      React.createElement(
	        'div',
	        {
	          style: textStyle
	        },
	        util.Text.convertSpaceToNbsp(this.props.text)
	      )
	    );
	  }
	});
	
	var List = React.createClass({
	  displayName: 'List',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: this.props.selectedIndex
	    };
	  },
	
	  parseText: function parseText() {
	    var text = styleHelper.getText(this.props);
	    text = util.Text.removeLastEmptyRow(text);
	    return util.Text.delimitText(text, util.Text.DM_RETURN);
	  },
	
	  additionalItems: function additionalItems(arr) {
	    var count = this.props.h / this.props.itemHeight;
	    var i = arr.length;
	    if (arr.length < count) {
	      for (i; i < count; i++) {
	        arr.push('');
	      }
	    }
	  },
	
	  render: function render() {
	    var textArray = this.parseText();
	    var maxValideItemCount = textArray.length;
	    var textMarginRight = 10;
	    var itemHeight = util.Int(this.props.itemHeight);
	    var top;
	    var style = {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      position: 'absolute'
	    };
	    this.additionalItems(textArray);
	    styleHelper.StyleUtil(this.props).default(style).background().text().border().align().size();
	
	    if (this.props.verticalScrollbarShow) {
	      textMarginRight = 22;
	      itemHeight -= 1;
	    }
	    //console.log(this.props.interactiveData.entry.length);
	
	    return React.createElement(
	      'div',
	      { key: this.props.controlID, style: style },
	      textArray.map(function (text, index) {
	        top = itemHeight * index;
	        return React.createElement(ListItem, {
	          key: index,
	          top: top,
	          index: index,
	          interlaceColor: styleHelper.getPropertyValue(this.props, propConst.INTERLACE_COLOR),
	          backgroundColor: styleHelper.getBackgroundColor(this.props),
	          textAlign: style.textAlign,
	          textMarginRight: textMarginRight,
	          selected: this.state.selectedIndex === index,
	          selectedColor: styleHelper.getSelectedColor(this.props),
	          showDivisionLine: styleHelper.getPropertyValue(this.props, propConst.SHOW_H_LINE2),
	          isInterlace: this.props.isInterlace && index % 2 === 1,
	          height: itemHeight,
	          width: styleHelper.getWidth(this.props) - (this.props.verticalScrollbarShow ? 14 : 2),
	          text: text,
	          onClickEvent: index < maxValideItemCount ? this._onClick.bind(this, index) : undefined,
	
	          showSeparator: this.props.showSeparator,
	          separatorColor: this.props.separatorColor,
	          textPadding: this.props.textPadding,
	          selectedTextColor: this.props.selectedTextColor || 'none'
	        });
	      }.bind(this)),
	      this.props.verticalScrollbarShow && React.createElement(VerticalScrollBar, {
	        value: util.Int(this.props.verticalScrollbarProgress)
	      })
	    );
	  },
	
	  _onClick: function _onClick(index) {
	    this.setState({ selectedIndex: index });
	  },
	
	  componentDidMount: function componentDidMount() {
	    var self = this;
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', function (e, index) {
	      self._onClick(index);
	    });
	  }
	});
	
	module.exports = List;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var _ = __webpack_require__(51);
	var GlobalConst = __webpack_require__(164);
	
	var CustomRect = React.createClass({
	  displayName: 'CustomRect',
	
	  propTypes: {
	    backgroundColor: React.PropTypes.string,
	    border: React.PropTypes.string,
	    borderStyle: React.PropTypes.string,
	    borderLeftStyle: React.PropTypes.string,
	    borderTopStyle: React.PropTypes.string,
	    borderRightStyle: React.PropTypes.string,
	    borderBottomStyle: React.PropTypes.string,
	    borderColor: React.PropTypes.string,
	    borderRadius: React.PropTypes.number,
	    borderWidth: React.PropTypes.number,
	    width: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
	    height: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
	    left: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
	    top: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
	    position: React.PropTypes.string,
	    style: React.PropTypes.object,
	    onClick: React.PropTypes.func
	  },
	
	  initStyle: function initStyle() {
	    var style = this.props.style;
	    if (!style) {
	      style = {
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%'
	      };
	    }
	    var props = this.props;
	    if (_.isUndefined(style.width)) {
	      style.width = '100%';
	    }
	    if (_.isUndefined(style.height)) {
	      style.height = '100%';
	    }
	    if (props.left) {
	      style.left = props.left;
	    }
	    if (props.top) {
	      style.top = props.top;
	    }
	    if (props.width) {
	      style.width = props.width;
	    }
	    if (props.height) {
	      style.height = props.height;
	    }
	    style.backgroundColor = style.backgroundColor || props.backgroundColor || 'transparent';
	    if (!_.isUndefined(props.border)) {
	      style.border = props.border;
	    }
	    if (!_.isUndefined(props.borderStyle)) {
	      style.borderStyle = props.borderStyle;
	    }
	    if (!_.isUndefined(props.borderLeftStyle)) {
	      style.borderLeftStyle = props.borderLeftStyle;
	    }
	    if (!_.isUndefined(props.borderTopStyle)) {
	      style.borderTopStyle = props.borderTopStyle;
	    }
	    if (!_.isUndefined(props.borderRightStyle)) {
	      style.borderRightStyle = props.borderRightStyle;
	    }
	    if (!_.isUndefined(props.borderBottomStyle)) {
	      style.borderBottomStyle = props.borderBottomStyle;
	    }
	    if (!_.isUndefined(props.borderColor)) {
	      style.borderColor = props.borderColor;
	    } else {
	      if (!style.border) style.borderColor = style.borderColor || GlobalConst.GLOBAL_COLOR.DEFAULT_BORDER_COLOR;
	    }
	    if (!_.isUndefined(props.borderWidth)) {
	      style.borderWidth = props.borderWidth;
	    } else {
	      style.borderWidth = style.borderWidth || 1;
	    }
	    if (!_.isUndefined(props.borderRadius)) {
	      style.borderRadius = props.borderRadius;
	    } else {
	      style.borderRadius = style.borderRadius || 0;
	    }
	    style.position = style.position || props.position || 'absolute';
	    style.textDecoration = style.textDecoration || props.textDecoration || 'inherit';
	    style.boxSizing = style.boxSizing || props.boxSizing || 'border-box';
	
	    if (this.props.showSeparator) {
	      style.borderBottom = '1px solid ' + this.props.separatorColor;
	    }
	
	    return style;
	  },
	  render: function render() {
	    var style = this.initStyle();
	    return React.createElement(
	      'div',
	      { className: this.props.className || 'custom_rect',
	        style: style,
	        onClick: this.props.onClick },
	      this.props.children
	    );
	  }
	});
	
	module.exports = CustomRect;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var appTypes = __webpack_require__(115);
	var CustomRect = __webpack_require__(199);
	var styleHelper = __webpack_require__(145);
	var textHelper = __webpack_require__(116).Text;
	
	/*
	 * 标签输入框组件
	 */
	var LabelTextInput = React.createClass({
	  displayName: 'LabelTextInput',
	
	
	  renderContent: function renderContent(text) {
	    var textArr = textHelper.delimitToParagraphs(text);
	    if (textArr && textArr.length) {
	      return textArr.map(function (txt, index) {
	        var margin = 2;
	        if (index === 0) {
	          margin = 0;
	        }
	        txt = textHelper.convertSpaceToNbsp(txt);
	        return React.createElement(
	          'div',
	          { key: index, className: 'paragraph' },
	          React.createElement(
	            'p',
	            { style: { marginTop: margin } },
	            textHelper.convertSpaceToNbsp(txt)
	          )
	        );
	      });
	    }
	    return null;
	  },
	
	  render: function render() {
	    var text = styleHelper.getText(this.props);
	    var textArray = textHelper.delimitToWords(text);
	    var titleText = '';
	    var contentText = '';
	    if (textArray.length) {
	      titleText = textArray[0];
	    }
	    if (textArray.length > 1) {
	      contentText = text.replace(titleText + ',', '');
	    }
	    var backgroundStyle = {};
	    var fontColor = styleHelper.getTextColor(this.props);
	    styleHelper.builderTextStyle(this.props, backgroundStyle);
	
	    var textColor = backgroundStyle.color;
	    var titleStyle = {
	      color: fontColor
	    };
	    var inputStyle = {};
	
	    var contentStyle = styleHelper.StyleUtil(this.props).text().style;
	    contentStyle.color = textColor;
	
	    styleHelper.StyleUtil(this.props, titleStyle).text();
	    styleHelper.StyleUtil(this.props, inputStyle).align().text().background().border();
	
	    var labelWrapperClassName = 'contents-layout';
	    if (this.props.textDirection === appTypes.TextDirection.LEFT) {
	      titleText += '  ';
	      labelWrapperClassName += ' label-at-left';
	    } else {
	      titleText = '  ' + titleText + '  ';
	      labelWrapperClassName += ' label-at-right';
	    }
	
	    switch (this.props.textVAlign) {
	      case 'VaTop':
	        labelWrapperClassName += ' vatop';
	        break;
	      case 'VaBottom':
	        labelWrapperClassName += ' vabottom';
	        break;
	      default:
	        labelWrapperClassName += ' vamiddle';
	        break;
	    }
	
	    return React.createElement(
	      'div',
	      { className: labelWrapperClassName, style: backgroundStyle },
	      this.props.textDirection === appTypes.TextDirection.LEFT && React.createElement(
	        'div',
	        { ref: 'title', style: titleStyle, className: 'title' },
	        React.createElement(
	          'label',
	          null,
	          textHelper.convertSpaceToNbsp(titleText)
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'input-rect' },
	        React.createElement(
	          CustomRect,
	          _extends({ ref: 'content' }, inputStyle, { style: { overflow: 'hidden' } }),
	          React.createElement(
	            'div',
	            { ref: 'context', className: 'content', style: contentStyle },
	            this.renderContent(contentText)
	          )
	        )
	      ),
	      this.props.textDirection === appTypes.TextDirection.RIGHT && React.createElement(
	        'div',
	        { ref: 'title', className: 'title', style: titleStyle },
	        React.createElement(
	          'label',
	          null,
	          textHelper.convertSpaceToNbsp(titleText)
	        )
	      )
	    );
	  }
	});
	
	module.exports = LabelTextInput;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var textHelper = __webpack_require__(116).Text;
	
	/*
	 * 链接组
	 */
	
	var LinkBar = React.createClass({
	  displayName: 'LinkBar',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: this.props.selectedIndex
	    };
	  },
	
	  _getArray: function _getArray() {
	    return textHelper.delimitToWords(styleHelper.getText(this.props));
	  },
	
	  render: function render() {
	    this.textArray = this._getArray();
	    var style = styleHelper.StyleUtil(this.props).size().text().lineHeight().default({
	      position: 'absolute',
	      float: 'left'
	    }).style;
	    return React.createElement(
	      'div',
	      { style: style },
	      this.textArray.map(function (text, index) {
	        return React.createElement(
	          'div',
	          { key: index,
	            ref: index,
	            className: 'LinkBar-Item',
	            style: this.getItemTextStyle(index),
	            onClick: this.onItemClick.bind(this, null, index) },
	          React.createElement(
	            'label',
	            null,
	            text
	          )
	        );
	      }, this),
	      this.textArray.map(function (text, index) {
	        if (index < this.textArray.length - 1) {
	          return React.createElement('div', { key: index, ref: 'separator' + index, style: this.getSeparatorStyle() });
	        }
	      }, this)
	    );
	  },
	
	  getSeparatorStyle: function getSeparatorStyle() {
	    var css = {
	      width: 2,
	      top: 1,
	      height: styleHelper.getHeight(this.props) - 2,
	      position: 'absolute',
	      backgroundColor: styleHelper.getBackgroundColor(this.props)
	    };
	    return css;
	  },
	
	  getItemTextStyle: function getItemTextStyle(index) {
	    var css = {
	      height: styleHelper.getHeight(this.props)
	    };
	    if (index === this.state.selectedIndex) {
	      css.color = styleHelper.getBackgroundColor(this.props);
	    }
	    return css;
	  },
	
	  onItemClick: function onItemClick(e, index) {
	    this.setState({ selectedIndex: index });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doAdjustItemBounds();
	    $(ReactDOM.findDOMNode(this)).off('itemClick');
	    $(ReactDOM.findDOMNode(this)).on('itemClick', this.onItemClick);
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doAdjustItemBounds();
	  },
	
	  doAdjustItemBounds: function doAdjustItemBounds() {
	    var i = 0;
	    var l = this.textArray.length;
	    var left = 0;
	    var textItem;
	    var separatorItem;
	    var itemW;
	    var gap = styleHelper.getInt(this.props, propConst.GAP);
	    for (i; i < l; i++) {
	      textItem = ReactDOM.findDOMNode(this.refs[i]);
	      itemW = textItem.clientWidth;
	      $(textItem).css({ left: left });
	      left += itemW;
	      left += gap / 2;
	      if (i < l - 1) {
	        separatorItem = ReactDOM.findDOMNode(this.refs['separator' + i]);
	        $(separatorItem).css({ left: left - 1 });
	        left += gap / 2;
	      }
	    }
	  }
	});
	
	module.exports = LinkBar;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Border = __webpack_require__(168);
	var styleHelper = __webpack_require__(145);
	
	/*
	 * 遮罩组件
	 */
	var ModalScreen = React.createClass({
	  displayName: 'ModalScreen',
	
	
	  render: function render() {
	    var style = {};
	    styleHelper.builderBackgroundStyle(this.props, style);
	    return React.createElement('div', { className: 'component-SimpleCom', style: style });
	  }
	
	});
	
	module.exports = ModalScreen;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	var RuntimeOptions = __webpack_require__(153);
	var DashBorder = __webpack_require__(204);
	var linkHelper = __webpack_require__(158);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-3-29
	 @Descript : 面板组件
	 */
	var Panel = React.createClass({
	  displayName: 'Panel',
	
	  actionData: {},
	  render: function render() {
	    if (this.props.interactiveData || this.props.links) {
	      this.actionData = linkHelper.parseComInteractive(this.props)[0];
	    }
	    var haveAction = this.actionData.externalURL || this.actionData.link || this.actionData.entry;
	    var isLink = this.actionData.externalURL || this.actionData.link;
	    var className = 'no-link';
	    var linkStyle = {
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      userSelect: 'none',
	      position: 'absolute',
	      //此处链接区域应该置于上层
	      //注意检查：改动该属性是否有副作用
	      zIndex: 800,
	      pointerEvents: 'none'
	    };
	    if (haveAction) {
	      if (isLink) {
	        className = 'page-link';
	      } else {
	        className = 'interactive-link';
	      }
	    }
	    var borderProp = _.extend({}, this.props.items[this.props.items.length - 1]);
	    //borderProp.borderColor = this.props.borderColor;
	    borderProp.w = styleHelper.getWidth(this.props);
	    borderProp.h = styleHelper.getHeight(this.props);
	    borderProp.zIndex = borderProp.zOrder || this.props.items.length;
	
	    var panelStyle = {
	      border: 'none',
	      width: '100%',
	      height: '100%',
	      cursor: haveAction ? 'pointer' : 'default'
	    };
	    styleHelper.StyleUtil(this.props, panelStyle).base().background();
	    return React.createElement(
	      'div',
	      {
	        id: this.props.controlID,
	        key: this.props.controlID,
	        className: 'component component-panel',
	        style: panelStyle,
	        onClick: this._onClick,
	        onMouseDown: this._onMouseDown,
	        onMouseUp: this._onMouseUp,
	        onDoubleClick: this._onDblClick,
	        onContextMenu: this._onContentMenu
	      },
	      haveAction && React.createElement('div', { className: className,
	        style: linkStyle
	
	      }),
	      React.createElement(
	        'div',
	        { style: {
	            width: '100%',
	            height: '100%',
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            border: 'none',
	            zIndex: 0,
	            overflow: 'hidden'
	          } },
	        this.props.children
	      ),
	      React.createElement(DashBorder, borderProp)
	    );
	  },
	
	  _onContentMenu: function _onContentMenu(e) {
	    e.nativeEvent.returnValue = false;
	    return false;
	  },
	
	  _onLinkEvent: function _onLinkEvent(evt, linkKey) {
	    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
	    this.props.events.doSelfClick(evt, this.props, linkKey, 0);
	  },
	
	  _onClick: function _onClick(e) {
	    var key;
	    if (this.longPress) {
	      return;
	    }
	    if (e.button === 0) {
	      if (this.actionData.externalURL) {
	        key = appTypes.ActionResponseType.OUTER;
	      } else if (this.actionData.link) {
	        key = appTypes.ActionResponseType.LINK;
	      } else if (this.actionData.entry) {
	        key = appTypes.ActionResponseType.INTERACTIVE;
	      }
	      if (key) {
	        this._onLinkEvent(e, key);
	      }
	    }
	  },
	
	  _onLongPress: function _onLongPress(evt) {
	    if (this.props.events.doSelfLongPress) this.props.events.doSelfLongPress(evt, this.props, 0);
	  },
	
	  _onRightClick: function _onRightClick(evt) {
	    if (this.props.events.doSelfRightClick) {
	      this.props.events.doSelfRightClick(evt, this.props, 0);
	    }
	  },
	
	  _onDblClick: function _onDblClick(evt) {
	    if (this.props.events.doSelfDbClick) {
	      this.props.events.doSelfDbClick(evt, this.props, 0);
	    }
	  },
	
	  _onMouseDown: function _onMouseDown(e) {
	    if (e.button === 0) {
	      this.mousePress = true;
	      this._startLongPress(e);
	    } else if (e.button === 2) {
	      this._onRightClick(e);
	    }
	  },
	
	  _onMouseUp: function _onMouseUp(e) {
	    this.mousePress = false;
	    this._stopLongPress();
	  },
	  _startLongPress: function _startLongPress(e) {
	    var self = this;
	    self.longPress = false;
	    if (linkHelper.hasLongPressEvents(this.props.interactiveData, 0)) {
	      this.longPressTimeID = setTimeout(function () {
	        if (self.mousePress) {
	          self.longPress = true;
	          self._onLongPress(e);
	        }
	        self._stopLongPress();
	      }, 800);
	    }
	  },
	
	  _stopLongPress: function _stopLongPress() {
	    if (this.longPressTimeID) {
	      clearTimeout(this.longPressTimeID);
	    }
	    delete this.longPressTimeID;
	  }
	});
	module.exports = Panel;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	var appTypes = __webpack_require__(115);
	
	/**
	 * LineModeBorder
	 * @author mxj
	 * @createDate 2016/8/22
	 **/
	
	var LineModeBorder = React.createClass({
	  displayName: 'LineModeBorder',
	
	
	  render: function render() {
	    var style = {
	      top: 0,
	      left: 0,
	      width: '100%',
	      height: '100%',
	      position: 'absolute',
	      pointerEvents: 'none',
	      zIndex: this.props.zIndex || 10
	    };
	    return React.createElement('canvas', { ref: 'ctx',
	      className: 'component component-line-mode-border',
	      style: style });
	  },
	
	  onPaint: function onPaint() {
	    this.doPaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doPaint();
	    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_PAINT, this.onPaint);
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doPaint();
	  },
	
	  doPaint: function doPaint() {
	    var ctx = ReactDOM.findDOMNode(this.refs.ctx);
	    var graphics = ctx.getContext('2d');
	    var w = ctx.clientWidth;
	    var h = ctx.clientHeight;
	    ctx.width = w;
	    ctx.height = h;
	    graphicsHelper.drawRect(graphics, 0, 0, w, h, this.props);
	  }
	});
	
	module.exports = LineModeBorder;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Border = __webpack_require__(168);
	var appTypes = __webpack_require__(115);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	
	/*
	 * 进度条组件
	 */
	var ProgressBar = React.createClass({
	  displayName: 'ProgressBar',
	
	
	  render: function render() {
	    var isBar = styleHelper.getPropertyValue(this.props, propConst.BAR_STYLE) === appTypes.ProgressBarStyle.BAR;
	
	    var indicatorStyle;
	    var trackBackgroundStyle;
	    var progress = parseInt(styleHelper.getInt(this.props, propConst.PROGRESS), 10);
	    var stripeStyle;
	    var bgStyle = styleHelper.StyleUtil(this.props).size().border().style;
	
	    indicatorStyle = {
	      width: styleHelper.getWidth(this.props) * (progress / 100),
	      backgroundColor: styleHelper.getPropertyValue(this.props, propConst.INDICATOR_COLOR)
	    };
	
	    trackBackgroundStyle = {
	      backgroundColor: styleHelper.getPropertyValue(this.props, propConst.TRACK_COLOR)
	    };
	
	    stripeStyle = {
	      backgroundImage: 'url(' + assetsHelper.getComponentAsset('progressThumb') + ')',
	      backgroundColor: trackBackgroundStyle.backgroundColor
	    };
	
	    //bgStyle.backgroundColor = this.props.trackColor;
	    return React.createElement(
	      'div',
	      { style: bgStyle },
	      isBar ? React.createElement(
	        'div',
	        { className: 'track', style: trackBackgroundStyle },
	        React.createElement('div', { className: 'indicator', style: indicatorStyle })
	      ) : React.createElement('div', { className: 'stripe', style: stripeStyle })
	    );
	  }
	
	});
	
	module.exports = ProgressBar;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var _ = __webpack_require__(51);
	var RadioItem = __webpack_require__(207);
	var propConst = __webpack_require__(147);
	
	/*
	 * 单选按钮组件
	 */
	var RadioButton = React.createClass({
	  displayName: 'RadioButton',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      selected: appTypes.ComStatus.isSelected(this.props.state),
	      disabled: appTypes.ComStatus.isDisabled(this.props.state)
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var newSelected = appTypes.ComStatus.isSelected(newProps.state);
	    var newDisabled = appTypes.ComStatus.isDisabled(newProps.state);
	    if (newSelected !== this.state.selected || newDisabled !== this.state.disabled) {
	      this.setState({ selected: newSelected });
	    }
	  },
	
	  render: function render() {
	    var state = styleHelper.getPropertyValue(this.props, propConst.STATE);
	    var props = _.extend({}, this.props);
	    props.isSelected = this.state.selected;
	    props.isDisabled = this.state.disabled;
	    props.onSelected = this.onSelected;
	    props.gap = 5;
	    props.text = styleHelper.getText(this.props);
	    if (props.stateProperties) {
	      props.isSelected = appTypes.ComStatus.isSelected(state);
	      props.isDisabled = appTypes.ComStatus.isDisabled(state);
	    }
	    return React.createElement(RadioItem, props);
	  },
	
	  onSelected: function onSelected() {
	    this.setState({ selected: true });
	  }
	});
	
	module.exports = RadioButton;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var styleHelper = __webpack_require__(145);
	var AutoSizeHelper = __webpack_require__(167);
	var appTypes = __webpack_require__(115);
	var RadioIcon = __webpack_require__(208);
	
	/**
	 * CheckBoxItem
	 * @author mxj
	 * @createDate 2016-8-3
	 **/
	
	var RadioItem = React.createClass({
	  displayName: 'RadioItem',
	  _doPaint: function _doPaint() {
	    var selfDom = ReactDOM.findDOMNode(this);
	    var parentDom;
	    var measureSize;
	
	    parentDom = selfDom.parentElement;
	    while (!parentDom && parentDom.id !== this.props.controlID) {
	      parentDom = parentDom.parentElement;
	    }
	
	    if (parentDom) {
	      measureSize = AutoSizeHelper.getComAutoSize(this.props);
	      parentDom.style.width = measureSize.width + 20 + 'px';
	    }
	  },
	
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.text !== this.props.text) {
	      this.isInvalid = true;
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._doPaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._doPaint();
	  },
	
	  render: function render() {
	    this.isLeftText = this.props.textDirection === appTypes.TextDirection.LEFT;
	    var divStyle;
	    var textStyle;
	    var size = parseInt(this.props.size, 10) || 16;
	    var gap = parseInt(this.props.gap, 10) || 0;
	
	    divStyle = {
	      width: '100%',
	      height: '100%',
	      opacity: this.props.isDisabled ? 0.6 : 1,
	      overflow: 'hidden',
	      pointerEvents: this.props.isDisabled ? 'none' : 'auto'
	    };
	
	    textStyle = {
	      left: this.isLeftText ? 0 : size + gap,
	      top: 0,
	      height: styleHelper.getHeight(this.props),
	      width: styleHelper.getWidth(this.props) - size - gap,
	      lineHeight: styleHelper.getHeight(this.props) + 'px',
	      position: 'absolute',
	      textDecoration: 'inherit',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    };
	    styleHelper.StyleUtil(this.props).default(divStyle).text().align();
	    return React.createElement(
	      'div',
	      { style: divStyle, onClick: this._onClick },
	      React.createElement(RadioIcon, {
	        enabled: _.isUndefined(this.props.enabled) ? true : this.props.enabled,
	        size: size,
	        color: this.props.borderColor,
	        left: this.props.textDirection === appTypes.TextDirection.RIGHT ? 0 : styleHelper.getWidth(this.props) - (this.props.size || 16),
	        top: (styleHelper.getHeight(this.props) - (this.props.size || 16)) / 2,
	        isSelected: this.props.isSelected,
	        borderColor: styleHelper.getBorderColor(this.props)
	      }),
	      React.createElement(
	        'div',
	        { style: textStyle },
	        React.createElement(
	          'label',
	          null,
	          this.props.text
	        )
	      )
	    );
	  },
	
	  _onClick: function _onClick() {
	    if (!this.props.isDisabled) {
	      if (this.props.onSelected) {
	        this.props.onSelected();
	      }
	    }
	  }
	});
	
	module.exports = RadioItem;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	
	var RadioIcon = React.createClass({
	  displayName: 'RadioIcon',
	
	  propTypes: {
	    isSelected: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.string]),
	    size: React.PropTypes.number,
	    color: React.PropTypes.string,
	    left: React.PropTypes.number,
	    top: React.PropTypes.number,
	    enabled: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.string])
	  },
	
	  defaultSize: 16,
	
	  render: function render() {
	    var enabled = true;
	    if (this.props.enabled !== undefined) {
	      enabled = this.props.enabled === true || this.props.enabled === 'true';
	    }
	    var style = {
	      width: this.props.size || this.defaultSize,
	      height: this.props.size || this.defaultSize,
	      left: this.props.left || 0,
	      top: this.props.top || 0,
	      position: this.props.position || 'absolute',
	      cursor: 'pointer',
	      pointerEvents: enabled ? 'auto' : 'none'
	    };
	    return React.createElement('canvas', { style: style, width: style.width, height: style.width, onClick: this.props.onClick });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.repaint();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.repaint();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  repaint: function repaint() {
	    var canvas = ReactDOM.findDOMNode(this);
	    var graphics = canvas.getContext('2d');
	    var self = this;
	    var size = this.props.size || this.defaultSize;
	    var centerX = size / 2;
	    var centerY = size / 2;
	    var radius;
	    var strokeColor = styleHelper.getBorderColor(this.props) || '#000';
	    var ratio = graphicsHelper.applyDeviceRatio(graphics, size, size);
	    this.requestID = window.requestAnimationFrame(function () {
	      graphics.clearRect(0, 0, size * ratio, size * ratio);
	      graphics.fillStyle = '#fff';
	      graphics.strokeStyle = strokeColor;
	
	      graphics.lineWidth = ratio;
	      graphics.beginPath();
	      radius = size / 2 - 0.5;
	      radius = radius * ratio;
	      centerX *= ratio;
	      centerY *= ratio;
	      graphics.arc(centerX, centerY, radius, 0, 360);
	      graphics.closePath();
	      graphics.fill();
	      graphics.stroke();
	      if (self.props.isSelected) {
	        graphics.beginPath();
	        radius = size / 4;
	        radius *= ratio;
	        graphics.arc(centerX, centerY, radius, 0, 360);
	        graphics.fillStyle = strokeColor;
	        graphics.closePath();
	        graphics.fill();
	      }
	    });
	  }
	});
	
	module.exports = RadioIcon;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var appTypes = __webpack_require__(115);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var AutoSizeHelper = __webpack_require__(167);
	var RadioItem = __webpack_require__(207);
	var styleHelper = __webpack_require__(145);
	var LinkHelper = __webpack_require__(158);
	var util = __webpack_require__(116);
	
	var RadioButtonGroup = React.createClass({
	  displayName: 'RadioButtonGroup',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: this.props.selectedIndex
	    };
	  },
	
	  parseItem: function parseItem(itemText) {
	    var item = JSON.parse(JSON.stringify(this.props));
	    var cfg;
	    cfg = this.parseState(itemText);
	    item.text = cfg.text;
	    item.gap = 5;
	    return item;
	  },
	
	  parseState: function parseState(text) {
	    var disabled = false;
	    text = text.trim();
	
	    if (text.indexOf('()') === 0) {
	      text = text.replace('()', '');
	    } else if (text.indexOf('( )') === 0) {
	      text = text.replace('( )', '');
	    } else if (text.indexOf('(o)') === 0) {
	      text = text.replace('(o)', '');
	    } else if (text.indexOf('(O)') === 0) {
	      text = text.replace('(O)', '');
	    } else if (text.charAt(0) === '-' && text.charAt(text.length - 1) === '-') {
	      text = text.substring(1, text.length - 1);
	      disabled = true;
	      if (text.indexOf('(o)') === 0) {
	        text = text.replace('(o)', '');
	      } else if (text.indexOf('(O)') === 0) {
	        text = text.replace('(O)', '');
	      } else if (text.indexOf('()') === 0) {
	        text = text.replace('()', '');
	      } else if (text.indexOf('( )') === 0) {
	        text = text.replace('( )', '');
	      }
	    };
	
	    return {
	      isDisabled: disabled,
	      text: text
	    };
	  },
	
	  parseItems: function parseItems() {
	    var TextUtil = util.Text;
	
	    {/*
	       var text = styleHelper.getText(this.props);
	       text = TextUtil.removeLastEmptyRow(text);
	      */}
	
	    var text = TextUtil.removeLastEmptyRow(styleHelper.getText(this.props));
	
	    var textArray = TextUtil.delimitText(text, TextUtil.DM_RETURN);
	    var i;
	    var itemText;
	    var resultArray = [];
	    var links = LinkHelper.tranItemRect(this.props.itemRect) || this.props.links.link;
	    var item;
	    var rect;
	    for (i = 0; i < textArray.length; i++) {
	      itemText = textArray[i].trim();
	      item = this.parseItem(itemText);
	      rect = links[i].area ? links[i].area.coords : links[i];
	      item.x = rect.left;
	      item.y = rect.top;
	      item.w = rect.width;
	      item.h = rect.height;
	      resultArray.push(item);
	    }
	
	    return resultArray;
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).on('itemClick', this.onItemClick);
	  },
	
	  render: function render() {
	    var itemArray = this.parseItems();
	    var itemStyle;
	    var style = styleHelper.StyleUtil(this.props).default({
	      overflow: 'hidden',
	      position: 'absolute'
	    }).size().text().align().style;
	    return React.createElement(
	      'div',
	      { style: style },
	      itemArray.map(function (item, index) {
	        item.isSelected = index === this.state.selectedIndex;
	        itemStyle = styleHelper.StyleUtil(item).default({ position: 'absolute' }).bounds().style;
	        return React.createElement(
	          'div',
	          { key: index, style: itemStyle, onClick: this.onSelect.bind(this, index) },
	          React.createElement(RadioItem, item)
	        );
	      }, this)
	    );
	  },
	
	  onSelect: function onSelect(index) {
	    this.setState({ selectedIndex: index });
	  },
	
	  onItemClick: function onItemClick(e, index) {
	    this.onSelect(index);
	  }
	
	});
	
	module.exports = RadioButtonGroup;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var appTypes = __webpack_require__(115);
	var graphicsHelper = __webpack_require__(172);
	var interactiveManager = __webpack_require__(150);
	var propConst = __webpack_require__(147);
	var VerticalScrollBar = __webpack_require__(178);
	var HorizontalScrollBar = __webpack_require__(184);
	var TextParts = __webpack_require__(211);
	var util = __webpack_require__(116);
	var _ = __webpack_require__(51);
	
	var Shape = React.createClass({
	  displayName: 'Shape',
	
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  paint: function paint(props) {
	    if (this.fallbackToDiv()) {
	      return;
	    }
	    var color = styleHelper.getBackgroundColor(this.props);
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var radius = styleHelper.getRadius(this.props);
	    var dashMode = styleHelper.parseDashMode(styleHelper.getPropertyValue(this.props, propConst.DASH_MODE));
	    //todo :PC上的形状的三角形的旋转方向居然与其它的旋转方向是相反的！！！
	    var triangleType = this.props.triangleType;
	    if (triangleType === appTypes.RotationAngle.NINETY) {
	      triangleType = appTypes.RotationAngle.TWO_HUNDRED_SEVENTY;
	    } else if (triangleType === appTypes.RotationAngle.TWO_HUNDRED_SEVENTY) {
	      triangleType = appTypes.RotationAngle.NINETY;
	    }
	    var ctx = canvas.getContext('2d');
	    var borderVisible = this.getBorderVisible() || {};
	    graphicsHelper.drawShpae(ctx, {
	      width: w,
	      height: h,
	      dashMode: dashMode,
	      borderType: this.props.shapeBorderType,
	      borderVisible: styleHelper.getPropertyValue(this.props, propConst.BORDER_VISIBLE),
	      borderColor: styleHelper.getBorderColor(this.props),
	      fillColor: color,
	      radius: radius,
	      borderWidth: styleHelper.getBorderWidth(this.props),
	      triangleType: triangleType,
	      borderLeft: borderVisible.left,
	      borderTop: borderVisible.top,
	      borderRight: borderVisible.right,
	      borderBottom: borderVisible.bottom
	    });
	  },
	
	  /***
	   * 获取每个边的 border 是否显示
	   * @returns {{left: *, top: *, right: *, bottom: *}}
	   */
	  getBorderVisible: function getBorderVisible() {
	    var visible = styleHelper.getBorderVisible(this.props);
	    if (visible) {
	      if (this.props.rectangleBorderLeftVisible !== undefined) {
	        //兼容数据精简后格式
	        return {
	          left: this.props.rectangleBorderLeftVisible,
	          top: this.props.rectangleBorderTopVisible,
	          right: this.props.rectangleBorderRightVisible,
	          bottom: this.props.rectangleBorderBottomVisible
	        };
	      }
	      var str = this.props.borderMode;
	      var result = {};
	      if (str.indexOf("bmLeft") !== -1) {
	        result.left = true;
	      }
	      if (str.indexOf("bmTop") !== -1) {
	        result.top = true;
	      }
	      if (str.indexOf("bmRight") !== -1) {
	        result.right = true;
	      }
	      if (str.indexOf("bmBottom") !== -1) {
	        result.bottom = true;
	      }
	      return result;
	    }
	    return null;
	  },
	
	  /**
	   * 该组件的边框能直接用 css 实现吗？
	   * @returns {boolean}
	   */
	  isThisBorderCanUseCss: function isThisBorderCanUseCss() {
	    var dashMode = this.props.dashMode;
	    return dashMode !== 'dash-dot-dot' && dashMode !== 'dash-dot';
	  },
	
	  doAdjustLinkArea: function doAdjustLinkArea() {
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    ///if(interactiveManager.isWorking(this.props)) {    //正在执行交互时不应用宽高
	    //w = 0;
	    //h = 0;
	    //}
	    var plink = $('#' + this.props.controlID + ' .page-link');
	    var interactiveLink = $('#' + this.props.controlID + ' .interactive-link');
	
	    if (plink) {
	      plink.css({
	        width: w,
	        height: h
	      });
	    }
	    if (interactiveLink) {
	      interactiveLink.css({
	        width: w,
	        height: h
	      });
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(props) {
	    this.paint(props);
	    this.doAdjustLinkArea();
	
	    var rectStyle = {};
	    var borderVisible = this.getBorderVisible();
	    if (borderVisible) {
	      if (!borderVisible.top) {
	        rectStyle['border-top-left-radius'] = '0';
	        rectStyle['border-top-right-radius'] = '0';
	        rectStyle['border-top'] = 'none';
	      }
	
	      if (!borderVisible.left) {
	        rectStyle['border-top-left-radius'] = '0';
	        rectStyle['border-bottom-left-radius'] = '0';
	        rectStyle['border-left'] = 'none';
	      }
	
	      if (!borderVisible.right) {
	        rectStyle['border-top-right-radius'] = '0';
	        rectStyle['border-bottom-right-radius'] = '0';
	        rectStyle['border-right'] = 'none';
	      }
	
	      if (!borderVisible.bottom) {
	        rectStyle['border-bottom-right-radius'] = '0';
	        rectStyle['border-bottom-left-radius'] = '0';
	        rectStyle['border-bottom'] = 'none';
	      }
	    }
	    $(ReactDOM.findDOMNode(this.refs.rectShape)).css(rectStyle);
	  },
	  componentDidMount: function componentDidMount(props) {
	    this.paint(props);
	    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_PROPS_CHANGE, this.onPropsChange).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize);
	  },
	
	  onResize: function onResize() {
	    $(ReactDOM.findDOMNode(this.refs.text)).trigger(appTypes.CUSTOM_EVENT.ON_PAINT, [this.props.controlID]);
	    this.paint(this.props);
	  },
	
	  onPropsChange: function onPropsChange(propName, propValue) {
	    var o = {};
	    o[propName] = propValue;
	    this.setState(o);
	  },
	
	  render: function render() {
	    var text = styleHelper.getText(this.props);
	    this.currentW = styleHelper.getWidth(this.props);
	    this.currentH = styleHelper.getHeight(this.props);
	    var isShowScrollBar = this.props.shapeBorderType === appTypes.ShapeType.RECTANGLE && (this.props.verticalScrollbarShow || this.props.horizontalScrollbarShow);
	    var verticalScrollBarHeight;
	    var horizontalScrollBarWidth;
	    var thickness = styleHelper.getBorderWidth(this.props);
	    if (text) {
	      var textArray = util.Text.delimitToParagraphs(text);
	      this.isMultiLineText = textArray.length > 1;
	    }
	    if (isShowScrollBar) {
	      if (this.props.verticalScrollbarShow && this.props.horizontalScrollbarShow) {
	        verticalScrollBarHeight = this.currentH - 12 - 2 * thickness - 4;
	        horizontalScrollBarWidth = this.currentW - 12 - 2 * thickness - 4;
	      }
	    }
	    var mainBoxStyle = {
	      position: 'absolute',
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      overflow: 'hidden',
	      boxSizing: 'border-box'
	    };
	    var textStyle = { overflow: 'hidden' };
	
	    var w = styleHelper.getWidth(this.props) - 2;
	    var h = styleHelper.getHeight(this.props);
	    textStyle.width = w;
	    textStyle.height = h;
	    // textStyle.lineHeight = styleHelper.getHeight(this.props) + 'px';
	    if (this.props.horizontalScrollbarShow) {
	      textStyle.height -= 16;
	    }
	    if (this.props.verticalScrollbarShow) {
	      textStyle.width -= 16;
	    }
	    return React.createElement(
	      'div',
	      {
	        id: this.props.id,
	        style: mainBoxStyle,
	        key: this.props.controlID + '-shape' },
	      this.renderShape(),
	      text &&
	      //<p style={{marginTop:0, marginBottom:0,textAlign:'center',overflow: 'hidden'}}>
	      //<span style={{width:'100%',height:'100%',textAlign:'center'}}>{text}</span>
	      //</p>
	      React.createElement(
	        'div',
	        { style: { width: w, height: h, position: 'absolute', left: 1, zIndex: 10 } },
	        React.createElement(TextParts, _extends({ ref: 'text', zIndex: 1 }, this.props, { partStyle: textStyle }))
	      ),
	      isShowScrollBar && this.props.horizontalScrollbarShow && React.createElement(HorizontalScrollBar, {
	        value: util.Int(this.props.horizontalScrollbarProgress),
	        width: horizontalScrollBarWidth
	      }),
	      isShowScrollBar && this.props.verticalScrollbarShow && React.createElement(VerticalScrollBar, {
	        value: util.Int(this.props.verticalScrollbarProgress),
	        height: verticalScrollBarHeight
	      })
	    );
	  },
	
	  // 当形状是矩形，并且没有圆角，并且没有边框时，使用 div
	  //DON'TFIXME: 这样处理的原因是用户经常使用形状组件作为 tab bar 的背景，在上面放了图标，在 iOS Safari 上可能会导致上面的组件显示不出来！
	  fallbackToDiv: function fallbackToDiv() {
	    return this.props.shapeBorderType === 'SbRectangle' && (this.props.borderVisible === false || this.isThisBorderCanUseCss());
	  },
	
	  renderShape: function renderShape() {
	    var shapeStyle = {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      width: '100%',
	      height: '100%',
	      boxSizing: 'border-box'
	    };
	    var borderVisible = this.getBorderVisible();
	    if (this.props.radiusIsPercent) {
	      var length = Math.min(this.props.w, this.props.h);
	      length = length * this.props.radius / 200;
	      if (borderVisible) {
	        length = length + this.props.thickness;
	      } else {
	        length = length + this.props.thickness * 2;
	      }
	      shapeStyle.borderRadius = length;
	    } else {
	      shapeStyle.borderRadius = this.props.radius;
	    }
	
	    // 如果要使用 div，先指定背景色和 border， 这里必须先指定，因为后续会有特殊规则覆盖这里的普遍规则
	    if (this.fallbackToDiv()) {
	      shapeStyle.backgroundColor = styleHelper.getBackgroundColor(this.props);
	      if (borderVisible) {
	        shapeStyle.border = this.props.thickness + 'px ' + this.props.dashMode + ' ' + styleHelper.getBorderColor(this.props);
	      }
	    }
	
	    if (borderVisible) {
	      if (!borderVisible.top) {
	        shapeStyle.borderTopLeftRadius = 0;
	        shapeStyle.borderTopRightRadius = 0;
	        shapeStyle.borderTop = 'none';
	      }
	
	      if (!borderVisible.left) {
	        shapeStyle.borderTopLeftRadius = 0;
	        shapeStyle.borderBottomLeftRadius = 0;
	        shapeStyle.borderLeft = 'none';
	      }
	
	      if (!borderVisible.right) {
	        shapeStyle.borderTopRightRadius = 0;
	        shapeStyle.borderBottomRightRadius = 0;
	        shapeStyle.borderRight = 'none';
	      }
	
	      if (!borderVisible.bottom) {
	        shapeStyle.borderBottomRightRadius = 0;
	        shapeStyle.borderBottomLeftRadius = 0;
	        shapeStyle.borderBottom = 'none';
	      }
	    }
	
	    if (this.fallbackToDiv()) {
	      // 矩形
	      return React.createElement('div', { ref: 'rectShape', style: shapeStyle });
	    }
	
	    shapeStyle.zIndex = -1;
	    return React.createElement('canvas', {
	      ref: 'canvas',
	      style: shapeStyle,
	      onChange: this.paint.bind(this, this.props),
	      width: this.currentW,
	      height: this.currentH });
	  }
	
	});
	
	module.exports = Shape;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDom = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var convertHelper = __webpack_require__(146);
	var styleHelper = __webpack_require__(145);
	var _ = __webpack_require__(51);
	var tool = __webpack_require__(121);
	var GlobalConst = __webpack_require__(164);
	var util = __webpack_require__(116);
	var measureTextHelper = __webpack_require__(148);
	
	var TextParts = React.createClass({
	  displayName: 'TextParts',
	
	
	  propTypes: {
	    partStyle: React.PropTypes.object,
	    showText: React.PropTypes.string
	  },
	
	  textStyle: function textStyle() {
	    var style = styleHelper.builderTextStyle(this.props);
	    var textHeight = measureTextHelper.measureTextWidth(style, 'YMK').height;
	
	    this.offset = Math.floor((lineHeight - textHeight) / 2);
	    //this.offset = Math.floor((lineHeight - textHeight)/(this.props.lineSpacingMultiple||1));
	    //console.log('fontFamily=',style.fontFamily,'\nfontSize=',style.fontSize,'\ntextHeight=',textHeight,'\nlineHeight=',lineHeight,'\noffsetTop=',this.offset);
	    var textStyle = _.extend(style, {
	      left: 0,
	      top: 0,
	      width: '100%',
	      height: '100%',
	      position: 'relative',
	      wordWrap: this.props.textWordWrap ? 'break-word' : 'nowrap',
	      wordBreak: 'break-word',
	      boxSizing: 'border-box',
	      zIndex: this.props.zIndex || 10
	    });
	
	    // 原来的老版本数据，有些没有 lineHeight，导致取出来为0，这时不能去设置为 0
	    var lineHeight = styleHelper.builderLineHeight(this.props);
	    if (lineHeight) {
	      textStyle.lineHeight = lineHeight + 'px';
	    } else {
	      textStyle.lineHeight = '1em';
	    }
	    return tool.extendObj(textStyle, this.props.partStyle);
	  },
	
	  render: function render() {
	    var textArray;
	    var divStyle;
	    var labelStyle;
	    var pStyle;
	    var divMultiStyle;
	    var showText;
	    var i;
	    var w;
	    var scale = 1;
	    var usePtag = this.props.textWordWrap;
	    var fontSize = styleHelper.getFontSize(this.props);
	    if (_.isUndefined(usePtag)) {
	      usePtag = false;
	    }
	    if (this.props.partStyle && this.props.partStyle) {
	      w = this.props.partStyle.width;
	    }
	    if (!w) {
	      w = styleHelper.getWidth(this.props);
	    }
	    showText = styleHelper.getText(this.props);
	    showText = util.Text.removeLastEmptyRow(showText);
	    textArray = util.Text.delimitText(showText, util.Text.DM_RETURN);
	    this.isMultiLineText = textArray.length > 1;
	    if (this.isMultiLineText) {
	      for (i = 0; i < textArray.length; i++) {
	        textArray[i] = util.Text.replaceIndentSpace(util.Text.convertSpaceToNbsp(textArray[i]));
	      }
	      usePtag = true;
	    } else {
	      showText = util.Text.replaceIndentSpace(util.Text.convertSpaceToNbsp(showText));
	      if (textArray.length) textArray[0] = showText;
	    }
	
	    divStyle = this.textStyle();
	
	    labelStyle = convertHelper.getTextAlign(this.props.textAlign, this.props.textVAlign);
	    labelStyle = _.extend(labelStyle, {
	      width: '100%',
	      textAlign: convertHelper.getTextHorizontalAlign(this.props.textAlign),
	      whiteSpace: !this.props.textWordWrap ? 'nowrap' : 'normal',
	      wordBreak: 'normal',
	      wordWrap: 'break-word',
	      textDecoration: this.props.textStyles ? this.props.textStyles.textDecoration : 'normal'
	    });
	
	    if (fontSize < 12) {
	      scale = fontSize / 12;
	      w = w / scale;
	    }
	
	    pStyle = {
	      margin: '0',
	      padding: 0,
	      width: w,
	      transform: 'scale(' + scale + ')',
	      transformOrigin: 'top left',
	      textOverflow: 'clip',
	      whiteSpace: !this.props.textWordWrap ? 'nowrap' : 'normal',
	      textAlign: convertHelper.getTextHorizontalAlign(this.props.textAlign),
	      textDecoration: this.props.textStyles ? this.props.textStyles.textDecoration : 'normal',
	      userSelect: 'text'
	
	    };
	
	    divMultiStyle = styleHelper.StyleUtil(this.props).align().default({
	      left: 0,
	      width: w,
	      overflow: 'hidden',
	      position: 'absolute'
	    }).style; //  convertHelper.builderTextAlign(this.props.textAlign, this.props.textVAlign);
	
	    if (usePtag) {
	      divMultiStyle.lineHeight = 'inherit';
	    }
	
	    var valign = this.props.textVAlign;
	    switch (valign) {
	      case appTypes.VertAlign.TOP:
	        divMultiStyle.top = 0;
	        break;
	      case appTypes.VertAlign.MIDDLE:
	        divMultiStyle.top = '50%';
	        divMultiStyle.transform = 'translateY(-50%)';
	        break;
	      case appTypes.VertAlign.BOTTOM:
	        divMultiStyle.bottom = 0;
	        break;
	    }
	
	    return React.createElement(
	      'div',
	      { style: divStyle },
	      !usePtag ? React.createElement(
	        'label',
	        { ref: 'lab', style: labelStyle },
	        showText
	      ) : React.createElement(
	        'div',
	        { ref: 'p', style: divMultiStyle },
	        textArray.map(function (text, idx) {
	          if (text.trim()) {
	            return React.createElement(
	              'p',
	              { key: idx, style: pStyle },
	              React.createElement(
	                'span',
	                null,
	                text
	              )
	            );
	          }
	          return React.createElement('br', { key: idx });
	        }, this)
	      )
	    );
	  },
	
	  splitSpace: function splitSpace(text) {
	    return text.trim().split(' ');
	  }
	});
	
	module.exports = TextParts;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var appTypes = __webpack_require__(115);
	var projectLoadHelper = __webpack_require__(68);
	var graphicsHelper = __webpack_require__(172);
	var _ = __webpack_require__(51);
	var util = __webpack_require__(116);
	
	/**
	 * Gif组件
	 * @author Allen
	 * @createDate 2017/7/13
	 **/
	
	var Triangle = React.createClass({
	  displayName: 'Triangle',
	
	
	  componentDidMount: function componentDidMount() {
	    this.paint(this.props);
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.paint(this.props);
	  },
	
	  render: function render() {
	    var shapeStyle = {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      width: '100%',
	      height: '100%',
	      boxSizing: 'border-box'
	    };
	
	    shapeStyle.zIndex = -1;
	    return React.createElement('canvas', {
	      ref: 'canvas',
	      style: shapeStyle,
	      onChange: this.paint.bind(this, this.props),
	      width: styleHelper.getWidth(this.props),
	      height: styleHelper.getHeight(this.props) });
	  },
	
	  paint: function paint(props) {
	    var color = styleHelper.getBackgroundColor(this.props);
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var dashMode = styleHelper.parseDashMode(styleHelper.getPropertyValue(this.props, propConst.DASH_MODE));
	    var ctx = canvas.getContext('2d');
	    graphicsHelper.drawTriangle(ctx, {
	      width: w,
	      height: h,
	      dashMode: dashMode,
	      borderType: appTypes.ShapeType.TRIANGLE,
	      borderVisible: styleHelper.getPropertyValue(this.props, propConst.BORDER_VISIBLE),
	      borderColor: styleHelper.getBorderColor(this.props),
	      fillColor: color,
	      borderWidth: styleHelper.getBorderWidth(this.props),
	      triangleType: styleHelper.getPropertyValue(this.props, 'triangleType'),
	      triangleDirection: styleHelper.getPropertyValue(this.props, 'triangleDirection')
	    });
	  }
	
	});
	
	module.exports = Triangle;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var ScrollBox = __webpack_require__(214);
	var Border = __webpack_require__(204);
	var styleHelper = __webpack_require__(145);
	var tool = __webpack_require__(121);
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-3-31
	 @Descript : 滚动区组件
	 */
	var ScrollView = React.createClass({
	  displayName: 'ScrollView',
	
	  ENABLED_DRAG: false,
	
	  getInitialState: function getInitialState() {
	    return {
	      scrollLeft: 0,
	      scrollTop: 0,
	      showScrollBar: false
	    };
	  },
	
	  currentScrollPoints: {
	    x: 0,
	    y: 0
	  },
	
	  render: function render() {
	    var content = this.props.items[0];
	    return React.createElement(
	      'div',
	      { key: 'scrollView', style: {
	          width: '100%',
	          height: '100%',
	          borderWidth: '1px',
	          borderColor: styleHelper.getBorderColor(this.props),
	          backgroundColor: styleHelper.getBackgroundColor(this.props),
	          overflow: 'hidden',
	          zIndex: this.props.zOrder
	        }
	        // onMouseDown={this.onMouseDown}
	        // onMouseUp={this.onMouseUp}
	        // onMouseMove={this.onMouseMove}
	        // onMouseLeave={this.onMouseLeave}
	        , onScroll: this.onSelfScroll
	      },
	      React.createElement(
	        ScrollBox,
	        {
	          ref: 'scrollbox',
	          id: this.props.controlID + '-scrollbox',
	          scrollTop: this.state.scrollTop,
	          scrollLeft: this.state.scrollLeft,
	          onScroll: this.onScroll,
	          scrollBarStyle: this.props.showScrollBars ? 'show' : 'hide',
	          disableHScroll: !this.props.canHoriScroll,
	          disableVScroll: !this.props.canVertScroll,
	          dragToScroll: true
	        },
	        React.createElement(
	          'div',
	          { ref: 'viewPort', style: {
	              width: content.w,
	              height: content.h,
	              overflow: 'hidden'
	            } },
	          this.props.children
	        )
	      ),
	      this.props.borderVisible && React.createElement(Border, { borderVisible: true, borderColor: styleHelper.getBorderColor(this.props), zIndex: 2 })
	    );
	  },
	
	  onSelfScroll: function onSelfScroll(e) {
	    e.stopPropagation();
	  },
	
	  onScroll: function onScroll(top, left) {
	    //this.setState({
	    //  scrollLeft: left,
	    //  scrollTop: top
	    //});
	    if (!this.hasShow) {
	      tool.setThumbOpaicty(ReactDOM.findDOMNode(this), 1);
	      this.hasShow = true;
	    }
	
	    this.currentScrollPoints = {
	      x: left,
	      y: top
	    };
	
	    this.startAutoSetState();
	  },
	
	  startAutoSetState: function startAutoSetState() {
	    var self = this;
	    if (this.autoScrolltimeID) clearTimeout(this.autoScrolltimeID);
	    this.autoScrolltimeID = setTimeout(function () {
	      clearTimeout(self.autoScrolltimeID);
	      self.setState({
	        scrollLeft: self.currentScrollPoints.x,
	        scrollTop: self.currentScrollPoints.y,
	        showScrollBar: true
	      });
	    }, 200);
	  },
	
	  // onMouseDown: function (e) {
	  //   e.stopPropagation();
	  //   this.mousePress = true;
	  //   this.downPoint = {
	  //     x: e.nativeEvent.layerX,
	  //     y: e.nativeEvent.layerY
	  //   }
	  // },
	  //
	  // onMouseUp: function (e) {
	  //   e.stopPropagation();
	  //   this.mousePress = false;
	  // },
	  //
	  // onMouseLeave: function (e) {
	  //   this.mousePress = false;
	  // },
	  //
	  // onMouseMove: function (e) {
	  //   var offsetX;
	  //   var offsetY;
	  //   // e.stopPropagation();
	  //   if (this.ENABLED_DRAG) {
	  //     if (this.mousePress) {
	  //       offsetX = e.nativeEvent.layerX - this.downPoint.x;
	  //       offsetY = e.nativeEvent.layerY - this.downPoint.y;
	  //       this.doScrollBy(offsetX, offsetY);
	  //       this.downPoint = {
	  //         x: e.nativeEvent.layerX,
	  //         y: e.nativeEvent.layerY
	  //       }
	  //     }
	  //   }
	  // },
	  //
	  // doScrollBy: function (x, y) {
	  //   var content = ReactDOM.findDOMNode(this.refs.viewPort);
	  //   var left = this.state.scrollLeft - x;
	  //   var top = this.state.scrollTop - y;
	  //   left = Math.min(left, content.clientWidth - styleHelper.getWidth(this.props));
	  //   left = Math.max(left, 0);
	  //   top = Math.min(top, content.clientHeight - styleHelper.getHeight(this.props));
	  //   top = Math.max(top, 0);
	  //   this.setState({
	  //     scrollLeft: left,
	  //     scrollTop: top
	  //   });
	  //   //$(content).css({left : left, top : top});
	  //
	  // },
	
	  componentDidMount: function componentDidMount() {
	    tool.setThumbOpaicty(ReactDOM.findDOMNode(this), 0);
	    this.doBindEvent();
	  },
	
	  timerId: null,
	  componentDidUpdate: function componentDidUpdate() {
	    this.doBindEvent();
	    this.doAutoHiddenBar();
	  },
	
	  doAutoHiddenBar: function doAutoHiddenBar() {
	
	    var dom = ReactDOM.findDOMNode(this);
	    var vertThumb = tool.getVertThumb(dom);
	    var horiThumb = tool.getHoriThumb(dom);
	
	    if (this.timerId) {
	      clearTimeout(this.timerId);
	    }
	    $(vertThumb).css('opacity', 1);
	    $(horiThumb).css('opacity', 1);
	    this.timerId = setTimeout(function () {
	      if (vertThumb) {
	        $(vertThumb).animate({ opacity: "0" }, 600);
	      }
	      if (horiThumb) {
	        $(horiThumb).animate({ opacity: "0" }, 600);
	      }
	    }, 800);
	
	    if (this.hasShow) {
	      this.hasShow = false;
	    }
	  },
	
	  doBindEvent: function doBindEvent() {
	    var dom = ReactDOM.findDOMNode(this);
	    $(dom).off('onScrollTo');
	    $(dom).on('onScrollTo', this.onScrollTo);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.timeID) {
	      clearTimeout(this.timeID);
	    }
	    if (this.autoScrolltimeID) {
	      clearTimeout(this.autoScrolltimeID);
	    }
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  onScrollTo: function onScrollTo(event, controlID, params, complete) {
	    var targetTop = Math.abs(params.top);
	    var self = this;
	    var call = function call() {
	      self.currentScrollPoints.y = targetTop;
	      if (complete) {
	        complete();
	      }
	    };
	    if (this.state.scrollTop !== this.currentScrollPoints.y) {
	      this.setState({
	        scrollLeft: this.currentScrollPoints.x,
	        scrollTop: this.currentScrollPoints.y
	      });
	    }
	
	    //params.useAnimate = true;
	
	    if (params.useAnimate) {
	      this.doLinerAnimateScrollTo(controlID, targetTop, call);
	    } else {
	      this.doNoAnimateScrollTo(controlID, targetTop, call);
	    }
	  },
	
	  doNoAnimateScrollTo: function doNoAnimateScrollTo(controlID, top, complete) {
	    if (controlID === this.props.controlID) {
	      this.setState({ scrollTop: top });
	      if (complete) {
	        complete();
	      }
	    }
	  },
	
	  doLinerAnimateScrollTo: function doLinerAnimateScrollTo(controlID, top, complete) {
	    var targetTop = top;
	    var view = ReactDOM.findDOMNode(this.refs.scrollbox);
	    view = $(view).children('.scroll-content')[0];
	    var oldTop = Math.abs(view.scrollTop);
	    var step = Math.max(40, Math.abs(targetTop - oldTop) / 10);
	    var self = this;
	    var currentTop = oldTop;
	    var isFinish = false;
	    if (targetTop < oldTop) {
	      step *= -1;
	    }
	
	    var doScroll = function doScroll() {
	      self.requestID = window.requestAnimationFrame(function () {
	        currentTop += step;
	        if (targetTop < oldTop) {
	          if (currentTop < targetTop) {
	            currentTop = targetTop;
	          }
	        } else if (targetTop > oldTop) {
	          if (currentTop > targetTop) {
	            currentTop = targetTop;
	          }
	        }
	        self.setState({ scrollTop: currentTop });
	        if (currentTop === targetTop) {
	          isFinish = true;
	        }
	        if (!isFinish) {
	          self.timeID = setTimeout(doScroll, 10);
	        } else {
	          if (complete) {
	            complete();
	          }
	        }
	      });
	    };
	    if (controlID === this.props.controlID) {
	      if (targetTop !== oldTop) {
	        doScroll();
	      } else {
	        if (complete) {
	          complete();
	        }
	      }
	    }
	  }
	});
	
	module.exports = ScrollView;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var PropTypes = React.PropTypes;
	var findDOMNode = __webpack_require__(12).findDOMNode;
	var mouseHelper = __webpack_require__(215);
	
	//
	// import {Component, PropTypes} from 'react';
	// import {findDOMNode} from 'react-dom';
	
	var STYLE_AUTO = 'auto';
	var STYLE_SHOW = 'show';
	var STYLE_HIDE = 'hide';
	
	var IS_LION_SCROLLBAR = /Android|webOS|iPhone|iPad|iPod|OS X|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent) && !/Chrome/i.test(window.navigator.userAgent);
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  propTypes: {
	    scrollBarStyle: PropTypes.string,
	    defaultScrollTop: PropTypes.number,
	    defaultScrollLeft: PropTypes.number,
	    scrollTop: PropTypes.number,
	    scrollLeft: PropTypes.number,
	    warning: PropTypes.bool,
	    onScroll: PropTypes.func,
	    disableHScroll: PropTypes.bool,
	    disableVScroll: PropTypes.bool,
	    dragToScroll: PropTypes.bool
	  },
	  getInitialState: function getInitialState() {
	    return {
	      loaded: false,
	      vSize: 0,
	      vPosition: 0,
	      hSize: 0,
	      hPosition: 0,
	      hide: this.props.scrollBarStyle === STYLE_HIDE,
	      alwaysShow: false,
	      scrollBarStyle: this.props.scrollBarStyle || 'auto', // auto | show | hide
	      hideTimeout: this.props.hideTimeout || 1500,
	      defaultScrollTop: this.props.defaultScrollTop || 0,
	      defaultScrollLeft: this.props.defaultScrollLeft || 0,
	      scrollTop: this.props.scrollTop || -1,
	      scrollLeft: this.props.scrollLeft || -1,
	      warning: this.props.warning || true
	    };
	  },
	  onScroll: function onScroll() {
	    this.onUpdate();
	    if (this.props.onScroll) {
	      var node = findDOMNode(this.refs.content);
	      this.props.onScroll(node.scrollTop, node.scrollLeft);
	    }
	  },
	  onUpdate: function onUpdate() {
	    var node = findDOMNode(this.refs.content);
	    this.setState({
	      vSize: node.offsetHeight / node.scrollHeight,
	      vPosition: node.scrollTop / node.scrollHeight,
	      hSize: node.offsetWidth / node.scrollWidth,
	      hPosition: node.scrollLeft / node.scrollWidth,
	      loaded: true,
	      hide: this.state.scrollBarStyle === STYLE_HIDE
	    });
	  },
	  onMouseMove: function onMouseMove(e) {
	    var node = findDOMNode(this.refs.content);
	    var delta, newPosition;
	    if (this.direction === 'vertical') {
	      delta = (e.pageY - this.start) / node.offsetHeight;
	      newPosition = Math.min(Math.max(0, this.startPosition + delta), this.max);
	      node.scrollTop = node.scrollHeight * newPosition;
	    } else {
	      delta = (e.pageX - this.start) / node.offsetWidth;
	      newPosition = Math.min(Math.max(0, this.startPosition + delta), this.max);
	      node.scrollLeft = node.scrollWidth * newPosition;
	    }
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  onMouseUp: function onMouseUp(e) {
	    document.body.removeEventListener('mousemove', this.onMouseMove);
	    document.body.removeEventListener('mouseup', this.onMouseUp);
	    this.setState({
	      mouseDown: false
	    });
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  onVerticalThumbMouseDown: function onVerticalThumbMouseDown(e) {
	    this.direction = 'vertical';
	    var node = findDOMNode(this.refs.content);
	    this.start = e.pageY;
	    this.startPosition = this.state.vPosition;
	    this.max = (node.scrollHeight - node.offsetHeight) / node.scrollHeight;
	    document.body.addEventListener('mousemove', this.onMouseMove);
	    document.body.addEventListener('mouseup', this.onMouseUp);
	    this.setState({
	      mouseDown: true
	    });
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  onHorizontalThumbMouseDown: function onHorizontalThumbMouseDown(e) {
	    this.direction = 'horizontal';
	    var node = findDOMNode(this.refs.content);
	    this.start = e.pageX;
	    this.startPosition = this.state.hPosition;
	    this.max = (node.scrollWidth - node.offsetWidth) / node.scrollWidth;
	    document.body.addEventListener('mousemove', this.onMouseMove);
	    document.body.addEventListener('mouseup', this.onMouseUp);
	    this.setState({
	      mouseDown: true
	    });
	    e.stopPropagation();
	    e.preventDefault();
	  },
	
	  setAutoHideTimer: function setAutoHideTimer() {
	    var _this = this;
	
	    if (this.hideTimer) {
	      clearTimeout(this.hideTimer);
	      this.hideTimer = null;
	    }
	
	    if (this.state.scrollBarStyle === STYLE_AUTO) {
	      this.hideTimer = setTimeout(function () {
	        _this.setState({
	          hide: true
	        });
	      }, this.state.hideTimeout);
	    }
	  },
	
	  onScrollBarMouseEnter: function onScrollBarMouseEnter(e) {
	    this.setState({
	      mouseEntered: true
	    });
	  },
	  onScrollBarMouseOut: function onScrollBarMouseOut(e) {
	    this.setState({
	      mouseEntered: false
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.setAutoHideTimer();
	    this.onUpdate();
	    var node = findDOMNode(this.refs.content);
	    this.contentNode = node;
	    var state = this.state;
	    if (state.defaultScrollTop > 0) {
	      node.scrollTop = state.defaultScrollTop;
	    }
	    if (state.defaultScrollLeft > 0) {
	      node.scrollLeft = state.defaultScrollLeft;
	    }
	    if (state.scrollTop > 0) {
	      node.scrollTop = state.scrollTop;
	    }
	    if (state.scrollLeft > 0) {
	      node.scrollLeft = state.scrollLeft;
	    }
	    if (state.scrollTop >= 0 || state.scrollLeft >= 0 && !state.warning) {
	      console.warn('WARNING: After setting scrollTop/scrollLeft, component will use these values in every updating.\nIf you want to set initial scrollTop/scrollLeft, please set defaultScrollLeft/defaultScrollTop.\nYou can set property warning = false to hide this warning.');
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var node = findDOMNode(this.refs.content);
	    if (!node) {
	      return;
	    }
	    if (nextProps.scrollTop >= 0) {
	      node.scrollTop = nextProps.scrollTop;
	    }
	    if (nextProps.scrollLeft >= 0) {
	      node.scrollLeft = nextProps.scrollLeft;
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {},
	
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.hideTimer);
	  },
	  render: function render() {
	    var contentStyle = {
	      overflowX: this.props.disableHScroll ? 'hidden' : 'auto',
	      overflowY: this.props.disableVScroll ? 'hidden' : 'auto'
	    };
	    if (IS_LION_SCROLLBAR) {
	      contentStyle.width = '100%';
	      contentStyle.height = '100%';
	      return React.createElement(
	        'div',
	        { ref: 'content', style: contentStyle },
	        React.createElement(
	          'div',
	          { style: {
	              position: 'relative'
	            } },
	          this.props.children
	        )
	      );
	    }
	    return React.createElement(
	      'div',
	      { className: 'scroll-view', onScroll: this.onScroll },
	      React.createElement(
	        'div',
	        { ref: 'content', className: 'scroll-content', style: contentStyle,
	          onMouseDown: this.onContentMouseDown
	          // onMouseMove={this.onContentMouseMove}
	          // onMouseUp={this.onContentMouseUp}
	        },
	        this.props.children
	      ),
	      !this.props.disableHScroll && this.shouldShowScrollBar() && React.createElement(
	        'div',
	        { className: 'track scroll-bar-horizontal',
	          onMouseDown: this.onHorizontalThumbMouseDown,
	          onMouseEnter: this.onScrollBarMouseEnter,
	          onMouseLeave: this.onScrollBarMouseOut },
	        React.createElement('div', { className: 'thumb', style: this.horizontalThumbStyle() })
	      ),
	      !this.props.disableVScroll && this.shouldShowScrollBar() && React.createElement(
	        'div',
	        { className: 'track scroll-bar-vertical',
	          onMouseDown: this.onVerticalThumbMouseDown,
	          onMouseEnter: this.onScrollBarMouseEnter,
	          onMouseLeave: this.onScrollBarMouseOut },
	        React.createElement('div', { className: 'thumb', style: this.verticalThumbStyle() })
	      )
	    );
	  },
	
	  shouldShowScrollBar: function shouldShowScrollBar() {
	    return this.state.scrollBarStyle !== STYLE_HIDE;
	  },
	
	  shouldScrollBarAlwaysShow: function shouldScrollBarAlwaysShow() {
	    return this.state.mouseEntered || this.state.mouseDown;
	  },
	
	  verticalThumbStyle: function verticalThumbStyle() {
	    return {
	      height: this.state.vSize * 100 + '%',
	      top: this.state.vPosition * 100 + '%',
	      display: this.state.vSize < 1 && (this.shouldScrollBarAlwaysShow || !this.state.hide && this.state.loaded) ? 'block' : 'none'
	    };
	  },
	
	  horizontalThumbStyle: function horizontalThumbStyle() {
	    return {
	      width: this.state.hSize * 100 + '%',
	      left: this.state.hPosition * 100 + '%',
	      display: this.state.hSize < 1 && (this.shouldScrollBarAlwaysShow || !this.state.hide && this.state.loaded) ? 'block' : 'none'
	    };
	  },
	  onContentMouseDown: function onContentMouseDown(e) {
	    if (!this.props.dragToScroll) {
	      return;
	    }
	    this.startPosition = { x: e.pageX, y: e.pageY };
	    this.scrollTop = this.contentNode.scrollTop;
	    this.scrollLeft = this.contentNode.scrollLeft;
	    mouseHelper.dragDelegate(this._onUpdating, this._onUpdatingEnd);
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  // onContentMouseMove: function (e) {
	  //   if (!this.startPosition) {
	  //     return;
	  //   }
	  //   var deltaX = e.pageX - this.startPosition.x;
	  //   var deltaY = e.pageY - this.startPosition.y;
	  //   this.contentNode.scrollTop = this.scrollTop - deltaY;
	  //   this.contentNode.scrollLeft = this.scrollLeft - deltaX;
	  //   e.stopPropagation();
	  //   e.preventDefault();
	  // },
	  // onContentMouseUp: function (e) {
	  //   this.startPosition = null;
	  //   e.stopPropagation();
	  //   e.preventDefault();
	  // },
	  _onUpdating: function _onUpdating(e, mouseDelta) {
	    if (!this.props.disableHScroll) {
	      this.contentNode.scrollLeft = this.scrollLeft - mouseDelta.x;
	    }
	    if (!this.props.disableVScroll) {
	      this.contentNode.scrollTop = this.scrollTop - mouseDelta.y;
	    }
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  _onUpdatingEnd: function _onUpdatingEnd(e) {
	    e.stopPropagation();
	    e.preventDefault();
	  }
	});

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var optimizeCall = __webpack_require__(216);
	
	var optimizeMouseMoveCall = optimizeCall();
	window.addEventListener('mousemove', optimizeMouseMoveCall.call);
	
	function dragDelegate(onMove, onEnd) {
	  var startPosition;
	  var delta;
	  var isMoving = false;
	  var onMoveProxy = function (e) {
	    if (!startPosition) {
	      startPosition = {
	        pageX: e.pageX,
	        pageY: e.pageY
	      };
	    }
	    delta = {
	      x: e.pageX - startPosition.pageX,
	      y: e.pageY - startPosition.pageY
	    };
	    if (!isMoving) {
	      if (Math.abs(delta.x) >= 5 || Math.abs(delta.y) >= 5) {
	        isMoving = true;
	      }
	    }
	    if (isMoving) {
	      onMove(e, delta);
	    }
	  };
	  var onEndProxy = function (e) {
	    document.body.removeEventListener('mouseup', onEndProxy);
	    optimizeMouseMoveCall.remove(onMoveProxy);
	    onEnd(e, delta, isMoving);
	  };
	  document.body.addEventListener('mouseup', onEndProxy);
	  optimizeMouseMoveCall.add(onMoveProxy);
	}
	
	/**
	 * get mouse position in a node and page
	 * @param node
	 * @param e
	 * @returns {{x: *, y: *, pageX: *, pageY: *}}
	 */
	function getMousePosition(node, e) {
	  var boundingRect = node.getBoundingClientRect();
	  return {
	    x: e.pageX - boundingRect.left + node.scrollLeft,
	    y: e.pageY - boundingRect.top + node.scrollTop,
	    pageX: e.pageX,
	    pageY: e.pageY
	  }
	}
	
	module.exports = {
	  dragDelegate: dragDelegate,
	  getMousePosition: getMousePosition,
	  onMove: function (cb) {
	    optimizeMouseMoveCall.add(cb);
	  },
	  offMove: function (cb) {
	    optimizeMouseMoveCall.remove(cb);
	  }
	};


/***/ }),
/* 216 */
/***/ (function(module, exports) {

	/**
	 * 高频事件调用帮助方法,将高频调用进行缓冲
	 */
	'use strict';
	function optimizeCall() {
	    var callbacks = [],
	        running = false,
	        callArgu;
	
	    // fired on resize event
	    function call() {
	        if (!running) {
	            running = true;
	            callArgu = arguments;
	            if (window.requestAnimationFrame) {
	                window.requestAnimationFrame(runCallbacks);
	            } else {
	                setTimeout(runCallbacks, 66);
	            }
	        }
	
	    }
	
	    // run the actual callbacks
	    function runCallbacks() {
	        callbacks.forEach(function (callback) {
	            callback.apply(null, callArgu);
	        });
	        callArgu = null;
	        running = false;
	    }
	
	    // adds callback to loop
	    function addCallback(callback) {
	
	        if (callback) {
	            callbacks.push(callback);
	        }
	    }
	
	    function removeCallback(callback) {
	        if (callback) {
	            callbacks.splice(callbacks.indexOf(callback), 1)
	        }
	    }
	
	    return {
	        add: addCallback,
	        remove: removeCallback,
	        call: call
	    };
	}
	
	module.exports = optimizeCall;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ScrollBox = __webpack_require__(214);
	var styleHelper = __webpack_require__(145);
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-4-1
	 @Descript : 内容面板中的滚动区
	 */
	var ScrollArea = React.createClass({
	  displayName: 'ScrollArea',
	
	  render: function render() {
	    var content = this.props.items[0];
	    var dom = React.createElement(
	      'div',
	      { key: this.props.controlID,
	        className: 'component component-scrollarea',
	        style: {
	          left: 0,
	          top: 0,
	          width: '100%',
	          height: '100%',
	          backgroundColor: styleHelper.getBackgroundColor(this.props),
	          borderStyle: 'none'
	        },
	        onScroll: this._onMouseWheel
	      },
	      React.createElement(
	        ScrollBox,
	        { disableHScroll: !this.props.canHoriScroll,
	          disableVScroll: !this.props.canVertScroll },
	        React.createElement(
	          'div',
	          { key: 'viewPort', style: {
	              width: this.props.viewPortSize ? this.props.viewPortSize.w + 20 : styleHelper.getWidth(this.props), //补偿滚动条的宽度 // FIXME: viewPortSize 可能为 undefined
	              height: this.props.viewPortSize ? this.props.viewPortSize.h + 20 : styleHelper.getHeight(this.props),
	              overflow: 'hidden'
	            } },
	          this.props.children
	        )
	      )
	    );
	    return dom;
	  },
	
	  _onMouseWheel: function _onMouseWheel(e) {
	    e.stopPropagation();
	  }
	});
	
	module.exports = ScrollArea;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var Border = __webpack_require__(168);
	var LabelParts = __webpack_require__(174);
	var textHelper = __webpack_require__(116).Text;
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 分段控件
	 */
	var ScopeBar = React.createClass({
	  displayName: 'ScopeBar',
	
	
	  getInitialState: function getInitialState() {
	    return { selectedIndex: this.props.selectedIndex };
	  },
	  render: function render() {
	    var textItems = textHelper.delimitText(styleHelper.getText(this.props), textHelper.DM_COMMA);
	    var length = textItems.length;
	    var itemW = (this.props.w - 2) / length;
	    this.itemCount = length;
	    var borderStyle = {
	      borderWidth: this.props.thickness,
	      borderRadius: styleHelper.getRadius(this.props),
	      overflow: 'hidden'
	    };
	
	    return React.createElement(
	      Border,
	      _extends({}, this.props, { partStyle: borderStyle }),
	      textItems.map(function (text, index) {
	        return React.createElement(
	          'div',
	          {
	            key: index,
	            onClick: this.onItemClick.bind(this, null, index),
	            onMouseOver: this.onItemMouseOver.bind(this, index),
	            onMouseOut: this.onItemMouseOut,
	            style: {
	              left: itemW * index,
	              width: index === length - 1 ? this.props.w - index * itemW : itemW,
	              height: this.props.h - 2,
	              position: 'absolute',
	              overflow: 'hidden',
	              backgroundColor: index === this.state.selectedIndex ? this.props.selectedColor : this.props.showHover && index === this.state.hoverIndex ? this.props.hoveredColor : null,
	              fontFamily: this.props.textFontFamily || decodeURIComponent(this.props.font.family)
	            } },
	          React.createElement(LabelParts, _extends({}, this.props, { text: text, partStyle: {
	              width: itemW,
	              height: this.props.h - 2,
	              lineHeight: this.props.h - 2 + 'px',
	              textAlign: 'center',
	              position: 'absolute',
	              color: index === this.state.selectedIndex ? styleHelper.getSelectedTextColor(this.props) : styleHelper.getTextColor(this.props)
	            } }))
	        );
	      }, this)
	    );
	  },
	
	  onItemClick: function onItemClick(e, i) {
	    this.setState({ selectedIndex: i });
	  },
	
	  onItemMouseOver: function onItemMouseOver(index) {
	    if (this.props.showHover) {
	      this.setState({ hoverIndex: index });
	    }
	  },
	
	  onItemMouseOut: function onItemMouseOut() {
	    this.setState({ hoverIndex: -1 });
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
	  }
	
	});
	
	module.exports = ScopeBar;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	var PopupHelper = __webpack_require__(156);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-4-1
	 @Descript : 弹出面板组件
	 */
	var SlidingDrawer = React.createClass({
	  displayName: 'SlidingDrawer',
	
	
	  render: function render() {
	    var bgComp = this.props.items[0];
	    var contentComp = this.props.items[1];
	    var contentStyle = { padding: 0, opacity: this.props.popup ? 1 : 0, visibility: 'visible', left: 0, zIndex: 1 };
	    var bg = util.Color.setOpacity(bgComp.color, 0.4);
	    styleHelper.StyleUtil(contentComp, contentStyle).bounds().background().border().base();
	    var dom = React.createElement(
	      'div',
	      {
	        key: this.props.controlID,
	        id: this.props.controlID,
	        className: 'component component-SlidingDrawer popup-control',
	        style: {
	          visibility: this.props.popup ? 'visible' : 'hidden',
	          zIndex: this.props.zOrder
	        } },
	      React.createElement('div', { id: this.props.controlID + '-background',
	        ref: 'background',
	        className: 'background',
	        style: {
	          width: this.props.measureWidth || 0,
	          height: this.props.measureHeight || 0,
	          backgroundColor: this.props.isShowBackground ? bg : 0,
	          pointerEvents: this.props.closeByClickMode === appTypes.PopupPanelClosePolicy.NONE ? 'auto' : 'none'
	        } }),
	      React.createElement(
	        'div',
	        { id: this.props.controlID + '-content',
	          className: 'content',
	          ref: 'content',
	          style: contentStyle },
	        this.props.children
	      )
	    );
	    return dom;
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doPopup();
	    if (this.props.onOpened) {
	      this.props.onOpened(this.props);
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doPopup();
	  },
	
	  doPopup: function doPopup() {
	    PopupHelper.registerPopup(this);
	    if (this.open) {
	      this.open();
	    }
	    var dom = $(ReactDOM.findDOMNode(this));
	    var content = $(ReactDOM.findDOMNode(this.refs.content));
	    var background = $(ReactDOM.findDOMNode(this.refs.background));
	    if (this.props.isPopupClosing && this.props.closePopup) {
	      this.props.closePopup(dom, this.props, content, background);
	    }
	  }
	});
	
	module.exports = SlidingDrawer;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var VerticalScrollBar = __webpack_require__(178);
	var TextParts = __webpack_require__(211);
	var Border = __webpack_require__(168);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var _ = __webpack_require__(51);
	
	var TextArea = React.createClass({
	  displayName: 'TextArea',
	
	
	  render: function render() {
	    var w = styleHelper.getWidth(this.props);
	    var showScrollBar = styleHelper.getBorderVisible(this.props) && this.props.verticalScrollbarShow;
	    if (showScrollBar) {
	      w -= 16;
	    }
	    var textStyle = {
	      width: w
	    };
	
	    return React.createElement(
	      Border,
	      _extends({}, this.props, {
	        partStyle: {
	          borderWidth: '1px',
	          borderColor: this.props.borderColor ? styleHelper.getBorderColor(this.props) : '#000',
	          zIndex: 0
	        }
	      }),
	      showScrollBar && React.createElement(VerticalScrollBar, {
	        zIndex: 1,
	        value: parseInt(this.props.verticalScrollbarProgress) }),
	      React.createElement(TextParts, _extends({ ref: 'text', zIndex: 0 }, this.props, { partStyle: textStyle }))
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize);
	  },
	
	  onResize: function onResize(e) {
	    $(ReactDOM.findDOMNode(this.refs.text)).trigger(appTypes.CUSTOM_EVENT.ON_PAINT);
	  }
	
	});
	
	module.exports = TextArea;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	var Border = __webpack_require__(168);
	var AutoSizeHelper = __webpack_require__(167);
	var convertHelper = __webpack_require__(146);
	var Dom = __webpack_require__(12);
	var util = __webpack_require__(116);
	var _ = __webpack_require__(51);
	
	var RuntimeOptions = __webpack_require__(153);
	var linkHelper = __webpack_require__(158);
	var appTypes = __webpack_require__(115);
	
	var TextInput = React.createClass({
	  displayName: 'TextInput',
	
	
	  _doPaint: function _doPaint() {
	    var com;
	    var parentDom;
	    var size;
	
	    if (this.props.isAutoSize) {
	      com = Dom.findDOMNode(this);
	      parentDom = com.parentElement;
	
	      while (!parentDom && parentDom.id !== this.props.controlID) {
	        parentDom = parentDom.parentElement;
	      }
	      if (parentDom) {
	        size = AutoSizeHelper.getComAutoSize(this.props);
	        parentDom.style.width = size.width + 6 + 'px';
	        parentDom.style.height = size.height + 8 + 'px';
	      }
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._doPaint();
	  },
	
	  render: function render() {
	    var haveAction = false;
	    var isLink = false;
	    var className = 'no-link';
	    var actionDatas = [];
	
	    if (this.props.interactiveData || this.props.links) {
	      actionDatas = linkHelper.parseComInteractive(this.props);
	    }
	
	    this.actionData = actionDatas[0] || {};
	    haveAction = this.actionData.externalURL || this.actionData.link || this.actionData.entry;
	    isLink = this.actionData.externalURL || this.actionData.link;
	
	    var linkStyle = {
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      userSelect: 'none',
	      position: 'absolute',
	      //此处链接区域应该置于上层
	      //注意检查：改动该属性是否有副作用
	      zIndex: 800,
	      pointerEvents: 'none'
	    };
	    if (haveAction) {
	      if (isLink) {
	        className = 'page-link';
	      } else {
	        className = 'interactive-link';
	      }
	    }
	
	    return React.createElement(
	      'div',
	      {
	        onClick: this._onClick,
	        onMouseDown: this._onMouseDown,
	        onMouseUp: this._onMouseUp,
	        onDoubleClick: this._onDblClick,
	        onContextMenu: this._onContentMenu },
	      this.renderInput(),
	      haveAction && React.createElement('div', { className: className,
	        style: linkStyle
	      })
	    );
	  },
	
	  renderInput: function renderInput() {
	    var h = styleHelper.getHeight(this.props);
	    var w = styleHelper.getWidth(this.props);
	    var inputStyle = {
	      position: 'absolute',
	      zIndex: 2,
	      width: w,
	      height: h,
	      border: 'none',
	      paddingLeft: 2,
	      paddingRight: 2,
	      margin: 0,
	      boxSizing: 'border-box',
	      outline: 'none',
	      lineHeight: h - 2 + 'px'
	    };
	    var placeHolder = this.props.placeHolder;
	    if (typeof placeHolder !== 'string') {
	      placeHolder = '';
	    }
	    var text = this.state.text.trim();
	    styleHelper.StyleUtil(this.props, inputStyle).align().text().background().border();
	    inputStyle.paddingLeft += inputStyle.borderRadius || 0;
	    if (_.isUndefined(this.props.canInput) || this.props.canInput) {
	      return React.createElement('input', {
	        ref: 'input',
	        value: text,
	        style: inputStyle,
	        onChange: this.onChange,
	        type: this.getInputType(),
	        placeholder: placeHolder
	      });
	    } else {
	      return React.createElement('input', {
	        ref: 'input',
	        disabled: true,
	        value: text,
	        style: inputStyle,
	        type: this.getInputType(),
	        placeholder: placeHolder });
	    }
	  },
	
	  getInputType: function getInputType() {
	    return this.props.inputModel === 'emPassword' ? 'password' : 'text';
	  },
	
	  onChange: function onChange(e) {
	    var text = this.tranText(e.target.value);
	    //var text = e.target.value;
	    //if(!this.validateNumber(text)) {      //验证是否合法数字输入
	    //text = this.state.text;
	    //}
	    this.setState({ text: text, update: !this.state.update });
	  },
	
	  //数字输入框时，屏蔽编辑情景中的不合法输入
	  tranText: function tranText(text) {
	    if (this.props.inputModel === 'emNumber') {
	      var t = text.charAt(0);
	      //中文句号转换为英文点
	      text = text.replace(/。/g, ".");
	      //先把非数字的都替换掉，除了数字和.
	      text = text.replace(/[^\d.]/g, "");
	      //必须保证第一个为数字而不是.
	      text = text.replace(/^\./g, "");
	      //保证只有出现一个.而没有多个.
	      text = text.replace(/\.{2,}/g, ".");
	      //保证.只出现一次，而不能出现两次以上
	      text = text.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
	      //如果第一位是负号，则允许添加  如果不允许添加负号 可以把这块注释掉
	      if (t === '-') {
	        text = '-' + text;
	      }
	    }
	    return text;
	  },
	
	  validateNumber: function validateNumber(text) {
	    //判断是否为数字的正则，与桌面端保持一致
	    var r = /^-?([1-9]+\d*|0)\.?\d*$/;
	    //空文本情况也是做合法输入
	    return r.test(text) || text === '';
	  },
	
	  setTextInteractiveNum: 0,
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var text = styleHelper.getText(newProps);
	    text = util.Text.replaceIndentSpace(util.Text.convertSpaceToNbsp(text));
	    var num = newProps.setTextInteractiveNum || 0;
	
	    //此处只有文本框被设置文本交互时才更新
	    //解析设置文本交互时记录了触发设置文本的次数
	    //不触发新的设置文本交互，不更新text
	    if (num !== this.setTextInteractiveNum) {
	      this.setTextInteractiveNum = num;
	      if (this.props.inputModel === 'emNumber') {
	        text = this.validateNumber(text) ? text : '123'; //不合法文本置为默认值123
	      }
	      this.setState({ text: text });
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      text: styleHelper.getText(this.props),
	      update: false
	    };
	  },
	
	  _onContentMenu: function _onContentMenu(e) {
	    e.nativeEvent.returnValue = false;
	    return false;
	  },
	
	  _onLinkEvent: function _onLinkEvent(evt, linkKey) {
	    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
	    this.props.events.doSelfClick(evt, this.props, linkKey, 0);
	  },
	
	  _onClick: function _onClick(e) {
	    var key;
	    if (this.longPress) {
	      return;
	    }
	    if (e.button === 0) {
	      if (this.actionData.externalURL) {
	        key = appTypes.ActionResponseType.OUTER;
	      } else if (this.actionData.link) {
	        key = appTypes.ActionResponseType.LINK;
	      } else if (this.actionData.entry) {
	        key = appTypes.ActionResponseType.INTERACTIVE;
	      }
	      if (key) {
	        this._onLinkEvent(e, key);
	      }
	    } else if (e.button === 2) {
	      this._onRightClick(e);
	    }
	  },
	
	  _onLongPress: function _onLongPress(evt) {
	    if (this.props.events.doSelfLongPress) this.props.events.doSelfLongPress(evt, this.props, 0);
	  },
	
	  _onRightClick: function _onRightClick(evt) {
	    if (this.props.events.doSelfRightClick) {
	      this.props.events.doSelfRightClick(evt, this.props, 0);
	    }
	  },
	
	  _onDblClick: function _onDblClick(evt) {
	    if (this.props.events.doSelfDbClick) {
	      this.props.events.doSelfDbClick(evt, this.props, 0);
	    }
	  },
	
	  _onMouseDown: function _onMouseDown(e) {
	    if (this.props.canInput) {
	      e.stopPropagation();
	    }
	    if (e.button === 0) {
	      this.mousePress = true;
	      this._startLongPress(e);
	    } else if (e.button === 2) {
	      this._onRightClick(e);
	    }
	  },
	
	  _onMouseUp: function _onMouseUp(e) {
	    if (this.props.canInput) {
	      e.stopPropagation();
	    }
	    this.mousePress = false;
	    this._stopLongPress();
	  },
	  _startLongPress: function _startLongPress(e) {
	    var self = this;
	    self.longPress = false;
	    if (linkHelper.hasLongPressEvents(this.props.interactiveData, 0)) {
	      this.longPressTimeID = setTimeout(function () {
	        if (self.mousePress) {
	          self.longPress = true;
	          self._onLongPress(e);
	        }
	        self._stopLongPress();
	      }, 800);
	    }
	  },
	
	  _stopLongPress: function _stopLongPress() {
	    if (this.longPressTimeID) {
	      clearTimeout(this.longPressTimeID);
	    }
	    delete this.longPressTimeID;
	  }
	
	});
	
	module.exports = TextInput;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var VerticalScrollBar = __webpack_require__(178);
	var Border = __webpack_require__(168);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var _ = __webpack_require__(51);
	
	var TitleWindow = React.createClass({
	  displayName: 'TitleWindow',
	
	
	  render: function render() {
	    var showScrollBar;
	    var value = styleHelper.getInt(this.props, propConst.VERTICAL_SCROLL_BAR_PROGRESS);
	
	    var h = styleHelper.getHeight(this.props);
	    var bgColor = styleHelper.getBackgroundColor(this.props);
	
	    var titleStyle = {
	      height: this.props.topHeight,
	      lineHeight: this.props.topHeight + 'px',
	      zIndex: 2
	    };
	    var contentStyle = {
	      top: parseInt(this.props.topHeight, 10),
	      height: h - this.props.topHeight - this.props.bottomHeight - 4,
	      backgroundColor: bgColor,
	      zIndex: 1
	    };
	
	    var statusStyle = {
	      height: this.props.bottomHeight,
	      zIndex: 3
	    };
	    var labelStyle = {
	      height: this.props.topHeight,
	      lineHeight: this.props.topHeight + 'px'
	    };
	    var style = styleHelper.StyleUtil(this.props).size().default({ border: '2px solid #444', boxSizing: 'border-box' }).text().background().style;
	
	    /*border相关兼容修正*/
	    if (this.props.borderVisible) {
	      style.border = '2px solid ' + this.props.borderColor;
	      titleStyle.borderBottom = '1px solid ' + this.props.borderColor;
	      statusStyle.borderTop = '1px solid ' + this.props.borderColor;
	      style.borderColor = styleHelper.getBorderColor(this.props);
	      titleStyle.borderColor = styleHelper.getBorderColor(this.props);
	    } else {
	      style.border = 'none';
	    }
	
	    showScrollBar = this.props.verticalScrollbarShow;
	    return React.createElement(
	      'div',
	      { className: 'component', style: style },
	      React.createElement(
	        'div',
	        { ref: 'title', className: 'title', style: titleStyle },
	        React.createElement(
	          'label',
	          { style: labelStyle },
	          styleHelper.getText(this.props)
	        ),
	        React.createElement(
	          'div',
	          { className: 'icon-box', style: { height: 'auto', right: 6, bottom: (this.props.topHeight - 12) / 2 - 6 } },
	          this.props.showMin && React.createElement('img', { width: '12', height: '12', className: 'win-icon',
	            src: assetsHelper.getComponentAsset('window_min') }),
	          this.props.showMax && React.createElement('img', { width: '12', height: '12', className: 'win-icon',
	            src: assetsHelper.getComponentAsset('window_max') }),
	          this.props.showClose && React.createElement('img', { width: '12', height: '12', className: 'win-icon',
	            src: assetsHelper.getComponentAsset('window_close') })
	        )
	      ),
	      React.createElement(
	        'div',
	        { ref: 'content', className: 'content', style: contentStyle },
	        showScrollBar && React.createElement(VerticalScrollBar, {
	          value: value,
	          right: -1,
	          height: '100%'
	        })
	      ),
	      React.createElement(
	        'div',
	        { ref: 'bottom', className: 'status-bar', style: statusStyle },
	        React.createElement(
	          'div',
	          { className: 'icon-box' },
	          this.props.showDrag && React.createElement('img', { width: '12', height: '12', className: 'win-icon',
	            src: assetsHelper.getComponentAsset('window_drag') })
	        )
	      )
	    );
	  }
	
	});
	
	module.exports = TitleWindow;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var PopupHelper = __webpack_require__(156);
	var util = __webpack_require__(116);
	
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-4-1
	 @Descript : 弹出面板组件
	 */
	var PopupPanel = React.createClass({
	  displayName: 'PopupPanel',
	
	  render: function render() {
	    var bgComp = this.props.items[0];
	    var contentComp = this.props.items[1];
	    var bg = util.Color.setOpacity(bgComp.color, 0.4);
	    var dom = React.createElement(
	      'div',
	      {
	        key: this.props.controlID,
	        id: this.props.controlID,
	        className: 'component component-PopupPanel popup-control',
	        style: {
	          //visibility : this.props.popup?'visible': 'hidden',
	          visibility: 'visible',
	          zIndex: this.props.zOrder
	        } },
	      React.createElement('div', { id: this.props.controlID + '-background',
	        className: 'background',
	        style: {
	          width: this.props.measureWidth || 0,
	          height: this.props.measureHeight || 0,
	          backgroundColor: this.props.isShowBackground ? bg : 0
	        },
	        ref: 'background'
	      }),
	      React.createElement(
	        'div',
	        { id: this.props.controlID + '-content',
	          className: 'content',
	          ref: 'content',
	          style: {
	            left: contentComp.x,
	            top: contentComp.y,
	            width: contentComp.w + 1,
	            height: contentComp.h + 1,
	            boxSizing: 'border-box',
	            overflow: 'visible'
	          } },
	        this.props.children
	      )
	    );
	
	    return dom;
	  },
	
	  doAdjustChildBounds: function doAdjustChildBounds() {
	    //var content = ReactDOM.findDOMNode(this.refs.content);
	    //var i = 0;
	    //var comp = this.props.items[1];
	    //for (i; i < content.children.length; i++) {
	    //  $(content.children[i]).css({left:comp.items[i].x + 1});
	    //}
	  },
	
	  componentDidMount: function componentDidMount() {
	    //this.doAdjustChildBounds();
	    this.doPopup();
	    if (this.props.onOpened) {
	      this.props.onOpened(this.props);
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doPopup();
	  },
	
	  doPopup: function doPopup() {
	    PopupHelper.registerPopup(this);
	    if (this.open) {
	      this.open();
	    }
	    var dom = $(ReactDOM.findDOMNode(this));
	    var content = $(ReactDOM.findDOMNode(this.refs.content));
	    var background = $(ReactDOM.findDOMNode(this.refs.background));
	    if (this.props.isPopupClosing && this.props.closePopup) {
	      this.props.closePopup(dom, this.props, content, background);
	    }
	  }
	});
	
	module.exports = PopupPanel;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-4-1
	 @Descript : 弹出面板容器层
	 */
	var PopupPanelContent = React.createClass({
	  displayName: 'PopupPanelContent',
	
	
	  render: function render() {
	    var dom = React.createElement(
	      'div',
	      {
	        style: {
	          left: this.props.x,
	          top: this.props.y,
	          width: this.props.w,
	          height: this.props.h,
	          backgroundColor: '#f00'
	        }
	      },
	      this.props.children
	    );
	    return dom;
	  }
	
	});
	
	module.exports = PopupPanelContent;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	var PopupHelper = __webpack_require__(156);
	var util = __webpack_require__(116);
	
	/*
	 @Author : mengxiaojiang
	 @CreateDate : 2016-6-2
	 @Descript : 弹出菜单组件
	 */
	var PopupMenu = React.createClass({
	  displayName: 'PopupMenu',
	
	
	  render: function render() {
	    var bgComp = this.props.items[0];
	    var contentComp = this.props.items[1];
	    var bg = util.Color.setOpacity(bgComp.color, 0.4);
	    var dom = React.createElement(
	      'div',
	      {
	        key: this.props.controlID,
	        id: this.props.controlID,
	        className: 'component component-PopupMenu popup-control ' + this.props.caption,
	        style: {
	          visibility: this.props.popup ? 'visible' : 'hidden',
	          zIndex: this.props.zOrder
	        } },
	      React.createElement('div', { id: this.props.controlID + '-background',
	        className: 'background',
	        style: {
	          width: this.props.measureWidth || 0,
	          height: this.props.measureHeight || 0,
	          backgroundColor: this.props.isShowBackground ? bg : 0
	        },
	        ref: 'background' }),
	      React.createElement(
	        'div',
	        { id: this.props.controlID + '-content',
	          className: 'content',
	          style: {
	            left: contentComp.x,
	            top: contentComp.y,
	            width: contentComp.w + 2,
	            height: contentComp.h + 2,
	            opacity: this.props.popup ? 1 : 0
	          },
	          ref: 'content' },
	        this.props.children
	      )
	    );
	    return dom;
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doPopup();
	    if (this.props.onOpened) {
	      this.props.onOpened(this.props);
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doPopup();
	    if (this.props.positionPolicy === appTypes.PositionPolicy.FREE) {
	      var scrollContent = $('.page-middle .scroll-view .scroll-content');
	      var offset = scrollContent.scrollTop();
	      $('.page-popup').css({ top: -offset });
	    }
	  },
	
	  doPopup: function doPopup() {
	    PopupHelper.registerPopup(this);
	    if (this.open) {
	      this.open();
	    }
	    var listDom = ReactDOM.findDOMNode(this.refs.content).children[0];
	    $(listDom).css({ left: 0, top: 0 });
	
	    var dom = $(ReactDOM.findDOMNode(this));
	    var content = $(ReactDOM.findDOMNode(this.refs.content));
	    var background = $(ReactDOM.findDOMNode(this.refs.background));
	    if (this.props.isPopupClosing && this.props.closePopup) {
	      this.props.closePopup(dom, this.props, content, background);
	    }
	  }
	});
	
	module.exports = PopupMenu;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	
	var SwitchIOS = React.createClass({
	  displayName: 'SwitchIOS',
	
	  propTypes: {
	    isOpen: React.PropTypes.bool.isRequired
	  },
	  getInitialState: function getInitialState() {
	    return {
	      isOpen: _.isUndefined(this.props.switchStatus) ? this.props.isOpen : parseInt(this.props.switchStatus, 10) === -1,
	      opacity: 1
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.isOpen !== this.props.isOpen) this.setState({ isOpen: _.isUndefined(newProps.switchStatus) ? newProps.isOpen : parseInt(newProps.switchStatus, 10) === -1 });
	  },
	
	  render: function render() {
	    var isOpen = styleHelper.getStateProperty(this.props, propConst.IS_OPEN);
	    var size = styleHelper.getSize(this.props);
	    var borderColor = styleHelper.getPropertyValue(this.props, propConst.BORDER_COLOR);
	    var onColor = styleHelper.getPropertyValue(this.props, propConst.OPEN_COLOR);
	    var offColor = styleHelper.getPropertyValue(this.props, propConst.CLOSE_COLOR);
	
	    if (!onColor) {
	      onColor = '#5f5';
	    }
	    if (!offColor) {
	      offColor = '#fff';
	    }
	
	    var stateStyle = {
	      width: this.props.h - 2,
	      height: size.height - 2,
	      top: 1
	    };
	
	    if (_.isUndefined(isOpen)) {
	      isOpen = this.state.isOpen;
	    }
	
	    if (isOpen) {
	      stateStyle.right = 1;
	      stateStyle.borderColor = onColor;
	    } else {
	      stateStyle.left = 1;
	      stateStyle.borderColor = offColor;
	    }
	    return React.createElement(
	      'div',
	      null,
	      React.createElement('div', { className: 'component contents-layout border',
	        style: {
	          borderTopLeftRadius: size.height / 2 + 'px 50%',
	          borderTopRightRadius: size.height / 2 + 'px 50%',
	          borderBottomLeftRadius: size.height / 2 + 'px 50%',
	          borderBottomRightRadius: size.height / 2 + 'px 50%',
	          backgroundColor: isOpen ? onColor : offColor,
	          borderColor: styleHelper.getBorderColor(this.props) || '#000',
	          border: this.props.borderVisible ? '1px solid ' + this.props.borderVisible : 'none'
	        },
	        onClick: this.onClick }),
	      React.createElement('div', { ref: 'btn', className: 'button', style: stateStyle })
	    );
	  },
	
	  onClick: function onClick(e) {
	    var ani;
	    var isOpen = !this.state.isOpen;
	    var w = styleHelper.getWidth(this.props);
	    var h = this.props.h - 2;
	    var s = h;
	    var margin = 1;
	    if (isOpen) {
	      ani = {
	        left: w - s - margin
	      };
	    } else {
	      ani = {
	        left: margin
	      };
	    }
	    $(ReactDOM.findDOMNode(this.refs.btn)).animate(ani, 150);
	
	    if (isOpen) {
	      this.props.events.switchOn(e, this.props, 'interactive-link', 0);
	    } else {
	      this.props.events.switchOff(e, this.props, 'interactive-link', 0);
	    }
	
	    this.setState({
	      isOpen: isOpen
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onClick);
	  }
	});
	module.exports = SwitchIOS;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	
	var Switch = React.createClass({
	  displayName: 'Switch',
	
	
	  propTypes: {
	    isOpen: React.PropTypes.bool.isRequired
	  },
	  getInitialState: function getInitialState() {
	    return {
	      isOpen: this.props.isOpen,
	      opacity: 1
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.isOpen !== this.props.isOpen) this.setState({ isOpen: _.isUndefined(newProps.switchStatus) ? newProps.isOpen : parseInt(newProps.switchStatus, 10) === -1 });
	  },
	
	  render: function render() {
	    var isOpen = styleHelper.getStateProperty(this.props, propConst.IS_OPEN);
	    var borderColor = styleHelper.getBorderColor(this.props);
	    var onColor = styleHelper.getPropertyValue(this.props, propConst.OPEN_COLOR);
	    /*getPropertyValue考虑交互*/
	    var offColor = styleHelper.getPropertyValue(this.props, propConst.CLOSE_COLOR);
	    var backgroundColor = styleHelper.getPropertyValue(this.props, propConst.BACKGROUND_COLOR);
	    var offBackgroundColor, onBackgroundColor;
	    var onStyle = {},
	        offStyle = {};
	    var borderVisible = this.props.borderVisible;
	
	    if (_.isUndefined(isOpen)) {
	      isOpen = this.state.isOpen;
	    }
	    if (onColor) {
	      onStyle.backgroundColor = isOpen ? onColor : backgroundColor;
	      /*onStyle.borderLeft = this.props.borderColor ? '1px solid ' + this.props.borderColor : '1px solid ' + onColor;*/
	      onStyle.boxSizing = 'border-box';
	    } else {
	      offStyle.backgroundColor = isOpen ? '#ddd' : '#c1c1c1';
	      /*onStyle.borderRight = this.props.borderColor ? '1px solid ' + this.props.borderColor : '1px solid ' + onColor;*/
	      offStyle.display = isOpen ? 'none' : 'block';
	    }
	    if (offColor) {
	      offStyle.backgroundColor = isOpen ? backgroundColor : offColor;
	      offStyle.display = isOpen ? 'none' : 'block';
	    } else {
	      onStyle.backgroundColor = isOpen ? '#41cdd6' : '#ddd';
	    }
	    if (borderColor === 'rgba(0,0,0,0)') {
	      borderColor = 'rgba(102,102,102,1)';
	    }
	    var dom = React.createElement(
	      'div',
	      { className: 'component contents-layout border',
	        style: {
	          lineHeight: this.props.h - 2 + 'px',
	          borderColor: borderVisible ? borderColor : 'inherit'
	        },
	        onClick: this.onClick },
	      React.createElement(
	        'div',
	        { className: 'off', style: offStyle },
	        React.createElement(
	          'label',
	          { style: {
	              display: isOpen ? 'none' : 'block'
	            } },
	          'OFF'
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'on', style: onStyle },
	        React.createElement(
	          'label',
	          { style: {
	              display: isOpen ? 'block' : 'none'
	            } },
	          'ON'
	        )
	      )
	    );
	    return dom;
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onClick);
	  },
	
	  //此事件由jquery触发，没有pageX等点击数据
	  //这里在trigger的时候把原来的事件传下来，而不使用trigger产生的事件
	  onClick: function onClick(e, index, linkKey, evt) {
	    var isOpen = !this.state.isOpen;
	    if (isOpen) {
	      this.props.events.switchOn(evt, this.props, 'interactive-link', 0);
	    } else {
	      this.props.events.switchOff(evt, this.props, 'interactive-link', 0);
	    }
	
	    this.setState({
	      isOpen: isOpen
	    });
	  }
	});
	
	module.exports = Switch;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var graphicsHelper = __webpack_require__(172);
	
	var PointyButton = React.createClass({
	  displayName: 'PointyButton',
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  paintBorder: function paintBorder() {
	    var ctx = ReactDOM.findDOMNode(this.refs.ctx).getContext('2d');
	    var direction = parseInt(this.props.direction, 10);
	    var bg = styleHelper.getBackgroundColor(this.props);
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var radius = 6;
	    var pointSize = 12;
	    var lineWidth = 1;
	    var top = lineWidth / 2;
	    var left = lineWidth / 2;
	    var right = w - lineWidth / 2;
	    var bottom = h - lineWidth / 2;
	    var self = this;
	
	    this.requestID = window.requestAnimationFrame(function () {
	      var ratio = graphicsHelper.applyDeviceRatio(ctx, w, h);
	      w *= ratio;
	      h *= ratio;
	      lineWidth *= ratio;
	      pointSize *= ratio;
	      top *= ratio;
	      left *= ratio;
	      right *= ratio;
	      bottom *= ratio;
	      ctx.beginPath();
	      ctx.lineWidth = lineWidth;
	
	      ctx.strokeStyle = self.props.borderVisible ? styleHelper.getBorderColor(self.props) : 'rgba(255,0,0, 0)';
	      ctx.strokeWidth = lineWidth;
	      ctx.fillStyle = bg;
	      switch (direction) {
	        case 0:
	          ctx.moveTo(pointSize, top);
	          ctx.lineTo(right - radius, top);
	          ctx.quadraticCurveTo(right, top, right, radius);
	          ctx.lineTo(right, bottom - radius);
	          ctx.quadraticCurveTo(right, bottom, right - radius, bottom);
	          ctx.lineTo(pointSize, bottom);
	          ctx.lineTo(left, h / 2);
	          break;
	        case 1:
	          ctx.moveTo(radius, top);
	          ctx.lineTo(right - radius, top);
	          ctx.quadraticCurveTo(right, top, right, radius);
	          ctx.lineTo(right, bottom - radius);
	          ctx.quadraticCurveTo(right, bottom, right - radius, bottom);
	          ctx.lineTo(radius, bottom);
	          ctx.quadraticCurveTo(left, bottom, left, bottom - radius);
	          ctx.lineTo(left, radius);
	          ctx.quadraticCurveTo(left, top, radius, top);
	          break;
	        case 2:
	          ctx.moveTo(radius, top);
	          ctx.lineTo(right - pointSize, top);
	          ctx.lineTo(right, h / 2);
	          ctx.lineTo(right - pointSize, bottom);
	          ctx.lineTo(radius, bottom);
	          ctx.quadraticCurveTo(left, bottom, left, bottom - radius);
	          ctx.lineTo(left, radius);
	          ctx.quadraticCurveTo(left, top, radius, top);
	          break;
	      }
	      ctx.closePath();
	      ctx.fill();
	      ctx.stroke();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.paintBorder();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.paintBorder();
	  },
	
	  render: function render() {
	    var textPaddingRight = this.props.showMenu ? 20 : 0;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var isEnabled = styleHelper.getPropertyValue(this.props, propConst.STATUS) === appTypes.ComStatus2.ENABLE;
	
	    return React.createElement(
	      'div',
	      { className: 'component component-PointyButton',
	        style: {
	          width: w,
	          height: h
	        } },
	      React.createElement('canvas', { ref: 'ctx',
	        style: {
	          position: 'absolute',
	          zIndex: 0,
	          width: '100%',
	          height: '100%'
	        },
	        width: w,
	        height: h,
	        borderColor: styleHelper.getBorderColor(this.props)
	      }),
	      React.createElement(
	        'div',
	        { style: {
	            position: 'absolute',
	            zIndex: 1,
	            left: 0,
	            textAlign: 'center',
	            color: isEnabled ? styleHelper.getTextColor(this.props) : '#999',
	            fontSize: styleHelper.getFontSize(this.props),
	            fontFamily: this.props.textFontFamily,
	            fontStyle: this.props.textStyles.fontStyle,
	            fontWeight: this.props.textStyles.fontWeight,
	            textDecoration: this.props.textStyles.textDecoration,
	            width: w - textPaddingRight
	          } },
	        React.createElement(
	          'label',
	          { style: {
	              height: h,
	              lineHeight: h + 'px',
	              fontFamily: this.props.textFontFamily || decodeURIComponent(this.props.font.family)
	            } },
	          styleHelper.getText(this.props)
	        )
	      ),
	      this.props.showMenu && React.createElement('div', { className: 'menu', style: {
	          top: h / 2 - 2.5,
	          borderTopColor: isEnabled ? '#444' : '#999'
	        } })
	    );
	  }
	});
	
	module.exports = PointyButton;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	var Border = __webpack_require__(168);
	var appTypes = __webpack_require__(115);
	var assetsHelper = __webpack_require__(65);
	var LabelParts = __webpack_require__(174);
	var AutoSizeHelper = __webpack_require__(167);
	var VerticalScrollBar = __webpack_require__(178);
	var _ = __webpack_require__(51);
	var linkHelper = __webpack_require__(158);
	var graphicsHelper = __webpack_require__(172);
	var versionHelper = __webpack_require__(124);
	
	var FOLD_ICON_SIZE = 13;
	var CHECK_BOX_SIZE = 12;
	var LINE_WIDTH = 1;
	var FOLD_ICON_COLOR = 'rgba(102,102,102,1)';
	
	var TreeNode = React.createClass({
	    displayName: 'TreeNode',
	
	    propTypes: {
	        selectIndex: React.PropTypes.number.isRequired,
	        data: React.PropTypes.object.isRequired,
	        itemHeight: React.PropTypes.number.isRequired,
	        onClickEvent: React.PropTypes.func.isRequired,
	        onDbClickEvent: React.PropTypes.func.isRequired,
	        onCheck: React.PropTypes.func.isRequired
	    },
	
	    location: {
	        foldStart: 0,
	        checkStart: 0,
	        iconStart: 0,
	        textStart: 0
	    },
	
	    adjustLocation: function adjustLocation() {
	        var iconSize = this.props.iconSize && parseInt(this.props.iconSize, 10) || 16;
	        this.location.foldStart = 8;
	        this.location.checkStart = 27;
	        this.location.iconStart = 45;
	        this.location.textStart = this.location.iconStart + iconSize;
	        if (!this.props.checkboxvisible) {
	            this.location.iconStart -= 18;
	            this.location.textStart -= 18;
	        }
	        if (!this.props.iconVisible) {
	            this.location.textStart -= iconSize;
	        }
	
	        this.initStyle(iconSize);
	        this.setItemShow(iconSize);
	    },
	
	    foldStyle: {},
	    checkBoxStyle: {},
	    iconStyle: {},
	    lineStyle: {},
	    verticalLine: {},
	    backgroundStyle: {},
	    linkAreaStyle: {},
	    initStyle: function initStyle(iconSize) {
	        this.foldStyle = this.getStyleBySize(FOLD_ICON_SIZE, this.location.foldStart);
	        this.foldStyle.zIndex = 2;
	
	        this.checkBoxStyle = this.getStyleBySize(CHECK_BOX_SIZE - 2, this.location.checkStart);
	        this.checkBoxStyle.border = '1px solid gray';
	        this.checkBoxStyle.background = '#fff';
	        this.checkBoxStyle.zIndex = 2;
	
	        this.iconStyle = this.getStyleBySize(iconSize, this.location.iconStart);
	
	        this.textStyle = {
	            width: '100%',
	            height: this.props.itemHeight,
	            lineHeight: this.props.itemHeight + 'px',
	            overflow: 'hidden',
	            position: 'absolute',
	            top: parseInt((this.props.data.level - 1) * this.props.itemHeight, 10),
	            left: 0,
	            marginLeft: (this.props.data.hierarchy - 1) * 19 + this.location.textStart + 6,
	            zIndex: 0
	        };
	
	        this.lineStyle = {
	            position: 'absolute',
	            top: parseInt((this.props.data.level - 1) * this.props.itemHeight, 10),
	            left: 0,
	            width: 14 + (this.props.data.container.length === 0 ? 16 : 0),
	            height: 1,
	            marginLeft: this.location.foldStart + FOLD_ICON_SIZE / 2 + (this.props.data.hierarchy - 2) * 19,
	            marginTop: (this.props.itemHeight - LINE_WIDTH) / 2,
	            zIndex: 0,
	            borderBottom: '1px dashed #666666'
	        };
	
	        var lastChild = this.props.data.container[this.props.data.container.length - 1];
	        var dy = 0;
	        if (lastChild) {
	            dy = (lastChild.level - this.props.data.level) * this.props.itemHeight - 6.5;
	        }
	        this.verticalLine = {
	            position: 'absolute',
	            top: parseInt((this.props.data.level - 1) * this.props.itemHeight, 10),
	            left: 0,
	            width: 1,
	            height: dy,
	            marginLeft: this.location.foldStart + (FOLD_ICON_SIZE - LINE_WIDTH) / 2 + (this.props.data.hierarchy - 1) * 19,
	            marginTop: this.props.itemHeight / 2 + 6.5,
	            zIndex: 0,
	            borderLeft: '1px dashed #666666'
	        };
	
	        this.backgroundStyle = {
	            width: '100%',
	            height: this.props.itemHeight,
	            overflow: 'hidden',
	            display: this.props.height < this.props.data.level * this.props.itemHeight ? 'none' : 'block',
	            backgroundColor: this.props.selectIndex === this.props.data.no ? this.props.selectedColor : undefined
	        };
	        this.linkAreaStyle = {
	            width: '100%',
	            height: this.props.itemHeight,
	            top: parseInt((this.props.data.level - 1) * this.props.itemHeight, 10),
	            left: 0,
	            position: 'absolute',
	            zIndex: 1,
	            cursor: this.haveAction ? 'pointer' : 'default'
	        };
	    },
	
	    isIconShow: true,
	    isCheckShow: true,
	    isFoldShow: true,
	    isItemShow: true,
	    isLineShow: true,
	    setItemShow: function setItemShow(iconSize) {
	        this.isIconShow = true;
	        this.isCheckShow = true;
	        this.isFoldShow = true;
	        this.isItemShow = true;
	        if (this.iconStyle.marginLeft + iconSize > this.props.w) {
	            this.isIconShow = false;
	        }
	        if (this.checkBoxStyle.marginLeft + CHECK_BOX_SIZE > this.props.w) {
	            this.isCheckShow = false;
	        }
	        if (this.foldStyle.marginLeft + FOLD_ICON_SIZE > this.props.w) {
	            this.isFoldShow = false;
	        }
	        //超出边缘的节点不显示
	        if (this.props.h < this.props.data.level * this.props.itemHeight) {
	            this.isItemShow = false;
	        }
	        if (this.lineStyle.marginLeft + this.lineStyle.width > this.props.w) {
	            this.isLineShow = false;
	        }
	    },
	
	    getStyleBySize: function getStyleBySize(size, beginX) {
	        var style = {
	            position: 'absolute',
	            top: parseInt((this.props.data.level - 1) * this.props.itemHeight, 10),
	            left: 0,
	            width: size,
	            height: size,
	            marginLeft: (this.props.data.hierarchy - 1) * 19 + beginX,
	            marginTop: (this.props.itemHeight - size) / 2,
	            zIndex: 2
	        };
	        return style;
	    },
	
	    render: function render() {
	        this.adjustLocation();
	        var imgSize = (this.props.iconSize && parseInt(this.props.iconSize, 10)) + 2 || 16;
	
	        this.actionData = this.props.data.actionData;
	        this.haveAction = this.actionData.link !== undefined || this.actionData.entry !== undefined || this.actionData.externalURL !== undefined;;
	        this.isLinkAction = this.actionData.link !== undefined || this.actionData.externalURL !== undefined;
	        var linkAreaClass = 'no-link';
	        if (this.haveAction) {
	            if (this.isLinkAction) {
	                linkAreaClass = 'page-link';
	            } else {
	                linkAreaClass = 'interactive-link';
	            }
	        }
	
	        var itemArray = this.props.data.container;
	        return React.createElement(
	            'div',
	            null,
	            this.isItemShow && React.createElement(
	                'div',
	                { style: this.backgroundStyle, onClick: this.handleClick, onDoubleClick: this.handleFold },
	                this.props.treelinevisible && this.props.data.hierarchy > 1 && this.isLineShow && React.createElement('div', { style: this.lineStyle }),
	                this.isFoldShow && React.createElement(
	                    'div',
	                    { style: this.foldStyle, onClick: this.onFoldIconClick },
	                    this.renderFoldIcon(FOLD_ICON_SIZE, FOLD_ICON_COLOR)
	                ),
	                this.props.checkboxvisible && this.isCheckShow && React.createElement(
	                    'div',
	                    { style: this.checkBoxStyle, onClick: this.checkNode },
	                    this.renderCheckIcon(this.props.data.check)
	                ),
	                this.props.iconVisible && this.isIconShow && React.createElement(
	                    'div',
	                    { style: this.iconStyle },
	                    this.renderIcon(this.props.data.type, imgSize, this.props.iconColor || this.props.textColor)
	                ),
	                React.createElement(
	                    'label',
	                    { style: this.textStyle, className: 'tree-label' },
	                    util.Text.convertSpaceToNbsp(this.props.data.text)
	                )
	            ),
	            this.props.treelinevisible && !this.props.data.isClose && React.createElement('div', { style: this.verticalLine }),
	            this.haveAction && React.createElement('div', { className: linkAreaClass,
	                style: this.linkAreaStyle,
	                onClick: this.onSelfClick,
	                onDoubleClick: this.onSelfDblClick,
	                onMouseDown: this.onSelfMouseDown,
	                onMouseUp: this.onSelfMouseUp
	            }),
	            this.props.data.isClose || itemArray.map(function (item) {
	                return React.createElement(TreeNode, _extends({}, this.props, {
	                    data: item,
	                    onCheck: this.props.onCheck,
	                    key: item.no
	                }));
	            }, this)
	        );
	    },
	
	    renderCheckIcon: function renderCheckIcon(state) {
	        return graphicsHelper.renderCheckIcon(12, state);
	    },
	
	    renderFoldIcon: function renderFoldIcon(size, color) {
	        if (this.props.data.container.length === 0) {
	            return;
	        }
	        if (this.props.iconStyle === 'isArrow') {
	            return graphicsHelper.renderIconArrow(size, this.props.data.isClose, color);
	        } else {
	            // isSquare 以及老版本的情况
	            return graphicsHelper.renderIconPlus(size, this.props.data.isClose, color);
	        }
	    },
	
	    renderIcon: function renderIcon(type, size, color) {
	        if (type === "dir") {
	            return graphicsHelper.renderIconDir(size, color);
	        } else if (type === "file") {
	            return graphicsHelper.renderIconFile(size, color);
	        }
	    },
	
	    onFoldIconClick: function onFoldIconClick(e) {
	        this.handleFold();
	        if (this.haveAction) {
	            this.onSelfClick(e);
	        }
	    },
	
	    handleFold: function handleFold() {
	        this.props.onDbClickEvent(this.props.data.no);
	    },
	
	    handleClick: function handleClick() {
	        this.props.onClickEvent(this.props.data.no);
	    },
	
	    checkNode: function checkNode() {
	        this.props.onCheck(this.props.data.no);
	    },
	
	    onSelfClick: function onSelfClick(e) {
	        var k;
	        if (this.longPress) {
	            return;
	        }
	        if (this.actionData) {
	            k = appTypes.ActionResponseType.NONE;
	            if (this.actionData.externalURL) {
	                k = appTypes.ActionResponseType.OUTER;
	            } else if (this.actionData.link) {
	                k = appTypes.ActionResponseType.LINK;
	            } else if (this.actionData.entry) {
	                k = appTypes.ActionResponseType.INTERACTIVE;
	            }
	        } else {
	            return;
	        }
	        if (e.button === 0) {
	            this.handleClick();
	            this.props.events.doSelfClick(e, this.props, k, this.props.data.no);
	        }
	    },
	
	    actionData: undefined,
	    haveAction: false,
	    isLinkAction: false,
	    mousePress: false,
	    longPressID: undefined,
	    longPress: false,
	
	    onSelfDblClick: function onSelfDblClick(e) {
	        this.props.onDbClickEvent(this.props.data.no);
	        if (this.props.events.doSelfDbClick) {
	            this.props.events.doSelfDbClick(e, this.props, this.props.data.no);
	        }
	    },
	
	    onSelfRightClick: function onSelfRightClick(e) {
	        if (this.props.events.doSelfRightClick) {
	            this.props.events.doSelfRightClick(e, this.props, this.props.data.no);
	        }
	    },
	
	    onSelfMouseDown: function onSelfMouseDown(e) {
	        if (e.button === 0) {
	            this.mousePress = true;
	            this.startLongPress(e);
	        } else if (e.button === 2) {
	            this.onSelfRightClick(e);
	        }
	    },
	
	    onSelfMouseUp: function onSelfMouseUp(e) {
	        this.mousePress = false;
	        this.longPress = false;
	        this.stopLongPress();
	    },
	
	    stopLongPress: function stopLongPress() {
	        if (this.longPressID) {
	            clearTimeout(this.longPressID);
	        }
	        delete this.longPressID;
	    },
	
	    startLongPress: function startLongPress(e) {
	        var self = this;
	        var data = this.actionData;
	        var entry;
	        if (data) {
	            entry = data.entry;
	        }
	        if (linkHelper.hasLongPressByEntry(entry)) {
	            this.longPressID = setTimeout(function () {
	                if (self.mousePress) {
	                    self.longPress = true;
	                    if (self.props.events.doSelfLongPress) {
	                        self.props.events.doSelfLongPress(e, self.props, self.props.data.no);
	                    }
	                }
	                self.stopLongPress();
	            });
	        }
	    }
	
	});
	
	var TreeEx = React.createClass({
	    displayName: 'TreeEx',
	
	
	    _myPush: function _myPush(dirStack, value) {
	        dirStack.dirs.push(value);
	        dirStack.top++;
	    },
	
	    _myPop: function _myPop(dirStack, number) {
	        for (var i = 0; i < number; i++) {
	            dirStack.dirs.pop();
	            dirStack.top--;
	        }
	    },
	
	    _getTop: function _getTop(dirStack) {
	        if (dirStack.top === -1) {
	            return null;
	        }
	        return dirStack.dirs[dirStack.top];
	    },
	
	    parseText: function parseText() {
	        var lines = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)), util.Text.DM_RETURN);
	
	        //1、建立一个目录栈，推入根节点
	        var dirStack = {
	            top: -1,
	            dirs: []
	        };
	        var root = [];
	        var actionDatas = [];
	
	        if (this.props.interactiveData || this.props.links) {
	            actionDatas = linkHelper.parseComInteractive(this.props);
	        }
	        this._myPush(dirStack, root);
	
	        for (var i = 0; i < lines.length; i++) {
	            //2、判断目标层级，大于栈顶级别，放入栈顶目录，小于等于栈顶级别，弹出（差值+1）个栈顶目录,再放入栈顶目录
	            var level = 1;
	            var line = lines[i].trim();
	            for (var j = 0; j < line.length; j++) {
	                if (line.charAt(j) === ".") {
	                    level++;
	                } else {
	                    break;
	                }
	            }
	
	            //找到父节点
	            if (dirStack.top >= level) {
	                this._myPop(dirStack, dirStack.top + 1 - level); //弹出差值+1个元素，当前栈顶就是父节点
	            }
	
	            //3、新建节点项
	            var item = {
	                "no": i,
	                "text": "",
	                type: "",
	                "hierarchy": dirStack.top + 1,
	                "container": [],
	                "isClose": false,
	                "level": 0,
	                "check": "false",
	                actionData: actionDatas[i] || {}
	            };
	
	            var re = /^\.*\[[+|-]\].*$/;
	            if (re.test(line)) {
	                //检查是否目录
	                var text = line.replace(/^\.*\[[+|-]\]/, ""); //提取节点名
	                item.text = text;
	                item.type = "dir";
	                var state = line.match(/\[[+|-]\]/g); //提取目录状态（+号展开|-号收缩）
	                if (state[0] === "[+]") {
	                    item.isClose = true;
	                }
	            } else {
	                var text = line.replace(/^\.*/, "");
	                item.text = text;
	                item.type = "file";
	            }
	
	            //4、将当前节点放入栈顶目录（位于栈顶的目录为父目录）的容器中
	            this._getTop(dirStack).push(item);
	
	            //4、若新节点是目录，压入目录栈
	            this._myPush(dirStack, item.container);
	        }
	
	        return root;
	    },
	
	    itemArray: undefined,
	    itemPosition: 0,
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedIndex: this.props.selectedIndex,
	            dbClickIndex: -1,
	            mySwitch: true
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.itemHeight = this.props.itemHeight;
	        this.itemArray = this.parseText();
	        this.resetLevel(this.itemArray);
	    },
	
	    searchTree: function searchTree(root, dbClickIndex) {
	        if (dbClickIndex < 0) {
	            return;
	        }
	        for (var i = 0; i < root.length; i++) {
	            var index = root[i].no;
	            if (index === dbClickIndex) {
	                root[i].isClose = !root[i].isClose;
	                return;
	            }
	            this.searchTree(root[i].container, dbClickIndex);
	        }
	    },
	
	    resetLevel: function resetLevel(root, index) {
	        for (var i = 0; i < root.length; i++) {
	            this.itemPosition = this.itemPosition + 1;
	            root[i].level = this.itemPosition;
	            if (!root[i].isClose) {
	                this.resetLevel(root[i].container);
	            }
	        }
	    },
	
	    setChildCheck: function setChildCheck(root, checkValue) {
	        var children = root.container;
	        for (var i = 0; i < children.length; i++) {
	            children[i].check = checkValue;
	            this.setChildCheck(children[i], checkValue);
	        }
	    },
	
	    setRootCheck: function setRootCheck(root) {
	        var checkNum = 0;
	        var unCheckNum = 0;
	        var children = root.container;
	        for (var i = 0; i < children.length; i++) {
	            if (children[i].container.length > 0) {
	                this.setRootCheck(children[i]);
	            }
	            if (children[i].check === 'true') {
	                checkNum++;
	            }
	            if (children[i].check === 'false') {
	                unCheckNum++;
	            }
	        }
	        if (checkNum === children.length) {
	            root.check = 'true';
	        } else if (unCheckNum === children.length) {
	            root.check = 'false';
	        } else {
	            root.check = 'half';
	        }
	    },
	
	    resetCheck: function resetCheck(root, index) {
	        if (root.no === index) {
	            var checkValue = 'false';
	            if (root.check === 'true' || root.check === 'half') {
	                checkValue = 'false';
	            } else if (root.check === 'false') {
	                checkValue = 'true';
	            }
	            root.check = checkValue;
	            this.setChildCheck(root, checkValue);
	            return;
	        }
	        var children = root.container;
	        for (var i = 0; i < children.length; i++) {
	            var node = children[i];
	            this.resetCheck(node, index);
	        }
	    },
	
	    onCheck: function onCheck(index) {
	        for (var i = 0; i < this.itemArray.length; i++) {
	            this.resetCheck(this.itemArray[i], index);
	            this.setRootCheck(this.itemArray[i]);
	        }
	    },
	
	    render: function render() {
	        var borderStyle = styleHelper.StyleUtil(this.props).text().border().size().base().background().style;
	        return React.createElement(
	            'div',
	            { style: borderStyle },
	            React.createElement(
	                'div',
	                { style: {
	                        height: '100%',
	                        width: this.props.verticalScrollbarShow ? styleHelper.getWidth(this.props) - 16 : '100%'
	                    } },
	                this.itemArray.map(function (item) {
	                    return React.createElement(TreeNode, _extends({}, this.props, {
	                        key: item.no,
	                        data: item,
	                        selectIndex: this.state.selectedIndex,
	                        dbClickIndex: this.state.dbClickIndex,
	                        itemHeight: this.itemHeight,
	                        onClickEvent: this._onClick,
	                        onDbClickEvent: this._onDbClick,
	                        onCheck: this.onCheck
	                    }));
	                }, this)
	            ),
	            this.props.verticalScrollbarShow && React.createElement(VerticalScrollBar, { value: parseInt(this.props.verticalScrollbarProgress, 10) })
	        );
	    },
	
	    _onClick: function _onClick(no) {
	        var index = undefined;
	        if (arguments.length === 1) {
	            index = arguments[0];
	        } else if (arguments.length === 2) {
	            index = arguments[1];
	        }
	        if (!_.isUndefined(index)) this.setState({ selectedIndex: index });
	    },
	
	    _onDbClick: function _onDbClick(no) {
	
	        var dbClickIndex = undefined;
	        if (arguments.length === 1) {
	            dbClickIndex = arguments[0];
	        } else if (arguments.length === 2) {
	            dbClickIndex = arguments[1];
	        }
	        if (!_.isUndefined(dbClickIndex)) {
	            var s = !this.state.mySwitch;
	            //递归搜索树，修改双击节点状态（展开|收缩）
	            this.searchTree(this.itemArray, dbClickIndex);
	            this.itemPosition = 0;
	            this.resetLevel(this.itemArray);
	            this.setState({ mySwitch: s });
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        $(ReactDOM.findDOMNode(this)).bind('itemClick', this._onClick);
	        $(ReactDOM.findDOMNode(this)).bind('itemDbClick', this._onDbClick);
	    }
	});
	
	var NodeType = { None: 1, Expansion: 2, Close: 3, File: 4 };
	
	var TreeItem = React.createClass({
	    displayName: 'TreeItem',
	
	    propTypes: {
	        selected: React.PropTypes.bool.isRequired,
	        data: React.PropTypes.object.isRequired,
	        itemHeight: React.PropTypes.number.isRequired,
	        onClickEvent: React.PropTypes.func.isRequired
	    },
	
	    render: function render() {
	        var imgStyle;
	        var textStyle;
	        var imgSize;
	
	        var backgroundStyle = {
	            width: '100%',
	            height: this.props.itemHeight,
	            backgroundColor: this.props.selected ? this.props.selectedColor : undefined
	        };
	
	        imgSize = this.props.iconSize && parseInt(this.props.iconSize, 10) || 16;
	
	        imgStyle = {
	            float: 'left',
	            width: imgSize,
	            height: imgSize,
	            marginLeft: 4 + this.props.data.hierarchy * 20,
	            marginTop: (this.props.itemHeight - imgSize) / 2
	        };
	
	        textStyle = {
	            lineHeight: this.props.itemHeight + 'px'
	        };
	
	        return React.createElement(
	            'div',
	            { style: backgroundStyle, onClick: this.props.onClickEvent },
	            React.createElement(
	                'div',
	                { style: imgStyle },
	                this.renderIcon(imgSize, this.props.iconColor || this.props.textColor)
	            ),
	            React.createElement(
	                'label',
	                { style: textStyle },
	                util.Text.convertSpaceToNbsp(this.props.data.text)
	            )
	        );
	    },
	    renderIcon: function renderIcon(size, color) {
	        var parentSize = Math.round(size * 0.8);
	        if (this.props.iconStyle === 'isArrow') {
	            if (this.props.data.nodeType === NodeType.Close) {
	                return this.renderIconArrow(parentSize, false, color);
	            } else if (this.props.data.nodeType === NodeType.Expansion) {
	                return this.renderIconArrow(parentSize, true, color);
	            }
	        } else {
	            // isSquare 以及老版本的情况下
	            if (this.props.data.nodeType === NodeType.Close) {
	                return this.renderIconDir(parentSize, false, color);
	            } else if (this.props.data.nodeType === NodeType.Expansion) {
	                return this.renderIconDir(parentSize, true, color);
	            }
	        }
	        return this.renderIconFile(size, color);
	    },
	    renderIconDir: function renderIconDir(size, expanded, color) {
	        return React.createElement(
	            'svg',
	            { width: size, height: size, viewBox: '0 0 20 20' },
	            React.createElement('rect', { x: '1', y: '1', width: '18', height: '18', stroke: color, fill: 'none', strokeWidth: '2' }),
	            React.createElement('line', { x1: '4', y1: '10', x2: '16', y2: '10', stroke: color, strokeWidth: '2' }),
	            expanded && React.createElement('line', { x1: '10', y1: '4', x2: '10', y2: '16', stroke: color, strokeWidth: '2' })
	        );
	    },
	    renderIconFile: function renderIconFile(size, color) {
	        return React.createElement(
	            'svg',
	            { width: size, height: size, viewBox: '0 0 20 20' },
	            React.createElement('path', { d: 'M 1 1 L 8 0 L 8 8 L 16 8 L 16 19 L 0 19 Z M 8 0 L 16 8', strokeWidth: '2', stroke: color,
	                fill: 'none' })
	        );
	    },
	    renderIconArrow: function renderIconArrow(size, expanded, color) {
	        if (expanded) {
	            return React.createElement(
	                'svg',
	                { width: size, height: size, viewBox: '0 0 20 20' },
	                React.createElement('line', { x1: '1', y1: '1', x2: '9', y2: '9', stroke: color, strokeWidth: '2' }),
	                React.createElement('line', { x1: '9', y1: '9', x2: '18', y2: '1', stroke: color, strokeWidth: '2' })
	            );
	        }
	        return React.createElement(
	            'svg',
	            { width: size, height: size, viewBox: '0 0 20 20' },
	            expanded || React.createElement('line', { x1: '1', y1: '1', x2: '9', y2: '9', stroke: color, strokeWidth: '2' }),
	            React.createElement('line', { x1: '1', y1: '18', x2: '9', y2: '9', stroke: color, fill: 'none', strokeWidth: '2' }),
	            expanded && React.createElement('line', { x1: '9', y1: '9', x2: '18', y2: '18', stroke: color, strokeWidth: '2' })
	        );
	    }
	});
	
	var TreeOld = React.createClass({
	    displayName: 'TreeOld',
	
	
	    _parseItemText: function _parseItemText(text) {
	        var resultObj = {
	            hierarchy: 0,
	            nodeType: NodeType.None,
	            text: ''
	        };
	
	        var length = text.length;
	        var index = 0;
	        var bracket = false;
	        var ch;
	        var isLoop = true;
	
	        while (index < length && isLoop) {
	            ch = text.charAt(index);
	            switch (ch) {
	                case '.':
	                    resultObj.hierarchy = resultObj.hierarchy + 1;
	                    break;
	                case '[':
	                    bracket = true;
	                    break;
	                case ']':
	                    bracket = false;
	                    isLoop = false;
	                    break;
	                case '+':
	                    if (bracket) {
	                        resultObj.nodeType = NodeType.Expansion;
	                    } else {
	                        isLoop = false;
	                    }
	                    break;
	                case '-':
	                    if (bracket) {
	                        resultObj.nodeType = NodeType.Close;
	                    } else {
	                        resultObj.nodeType = NodeType.File;
	                        isLoop = false;
	                    }
	                    break;
	                default:
	                    isLoop = false;
	            }
	            index = index + 1;
	        }
	
	        resultObj.text = text.substring(index, text.length);
	
	        return resultObj;
	    },
	
	    _getItemArray: function _getItemArray() {
	        var resultArray = [];
	        var textArray = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)), util.Text.DM_RETURN);
	
	        textArray.forEach(function (text) {
	            resultArray.push(this._parseItemText(text.trim()));
	        }.bind(this));
	
	        return resultArray;
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedIndex: this.props.selectedIndex
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        var size = AutoSizeHelper.getComAutoSize(this.props, '^p');
	        this.itemHeight = Math.round(size.height + 2 * 7.8);
	    },
	
	    render: function render() {
	        var itemArray = this._getItemArray();
	        var borderStyle = styleHelper.StyleUtil(this.props).text().border().size().base().background().style;
	        return React.createElement(
	            'div',
	            { style: borderStyle },
	            React.createElement(
	                'div',
	                { style: {
	                        height: '100%',
	                        width: this.props.verticalScrollbarShow ? styleHelper.getWidth(this.props) - 16 : '100%'
	                    } },
	                itemArray.map(function (item, index) {
	                    return React.createElement(TreeItem, _extends({}, this.props, {
	                        key: index,
	                        data: item,
	                        selected: index === this.state.selectedIndex,
	                        itemHeight: this.itemHeight,
	                        onClickEvent: this._onClick.bind(this, null, index)
	                    }));
	                }.bind(this))
	            ),
	            this.props.verticalScrollbarShow && React.createElement(VerticalScrollBar, { value: parseInt(this.props.verticalScrollbarProgress, 10) })
	        );
	    },
	
	    _onClick: function _onClick(e, index) {
	        this.setState({ selectedIndex: index });
	    },
	
	    componentDidMount: function componentDidMount() {
	        $(ReactDOM.findDOMNode(this)).bind('itemClick', this._onClick);
	    }
	});
	
	/**
	 * Tree外壳，根据版本选择具体的Tree实现
	 */
	var Tree = React.createClass({
	    displayName: 'Tree',
	
	
	    render: function render() {
	        var isOldVersion = versionHelper.isPageVersionLowerThan4_5();
	
	        if (isOldVersion) {
	            return React.createElement(TreeOld, this.props);
	        }
	        return React.createElement(TreeEx, this.props);
	    }
	
	});
	
	module.exports = Tree;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var graphicsHelper = __webpack_require__(172);
	
	var LineChart = React.createClass({
	  displayName: 'LineChart',
	
	  render: function render() {
	
	    return React.createElement(
	      'div',
	      { className: 'border' },
	      React.createElement('img', { width: '100%', height: '100%', src: assetsHelper.getComponentAsset('lineChart'), alt: '' })
	    );
	  }
	});
	
	module.exports = LineChart;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	var util = __webpack_require__(116);
	
	var LineChart = React.createClass({
	  displayName: 'LineChart',
	
	
	  itemNum: 0,
	
	  parseText: function parseText() {
	
	    var lines = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)), util.Text.DM_RETURN);
	    var result = [];
	    var colors = [];
	
	    for (var i = 0; i < lines.length; i++) {
	      var item = {
	        points: undefined,
	        color: 'rgba(0,0,0,1)'
	      };
	      var datas = lines[i].split(/,|，/);
	
	      var colorStr = graphicsHelper.tranColor(datas[datas.length - 1].trim());
	      colors.push(colorStr);
	      var off = 1;
	      if (colorStr === "empty") {
	        //colorStr = "ff000000";
	        off = 0;
	      }
	      //item.color = graphicsHelper.toRGBA(colorStr);
	
	      var points = [];
	      if (datas.length - 1 - off > this.itemNum) {
	        this.itemNum = datas.length - 1 - off;
	      }
	      for (var j = 0; j < datas.length - off; j++) {
	        var n = 0;
	        if (datas[j] === '-') {
	          n = -1;
	        } else if (parseFloat(datas[j])) {
	          n = parseFloat(datas[j]);
	          if (n > 100) {
	            n = 100;
	          }
	          if (n < 0) {
	            n = 0;
	          }
	        }
	        points.push(n);
	      }
	      item.points = points;
	
	      result.push(item);
	    }
	    graphicsHelper.getTempleteColor(colors);
	    for (var i = 0; i < result.length; i++) {
	      result[i].color = graphicsHelper.toRGBA(colors[i]);
	    }
	
	    return result;
	  },
	
	  fillCanvas: function fillCanvas() {
	
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    var context = canvas.getContext('2d');
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var ratio = graphicsHelper.applyDeviceRatio(context, w, h);
	    w *= ratio;
	    h *= ratio;
	    var width = Math.round(w * 0.9);
	    var height = Math.round(h * 0.9);
	
	    var offset = Math.round(h * 0.1);
	
	    var result = this.parseText();
	    context.lineWidth = ratio;
	    for (var i = 0; i < result.length; i++) {
	      var item = result[i];
	      var points = item.points;
	      if (points.length > 0) {
	        var itemWidth = Math.round(width / this.itemNum);
	        context.beginPath();
	        context.strokeStyle = item.color;
	        var beginY = points[0];
	        var beginX = 0;
	        if (points[0] === -1 && points.length > 1) {
	          beginX = itemWidth;
	          beginY = points[1];
	        }
	        context.moveTo(beginX, Math.round(height - height * 0.9 * beginY / 100 + offset));
	        for (var j = 1; j < points.length; j++) {
	          if (points[j] === -1) {
	            continue;
	          }
	          context.lineTo(itemWidth * j, Math.round(height - height * 0.9 * points[j] / 100 + offset));
	        }
	        context.stroke();
	      }
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.fillCanvas();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.fillCanvas();
	  },
	
	  render: function render() {
	    var style = styleHelper.StyleUtil(this.props).size().style;
	    return React.createElement(
	      'div',
	      { className: 'component-SimpleCom' },
	      React.createElement(
	        'canvas',
	        { ref: 'canvas', width: style.width, height: style.height },
	        '\u6D4F\u89C8\u5668\u4E0D\u652F\u6301canvas'
	      ),
	      this.props.axisvisible && React.createElement('div', { className: 'component-Chart-Coord' })
	    );
	  }
	});
	
	module.exports = LineChart;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var IconParts = __webpack_require__(233);
	var _ = __webpack_require__(51);
	
	var Icon = React.createClass({
	  displayName: 'Icon',
	
	  render: function render() {
	    var props = _.extend({}, this.props);
	    props.x = props.y = 0;
	    delete props.currentX;
	    delete props.currentY;
	    return React.createElement(IconParts, props);
	  }
	});
	
	module.exports = Icon;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	var assetsHelper = __webpack_require__(65);
	var propConst = __webpack_require__(147);
	var appTypes = __webpack_require__(115);
	var projectLoadHelper = __webpack_require__(68);
	var _ = __webpack_require__(51);
	var ColorImage = __webpack_require__(234);
	var envHelper = __webpack_require__(48);
	
	/**
	 * 图标组件部件
	 */
	var IconParts = React.createClass({
	  displayName: 'IconParts',
	
	
	  propTypes: {
	    rotateAngle: React.PropTypes.string,
	    imgSource: React.PropTypes.string,
	    flipHorizontal: React.PropTypes.bool,
	    flipVertical: React.PropTypes.bool,
	    URL: React.PropTypes.string,
	    partStyle: React.PropTypes.object
	  },
	
	  isSVGIcon: false,
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    this.isSVGIcon = this.props.icon && this.props.icon.iconFontName && this.props.icon.iconCode && parseInt(this.props.icon.iconCode, 10) !== -1;
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.isSVGIcon = this.props.icon && this.props.icon.iconFontName && this.props.icon.iconCode && parseInt(this.props.icon.iconCode, 10) !== -1;
	  },
	
	  initTransformStyle: function initTransformStyle(style) {
	    var transform;
	    var transform3D;
	    var rotationAngle = styleHelper.getPropertyValue(this.props, propConst.ROTATION_ANGLE);
	    var flipH = styleHelper.getPropertyValue(this.props, propConst.FLIP_HORIZONTAL);
	    var flipV = styleHelper.getPropertyValue(this.props, propConst.FLIP_VERTICAL);
	    if (rotationAngle && !this.isSVGIcon) {
	      switch (rotationAngle) {
	        case appTypes.RotationAngle.NINETY:
	          transform = 'rotate(90deg)';
	          break;
	        case appTypes.RotationAngle.ONE_HUNDRED_EIGHTY:
	          transform = 'rotate(180deg)';
	          break;
	        case appTypes.RotationAngle.TWO_HUNDRED_SEVENTY:
	          transform = 'rotate(-90deg)';
	          break;
	        default:
	          transform = '';
	          break;
	      }
	    }
	    if (flipH && flipV) {
	      transform3D = 'rotate3D(0,0,1,180deg)';
	    } else if (flipH) {
	      transform3D = 'rotate3D(0,1,0,180deg)';
	    } else if (flipV) {
	      transform3D = 'rotate3D(1,0,0,180deg)';
	    }
	
	    if (transform3D) {
	      if (transform) {
	        transform += ' ';
	      }
	      transform += transform3D;
	    }
	    if (transform) {
	      style.transform = transform;
	    }
	  },
	  scaleIconCodes: { "62413": 1.139344262295082, "61979": 1.217821782178218 },
	  scaleIcon: function scaleIcon(style) {
	    var ratio = this.scaleIconCodes[this.props.icon.iconCode];
	    if (ratio) {
	      style.width = Math.round(this.props.w * ratio);
	      style.height = Math.round(this.props.h * ratio);
	      var offsetX = Math.round((this.props.w - style.width) / 2);
	      var offsetY = Math.round((this.props.h - style.height) / 2);
	      style.left = offsetX;
	      style.top = offsetY;
	      style.fontSize = style.width + 'px';
	      style.lineHeight = style.width + 'px';
	    }
	  },
	
	  renderSVGIcon: function renderSVGIcon() {
	    var iconFontName = this.props.icon.iconFontName;
	    var style = {
	      borderStyle: 'none',
	      width: '100%',
	      height: '100%',
	      backgroundColor: 'rgba(0,0,0,0)',
	      pointerEvents: 'none',
	      position: 'absolute',
	      fontFamily: iconFontName,
	      fontSize: Math.min(styleHelper.getWidth(this.props), styleHelper.getHeight(this.props)),
	      color: styleHelper.getBackgroundColor(this.props),
	      textAlign: 'center',
	      lineHeight: styleHelper.getWidth(this.props) + 'px'
	    };
	    var className = '';
	
	    // 在 iOS 和 macOS 上，jongdefontC 和 jongdefontD 这两个字体的文字内容往上偏移了 11%，这里需要校正。
	    if (envHelper.isMac() || envHelper.isiOS()) {
	      if (iconFontName === 'jdiconfontC') {
	        className = 'mac-ios-icon-transform-C';
	      } else if (iconFontName === 'jdiconfontD') {
	        className = 'mac-ios-icon-transform-D';
	      }
	    }
	
	    //屏蔽企业版字体
	    if (iconFontName === 'jdiconfontC' || iconFontName === 'jdiconfontD') {
	      return React.createElement('div', null);
	    }
	
	    this.initTransformStyle(style);
	    this.scaleIcon(style);
	    return React.createElement(
	      'div',
	      {
	        id: this.props.id,
	        className: className,
	        ref: 'svgIcon',
	        key: this.props.id,
	        style: style },
	      String.fromCharCode(this.props.icon.iconCode)
	    );
	  },
	
	  renderImageIcon: function renderImageIcon() {
	    var imgStyle;
	    var imagePath;
	
	    if (this.props.icon.ID && !_.isEmpty(this.props.icon.ID)) {
	      imagePath = assetsHelper.getIcon(this.props.icon.ID);
	    } else if (!_.isEmpty(this.props.URL)) {
	      imagePath = projectLoadHelper.loadSVG(this.props.URL);
	    } else {
	      imagePath = assetsHelper.getIcon(this.props.defaultIcon || 'Empty.png');
	    }
	
	    imgStyle = {
	      width: styleHelper.getWidth(this.props),
	      height: styleHelper.getHeight(this.props),
	      border: 'none',
	      backgroundColor: null,
	      position: 'absolute'
	    };
	    return React.createElement(ColorImage, {
	      src: imagePath,
	      style: imgStyle,
	      k: 'color_image',
	      color: styleHelper.getBackgroundColor(this.props)
	    });
	  },
	
	  render: function render() {
	    var divStyle;
	    divStyle = {
	      width: styleHelper.getWidth(this.props),
	      height: styleHelper.getHeight(this.props),
	      left: styleHelper.getX(this.props),
	      top: styleHelper.getY(this.props),
	      border: 'none',
	      position: 'absolute'
	    };
	
	    this.initTransformStyle(divStyle);
	    //this.scaleIcon(divStyle);
	
	    return React.createElement(
	      'div',
	      { style: divStyle, key: 'iconParts' + this.props.controlID },
	      this.isSVGIcon && this.renderSVGIcon(),
	      !this.isSVGIcon && this.renderImageIcon()
	    );
	  }
	
	});
	
	module.exports = IconParts;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var graphicsHelper = __webpack_require__(172);
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var GlobalConst = __webpack_require__(164);
	
	/**
	 * 可进行图片颜色变化的组件
	 */
	var ColorImage = React.createClass({
	  displayName: 'ColorImage',
	
	
	  propTypes: {
	    src: React.PropTypes.string.isRequired,
	    color: React.PropTypes.string,
	    gridRect: React.PropTypes.object,
	    style: React.PropTypes.object
	  },
	
	  render: function render() {
	    var sw = this.props.style ? this.props.style.width : this.props.width || '100%';
	    var sh = this.props.style ? this.props.style.height : this.props.height || '100%';
	    var style = this.props.style;
	
	    if (!style) {
	      style = {};
	    }
	    return React.createElement(
	      'canvas',
	      {
	        key: this.props.k,
	        ref: 'ctx',
	        width: sw,
	        height: sh,
	        style: style },
	      React.createElement('img', {
	        ref: 'img',
	        src: this.props.src,
	        style: {
	          width: sw,
	          height: sh,
	          visibility: 'hidden'
	        },
	        onLoad: this._onImageLoaded
	      })
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.isChanged = true;
	    this.doPaint();
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	    this.isChanged = false;
	    if (this.props.src !== newProps.src) {
	      this.isChanged = true;
	    } else if (this.props.color !== newProps.color) {
	      this.isChanged = true;
	    } else if (JSON.stringify(this.props.style) !== JSON.stringify(newProps.style)) {
	      this.isChanged = true;
	    }
	
	    return this.isChanged;
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    //if (this.isChanged) {
	    this.doPaint();
	    this.isChanged = false;
	    //}
	  },
	
	  _onImageLoaded: function _onImageLoaded() {
	    this.isLoaded = true;
	    this.doPaint();
	  },
	
	  isChanged: true,
	
	  doPaint: function doPaint() {
	    var gridRect = this.props.gridRect;
	    var color = this.props.color || GlobalConst.GLOBAL_COLOR.DARK_GRAY_COLOR;
	    var canvas = ReactDOM.findDOMNode(this.refs.ctx);
	    var img = ReactDOM.findDOMNode(this.refs.img);
	    var w = 0;
	    var h = 0;
	    if (!this.isChanged) {
	      return;
	    }
	    if (canvas && img) {
	      w = canvas.clientWidth;
	      h = canvas.clientHeight;
	    } else {
	      return;
	    }
	
	    //这里显示的强制再设置一次Canvas的width,height
	    //Canvas的width,height必须要为明确的像素值，而不能是相对的百分比
	    canvas.width = w;
	    canvas.height = h;
	
	    graphicsHelper.drawColorImage(canvas.getContext('2d'), img, color, gridRect, {
	      left: 0,
	      top: 0,
	      right: w,
	      bottom: h
	    });
	  }
	});
	
	module.exports = ColorImage;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var convertHelper = __webpack_require__(146);
	var appTypes = __webpack_require__(115);
	var VerticalScrollBar = __webpack_require__(178);
	var GlobalConst = __webpack_require__(164);
	var linkHelper = __webpack_require__(158);
	var RuntimeOptions = __webpack_require__(153);
	var util = __webpack_require__(116);
	
	/***
	 * 每一个项
	 */
	var AccordionItem = React.createClass({
	  displayName: 'AccordionItem',
	
	  render: function render() {
	    var offsetX = 20 * this.props.leave + 6;
	    var haveAction = this.props.actionData.link != undefined || this.props.actionData.entry != undefined || this.props.actionData.externalURL != undefined;
	    var isLinkAction = this.props.actionData.link != undefined || this.props.actionData.externalURL != undefined;
	    var clz = 'no-link';
	    if (haveAction) {
	      if (isLinkAction) {
	        clz = 'page-link';
	      } else {
	        clz = 'interactive-link';
	      }
	    }
	    var AccordionItemStyle = {
	      paddingLeft: offsetX,
	      //borderBottomStyle:  this.props.leave === 0 ?'solid':'none',
	      //borderColor: GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK,
	      backgroundColor: this.props.color
	    };
	    if (this.props.showSeparator) {
	      AccordionItemStyle.borderBottom = '1px solid ' + this.props.separatorColor;
	    } else {
	      AccordionItemStyle.borderBottom = '1px solid ' + 'rgba(0,0,0, 0)';
	    }
	
	    return React.createElement(
	      'div',
	      {
	        className: 'AccordionItem',
	        id: this.props.controlID + '_' + this.props.index,
	        style: AccordionItemStyle,
	        onClick: this.onSelfClick,
	        onDoubleClick: this.onSelfDblClick,
	        onMouseDown: this.onSelfMouseDown,
	        onMouseUp: this.onSelfMouseUp
	      },
	      React.createElement(
	        'label',
	        null,
	        util.Text.convertSpaceToNbsp(this.props.title)
	      ),
	      React.createElement('div', { className: clz,
	        style: {
	          width: '100%',
	          height: '100%',
	          top: 0,
	          left: 0,
	          position: 'absolute',
	          zIndex: 1,
	          cursor: haveAction ? 'pointer' : 'default'
	        }
	      })
	    );
	  },
	  onSelfClick: function onSelfClick(e) {
	    var k;
	
	    if (this.longPress) {
	      return;
	    }
	    if (this.props.actionData) {
	      k = appTypes.ActionResponseType.NONE;
	      if (this.props.actionData.externalURL) {
	        k = appTypes.ActionResponseType.OUTER;
	      } else if (this.props.actionData.link) {
	        k = appTypes.ActionResponseType.LINK;
	      } else if (this.props.actionData.entry) {
	        k = appTypes.ActionResponseType.INTERACTIVE;
	      }
	    }
	    if (e.button === 0) {
	      if (this.props.onClick) {
	        this.props.onClick(e, k, this.props.index);
	      }
	    }
	  },
	
	  mousePress: false,
	
	  longPressID: undefined,
	
	  longPress: false,
	
	  onSelfDblClick: function onSelfDblClick(e) {
	    if (this.props.onDoubleClick) {
	      this.props.onDoubleClick(e, this.props.index);
	    }
	  },
	
	  onSelfRightClick: function onSelfRightClick(e) {
	    if (this.props.onRightClick) {
	      this.props.onRightClick(e, this.props.index);
	    }
	  },
	
	  onSelfMouseDown: function onSelfMouseDown(e) {
	    if (e.button === 0) {
	      this.mousePress = true;
	      this.startLongPress(e);
	    } else if (e.button === 2) {
	      this.onSelfRightClick(e);
	    }
	  },
	
	  onSelfMouseUp: function onSelfMouseUp(e) {
	    this.mousePress = false;
	    this.longPress = false;
	    this.stopLongPress();
	  },
	
	  stopLongPress: function stopLongPress() {
	    if (this.longPressID) {
	      clearTimeout(this.longPressID);
	    }
	    delete this.longPressID;
	  },
	
	  startLongPress: function startLongPress(e) {
	    var self = this;
	    var data = this.props.actionData;
	    var entry;
	    if (data) {
	      entry = data.entry;
	    }
	    if (linkHelper.hasLongPressByEntry(entry)) {
	      this.longPressID = setTimeout(function () {
	        if (self.mousePress) {
	          self.longPress = true;
	          if (self.props.onLongPress) {
	            self.props.onLongPress(e, self.props.index);
	          }
	        }
	        self.stopLongPress();
	      });
	    }
	  }
	
	});
	/***
	 * 每一个分组
	 */
	var AccordionModule = React.createClass({
	  displayName: 'AccordionModule',
	
	  render: function render() {
	    var h = (this.props.expand ? this.props.childHeight : 0) + 30;
	    var boxStyle = {
	      height: this.props.expand ? this.props.childHeight : 0,
	      overflow: 'hidden'
	    };
	    if (this.props.showSeparator) {
	      boxStyle.borderBottom = '1px solid ' + this.props.separatorColor;
	    } else {
	      boxStyle.borderBottom = '1px solid ' + 'rgba(0,0,0, 0)';
	    }
	
	    return React.createElement(
	      'div',
	      {
	        className: 'AccordionModule',
	        style: { height: h, overflow: 'hidden' } },
	      React.createElement(AccordionItem, _extends({
	        key: 'title'
	      }, this.props)),
	      React.createElement(
	        'div',
	        { className: 'AccordionModule-Box',
	          style: boxStyle },
	        this.props.childNode.map(function (node, index) {
	          return React.createElement(AccordionItem, _extends({ key: index, ref: 'subItem-' + index }, node));
	        }),
	        this.props.showScrollBar && React.createElement(VerticalScrollBar, _extends({
	          key: 'scrollbar'
	        }, {
	          value: parseInt(this.props.scrollPoint, 10),
	          right: this.props.w - 1,
	          height: '100%',
	          zIndex: this.props.childNode.length + 10
	        }))
	      )
	    );
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doAdjustSubItemPoint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doAdjustSubItemPoint();
	  },
	
	  doAdjustSubItemPoint: function doAdjustSubItemPoint() {
	    var i = 0;
	    var subItem;
	    var top = 0;
	    var itemHeight = 30;
	    while (true) {
	      subItem = ReactDOM.findDOMNode(this.refs['subItem-' + i]);
	      if (!subItem) {
	        break;
	      }
	      $(subItem).css({ top: top });
	      top += itemHeight;
	      i++;
	    }
	  }
	});
	
	/**
	 * 折叠面板组件
	 * @author mxj
	 *
	 */
	var Accordion = React.createClass({
	  displayName: 'Accordion',
	
	  propTypes: {
	    text: React.PropTypes.string.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: parseInt(this.props.selectedIndex, 10)
	    };
	  },
	
	  /**
	   * 解析数据为节点
	   * @param items
	   * @returns {Array}
	   */
	  parseTextToNode: function parseTextToNode(items) {
	    var Items = [];
	    var childNode = {};
	    var actionDatas = [];
	
	    if (this.props.interactiveData || this.props.links) {
	      actionDatas = linkHelper.parseComInteractive(this.props);
	    }
	
	    for (var i = 0; i < items.length; i++) {
	      var item = items[i];
	      if (item.charAt(0) != '-') {
	        Items.push({
	          title: item,
	          leave: 0,
	          index: i,
	          controlID: this.props.controlID,
	          expand: i === this.state.selectedIndex,
	          color: i === this.state.selectedIndex ? this.props.selectedColor : GlobalConst.GLOBAL_COLOR.TRANSPARENT_COLOR,
	          onClick: this.onItemClick,
	          actionData: actionDatas[i] || {},
	          top: Items.length * 30,
	          childNode: []
	        });
	        if (i === this.state.selectedIndex) {
	          this.selectedModuleIndex = Items.length - 1;
	        }
	      } else {
	        childNode = {
	          title: item.substring(1),
	          leave: 1,
	          index: i,
	          controlID: this.props.controlID,
	          color: i === this.state.selectedIndex ? this.props.selectedColor : GlobalConst.GLOBAL_COLOR.TRANSPARENT_COLOR,
	          onClick: this.onItemClick,
	          onDblClick: this.onItemDblClick,
	          onRightClick: this.onItemRightClick,
	          onLongPress: this.onItemLongPress,
	          actionData: actionDatas[i] || {},
	          top: Items[Items.length - 1].childNode ? Items[Items.length - 1].childNode.length * 30 : 0
	        };
	        if (i === this.state.selectedIndex) {
	          Items[Items.length - 1].expand = true;
	          Items[Items.length - 1].color = this.props.selectedColor;
	          this.selectedModuleIndex = Items.length - 1;
	        }
	        Items[Items.length - 1].childNode.push(childNode);
	      }
	    }
	    return Items;
	  },
	
	  selectedModuleIndex: -1,
	
	  render: function render() {
	    var textItems = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)), util.Text.DM_RETURN);
	    var nodes = this.parseTextToNode(textItems);
	    var childHeight = this.props.h - nodes.length * 30 + 2;
	
	    var style = {
	      width: '100%',
	      height: '100%',
	      lineHeight: '30px',
	      borderWidth: 1,
	      overflow: 'hidden',
	      boxSizing: 'border-box',
	      position: 'absolute',
	      borderColor: GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK
	    };
	    style = styleHelper.StyleUtil(this.props).background().border().text().align().default(style).style;
	
	    /*border相关修正*/
	    if (this.props.borderVisible) {
	      style.borderWidth = 1;
	    } else {
	      style.borderWidth = 0;
	    }
	
	    if (this.props.borderColor) {
	      style.borderColor = this.props.borderColor;
	    } else {
	      style.borderColor = GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK;
	    }
	
	    var node;
	    for (var i = 0; i < nodes.length; i++) {
	      node = nodes[i];
	      var minHeight = (node.childNode.length + 1) * (this.props.itemHeight || 30) + 2;
	
	      node.childHeight = childHeight > minHeight ? childHeight : minHeight;
	      node.showScrollBar = this.props.verticalScrollbarShow;
	      node.scrollPoint = this.props.verticalScrollbarProgress;
	      node.showSeparator = this.props.showSeparator;
	      node.separatorColor = this.props.separatorColor;
	    }
	    return React.createElement(
	      'div',
	      { style: style },
	      nodes && nodes.map(function (cnode, index) {
	        return React.createElement(AccordionModule, _extends({ key: index, ref: 'module-' + index }, cnode));
	      })
	    );
	  },
	
	  _onLinkEvent: function _onLinkEvent(evt, linkKey, index) {
	    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
	    this.props.events.doSelfClick(evt, this.props, linkKey, index);
	  },
	
	  onItemClick: function onItemClick(e, key, index) {
	    this.setState({
	      selectedIndex: index
	    });
	    if (this.longPress) {
	      return;
	    }
	    if (e.button === 0) {
	      if (key) {
	        this._onLinkEvent(e, key, index);
	      }
	    } else if (e.button === 2) {
	      this._onRightClick(e, index);
	    }
	  },
	
	  onItemDblClick: function onItemDblClick(e, index) {
	    if (this.props.events.doSelfDbClick) {
	      this.props.events.doSelfDbClick(e, this.props, index);
	    }
	  },
	
	  onItemLongPress: function onItemLongPress(e, index) {
	    if (this.props.events.doSelfLongPress) this.props.events.doSelfLongPress(e, this.props, index);
	  },
	
	  onItemRightClick: function onItemRightClick(e, index) {
	    if (this.props.events.doSelfRightClick) {
	      this.props.events.doSelfRightClick(e, this.props, index);
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
	    // this.doAdjustModulePoint();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    // this.doAdjustModulePoint();
	  },
	
	  doAdjustModulePoint: function doAdjustModulePoint() {
	    var i = 0;
	    var refStr;
	    var moduleItem;
	    var selfDom = ReactDOM.findDOMNode(this);
	    var c = selfDom.childElementCount;
	    var h = styleHelper.getHeight(this.props);
	    var itemHeight = 30;
	    var top = 0;
	    var moduleHeight = itemHeight * c;
	    var subHeight = h - moduleHeight;
	
	    while (true) {
	      moduleItem = ReactDOM.findDOMNode(this.refs['module-' + i]);
	      if (!moduleItem) {
	        break;
	      }
	      $(moduleItem).css({ top: top });
	      top += itemHeight;
	      if (i === this.selectedModuleIndex) {
	        // if (i === this.state.selectedIndex) {
	        top += subHeight;
	      }
	      i++;
	    }
	  }
	
	});
	
	module.exports = Accordion;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var VerticalScrollBar = __webpack_require__(178);
	var styleHelper = __webpack_require__(145);
	var LinkHelper = __webpack_require__(158);
	var measureHelper = __webpack_require__(148);
	var CheckIcon = __webpack_require__(171);
	var RadioIcon = __webpack_require__(208);
	var assetsHelper = __webpack_require__(65);
	var util = __webpack_require__(116);
	var propConst = __webpack_require__(147);
	
	/**
	 * Tabel
	 * @author mxj
	 * @createDate 2016/9/6
	 *
	 * @descriptor 列宽的计算方式，
	 *  1、计算出所有列最大宽度，及其相加的总和
	 *  2、计算所有列的宽度比例，及其比例总和
	 *  3、如果总和大于0 小于 100时，较正各列的比较值
	 *  4、如果部比例为0时，
	 *    a ：如果总宽度为０，则，各列平分组件宽度
	 *    b : 如果总宽度不为0，则各列平分比例，并根据比例计算出各列的宽度
	 *  *** 需要注意的是，如果有换行的情况下，如何测量出正确的列宽
	 *
	 *  cellDatas :[
	 *    {
	 *      columns : [
	 *        {
	 *          text : string|NaN,
	 *          width : number|NaN,
	 *          type : 'none|text|up|down|up-down|check-off|check-on|select_off|select-on'
	 *        },{},...
	 *      ],
	 *      rowHeight : px
	 *    },{},...
	 *  ]
	 **/
	
	var Tabel = React.createClass({
	  displayName: 'Tabel',
	
	  propTypes: {},
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: this.props.selectedIndex
	    };
	  },
	
	  cellType: {
	    text: 'text',
	    checkOn: 'check-on',
	    checkOff: 'check-off',
	    selectOn: 'select-on',
	    selectOff: 'select-off'
	  },
	
	  orderType: {
	    none: 'none',
	    up: 'up',
	    down: 'down',
	    up_down: 'up-down'
	  },
	
	  upIcon: 'upicon.png',
	
	  downIcon: 'downicon.png',
	
	  upAndDownIcon: 'updownicon.png',
	
	  render: function render() {
	    this.showVLine = styleHelper.getPropertyValue(this.props, propConst.SHOW_V_LINE);
	    this.showHLine = styleHelper.getPropertyValue(this.props, propConst.SHOW_H_LINE);
	    var h = styleHelper.getHeight(this.props);
	    var borderVisible = styleHelper.getPropertyValue(this.props, propConst.BORDER_VISIBLE);
	    var bgColor = styleHelper.getBackgroundColor(this.props);
	    var showHeader = styleHelper.getPropertyValue(this.props, propConst.SHOW_HEADER);
	    var borderColor = styleHelper.getBorderColor(this.props);
	
	    var style = {
	      backgroundColor: bgColor,
	      borderStyle: borderVisible ? 'solid' : 'none',
	      borderColor: borderColor,
	      color: styleHelper.getTextColor(this.props),
	      letterSpacing: -1,
	      fontFamily: this.props.textFontFamily || decodeURIComponent(this.props.font.family)
	    };
	    var scrollTop = 0;
	    var selfH = h;
	    var scrollHeight = selfH;
	
	    this.parseCells();
	
	    if (showHeader) {
	      scrollTop = this.headDatas.height + 5;
	      scrollHeight = selfH - scrollTop - 5;
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'component border', style: style },
	      React.createElement(
	        'table',
	        { ref: 'tabel', frameBorder: 'border',
	          width: '100%',
	          colSpan: 6,
	          rowSpan: 0,
	          cellSpacing: 0 },
	        this.headDatas && React.createElement(
	          'thead',
	          null,
	          React.createElement(
	            'tr',
	            { ref: 'headRow', height: this.headDatas.height, style: this.headStyle(),
	              onClick: this.rowClick.bind(this, true, 0) },
	            this.headDatas.cells.map(function (td, index) {
	              return React.createElement(
	                'td',
	                { key: "head-td" + index, style: this.cellStyle(td, this.headDatas.height, index) },
	                td.type === this.cellType.text && this.renderTextCell(td, index),
	                td.type === this.cellType.checkOn && React.createElement(CheckIcon, { key: 'head-td-check-' + index,
	                  position: 'relative',
	                  isChecked: 'true', enabled: 'false' }),
	                td.type === this.cellType.checkOff && React.createElement(CheckIcon, { key: 'head-td-check-' + index,
	                  position: 'relative',
	                  enabled: 'false' }),
	                td.type === this.cellType.selectOn && React.createElement(RadioIcon, { key: 'head-td-radio-' + index,
	                  position: 'relative',
	                  isSelected: 'true', enabled: 'false' }),
	                td.type === this.cellType.selectOff && React.createElement(RadioIcon, { key: 'head-td-radio-' + index, position: 'relative',
	                  enabled: 'false' }),
	                td.order && td.order !== this.orderType.none && React.createElement('img', { width: '10', height: '10',
	                  ref: 'headIcon-' + index,
	                  src: this.getHeaderIcon(td),
	                  style: this.headIconStyle(index) })
	              );
	            }, this)
	          )
	        ),
	        React.createElement(
	          'tbody',
	          null,
	          this.cellDatas.map(function (row, index) {
	            return React.createElement(
	              'tr',
	              { key: 'body-row-' + index, style: this.rowStyle(row, index),
	                onClick: this.rowClick.bind(this, false, index) },
	              row.cells.map(function (cel, i, arr) {
	                return React.createElement(
	                  'td',
	                  { key: index + '-' + i, style: this.cellStyle(cel, row.height, i, index) },
	                  cel.type === this.cellType.text && this.renderTextCell(cel, i),
	                  cel.type === this.cellType.checkOn && React.createElement(CheckIcon, { key: 'body-td-check-' + index + '-' + i,
	                    position: 'relative',
	                    isChecked: 'true',
	                    enabled: 'false' }),
	                  cel.type === this.cellType.checkOff && React.createElement(CheckIcon, { key: 'body-td-check-' + index + '-' + i,
	                    position: 'relative',
	                    enabled: 'false' }),
	                  cel.type === this.cellType.selectOn && React.createElement(RadioIcon, { key: 'body-td-radio-' + index + '-' + i,
	                    position: 'relative',
	                    isSelected: 'true',
	                    enabled: 'false' }),
	                  cel.type === this.cellType.selectOff && React.createElement(RadioIcon, { key: 'body-td-radio-' + index + '-' + i,
	                    position: 'relative',
	                    enabled: 'false' })
	                );
	              }, this)
	            );
	          }, this)
	        )
	      ),
	      this.props.verticalScrollbarShow && React.createElement(VerticalScrollBar, {
	        key: 'scrollbar',
	        value: parseInt(this.props.verticalScrollbarProgress, 10),
	        top: scrollTop,
	        height: scrollHeight,
	        zIndex: 1
	      })
	    );
	  },
	
	  /**
	   * 单元格内容渲染
	   * @param cel
	   * @param index
	   * @returns {*|Object|Array}
	   */
	  renderTextCell: function renderTextCell(cel, index) {
	    var text = cel.text;
	    var strs = util.Text.delimitToParagraphs(text);
	    var cellWith = this.getCellWidth(index);
	    var textStyle = {
	      height: 'auto',
	      overflow: 'hidden',
	      wordBreak: 'break-all',
	      whiteSpace: 'nowrap'
	    };
	    if (typeof cellWith === 'string' && cellWith.indexOf('%') !== -1) {
	      var width = parseInt(this.props.w, 10) * parseInt(cellWith, 10) / 100 - 10;
	      textStyle.width = width;
	    } else if (typeof cellWith === 'number') {
	      textStyle.width = cellWith - 10;
	    }
	    return strs.map(function (str, i) {
	      return React.createElement(
	        'p',
	        { key: i, style: textStyle },
	        util.Text.replaceIndentSpace(util.Text.convertSpaceToNbsp(str))
	      );
	    });
	  },
	
	  getHeaderIcon: function getHeaderIcon(td) {
	    var src;
	    if (td) {
	      if (td.order === this.orderType.up) {
	        src = this.upIcon;
	      } else if (td.order === this.orderType.down) {
	        src = this.downIcon;
	      } else if (td.order === this.orderType.up_down) {
	        src = this.upAndDownIcon;
	      }
	    }
	    if (src) {
	      src = assetsHelper.getAssistAsset(src);
	    }
	    return src;
	  },
	
	  headIconStyle: function headIconStyle(index) {
	    var style = {
	      width: 10,
	      height: 10,
	      top: (this.headDatas.height - 10) / 2 + 2,
	      position: 'absolute'
	    };
	    var i = 0;
	    var l = 0;
	    for (i = 0; i <= index; i++) {
	      l += this.columnWidth[i];
	    }
	    style.left = l - 20;
	    return style;
	  },
	
	  headStyle: function headStyle() {
	    var style = {
	      backgroundColor: 'inherit',
	      height: this.headDatas.height + 3,
	      boxSizing: 'border-box'
	    };
	    if (this.props.showHeader) {
	      style.backgroundColor = this.props.headerColor;
	      style.height = this.headDatas.height - 3;
	      style.color = this.props.headerTextColor;
	    } else {
	      if (this.state.selectedIndex === 0) {
	        style.backgroundColor = this.props.selectedColor;
	      }
	    }
	    return style;
	  },
	
	  measureLineHeight: function measureLineHeight() {
	    if (!this.isMeasured) {
	      var lineHeight = styleHelper.builderLineHeight(this.props);
	      if (lineHeight) {
	        return lineHeight + 'px';
	      }
	    }
	    return '1em';
	  },
	
	  /**
	   * 单元格 style
	   * @param td
	   * @param height
	   * @param index
	   * @returns {*|{borderBottomStyle, borderRightStyle, borderColor, fontSize, fontFamily, fontWeight, fontStyle, textDecoration}}
	   */
	  cellStyle: function cellStyle(td, height, index, rowIndex) {
	    var isEnd = index === this.maxColumnCount - 1;
	    var style = this.tdStyle(isEnd);
	    style.textAlign = this.columnConfig[index].align;
	    style.height = height || 'inherit';
	
	    style.width = this.getCellWidth(index);
	    if (rowIndex !== undefined && rowIndex + 1 === this.state.selectedIndex) {
	      style.color = this.props.selectedTextColor || '';
	    }
	    if (td.text) {
	      if (util.Text.isMultiLineText(td.text)) {
	        style.lineHeight = this.measureLineHeight(); // this.props.textSize + 'px';
	        // style.whiteSpace = 'normal';
	      } else {
	          // style.whiteSpace = 'nowrap'
	        }
	    }
	    return style;
	  },
	
	  /**
	   * 单元格宽度
	   * @param index
	   * @returns {*}
	   */
	  getCellWidth: function getCellWidth(index) {
	    /*2.2.8版本与2.2.9兼容处理处*/
	    //if (!this.props.columnRatio) {
	    return this.columnWidth[index] - 5;
	    //}
	    //var columnRatio = this.props.columnRatio.substr(1, this.props.columnRatio.length - 2);
	    //var colList = columnRatio.split(',');
	    //return colList[index] + '%';
	  },
	
	  /**
	   * 行 style
	   * @param td
	   * @param index
	   * @returns {{backgroundColor: string, height: number, boxSizing: string, lineHeight}}
	   */
	  rowStyle: function rowStyle(td, index) {
	    var condition = false;
	    var bg = 'inherit';
	    var i = index + 1;
	
	    if (this.props.isInterlace) {
	      if (this.props.showHeader) {
	        condition = index % 2 !== 0;
	      } else {
	        condition = index % 2 === 0;
	      }
	    }
	    if (i === this.state.selectedIndex) {
	      bg = this.props.selectedColor;
	    } else {
	      if (condition) {
	        bg = this.props.interlaceColor;
	      }
	    }
	
	    return {
	      backgroundColor: bg,
	      height: td.height - 3,
	      boxSizing: 'border-box',
	      lineHeight: td.lineHeight
	    };
	  },
	
	  tdStyle: function tdStyle(isEnd) {
	    return {
	      borderBottomStyle: this.showHLine ? 'solid' : 'none',
	      borderRightStyle: this.showVLine ? isEnd ? 'none' : 'solid' : 'none',
	      /*borderColor: styleHelper.getBorderColor(this.props),*/
	      borderColor: this.props.separatorColor,
	      fontSize: styleHelper.getFontSize(this.props),
	      fontFamily: this.props.textFontFamily,
	      fontWeight: this.props.textStyles.fontWeight,
	      fontStyle: this.props.textStyles.fontStyle,
	      textDecoration: this.props.textStyles.textDecoration
	    };
	  },
	
	  bodyContext: undefined,
	
	  configText: undefined,
	
	  headText: undefined,
	
	  columnConfig: [],
	
	  headDatas: undefined,
	
	  cellDatas: [],
	
	  columnWidth: [], /*求值结果参数*/
	
	  maxColumnCount: 0,
	
	  validRowCount: 0,
	
	  parseRow: function parseRow(rowStr) {
	    var cells = [];
	    var rowArr;
	    var text;
	    var i;
	    var d;
	    var originalText;
	    var rowConfig = {
	      height: this.props.itemHeight,
	      cells: cells
	    };
	    if (rowStr) {
	      rowArr = util.Text.delimitText(rowStr, util.Text.DM_COMMA);
	      for (i = 0; i < rowArr.length; i++) {
	        originalText = rowArr[i];
	        originalText = rowArr[i].replace(/\\r/g, '\n');
	        text = rowArr[i].trim().replace(/\\r/g, '\n');
	        if (util.Text.compareTo(text, '[]', false) || util.Text.compareTo(text, '[ ]', true)) {
	          d = {
	            text: util.Text.replaceLast(text, ['[]', '[ ]']),
	            type: this.cellType.checkOff
	          };
	        } else if (util.Text.compareTo(text, '[x]', true) || util.Text.compareTo(text, '[X]', true)) {
	          d = {
	            text: util.Text.replaceLast(text, '[x]'),
	            type: this.cellType.checkOn
	          };
	        } else if (util.Text.compareTo(text, '()', true) || util.Text.compareTo(text, '( )', true)) {
	          d = {
	            text: util.Text.replaceLast(text, ['()', '( )']),
	            type: this.cellType.selectOff
	          };
	        } else if (util.Text.compareTo(text, '(o)', true)) {
	          d = {
	            text: util.Text.replaceLast(text, '(o)'),
	            type: this.cellType.selectOn
	          };
	        } else {
	          d = {
	            text: text,
	            type: this.cellType.text
	          };
	        }
	        d.originalText = originalText;
	        cells.push(d);
	      }
	    }
	    this.cellDatas.push(rowConfig);
	  },
	
	  parseColumnConfig: function parseColumnConfig() {
	    var i;
	    var str;
	    var props = this.props;
	
	    function parseCellConfig(cfgStr) {
	      var cfg = {
	        scale: 0,
	        align: styleHelper.builderTextAlign(props).textAlign
	      };
	      var w;
	      var v;
	      if (cfgStr) {
	        cfgStr = cfgStr.trim();
	
	        v = cfgStr[cfgStr.length - 1];
	        w = cfgStr.replace(v, '');
	        if (w) {
	          cfg.scale = parseInt(w);
	        }
	        if (v) {
	          v = v.toUpperCase();
	          switch (v) {
	            case 'C':
	              cfg.align = 'center';
	              break;
	            case 'L':
	              cfg.align = 'left';
	              break;
	            case 'R':
	              cfg.align = 'right';
	              break;
	          }
	        }
	      }
	      return cfg;
	    }
	
	    i = 0;
	    this.columnConfig = [];
	    if (this.configText) {
	      str = this.configText.replace('{', '').replace('}', '');
	      str = util.Text.delimitText(str, util.Text.DM_COMMA);
	      this.maxColumnCount = Math.max(this.maxColumnCount, str.length);
	      var itm;
	
	      for (i = 0; i < str.length; i++) {
	        itm = str[i].trim();
	        this.columnConfig.push(parseCellConfig(itm));
	      }
	    } else {
	      for (i = 0; i < this.maxColumnCount; i++) {
	        this.columnConfig.push(parseCellConfig());
	      }
	    }
	    if (i < this.maxColumnCount) {
	      for (i; i < this.maxColumnCount; i++) {
	        this.columnConfig.push(parseCellConfig());
	      }
	    }
	  },
	
	  parseHeadCell: function parseHeadCell(td) {
	    var h = {
	      text: '',
	      originalText: td,
	      type: this.cellType.text
	    };
	    if (td) {
	      td = td.trim().replace('\\r', '\n');
	      if (util.Text.ansiEndsStr(td, '^v')) {
	        h.order = this.orderType.up_down;
	        h.text = td.substring(0, td.length - 2);
	      } else if (util.Text.ansiEndsStr(td, 'v')) {
	        h.order = this.orderType.down;
	        h.text = td.substring(0, td.length - 1);
	      } else if (util.Text.ansiEndsStr(td, '^')) {
	        h.order = this.orderType.up;
	        h.text = td.substring(0, td.length - 1);
	      } else if (util.Text.compareTo(td, '[]', true) || util.Text.compareTo(td, '[ ]', true)) {
	        h.type = this.cellType.checkOff;
	      } else if (util.Text.compareTo(td, '[x]')) {
	        h.type = this.cellType.checkOn;
	      } else if (util.Text.compareTo(td, '()', true) || util.Text.compareTo(td, '( )', true)) {
	        h.type = this.cellType.selectOff;
	      } else if (util.Text.compareTo(td, '(o)', true)) {
	        h.type = this.cellType.selectOn;
	      } else {
	        h.type = this.cellType.text;
	        h.text = td;
	      }
	    }
	    if (!h.text) {
	      if (td) {
	        h.originalText = td.replace(/ /g, '\u0A00');
	      }
	    } else {
	      h.text = h.text.trim();
	    }
	    return h;
	  },
	
	  parseHead: function parseHead(str) {
	    var i = 0;
	    var endStr;
	    var arr;
	    var td;
	    var cells;
	
	    arr = util.Text.delimitText(str, util.Text.DM_COMMA);
	    cells = [];
	    this.headDatas = {
	      height: 0,
	      cells: cells
	    };
	    for (i; i < arr.length; i++) {
	      td = arr[i];
	      cells.push(this.parseHeadCell(td));
	    }
	    for (i; i < this.maxColumnCount; i++) {
	      cells.push(this.parseHeadCell(''));
	    }
	  },
	
	  fitCellDatas: function fitCellDatas() {
	    var i;
	    var j;
	    var row;
	
	    var maxRowCount = styleHelper.getHeight(this.props) / this.props.itemHeight;
	    i = this.cellDatas.length;
	    var emptyRow = {
	      height: this.props.itemHeight,
	      cells: []
	    };
	    for (i; i < maxRowCount; i++) {
	      this.cellDatas.push(emptyRow);
	    }
	    i = 0;
	    for (i; i < this.cellDatas.length; i++) {
	      row = this.cellDatas[i];
	      j = row.cells.length;
	      for (j; j < this.maxColumnCount; j++) {
	        row.cells.push({ text: '', type: 'text' });
	      }
	    }
	    i = this.headDatas.cells.length;
	    for (i; i < this.maxColumnCount; i++) {
	      this.headDatas.cells.push(this.parseHeadCell());
	    }
	  },
	
	  isConfigText: function isConfigText(str) {
	    var r = false;
	    if (str && str.length) {
	      r = util.Text.ansiStartsStr(str.trim(), '{');
	      if (r) {
	        r = util.Text.ansiEndsStr(str.trim(), '}');
	      }
	    }
	    return r;
	  },
	
	  measureCell: function measureCell(text) {
	    var style = {
	      fontSize: this.props.textSize,
	      fontStyle: this.props.textStyles.fontStyle,
	      textDecoration: this.props.textStyles.textDecoration,
	      fontWeight: this.props.textStyles.fontWeight,
	      fontFamily: this.props.textStyles.fontFamily /*,
	                                                   letterSpacing : -1*/
	    };
	    return measureHelper.measureTextWidth(style, text);
	  },
	
	  initHeaderHeight: function initHeaderHeight() {
	    var links = LinkHelper.tranItemRect(this.props.itemRect) || this.props.links.link;
	    var link = links[0];
	    if (link.height === undefined) {
	      this.headDatas.height = link.area.coords.height - 3;
	    } else {
	      this.headDatas.height = link.height - 3;
	    }
	  },
	  /*
	   * 默认计算
	   * */
	  measureColumns: function measureColumns() {
	    var i;
	    var j;
	    var row;
	    var cell;
	    var text;
	    var w;
	    var h;
	    var size;
	    var links = LinkHelper.tranItemRect(this.props.itemRect) || this.props.links.link;
	    var link;
	    var l;
	    var maxWidth = 0;
	    var scaleW;
	    var selfW = styleHelper.getWidth(this.props);
	    var lockW;
	    this.columnWidth = [];
	    for (i = 0; i < this.maxColumnCount; i++) {
	      this.columnWidth.push(0);
	    }
	    for (i = 0; i < this.cellDatas.length; i++) {
	      row = this.cellDatas[i];
	      for (j = 0; j < row.cells.length; j++) {
	        cell = row.cells[j];
	        text = cell.originalText;
	        if (text) {
	          size = this.measureCell(text);
	          w = size.width;
	          maxWidth = Math.max(w, this.columnWidth[j]);
	          this.columnWidth[j] = maxWidth;
	        }
	      }
	
	      maxWidth = 0;
	    }
	    i = 0;
	    for (i = 0; i < this.headDatas.cells.length; i++) {
	      cell = this.headDatas.cells[i];
	      text = cell.originalText;
	      if (text) {
	        w = this.measureCell(text).width;
	        this.columnWidth[i] = Math.max(this.columnWidth[i], w);
	      }
	    }
	
	    i = 1;
	
	    l = this.cellDatas.length + i;
	    j = 0;
	    for (i; i < links.length; i++) {
	      link = links[i];
	      if (j < this.cellDatas.length) {
	        if (link.height === undefined) {
	          this.cellDatas[j].height = link.area.coords.height - 3;
	        } else {
	          this.cellDatas[j].height = link.height - 3;
	        }
	        this.cellDatas[j].lineHeight = this.cellDatas[j].height + 'px';
	      }
	      j++;
	    }
	
	    scaleW = 0;
	    for (i = 0; i < this.columnConfig.length; i++) {
	      scaleW += this.columnConfig[i].scale;
	    }
	    lockW = 0;
	    if (scaleW !== 0 && scaleW !== 100) {
	
	      for (i = 0; i < this.columnConfig.length; i++) {
	        w = this.columnConfig[i].scale;
	        w = w * (100 / scaleW);
	        this.columnConfig[i].scale = w;
	        if (w === 0) {
	          lockW += this.columnWidth[i];
	        }
	      }
	    } else if (scaleW === 0) {
	      w = 0;
	      for (i = 0; i < this.columnWidth.length; i++) {
	        w += this.columnWidth[i];
	      }
	      if (w === 0) {
	        w = selfW;
	      }
	
	      for (i = 0; i < this.columnConfig.length; i++) {
	        this.columnConfig[i].scale = this.columnWidth[i] * 100 / w;
	      }
	    }
	    selfW -= lockW;
	    if (this.props.verticalScrollbarShow) {
	      selfW -= 20;
	    }
	    for (i = 0; i < this.columnConfig.length; i++) {
	      if (this.columnConfig[i].scale !== 0) {
	        this.columnWidth[i] = selfW * Math.round(this.columnConfig[i].scale * 10) / 1000;
	      }
	    }
	  },
	
	  calculateMaxColumn: function calculateMaxColumn() {
	    this.maxColumnCount = this.headDatas.cells.length;
	    var i = 0;
	    var j;
	    var row;
	    for (i; i < this.cellDatas.length; i++) {
	      row = this.cellDatas[i];
	      this.maxColumnCount = Math.max(this.maxColumnCount, row.cells.length);
	    }
	  },
	
	  isValidateColumnRatio: function isValidateColumnRatio(v) {
	    if (_.isUndefined(v) || _.isEmpty(v)) {
	      return false;
	    }
	
	    v = v.replace(/\{|\}/g, '');
	    var i;
	    var arr = util.Text.delimitToWords(v, false);
	    if (arr.length < this.maxColumnCount) return false;
	    for (i = 0; i < arr.length; i++) {
	      if (util.Int(arr[i].trim()) === 0) {
	        return false;
	      }
	    }
	    return true;
	  },
	
	  measureCellWidthWithColumnRatio: function measureCellWidthWithColumnRatio(v) {
	    var w = styleHelper.getWidth(this.props);
	    var ratios = v.replace(/\{|\}/g, '');
	    var r;
	    var i;
	    ratios = util.Text.delimitToWords(ratios, false);
	    this.columnWidth = [];
	    for (i = 0; i < ratios.length; i++) {
	      r = ratios[i].trim();
	      if (r.indexOf('.') === 0) {
	        r = '0' + r;
	      }
	      r = util.Float(r) / 100;
	      r = r * w;
	      this.columnWidth.push(r);
	    }
	  },
	
	  parseCells: function parseCells() {
	    var text = util.Text.removeLastEmptyRow(this.props.text);
	    var columnRatio = this.props.columnRatio;
	    this.cellDatas = [];
	
	    var rowStrs = util.Text.delimitText(text, util.Text.DM_RETURN);
	    var i;
	    this.validRowCount = rowStrs.length;
	    for (i = 0; i < rowStrs.length; i++) {
	      if (i === 0) {
	        this.headText = rowStrs[i];
	        continue;
	      } else if (i === rowStrs.length - 1) {
	        if (this.isConfigText(rowStrs[i])) {
	          this.configText = rowStrs[i];
	          this.validRowCount -= 1;
	          break;
	        }
	      }
	      this.parseRow(rowStrs[i]);
	    }
	
	    this.parseHead(this.headText);
	    this.calculateMaxColumn();
	    this.parseColumnConfig();
	    this.fitCellDatas();
	    if (this.isValidateColumnRatio(columnRatio)) {
	      this.measureCellWidthWithColumnRatio(columnRatio);
	    } else {
	      this.measureColumns();
	    }
	    this.initHeaderHeight();
	  },
	
	  rowClick: function rowClick(isHead, index) {
	
	    if (isHead) {
	      this.setState({ selectedIndex: index });
	    } else {
	      if (index + 1 >= this.validRowCount) {
	        return;
	      }
	      this.setState({ selectedIndex: index + 1 });
	    }
	  },
	
	  onItemClick: function onItemClick(e, index) {
	    this.setState({
	      selectedIndex: index
	    });
	  },
	
	  doAdjustHeadIconPoint: function doAdjustHeadIconPoint() {
	    var row = ReactDOM.findDOMNode(this.refs.headRow);
	    var img;
	    var td;
	    var i;
	    if (row) {
	      for (i = 0; i < row.childElementCount; i++) {
	        td = row.children[i];
	        img = ReactDOM.findDOMNode(this.refs['headIcon-' + i]);
	        if (img) {
	          $(img).css({ left: td.offsetLeft + td.clientWidth - 12 });
	        }
	      }
	    }
	  },
	
	  doAdjustRowHeight: function doAdjustRowHeight() {
	    var link = LinkHelper.tranItemRect(this.props.itemRect) || this.props.links.link;
	    var item;
	    var tr;
	    var rows;
	    var i;
	    var itemHeight = this.props.itemHeight;
	    var rowHeight;
	    var tabel = ReactDOM.findDOMNode(this.refs.tabel);
	    //var t = 0;
	    //var h = styleHelper.getHeight(this.props);
	    rows = $(tabel).find('tr');
	    for (i = 0; i < rows.length; i++) {
	      tr = rows[i];
	      if (i < link.length) {
	        item = link[i];
	        if (item.height === undefined) {
	          rowHeight = item.area.coords.height;
	        } else {
	          rowHeight = item.height;
	        }
	      } else {
	        rowHeight = itemHeight;
	      }
	      $(tr).css({ height: rowHeight });
	    }
	  },
	
	  doAdjustColumnWidth: function doAdjustColumnWidth() {},
	
	  doAdjust: function doAdjust() {
	    this.doAdjustRowHeight();
	    this.doAdjustColumnWidth();
	    this.doAdjustHeadIconPoint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
	    this.doAdjust();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doAdjust();
	  }
	});
	
	module.exports = Tabel;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	var convertHelper = __webpack_require__(146);
	var dataHelper = __webpack_require__(113);
	var tableHelper = __webpack_require__(238);
	var util = __webpack_require__(116);
	
	var NewTable = React.createClass({
	  displayName: 'NewTable',
	
	  propTypes: {},
	
	  getInitialState: function getInitialState() {
	    var cols = JSON.parse(JSON.stringify(this.props.cols.col));
	    var rows = JSON.parse(JSON.stringify(this.props.rows.row));
	    var cells = JSON.parse(JSON.stringify(this.props.cells.cell));
	
	    var coords = tableHelper.buildCoords(rows, cols);
	    var matrix = tableHelper.buildMatrix(rows, cols, cells);
	    var cell;
	    //应用交错、表头风格属性
	    for (var i = 0; i < matrix.length; i++) {
	      for (var j = 0; j < matrix[i].length; j++) {
	        cell = matrix[i][j];
	        if (this.props.tableStyle !== undefined && cell.backColor === '#FFFFFF') {
	          if (this.props.tableStyle === 'tsInterlace' && i % 2 !== 0) {
	            cell.backColor = '#EEEEEE';
	          }
	          if (this.props.tableStyle === 'tsTitle' && i === 0) {
	            cell.backColor = '#999999';
	          }
	        }
	      }
	    }
	    return {
	      coords: coords,
	      matrix: matrix
	    };
	  },
	
	  render: function render() {
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var elWidth, elHeight;
	    var canvasStyle = {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      width: w,
	      height: h
	    };
	    if (window.devicePixelRatio) {
	      elWidth = w * window.devicePixelRatio;
	      elHeight = h * window.devicePixelRatio;
	    } else {
	      elWidth = w;
	      elHeight = h;
	    }
	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'div',
	        { className: 'cells' },
	        this.renderCells()
	      ),
	      React.createElement('canvas', { style: canvasStyle, width: elWidth, height: elHeight, ref: 'canvas' })
	    );
	  },
	
	  renderCells: function renderCells() {
	    var cellList = [];
	    var areaStyle, horiStyle, fontStyle;
	    var area, cell, text;
	    var cells = tableHelper.getAllCells(this.state.matrix, this.state.coords);
	    for (var i = 0; i < cells.length; i++) {
	      cell = cells[i];
	      area = cell.area;
	      text = cell.text;
	      if (typeof text !== 'string') {
	        text = ' ';
	      }
	      areaStyle = {
	        position: 'absolute',
	        left: area.left,
	        top: area.top,
	        width: area.width,
	        height: area.height,
	        backgroundColor: cell.backColor
	      };
	      fontStyle = {
	        margin: '5px',
	        height: area.height - 10,
	        width: area.width - 10,
	        overflow: 'hidden',
	        color: cell.textColor,
	        fontSize: cell.fontSize,
	        fontFamily: dataHelper.decodeURIComponent(cell.font.family.replace(/\+/g, '%20')),
	        fontWeight: cell.textStyles.fontWeight,
	        fontStyle: cell.textStyles.fontStyle,
	        textDecoration: cell.textStyles.textDecoration,
	        textAlign: convertHelper.getTextHorizontalAlign(cell.textHAlign),
	        display: 'flex',
	        flexDirection: 'column',
	        justifyContent: convertHelper.getFlexVerticalAlign(cell.textVAlign)
	      };
	
	      if (!cell.textWordWrap) {
	        fontStyle.whiteSpace = 'nowrap';
	      } else {
	        fontStyle.wordWrap = 'breake-word';
	      }
	
	      styleHelper.StyleUtil(cell, fontStyle).align().text().background();
	      var textArray = text.split('\n');
	      cellList.push(React.createElement(
	        'div',
	        { style: areaStyle, key: i },
	        React.createElement(
	          'div',
	          { className: 'texts', style: fontStyle },
	          textArray.map(function (txt, idx) {
	            if (!txt.trim()) {
	              return React.createElement('p', { key: idx });
	            }
	            return React.createElement(
	              'p',
	              { key: idx },
	              txt
	            );
	          })
	        )
	      ));
	    }
	    return cellList;
	  },
	
	  componentDidMount: function componentDidMount() {
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    var context = canvas.getContext('2d');
	    this.drawLine(context);
	  },
	
	  drawLine: function drawLine(context) {
	    var horiLines = this.getHoriDiliverLine();
	    var vertLines = this.getVertDiliverLine();
	    var lines = horiLines.concat(vertLines);
	    var line;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	
	    var borderStyle = {
	      thickness: styleHelper.getBorderWidth(this.props),
	      dashMode: styleHelper.getPropertyValue(this.props, 'dashMode') || 'solid',
	      borderColor: styleHelper.getBorderColor(this.props),
	      borderVisible: styleHelper.getBorderVisible(this.props)
	    };
	
	    graphicsHelper.drawRect(context, 0, 0, w, h, borderStyle, false);
	    if (window.devicePixelRatio) {
	      context.scale(window.devicePixelRatio, window.devicePixelRatio);
	    }
	    for (var i = 0; i < lines.length; i++) {
	      line = lines[i];
	      if (window.devicePixelRatio) {
	        line.lineWidth = line.lineWidth / window.devicePixelRatio;
	      }
	      graphicsHelper.drawLine(context, line);
	    }
	  },
	
	  getHoriDiliverLine: function getHoriDiliverLine() {
	    var horiLines = [];
	    var offset = 0;
	    var w = styleHelper.getWidth(this.props);
	    var borderWidth = styleHelper.getBorderWidth(this.props) || 1;
	    var lineWidth;
	    var dashMode;
	    var strokeColor;
	    var aboveCell, bottomCell, topCell;
	    if (this.props.tableStyle === 'tsHiddenLine' || this.props.tableStyle === 'tsHiddenRowLine') {
	      return horiLines;
	    }
	    for (var i = 0; i < this.state.matrix.length - 1; i++) {
	      for (var j = 0; j < this.state.matrix[0].length; j++) {
	        aboveCell = this.state.matrix[i][j];
	        bottomCell = this.state.matrix[i + 1][j];
	        //合并单元格
	        if (aboveCell === bottomCell) {
	          continue;
	        }
	        if (bottomCell.editIndex !== undefined && aboveCell.editIndex !== undefined && parseInt(bottomCell.editIndex, 10) > parseInt(aboveCell.editIndex, 10)) {
	          topCell = bottomCell;
	        } else {
	          topCell = aboveCell;
	        }
	        if (topCell.bottomBorderVisible) {
	          lineWidth = Math.round(topCell.bottomBorderThinckness);
	          dashMode = styleHelper.parseDashMode(topCell.bottomBorderDashMode);
	          strokeColor = topCell.bottomBorderColor;
	          offset = 0;
	          if (lineWidth % 2 !== 0) {
	            offset = 0.5;
	          }
	
	          var line = {
	            startX: Math.round(this.state.coords[i][j].left) + offset,
	            endX: Math.round(this.state.coords[i][j].right) + offset,
	            startY: Math.round(this.state.coords[i][j].bottom) + offset,
	            endY: Math.round(this.state.coords[i][j].bottom) + offset,
	            lineWidth: lineWidth,
	            strokeColor: strokeColor,
	            dashMode: dashMode
	          };
	
	          line.startX = Math.max(line.startX, lineWidth / 2 + borderWidth);
	          line.endX = Math.min(line.endX, w - borderWidth - lineWidth / 2);
	
	          horiLines.push(line);
	        }
	      }
	    }
	    return horiLines;
	  },
	
	  getVertDiliverLine: function getVertDiliverLine() {
	    var vertLines = [];
	    var offset = 0;
	    var h = styleHelper.getHeight(this.props);
	    var borderWidth = styleHelper.getBorderWidth(this.props) || 1;
	    var lineWidth;
	    var dashMode;
	    var strokeColor;
	    var leftCell, rightCell, topCell;
	    if (this.props.tableStyle === 'tsHiddenLine' || this.props.tableStyle === 'tsHiddenColLine') {
	      return vertLines;
	    }
	    for (var i = 0; i < this.state.matrix.length; i++) {
	      for (var j = 0; j < this.state.matrix[0].length - 1; j++) {
	        if (this.state.matrix[i][j].rightBorderVisible) {
	          leftCell = this.state.matrix[i][j];
	          rightCell = this.state.matrix[i][j + 1];
	          //合并单元格
	          if (leftCell === rightCell) {
	            continue;
	          }
	          if (rightCell.editIndex !== undefined && leftCell.editIndex !== undefined && parseInt(rightCell.editIndex, 10) > parseInt(leftCell.editIndex, 10)) {
	            topCell = rightCell;
	          } else {
	            topCell = leftCell;
	          }
	          lineWidth = Math.round(topCell.rightBorderThinckness);
	          dashMode = styleHelper.parseDashMode(topCell.rightBorderDashMode);
	          strokeColor = topCell.rightBorderColor;
	          offset = 0;
	          if (lineWidth % 2 !== 0) {
	            offset = 0.5;
	          }
	          var line = {
	            startX: Math.round(this.state.coords[i][j].right) + offset,
	            endX: Math.round(this.state.coords[i][j].right) + offset,
	            startY: Math.round(this.state.coords[i][j].top) + offset,
	            endY: Math.round(this.state.coords[i][j].bottom) + offset,
	            lineWidth: lineWidth,
	            strokeColor: strokeColor,
	            dashMode: dashMode
	          };
	
	          line.startY = Math.max(line.startY, lineWidth / 2 + borderWidth);
	          line.endY = Math.min(line.endY, h - borderWidth - lineWidth / 2);
	          vertLines.push(line);
	        }
	      }
	    }
	    return vertLines;
	  }
	});
	
	module.exports = NewTable;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(116);
	
	function aplayProp(cell, row, col) {
	  return function (key, defaultValue) {
	    if (cell[key] === undefined) {
	      if (row[key] !== undefined) {
	        cell[key] = row[key];
	      } else if (col[key] !== undefined) {
	        cell[key] = col[key];
	      } else {
	        cell[key] = defaultValue;
	      }
	    }
	  };
	}
	
	function setTableCellDefaultProps(cell, row, col) {
	
	  var setDefaultProp = aplayProp(cell, row, col);
	
	  setDefaultProp('fontSize', 12);
	
	  setDefaultProp('backColor', '#FFFFFF');
	
	  setDefaultProp('textHAlign', 'HaCenter');
	
	  setDefaultProp('textVAlign', 'VaMiddle');
	
	  setDefaultProp('textColor', "#000000");
	
	  setDefaultProp('fontFamily', "");
	
	  setDefaultProp('textStyles', {});
	
	  setDefaultProp('fontWeight', "Regular");
	
	  setDefaultProp('fontSize', 12);
	
	  setDefaultProp('textWordWrap', true);
	
	  setDefaultProp('cellBorderVisible', true);
	
	  setDefaultProp('cellBorderVisible', true);
	  if (cell.cellBorderVisible !== undefined) {
	    cell.leftBorderVisible = cell.cellBorderVisible;
	    cell.topBorderVisible = cell.cellBorderVisible;
	    cell.rightBorderVisible = cell.cellBorderVisible;
	    cell.bottomBorderVisible = cell.cellBorderVisible;
	  }
	
	  setDefaultProp('cellBorderThinckness', 1);
	  if (cell.cellBorderThinckness !== undefined) {
	    cell.leftBorderThinckness = cell.cellBorderThinckness;
	    cell.topBorderThinckness = cell.cellBorderThinckness;
	    cell.rightBorderThinckness = cell.cellBorderThinckness;
	    cell.bottomBorderThinckness = cell.cellBorderThinckness;
	  }
	
	  setDefaultProp('cellBorderColor', "#C5C5C5");
	  if (cell.cellBorderColor !== undefined) {
	    cell.leftBorderColor = cell.cellBorderColor;
	    cell.topBorderColor = cell.cellBorderColor;
	    cell.rightBorderColor = cell.cellBorderColor;
	    cell.bottomBorderColor = cell.cellBorderColor;
	  }
	
	  setDefaultProp('cellBorderDashMode', "SdSolid");
	  if (cell.cellBorderDashMode !== undefined) {
	    cell.leftBorderDashMode = cell.cellBorderDashMode;
	    cell.topBorderDashMode = cell.cellBorderDashMode;
	    cell.rightBorderDashMode = cell.cellBorderDashMode;
	    cell.bottomBorderDashMode = cell.cellBorderDashMode;
	  }
	  setDefaultProp('editIndex', 0);
	}
	
	function buildCoords(rows, cols) {
	  var horiOff = 0;
	  var vertOff = 0;
	  var width, height;
	  var coords = [];
	  for (var i = 0; i < rows.length; i++) {
	    height = Math.round(rows[i].height);
	    coords.push([]);
	    horiOff = 0;
	    for (var j = 0; j < cols.length; j++) {
	      width = Math.round(cols[j].width);
	      var rect = util.Rect.create(horiOff, vertOff, width, height);
	      coords[i].push(rect);
	      horiOff += width;
	    }
	    vertOff += height;
	  }
	  return coords;
	}
	
	function buildMatrix(rows, cols, cells) {
	  var matrix = [];
	  for (var i = 0; i < rows.length; i++) {
	    matrix.push([]);
	    for (var j = 0; j < cols.length; j++) {
	      matrix[i].push({});
	    }
	  }
	  for (var i = 0; i < cells.length; i++) {
	    var rowArr = cells[i].rows.split(',');
	    var colArr = cells[i].cols.split(',');
	    var rowBeginIndex = parseInt(rowArr[0], 10) || 0;
	    var rowEndIndex = parseInt(rowArr[1], 10) || 0;
	    var colBeginIndex = parseInt(colArr[0], 10) || 0;
	    var colEndIndex = parseInt(colArr[1], 10) || 0;
	    for (var j = rowBeginIndex; j <= rowEndIndex; j++) {
	      for (var k = colBeginIndex; k <= colEndIndex; k++) {
	        matrix[j][k] = cells[i];
	        setTableCellDefaultProps(cells[i], rows[j], cols[k]);
	      }
	    }
	    delete cells[i].rows;
	    delete cells[i].cols;
	  }
	  return matrix;
	}
	
	function getAllCells(matrix, coords) {
	  var cells = [];
	  for (var i = 0; i < matrix.length; i++) {
	    for (var j = 0; j < matrix[0].length; j++) {
	      var area = coords[i][j];
	      var cell = matrix[i][j];
	      if (cell.area === undefined) {
	        cell.area = area;
	      } else {
	        util.Rect.combo(cell.area, area);
	      }
	      if (cells.indexOf(cell) === -1) {
	        cells.push(cell);
	      }
	    }
	  }
	  return cells;
	}
	
	module.exports = {
	  setTableCellDefaultProps: setTableCellDefaultProps,
	  buildCoords: buildCoords,
	  buildMatrix: buildMatrix,
	  getAllCells: getAllCells
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var VerticalScrollBar = __webpack_require__(178);
	var styleHelper = __webpack_require__(145);
	var appTypes = __webpack_require__(115);
	var Border = __webpack_require__(168);
	var textHelper = __webpack_require__(116).Text;
	var measureHelper = __webpack_require__(148);
	
	var Item = React.createClass({
	  displayName: 'Item',
	
	  propTypes: {
	    parentStyle: React.PropTypes.object.isRequired, // 父级的样式，这里测量文字时需要用到
	    width: React.PropTypes.number.isRequired,
	    tabHeight: React.PropTypes.number.isRequired,
	    fontSize: React.PropTypes.number.isRequired
	  },
	  render: function render() {
	    var parentStyle = this.props.parentStyle;
	    var fontSize = this.props.fontSize;
	    var halfFontSize = fontSize / 2;
	    var tabHeight = parseInt(this.props.tabHeight, 10);
	    var css = {
	      height: this.props.height,
	      backgroundColor: this.props.backgroundColor || '#ddd',
	      borderLeftColor: this.props.hideLeftBorder ? this.props.backgroundColor : this.props.borderColor,
	      borderRightColor: this.props.hideRightBorder ? this.props.backgroundColor : this.props.borderColor,
	      padding: 0
	    };
	
	    if (this.props.direction == 'HdLeft') {
	      css.borderTopLeftRadius = this.props.radius;
	      css.borderBottomLeftRadius = this.props.radius;
	      css.borderLeftColor = this.props.borderColor;
	      css.borderTopColor = this.props.borderColor;
	      css.borderBottomColor = this.props.borderColor;
	    } else {
	      css.borderTopRightRadius = this.props.radius;
	      css.borderBottomRightRadius = this.props.radius;
	      css.borderRightColor = this.props.borderColor;
	      css.borderTopColor = this.props.borderColor;
	      css.borderBottomColor = this.props.borderColor;
	    }
	
	    var labelCss = {
	      display: 'block',
	      height: fontSize,
	      lineHeight: fontSize + 'px',
	      color: this.props.textColor
	    };
	    var itemContentCss = {
	      width: 0,
	      height: 0,
	      margin: 0,
	      position: 'relative',
	      padding: 0,
	      display: 'inline-block'
	    };
	    var texts = this.props.text.split('\\r');
	
	    var maxText = '';
	    texts.forEach(function (item) {
	      var measuredSize = measureHelper.measureTextWidth(parentStyle, item);
	      if (item.length > maxText) {
	        maxText = item;
	        itemContentCss.width = measuredSize.width;
	      }
	      itemContentCss.height += measuredSize.height;
	    });
	
	    if (this.props.tabDirection === 'SmVert') {
	      // 垂直选项卡
	      css.width = this.props.tabHeight;
	      css.height = itemContentCss.width + 16;
	      labelCss.display = 'block';
	      labelCss.position = 'relative';
	      css.textAlign = 'left';
	      itemContentCss.transformOrigin = '0 0';
	      var xTranslate, yTranslate;
	      if (this.props.direction === 'HdLeft') {
	        // 左侧
	        xTranslate = -(itemContentCss.width + css.height) / 2 + 'px';
	        yTranslate = '-50%';
	        itemContentCss.transform = 'rotate(-90deg) translate(' + xTranslate + ', ' + yTranslate + ')';
	        itemContentCss.left = '50%';
	      } else {
	        // 右侧
	        xTranslate = itemContentCss.height / 2 - halfFontSize + 'px';
	        yTranslate = -(halfFontSize + tabHeight / 2) + 'px';
	        itemContentCss.transform = 'rotate(90deg) translate(' + xTranslate + ', ' + yTranslate + ')';
	      }
	    } else {
	      // 水平选项卡以及原来的老版本兼容
	      css.textAlign = 'center';
	      css.lineHeight = tabHeight + 'px';
	      css.width = this.props.width + 16;
	    }
	
	    delete itemContentCss.width;
	    delete itemContentCss.height;
	
	    return React.createElement(
	      'div',
	      { className: 'item', style: css, onClick: this._onSelfClick },
	      React.createElement(
	        'div',
	        { className: 'item-content', style: itemContentCss },
	        texts.map(function (text, idx) {
	          return React.createElement(
	            'label',
	            { key: idx, style: labelCss },
	            text
	          );
	        })
	      )
	    );
	  },
	
	  _onSelfClick: function _onSelfClick(e) {
	    if (this.props.onClick) {
	      this.props.onClick(e, this.props.index);
	    }
	  }
	});
	
	var VerticalTabBar = React.createClass({
	  displayName: 'VerticalTabBar',
	
	  propTypes: {
	    text: React.PropTypes.string.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: parseInt(this.props.selectedIndex, 10)
	    };
	  },
	
	  parseText: function parseText() {
	    var textItems = textHelper.delimitText(styleHelper.getText(this.props), textHelper.DM_COMMA);
	    for (var i = 0; i < textItems.length; i++) {
	      textItems[i] = textHelper.convertSpaceToNbsp(textItems[i]);
	    }
	    return textItems;
	  },
	
	  render: function render() {
	    var textItems = this.parseText();
	    this.showScrollBar = false;
	    var tabHeight = parseInt(this.props.tabHeight, 10);
	    var value = 0;
	    var isLeft = this.props.direction === appTypes.HorizontalDirection.LEFT;
	    var selIndex = this.state.selectedIndex;
	    var tabColor = this.props.tabColor;
	    var h = styleHelper.getHeight(this.props);
	    var bg = styleHelper.getBackgroundColor(this.props);
	    var selTextColor = this.props.selectedTextColor;
	
	    if (!_.isUndefined(this.props.verticalScrollbarShow)) {
	      this.showScrollBar = this.props.verticalScrollbarShow;
	      value = parseInt(this.props.verticalScrollbarProgress, 10);
	    }
	
	    var style = {
	      whiteSpace: 'nowrap',
	      textAlign: 'center',
	      left: 0,
	      top: 0,
	      width: '100%',
	      height: '100%'
	    };
	
	    styleHelper.builderTextStyle(this.props, style);
	
	    var cssBar = {
	      height: h - 20,
	      top: this.props.tabEdge
	    };
	
	    var barWidth = this.getBarWidth();
	
	    if (this.isTabAtLeft()) {
	      return React.createElement(
	        'div',
	        { className: 'component component-verticalTabBar bar-at-left', style: style },
	        React.createElement(
	          'div',
	          { ref: 'bar',
	            className: 'bar',
	            style: cssBar
	          },
	          textItems.map(function (item, index) {
	            return React.createElement(Item, {
	              key: index,
	              index: index,
	              hideLeftBorder: !isLeft && index === selIndex,
	              hideRightBorder: isLeft && index === selIndex,
	              text: item,
	              height: tabHeight,
	              backgroundColor: index === selIndex ? bg : tabColor,
	              onClick: this.onSelected.bind(this, index),
	              direction: this.props.direction,
	              tabDirection: this.props.tabDirection,
	              radius: this.props.radius,
	              borderColor: this.props.borderColor,
	              textColor: index === selIndex && selTextColor !== undefined ? selTextColor : '',
	              tabEdge: this.props.tabEdge,
	              tabHeight: tabHeight,
	              fontSize: parseInt(this.props.textSize, 10),
	              parentStyle: style,
	              width: barWidth
	            });
	          }, this)
	        ),
	        React.createElement(
	          'div',
	          { ref: 'content', className: 'content', style: this.contentCSS(isLeft) },
	          this.showScrollBar && React.createElement(VerticalScrollBar, _extends({ ref: 'scroll' }, {
	            value: value,
	            right: 0,
	            height: '100%',
	            zIndex: 1
	          }))
	        )
	      );
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'component component-verticalTabBar bar-at-right', style: style },
	      React.createElement(
	        'div',
	        { ref: 'content', className: 'content', style: this.contentCSS(isLeft) },
	        this.showScrollBar && React.createElement(VerticalScrollBar, _extends({ ref: 'scroll' }, {
	          value: value,
	          right: 0,
	          height: '100%',
	          zIndex: 1
	        }))
	      ),
	      React.createElement(
	        'div',
	        { ref: 'bar',
	          className: 'bar',
	          style: cssBar
	        },
	        textItems.map(function (item, index) {
	          return React.createElement(Item, {
	            key: index,
	            index: index,
	            hideLeftBorder: !isLeft && index === selIndex,
	            hideRightBorder: isLeft && index === selIndex,
	            text: item,
	            height: tabHeight,
	            backgroundColor: index === selIndex ? bg : tabColor,
	            onClick: this.onSelected.bind(this, index),
	            direction: this.props.direction,
	            tabDirection: this.props.tabDirection,
	            radius: this.props.radius,
	            borderColor: this.props.borderColor,
	            tabEdge: this.props.tabEdge,
	            tabHeight: tabHeight,
	            fontSize: parseInt(this.props.textSize, 10),
	            parentStyle: style,
	            width: barWidth
	          });
	        }, this)
	      )
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onSelected);
	  },
	
	  isTabAtLeft: function isTabAtLeft() {
	    return this.props.direction === appTypes.HorizontalDirection.LEFT;
	  },
	
	  contentCSS: function contentCSS(isLeft) {
	    var showBorder = this.props.borderVisible;
	
	    return {
	      backgroundColor: styleHelper.getBackgroundColor(this.props),
	      borderTopStyle: showBorder ? 'solid' : 'none',
	      borderBottomStyle: showBorder ? 'solid' : 'none',
	      borderLeftStyle: isLeft ? 'solid' : showBorder ? 'solid' : 'none',
	      borderRightStyle: !isLeft ? 'solid' : showBorder ? 'solid' : 'none',
	      position: 'relative',
	      border: "1px solid " + this.props.borderColor
	    };
	  },
	
	  onSelected: function onSelected(index) {
	    this.setState({
	      selectedIndex: index
	    });
	  },
	
	  /**
	   * 获取选项卡的宽度
	   * @returns {number}
	   */
	  getBarWidth: function getBarWidth() {
	    if (this.props.tabWidth) {
	      return parseInt(this.props.tabWidth, 10) || 50;
	    } else {
	      var textItems = this.parseText();
	      var maxWidth = 0;
	      var style = {};
	      styleHelper.builderTextStyle(this.props, style);
	      textItems.forEach(function (item) {
	        item && item.split('\\r').forEach(function (line) {
	          var width = measureHelper.measureTextWidth(style, line).width;
	          if (width > maxWidth) {
	            maxWidth = width;
	          }
	        });
	      });
	      return maxWidth;
	    }
	  }
	});
	
	module.exports = VerticalTabBar;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var util = __webpack_require__(116);
	
	var _ = __webpack_require__(51);
	
	var textHelper = util.Text;
	var styleHelper = __webpack_require__(145);
	
	var propConst = __webpack_require__(147);
	var appTypes = __webpack_require__(115);
	
	var OldTabBar = __webpack_require__(241);
	var VerticalScrollBar = __webpack_require__(178);
	
	var BarItem = React.createClass({
	  displayName: 'BarItem',
	
	  render: function render() {
	    var isTopBar = this.props.direction === appTypes.VerticalDirection.TOP;
	    var borderStr = '1px solid ' + this.props.borderColor || 'gray';
	    var radiusStr = (this.props.radius || 0) + 'px';
	    var style = JSON.parse(JSON.stringify(this.props.textStyle));
	    style.border = borderStr;
	
	    if (isTopBar) {
	      style.borderTopLeftRadius = radiusStr;
	      style.borderTopRightRadius = radiusStr;
	    } else {
	      style.borderBottomLeftRadius = radiusStr;
	      style.borderBottomRightRadius = radiusStr;
	    }
	    if (this.props.isChecked) {
	      var color = this.props.color || '#ffffff';
	      if (isTopBar) {
	        style.borderBottom = '1px solid ' + color;
	      } else {
	        style.borderTop = '1px solid ' + color;
	      }
	
	      style.backgroundColor = color;
	      style.color = this.props.selectedTextColor || '#000000';
	    } else {
	      if (isTopBar) {
	        style.borderBottom = borderStr;
	      } else {
	        style.borderTop = borderStr;
	      }
	      style.backgroundColor = this.props.tabColor || '#dddddd';
	      style.color = this.props.textStyle.color || '#000000';
	    }
	    if (this.props.tabWidth) {
	      style.width = this.props.tabWidth + 'px';
	    }
	    return React.createElement(
	      'div',
	      {
	        className: 'bar-item',
	        style: style,
	        onClick: this.handleClick
	      },
	      React.createElement(
	        'label',
	        { className: 'bar-item-text' },
	        this.props.text
	      )
	    );
	  },
	
	  handleClick: function handleClick() {
	    this.props.onItemClick(this.props.index);
	  }
	
	});
	
	/***
	 * 水平选项卡面板
	 * @orthor allen
	 * @createData 2018-6-25
	 */
	var HorizontalTabBarEx = React.createClass({
	  displayName: 'HorizontalTabBarEx',
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: parseInt(this.props.selectedIndex, 10) || 0
	    };
	  },
	
	  render: function render() {
	    var txtStr;
	    var isTopBar = this.props.direction === appTypes.VerticalDirection.TOP;
	    var tabPosition = styleHelper.getPropertyValue(this.props, propConst.TAB_POSITION);
	
	    var barHeight = styleHelper.getInt(this.props, propConst.TAB_HEIGHT);
	    var barStyle = {
	      height: barHeight
	    };
	    if (tabPosition === appTypes.HoriAlign.LEFT) {
	      barStyle.marginLeft = (parseInt(this.props.tabEdge, 10) || 0 + 1) + 'px';
	      barStyle.justifyContent = 'flex-start';
	    } else if (tabPosition === appTypes.HoriAlign.CENTER) {
	      barStyle.justifyContent = 'center';
	    } else if (tabPosition === appTypes.HoriAlign.RIGHT) {
	      barStyle.marginRight = (parseInt(this.props.tabEdge, 10) || 0) + 'px';
	      barStyle.justifyContent = 'flex-end';
	    }
	
	    var textStyle = {
	      lineHeight: barHeight + 'px'
	    };
	    styleHelper.StyleUtil(this.props, textStyle).text();
	
	    if (this.props.text) {
	      txtStr = textHelper.delimitText(styleHelper.getText(this.props), textHelper.DM_COMMA);
	    }
	    console.log(txtStr);
	    var self = this;
	    return React.createElement(
	      'div',
	      { className: 'component-HorizontalTabBar' },
	      !isTopBar && this.renderContent(),
	      React.createElement(
	        'div',
	        {
	          className: 'bar-ex',
	          style: barStyle
	        },
	        txtStr.map(function (itm, index) {
	          return React.createElement(BarItem, _extends({ key: index
	          }, this.props, {
	            text: itm,
	            index: index,
	            isChecked: this.state.selectedIndex === index,
	            onItemClick: self.onItemClick,
	            textStyle: textStyle
	          }));
	        }, this)
	      ),
	      isTopBar && this.renderContent()
	    );
	  },
	
	  renderContent: function renderContent() {
	    var showScrollBar, scrollValue;
	    var isTopBar = this.props.direction === appTypes.VerticalDirection.TOP;
	    var barHeight = styleHelper.getInt(this.props, propConst.TAB_HEIGHT);
	    var h = styleHelper.getHeight(this.props);
	    var style = {
	      backgroundColor: this.props.color || '#ffffff'
	    };
	    var borderStr = '1px solid ' + this.props.borderColor || 'gray';
	    if (this.props.borderVisible) {
	      style.border = borderStr;
	    } else {
	      style.borderTop = borderStr;
	    }
	    if (isTopBar) {
	      style.marginTop = '-1px';
	    } else {
	      style.marginBottom = '-1px';
	    }
	    if (!_.isUndefined(this.props.verticalScrollbarShow)) {
	      showScrollBar = this.props.verticalScrollbarShow;
	      scrollValue = parseInt(this.props.verticalScrollbarProgress, 10) || 0;
	    }
	    return React.createElement(
	      'div',
	      { className: 'content-ex', style: style },
	      showScrollBar && React.createElement(VerticalScrollBar, { value: scrollValue, right: -1, top: isTopBar ? barHeight - 1 : 0, height: h - barHeight - 2 })
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('tabClick', this._InteractiveClick);
	  },
	
	  _InteractiveClick: function _InteractiveClick(e, index) {
	    this.onItemClick(index);
	  },
	
	  onItemClick: function onItemClick(index) {
	    this.setState({ selectedIndex: index });
	  }
	});
	
	var TabBarShell = React.createClass({
	  displayName: 'TabBarShell',
	
	
	  render: function render() {
	    console.log(this.props);
	    //目前仅对方角标签进行重写
	    //斜角标签使用布局方式来绘制很麻烦，这里暂时只处理方角标签
	    if (this.props.tabStyle === 'csSquare') {
	      return React.createElement(HorizontalTabBarEx, this.props);
	    } else {
	      return React.createElement(OldTabBar, this.props);
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this._InteractiveClick);
	  },
	
	  _InteractiveClick: function _InteractiveClick(e, index) {
	    $(ReactDOM.findDOMNode(this).children[0]).trigger('tabClick', [index]);
	  }
	
	});
	
	module.exports = TabBarShell;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var VerticalScrollBar = __webpack_require__(178);
	var appTypes = __webpack_require__(115);
	var util = __webpack_require__(116);
	var textHelper = util.Text;
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var graphicsHelper = __webpack_require__(172);
	
	var BarItem = React.createClass({
	  displayName: 'BarItem',
	
	  render: function render() {
	    var text = textHelper.convertSpaceToNbsp(this.props.text);
	    var textStyle = { width: 'auto', color: this.props.textColor };
	    if (this.props.width) {
	      textStyle.width = '100%';
	      textStyle.textAlign = 'center';
	    }
	    return React.createElement(
	      'div',
	      { className: 'BarItem',
	        style: this.mainCSS(),
	        onClick: this.onSelClick },
	      React.createElement(
	        'div',
	        { ref: 'text', className: 'item-text', style: textStyle },
	        React.createElement(
	          'label',
	          null,
	
	          //this.props.text     //Allen:html中的空格文本会被忽略，此处装换为可显示的空格
	          text
	        )
	      ),
	      React.createElement('canvas', { ref: 'canvas', style: { position: 'absolute', zIndex: 0, width: this.props.width || '100%', height: '100%' } })
	    );
	  },
	
	  paint: function paint() {
	    var self = this;
	    this.requestID = window.requestAnimationFrame(function () {
	      var radius = self.props.radius;
	      var tabStyle = self.props.tabStyle || appTypes.TAB_BAR_STYLE.LEAN;
	      var strokeStyleColor = self.props.borderColor;
	      var canvas = ReactDOM.findDOMNode(self.refs.canvas);
	      var g = canvas.getContext('2d');
	      //var w = canvas.clientWidth;
	      var w = canvas.scrollWidth;
	      var h = canvas.clientHeight;
	      var ratio = graphicsHelper.applyDeviceRatio(g, w, h);
	      var thickness = ratio;
	      var offset = thickness / 2;
	      w *= ratio;
	      h *= ratio;
	      //canvas.width = w;
	      //canvas.height = h;
	      //g.clearRect(0, 0, w, h);
	      graphicsHelper.clearRect(g);
	      g.lineWidth = thickness;
	      g.strokeStyle = strokeStyleColor;
	      g.strokeWidth = thickness;
	      g.fillStyle = self.props.backgroundColor;
	      if (tabStyle === appTypes.TAB_BAR_STYLE.LEAN) {
	        if (self.props.direction === appTypes.VerticalDirection.TOP) {
	          g.moveTo(offset, h + offset);
	          g.lineTo(offset, radius);
	          g.quadraticCurveTo(offset, offset, radius, 0);
	          g.lineTo(w - 20 * ratio, offset);
	          g.lineTo(w + offset, h + offset);
	        } else {
	          g.moveTo(offset, 0);
	          g.lineTo(offset, h - radius);
	
	          g.quadraticCurveTo(offset, h, radius, h - offset);
	          g.lineTo(w - 20 * ratio, h - offset);
	          g.lineTo(w, 0);
	        }
	        g.fill();
	        g.stroke();
	      } else if (tabStyle === appTypes.TAB_BAR_STYLE.SQUARE) {
	        if (self.props.direction === appTypes.VerticalDirection.TOP) {
	          g.moveTo(offset, h + offset);
	          g.lineTo(offset, radius);
	          if (radius) g.quadraticCurveTo(offset, offset, radius, 0);
	          g.lineTo(w - radius, offset);
	          if (radius) g.quadraticCurveTo(w, offset, w, radius);
	          g.lineTo(w, h + offset);
	          g.lineTo(offset, h + offset);
	          g.lineTo(offset, radius);
	        } else {
	          g.moveTo(offset, 0);
	          g.lineTo(offset, h - radius);
	          if (radius) g.quadraticCurveTo(offset, h, radius, h);
	          g.lineTo(w - radius, h);
	          if (radius) g.quadraticCurveTo(w, h, w, h - radius);
	          g.lineTo(w, 0);
	        }
	        g.fill();
	        g.stroke();
	      }
	    });
	  },
	
	  mainCSS: function mainCSS() {
	    var css = {
	      overflow: 'hidden',
	      position: 'absolute',
	      width: this.props.width || 'auto',
	      height: this.props.height,
	      zIndex: this.props.zIndex,
	      borderStyle: 'none',
	      boxSizing: 'border-box',
	      borderWidth: 1,
	      textDecoration: 'inherit',
	      lineHeight: this.props.height + 'px'
	    };
	    if (this.props.direction === appTypes.VerticalDirection.TOP) {
	      css.borderBottom = this.props.selected ? '1px solid ' + this.props.backgroundColor : '1px solid ' + this.props.borderColor;
	    } else {
	      css.borderTop = this.props.selected ? '1px solid ' + this.props.backgroundColor : '1px solid ' + this.props.borderColor;
	      css.bottom = 1;
	    }
	    return css;
	  },
	
	  onSelClick: function onSelClick(e) {
	    if (this.props.onClick) {
	      this.props.onClick(e, this.props.index);
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      window.cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.adjust();
	    this.paint();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.paint();
	  },
	
	  adjust: function adjust() {
	    if (this.props.width) {
	      return;
	    }
	    var txtDom = ReactDOM.findDOMNode(this.refs.text);
	    var leftDom = ReactDOM.findDOMNode(this.refs.left);
	    var bevelBorderDom = ReactDOM.findDOMNode(this.refs.bevelBorder);
	    var bevelFillDom = ReactDOM.findDOMNode(this.refs.bevelFill);
	    var selfDom = ReactDOM.findDOMNode(this);
	    //var txtWidth = txtDom.clientWidth;
	    var txtWidth = txtDom.scrollWidth;
	    var h = selfDom.clientHeight;
	    var offset = 1;
	    if (h > 25) {
	      offset = (h - 25) / 150;
	    }
	    var width = txtWidth + 32;
	    $(selfDom).css({ width: width - 6 });
	    $(leftDom).css({ width: width - 20 });
	    $(bevelBorderDom).css({ left: width - 20 });
	    $(bevelFillDom).css({ left: width - 20 - offset });
	    $(txtDom).css({ lineHeight: this.props.height + 'px', paddingLeft: 6 });
	    if (this.props.direction !== appTypes.VerticalDirection.TOP && this.props.tabStyle === 'csSquare') {
	      $(selfDom).css({ width: width - 20 + 'px' });
	    } else if (this.props.direction === appTypes.VerticalDirection.TOP && this.props.tabStyle === 'csSquare') {
	      $(selfDom).css({ width: width - 20 + 'px' });
	    }
	  }
	});
	
	/***
	 * 水平选项卡面板
	 * @orthor mengxiaojiang
	 * @createData 2016-6-15
	 */
	var HorizontalTabBar = React.createClass({
	  displayName: 'HorizontalTabBar',
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: util.Int(this.props.selectedIndex)
	    };
	  },
	
	  render: function render() {
	    console.log(this.props);
	    var txtStr;
	    var tabHeight = styleHelper.getInt(this.props, propConst.TAB_HEIGHT);
	    var tabWidth = styleHelper.getInt(this.props, propConst.TAB_WIDTH);
	    var selIndex = this.state.selectedIndex;
	    var showScrollBar = false;
	    var value = 0;
	    var txtColor = styleHelper.getTextColor(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var bgColor = styleHelper.getBackgroundColor(this.props);
	    var selTextColor = this.props.selectedTextColor;
	    if (!_.isUndefined(this.props.verticalScrollbarShow)) {
	      showScrollBar = this.props.verticalScrollbarShow;
	      value = util.Int(this.props.verticalScrollbarProgress);
	    }
	    if (this.props.text) {
	      txtStr = textHelper.delimitText(styleHelper.getText(this.props), textHelper.DM_COMMA);
	    }
	    return React.createElement(
	      'div',
	      { className: 'component component-HorizontalTabBar' },
	      React.createElement(
	        'div',
	        { ref: 'bar', className: 'bar',
	          style: {
	            height: tabHeight + 1,
	            fontStyle: this.props.textStyles.fontStyle,
	            fontSize: this.props.textSize,
	            fontWeight: this.props.textStyles.fontWeight,
	            textDecoration: this.props.textStyles.textDecoration,
	            fontFamily: this.props.textFontFamily,
	            color: txtColor
	          } },
	        txtStr.map(function (itm, index) {
	          return React.createElement(BarItem, _extends({ key: index }, {
	            width: tabWidth || 0,
	            height: tabHeight,
	            backgroundColor: index === selIndex ? styleHelper.getBackgroundColor(this.props) : this.props.tabColor || '#ddd',
	            borderColor: this.props.borderColor,
	            textColor: index === selIndex && selTextColor !== undefined ? selTextColor : '',
	            text: itm,
	            index: index,
	            selected: index === selIndex,
	            zIndex: index === selIndex ? txtStr.length + 10 : txtStr.length - index,
	            onClick: this.onItemClick,
	            direction: this.props.direction,
	            cardPadding: this.props.tabEdge,
	            tabStyle: this.props.tabStyle,
	            radius: this.props.radius || 0
	          }));
	        }, this)
	      ),
	      React.createElement(
	        'div',
	        { ref: 'content', style: {
	            position: 'absolute',
	            zIndex: 1,
	            width: '100%',
	            height: h - tabHeight + 1,
	            top: tabHeight - 1,
	            borderLeftStyle: this.props.borderVisible ? 'solid' : 'none',
	            borderRightStyle: this.props.borderVisible ? 'solid' : 'none',
	            borderTopStyle: this.props.borderVisible ? 'solid' : this.props.direction === appTypes.VerticalDirection.TOP ? 'solid' : 'none',
	            borderBottomStyle: this.props.borderVisible ? 'solid' : this.props.direction === appTypes.VerticalDirection.BOTTOM ? 'solid' : 'none',
	            borderWidth: 1,
	            backgroundColor: styleHelper.getBackgroundColor(this.props),
	            borderColor: this.props.borderColor
	          } },
	        showScrollBar && React.createElement(VerticalScrollBar, { value: value, right: -1, top: -1, height: h - tabHeight })
	      )
	    );
	  },
	
	  onItemClick: function onItemClick(e, index) {
	    this.setState({ selectedIndex: index });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.adjust();
	    $(ReactDOM.findDOMNode(this)).bind('tabClick', this.onItemClick);
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.adjust();
	  },
	
	  adjust: function adjust() {
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var bar = ReactDOM.findDOMNode(this.refs.bar);
	    var tabH = styleHelper.getInt(this.props, propConst.TAB_HEIGHT);
	    var tabW = styleHelper.getInt(this.props, propConst.TAB_WIDTH);
	    var content = ReactDOM.findDOMNode(this.refs.content);
	    var barItems = bar.children;
	    var itemDom;
	    var i;
	    var tabEdge = 20;
	
	    if (this.props.tabEdge !== undefined) {
	      tabEdge = parseInt(this.props.tabEdge, 10) || 0;
	    }
	    var left = tabEdge;
	    var itemWidth;
	    var display = 'visible';
	    var tabPosition = styleHelper.getPropertyValue(this.props, propConst.TAB_POSITION);
	    var barWidth = 0;
	    for (i = 0; i < barItems.length; i++) {
	      itemDom = barItems[i];
	      //itemWidth = itemDom.clientWidth;
	      itemWidth = itemDom.scrollWidth;
	      barWidth += itemWidth - 15;
	    }
	    if (barWidth) {
	      barWidth += 15;
	    }
	    if (tabPosition === appTypes.HoriAlign.CENTER) {
	      left = (w - barWidth) / 2;
	    } else if (tabPosition === appTypes.HoriAlign.RIGHT) {
	      left = w - barWidth - 28 - tabEdge;
	    }
	    for (i = 0; i < barItems.length; i++) {
	      itemDom = barItems[i];
	      //itemWidth = itemDom.clientWidth;
	      itemWidth = itemDom.scrollWidth;
	      if (itemDom.clientWidth !== itemWidth && tabW === 0) {
	        itemWidth += 9;
	      }
	
	      display = 'visible';
	      if (left < 0) {
	        display = 'hidden';
	      }
	      if (left + itemWidth > w) {
	        display = 'hidden';
	      }
	      $(itemDom).css({ left: left, width: itemWidth, visibility: display });
	      //left += itemDom.clientWidth - 9;
	      left += itemDom.scrollWidth - 9;
	      if (this.props.direction !== appTypes.VerticalDirection.TOP && this.props.tabStyle === 'csSquare') {
	        left = left + 8;
	      } else if (this.props.direction === appTypes.VerticalDirection.TOP && this.props.tabStyle === 'csSquare') {
	        left = left + 8;
	      }
	    }
	    if (this.props.direction === appTypes.VerticalDirection.TOP) {
	      $(bar).css({ top: 0 });
	      $(content).css({ top: tabH - 1 });
	    } else {
	      $(bar).css({ top: h - tabH + 2 });
	      $(content).css({ top: 0 });
	    }
	  }
	});
	
	module.exports = HorizontalTabBar;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var VerticalScrollBar = __webpack_require__(178);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	
	var VerticalScrollBarCom = React.createClass({
	  displayName: 'VerticalScrollBarCom',
	
	
	  render: function render() {
	    var v = styleHelper.getInt(this.props, propConst.PROGRESS);
	    return React.createElement(VerticalScrollBar, {
	      backgroundColor: '#fff',
	      value: v
	    });
	  }
	});
	
	module.exports = VerticalScrollBarCom;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var HorizontalScrollBar = __webpack_require__(184);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	
	var HorizontalScrollBarCom = React.createClass({
	  displayName: 'HorizontalScrollBarCom',
	
	
	  render: function render() {
	    return React.createElement(HorizontalScrollBar, {
	      backgroundColor: '#fff',
	      value: styleHelper.getInt(this.props, propConst.PROGRESS)
	    });
	  }
	});
	
	module.exports = HorizontalScrollBarCom;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var mouseHelper = __webpack_require__(149);
	
	/**
	 * Slider
	 * 滑块
	 */
	var Slider = React.createClass({
	  displayName: 'Slider',
	
	  getInitialState: function getInitialState() {
	    return {
	      progress: styleHelper.getInt(this.props, propConst.PROGRESS)
	    };
	  },
	  render: function render() {
	    var progress = this.state.progress;
	    var value = this.props.w * progress / 100;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var ch = this.props.h;
	    var bg = styleHelper.getBackgroundColor(this.props);
	
	    var trackRightColor = this.props.borderColor;
	    if (trackRightColor === 'rgba(0,0,0,0)') {
	      trackRightColor = 'rgba(102,102,102,1)';
	    }
	    return React.createElement(
	      'div',
	      { ref: 'slider', className: 'component-Slider', onClick: this.onTrackClick },
	      React.createElement('span', { className: 'track-left', style: {
	          top: h * 0.5 - 1,
	          width: progress === 100 ? w - ch / 2 : value,
	          backgroundColor: bg
	        } }),
	      React.createElement('span', { className: 'track-right', style: {
	          left: progress === 0 ? ch / 2 : value,
	          top: h * 0.5 - 1,
	          width: progress === 100 ? 0 : progress === 0 ? w - ch / 2 : w - value,
	          background: trackRightColor
	        } }),
	      React.createElement(
	        'span',
	        { className: 'slider',
	          onMouseDown: this.onDrag,
	          onTouchStart: this.onDrag,
	          style: {
	            left: Math.max(0, Math.min(value - ch / 2, w - ch)),
	            top: (h - ch) / 2,
	            width: ch,
	            height: ch
	          } },
	        React.createElement('span', { className: 'slider-outer', style: { backgroundColor: bg } }),
	        React.createElement('spane', { className: 'slider-inner', style: {
	            left: (ch - 10) / 2,
	            top: (ch - 10) / 2,
	            backgroundColor: bg
	          } })
	      )
	    );
	  },
	  onDrag: function onDrag(e) {
	    var width = parseInt(this.props.w, 10);
	    var self = this;
	    var progress = this.state.progress;
	    var unit = width / 100;
	    mouseHelper.dragDelegate(function (e, delta) {
	      self.setState({
	        progress: Math.max(0, Math.min(delta.x / unit + progress, 100))
	      });
	      e.stopPropagation();
	      e.preventDefault();
	    }, function (e) {
	      e.stopPropagation();
	      e.preventDefault();
	    });
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  onTrackClick: function onTrackClick(e) {
	    var parent = ReactDOM.findDOMNode(this.refs.slider);
	    var parentRects = parent.getBoundingClientRect();
	    var offsetLeft = e.clientX - parentRects.left;
	    var width = parseInt(this.props.w, 10);
	    this.setState({
	      progress: offsetLeft / width * 100
	    });
	  }
	
	});
	
	module.exports = Slider;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var Border = __webpack_require__(168);
	var util = __webpack_require__(116);
	var propConst = __webpack_require__(147);
	var styleHelper = __webpack_require__(145);
	var ColorImage = __webpack_require__(234);
	
	var TableViewItem = React.createClass({
	  displayName: 'TableViewItem',
	
	  render: function render() {
	    var text = this.props.text;
	    var len = text.length;
	    var iconIndex = text.lastIndexOf('-'); //   text.search(/\-/);
	    var shortText = text.slice(0, iconIndex);
	    var icon = text.slice(iconIndex, len);
	    var hasIcon = this.getIcon(icon);
	
	    if (hasIcon) {
	      shortText = util.Text.convertSpaceToNbsp(shortText, false);
	    } else {
	      shortText = util.Text.convertSpaceToNbsp(text, false);
	    }
	
	    var itemBorderStyle = {
	      width: this.props.width - 20
	    };
	
	    /*border相关兼容修正*/
	    if (this.props.showSeparator && !this.props.isLast) {
	      itemBorderStyle.borderBottom = '1px solid ' + this.props.separatorColor;
	    }
	
	    var iconSize = parseInt(this.props.iconSize);
	    var imgStyle = {
	      float: 'left',
	      width: iconSize || 22,
	      height: iconSize || 22
	    };
	
	    return React.createElement(
	      'div',
	      { className: 'item', style: {
	          width: this.props.width,
	          height: this.props.height,
	          backgroundColor: this.props.backgroundColor,
	          display: this.props.display ? 'block' : 'none',
	          wordSpacing: -1
	        },
	        onClick: this.onSelfClick },
	      React.createElement(
	        'div',
	        { className: 'item-border', style: itemBorderStyle },
	        React.createElement(
	          'div',
	          { className: 'item-text', style: {
	              width: this.props.width - iconSize - 20
	            } },
	          React.createElement(
	            'label',
	            null,
	            shortText
	          )
	        ),
	        hasIcon && React.createElement(
	          'div',
	          { className: 'item-icon', style: {
	              left: this.props.width - iconSize - 20,
	              top: (this.props.height - iconSize) / 2,
	              width: iconSize,
	              height: iconSize
	            } },
	          React.createElement(ColorImage, { style: imgStyle,
	            src: hasIcon,
	            color: this.props.iconColor
	          })
	        )
	      )
	    );
	  },
	
	  onSelfClick: function onSelfClick(e) {
	    if (this.props.onClick) {
	      this.props.onClick(e, this.props.index);
	    }
	  },
	
	  getIcon: function getIcon(cfg) {
	    var url;
	    switch (cfg.trim().toLowerCase()) {
	      case '->':
	        url = 'Gt';
	        break;
	      case '-p':
	        url = 'DocEmpty';
	        break;
	      case '-n':
	        url = 'Pencil';
	        break;
	      case '-+':
	        url = 'Plus';
	        break;
	      case '-f':
	        url = 'Folder';
	        break;
	      case '-r':
	        url = 'RightTriangle';
	        break;
	      case '-v':
	        url = 'CheckMark';
	        break;
	    }
	    if (url) {
	      return assetsHelper.getIcon(url + '.png');
	    }
	    return null;
	  }
	});
	
	var TableView = React.createClass({
	  displayName: 'TableView',
	
	  parseText: function parseText() {
	    var text = styleHelper.getText(this.props);
	    text = util.Text.removeLastEmptyRow(text);
	    return util.Text.delimitText(text, util.Text.DM_RETURN);
	  },
	  getInitialState: function getInitialState() {
	    return { selectedIndex: util.Int(this.props.selectedIndex) };
	  },
	  render: function render() {
	    var textItems = this.parseText();
	    var itemH = util.Int(this.props.itemHeight);
	    var h = styleHelper.getHeight(this.props);
	    var w = styleHelper.getWidth(this.props);
	    var bgColor = styleHelper.getBackgroundColor(this.props);
	    var borderVisible = styleHelper.getPropertyValue(this.props, propConst.BORDER_VISIBLE);
	    if (borderVisible) {
	      w -= 2;
	    }
	
	    var textSize = styleHelper.getFontSize(this.props);
	
	    var style = {
	      lineHeight: itemH + 'px',
	      boxSizing: 'content-box',
	      overflow: 'hidden'
	    };
	    styleHelper.StyleUtil(this.props, style).text().background().border();
	
	    return React.createElement(
	      'div',
	      { className: 'component component-TableView', style: style },
	      textItems.map(function (itm, index) {
	        var isLast = false;
	        if (index === textItems.length - 1) {
	          //最后一列不显示分割线
	          isLast = true;
	        }
	        return React.createElement(TableViewItem, {
	          key: index,
	          height: itemH + 0.5,
	          width: w,
	          text: itm,
	          index: index,
	          display: itemH * (index + 1) < h,
	          backgroundColor: this.state.selectedIndex === index ? this.props.selectedColor : bgColor,
	          onClick: this.onSelected,
	
	          showSeparator: this.props.showSeparator,
	          separatorColor: this.props.separatorColor,
	          iconColor: this.props.iconColor,
	          iconSize: this.props.iconSize,
	
	          isLast: isLast
	        });
	      }, this)
	    );
	  },
	  onSelected: function onSelected(e, index) {
	    this.setState({ selectedIndex: index });
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onSelected);
	  }
	});
	
	module.exports = TableView;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var util = __webpack_require__(116);
	var styleHelper = __webpack_require__(145);
	var envHelper = __webpack_require__(48);
	var propConst = __webpack_require__(147);
	var ColorImage = __webpack_require__(234);
	var _ = __webpack_require__(51);
	
	var IOSStatusBar = React.createClass({
	  displayName: 'IOSStatusBar',
	
	  render: function render() {
	
	    var bgColor = styleHelper.getBackgroundColor(this.props);
	    var isLightColor = util.Color.isLight(bgColor);
	    var color = styleHelper.getPropertyValue(this.props, propConst.FOREGROUND_COLOR);
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    if (_.isUndefined(this.props.IsAutoTextColor) || this.props.IsAutoTextColor) {
	      if (isLightColor) {
	        color = '#000';
	      } else {
	        color = '#fff';
	      }
	    }
	    if (envHelper.isWxMiniApp() && this.props.x <= 3 && this.props.y <= 3) {
	      return React.createElement('div', { style: { width: w, height: h, backgroundColor: bgColor } });
	    }
	    return React.createElement(
	      'div',
	      { className: 'component-IOSStatusBar', style: { backgroundColor: bgColor } },
	      React.createElement(ColorImage, _extends({
	        src: assetsHelper.getComponentAsset('StatusBar(IOS)'),
	        height: 20,
	        width: '100%',
	        color: color,
	        gridRect: {
	          left: 107,
	          right: 250
	        }
	      }, { style: {
	          width: '100%',
	          height: 20,
	          position: 'absolute',
	          top: (h - 20) / 2
	        } })),
	      React.createElement(
	        'div',
	        { className: 'time' },
	        React.createElement(
	          'label',
	          { style: {
	              lineHeight: h + 'px',
	              color: color,
	              fontSize: Math.min(h, 20) / 2
	            } },
	          '4:20PM'
	        )
	      )
	    );
	  }
	});
	
	module.exports = IOSStatusBar;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	var propConst = __webpack_require__(147);
	
	/**
	 * 垂直分割条
	 */
	var VerticalRule = React.createClass({
	  displayName: 'VerticalRule',
	
	  render: function render() {
	    var width = styleHelper.getWidth(this.props);
	    var height = styleHelper.getHeight(this.props);
	    return React.createElement(
	      'div',
	      null,
	      React.createElement('canvas', {
	        ref: 'canvas',
	        style: { width: '100%', height: '100%' },
	        onChange: this.paint.bind(this, this.props),
	        width: width,
	        height: height })
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.paint();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.paint();
	  },
	
	  paint: function paint() {
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var dashMode = styleHelper.parseDashMode(styleHelper.getPropertyValue(this.props, propConst.DASH_MODE));
	    var lineWidth = styleHelper.getBorderWidth(this.props);
	    var strokeColor = styleHelper.getBackgroundColor(this.props);
	    var x = (parseInt(w / 2, 10) || 6) - (lineWidth % 2 === 0 ? 0 : 0.5);
	    var ctx = canvas.getContext('2d');
	
	    var ratio = graphicsHelper.applyDeviceRatio(ctx, w, h);
	    w *= ratio;
	    h *= ratio;
	    x *= ratio;
	    lineWidth *= ratio;
	    graphicsHelper.clearRect(ctx);
	    //ctx.clearRect(0, 0, w, h);
	    graphicsHelper.drawLine(ctx, {
	      dashMode: dashMode,
	      lineWidth: lineWidth,
	      strokeColor: strokeColor,
	      startX: x,
	      startY: 0,
	      endX: x,
	      endY: h
	    });
	  }
	});
	
	module.exports = VerticalRule;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	var propConst = __webpack_require__(147);
	
	/**
	 * 水平分割条
	 */
	var HorizontalRule = React.createClass({
	  displayName: 'HorizontalRule',
	
	
	  render: function render() {
	    var width = styleHelper.getWidth(this.props);
	    var height = styleHelper.getHeight(this.props);
	    return React.createElement(
	      'div',
	      null,
	      React.createElement('canvas', {
	        ref: 'canvas',
	        style: { width: '100%', height: '100%', position: 'absolute' },
	        onChange: this.paint.bind(this, this.props),
	        width: width,
	        height: height })
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.paint();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    //this.paint();
	  },
	
	  paint: function paint() {
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var dashMode = styleHelper.parseDashMode(styleHelper.getPropertyValue(this.props, propConst.DASH_MODE));
	    var lineWidth = styleHelper.getBorderWidth(this.props);
	    var strokeColor = styleHelper.getBackgroundColor(this.props);
	    var y = (parseInt(h / 2, 10) || 6) + (lineWidth % 2 === 0 ? 0 : 0.5);
	    var ctx = canvas.getContext('2d');
	    var ratio = graphicsHelper.applyDeviceRatio(ctx, w, h);
	    w *= ratio;
	    h *= ratio;
	    y *= ratio;
	    lineWidth *= ratio;
	    //ctx.clearRect(0, 0, w, h);
	    graphicsHelper.clearRect(ctx);
	    graphicsHelper.drawLine(ctx, {
	      dashMode: dashMode,
	      lineWidth: lineWidth,
	      strokeColor: strokeColor,
	      startX: 0,
	      startY: y,
	      endX: w,
	      endY: y
	    });
	  }
	});
	
	module.exports = HorizontalRule;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var _ = __webpack_require__(51);
	var styleHelper = __webpack_require__(145);
	/**
	 * @author mengxiaojiang
	 * @createData 2016-6-14
	 * @descriptor 垂直分隔条
	 */
	var VerticalSplitter = React.createClass({
	  displayName: 'VerticalSplitter',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'component component-VerticalSplitter' },
	      React.createElement(
	        'ul',
	        { style: { paddingTop: (styleHelper.getHeight(this.props) - 15) / 2 } },
	        React.createElement('li', null),
	        React.createElement('li', null),
	        React.createElement('li', null)
	      )
	    );
	  }
	});
	
	module.exports = VerticalSplitter;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var _ = __webpack_require__(51);
	var styleHelper = __webpack_require__(145);
	/**
	 * @author mengxiaojiang
	 * @createData 2016-6-14
	 * @descriptor 水平分隔条
	 */
	var HorizontalSplitter = React.createClass({
	  displayName: 'HorizontalSplitter',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'component component-HorizontalSplitter' },
	      React.createElement(
	        'ul',
	        { style: { paddingLeft: (styleHelper.getWidth(this.props) - 14) / 2 } },
	        React.createElement('li', null),
	        React.createElement('li', null),
	        React.createElement('li', null)
	      )
	    );
	  }
	});
	
	module.exports = HorizontalSplitter;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var util = __webpack_require__(116);
	
	var PageControl = React.createClass({
	  displayName: 'PageControl',
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: 3,
	      canClick: false
	    };
	  },
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'component component-PageControl' },
	      React.createElement(
	        'ul',
	        null,
	        util.Util.map(5, function (o, i) {
	          return React.createElement('li', { key: i });
	        })
	      )
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    var dom = ReactDOM.findDOMNode(this);
	    var i;
	    var li;
	    dom = dom.children[0];
	    for (i = 0; i < dom.children.length; i++) {
	      li = dom.children[i];
	      $(li).off('click');
	      $(li).on('click', { index: i }, this.onItemClick);
	    }
	    this.doSelect();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doSelect();
	  },
	
	  onItemClick: function onItemClick(e) {
	    var index = e.data.index;
	    if (this.state.canClick) {
	      this.setState({ selectedIndex: index });
	    }
	  },
	
	  doSelect: function doSelect() {
	    var dom = ReactDOM.findDOMNode(this);
	    var i;
	    var li;
	    var bg;
	    dom = dom.children[0];
	    for (i = 0; i < dom.children.length; i++) {
	      li = dom.children[i];
	      if (i === this.state.selectedIndex) {
	        bg = '#41c7d6';
	      } else {
	        bg = '#ddd';
	      }
	      $(li).css({ backgroundColor: bg });
	    }
	  }
	});
	
	module.exports = PageControl;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var util = __webpack_require__(116);
	
	var PageControlEx = React.createClass({
	  displayName: 'PageControlEx',
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: this.props.selectedIndex,
	      columnCount: this.props.columnCount,
	      shapeType: this.props.shapeType
	    };
	  },
	
	  render: function render() {
	    var cssIcon = {
	      width: this.props.size,
	      height: this.props.size
	    };
	
	    if (this.props.borderVisible) {
	      cssIcon.border = '1px solid ' + this.props.borderColor;
	    }
	
	    if (this.state.shapeType == 'stSquare') {
	      cssIcon.border = '1px solid ' + this.props.color;
	      cssIcon.backgroundColor = '#fff';
	      cssIcon.borderRadius = '0';
	    }
	
	    var self = this;
	
	    return React.createElement(
	      'div',
	      { ref: 'asd', className: 'component component-PageControlEx',
	        style: { width: this.state.columnCount * cssIcon.width + this.state.columnCount * this.props.gap } },
	      React.createElement(
	        'ul',
	        { ref: 'list' },
	        util.Util.map(this.state.columnCount, function (o, i) {
	          if (self.state.shapeType == 'stRound') {
	            return React.createElement('li', { style: cssIcon, className: 'stRound', key: i });
	          } else if (self.state.shapeType == 'stHollowRect') {
	            return React.createElement('li', { style: cssIcon, className: 'stHollowRect', key: i });
	          } else if (self.state.shapeType == 'stSquare') {
	            return React.createElement('li', { style: cssIcon, className: 'stSquare', key: i });
	          }
	        })
	      )
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    var dom = ReactDOM.findDOMNode(this.refs.list);
	    var i;
	    var li;
	    for (i = 0; i < dom.children.length; i++) {
	      li = dom.children[i];
	      $(li).off('click');
	      $(li).on('click', { index: i }, this.onItemClick);
	    }
	
	    this.doSelect();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doSelect();
	  },
	
	  onItemClick: function onItemClick(e) {
	    var index = e.data.index;
	    this.setState({ selectedIndex: index });
	  },
	
	  doSelect: function doSelect() {
	    var dom = ReactDOM.findDOMNode(this);
	    var i;
	    var li;
	    var bg;
	    dom = dom.children[0];
	
	    for (i = 0; i < dom.children.length; i++) {
	      li = dom.children[i];
	      if (i === this.state.selectedIndex) {
	        bg = this.props.selectedColor || '#41c7d6';
	      } else {
	        bg = this.props.color || '#dddddd';
	      }
	      $(li).css({
	        backgroundColor: bg,
	        borderColor: this.props.borderColor || bg
	      });
	    }
	  }
	});
	
	module.exports = PageControlEx;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var assetsHelper = __webpack_require__(65);
	var VerticalScrollBar = __webpack_require__(178);
	var graphicsHelper = __webpack_require__(172);
	var GlobalConst = __webpack_require__(164);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	
	/**
	 * 浏览器组件
	 * @author mxj
	 */
	var BrowserWindow = React.createClass({
	  displayName: 'BrowserWindow',
	
	  render: function render() {
	    var title;
	    var url;
	    var strArr;
	    var text = styleHelper.getText(this.props);
	    var showScrollBar = false;
	    var value = 0;
	    var style;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    if (text) {
	      text = text.trim();
	      if (text) {
	        strArr = util.Text.delimitText(text, util.Text.DM_RETURN);
	        if (strArr) {
	          if (strArr.length > 0) {
	            title = strArr[0];
	          }
	          if (strArr.length > 1) {
	            url = strArr[1];
	          }
	        }
	      }
	    }
	    if (!_.isUndefined(this.props.verticalScrollbarShow)) {
	      showScrollBar = this.props.verticalScrollbarShow;
	      value = util.Number.toInt(this.props.verticalScrollbarProgress);
	    }
	    style = {
	      height: '100%',
	      width: '100%',
	      left: 0,
	      top: 0,
	      overflow: 'hidden',
	      backgroundColor: GlobalConst.GLOBAL_COLOR.SYSTEM_WHITE
	    };
	    styleHelper.builderTextStyle(this.props, style);
	    return React.createElement(
	      'div',
	      { className: 'component component-browserwindow', style: style },
	      React.createElement('div', { className: 'bg', style: {
	          height: h - 100,
	          backgroundColor: this.props.color
	        } }),
	      React.createElement(
	        'div',
	        { className: 'img-bg' },
	        React.createElement(
	          'canvas',
	          { ref: 'canvas', width: w, height: h },
	          React.createElement('img', { ref: 'img', src: assetsHelper.getComponentAsset('browserwindow'),
	            onLoad: this.onImageLoaded })
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'title', style: { width: styleHelper.getWidth(this.props) - 4 } },
	        React.createElement(
	          'label',
	          null,
	          title
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'url', style: { width: styleHelper.getWidth(this.props) - 188 } },
	        React.createElement(
	          'label',
	          null,
	          url
	        )
	      ),
	      showScrollBar && React.createElement(VerticalScrollBar, { top: 72, right: 1, height: h - 103, value: value, zIndex: 5 })
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.paint();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.paint();
	  },
	
	  onImageLoaded: function onImageLoaded() {
	    this.isLoaded = true;
	    this.paint();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  paint: function paint() {
	    if (this.isLoaded) {
	      this.requestID = window.requestAnimationFrame(this.doPaint);
	    }
	  },
	
	  doPaint: function doPaint() {
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    //canvas.width = styleHelper.getWidth(this.props);
	    //canvas.height = styleHelper.getHeight(this.props);
	    var graphics;
	    var img = ReactDOM.findDOMNode(this.refs.img);
	    var img9 = {
	      left: 141,
	      top: 74,
	      right: 417,
	      bottom: 374
	    };
	    if (canvas && img) {
	      graphics = canvas.getContext('2d');
	
	      graphicsHelper.drawNineGridImage(graphics, img, img9, {
	        left: 0,
	        top: 0,
	        right: styleHelper.getWidth(this.props),
	        bottom: styleHelper.getHeight(this.props)
	      });
	    }
	  }
	
	});
	
	module.exports = BrowserWindow;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var IOSStatusBar = __webpack_require__(246);
	var assetsHelper = __webpack_require__(65);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	
	/**
	 * IPhone
	 * @author mengxiaojiang
	 * @createDate 2016-6-15
	 */
	var IPhone = React.createClass({
	  displayName: 'IPhone',
	
	  render: function render() {
	    var direction = this.props.direction;
	    var size = styleHelper.getSize(this.props);
	    var move = 0;
	    this.contentOrigRect = {
	      left: 29.5,
	      top: 87,
	      right: 372,
	      bottom: 609
	    };
	    if (direction === appTypes.Direction.HORIZONTAL) {
	      move = (size.width - size.height) / 2;
	    }
	    return React.createElement(
	      'div',
	      { className: 'component contents-layout component-IPhone' },
	      React.createElement(
	        'div',
	        { className: 'contents-layout' },
	        React.createElement('img', {
	          style: {
	            width: direction === appTypes.Direction.VERTICAL ? size.width : size.height,
	            height: direction === appTypes.Direction.VERTICAL ? size.height : size.width,
	            pointerEvents: 'none',
	            transform: 'rotate(' + (direction === appTypes.Direction.HORIZONTAL ? 270 : 0) + 'deg) translate(' + move + 'px,' + move + 'px)'
	          },
	          ref: 'backgroundImg',
	          src: assetsHelper.getAsset('components/wireframe/iphone.png'),
	          onLoad: this.onImgLoaded })
	      ),
	      React.createElement(
	        'div',
	        { ref: 'content', className: 'contents-layout' },
	        React.createElement(
	          'div',
	          { ref: 'statusBar', className: 'status-bar' },
	          React.createElement(IOSStatusBar, { ForegroundColor: '#FFF', color: '#000', IsAutoTextColor: false, h: 20, w: '100%' })
	        ),
	        React.createElement(
	          'div',
	          { ref: 'bg', className: 'contents-layout' },
	          React.createElement('div', { ref: 'top', className: 'top' }),
	          React.createElement('div', { ref: 'bottom', className: 'bottom' })
	        )
	      )
	    );
	  },
	
	  onImgLoaded: function onImgLoaded() {
	    this.isLoaded = true;
	    this.doAdjustChildBounds();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doAdjustChildBounds();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doAdjustChildBounds();
	  },
	
	  doAdjustChildBounds: function doAdjustChildBounds() {
	    var contentDom;
	    var size = styleHelper.getSize(this.props);
	    var w = size.width;
	    var h = size.height;
	    var t;
	    var contentRect;
	    var scale;
	    var sy;
	    var imgW = 400;
	    var imgH = 702;
	    var _$;
	    var showTop = false;
	    var showBottom = false;
	    var bgTop;
	    var fullScreen = styleHelper.getPropertyValue(this.props, propConst.FULL_SCREEN);
	    var phoneType = styleHelper.getPropertyValue(this.props, propConst.PHONE_TYPE);
	    var isTransparent = styleHelper.getPropertyValue(this.props, propConst.IS_TRANSPARENT);
	    if (!this.isLoaded) {
	      return;
	    }
	    if (this.props.direction === appTypes.Direction.HORIZONTAL) {
	      t = w;
	      w = h;
	      h = t;
	    }
	    scale = {
	      x: w / imgW,
	      y: h / imgH
	    };
	
	    contentRect = {
	      left: this.contentOrigRect.left * scale.x,
	      top: this.contentOrigRect.top * scale.y,
	      right: this.contentOrigRect.right * scale.x,
	      bottom: this.contentOrigRect.bottom * scale.y
	    };
	    sy = scale.y;
	    if (this.props.direction === appTypes.Direction.HORIZONTAL) {
	      sy = scale.x;
	      contentRect = {
	        left: contentRect.top,
	        top: h - contentRect.right,
	        right: contentRect.bottom,
	        bottom: h - contentRect.left
	      };
	    }
	    bgTop = 20 * sy;
	    _$ = $(ReactDOM.findDOMNode(this.refs.content));
	    _$.css({
	      left: contentRect.left,
	      top: contentRect.top,
	      width: contentRect.right - contentRect.left,
	      height: contentRect.bottom - contentRect.top
	    });
	
	    if (isTransparent) {
	      _$.css({ backgroundColor: 'rgba(0,0,0,0)' });
	    } else {
	      if (phoneType === appTypes.PhoneType.ALLBLACK) {
	        _$.css({ backgroundColor: 'rgba(0,0,0,0.5)' });
	      } else {
	        _$.css({ backgroundColor: '#fff' });
	      }
	    }
	
	    if (fullScreen) {
	      _$ = $(ReactDOM.findDOMNode(this.refs.statusBar));
	      _$.css({ display: 'none' });
	      _$ = $(ReactDOM.findDOMNode(this.refs.bg));
	      _$.css({ display: 'none' });
	      showBottom = showTop = false;
	    } else {
	      $(ReactDOM.findDOMNode(this.refs.statusBar)).css({ transform: 'scale(1,' + sy + ')', 'transform-origin': 'top', display: 'block' });
	      $(ReactDOM.findDOMNode(this.refs.bg)).css({ top: bgTop, height: contentRect.bottom - contentRect.top - 20 * sy, display: 'block' });
	      showTop = phoneType === appTypes.PhoneType.TOPONLY || phoneType === appTypes.PhoneType.TOPANDBOTTOM;
	      showBottom = phoneType === appTypes.PhoneType.TOPANDBOTTOM;
	    }
	    $(ReactDOM.findDOMNode(this.refs.top)).css({ display: showTop ? 'block' : 'none', height: 40 * sy });
	    $(ReactDOM.findDOMNode(this.refs.bottom)).css({ display: showBottom ? 'block' : 'none', height: 40 * sy });
	  }
	});
	
	module.exports = IPhone;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var AndroidStatusBar = __webpack_require__(256);
	var assetsHelper = __webpack_require__(65);
	var appTypes = __webpack_require__(115);
	var GlobalConst = __webpack_require__(164);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	
	/**
	 * AndroidPhone
	 * @author mengxiaojiang
	 * @createDate 2016-6-15
	 */
	var AndroidPhone = React.createClass({
	  displayName: 'AndroidPhone',
	
	  render: function render() {
	    var direction = this.props.direction;
	    var move = 0;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    this.contentOrigRect = {
	      left: 30,
	      top: 60,
	      right: 372,
	      bottom: 607
	    };
	    if (direction === appTypes.Direction.HORIZONTAL) {
	      move = (w - h) / 2;
	    }
	    return React.createElement(
	      'div',
	      { className: 'component contents-layout component-androidphone' },
	      React.createElement(
	        'div',
	        { className: 'contents-layout' },
	        React.createElement('img', {
	          style: {
	            pointerEvents: 'none',
	            width: direction === appTypes.Direction.VERTICAL ? w : h,
	            height: direction === appTypes.Direction.VERTICAL ? h : w,
	            transform: 'rotate(' + (direction === appTypes.Direction.HORIZONTAL ? 270 : 0) + 'deg) translate(' + move + 'px,' + move + 'px)'
	          },
	          ref: 'backgroundImg',
	          src: assetsHelper.getAsset('components/wireframe/phone.png'),
	          onLoad: this.onImgLoaded })
	      ),
	      React.createElement(
	        'div',
	        { ref: 'content', className: 'contents-layout' },
	        React.createElement(
	          'div',
	          { ref: 'statusBar', style: { width: '100%', height: 20 } },
	          React.createElement(AndroidStatusBar, {
	            ForegroundColor: '#FFF',
	            IsAutoTextColor: false,
	            color: GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK,
	            h: 20,
	            w: '100%'
	          })
	        ),
	        React.createElement(
	          'div',
	          { ref: 'bg', className: 'contents-layout' },
	          React.createElement('div', { ref: 'top', className: 'top' }),
	          React.createElement('div', { ref: 'bottom', className: 'bottom' })
	        )
	      )
	    );
	  },
	
	  onImgLoaded: function onImgLoaded() {
	    this.isLoaded = true;
	    this.doAdjustChildBounds();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doAdjustChildBounds();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doAdjustChildBounds();
	  },
	
	  doAdjustChildBounds: function doAdjustChildBounds() {
	    var contentDom;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var t;
	    var contentRect;
	    var scale;
	    var sy;
	    var imgW = 400;
	    var imgH = 702;
	    var _$;
	    var showTop = false;
	    var showBottom = false;
	    var phoneType = styleHelper.getPropertyValue(this.props, 'phoneType');
	    var isTransparent = styleHelper.getPropertyValue(this.props, 'isTransparent');
	    var fullScreen = styleHelper.getPropertyValue(this.props, 'fullScreen');
	
	    var barHeight = 20;
	    var bgTop = 20;
	    if (!this.isLoaded) {
	      return;
	    }
	    contentDom = ReactDOM.findDOMNode(this.refs.content);
	    if (this.props.direction === appTypes.Direction.HORIZONTAL) {
	      t = w;
	      w = h;
	      h = t;
	    }
	    scale = {
	      x: w / imgW,
	      y: h / imgH
	    };
	
	    contentRect = {
	      left: this.contentOrigRect.left * scale.x,
	      top: this.contentOrigRect.top * scale.y,
	      right: this.contentOrigRect.right * scale.x,
	      bottom: this.contentOrigRect.bottom * scale.y
	    };
	    sy = scale.y;
	    if (this.props.direction === appTypes.Direction.HORIZONTAL) {
	      sy = scale.x;
	      contentRect = {
	        left: contentRect.top,
	        top: styleHelper.getHeight(this.props) - contentRect.right,
	        right: contentRect.bottom,
	        bottom: styleHelper.getHeight(this.props) - contentRect.left
	      };
	    }
	    bgTop = 20 * sy;
	    _$ = $(ReactDOM.findDOMNode(this.refs.content));
	    _$.css({
	      left: contentRect.left,
	      top: contentRect.top,
	      width: contentRect.right - contentRect.left,
	      height: contentRect.bottom - contentRect.top
	    });
	
	    if (isTransparent) {
	      _$.css({ backgroundColor: 'rgba(0,0,0,0)' });
	    } else {
	      if (phoneType === appTypes.PhoneType.ALLBLACK) {
	        _$.css({ backgroundColor: 'rgba(0,0,0,0.5)' });
	      } else {
	        _$.css({ backgroundColor: '#fff' });
	      }
	    }
	
	    if (fullScreen) {
	      _$ = $(ReactDOM.findDOMNode(this.refs.statusBar));
	      _$.css({ display: 'none' });
	      _$ = $(ReactDOM.findDOMNode(this.refs.bg));
	      _$.css({ display: 'none' });
	      showBottom = showTop = false;
	    } else {
	      $(ReactDOM.findDOMNode(this.refs.statusBar)).css({
	        transform: 'scale(1,' + sy + ')',
	        'transform-origin': 'top',
	        display: 'block'
	      });
	      $(ReactDOM.findDOMNode(this.refs.bg)).css({
	        top: bgTop,
	        height: contentRect.bottom - contentRect.top - 20 * sy,
	        display: 'block'
	      });
	      showTop = phoneType === appTypes.PhoneType.TOPONLY || phoneType === appTypes.PhoneType.TOPANDBOTTOM;
	      showBottom = phoneType === appTypes.PhoneType.TOPANDBOTTOM;
	    }
	    $(ReactDOM.findDOMNode(this.refs.top)).css({ display: showTop ? 'block' : 'none', height: 40 * sy });
	    $(ReactDOM.findDOMNode(this.refs.bottom)).css({ display: showBottom ? 'block' : 'none', height: 40 * sy });
	  }
	});
	
	module.exports = AndroidPhone;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var dataHelper = __webpack_require__(113);
	var envHelper = __webpack_require__(48);
	var ColorImage = __webpack_require__(234);
	var GlobalConst = __webpack_require__(164);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 安卓状态栏
	 */
	var AndroidStatusBar = React.createClass({
	  displayName: 'AndroidStatusBar',
	
	  render: function render() {
	    var bgColor = styleHelper.getBackgroundColor(this.props);
	    var isLightColor = dataHelper.isLightColor(bgColor);
	    var color = styleHelper.getPropertyValue(this.props, 'ForegroundColor'); // this.props.ForegroundColor;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    if (this.props.IsAutoTextColor) {
	      if (isLightColor) {
	        color = GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK;
	      } else {
	        color = GlobalConst.GLOBAL_COLOR.SYSTEM_WHITE;
	      }
	    }
	    if (envHelper.isWxMiniApp() && this.props.x <= 3 && this.props.y <= 3) {
	      return React.createElement('div', { style: { width: w, height: h, backgroundColor: bgColor } });
	    }
	    return React.createElement(
	      'div',
	      { className: 'android-status-bar-content', key: this.props.controlID, style: {
	          backgroundColor: bgColor,
	          width: '100%',
	          height: '100%'
	        } },
	      React.createElement(ColorImage, _extends({
	        src: assetsHelper.getComponentAsset('StatusBar(Android)'),
	        height: 20,
	        width: '100%',
	        color: color,
	        gridRect: {
	          left: 1,
	          right: 220
	        }
	      }, {
	        style: {
	          width: '100%',
	          height: 20,
	          position: 'absolute',
	          top: (styleHelper.getHeight(this.props) - 20) / 2
	        } }))
	    );
	  }
	});
	
	module.exports = AndroidStatusBar;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	
	/**
	 * IPad
	 */
	var IPad = React.createClass({
	  displayName: 'IPad',
	
	
	  render: function render() {
	    var move;
	    var isVerticalScreen = this.props.direction === appTypes.Direction.VERTICAL;
	    var size = styleHelper.getSize(this.props);
	    var r = util.Rect.create(34, 53, 472, 582);
	    var ms = util.Size.create(537, 702);
	    if (!isVerticalScreen) {
	      util.Rect.overturn(r);
	      util.Size.overturn(ms);
	    }
	    var sw = size.width / ms.width;
	    var sh = size.height / ms.height;
	    util.Rect.scale(r, sw, sh);
	    util.Rect.inflate(r, 5, 5);
	
	    var imgStyle = {
	      width: isVerticalScreen ? size.width : size.height,
	      height: isVerticalScreen ? size.height : size.width,
	      position: 'absolute',
	      pointerEvents: 'none',
	      zIndex: 1
	    };
	
	    var bgStyle = {
	      width: r.width,
	      height: r.height,
	      top: r.top,
	      left: r.left,
	      position: 'absolute',
	      zIndex: 0,
	      backgroundColor: styleHelper.getBackgroundColor(this.props)
	    };
	    if (!isVerticalScreen) {
	      move = (size.width - size.height) / 2;
	      imgStyle.transform = 'rotate(270deg) translate(' + move + 'px,' + move + 'px)';
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'component' },
	      React.createElement('div', { style: bgStyle }),
	      React.createElement('img', { src: assetsHelper.getComponentAsset('ipad'),
	        style: imgStyle
	      })
	    );
	  }
	
	});
	
	module.exports = IPad;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	
	/**
	 * 平板
	 */
	var TabletPC = React.createClass({
	  displayName: 'TabletPC',
	
	
	  render: function render() {
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var move;
	    var isVerticalScreen = this.props.direction === appTypes.Direction.VERTICAL;
	
	    var size = styleHelper.getSize(this.props);
	    var r = util.Rect.create(33, 35, 472, 602);
	    var ms = util.Size.create(537, 702);
	    if (!isVerticalScreen) {
	      util.Rect.overturn(r);
	      util.Size.overturn(ms);
	    }
	    var sw = size.width / ms.width;
	    var sh = size.height / ms.height;
	    util.Rect.scale(r, sw, sh);
	    util.Rect.inflate(r, 5, 5);
	
	    var imgStyle = {
	      width: isVerticalScreen ? w : h,
	      height: isVerticalScreen ? h : w,
	      position: 'absolute',
	      pointerEvents: 'none',
	      zIndex: 1
	    };
	
	    var bgStyle = {
	      width: r.width,
	      height: r.height,
	      top: r.top,
	      left: r.left,
	      position: 'absolute',
	      zIndex: 0,
	      backgroundColor: styleHelper.getBackgroundColor(this.props)
	    };
	
	    if (!isVerticalScreen) {
	      move = (w - h) / 2;
	      imgStyle.transform = 'rotate(270deg) translate(' + move + 'px,' + move + 'px)';
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'component' },
	      React.createElement('div', { style: bgStyle }),
	      React.createElement('img', { src: assetsHelper.getComponentAsset('TabletPC'),
	        style: imgStyle
	      })
	    );
	  }
	
	});
	
	module.exports = TabletPC;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	
	/// Wifi图标路
	var WIFI = 'M236,178.973l2.09,2.128l2.09-2.128c-0.535-0.545-1.273-0.882-2.09-0.882S236.535,178.428,236,178.973z ' + 'M234,176.936l1.045,1.063c0.78-0.794,1.857-1.287,3.045-1.287s2.265,0.492,3.045,1.287l1.045-1.063' + ' c-1.048-1.067-2.494-1.729-4.09-1.729S235.048,175.869,234,176.936z ' + 'M238.09,172.104c-2.436,0-4.644,1.009-6.243,2.638l1.045,1.064 c1.331-1.357,3.171-2.197,5.198-2.197' + 's3.867,0.84,5.198,2.197l1.044-1.064C242.733,173.114,240.525,172.104,238.09,172.104z';
	
	/// 安卓Home键路
	var ANDROID_HOME = 'M312.892,857.672h-14.318c-1.368,0-2.481-1.111-2.481-2.48v-2.992c0-0.266,0.105-0.52,0.293-0.707 ' + 's0.442-0.293,0.707-0.293h0.001l17.28,0.02c0.552,0,0.999,0.447,0.999,1v2.973C315.372,856.561,314.26,857.672,312.892,857.672z ' + 'M298.092,853.201v1.99c0,0.266,0.216,0.48,0.481,0.48h14.318c0.265,0,0.48-0.215,0.48-0.48v-1.975L298.092,853.201z ' + 'M317.828,850.066L317.828,850.066l-23.698-0.01c-0.448,0-0.842-0.299-0.963-0.73s0.061-0.891,0.443-1.125l11.355-6.91 ' + 'c0.307-0.186,0.692-0.195,1.009-0.018l12.343,6.92c0.396,0.223,0.594,0.686,0.479,1.125 C318.681,849.76,318.283,850.066,317.828,850.066z ' + 'M297.694,848.059l16.303,0.006l-8.491-4.76L297.694,848.059z';
	
	var ANDROID_HOME_WIDTH = 27;
	var ANDROID_HOME_HEIGHT = 17;
	
	/// 安卓菜单键路
	var MENU = 'M193.238,843.354h-17.992c-0.553,0-1-0.447-1-1s0.447-1,1-1h17.992c0.553,0,1,0.447,1,1 S193.791,843.354,193.238,843.354z' + 'M193.238,848.082h-17.992c-0.553,0-1-0.447-1-1s0.447-1,1-1h17.992c0.553,0,1,0.447,1,1 S193.791,848.082,193.238,848.082z' + 'M193.238,853.117h-17.992c-0.553,0-1-0.447-1-1s0.447-1,1-1h17.992c0.553,0,1,0.447,1,1 S193.791,853.117,193.238,853.117z';
	
	var MENU_WIDTH = 20;
	var MENU_HEIGHT = 12;
	
	/// 安卓返回键路
	var BACK = 'M423.395,851.301c-0.219,0-0.439-0.072-0.624-0.219l-4.938-3.949c-0.237-0.191-0.375-0.479-0.375-0.781 ' + 'c0-0.305,0.138-0.592,0.375-0.781l4.938-3.949c0.433-0.346,1.061-0.273,1.406,0.156c0.345,0.432,0.274,1.063-0.156,1.406 ' + 'l-3.961,3.168l3.961,3.168c0.431,0.346,0.501,0.975,0.156,1.406C423.979,851.172,423.688,851.301,423.395,851.301z' + 'M432.282,856.729h-11.355c-0.553,0-1-0.447-1-1s0.447-1,1-1h11.355c2.035,0,3.69-1.654,3.69-3.689 c0-2.033-1.655-3.688-3.69-3.688h-11.355' + 'c-0.553,0-1-0.447-1-1s0.447-1,1-1h11.355c3.138,0,5.69,2.551,5.69,5.688 S435.42,856.729,432.282,856.729z';
	
	var BACK_WIDTH = 21;
	var BACK_HEIGHT = 16;
	
	/// 安卓电量图标路
	var ANDROID_BETTERY = 'M427.214,167.796h-1.1 c0.003-0.019,0.012-0.035,0.012-0.055c0-0.387-0.313-0.7-0.699-0.7h-1.646c-0.387,0-0.699,0.313-0.699,0.7 ' + 'c0,0.02,0.009,0.036,0.011,0.055h-0.958c-0.576,0-1.044,0.467-1.044,1.044v6.945c0,0.577,0.468,1.044,1.044,1.044h5.08 ' + 'c0.576,0,1.044-0.468,1.044-1.044v-6.945C428.258,168.264,427.79,167.796,427.214,167.796z';
	
	/// IOS默认尺寸下外壳圆角
	var IPHONE_RADIUS = 45; //60;
	
	/// IOS默认尺寸下屏幕左边界
	var IPHONE_BORDER_LEFT = 20;
	
	/// IOS默认尺寸下屏幕上边界
	var IPHONE_BORDER_TOP = 83;
	
	/// IOS默认尺寸下屏幕右边界
	var IPHONE_BORDER_RIGHT = 20;
	
	/// IOS默认尺寸下屏幕下边界
	var IPHONE_BORDER_BOTTOM = 83;
	
	/// IOS默认宽度
	var IPHONE_DEFAULT_WIDTH = 340; //425;
	
	/// IOS默认高度
	var IPHONE_DEFAULT_HEIGHT = 702; //876;
	
	/// IOS默认尺寸下Home键尺寸
	var IPHONE_BUTTONS_SIZE = 45; //55;
	
	/// IOS默认尺寸下听筒高度
	var IPHONE_HORM_HEIGHT = 6; //4
	
	/// IOS默认尺寸下Mic尺寸
	var IPHONE_MIC_SIZE = 6; //4
	
	/// IOS默认尺寸下摄像头尺寸
	var IPHONE_CAMERA_SIZE = 12; //6
	
	/// IOS默认尺寸摄像头与听筒间距
	var IPHONE_CAMERA_OFFSET = 27;
	
	/// IOS默认尺寸下Mic与听筒间距
	var IPHONE_MIC_OFFSET = 15;
	
	/// IOS默认尺寸下高亮边框与整体的间距
	var IPHONE_MARGIN = 0; //4;
	
	/// Android默认宽度
	var ANDROID_DEFAULT_WIDTH = 344; //420;
	
	/// Android默认高度
	var ANDROID_DEFAULT_HEIGHT = 702; //822;
	
	/// Android默认尺寸下屏幕左边框
	var ANDROID_BORDER_LEFT = 18;
	
	/// Android默认尺寸下屏幕右边框
	var ANDROID_BORDER_RIGHT = 18;
	
	/// Android默认尺寸下屏幕上边框
	var ANDROID_BORDER_TOP = 63;
	
	/// Android默认尺寸下屏幕下边框
	var ANDROID_BORDER_BOTTOM = 90;
	
	/// Android默认尺寸下听筒高度
	var ANDROID_HORM_HEIGHT = 6; //4
	
	/// Android默认尺寸下听筒高度
	var ANDROID_HORM_WIDTH = 64;
	
	/// Android默认尺寸下摄像头与听筒间距
	var ANDROID_CAMERA_OFFSET = 82;
	
	/// Android默认尺寸下导航栏高度
	var ANDROID_BUTTONS_HEIGHT = 15;
	
	/// Android默认尺寸下导航栏宽度
	var ANDROID_BUTTONS_WIDTH = 225;
	
	/// IPad默认宽度
	var IPAD_DEFAULT_WIDTH = 491; //884;
	
	/// IPad默认高度
	var IPAD_DEFAULT_HEIGHT = 702; //1264;
	
	/// IPad默认尺寸下屏幕上边距
	var IPAD_BORDER_TOP = 67;
	
	/// IPad默认尺寸下屏幕左边距
	var IPAD_BORDER_LEFT = 32;
	
	/// IPad默认尺寸下屏幕右边距
	var IPAD_BORDER_RIGHT = 32;
	
	/// IPad默认尺寸下屏幕下边距
	var IPAD_BORDER_BOTTOM = 67;
	
	/// IPad默认尺寸下Home键尺寸
	var IPAD_BUTTONS_SIZE = 45; //33
	
	/// IPad默认尺寸下摄像头尺寸
	var IPAD_CAMERA_SIZE = 8; //8
	
	/// 平板默认宽度
	var TABLET_DEFAULT_WIDTH = 521; //941;
	
	/// 平板默认高度
	var TABLET_DEFAULT_HEIGHT = 702; //1267;
	
	/// 平板默认尺寸下屏幕左边距
	var TABLET_BORDER_LEFT = 35; //61;
	
	/// 平板默认尺寸下屏幕上边距
	var TABLET_BORDER_TOP = 58; //105;
	
	/// 平板默认尺寸下屏幕下边距
	var TABLET_BORDER_BOTTOM = 68; //120;
	
	/// 平板默认尺寸下屏幕右边距
	var TABLET_BORDER_RIGHT = 35; //61;
	
	/// 平板默认尺寸下听筒高度
	var TABLET_HORM_HEIGHT = 6;
	
	/// 平板默认尺寸下听筒宽度
	var TABLET_HORM_WIDTH = 50;
	
	/// 平板默认尺寸下摄像头与听筒间距
	var TABLET_CAMERA_OFFSET = 155;
	
	/// 平板默认尺寸下导航栏高度
	var TABLET_BUTTONS_HEIGHT = 25;
	
	/// 平板默认尺寸下导航栏宽度
	var TABLET_BUTTOMS_WIDTH = 380;
	
	function getDefaultSize(shellType) {
	  switch (shellType) {
	    case 'IPhone2':
	      return {
	        width: IPHONE_DEFAULT_WIDTH,
	        height: IPHONE_DEFAULT_HEIGHT
	      };
	    case 'Android':
	      return {
	        width: ANDROID_DEFAULT_WIDTH,
	        height: ANDROID_DEFAULT_HEIGHT
	      };
	    case 'IPad2':
	      return {
	        width: IPAD_DEFAULT_WIDTH,
	        height: IPAD_DEFAULT_HEIGHT
	      };
	    case 'TabletPC2':
	      return {
	        width: TABLET_DEFAULT_WIDTH,
	        height: TABLET_DEFAULT_HEIGHT
	      };
	  }
	}
	
	function getDefaultBorderMargin(shellType) {
	  switch (shellType) {
	    case 'IPhone2':
	      return {
	        left: IPHONE_BORDER_LEFT,
	        top: IPHONE_BORDER_TOP,
	        right: IPHONE_BORDER_RIGHT,
	        bottom: IPHONE_BORDER_BOTTOM
	      };
	    case 'Android':
	      return {
	        left: ANDROID_BORDER_LEFT,
	        top: ANDROID_BORDER_TOP,
	        right: ANDROID_BORDER_RIGHT,
	        bottom: ANDROID_BORDER_BOTTOM
	      };
	    case 'IPad2':
	      return {
	        left: IPAD_BORDER_LEFT,
	        top: IPAD_BORDER_TOP,
	        right: IPAD_BORDER_RIGHT,
	        bottom: IPAD_BORDER_BOTTOM
	      };
	    case 'TabletPC2':
	      return {
	        left: TABLET_BORDER_LEFT,
	        top: TABLET_BORDER_TOP,
	        right: TABLET_BORDER_RIGHT,
	        bottom: TABLET_BORDER_BOTTOM
	      };
	  }
	}
	
	function calculateNormalScale(scaleX, scaleY) {
	  return Math.min(1, scaleX, scaleY);
	}
	
	/**
	 * 计算内容区域
	 * @param info
	 * @returns {{left: *, top: *, right: *, bottom: *}}
	 */
	function calculateContentRect(info) {
	  var lScaleX, lScaleY, lRect;
	  var L, T, R, B;
	  lScaleX = Math.min(info.scaleX, 1);
	  lScaleY = Math.min(info.scaleY, 1);
	  lRect = getDefaultBorderMargin(info.shellType); // TODO: set shell type
	  if (info.direction === 'SmVert') {
	    L = lRect.left * lScaleX;
	    T = lRect.top * lScaleY;
	    R = info.width - L;
	    B = info.height - lRect.bottom * lScaleX;
	  } else {
	    L = lRect.top * lScaleX;
	    T = lRect.left * lScaleX;
	    R = info.width - lRect.bottom * lScaleX;
	    B = info.height - T;
	  }
	  // TODO: RoundRect
	  return {
	    left: L,
	    top: T,
	    right: R,
	    bottom: B,
	    width: R - L,
	    height: B - T
	  };
	}
	var NewPhone = React.createClass({
	  displayName: 'NewPhone',
	
	  render: function render() {
	    var controlType = this.props.controlTypeID;
	    var width = this.props.w;
	    var height = this.props.h;
	    var defaultSize = getDefaultSize(controlType);
	    var scaleX, scaleY;
	    if (this.isVertical()) {
	      scaleX = width / defaultSize.width;
	      scaleY = height / defaultSize.height;
	    } else {
	      scaleX = height / defaultSize.width;
	      scaleY = width / defaultSize.height;
	    }
	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'svg',
	        { width: width, height: height, viewBox: "0 0 " + width + " " + height },
	        this.renderShellBorder(scaleX, scaleY),
	        this.renderComponents(scaleX, scaleY)
	      ),
	      this.props.fullScreen || this.renderStatusBar(scaleX, scaleY)
	    );
	  },
	  renderShellBorder: function renderShellBorder(scaleX, scaleY) {
	    var width = ~~this.props.w;
	    var height = ~~this.props.h;
	    var normalScale = calculateNormalScale(scaleX, scaleY);
	
	    var radius = normalScale * IPHONE_RADIUS;
	
	    var screenRect = calculateContentRect({
	      shellType: this.props.controlTypeID,
	      width: width,
	      height: height,
	      scaleX: scaleX,
	      scaleY: scaleY,
	      direction: this.props.direction
	    });
	    this.screenRect = screenRect; // 这里设置了屏幕区域
	    // FIXME: 中间屏幕区域的透明还没有处理
	    /*试图区域透明控制*/
	    var fillOpcity;
	    var isTransparent = this.props.isTransparent;
	    if (isTransparent) {
	      fillOpcity = 0;
	    }
	
	    return React.createElement(
	      'g',
	      null,
	      React.createElement(
	        'defs',
	        null,
	        this.props.controlTypeID == 'IPhone2' && React.createElement(
	          'clipPath',
	          { id: 'viewArea' },
	          React.createElement('rect', { x: '0', y: '0', width: '100%', height: screenRect.top }),
	          React.createElement('rect', { x: '0', y: screenRect.top + screenRect.bottom - screenRect.top, width: '100%',
	            height: height - screenRect.bottom }),
	          React.createElement('rect', { x: '0', y: '0', width: screenRect.left, height: '100%' }),
	          React.createElement('rect', { x: screenRect.right, y: '0', width: screenRect.left, height: '100%' })
	        ),
	        this.props.controlTypeID == 'Android' && React.createElement(
	          'clipPath',
	          { id: 'viewArea' },
	          React.createElement('rect', { x: '0', y: '0', width: '100%', height: screenRect.top }),
	          React.createElement('rect', { x: '0', y: screenRect.top + screenRect.bottom - screenRect.top, width: '100%',
	            height: height - screenRect.bottom }),
	          React.createElement('rect', { x: '0', y: '0', width: screenRect.left, height: '100%' }),
	          React.createElement('rect', { x: screenRect.right, y: '0', width: screenRect.left, height: '100%' })
	        )
	      ),
	      React.createElement('rect', { x: '0', y: '0',
	        width: width,
	        height: height,
	        rx: radius,
	        ry: radius,
	        fill: this.props.color,
	        strokeWidth: 1,
	        stroke: styleHelper.getBorderColor(this.props) }),
	      React.createElement('rect', { x: screenRect.left,
	        y: screenRect.top,
	        width: screenRect.right - screenRect.left,
	        height: screenRect.bottom - screenRect.top,
	        fill: '#FFF',
	        fillOpacity: fillOpcity,
	        strokeWidth: 1,
	        stroke: styleHelper.getBorderColor(this.props)
	      })
	    );
	  },
	  renderComponents: function renderComponents(scaleX, scaleY) {
	    switch (this.props.controlTypeID) {
	      case 'IPhone2':
	        return this.renderIPhoneComponents(scaleX, scaleY);
	      case 'Android':
	        return this.renderAndroidPhone(scaleX, scaleY);
	      case 'IPad2':
	        return this.renderIpadComponent(scaleX, scaleY);
	      case 'TabletPC2':
	        return this.renderTablePCComponent(scaleX, scaleY);
	    }
	  },
	  renderStatusBar: function renderStatusBar(scaleX, scaleY) {
	    switch (this.props.controlTypeID) {
	      case 'IPhone2':
	        return this.renderIPhoneStatusBar(scaleX, scaleY);
	    }
	  },
	
	  renderIPhoneStatusBar: function renderIPhoneStatusBar(scaleX, scaleY) {
	    var defaultWidth = 320;
	    var defaultHeight = 22;
	    var style = {
	      position: 'absolute',
	      top: this.screenRect.top,
	      left: this.screenRect.left
	    };
	    var batteryOffset = this.screenRect.width - defaultWidth; // 电池信息横向位移
	    if (this.screenRect.width <= 260) {
	      var statusBarScaleY = this.screenRect.width / defaultWidth;
	      style.transform = 'scaleY(' + statusBarScaleY + ')';
	      style.top = style.top - defaultHeight * (1 - statusBarScaleY);
	    }
	    return React.createElement(
	      'svg',
	      { width: this.screenRect.width, height: 22, style: style },
	      React.createElement('rect', {
	        x: '0',
	        y: '0',
	        height: '22',
	        width: '100%',
	        fill: '#000'
	      }),
	      React.createElement('circle', {
	        cx: '6',
	        cy: '50%',
	        r: '3',
	        fill: '#FFF',
	        stroke: '#FFF'
	      }),
	      React.createElement('circle', {
	        cx: '15',
	        cy: '50%',
	        r: '3',
	        fill: '#FFF',
	        stroke: '#FFF'
	      }),
	      React.createElement('circle', {
	        cx: '24',
	        cy: '50%',
	        r: '3',
	        fill: '#FFF',
	        stroke: '#FFF'
	      }),
	      React.createElement('circle', {
	        cx: '33',
	        cy: '50%',
	        r: '3',
	        fill: '#000',
	        stroke: '#FFF'
	      }),
	      React.createElement('circle', {
	        cx: '42',
	        cy: '50%',
	        r: '3',
	        fill: '#000',
	        stroke: '#FFF'
	      }),
	      React.createElement(
	        'text',
	        {
	          x: '52',
	          y: '16',
	          fill: '#FFF',
	          fontSize: '12',
	          transform: 'scale(1)' },
	        'Mockplus'
	      ),
	      React.createElement(
	        'text',
	        {
	          x: '50%',
	          y: '16',
	          fill: '#FFF',
	          textAnchor: 'middle',
	          fontSize: '12' },
	        '12:00AM'
	      ),
	      React.createElement(
	        'text',
	        {
	          x: 250 + batteryOffset,
	          y: '16',
	          fill: '#FFF',
	          fontSize: '12' },
	        '100%'
	      ),
	      React.createElement('rect', {
	        x: 286 + batteryOffset,
	        y: '6',
	        width: '24',
	        height: '11',
	        fill: '#000',
	        strokeWidth: '2',
	        stroke: '#FFF'
	      }),
	      React.createElement('rect', {
	        x: 288 + batteryOffset,
	        y: '9',
	        width: '20',
	        height: '5',
	        fill: '#FFF'
	      }),
	      React.createElement('rect', {
	        x: 310 + batteryOffset,
	        y: '10',
	        width: '4',
	        height: '4',
	        fill: '#FFF'
	      })
	    );
	  },
	
	  renderIPhoneComponents: function renderIPhoneComponents(scaleX, scaleY) {
	    var lScale = calculateNormalScale(scaleX, scaleY);
	    var width = ~~this.props.w;
	    var height = ~~this.props.h;
	
	    var homeButtonX, homeButtonY;
	    var homeButtonSize = IPHONE_BUTTONS_SIZE * lScale; // home 键大小
	
	    var receiverWidth, receiverHeight, receiverX, receiverY, receiverRadius;
	    var cameraX, cameraY;
	
	    var offset;
	
	    var cameraRadius = IPHONE_CAMERA_SIZE * lScale / 2;
	    var lightRadius = IPHONE_MIC_SIZE * lScale / 2;
	    var lightX, lightY;
	
	    if (this.isVertical()) {
	      homeButtonX = (width - homeButtonSize) / 2;
	      homeButtonY = this.screenRect.bottom + (height - this.screenRect.bottom - homeButtonSize) / 2;
	
	      receiverWidth = homeButtonSize; // 听筒宽度
	      receiverHeight = IPHONE_HORM_HEIGHT * lScale;
	      receiverRadius = receiverHeight / 2;
	      receiverX = (width - receiverWidth) / 2;
	      receiverY = (this.screenRect.top - receiverHeight) / 2 + IPHONE_MARGIN * lScale;
	      offset = (IPHONE_CAMERA_SIZE - IPHONE_HORM_HEIGHT) * lScale * 0.5;
	
	      cameraX = receiverX - IPHONE_CAMERA_OFFSET * lScale + cameraRadius;
	      cameraY = receiverY - offset + cameraRadius;
	
	      lightX = (width - IPHONE_MIC_SIZE * scaleX) / 2;
	      lightY = receiverY - IPHONE_MIC_OFFSET * lScale;
	    } else {
	      homeButtonX = this.screenRect.right + (width - this.screenRect.right - homeButtonSize) / 2;
	      homeButtonY = (height - homeButtonSize) / 2;
	
	      receiverWidth = IPHONE_HORM_HEIGHT * lScale;
	      receiverHeight = homeButtonSize;
	      receiverRadius = receiverWidth / 2;
	      receiverX = (this.screenRect.left - receiverWidth) / 2 + IPHONE_MARGIN * lScale;
	      receiverY = homeButtonY;
	
	      offset = (IPHONE_CAMERA_SIZE - IPHONE_HORM_HEIGHT) * lScale * 0.5;
	
	      cameraX = receiverX - offset + cameraRadius;
	      cameraY = receiverY + homeButtonSize + IPHONE_CAMERA_OFFSET * lScale;
	
	      lightX = receiverX - IPHONE_MIC_OFFSET * lScale + lightRadius;
	      lightY = (height - IPHONE_MIC_SIZE * scaleX) / 2 + lightRadius;
	    }
	    var startLeft = 5 * lScale;
	    var circles = [];
	    var circleRadius = 6 * lScale / 2;
	    var circleY = 10;
	    var circleFillColor = '';
	    for (var i = 0; i < 5; i++) {
	      if (i < 3) {
	        // 实心
	        circleFillColor = '#FFF';
	      } else {
	        circleFillColor = '';
	      }
	      circles.push(React.createElement('circle', {
	        cx: startLeft + circleRadius,
	        cy: circleY,
	        r: circleRadius,
	        fill: circleFillColor,
	        stroke: '#FFF'
	      }));
	      startLeft = startLeft + circleRadius * 2 + 2.5;
	    }
	
	    /*状态控制*/
	    var phoneType = this.props.phoneType;
	    var phoneTypeState;
	    var isTransparent = this.props.isTransparent;
	    var fillOpacity;
	    var rectTop, rectHeight;
	    if (isTransparent) {
	      fillOpacity = 0;
	    } else {
	      fillOpacity = 1;
	    }
	    if (this.props.fullScreen) {
	      rectTop = this.screenRect.top;
	      rectHeight = this.screenRect.bottom - this.screenRect.top;
	    } else {
	      rectTop = this.screenRect.top + 20 * lScale;
	      rectHeight = this.screenRect.bottom - this.screenRect.top - 20 * lScale;
	    }
	    if (phoneType === 'PtTopOnly') {
	      phoneTypeState = React.createElement(
	        'g',
	        null,
	        React.createElement('rect', {
	          x: this.screenRect.left,
	          y: this.screenRect.top + 20 * lScale,
	          height: 40 * lScale,
	          width: width - 2 * this.screenRect.left,
	          fill: '#fff',
	          fillOpacity: fillOpacity,
	          stroke: '#000'
	        })
	      );
	    } else if (phoneType === 'PtTopAndBottom') {
	      phoneTypeState = React.createElement(
	        'g',
	        null,
	        React.createElement('rect', {
	          x: this.screenRect.left,
	          y: this.screenRect.top + 20 * lScale,
	          height: 40 * lScale,
	          width: width - 2 * this.screenRect.left,
	          fill: '#fff',
	          fillOpacity: fillOpacity,
	          stroke: '#000'
	        }),
	        React.createElement('rect', {
	          x: this.screenRect.left,
	          y: this.screenRect.top + this.screenRect.bottom - this.screenRect.top - 40 * lScale,
	          height: 40 * lScale,
	          width: width - 2 * this.screenRect.left,
	          fill: '#fff',
	          fillOpacity: fillOpacity,
	          stroke: '#000'
	        })
	      );
	    } else if (phoneType === 'PtAllBlack') {
	      phoneTypeState = React.createElement(
	        'g',
	        null,
	        React.createElement('rect', {
	          x: this.screenRect.left,
	          y: rectTop,
	          height: rectHeight,
	          width: width - 2 * this.screenRect.left,
	          fill: '#3f3f3f',
	          fillOpacity: fillOpacity
	        })
	      );
	    }
	    return React.createElement(
	      'g',
	      null,
	      React.createElement('rect', {
	        x: homeButtonX,
	        y: homeButtonY,
	        width: homeButtonSize,
	        height: homeButtonSize,
	        rx: homeButtonSize,
	        ry: homeButtonSize,
	        fill: this.props.color,
	        stroke: this.getColor(),
	        strokeWidth: 2
	      }),
	      React.createElement('rect', {
	        x: receiverX,
	        y: receiverY,
	        width: receiverWidth,
	        height: receiverHeight,
	        rx: receiverRadius,
	        ry: receiverRadius,
	        fill: this.getColor()
	      }),
	      React.createElement('circle', {
	        cx: cameraX,
	        cy: cameraY,
	        r: cameraRadius,
	        fill: this.getColor()
	      }),
	      React.createElement('circle', {
	        cx: lightX,
	        cy: lightY,
	        r: lightRadius,
	        fill: this.getColor()
	      }),
	      phoneTypeState
	    );
	  },
	
	  renderIpadComponent: function renderIpadComponent(scaleX, scaleY) {
	    var lScale = calculateNormalScale(scaleX, scaleY);
	    var width = ~~this.props.w;
	    var height = ~~this.props.h;
	    var homeButtonX, homeButtonY;
	    var homeButtonSize = IPAD_BUTTONS_SIZE * lScale; //Home 尺寸大小
	    var cameraX, cameraY;
	    var cameraRadius = IPAD_CAMERA_SIZE * lScale / 2;
	    if (this.isVertical()) {
	      homeButtonX = (width - homeButtonSize) / 2;
	      homeButtonY = this.screenRect.bottom + (height - this.screenRect.bottom - homeButtonSize) / 2;
	
	      cameraX = (width - cameraRadius) / 2;
	      cameraY = (this.screenRect.top + cameraRadius) / 2;
	    } else {
	      homeButtonX = this.screenRect.right + (width - this.screenRect.right - homeButtonSize) / 2;
	      homeButtonY = (height - homeButtonSize) / 2;
	
	      cameraX = (this.screenRect.left + cameraRadius) / 2;
	      cameraY = (height - cameraRadius) / 2;
	    }
	    return React.createElement(
	      'g',
	      null,
	      React.createElement('rect', {
	        x: homeButtonX,
	        y: homeButtonY,
	        width: homeButtonSize,
	        height: homeButtonSize,
	        rx: homeButtonSize,
	        ry: homeButtonSize,
	        fill: this.props.color,
	        stroke: this.getColor(),
	        strokeWidth: 2 * lScale
	      }),
	      React.createElement('circle', {
	        cx: cameraX,
	        cy: cameraY,
	        r: cameraRadius * lScale,
	        fill: this.getColor()
	      })
	    );
	  },
	
	
	  renderAndroidPhone: function renderAndroidPhone(scaleX, scaleY) {
	    var lScale = calculateNormalScale(scaleX, scaleY);
	
	    var lScaleX = Math.min(1, scaleX);
	    var lScaleY = Math.min(1, scaleY);
	    var normalScale = calculateNormalScale(scaleX, scaleY);
	    var width = ~~this.props.w;
	    var height = ~~this.props.h;
	
	    var receiverX, receiverY, receiverWidth, receiverHeight, receiverRadius;
	
	    var cameraX, cameraY, cameraRadius;
	
	    var rect;
	
	    var menuX, menuY, menuStyle;
	    var homeX, homeY, homeStyle;
	    var backX, backY, backStyle;
	    var buttonsY;
	
	    var L, T, B, R;
	
	    var statusBar;
	
	    if (this.isVertical()) {
	      receiverWidth = ANDROID_HORM_WIDTH * scaleX;
	      receiverHeight = ANDROID_HORM_HEIGHT * lScaleY;
	      receiverX = (width - receiverWidth) / 2;
	      receiverY = ANDROID_BORDER_TOP * lScaleY / 2 - receiverHeight;
	      receiverRadius = receiverHeight / 2;
	
	      cameraRadius = receiverHeight;
	      cameraX = receiverX + receiverWidth + ANDROID_CAMERA_OFFSET * scaleX + cameraRadius;
	      cameraY = receiverY + cameraRadius;
	
	      L = (width - ANDROID_BUTTONS_WIDTH * scaleX) / 2;
	      T = height - ANDROID_BORDER_BOTTOM * lScaleY;
	      T = T + (ANDROID_BORDER_BOTTOM - ANDROID_BUTTONS_HEIGHT) * 0.5 * lScaleY;
	      B = T + ANDROID_BUTTONS_HEIGHT * lScaleY;
	      R = width - L;
	
	      rect = {
	        left: L,
	        top: T,
	        bottom: B,
	        right: R,
	        width: R - L,
	        height: B - T
	      };
	
	      menuX = rect.left;
	      buttonsY = rect.top + (rect.height - MENU_HEIGHT) / 2;
	      menuStyle = {
	        transform: "translate(" + (-174 + menuX) + "px," + (-841 + buttonsY) + "px) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	
	      homeX = (width - ANDROID_HOME_WIDTH) / 2;
	      homeStyle = {
	        transform: "translate(" + (-293 + homeX) + "px," + (-841 + buttonsY) + "px) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	
	      backX = rect.right - BACK_WIDTH;
	      backStyle = {
	        transform: "translate(" + (-418 + backX) + "px," + (-841 + buttonsY) + "px) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	    } else {
	      receiverWidth = ANDROID_HORM_HEIGHT * lScaleY;
	      receiverHeight = ANDROID_HORM_WIDTH * lScaleX;
	      receiverX = ANDROID_BORDER_TOP * lScaleY / 2 - receiverWidth;
	      receiverY = (height - receiverHeight) / 2;
	      receiverRadius = receiverWidth / 2;
	
	      cameraRadius = receiverWidth;
	      cameraX = receiverX + cameraRadius;
	      cameraY = receiverY - ANDROID_CAMERA_OFFSET * scaleX;
	
	      T = (height - ANDROID_BUTTONS_WIDTH * scaleX) / 2;
	      L = width - ANDROID_BORDER_BOTTOM * lScaleY;
	      L = L + (ANDROID_BORDER_BOTTOM - ANDROID_BUTTONS_HEIGHT) * 0.5 * lScaleY;
	      B = height - T;
	      R = L + ANDROID_BUTTONS_HEIGHT * lScaleY;
	
	      rect = {
	        left: L,
	        top: T,
	        bottom: B,
	        right: R,
	        width: R - L,
	        height: B - T,
	        center: {
	          x: L + (R - L) / 2,
	          y: T + (B - T) / 2
	        }
	      };
	
	      backX = rect.center.x - BACK_WIDTH / 2;
	      backY = rect.top;
	      backStyle = {
	        transform: "translate(" + (-418 + backX) + "px," + (-841 + backY) + "px) rotate(270deg) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	
	      homeX = rect.center.x - ANDROID_HOME_WIDTH / 2;
	      homeY = rect.center.y - ANDROID_HOME_HEIGHT / 2;
	      homeStyle = {
	        transform: "translate(" + (-293 + homeX) + "px," + (-841 + homeY) + "px) rotate(270deg) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	
	      menuX = rect.center.x - MENU_WIDTH / 2;
	      menuY = rect.bottom - MENU_HEIGHT;
	      menuStyle = {
	        transform: "translate(" + (-174 + menuX) + "px," + (-841 + menuY) + "px) rotate(270deg) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	    }
	
	    var statusBarOffsetHeight = this.screenRect.top + 6;
	    statusBar = React.createElement(
	      'g',
	      null,
	      React.createElement('rect', {
	        x: this.screenRect.left,
	        y: this.screenRect.top,
	        width: this.screenRect.width,
	        height: 20 * normalScale,
	        fill: '#040000'
	      }),
	      React.createElement(
	        'text',
	        {
	          x: this.screenRect.right - 54 * normalScale,
	          y: this.screenRect.top + 16 * normalScale,
	          fontSize: 10 * normalScale,
	          fill: '#FFF'
	        },
	        '12:00AM'
	      ),
	      React.createElement('path', {
	        d: ANDROID_BETTERY,
	        fill: '#FFF',
	        transform: "translate(" + (-421 + this.screenRect.right - 66) + "," + (-167 + statusBarOffsetHeight) + ")"
	      }),
	      React.createElement('line', {
	        x1: this.screenRect.right - 71,
	        y1: statusBarOffsetHeight,
	        x2: this.screenRect.right - 71,
	        y2: statusBarOffsetHeight + 10,
	        stroke: '#FFF',
	        strokeWidth: 2
	      }),
	      React.createElement('line', {
	        x1: this.screenRect.right - 74,
	        y1: statusBarOffsetHeight + 3,
	        x2: this.screenRect.right - 74,
	        y2: statusBarOffsetHeight + 10,
	        stroke: '#FFF',
	        strokeWidth: 2
	      }),
	      React.createElement('line', {
	        x1: this.screenRect.right - 77,
	        y1: statusBarOffsetHeight + 6,
	        x2: this.screenRect.right - 77,
	        y2: statusBarOffsetHeight + 10,
	        stroke: '#FFF',
	        strokeWidth: 2
	      }),
	      React.createElement('line', {
	        x1: this.screenRect.right - 80,
	        y1: statusBarOffsetHeight + 8,
	        x2: this.screenRect.right - 80,
	        y2: statusBarOffsetHeight + 10,
	        stroke: '#FFF',
	        strokeWidth: 2
	      }),
	      React.createElement('path', {
	        transform: "translate(" + (-232 + this.screenRect.right - 96) + "," + (-171 + statusBarOffsetHeight) + ")",
	        d: WIFI,
	        fill: '#FFF'
	      })
	    );
	    /*状态控制*/
	    var phoneType = this.props.phoneType;
	    var phoneTypeState;
	    var isTransparent = this.props.isTransparent;
	    var fillOpacity;
	    var rectTop, rectHeight;
	    if (isTransparent) {
	      fillOpacity = 0;
	    } else {
	      fillOpacity = 1;
	    }
	    var fullScreen = this.props.fullScreen;
	    if (fullScreen) {
	      rectTop = this.screenRect.top;
	      rectHeight = this.screenRect.bottom - this.screenRect.top;
	    } else {
	      rectTop = this.screenRect.top + 20 * lScale;
	      rectHeight = this.screenRect.bottom - this.screenRect.top - 20 * lScale;
	    }
	    if (phoneType === 'PtTopOnly') {
	      phoneTypeState = React.createElement(
	        'g',
	        null,
	        React.createElement('rect', {
	          x: this.screenRect.left,
	          y: this.screenRect.top + 20 * lScale,
	          height: 40 * lScaleY,
	          width: this.screenRect.width,
	          fill: '#fff',
	          fillOpacity: fillOpacity,
	          stroke: '#000'
	        })
	      );
	    } else if (phoneType === 'PtTopAndBottom') {
	      phoneTypeState = React.createElement(
	        'g',
	        null,
	        React.createElement('rect', {
	          x: this.screenRect.left,
	          y: this.screenRect.top + 20 * lScale,
	          height: 40 * lScale,
	          width: width - 2 * this.screenRect.left,
	          fill: '#fff',
	          fillOpacity: fillOpacity,
	          stroke: '#000'
	        }),
	        React.createElement('rect', {
	          x: this.screenRect.left,
	          y: this.screenRect.top + this.screenRect.bottom - this.screenRect.top - 40 * lScale,
	          height: 40 * lScale,
	          width: width - 2 * this.screenRect.left,
	          fill: '#fff',
	          fillOpacity: fillOpacity,
	          stroke: '#000'
	        })
	      );
	    } else if (phoneType === 'PtAllBlack') {
	      phoneTypeState = React.createElement(
	        'g',
	        null,
	        React.createElement('rect', {
	          x: this.screenRect.left,
	          y: rectTop,
	          height: rectHeight,
	          width: this.screenRect.width,
	          fill: '#3f3f3f',
	          fillOpacity: fillOpacity
	        })
	      );
	    }
	
	    /*全屏控制*/
	    var fullScreen = this.props.fullScreen;
	    if (fullScreen) {
	      statusBar = null;
	    }
	    return React.createElement(
	      'g',
	      null,
	      React.createElement('rect', {
	        x: receiverX,
	        y: receiverY,
	        rx: receiverRadius,
	        ry: receiverRadius,
	        width: receiverWidth,
	        height: receiverHeight,
	        fill: this.getColor()
	      }),
	      React.createElement('circle', {
	        cx: cameraX,
	        cy: cameraY,
	        r: cameraRadius,
	        fill: this.getColor()
	      }),
	      React.createElement('path', { d: MENU,
	        style: menuStyle,
	        fill: this.getColor()
	      }),
	      React.createElement('path', { d: ANDROID_HOME,
	        style: homeStyle,
	        fill: this.getColor()
	      }),
	      React.createElement('path', { d: BACK,
	        style: backStyle,
	        fill: this.getColor()
	      }),
	      statusBar,
	      phoneTypeState
	    );
	  },
	
	  renderTablePCComponent: function renderTablePCComponent(scaleX, scaleY) {
	    var lScaleX = Math.min(1, scaleX);
	    var lScaleY = Math.min(1, scaleY);
	    var normalScale = calculateNormalScale(scaleX, scaleY);
	    var width = ~~this.props.w;
	    var height = ~~this.props.h;
	
	    var receiverX, receiverY, receiverWidth, receiverHeight, receiverRadius;
	
	    var cameraX, cameraY, cameraRadius;
	
	    var rect;
	
	    var menuX, menuY, menuStyle;
	    var homeX, homeY, homeStyle;
	    var backX, backY, backStyle;
	
	    var L, T, B, R;
	
	    if (this.isVertical()) {
	      receiverWidth = TABLET_HORM_WIDTH * scaleX;
	      receiverHeight = TABLET_HORM_HEIGHT * lScaleY;
	      receiverX = (width - receiverWidth) / 2;
	      receiverY = TABLET_BORDER_TOP * lScaleY / 2 - receiverHeight;
	      receiverRadius = receiverHeight / 2;
	
	      cameraRadius = receiverHeight;
	      cameraX = receiverX + receiverWidth + TABLET_CAMERA_OFFSET * scaleX + cameraRadius;
	      cameraY = receiverY + cameraRadius;
	
	      L = (width - TABLET_BUTTOMS_WIDTH * scaleX) / 2;
	      T = height - TABLET_BORDER_BOTTOM * lScaleY;
	      T = T + (TABLET_BORDER_BOTTOM - TABLET_BUTTONS_HEIGHT) * 0.5 * lScaleY;
	      B = T + TABLET_BUTTONS_HEIGHT * lScaleY;
	      R = width - L;
	
	      rect = {
	        left: L,
	        top: T,
	        bottom: B,
	        right: R,
	        width: R - L,
	        height: B - T
	      };
	
	      menuX = rect.left;
	      menuY = rect.top + (rect.height - MENU_HEIGHT) / 2;
	      menuStyle = {
	        transform: "translate(" + (-174 + menuX) + "px," + (-841 + menuY) + "px) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	
	      homeX = (width - ANDROID_HOME_WIDTH) / 2;
	      homeY = rect.top + (rect.height - ANDROID_HOME_HEIGHT) / 2;
	      homeStyle = {
	        transform: "translate(" + (-293 + homeX) + "px," + (-841 + menuY) + "px) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	
	      backX = rect.right - BACK_WIDTH;
	      backY = rect.top + (rect.height - BACK_HEIGHT);
	      backStyle = {
	        transform: "translate(" + (-418 + backX) + "px," + (-841 + menuY) + "px) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	    } else {
	      receiverWidth = TABLET_HORM_HEIGHT * lScaleY;
	      receiverHeight = TABLET_HORM_WIDTH * lScaleX;
	      receiverX = TABLET_BORDER_TOP * lScaleY / 2 - receiverWidth;
	      receiverY = (height - receiverHeight) / 2;
	      receiverRadius = receiverWidth / 2;
	      cameraRadius = receiverWidth;
	      cameraX = receiverX + cameraRadius;
	      cameraY = receiverY - TABLET_CAMERA_OFFSET * scaleX;
	
	      T = (height - TABLET_BUTTOMS_WIDTH * scaleX) / 2;
	      L = width - TABLET_BORDER_BOTTOM * lScaleY;
	      L = L + (TABLET_BORDER_BOTTOM - TABLET_BUTTONS_HEIGHT) * 0.5 * lScaleY;
	      B = height - T;
	      R = L + TABLET_BUTTONS_HEIGHT * lScaleY;
	
	      rect = {
	        left: L,
	        top: T,
	        bottom: B,
	        right: R,
	        width: R - L,
	        height: B - T,
	        center: {
	          x: L + (R - L) / 2,
	          y: T + (B - T) / 2
	        }
	      };
	
	      backX = rect.center.x - BACK_WIDTH / 2;
	      backY = rect.top;
	      backStyle = {
	        transform: "translate(" + (-418 + backX) + "px," + (-841 + backY) + "px) rotate(270deg) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	
	      homeX = rect.center.x - ANDROID_HOME_WIDTH / 2;
	      homeY = rect.center.y - ANDROID_HOME_HEIGHT / 2;
	      homeStyle = {
	        transform: "translate(" + (-293 + homeX) + "px," + (-841 + homeY) + "px) rotate(270deg) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	
	      menuX = rect.center.x - MENU_WIDTH / 2;
	      menuY = rect.bottom - MENU_HEIGHT;
	      menuStyle = {
	        transform: "translate(" + (-174 + menuX) + "px," + (-841 + menuY) + "px) rotate(270deg) scale(" + normalScale + ")",
	        transformOrigin: "center"
	      };
	    }
	
	    return React.createElement(
	      'g',
	      null,
	      React.createElement('rect', {
	        x: receiverX,
	        y: receiverY,
	        rx: receiverRadius,
	        ry: receiverRadius,
	        width: receiverWidth,
	        height: receiverHeight,
	        fill: this.getColor()
	      }),
	      React.createElement('circle', {
	        cx: cameraX,
	        cy: cameraY,
	        r: cameraRadius * scaleX,
	        fill: this.getColor()
	      }),
	      React.createElement('path', { d: MENU,
	        style: menuStyle,
	        fill: this.getColor()
	      }),
	      React.createElement('path', { d: ANDROID_HOME,
	        style: homeStyle,
	        fill: this.getColor()
	      }),
	      React.createElement('path', { d: BACK,
	        style: backStyle,
	        fill: this.getColor()
	      })
	    );
	  },
	
	
	  isVertical: function isVertical() {
	    return this.props.direction === 'SmVert';
	  },
	  getColor: function getColor() {
	    return '#808080';
	  }
	});
	
	module.exports = NewPhone;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var _ = __webpack_require__(51);
	var styleHelper = __webpack_require__(145);
	var textHelper = __webpack_require__(116).Text;
	
	var Tabs = React.createClass({
	  displayName: 'Tabs',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: parseInt(this.props.selectedIndex, 10)
	    };
	  },
	
	  render: function render() {
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var items = textHelper.delimitToWords(styleHelper.getText(this.props));
	    var itemW = w / items.length;
	    var indicatorHeight;
	    var indicatorWidth;
	    var dividerPercentHeight;
	    var dividerColor;
	    var dividerTop;
	    var indicatorTop;
	    var indicatorLeft;
	
	    var style = {
	      borderColor: this.props.borderColor,
	      borderWidth: styleHelper.getBorderWidth(this.props) || 1,
	      borderStyle: 'none',
	      borderBottomStyle: styleHelper.getBorderVisible(this.props) ? 'solid' : 'none',
	      textAlign: 'center',
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      position: 'relative'
	    };
	    var dividerStyle;
	    var indicatorStyle;
	    var textStyle;
	    var margin = 0;
	    var left;
	    var tempStyle;
	
	    style = styleHelper.StyleUtil(this.props).size().background().text().default(style).style;
	    style.borderColor = _.isUndefined(this.props.indicatorHeight) ? '#000' : style.borderColor;
	    indicatorHeight = this.props.indicatorHeight || 6;
	    indicatorWidth = _.isUndefined(this.props.indicatorPercentWidth) ? itemW : itemW * this.props.indicatorPercentWidth * 0.01;
	    dividerPercentHeight = _.isUndefined(this.props.dividerPercentHeight) ? h * 0.6 : h * this.props.dividerPercentHeight * 0.01;
	    dividerColor = _.isUndefined(this.props.dividerColor) ? '#000' : this.props.dividerColor;
	    dividerTop = (h - dividerPercentHeight) / 2;
	    indicatorTop = h - indicatorHeight;
	    dividerStyle = {
	      width: itemW,
	      height: dividerPercentHeight,
	      top: dividerTop,
	      borderStyle: 'none',
	      boxSizing: 'border-box',
	      borderLeftStyle: 'solid',
	      borderWidth: 1,
	      borderColor: dividerColor,
	      position: 'absolute',
	      pointerEvents: 'none'
	    };
	    indicatorStyle = {
	      position: 'absolute',
	      left: "50%",
	      top: indicatorTop,
	      transform: 'translateX(-50%)',
	      width: indicatorWidth,
	      height: indicatorHeight,
	      border: 'none',
	      backgroundColor: this.props.selectedColor,
	      pointerEvents: 'none',
	      zIndex: -1
	    };
	    textStyle = {
	      width: itemW - margin * 2,
	      height: '100%',
	      position: 'absolute',
	      top: 0,
	      lineHeight: h + 'px',
	      overflow: 'hidden'
	    };
	
	    return React.createElement(
	      'div',
	      { className: 'component contents-layout content', style: style },
	      items.map(function (tx, index) {
	        var isSelected = index === this.state.selectedIndex;
	        left = itemW * index;
	        tempStyle = _.extend({}, textStyle);
	        tempStyle.left = left + margin;
	        tempStyle.zIndex = index + 1;
	        tempStyle.overflow = 'visible';
	        if (isSelected) {
	          tempStyle.color = styleHelper.getSelectedTextColor(this.props);
	        }
	        return React.createElement(
	          'div',
	          { key: index, style: tempStyle, onClick: this.onItemClick.bind(this, null, index) },
	          React.createElement(
	            'label',
	            null,
	            tx
	          ),
	          isSelected && React.createElement('div', { style: indicatorStyle })
	        );
	      }, this),
	      items.map(function (tx, index) {
	        left = itemW * index;
	        tempStyle = _.extend({}, dividerStyle);
	        tempStyle.left = left;
	        if (index === 0) {
	          tempStyle.borderLeftStyle = 'none';
	        } else {
	          tempStyle.borderLeftStyle = 'solid';
	        }
	        return React.createElement('div', { key: index, style: tempStyle });
	      }, this)
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
	  },
	
	  onItemClick: function onItemClick(e, index) {
	    this.setState({ selectedIndex: index });
	  }
	
	});
	
	module.exports = Tabs;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Border = __webpack_require__(168);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	
	/*
	 * 按钮栏组件
	 */
	
	var ButtonBarItem = React.createClass({
	  displayName: 'ButtonBarItem',
	
	  propTypes: {
	    onClickEvent: React.PropTypes.func.isRequired,
	    width: React.PropTypes.number,
	    left: React.PropTypes.number,
	    text: React.PropTypes.string,
	    backgroundColor: React.PropTypes.string,
	    borderColor: React.PropTypes.string
	  },
	
	  render: function render() {
	    var backgroundStyle;
	
	    backgroundStyle = {
	      position: 'absolute',
	      left: this.props.left,
	      width: this.props.width,
	      height: this.props.height,
	      borderColor: this.props.borderColor,
	      borderWidth: this.props.borderWidth,
	      borderStyle: 'none',
	      borderLeftStyle: this.props.borderVisible ? 'solid' : 'none',
	      backgroundColor: this.props.backgroundColor,
	      color: this.props.color,
	      textAlign: 'center',
	      textDecoration: 'inherit',
	      lineHeight: this.props.height + 'px',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    };
	    backgroundStyle.borderRightStyle = backgroundStyle.borderLeftStyle;
	
	    return React.createElement(
	      'div',
	      {
	        style: backgroundStyle,
	        onClick: this._onSelfClick,
	        onMouseOver: this._onMouseOver.bind(this, this.props.index),
	        onMouseOut: this._onMouseOut.bind(this, this.props.index) },
	      React.createElement(
	        'label',
	        null,
	        this.props.text
	      )
	    );
	  },
	
	  _onSelfClick: function _onSelfClick(e) {
	    if (this.props.onClickEvent) {
	      this.props.onClickEvent(e, this.props.index);
	    }
	  },
	  _onMouseOver: function _onMouseOver(index) {
	    if (this.props.onMouseOver) {
	      this.props.onMouseOver(index);
	    }
	  },
	  _onMouseOut: function _onMouseOut(index) {
	    if (this.props.onMouseOut) {
	      this.props.onMouseOut(index);
	    }
	  }
	});
	
	var ButtonBar = React.createClass({
	  displayName: 'ButtonBar',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: this.props.selectedIndex
	    };
	  },
	
	  render: function render() {
	    var selfWidth = styleHelper.getWidth(this.props);
	    var borderVisible = styleHelper.getPropertyValue(this.props, 'borderVisible');
	    var borderWidth = styleHelper.getBorderWidth(this.props);
	    var textArray = util.Text.delimitText(styleHelper.getText(this.props), util.Text.DM_COMMA);
	    var itemWidth = textArray.length !== 0 ? selfWidth / textArray.length : 0;
	    var style;
	    var left = 0;
	    var w;
	    if (textArray.length) {
	      if (borderVisible) {
	        itemWidth = (selfWidth + borderWidth * (textArray.length - 1)) / textArray.length;
	        w = itemWidth - borderWidth * 2;
	      } else {
	        itemWidth = selfWidth / textArray.length;
	        w = itemWidth;
	      }
	    } else {
	      itemWidth = 0;
	    }
	
	    style = styleHelper.StyleUtil(this.props).size().background().border().text().style;
	    style.boxSizing = 'border-box';
	
	    styleHelper.shrinkageWordSpacing(style);
	    return React.createElement(
	      'div',
	      { style: style },
	      textArray.map(function (text, index) {
	        text = text.trim();
	        if (index) {
	          if (borderVisible) {
	            left += itemWidth - styleHelper.getBorderWidth(this.props);
	          } else {
	            left += itemWidth;
	          }
	        }
	        return React.createElement(ButtonBarItem, {
	          key: index,
	          text: text,
	          width: w,
	          height: styleHelper.getHeight(this.props) - (borderVisible ? this.props.thickness * 2 : 0),
	          left: left,
	          index: index,
	          color: index === this.state.selectedIndex ? styleHelper.getSelectedTextColor(this.props) : styleHelper.getTextColor(this.props),
	          borderVisible: styleHelper.getPropertyValue(this.props, 'borderVisible'),
	          borderColor: styleHelper.getPropertyValue(this.props, 'borderColor'),
	          borderWidth: styleHelper.getBorderWidth(this.props),
	          backgroundColor: index === this.state.selectedIndex ? this.props.selectedColor : this.props.showHover && index === this.state.hoverIndex ? this.props.hoveredColor : styleHelper.getBackgroundColor(this.props),
	          onClickEvent: this.onItemClick,
	          onMouseOver: this.onItemMouseOver,
	          onMouseOut: this.onItemMouseOut
	        });
	      }, this)
	    );
	  },
	
	  onItemClick: function onItemClick(e, index) {
	    this.setState({ selectedIndex: index });
	  },
	
	  onItemMouseOver: function onItemMouseOver(index) {
	    if (this.props.showHover) {
	      this.setState({ hoverIndex: index });
	    }
	  },
	
	  onItemMouseOut: function onItemMouseOut() {
	    this.setState({ hoverIndex: -1 });
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
	  }
	
	});
	
	module.exports = ButtonBar;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var appTypes = __webpack_require__(115);
	var assetsHelper = __webpack_require__(65);
	var util = __webpack_require__(116);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 菜单组件
	 */
	
	var ToggleType = { toggleNone: 0, toggleCircle: 1, toggleMark: 2, toggleDisable: 3 };
	
	var MenuItem = React.createClass({
	  displayName: 'MenuItem',
	
	  propTypes: {
	    selected: React.PropTypes.bool.isRequired,
	    onClickEvent: React.PropTypes.func.isRequired,
	    data: React.PropTypes.object.isRequired,
	    height: React.PropTypes.number.isRequired
	  },
	
	  render: function render() {
	
	    var backgroundStyle;
	    var toggleStyle;
	    var toggleClass;
	    var itemStyle;
	    var showToggle;
	    var toggleBoundary;
	
	    /*分割线兼容控制*/
	    var backgroundColor;
	    if (this.props.showSeparator === undefined) {
	      // backgroundColor = this.props.data.separator ? '#000' : (this.props.selected && this.props.data.toggle !== ToggleType.toggleDisable ? this.props.selectedColor : undefined);
	      backgroundColor = this.props.data.separator ? '#000' : this.props.selected ? this.props.selectedColor : undefined;
	    } else if (this.props.showSeparator) {
	      backgroundColor = this.props.separatorColor;
	    } else {
	      backgroundColor = '#000';
	    }
	
	    backgroundStyle = {
	      width: '100%',
	      height: this.props.data.separator ? 1 : this.props.height,
	      lineHeight: this.props.height + 'px',
	      position: 'absolute',
	      right: this.props.data.separator ? 2 : 0,
	      color: this.props.data.toggle === ToggleType.toggleDisable ? appTypes.Color.MODEL_DISABLE : undefined,
	      left: this.props.data.separator ? 2 : 0,
	      top: this.props.top,
	      backgroundColor: backgroundColor,
	      textDecoration: 'inherit'
	    };
	
	    if (backgroundStyle.height === 1) {
	      backgroundStyle.backgroundColor = this.props.separatorColor;
	      backgroundStyle.width = '97%';
	    }
	    showToggle = this.props.data.toggle === ToggleType.toggleCircle || this.props.data.toggle === ToggleType.toggleMark;
	
	    if (this.props.data.toggle === ToggleType.toggleCircle) {
	      toggleStyle = {
	        top: (this.props.itemHeight - 10) / 2 + 'px'
	      };
	      toggleClass = 'toggle-radio';
	    } else if (this.props.data.toggle === ToggleType.toggleMark) {
	      toggleStyle = {
	        top: (this.props.itemHeight - 8) / 2 - 2 + 'px'
	      };
	      toggleClass = 'toggle-check';
	    }
	
	    return React.createElement(
	      'div',
	      { style: backgroundStyle, onClick: this.props.onClickEvent },
	      React.createElement(
	        'div',
	        { className: 'item' },
	        showToggle && React.createElement(
	          'div',
	          { className: 'toggle' },
	          React.createElement('div', { className: toggleClass, style: toggleStyle })
	        ),
	        !this.props.data.separator && React.createElement(
	          'label',
	          { className: 'menu-text' },
	          util.Text.convertSpaceToNbsp(this.props.data.content)
	        ),
	        this.props.data.shortcut && React.createElement(
	          'label',
	          { className: 'menu-short' },
	          this.props.data.shortcut
	        ),
	        this.props.data.isNotLeaf && React.createElement('img', { src: assetsHelper.getComponentAsset('commons/separator') })
	      )
	    );
	  }
	});
	
	var Menu = React.createClass({
	  displayName: 'Menu',
	
	
	  _parseTextItem: function _parseTextItem(itemText) {
	    var resultItem;
	    var tempText = itemText.trim();
	    itemText = itemText.trim();
	
	    resultItem = {
	      toggle: ToggleType.toggleNone,
	      content: '',
	      shortcut: '',
	      separator: tempText === '' || tempText.replace(/\-/g, '') === '' || tempText.replace(/=/g, '') === ''
	    };
	
	    if (resultItem.separator) return resultItem;
	
	    if (itemText.charAt(0) === '-' && itemText.charAt(itemText.length - 1) === '-') {
	      itemText = itemText.substring(1, itemText.length - 1);
	      resultItem.toggle = ToggleType.toggleDisable;
	    }
	
	    if (itemText.length >= 2 && itemText.charAt(1) === ' ') {
	      if (itemText.charAt(0) === 'o') {
	        resultItem.toggle = ToggleType.toggleCircle;
	        itemText = itemText.substring(2, itemText.length);
	      } else if (itemText.charAt(0) === 'x') {
	        resultItem.toggle = ToggleType.toggleMark;
	        itemText = itemText.substring(2, itemText.length);
	      }
	    }
	
	    if (itemText.charAt(itemText.length - 1) === '>') {
	      resultItem.content = itemText.substring(0, itemText.length - 1).trim();
	      resultItem.isNotLeaf = true;
	    } else {
	      if (itemText.indexOf(',') !== -1) {
	        resultItem.content = itemText.substring(0, itemText.indexOf(','));
	        resultItem.shortcut = itemText.substring(itemText.indexOf(',') + 1, itemText.length);
	      } else {
	        resultItem.content = itemText;
	      }
	    }
	
	    return resultItem;
	  },
	
	  _parseText: function _parseText() {
	
	    var textArray = util.Text.delimitToParagraphs(styleHelper.getText(this.props));
	    var resultArray = [];
	
	    textArray.forEach(function (text) {
	      text = text.trim();
	      resultArray.push(this._parseTextItem(text));
	    }.bind(this));
	
	    return resultArray;
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: this.props.selectedIndex
	    };
	  },
	
	  render: function render() {
	    var itemArray = this._parseText();
	    var borderStyle = {
	      borderColor: this.props.borderColor ? this.props.borderColor : '#000'
	    };
	    var top = 0;
	    styleHelper.StyleUtil(this.props, borderStyle).background().text();
	    return React.createElement(
	      'div',
	      { className: 'border', style: borderStyle },
	      itemArray.map(function (itemData, index) {
	        var h = this.props.itemHeight;
	
	        if (itemData.separator) {
	          h = 1;
	        }
	        var item = React.createElement(MenuItem, _extends({}, this.props, {
	          selected: this.state.selectedIndex == index,
	          data: itemData,
	          top: top,
	          height: parseInt(this.props.itemHeight, 10),
	          onClickEvent: this._onClick.bind(this, index),
	          separatorColor: this.props.separatorColor
	        }));
	        top += h;
	        return item;
	      }.bind(this))
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.handleClick);
	  },
	
	  handleClick: function handleClick(no) {
	    var index = undefined;
	    if (arguments.length === 1) {
	      index = arguments[0];
	    } else if (arguments.length === 4) {
	      index = arguments[1];
	    }
	    if (index !== undefined) this._onClick(index);
	  },
	
	  _onClick: function _onClick(index) {
	    this.setState({ selectedIndex: index });
	  }
	});
	
	module.exports = Menu;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var appTypes = __webpack_require__(115);
	var Dom = __webpack_require__(12);
	var AutoSizeHelper = __webpack_require__(167);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	
	/**
	 * 菜单栏组件
	 */
	var MenuBarItem = React.createClass({
	  displayName: 'MenuBarItem',
	
	  propTypes: {
	    onClickEvent: React.PropTypes.func.isRequired,
	    selected: React.PropTypes.bool.isRequired
	  },
	
	  render: function render() {
	    var backgroundStyle = {
	      backgroundColor: this.props.selected ? this.props.selectedColor : undefined
	    };
	    return React.createElement(
	      'div',
	      { style: backgroundStyle, className: 'item-bg', onClick: this.props.onClickEvent },
	      React.createElement(
	        'label',
	        null,
	        util.Text.convertSpaceToNbsp(this.props.text)
	      )
	    );
	  }
	});
	
	var MenuBar = React.createClass({
	  displayName: 'MenuBar',
	
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: parseInt(this.props.selectedIndex, 10)
	    };
	  },
	
	  render: function render() {
	    this.textArray = util.Text.delimitToWords(styleHelper.getText(this.props));
	    var borderStyle = {
	      lineHeight: styleHelper.getHeight(this.props) + 'px'
	      // display: 'flex'
	    };
	    styleHelper.StyleUtil(this.props, borderStyle).base().background().border().text();
	    return React.createElement(
	      'div',
	      { style: borderStyle },
	      React.createElement(
	        'div',
	        { style: { width: 10000 } },
	        this.textArray.map(function (text, index) {
	          return React.createElement(MenuBarItem, _extends({}, this.props, {
	            key: index,
	            text: text,
	            selected: this.state.selectedIndex == index,
	            onClickEvent: this.onItemClick.bind(this, null, index)
	          }));
	        }, this)
	      )
	    );
	  },
	
	  onItemClick: function onItemClick(e, index) {
	    this.setState({ selectedIndex: index });
	  }
	
	});
	
	module.exports = MenuBar;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	
	var NumericStepper = React.createClass({
	  displayName: 'NumericStepper',
	
	
	  render: function render() {
	    var rightDivStyle;
	    var AllDivStyle;
	    var upTriangleStyle;
	    var downTriangleStyle;
	    var textDivStyle;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var bgColor = styleHelper.getBackgroundColor(this.props);
	    var color = styleHelper.getTextColor(this.props);
	    var fontSize = styleHelper.getFontSize(this.props);
	    var borderColor = styleHelper.getBorderColor(this.props);
	
	    rightDivStyle = {
	      borderLeft: this.props.borderVisible ? '1px solid ' + borderColor : 'none'
	    };
	
	    AllDivStyle = {
	      border: this.props.borderVisible ? '1px solid ' + borderColor : 'none',
	      boxSizing: 'border-box'
	    };
	
	    upTriangleStyle = {
	      top: h / 2 - 7
	    };
	
	    downTriangleStyle = {
	      top: h / 2 + 1
	    };
	
	    textDivStyle = {
	      width: w - 21, // 几个像素边距
	      color: color,
	      backgroundColor: bgColor
	    };
	
	    {/*return (<div className="border">*/}
	    return React.createElement(
	      'div',
	      { className: 'border', style: AllDivStyle },
	      React.createElement(
	        'div',
	        { style: rightDivStyle, className: 'right' },
	        React.createElement('div', { style: upTriangleStyle, className: 'upTriangle' }),
	        React.createElement('div', { style: downTriangleStyle, className: 'downTriangle' })
	      ),
	      React.createElement(
	        'div',
	        { style: textDivStyle, className: 'text' },
	        React.createElement(
	          'label',
	          { style: {
	              lineHeight: h + 'px',
	              width: w - 26,
	              fontSize: fontSize,
	              fontFamily: this.props.textFontFamily,
	              fontWeight: this.props.textStyles.fontWeight,
	              fontStyle: this.props.textStyles.fontStyle,
	              textDecoration: this.props.textStyles.textDecoration
	            } },
	          styleHelper.getText(this.props)
	        )
	      )
	    );
	  }
	});
	
	module.exports = NumericStepper;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Border = __webpack_require__(168);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var appTypes = __webpack_require__(115);
	
	/**
	 * 时间选择器
	 */
	var DateTimePicker = React.createClass({
	  displayName: 'DateTimePicker',
	
	
	  render: function render() {
	    var borderStyle;
	    var containerStyle;
	    var imgStyle;
	    var imgDivStyle;
	    var imgWidth;
	    var textStyle;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	
	    containerStyle = {
	      width: '100%',
	      height: '100%'
	    };
	
	    imgWidth = Math.min(h, 64);
	
	    imgDivStyle = {
	      backgroundColor: '#fff',
	      width: imgWidth,
	      height: imgWidth,
	      right: 0,
	      top: (h - imgWidth) / 2,
	      position: 'absolute',
	      boxSizing: 'border-box'
	    };
	
	    imgStyle = {
	      top: 0,
	      left: 0,
	      width: imgWidth,
	      height: imgWidth,
	      position: 'absolute'
	    };
	
	    borderStyle = {
	      width: w - imgWidth - 1,
	      height: '100%',
	      position: 'absolute',
	      whiteSpace: 'nowrap',
	      boxSizing: 'border-box',
	      overflow: 'hidden'
	    };
	    styleHelper.StyleUtil(this.props, borderStyle).text().background().border();
	
	    textStyle = {
	      top: 0,
	      left: borderStyle.fontSize / 4,
	      height: h,
	      position: 'absolute',
	      width: borderStyle.width - borderStyle.fontSize / 2,
	      //wordSpacing: -1,
	      lineHeight: h + 'px',
	      overflow: 'hidden'
	    };
	
	    return React.createElement(
	      'div',
	      { style: containerStyle },
	      React.createElement(
	        'div',
	        { style: borderStyle },
	        React.createElement(
	          'label',
	          {
	            style: textStyle
	          },
	          styleHelper.getText(this.props)
	        )
	      ),
	      React.createElement(
	        'div',
	        { style: imgDivStyle },
	        React.createElement('img', { style: imgStyle,
	          src: assetsHelper.getComponentAsset('Calendar_') })
	      )
	    );
	  }
	
	});
	
	module.exports = DateTimePicker;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/*
	 * 颜色选择器
	 */
	
	var React = __webpack_require__(11);
	var GlobalConst = __webpack_require__(164);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var graphicsHelper = __webpack_require__(172);
	
	var ColorPicker = React.createClass({
	  displayName: 'ColorPicker',
	
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  _doPaint: function _doPaint() {
	    var selfDom = ReactDOM.findDOMNode(this.refs.canvas);
	    var graphics = selfDom.getContext('2d');
	    var clientWidth = selfDom.clientWidth;
	    var clientHeight = selfDom.clientHeight;
	
	    //var clientWidth = this.props.w;
	    //var clientHeight = this.props.h;
	
	    var _this = this;
	    var clipTriangleSize = 8;
	    var clipSizeIncrement = 2;
	
	    var fillRect;
	
	    graphics.save();
	
	    this.requestID = window.requestAnimationFrame(function () {
	
	      var ratio = graphicsHelper.applyDeviceRatio(graphics, clientWidth, clientHeight);
	      graphicsHelper.clearRect(graphics);
	      clientHeight *= ratio;
	      clientWidth *= ratio;
	      clipTriangleSize *= ratio;
	      clipSizeIncrement *= ratio;
	      graphics.beginPath();
	      graphics.strokeStyle = GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK;
	      graphics.strokeWidth = ratio;
	
	      graphics.strokeRect(0, 0, clientWidth, clientHeight);
	      graphics.closePath();
	
	      // 绘制底部实心三角形
	
	      graphics.beginPath();
	      graphics.moveTo(clientWidth, clientHeight);
	      graphics.lineTo(clientWidth - clipTriangleSize, clientHeight);
	      graphics.lineTo(clientWidth, clientHeight - clipTriangleSize);
	      graphics.lineTo(clientWidth, clientHeight);
	      graphics.closePath();
	      graphics.fillStyle = GlobalConst.GLOBAL_COLOR.SYSTEM_BLANK;
	      graphics.fill();
	
	      graphics.beginPath();
	      graphics.moveTo(clipSizeIncrement, clipSizeIncrement);
	      graphics.lineTo(clipSizeIncrement, clientHeight - clipSizeIncrement);
	      graphics.lineTo(clientWidth - clipSizeIncrement - clipTriangleSize, clientHeight - clipSizeIncrement);
	      graphics.lineTo(clientWidth - clipSizeIncrement, clientHeight - clipSizeIncrement - clipTriangleSize);
	      graphics.lineTo(clientWidth - clipSizeIncrement, clipSizeIncrement);
	      graphics.lineTo(clipSizeIncrement, clipSizeIncrement);
	      graphics.closePath();
	      graphics.fillStyle = styleHelper.getPropertyValue(_this.props, propConst.COLOR);
	      graphics.fill();
	    });
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._doPaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._doPaint();
	  },
	
	  render: function render() {
	
	    var canvasStyle = {
	      width: '100%',
	      height: '100%'
	    };
	
	    return React.createElement('canvas', { style: canvasStyle,
	      ref: 'canvas',
	      width: styleHelper.getWidth(this.props),
	      height: styleHelper.getHeight(this.props) });
	  }
	
	});
	
	module.exports = ColorPicker;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var mouseHelper = __webpack_require__(149);
	
	/**
	 * 水平滑块
	 */
	var HSlider2 = React.createClass({
	  displayName: 'HSlider2',
	
	  getInitialState: function getInitialState() {
	    return {
	      progress: styleHelper.getInt(this.props, propConst.PROGRESS)
	    };
	  },
	  render: function render() {
	    var trackStyle;
	    var sliderStyle;
	    var sliderClass = 'slide';
	    var sliderWidth;
	    var sliderContentStyle;
	    var boxStyle;
	
	    var isDisabled = this.getIsDisabled();
	    var sliderColor = isDisabled ? '#DDD' : this.props.sliderColor;
	    switch (this.props.sliderShapeType) {
	      case 'SCircle':
	        sliderClass += ' circle';
	        sliderWidth = 15;
	        sliderContentStyle = {
	          backgroundColor: sliderColor
	        };
	        break;
	      case 'SSquare':
	        sliderClass += ' square';
	        sliderWidth = 15;
	        sliderContentStyle = {
	          backgroundColor: sliderColor
	        };
	        break;
	      default:
	        sliderClass += ' incisive';
	        sliderWidth = 8;
	        sliderContentStyle = {
	          borderBottomColor: sliderColor
	        };
	        break;
	    }
	    var progress = this.state.progress;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	
	    var test = this.props;
	
	    trackStyle = {
	      top: (h - 2) / 2,
	      backgroundColor: isDisabled ? '#DDD' : this.props.trackColor
	    };
	
	    sliderStyle = {
	      left: Math.min(progress / 100 * w, w - sliderWidth)
	    };
	
	    boxStyle = {
	      height: h
	    };
	
	    return React.createElement(
	      'div',
	      { style: boxStyle, onClick: this.onTrackClick },
	      React.createElement('div', { style: trackStyle, className: 'track' }),
	      React.createElement(
	        'div',
	        { onMouseDown: this.onDrag,
	          onTouchStart: this.onDrag,
	          onClick: this.onSliderClick,
	          style: sliderStyle, className: sliderClass },
	        React.createElement('div', { className: 'slide-shape', style: sliderContentStyle })
	      )
	    );
	  },
	  getIsDisabled: function getIsDisabled() {
	    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
	    if (!state) {
	      state = this.props[propConst.STATE];
	    }
	    return state === appTypes.ComStatus2.DISABLE;
	  },
	  onSliderClick: function onSliderClick(e) {
	    e.stopPropagation();
	  },
	  onDrag: function onDrag(e) {
	    if (this.getIsDisabled()) {
	      return;
	    }
	    var width = parseInt(this.props.w, 10);
	    var self = this;
	    var progress = this.state.progress;
	    var unit = width / 100;
	    mouseHelper.dragDelegate(function (e, delta) {
	      self.setState({
	        progress: Math.max(0, Math.min(delta.x / unit + progress, 100))
	      });
	      e.stopPropagation();
	      e.preventDefault();
	    }, function (e) {
	      e.stopPropagation();
	      e.preventDefault();
	    });
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  onTrackClick: function onTrackClick(e) {
	    var parent = e.target.parentNode;
	    var parentRects = parent.getBoundingClientRect();
	    var offsetLeft = e.clientX - parentRects.left;
	    var width = parseInt(this.props.w, 10);
	    this.setState({
	      progress: offsetLeft / width * 100
	    });
	  }
	});
	
	module.exports = HSlider2;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var mouseHelper = __webpack_require__(149);
	
	/**
	 * 水平滑块
	 */
	var VSlider2 = React.createClass({
	  displayName: 'VSlider2',
	
	
	  getInitialState: function getInitialState() {
	    return {
	      progress: styleHelper.getInt(this.props, propConst.PROGRESS)
	    };
	  },
	
	  render: function render() {
	    var trackStyle;
	    var sliderStyle;
	    var sliderClass = 'slide';
	    var sliderHeight;
	    var sliderContentStyle;
	    var boxStyle;
	
	    var isDisabled = this.getIsDisabled();
	    var sliderColor = isDisabled ? '#DDD' : this.props.sliderColor;
	    switch (this.props.sliderShapeType) {
	      case 'SCircle':
	        sliderClass += ' circle';
	        sliderHeight = 15;
	        sliderContentStyle = {
	          backgroundColor: sliderColor
	        };
	        break;
	      case 'SSquare':
	        sliderClass += ' square';
	        sliderHeight = 15;
	        sliderContentStyle = {
	          backgroundColor: sliderColor
	        };
	        break;
	      default:
	        sliderClass += ' incisive';
	        sliderHeight = 4;
	        sliderContentStyle = {
	          borderLeftColor: sliderColor
	        };
	        break;
	    }
	
	    var progress = this.state.progress;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	
	    trackStyle = {
	      left: (w - 2) / 2,
	      backgroundColor: isDisabled ? '#DDD' : this.props.trackColor
	    };
	
	    sliderStyle = {
	      top: Math.min(progress / 100 * h, h - sliderHeight)
	    };
	
	    boxStyle = {
	      width: w,
	      height: h
	    };
	
	    return React.createElement(
	      'div',
	      { style: boxStyle, onClick: this.onTrackClick },
	      React.createElement('div', { className: 'track', style: trackStyle }),
	      React.createElement(
	        'div',
	        { onMouseDown: this.onDrag,
	          onTouchStart: this.onDrag,
	          onClick: this.onSliderClick,
	          className: sliderClass, style: sliderStyle },
	        React.createElement('div', { className: 'slide-shape', style: sliderContentStyle })
	      )
	    );
	  },
	  getIsDisabled: function getIsDisabled() {
	    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
	    if (!state) {
	      state = this.props[propConst.STATE];
	    }
	    return state === appTypes.ComStatus2.DISABLE;
	  },
	  onDrag: function onDrag(e) {
	    if (this.getIsDisabled()) {
	      return;
	    }
	    var height = parseInt(this.props.h, 10);
	    var self = this;
	    var progress = this.state.progress;
	    var unit = height / 100;
	    mouseHelper.dragDelegate(function (e, delta) {
	      self.setState({
	        progress: Math.max(0, Math.min(delta.y / unit + progress, 100))
	      });
	      e.stopPropagation();
	      e.preventDefault();
	    }, function (e) {
	      e.stopPropagation();
	      e.preventDefault();
	    });
	    e.preventDefault();
	  },
	  onSliderClick: function onSliderClick(e) {
	    e.stopPropagation();
	  },
	  onTrackClick: function onTrackClick(e) {
	    var parent = e.target.parentNode;
	    var parentRects = parent.getBoundingClientRect();
	    var offsetTop = e.clientY - parentRects.top;
	    var height = parseInt(this.props.h, 10);
	    this.setState({
	      progress: offsetTop / height * 100
	    });
	  }
	});
	
	module.exports = VSlider2;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Border = __webpack_require__(168);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	var appTypes = __webpack_require__(115);
	var propConst = __webpack_require__(147);
	var ColorImage = __webpack_require__(234);
	
	var SearchBox = React.createClass({
	  displayName: 'SearchBox',
	
	  render: function render() {
	    var h = styleHelper.getHeight(this.props);
	    var state = styleHelper.getPropertyValue(this.props, propConst.STATE);
	    if (!state) {
	      state = this.props.state;
	    }
	    var isDisable = state === appTypes.ComStatus1.DISABLED;
	    var imgStyle = {
	      position: 'absolute',
	      top: h / 2 - 8,
	      width: 16,
	      height: 16,
	      whiteSpace: 'nowrap'
	    };
	
	    //var editable = false;
	    var borderStyle = styleHelper.StyleUtil(this.props).background().size().border().text().lineHeight().align().base().style;
	    var inputStyle = {};
	    styleHelper.StyleUtil(this.props, inputStyle).align().text().background();
	    if (this.props.textDirection === 'tdLeft') {
	      imgStyle.right = 8;
	      inputStyle.paddingLeft = 8 + parseInt(inputStyle.fontSize / 3, 10) || 5;
	    } else {
	      imgStyle.left = 8;
	      inputStyle.paddingLeft = 24 + parseInt(inputStyle.fontSize / 3, 10) || 5;
	    }
	    inputStyle.width = parseInt(this.props.w, 10) - 24 - borderStyle.borderRadius - 2 * (parseInt(inputStyle.fontSize / 3, 10) || 5);
	    if (isDisable) {
	      borderStyle.color = borderStyle.borderColor = appTypes.Color.MODEL_DISABLE;
	      var rgba = util.Color.toRGBA(inputStyle.color);
	      rgba.a *= 0.4;
	      inputStyle.color = util.Color.rgbaToString(rgba);
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'border', style: borderStyle },
	      React.createElement(ColorImage, { style: imgStyle,
	        color: isDisable ? appTypes.Color.MODEL_DISABLE : styleHelper.getBorderColor(this.props),
	        src: assetsHelper.getComponentAsset('Search')
	      }),
	      React.createElement('input', {
	        type: 'text',
	        defaultValue: styleHelper.getText(this.props),
	        style: inputStyle
	
	      })
	    );
	  }
	});
	
	module.exports = SearchBox;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var LabelParts = __webpack_require__(174);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var textHelper = __webpack_require__(116).Text;
	
	var BreadCrumbs = React.createClass({
	  displayName: 'BreadCrumbs',
	
	
	  _getItemArray: function _getItemArray() {
	    return textHelper.delimitText(styleHelper.getText(this.props), textHelper.DM_COMMA);
	  },
	
	  render: function render() {
	    var backgroundStyle = {
	      width: '100%',
	      height: '100%'
	    };
	
	    var textArray = this._getItemArray();
	    this.len = textArray.length;
	    var separatorSrc = assetsHelper.getComponentAsset('commons/separator');
	    styleHelper.StyleUtil(this.props).default(backgroundStyle).text();
	    return React.createElement(
	      'div',
	      { style: backgroundStyle },
	      textArray.map(function (text, index) {
	        var css = { width: 'auto', position: 'absolute', whiteSpace: 'nowrap' };
	        if (index === textArray.length - 1) {
	          css.color = '#000';
	        }
	        return React.createElement(
	          'div',
	          { key: index, ref: 'text_' + index, style: css },
	          React.createElement(
	            'label',
	            null,
	            text
	          )
	        );
	      }, this),
	      textArray.map(function (t, index) {
	        if (index < this.len - 1) {
	          return React.createElement(
	            'div',
	            { key: index, ref: 'separator_' + index, style: { width: this.props.gap, position: 'absolute' } },
	            React.createElement('img', { style: { position: 'absolute', top: (this.props.h - 10) / 2, left: (this.props.gap - 8) / 2 },
	              src: separatorSrc })
	          );
	        }
	      }, this)
	    );
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.adjustPosition();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.adjustPosition();
	  },
	
	  adjustPosition: function adjustPosition() {
	    var i = 0;
	    var txt;
	    var separator;
	    var left = 0;
	    for (i; i < this.len; i++) {
	      txt = ReactDOM.findDOMNode(this.refs['text_' + i]);
	      separator = ReactDOM.findDOMNode(this.refs['separator_' + i]);
	
	      $(txt).css({ left: left });
	      left += txt.clientWidth;
	      if (separator) {
	        $(separator).css({ left: left });
	        left += separator.clientWidth;
	      }
	    }
	  }
	
	});
	
	module.exports = BreadCrumbs;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var TextParts = __webpack_require__(211);
	var styleHelper = __webpack_require__(145);
	var appTypes = __webpack_require__(115);
	var util = __webpack_require__(116);
	var graphicsHelper = __webpack_require__(172);
	/**
	 * 工具提示
	 */
	var ToolTip = React.createClass({
	  displayName: 'ToolTip',
	
	
	  createPath: function createPath(graphics, direction, width, height) {
	    var pathData = new util.Path.PathData();
	    var ratio = graphicsHelper.applyDeviceRatio(graphics, width, height);
	    var offset = 0.5 * ratio;
	    var indicatorLeft = 15 * ratio;
	    var indicatorRight = 19 * ratio;
	    var indicatorHeight = 10 * ratio;
	    var indicatorWidth = 14 * ratio;
	    var radius = 4 * ratio;
	    graphics.strokeStyle = styleHelper.getBorderColor(this.props) || '#000';
	    var borderVisible = styleHelper.getBorderVisible(this.props);
	    if (borderVisible !== undefined && !borderVisible) {
	      graphics.strokeStyle = '#00000000';
	    }
	    graphics.fillStyle = styleHelper.getBackgroundColor(this.props);
	    graphics.lineWidth = ratio;
	    graphics.strokeWidth = ratio;
	
	    height *= ratio;
	    width *= ratio;
	    graphics.clearRect(0, 0, width, height);
	    switch (direction) {
	      case appTypes.ToolTipDirection.LEFT:
	        pathData.moveTo(offset, height / 2).lineTo(indicatorHeight - offset, height / 2 - indicatorWidth / 2).lineTo(indicatorHeight - offset, radius).curveTo(indicatorHeight - offset, offset, indicatorHeight + radius, offset).lineTo(width - radius, offset).curveTo(width - offset, offset, width - offset, radius).lineTo(width - offset, height - radius).curveTo(width - offset, height - offset, width - radius, height - offset).lineTo(indicatorHeight + radius, height - offset).curveTo(indicatorHeight - offset, height - offset, indicatorHeight - offset, height - radius).lineTo(indicatorHeight - offset, height / 2 + indicatorWidth / 2).close().stroke(graphics, true);
	        break;
	      case appTypes.ToolTipDirection.LEFT_TOP:
	        pathData.moveTo(indicatorLeft, 0).lineTo(indicatorLeft + indicatorWidth, indicatorHeight - offset).lineTo(width - radius, indicatorHeight - offset).curveTo(width - offset, indicatorHeight - offset, width - offset, indicatorWidth).lineTo(width - offset, height - radius).curveTo(width - offset, height - offset, width - radius, height - offset).lineTo(radius, height - offset).curveTo(offset, height - offset, offset, height - radius).lineTo(offset, indicatorWidth - offset).curveTo(offset, indicatorHeight - offset, radius, indicatorHeight - offset).lineTo(indicatorRight, indicatorHeight - offset).close().stroke(graphics, true);
	        break;
	      case appTypes.ToolTipDirection.TOP:
	        pathData.moveTo(width / 2, 0).lineTo(width / 2 + indicatorWidth / 2, indicatorHeight - offset).lineTo(width - radius, indicatorHeight - offset).curveTo(width - offset, indicatorHeight - offset, width - offset, indicatorHeight + radius).lineTo(width - offset, height - radius).curveTo(width - offset, height - offset, width - radius, height - offset).lineTo(radius, height - offset).curveTo(offset, height - offset, offset, height - radius).lineTo(offset, indicatorHeight + radius - offset).curveTo(offset, indicatorHeight - offset, radius, indicatorHeight - offset).lineTo(width / 2 - indicatorWidth / 2, indicatorHeight - offset).close().stroke(graphics, true);
	        break;
	      case appTypes.ToolTipDirection.RIGHT_TOP:
	        pathData.moveTo(width - indicatorLeft, 0).lineTo(width - indicatorRight, indicatorHeight - offset).lineTo(width - radius, indicatorHeight - offset).curveTo(width - offset, indicatorHeight - offset, width - offset, indicatorHeight + radius).lineTo(width - offset, height - radius).curveTo(width - offset, height - offset, width - radius, height - offset).lineTo(radius, height - offset).curveTo(offset, height - offset, offset, height - radius).lineTo(offset, indicatorHeight + radius - offset).curveTo(offset, indicatorHeight - offset, radius, indicatorHeight - offset).lineTo(width - indicatorLeft - indicatorWidth, indicatorHeight - offset).close().stroke(graphics, true);
	        break;
	      case appTypes.ToolTipDirection.RIGHT:
	        pathData.moveTo(width, height / 2).lineTo(width - indicatorHeight + offset, height / 2 + indicatorWidth / 2).lineTo(width - indicatorHeight + offset, height - radius).curveTo(width - indicatorHeight + offset, height - offset, width - indicatorHeight - radius, height - offset).lineTo(radius, height - offset).curveTo(offset, height - offset, offset, height - radius).lineTo(offset, radius).curveTo(offset, offset, radius, offset).lineTo(width - indicatorHeight - radius, offset).curveTo(width - indicatorHeight + offset, offset, width - indicatorHeight + offset, radius).lineTo(width - indicatorHeight + offset, height / 2 - indicatorWidth / 2).close().stroke(graphics, true);
	        break;
	      case appTypes.ToolTipDirection.RIGHT_BOTTOM:
	        pathData.moveTo(width - indicatorLeft, height).lineTo(width - indicatorLeft - indicatorWidth, height - indicatorHeight + offset).lineTo(radius, height - indicatorHeight + offset).curveTo(offset, height - indicatorHeight + offset, offset, height - indicatorHeight - radius).lineTo(offset, radius).curveTo(offset, offset, radius, offset).lineTo(width - radius, offset).curveTo(width - offset, offset, width - offset, radius).lineTo(width - offset, height - indicatorHeight - radius).curveTo(width - offset, height - indicatorHeight + offset, width - radius, height - indicatorHeight + offset).lineTo(width - indicatorRight, height - indicatorHeight + offset).close().stroke(graphics, true);
	        break;
	      case appTypes.ToolTipDirection.BOTTOM:
	        pathData.moveTo(width / 2, height).lineTo(width / 2 - indicatorWidth / 2, height - indicatorHeight + offset).lineTo(radius, height - indicatorHeight + offset).curveTo(offset, height - indicatorHeight + offset, offset, height - indicatorHeight - radius).lineTo(offset, radius).curveTo(offset, offset, radius, offset).lineTo(width - radius, offset).curveTo(width - offset, offset, width - offset, radius).lineTo(width - offset, height - indicatorHeight - radius).curveTo(width - offset, height - indicatorHeight + offset, width - radius, height - indicatorHeight + offset).lineTo(width / 2 + indicatorWidth / 2, height - indicatorHeight + offset).close().stroke(graphics, true);
	        break;
	      case appTypes.ToolTipDirection.LEFT_BOTTOM:
	        pathData.moveTo(indicatorLeft, height).lineTo(indicatorRight, height - indicatorHeight + offset).lineTo(radius, height - indicatorHeight + offset).curveTo(offset, height - indicatorHeight + offset, offset, height - indicatorHeight - radius).lineTo(offset, radius).curveTo(offset, offset, radius, offset).lineTo(width - radius, offset).curveTo(width - offset, offset, width - offset, radius).lineTo(width - offset, height - indicatorHeight - radius).curveTo(width - offset, height - indicatorHeight + offset, width - radius, height - indicatorHeight + offset).lineTo(indicatorLeft + indicatorWidth, height - indicatorHeight + offset).close().stroke(graphics, true);
	        break;
	    }
	  },
	
	  _doPaint: function _doPaint() {
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    var dom = ReactDOM.findDOMNode(this);
	    var graphics = canvas.getContext('2d');
	    var clientWidth = dom.clientWidth;
	    var clientHeight = dom.clientHeight;
	    var direction = this.props.tipCornerDirection;
	    var width = clientWidth;
	    var height = clientHeight;
	    canvas.width = width;
	    canvas.height = height;
	
	    this.requestID = window.requestAnimationFrame(function () {
	      this.createPath(graphics, direction, width, height);
	    }.bind(this));
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._doPaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._doPaint();
	    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize);
	  },
	
	  onResize: function onResize(e) {
	    this._doPaint();
	    $(ReactDOM.findDOMNode(this.refs.text)).trigger(appTypes.CUSTOM_EVENT.ON_PAINT);
	  },
	
	  render: function render() {
	
	    this.radius = 4;
	    this.angleHeight = 10;
	    var padding = 7; //这个值是与桌面端一样的
	
	    var direction = this.props.tipCornerDirection;
	    var left = padding;
	    var top = padding;
	    var right = padding;
	    var bottom = padding;
	    var width = styleHelper.getWidth(this.props);
	    var height = styleHelper.getHeight(this.props);
	
	    if (direction === appTypes.ToolTipDirection.LEFT) {
	      left = this.angleHeight + padding;
	    } else if (direction === appTypes.ToolTipDirection.BOTTOM || direction === appTypes.ToolTipDirection.LEFT_BOTTOM || direction === appTypes.ToolTipDirection.RIGHT_BOTTOM) {
	      bottom = this.angleHeight + padding;
	    } else if (direction === appTypes.ToolTipDirection.TOP || direction === appTypes.ToolTipDirection.LEFT_TOP || direction === appTypes.ToolTipDirection.RIGHT_TOP) {
	      top = this.angleHeight + padding;
	    } else if (direction === appTypes.ToolTipDirection.RIGHT) {
	      right = this.angleHeight + padding;
	    }
	    var textStyle = {
	      overflow: 'hidden',
	      position: 'absolute',
	      zIndex: 1
	    };
	
	    var props = _.extend({}, this.props);
	    props.x = left;
	    props.y = top;
	    props.w = width - left - right;
	    props.h = height - top - bottom;
	    return React.createElement(
	      'div',
	      { style: { width: '100%', height: '100%' } },
	      React.createElement('canvas', { ref: 'canvas',
	        style: { width: '100%', height: '100%' }
	      }),
	      React.createElement(
	        'div',
	        { style: {
	            left: left,
	            top: top,
	            right: right,
	            bottom: bottom,
	            position: 'absolute'
	          } },
	        React.createElement(TextParts, _extends({ ref: 'text' }, props, { partStyle: textStyle }))
	      )
	    );
	  }
	
	});
	
	module.exports = ToolTip;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Border = __webpack_require__(168);
	var util = __webpack_require__(116);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	
	/**
	 * 便签条
	 */
	var StickyNote = React.createClass({
	  displayName: 'StickyNote',
	
	
	  render: function render() {
	    var isShowTabBar = this.props.isShowTabBar;
	    var text = styleHelper.getText(this.props);
	    var textArray = util.Text.delimitToParagraphs(text);
	    var backgroundStyle;
	    var tabBarStyle;
	    var textStyle;
	    var tabBarHeight = isShowTabBar ? 22 : 0;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    if (isShowTabBar) {
	      tabBarStyle = {
	        position: 'absolute',
	        left: Math.round((w - w * (71 / 178)) / 2),
	        top: 0,
	        width: Math.round(w * (71 / 178)),
	        height: tabBarHeight,
	        backgroundColor: '#e33c2f'
	      };
	    }
	
	    backgroundStyle = {
	      top: tabBarHeight / 2,
	      borderStyle: 'none',
	      height: h - tabBarHeight / 2,
	      width: '100%',
	      left: 0,
	      position: 'absolute',
	      backgroundColor: styleHelper.getBackgroundColor(this.props)
	    };
	
	    textStyle = {
	      left: 12,
	      top: 10 + tabBarHeight / 2,
	      width: w - 2 * 12,
	      height: backgroundStyle.height - 16 - tabBarHeight / 2,
	      position: 'absolute',
	      overflow: 'hidden'
	    };
	
	    // 原来的老版本数据，有些没有 lineHeight，导致取出来为0，这时不能去设置为 0
	    var lineHeight = styleHelper.builderLineHeight(this.props);
	    if (lineHeight) {
	      textStyle.lineHeight = lineHeight + 'px';
	    } else {
	      textStyle.lineHeight = '1em';
	    }
	
	    styleHelper.StyleUtil(this.props, textStyle).text().align();
	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'div',
	        { style: backgroundStyle },
	        React.createElement(
	          'div',
	          { style: textStyle },
	          textArray.map(function (t, idx) {
	            t = util.Text.replaceIndentSpace(util.Text.convertSpaceToNbsp(t));
	            if (!t.trim()) {
	              return React.createElement(
	                'p',
	                { key: idx },
	                '\xA0'
	              );
	            }
	            return React.createElement(
	              'p',
	              { key: idx },
	              t
	            );
	          })
	        )
	      ),
	      React.createElement('div', { style: tabBarStyle })
	    );
	  }
	});
	
	module.exports = StickyNote;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var Border = __webpack_require__(168);
	var TextParts = __webpack_require__(211);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 编号
	 */
	var CallOut = React.createClass({
	  displayName: 'CallOut',
	
	  render: function render() {
	    var borderStyle = {
	      borderRadius: 12,
	      border: 'none',
	      overflow: 'hidden',
	      position: 'absolute'
	    };
	
	    var textStyle = {
	      left: 11,
	      top: 6,
	      width: this.props.w - 8,
	      height: this.props.h - 5,
	      overflow: 'hidden'
	
	    };
	
	    styleHelper.StyleUtil(this.props).default(borderStyle).size().background().text().align();
	    return React.createElement(
	      'div',
	      { style: borderStyle },
	      React.createElement(TextParts, _extends({}, this.props, { partStyle: textStyle }))
	    );
	  }
	});
	
	module.exports = CallOut;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var appTypes = __webpack_require__(115);
	var TextParts = __webpack_require__(211);
	var styleHelper = __webpack_require__(145);
	var _ = __webpack_require__(51);
	
	/**
	 * 水平花括号
	 */
	var HCurly = React.createClass({
	  displayName: 'HCurly',
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  _doPaint: function _doPaint() {
	
	    this.requestID = window.requestAnimationFrame(function () {
	      var canvasDom = ReactDOM.findDOMNode(this.refs.canvas);
	      var graphics;
	      var clientWidth;
	      var clientHeight;
	      var lineWidth = 1;
	      var offset = lineWidth / 2;
	      var c;
	      var cl;
	      var cr;
	      if (!canvasDom) {
	        return;
	      }
	      graphics = canvasDom.getContext('2d');
	      clientWidth = canvasDom.clientWidth;
	      clientHeight = canvasDom.clientHeight;
	      c = Math.round(clientWidth / 2);
	      cl = c - 7;
	      cr = c + 7;
	      graphics.clearRect(0, 0, clientWidth, clientHeight);
	
	      graphics.lineWidth = lineWidth;
	      graphics.strokeWidth = lineWidth;
	      graphics.strokeStyle = styleHelper.getBackgroundColor(this.props);
	
	      if (this.isDirTop) {
	
	        graphics.moveTo(offset, offset);
	        graphics.arcTo(offset, 6 - offset, 5 - offset, 6 - offset, 5);
	
	        graphics.lineTo(cl, 6 - offset);
	        graphics.lineTo(c, this.curlyHeight);
	        graphics.lineTo(cr, 6 - offset);
	
	        graphics.lineTo(clientWidth - 5 + offset, 6 - offset);
	        graphics.arcTo(clientWidth - offset, 6 - offset, clientWidth - offset, offset, 5);
	      } else {
	        graphics.moveTo(offset, clientHeight - offset);
	        graphics.arcTo(offset, clientHeight - 6 + offset, 5 - offset, clientHeight - 6 + offset, 5);
	
	        graphics.lineTo(cl, clientHeight - 6 + offset);
	        graphics.lineTo(c, clientHeight - this.curlyHeight);
	        graphics.lineTo(cr, clientHeight - 6 + offset);
	
	        graphics.lineTo(clientWidth - 5 + offset, clientHeight - 6 + offset);
	
	        graphics.arcTo(clientWidth - offset, clientHeight - 6 + offset, clientWidth - offset, clientHeight - offset, 5);
	      }
	
	      graphics.stroke();
	    }.bind(this));
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	
	    // TODO: 此次出调用绘制时，会导致整体花括号颜色变深，比较奇怪？？？
	    this._doPaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._doPaint();
	  },
	
	  render: function render() {
	    this.curlyHeight = 15;
	    this.isDirTop = this.props.direction == appTypes.HCurlyDirection.TOP;
	    var canvasTop;
	
	    var canvasStyle;
	    var textStyle;
	    var selfH = styleHelper.getHeight(this.props);
	    var tprops = _.extend({}, this.props);
	    delete tprops.currentH;
	    tprops.h = selfH - this.curlyHeight - 3;
	
	    if (this.isDirTop) {
	      canvasTop = 0;
	    } else {
	      canvasTop = selfH - this.curlyHeight;
	    }
	
	    canvasStyle = {
	      left: 0,
	      top: canvasTop,
	      height: this.curlyHeight,
	      position: 'absolute',
	      zIndex: 0
	    };
	
	    textStyle = {
	      left: 0,
	      top: this.isDirTop ? this.curlyHeight + 3 : 0,
	      width: '100%',
	      height: selfH - this.curlyHeight - 3,
	      position: 'absolute',
	      zIndex: 1
	    };
	
	    return React.createElement(
	      'div',
	      { className: 'component-Base' },
	      React.createElement('canvas', { ref: 'canvas',
	        style: canvasStyle,
	        width: styleHelper.getWidth(this.props),
	        height: this.curlyHeight
	      }),
	      React.createElement(TextParts, _extends({}, tprops, {
	        partStyle: textStyle,
	        textWordWrap: true,
	        textVAlign: this.isDirTop ? appTypes.VertAlign.TOP : appTypes.VertAlign.BOTTOM,
	        textAlign: appTypes.HoriAlign.CENTER
	      }))
	    );
	  }
	});
	
	module.exports = HCurly;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var appTypes = __webpack_require__(115);
	var TextParts = __webpack_require__(211);
	var styleHelper = __webpack_require__(145);
	var _ = __webpack_require__(51);
	
	/**
	 * 垂直花括号
	 */
	var VCurly = React.createClass({
	  displayName: 'VCurly',
	
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  _doPaint: function _doPaint() {
	    var canvasDom = ReactDOM.findDOMNode(this.refs.canvas);
	    var graphics = canvasDom.getContext('2d');
	    var clientWidth = canvasDom.clientWidth;
	    var clientHeight = canvasDom.clientHeight;
	    var c = clientHeight / 2;
	    var ct = c - 7;
	    var cb = c + 7;
	    var lineWidth = 1;
	    var offset = lineWidth / 2;
	
	    this.requestID = window.requestAnimationFrame(function () {
	      graphics.clearRect(0, 0, clientWidth, clientHeight);
	
	      graphics.lineWidth = lineWidth;
	      graphics.strokeWidth = lineWidth;
	      graphics.strokeStyle = styleHelper.getBackgroundColor(this.props);
	      if (this.isDirLeft) {
	
	        graphics.moveTo(offset, offset);
	        graphics.arcTo(6 - offset, offset, 6 - offset, 5 - offset, 5);
	
	        graphics.lineTo(6 - offset, ct);
	        graphics.lineTo(this.curlyWidth, c);
	        graphics.lineTo(6 - offset, cb);
	
	        graphics.lineTo(6 - offset, clientHeight - 5);
	        graphics.arcTo(6 - offset, clientHeight - offset, offset, clientHeight - offset, 5);
	      } else {
	
	        graphics.moveTo(clientWidth - offset, offset);
	        //graphics.lineTo(clientWidth - 6, 5);
	        graphics.arcTo(clientWidth - 6 + offset, offset, clientWidth - 6 + offset, 5 - offset, 5);
	
	        graphics.lineTo(clientWidth - 6 + offset, ct);
	        graphics.lineTo(clientWidth - this.curlyWidth, c);
	        graphics.lineTo(clientWidth - 6 + offset, cb);
	
	        graphics.lineTo(clientWidth - 6 + offset, clientHeight - 5);
	        //graphics.lineTo(clientWidth - 1, clientHeight - 1);
	        graphics.arcTo(clientWidth - 6 + offset, clientHeight - offset, clientWidth - offset, clientHeight - offset, 5);
	      }
	
	      graphics.stroke();
	    }.bind(this));
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	
	    // TODO: 此次出调用绘制时，会导致整体花括号颜色变深，比较奇怪？？？
	    this._doPaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._doPaint();
	  },
	
	  render: function render() {
	    var curlyWidth = 15;
	    this.curlyWidth = 15;
	    var canvasLeft;
	    var dirLeft = this.props.direction == appTypes.VCurlyDirection.LEFT;
	    this.isDirLeft = dirLeft;
	
	    var canvasStyle;
	    var textStyle;
	    var selfW = styleHelper.getWidth(this.props);
	    var tprops = _.extend({}, this.props);
	    tprops.w = styleHelper.getWidth(this.props) - curlyWidth - 3;
	    delete tprops.currentW;
	    var w = styleHelper.getWidth(tprops);
	    var h = styleHelper.getHeight(tprops);
	    if (dirLeft) {
	      canvasLeft = 0;
	    } else {
	      canvasLeft = selfW - curlyWidth;
	    }
	
	    canvasStyle = {
	      left: canvasLeft,
	      zIndex: 0,
	      width: this.curlyWidth,
	      height: h
	    };
	
	    textStyle = {
	      left: dirLeft ? curlyWidth + 3 : 0,
	      top: 0,
	      width: w,
	      height: '100%',
	      position: 'absolute',
	      zIndex: 1
	    };
	
	    return React.createElement(
	      'div',
	      { className: 'component-Base' },
	      React.createElement('canvas', { ref: 'canvas',
	        style: canvasStyle,
	        width: curlyWidth,
	        height: h
	      }),
	      React.createElement(TextParts, _extends({}, tprops, {
	        partStyle: textStyle,
	        textVAlign: appTypes.VertAlign.MIDDLE,
	        textAlign: dirLeft ? appTypes.HoriAlign.LEFT : appTypes.HoriAlign.RIGHT
	      }))
	    );
	  }
	});
	
	module.exports = VCurly;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 红叉组件
	 */
	var RedX = React.createClass({
	  displayName: 'RedX',
	
	
	  render: function render() {
	    var sw = styleHelper.getWidth(this.props);
	    var sh = styleHelper.getHeight(this.props);
	    //console.log(this.props.opacity);
	
	    var height = 4;
	    var degree = Math.atan(sh / sw) / Math.PI * 180;
	
	    var width = Math.round(Math.sqrt(sw * sw + sh * sh) - height);
	
	    var line1Style = {
	      backgroundColor: '#df2000',
	      top: sh / 2 - 3,
	      left: -(width - sw) / 2,
	      width: width,
	      height: height,
	      position: 'absolute',
	      boxSizing: 'border-box',
	      transform: 'rotate(' + degree + 'deg)'
	    };
	    var line2Style = {
	      backgroundColor: '#df2000',
	      top: sh / 2 - 3,
	      left: -(width - sw) / 2,
	      width: width,
	      height: height,
	      position: 'absolute',
	      boxSizing: 'border-box',
	      transform: 'rotate(' + (180 - degree) + 'deg)'
	    };
	
	    return React.createElement(
	      'div',
	      { style: {
	          width: '100%',
	          height: '100%'
	        } },
	      React.createElement('div', { style: line1Style }),
	      React.createElement('div', { style: line2Style })
	    );
	  }
	});
	
	module.exports = RedX;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	/**
	 * 涂抹组件
	 */
	var ScratchOut = React.createClass({
	  displayName: 'ScratchOut',
	
	  render: function render() {
	    return React.createElement('img', { className: 'component-SimpleCom',
	      src: assetsHelper.getComponentAsset('ScratchOut')
	    });
	  }
	});
	
	module.exports = ScratchOut;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	/**
	 * 组件
	 */
	var QRCode = React.createClass({
	  displayName: 'QRCode',
	
	  render: function render() {
	    return React.createElement('img', { className: 'component-SimpleCom',
	      src: assetsHelper.getComponentAsset('QRCode')
	    });
	  }
	});
	
	module.exports = QRCode;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	/**
	 * 日历组件
	 */
	var Calendar = React.createClass({
	  displayName: 'Calendar',
	
	  render: function render() {
	    var backgroundStyle = {
	      width: '100%',
	      height: '100%',
	      borderStyle: 'none'
	    };
	
	    return React.createElement('img', { style: backgroundStyle,
	      src: assetsHelper.getComponentAsset('Calendar')
	    });
	  }
	});
	
	module.exports = Calendar;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	/**
	 * 头像
	 */
	var Webcam = React.createClass({
	    displayName: 'Webcam',
	
	    render: function render() {
	        return React.createElement('img', { className: 'component-SimpleCom', src: assetsHelper.getComponentAsset('Webcam') });
	    }
	});
	
	module.exports = Webcam;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var Shape = __webpack_require__(210);
	var Icon = __webpack_require__(232);
	
	/**
	 * 头像
	 */
	var AvatarEx = React.createClass({
	  displayName: 'AvatarEx',
	
	  render: function render() {
	    var shapeProps = this.props.children[0].props;
	    var iconProps = this.props.children[1].props;
	    var iconStyle = {
	      width: iconProps.w,
	      height: iconProps.h,
	      marginLeft: iconProps.x,
	      marginTop: iconProps.y - 1,
	      position: 'absolute'
	    };
	    var icon = iconProps.icon;
	    if (icon.iconCode === '62168' && icon.iconFontName === 'jdIonicons') {
	      iconStyle.width = Math.round(iconStyle.width * 9 / 7);
	      iconStyle.height = Math.round(iconStyle.height * 9 / 7);
	      iconStyle.marginLeft = Math.round((this.props.w - iconStyle.width) / 2);
	      iconStyle.marginTop = this.props.h - Math.round(iconStyle.height * 8 / 9) - shapeProps.thickness + 1;
	    }
	    return React.createElement(
	      'div',
	      null,
	      React.createElement(Shape, _extends({}, shapeProps, {
	        key: this.props.children[0].key })),
	      React.createElement(
	        'div',
	        { style: iconStyle },
	        React.createElement(Icon, _extends({}, iconProps, {
	          w: iconStyle.width,
	          h: iconStyle.height,
	          key: this.props.children[1].key }))
	      )
	    );
	  }
	});
	
	module.exports = AvatarEx;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ShapeParts = __webpack_require__(283);
	var IconParts = __webpack_require__(233);
	var styleHelper = __webpack_require__(145);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	
	/**
	 * 头像
	 */
	var AvatarEx = React.createClass({
	  displayName: 'AvatarEx',
	
	  render: function render() {
	    var thickness = 1;
	    var iconStyle = {};
	
	    var shapeStyle = {
	      borderVisible: styleHelper.getPropertyValue(this.props, 'borderVisible'),
	      borderColor: styleHelper.getPropertyValue(this.props, 'borderColor'),
	      shapeType: styleHelper.getPropertyValue(this.props, 'avatarShapeStyle'),
	      color: this.props.avatarBackgroundColor,
	      thickness: styleHelper.getPropertyValue(this.props, 'thickness')
	    };
	
	    if (shapeStyle.shapeType === appTypes.AVATAR_SHAPE_STYLE.RECTANGLE) {
	      shapeStyle.shapeType = appTypes.SHAPE_TYPE.RECTANGLE;
	    } else if (shapeStyle.shapeType === appTypes.AVATAR_SHAPE_STYLE.CIRCLE) {
	      shapeStyle.shapeType = appTypes.SHAPE_TYPE.ECLIPSE;
	    }
	
	    thickness = 1;
	    if (this.props.borderVisible) {
	      thickness = styleHelper.getPropertyValue(this.props, 'thickness') * 2;
	    }
	
	    if (shapeStyle.shapeType === appTypes.SHAPE_TYPE.RECTANGLE) {
	      iconStyle.w = (styleHelper.getWidth(this.props) - thickness) * 0.85;
	      iconStyle.h = (styleHelper.getHeight(this.props) - thickness) * 0.85;
	      iconStyle.x = (styleHelper.getWidth(this.props) - iconStyle.w) / 2;
	      iconStyle.y = styleHelper.getHeight(this.props) - iconStyle.h - thickness / 2;
	    } else if (shapeStyle.shapeType === appTypes.SHAPE_TYPE.ECLIPSE) {
	      iconStyle.w = (styleHelper.getWidth(this.props) - thickness) / 2 * Math.sqrt(2);
	      iconStyle.h = (styleHelper.getHeight(this.props) - thickness) / 2 * Math.sqrt(2);
	      iconStyle.x = styleHelper.getWidth(this.props) / 2 - iconStyle.w / 2;
	      iconStyle.y = styleHelper.getHeight(this.props) / 2 - iconStyle.h / 2;
	    }
	
	    iconStyle.URL = this.props.URL;
	    iconStyle.icon = this.props.icon;
	
	    if (this.props.avatarColorStyle === appTypes.AVATAR_COLOR_STYLE.NORMAL) {
	      iconStyle.color = styleHelper.getPropertyValue(this.props, 'avatarColor');
	    } else if (this.props.avatarColorStyle === appTypes.AVATAR_COLOR_STYLE.BLACK) {
	      iconStyle.color = '#000000';
	      shapeStyle.color = '#FFFFFF';
	    } else if (this.props.avatarColorStyle === appTypes.AVATAR_COLOR_STYLE.GRAY) {
	      iconStyle.color = '#FFFFFF';
	      shapeStyle.color = '#CCCCCC';
	    }
	
	    if (this.props.icon.iconCode === '62168' && this.props.icon.iconFontName === 'jdIonicons') {
	      if (shapeStyle.shapeType === appTypes.SHAPE_TYPE.RECTANGLE) {
	        iconStyle.w = Math.round(iconStyle.w * 9 / 7);
	        iconStyle.h = Math.round(iconStyle.h * 9 / 7);
	        iconStyle.x = Math.round((styleHelper.getWidth(this.props) - iconStyle.w) / 2);
	        iconStyle.y = this.props.h - Math.round(iconStyle.h * 8 / 9) - thickness + 1;
	      } else if (shapeStyle.shapeType === appTypes.SHAPE_TYPE.ECLIPSE) {
	        iconStyle.w = Math.round(iconStyle.w * 9 / 7);
	        iconStyle.h = Math.round(iconStyle.h * 9 / 7);
	        iconStyle.x = Math.round((styleHelper.getWidth(this.props) - iconStyle.w) / 2);
	        iconStyle.y = this.props.h - Math.round(iconStyle.h) - thickness + 1;
	      }
	    }
	
	    return React.createElement(
	      'div',
	      { style: {
	          width: '100%',
	          height: '100%'
	        } },
	      React.createElement(
	        ShapeParts,
	        shapeStyle,
	        React.createElement(IconParts, iconStyle)
	      )
	    );
	  }
	});
	
	module.exports = AvatarEx;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDom = __webpack_require__(12);
	var styleHelper = __webpack_require__(145);
	var appTypes = __webpack_require__(115);
	
	/**
	 * 形状部件
	 */
	var ShapeParts = React.createClass({
	  displayName: 'ShapeParts',
	
	
	  buildShapeStyle: function buildShapeStyle() {
	    var shapeStyle = {
	      width: '100%',
	      height: '100%'
	    };
	    shapeStyle.borderStyle = this.props.borderVisible ? 'solid' : 'none';
	    shapeStyle.borderColor = this.props.borderColor;
	    shapeStyle.borderWidth = this.props.thickness;
	    shapeStyle.backgroundColor = this.props.color;
	    if (this.props.shapeType === appTypes.SHAPE_TYPE.RECTANGLE) {
	      // shapeStyle.borderRadius = this.props.thickness + 'px';
	    } else if (this.props.shapeType === appTypes.SHAPE_TYPE.ECLIPSE) {
	      shapeStyle.borderRadius = '50%';
	    }
	    shapeStyle.boxSizing = 'border-box';
	
	    return shapeStyle;
	  },
	
	  render: function render() {
	    var divStyle = this.buildShapeStyle();
	
	    return React.createElement(
	      'div',
	      { id: 'avater oktest', style: divStyle },
	      this.props.children
	    );
	  }
	});
	
	module.exports = ShapeParts;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 柱状图
	 */
	var ColumnChart = React.createClass({
	    displayName: 'ColumnChart',
	
	
	    render: function render() {
	        var w = styleHelper.getWidth(this.props);
	        var chartWidth = Math.round(w / 7);
	
	        var offset = chartWidth;
	
	        var chart1Style = {
	            left: offset
	        };
	
	        offset = chartWidth * 2 + 6;
	
	        var chart2Style = {
	            left: offset
	        };
	
	        offset = chartWidth * 4;
	
	        var chart3Style = {
	            left: offset
	        };
	
	        offset = chartWidth * 5 + 6;
	        var chart4Style = {
	            left: offset
	        };
	
	        return React.createElement(
	            'div',
	            { className: 'content' },
	            React.createElement('div', { className: 'chart-one', style: chart1Style }),
	            React.createElement('div', { className: 'chart-two', style: chart2Style }),
	            React.createElement('div', { className: 'chart-three', style: chart3Style }),
	            React.createElement('div', { className: 'chart-four', style: chart4Style })
	        );
	    }
	
	});
	
	module.exports = ColumnChart;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	var util = __webpack_require__(116);
	
	/**
	 * 柱状图
	 */
	var ColumnChart = React.createClass({
	  displayName: 'ColumnChart',
	
	
	  render: function render() {
	    var style = styleHelper.StyleUtil(this.props).bounds().border().style;
	    var width = Math.round(style.width * 0.9);
	    var height = Math.round(style.height * 0.9);
	    var lineWidth = 1;
	    var offset = style.height - height - lineWidth;
	
	    var result = graphicsHelper.parseText(styleHelper.getText(this.props), 100);
	    var data_arr = result["areas"];
	    var color_arr = result["colors"];
	
	    var isShowBorder = style.borderWidth != "inherit";
	
	    var itemWidth = width / data_arr.length;
	    var className = "";
	    if (isShowBorder) {
	      className = "chart-item";
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'component-SimpleCom component-ColumnChart' },
	      data_arr.map(function (item, index) {
	        var h = Math.round(item / 100 * height * 0.9);
	        return React.createElement('div', { className: className, style: {
	            width: Math.round(itemWidth * 0.75),
	            height: h,
	            top: height - h + offset,
	            left: Math.round(itemWidth * index + itemWidth * 0.25),
	            backgroundColor: color_arr[index],
	            position: 'absolute'
	          } });
	      }, this),
	      React.createElement('div', { className: 'component-Chart-Coord' })
	    );
	  }
	
	});
	
	module.exports = ColumnChart;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 柱状图
	 */
	var BarChart = React.createClass({
	  displayName: 'BarChart',
	
	
	  render: function render() {
	    var h = styleHelper.getHeight(this.props);
	    var chartHeight = Math.round(h / 7);
	    var offset = chartHeight;
	    var chart1Style = {
	      top: offset
	    };
	    offset = chartHeight * 2 + 6;
	    var chart2Style = {
	      top: offset
	    };
	    offset = chartHeight * 4;
	    var chart3Style = {
	      top: offset
	    };
	    offset = chartHeight * 5 + 6;
	    var chart4Style = {
	      top: offset
	    };
	    return React.createElement(
	      'div',
	      { className: 'content' },
	      React.createElement('div', { className: 'chart-one', style: chart1Style }),
	      React.createElement('div', { className: 'chart-two', style: chart2Style }),
	      React.createElement('div', { className: 'chart-three', style: chart3Style }),
	      React.createElement('div', { className: 'chart-four', style: chart4Style })
	    );
	  }
	
	});
	
	module.exports = BarChart;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	var util = __webpack_require__(116);
	
	/**
	 * 柱状图
	 */
	var BarChart = React.createClass({
	  displayName: 'BarChart',
	
	
	  render: function render() {
	
	    var style = styleHelper.StyleUtil(this.props).bounds().border().style;
	    var width = Math.round(style.width * 0.9);
	    var height = Math.round(style.height * 0.9);
	    var lineWidth = 1;
	    var offset = style.height - height;
	
	    var result = graphicsHelper.parseText(styleHelper.getText(this.props), 100);
	    var data_arr = result["areas"].reverse();
	    var color_arr = result["colors"].reverse();
	
	    var isShowBorder = style.borderWidth != "inherit";
	
	    var itemHeight = height / data_arr.length;
	    var className = "";
	    if (isShowBorder) {
	      className = "chart-item";
	    }
	    return React.createElement(
	      'div',
	      { className: 'component-SimpleCom component-BarChart' },
	      data_arr.map(function (item, index) {
	        return React.createElement('div', {
	          key: index,
	          className: className, style: {
	            width: Math.round(item / 100 * width * 0.9),
	            height: Math.round(itemHeight * 0.75),
	            top: height - Math.round(itemHeight * index + itemHeight) + offset,
	            left: 0,
	            backgroundColor: color_arr[index],
	            position: 'absolute'
	          } });
	      }, this),
	      React.createElement('div', { className: 'component-Chart-Coord' })
	    );
	  }
	
	});
	
	module.exports = BarChart;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var LabelParts = __webpack_require__(174);
	var AutoSizeHelper = __webpack_require__(167);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var textHelper = __webpack_require__(116).Text;
	var CheckIcon = __webpack_require__(171);
	var RadioIcon = __webpack_require__(208);
	var versionHelper = __webpack_require__(124);
	var util = __webpack_require__(116);
	
	/**
	 * 表单组件
	 */
	
	var FormType = { NONE: 0, INPUT: 1, RADIO: 2, RADIO_SELECT: 3, CHECK: 4, CHECK_SELECT: 5, COMBO: 6, AREA: 7 };
	
	var CheckOrRadioItem = React.createClass({
	  displayName: 'CheckOrRadioItem',
	
	  render: function render() {
	    var style = this.props.style;
	    var text = styleHelper.getText(this.props) || styleHelper.getPropertyValue(this.props, 'context');
	    var content = textHelper.delimitText(text, textHelper.DM_COMMA);
	    var titleStyle = {
	      width: this.props.titleWidth,
	      height: style.height,
	      lineHeight: style.height + 'px',
	      position: 'absolute'
	    };
	    var iconStyle = { left: 0, top: (style.height - 14) / 2, size: 14, isChecked: this.props.isChecked };
	    iconStyle.isSelected = iconStyle.isChecked;
	    return React.createElement(
	      'div',
	      { style: style },
	      React.createElement(
	        'label',
	        { style: titleStyle },
	        this.props.title
	      ),
	      React.createElement(
	        'div',
	        { style: { left: this.props.titleWidth + 4, position: 'absolute' } },
	        content.map(function (item, index) {
	          var labelStyle = {
	            left: 18,
	            top: 0,
	            lineHeight: (this.props.height || style.height) + 'px',
	            textDecoration: 'inherit',
	            position: 'absolute',
	            height: style.height,
	            width: 'auto',
	            whiteSpace: 'nowrap'
	          };
	          return React.createElement(
	            'div',
	            { key: index, ref: 'item_' + index, style: { position: 'absolute' } },
	            this.props.type === 'check' && React.createElement(CheckIcon, iconStyle),
	            this.props.type === 'radio' && React.createElement(RadioIcon, iconStyle),
	            React.createElement(
	              'label',
	              { style: labelStyle },
	              item
	            )
	          );
	        }, this)
	      )
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doAdjustItemPoint();
	  },
	  doAdjustItemPoint: function doAdjustItemPoint() {
	    var i = 0;
	    var dom;
	    var k;
	    var left = 0;
	    var w;
	    var tx;
	    while (true) {
	      k = this.refs['item_' + i];
	      i++;
	      if (k) {
	        dom = ReactDOM.findDOMNode(k);
	        $(dom).css({ left: left });
	        tx = dom.children[1];
	        w = tx.clientWidth + 18;
	        left += w + 6;
	      } else {
	        break;
	      }
	    }
	  }
	});
	
	var ComboFormItem = React.createClass({
	  displayName: 'ComboFormItem',
	
	  render: function render() {
	    var style = this.props.style;
	    var contentStyle = {
	      left: this.props.titleWidth + 4,
	      top: 0,
	      position: 'absolute',
	      height: style.height
	    };
	    var titleStyle = {
	      lineHeight: style.height + 'px',
	      height: style.height,
	      width: this.props.titleWidth,
	      position: 'absolute'
	    };
	    return React.createElement(
	      'div',
	      { style: style },
	      React.createElement(
	        'label',
	        { style: titleStyle },
	        this.props.title
	      ),
	      React.createElement(
	        'div',
	        { style: contentStyle },
	        React.createElement('canvas', { ref: 'ctx', style: { width: '100%', height: '100%', position: 'absolute', zIndex: 0 } }),
	        React.createElement(
	          'label',
	          { ref: 'context', style: {
	              position: 'absolute',
	              zIndex: 1,
	              height: style.height,
	              lineHeight: titleStyle.lineHeight,
	              left: 2,
	              overflow: 'hidden'
	            } },
	          this.props.context
	        )
	      )
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doPaint();
	    $(ReactDOM.findDOMNode(this.refs.context)).css({ width: ReactDOM.findDOMNode(this.refs.ctx).width - 22 });
	  },
	
	  doPaint: function doPaint() {
	    var ctx = ReactDOM.findDOMNode(this.refs.ctx);
	    var w = ReactDOM.findDOMNode(this).clientWidth;
	    var g = ctx.getContext('2d');
	    var w = w - this.props.titleWidth - 4;
	    var h = ctx.clientHeight;
	
	    w = Math.round(w * (this.props.widthRadio || 100) / 100);
	
	    ctx.height = h;
	    ctx.width = w;
	    $(ctx).css({ width: w, height: h });
	    g.clearRect(0, 0, w, h);
	    g.strokeStyle = this.props.borderColor || '#444';
	    g.fillStyle = this.props.backgroundColor || '#fff';
	
	    g.beginPath();
	    g.rect(0, 0, w - 16, h);
	    g.closePath();
	    g.fill();
	
	    g.beginPath();
	    g.rect(0.5, 0.5, w - 1, h - 1);
	    g.moveTo(w - 16.5, 0);
	    g.lineTo(w - 16.5, h);
	    g.closePath();
	    g.stroke();
	
	    g.beginPath();
	    g.fillStyle = '#444';
	    g.moveTo(w - 12.5, (h - 4) / 2);
	    g.lineTo(w - 4.5, (h - 4) / 2);
	    g.lineTo(w - 8.5, (h + 4) / 2);
	    g.closePath();
	    g.fill();
	  }
	});
	//
	var InputOrTextAreaFormItem = React.createClass({
	  displayName: 'InputOrTextAreaFormItem',
	
	  render: function render() {
	    var style = this.props.style;
	    var titleStyle = {
	      width: this.props.titleWidth,
	      height: style.height,
	      lineHeight: this.props.type === 'input' ? style.height + 'px' : '24px',
	      position: 'absolute'
	    };
	    var contentStyle = {
	      borderWidth: 1,
	      borderStyle: 'solid',
	      position: 'absolute',
	      borderColor: this.props.borderColor,
	      backgroundColor: this.props.backgroundColor,
	      width: (this.props.widthRadio || 100) + '%',
	      height: style.height,
	      lineHeight: titleStyle.lineHeight,
	      left: this.props.titleWidth + 4,
	      textDecoration: 'inherit'
	    };
	    return React.createElement(
	      'div',
	      { style: style },
	      React.createElement(
	        'label',
	        { style: titleStyle },
	        this.props.title
	      ),
	      React.createElement(
	        'div',
	        { ref: 'content', style: contentStyle },
	        React.createElement(
	          'label',
	          null,
	          this.props.context
	        )
	      )
	    );
	  },
	  doAdjust: function doAdjust() {
	    var w = ReactDOM.findDOMNode(this).clientWidth;
	    w -= this.props.titleWidth + 4;
	    w = w * (this.props.widthRadio || 100) / 100;
	    $(ReactDOM.findDOMNode(this.refs.content)).css({ width: w });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doAdjust();
	  }
	});
	
	var Form = React.createClass({
	  displayName: 'Form',
	
	
	  _parseItemText: function _parseItemText(text) {
	
	    var resultObj = {
	      title: '',
	      content: '',
	      type: FormType.INPUT,
	      width: 100
	    };
	
	    var titleIndex = text.indexOf(',');
	    var lastIndex = text.lastIndexOf(',');
	    var configText;
	    var number;
	
	    if (titleIndex === -1) {
	      resultObj.title = text.trim();
	      return resultObj;
	    }
	
	    resultObj.title = text.substring(0, titleIndex).trim();
	
	    if (text.charAt(text.length - 1) === '=') {
	      resultObj.type = FormType.AREA;
	      resultObj.content = text.substring(titleIndex + 1, text.length - 1);
	      return resultObj;
	    }
	
	    if (lastIndex === -1 || lastIndex === titleIndex) {
	      resultObj.content = text.substring(titleIndex + 1, text.length).trim();
	      if (resultObj.content === '=') {
	        resultObj.type = FormType.AREA;
	        resultObj.content = '';
	      }
	
	      return resultObj;
	    }
	
	    resultObj.content = text.substring(titleIndex + 1, lastIndex).trim();
	    configText = text.substring(lastIndex + 1, text.length).trim();
	
	    if (configText) {
	      number = parseInt(configText, 10);
	      if (number == configText) {
	        if (number < 30) {
	          number = 30;
	        } else if (number > 100) {
	          number = 100;
	        }
	        resultObj.width = number;
	      } else {
	        if (configText.charAt(0) === 'v') {
	          configText = configText.substring(1, configText.length);
	          number = parseInt(configText, 10);
	          if (number == configText) {
	            resultObj.width = number;
	          }
	          resultObj.type = FormType.COMBO;
	        } else if (configText === '[]') {
	          resultObj.type = FormType.CHECK;
	        } else if (configText === '[x]') {
	          resultObj.type = FormType.CHECK_SELECT;
	        } else if (configText === '()') {
	          resultObj.type = FormType.RADIO;
	        } else if (configText === '(o)') {
	          resultObj.type = FormType.RADIO_SELECT;
	        } else {
	          resultObj.content = text.substring(titleIndex + 1, text.length).trim();
	        }
	      }
	    }
	    return resultObj;
	  },
	
	  _parseText: function _parseText() {
	    var resultArray = [];
	    var textArray = this.props.text.split('\n');
	
	    textArray.forEach(function (text) {
	      resultArray.push(this._parseItemText(text.trim()));
	    }.bind(this));
	
	    return resultArray;
	  },
	
	  _getTitleWidth: function _getTitleWidth(itemArray) {
	    var width = 0;
	    var size;
	
	    itemArray.forEach(function (data) {
	      size = data.title ? AutoSizeHelper.getComAutoSize(this.props, data.title) : 0;
	
	      if (size.width > width) {
	        width = size.width;
	      }
	    }.bind(this));
	
	    return width;
	  },
	
	  render: function render() {
	    var itemArray = this._parseText();
	
	    var backgroundStyle = {
	      width: '100%',
	      height: '100%'
	    };
	
	    var titleWidth = this._getTitleWidth(itemArray);
	    var self = this;
	
	    if (titleWidth) {
	      titleWidth += 4;
	    }
	
	    return React.createElement(
	      'div',
	      { style: backgroundStyle },
	      itemArray.map(function (itemData, index) {
	        var baseStyle;
	        //处理老版本表单组件不显示问题
	        var area;
	        if (versionHelper.isPageVersionLowerThan4_5()) {
	          var links = self.props.links.link;
	          area = links[index].area.coords;
	        } else {
	          area = {};
	          var h = styleHelper.getHeight(self.props);
	          var gap = this.props.gap;
	          var count = itemArray.length;
	          area.width = styleHelper.getWidth(self.props);
	          area.height = (h - gap * (count - 1)) / count;
	          area.left = 0;
	          area.top = index * (area.height + gap);
	        }
	        baseStyle = $.extend({}, styleHelper.builderTextStyle(this.props), {
	          position: 'absolute',
	          height: area.height,
	          width: styleHelper.getWidth(this.props),
	          top: area.top,
	          textDecoration: 'inherit'
	        });
	        if ([FormType.CHECK, FormType.CHECK_SELECT, FormType.RADIO, FormType.RADIO_SELECT].indexOf(itemData.type) !== -1) {
	          return React.createElement(CheckOrRadioItem, {
	            type: [FormType.CHECK, FormType.CHECK_SELECT].indexOf(itemData.type) !== -1 ? 'check' : 'radio',
	            title: itemData.title,
	            context: itemData.content,
	            titleWidth: titleWidth,
	            isChecked: itemData.type === FormType.CHECK_SELECT || itemData.type === FormType.RADIO_SELECT,
	            style: baseStyle
	          });
	        } else if (itemData.type === FormType.COMBO) {
	          return React.createElement(ComboFormItem, {
	            title: itemData.title,
	            context: itemData.content,
	            titleWidth: titleWidth,
	            style: baseStyle,
	            widthRadio: itemData.width,
	            borderColor: this.props.borderColor,
	            backgroundColor: this.props.color
	          });
	        } else {
	          return React.createElement(InputOrTextAreaFormItem, {
	            title: itemData.title,
	            context: itemData.content,
	            titleWidth: titleWidth,
	            style: baseStyle,
	            widthRadio: itemData.width,
	            borderColor: this.props.borderColor,
	            backgroundColor: this.props.color,
	            type: itemData.type === FormType.INPUT ? 'input' : 'textArea'
	          });
	        }
	      }.bind(this))
	    );
	  }
	});
	
	module.exports = Form;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var ColorImage = __webpack_require__(234);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	
	var TextField = React.createClass({
	  displayName: 'TextField',
	
	  render: function render() {
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var showIcon = styleHelper.getPropertyValue(this.props, propConst.SHOW_ICON);
	    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
	    var color = styleHelper.getTextColor(this.props);
	    var bgColor = '#444';
	    if (state === appTypes.ComStatus2.DISABLE) {
	      color = '#999';
	      bgColor = '#999';
	    }
	    return React.createElement(
	      'div',
	      { className: 'text-field-content', style: {
	          width: w,
	          height: h,
	          color: color
	        } },
	      this.renderInput(color),
	      React.createElement(ColorImage, { style: { position: 'absolute', left: 0, bottom: 0, width: w - (showIcon ? 30 : 0), height: 4 }, color: bgColor, src: assetsHelper.getComponentAsset('TextField') }),
	      showIcon && React.createElement(ColorImage, { color: bgColor, style: { right: 0, bottom: 0, width: 25, height: 25, position: 'absolute' }, src: assetsHelper.getComponentAsset('Send') })
	    );
	  },
	
	  renderInput: function renderInput(color) {
	    var size = styleHelper.getSize(this.props);
	
	    var style = {
	      width: size.width - (this.props.showIcon ? 40 : 0),
	      paddingBottom: 2,
	      backgroundColor: 'rgba(0,0,0,0)'
	    };
	    styleHelper.StyleUtil(this.props, style).align().text();
	    style.color = color;
	    if (_.isUndefined(this.props.canInput) || this.props.canInput) {
	      return React.createElement('input', { style: style, defaultValue: styleHelper.getText(this.props) });
	    } else {
	      return React.createElement('input', { style: style, disabled: true, defaultValue: styleHelper.getText(this.props) });
	    }
	  }
	});
	
	module.exports = TextField;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	var graphicsHelper = __webpack_require__(172);
	
	var Spinner = React.createClass({
	  displayName: 'Spinner',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'component component-spinner', style: { width: '100%', height: '100%' } },
	      this.renderLabel(),
	      React.createElement('canvas', { width: styleHelper.getWidth(this.props),
	        height: styleHelper.getHeight(this.props), style: { position: 'absolute' }, ref: 'ctx' })
	    );
	  },
	  renderLabel: function renderLabel() {
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
	    var fontSize = styleHelper.getFontSize(this.props);
	    var style = {
	      width: w - 18,
	      position: 'absolute',
	      left: 5,
	      top: 0,
	      height: fontSize,
	      lineHeight: fontSize + 'px',
	      whiteSpace: 'nowrap'
	    };
	    var divStyle = {
	      width: style.width,
	      height: fontSize + 5,
	      bottom: 0,
	      position: 'absolute',
	      overflow: 'hidden'
	    };
	    styleHelper.StyleUtil(this.props, style).text();
	    if (state === appTypes.ComStatus2.DISABLE) {
	      style.color = '#e0e0e0';
	    }
	    return React.createElement(
	      'div',
	      { style: divStyle },
	      React.createElement(
	        'label',
	        { style: style },
	        styleHelper.getText(this.props)
	      )
	    );
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.doPaint();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.doPaint();
	  },
	
	  doPaint: function doPaint() {
	    var ctx = ReactDOM.findDOMNode(this.refs.ctx);
	    var g = ctx.getContext('2d');
	    var clientRect = ctx.getBoundingClientRect();
	    var w = clientRect.width;
	    var h = clientRect.height;
	    var state = styleHelper.getPropertyValue(this.props, propConst.STATUS);
	    var ratio = graphicsHelper.applyDeviceRatio(g, w, h);
	    var iconSize = 12 * ratio;
	    var c = state === appTypes.ComStatus2.DISABLE ? '#E0E0E0' : '#444';
	    graphicsHelper.clearRect(g);
	    //g.clearRect(0, 0, clientRect.width, clientRect.height);
	
	    w *= ratio;
	    h *= ratio;
	    g.beginPath();
	    g.strokeStyle = c;
	    g.lineWidth = ratio;
	    g.moveTo(0, h - 0.5 * ratio);
	    g.lineTo(w, h - 0.5 * ratio);
	    g.closePath();
	    g.stroke();
	
	    g.beginPath();
	    g.fillStyle = c;
	    g.moveTo(w, h - iconSize);
	    g.lineTo(w, h);
	    g.lineTo(w - iconSize, h);
	    g.closePath();
	    g.fill();
	  }
	});
	
	module.exports = Spinner;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var _ = __webpack_require__(51);
	var IconPart = __webpack_require__(233);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 告警图标
	 * @author mxj
	 */
	var AlarmIcon = React.createClass({
	  displayName: 'AlarmIcon',
	
	  render: function render() {
	    var props = _.extend({}, this.props);
	
	    this.builderIconProps(props);
	
	    return React.createElement(
	      'div',
	      { className: 'alarm-icon-content' },
	      React.createElement('div', { className: 'round-rect', style: this.getRectStyle() }),
	      React.createElement(
	        'span',
	        { className: 'alarm-text', style: this.builderTextStyle() },
	        '2'
	      ),
	      React.createElement(
	        'div',
	        { className: 'alarm-icon', style: this.getIconWapperStyle() },
	        React.createElement(IconPart, props)
	      )
	    );
	  },
	
	  builderIconProps: function builderIconProps(props) {
	    var s = styleHelper.getWidth(this.props);
	    props.defaultIcon = 'email.png';
	    props.color = '#444';
	    props.h = props.w = styleHelper.getWidth(this.props) * 6 / 7 - 24;
	    props.x = props.y = (s - props.h) / 2;
	  },
	
	  getRectStyle: function getRectStyle() {
	    return {
	      width: styleHelper.getWidth(this.props) * 6 / 7,
	      height: styleHelper.getHeight(this.props) * 6 / 7
	    };
	  },
	
	  builderTextStyle: function builderTextStyle() {
	    return {
	      width: styleHelper.getWidth(this.props) * 2 / 7,
	      height: styleHelper.getHeight(this.props) * 2 / 7,
	      lineHeight: styleHelper.getHeight(this.props) * 2 / 7 + 'px'
	    };
	  },
	
	  getIconWapperStyle: function getIconWapperStyle() {
	    return {
	      left: 0,
	      top: 0 //styleHelper.getHeight(this.props) / 7 + 12
	    };
	  }
	});
	
	module.exports = AlarmIcon;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	var propConst = __webpack_require__(147);
	var ColorImage = __webpack_require__(234);
	
	var NavigationBar = React.createClass({
	  displayName: 'NavigationBar',
	
	  render: function render() {
	    var bgColor = styleHelper.getBackgroundColor(this.props);
	    var isLightColor = util.Color.isLight(bgColor);
	
	    var color = styleHelper.getPropertyValue(this.props, propConst.FOREGROUND_COLOR);
	    if (this.props.IsAutoTextColor) {
	      if (isLightColor) {
	        color = '#000';
	      } else {
	        color = '#fff';
	      }
	    }
	    return React.createElement(
	      'div',
	      {
	        className: 'navigation-bar-content',
	        style: {
	          width: '100%',
	          height: '100%',
	          backgroundColor: bgColor
	        } },
	      React.createElement(ColorImage, _extends({
	        src: assetsHelper.getComponentAsset('navigationbar'),
	        height: 48,
	        width: styleHelper.getWidth(this.props),
	        color: color
	      }, { style: {
	          width: styleHelper.getWidth(this.props),
	          height: 48,
	          position: 'absolute',
	          top: (styleHelper.getHeight(this.props) - 48) / 2
	        } }))
	    );
	  }
	});
	
	module.exports = NavigationBar;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	var Keyboard = React.createClass({
	  displayName: 'Keyboard',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      {
	        className: 'component-Keyboard' },
	      React.createElement('img', { width: '100%', height: '100%', src: assetsHelper.getComponentAsset(this.getKeyboard()) })
	    );
	  },
	  getKeyboard: function getKeyboard() {
	    var keyboards = {
	      ktGridNine_SmHori: 'iphoneKeyboard_landscape_number',
	      ktLetter_SmHori: 'iphoneKeyboard_landscape_letter',
	      ktGridNine_SmVert: 'iphoneKeyboard_portrait_number',
	      ktLetter_SmVert: 'iphoneKeyboard_portrait_letter',
	      ktNumber_SmHori: 'iphoneKeyboard_landscape_symbol',
	      ktNumber_SmVert: 'iphoneKeyboard_portrait_symbol'
	    };
	    return keyboards[this.props.keyboardType + '_' + this.props.direction];
	  }
	});
	
	module.exports = Keyboard;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assestsHelper = __webpack_require__(65);
	
	var VolumeSlider = React.createClass({
	  displayName: 'VolumeSlider',
	
	  propTypes: {
	    opacity: React.PropTypes.string,
	    w: React.PropTypes.number,
	    h: React.PropTypes.number
	  },
	  render: function render() {
	    return React.createElement(
	      'div',
	      { style: {
	          width: '100%',
	          height: '100%'
	        } },
	      React.createElement(
	        'div',
	        { className: 'content' },
	        React.createElement('img', { src: assestsHelper.getComponentAsset('volumeslider'), alt: '' })
	      )
	    );
	  }
	});
	
	module.exports = VolumeSlider;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var graphicsHelper = __webpack_require__(172);
	var styleHelper = __webpack_require__(145);
	
	var VideoPlayer = React.createClass({
	  displayName: 'VideoPlayer',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'video-player-content' },
	      React.createElement(
	        'div',
	        { className: 'bottom' },
	        React.createElement(
	          'canvas',
	          { ref: 'canvas', style: { width: '100%', height: '100%' }, width: styleHelper.getWidth(this.props) - 4, height: 27 },
	          React.createElement('img', { ref: 'img', src: assetsHelper.getComponentAsset('videoplayer'),
	            onLoad: this.onImageLoaded })
	        )
	      )
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.paint();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.paint();
	  },
	
	  onImageLoaded: function onImageLoaded() {
	    this.isLoaded = true;
	    this.paint();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  paint: function paint() {
	    if (this.isLoaded) {
	      this.requestID = window.requestAnimationFrame(this.doPaint);
	    }
	  },
	
	  doPaint: function doPaint() {
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas).getContext('2d');
	    var img = ReactDOM.findDOMNode(this.refs.img);
	    var img9 = {
	      left: 100,
	      right: 120
	    };
	    //canvas.canvas.width = this.props.w - 4;
	    //canvas.canvas.height = 27;
	    graphicsHelper.drawHorizontalThreeGridImage(canvas, img, 150, 151, { left: 0, top: 0, right: this.props.w - 4, bottom: 27 });
	    //graphicsHelper.drawNineGridImage(canvas,img,img9,{left :0,top : 0,right : this.props.w,bottom : 27});
	  }
	});
	
	module.exports = VideoPlayer;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	var Media_Control = React.createClass({
	  displayName: 'Media_Control',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'component-SimpleCom' },
	      React.createElement('img', { width: '100%', height: '100%', src: assetsHelper.getComponentAsset('media_control'), alt: '' })
	    );
	  }
	});
	
	module.exports = Media_Control;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	var PieChart = React.createClass({
	  displayName: 'PieChart',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'component-SimpleCom' },
	      React.createElement('img', { width: '100%', height: '100%', src: assetsHelper.getComponentAsset('pieChart'), alt: '' })
	    );
	  }
	});
	
	module.exports = PieChart;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var appTypes = __webpack_require__(115);
	
	var graphicsHelper = __webpack_require__(172);
	
	var PieChart = React.createClass({
	  displayName: 'PieChart',
	
	
	  fillCanvas: function fillCanvas() {
	
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    var context = canvas.getContext('2d');
	    var style = styleHelper.StyleUtil(this.props).bounds().border().style;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var ratio = graphicsHelper.applyDeviceRatio(context, w, h);
	    w *= ratio;
	    h *= ratio;
	    var result = graphicsHelper.parseText(styleHelper.getText(this.props));
	
	    var data_arr = result["areas"];
	    var color_arr = result["colors"];
	
	    var startAngle = -90 * Math.PI / 180; //起始弧度
	    var endAngle = -90 * Math.PI / 180; //结束弧度
	
	    context.lineWidth = ratio;
	    if (style.borderWidth != "inherit") {
	      //判断是否隐藏边框
	      graphicsHelper.drawEllipse(context, w, h, style.borderColor);
	    }
	
	    var total = 0.0;
	    for (var i = 0; i < data_arr.length; i++) {
	      total += data_arr[i];
	    }
	    for (var i = 0; i < data_arr.length; i++) {
	      //绘制饼图
	      endAngle = endAngle + data_arr[i] / total * Math.PI * 2; //结束弧度
	      graphicsHelper.drawEllipseByAngle(context, w, h, startAngle, endAngle, color_arr[i]);
	      startAngle = endAngle; //设置起始弧度
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.fillCanvas();
	    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this._onResize);
	  },
	
	  _onResize: function _onResize() {
	    this.fillCanvas();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.fillCanvas();
	  },
	
	  render: function render() {
	    //获取饼状图宽高，统一canvas与饼图宽高
	    var style = styleHelper.StyleUtil(this.props).size().style;
	    return React.createElement(
	      'div',
	      { className: 'component-SimpleCom' },
	      React.createElement(
	        'canvas',
	        { ref: 'canvas', width: style.width, height: style.height },
	        '\u6D4F\u89C8\u5668\u4E0D\u652F\u6301canvas'
	      )
	    );
	  }
	
	});
	
	module.exports = PieChart;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	var Map = React.createClass({
	  displayName: 'Map',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'component-SimpleCom' },
	      React.createElement('img', { width: '100%', height: '100%', src: assetsHelper.getComponentAsset('map'), alt: '' })
	    );
	  }
	});
	
	module.exports = Map;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var _ = __webpack_require__(51);
	var assetsHelper = __webpack_require__(65);
	var projectLoadHelper = __webpack_require__(68);
	var HorizontalScrollBar = __webpack_require__(184);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 图片流
	 */
	var CoverFlow = React.createClass({
	  displayName: 'CoverFlow',
	
	  render: function render() {
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    return React.createElement(
	      'div',
	      null,
	      React.createElement(
	        'div',
	        { style: { position: 'relative' } },
	        React.createElement('img', { width: w, height: h, src: assetsHelper.getComponentAsset('coverFlow'), alt: '' }),
	        this.renderCover()
	      ),
	      this.props.horizontalScrollbarShow && React.createElement(
	        'div',
	        { style: { height: 14, position: 'absolute', width: '100%' } },
	        React.createElement(HorizontalScrollBar, {
	          value: parseInt(this.props.horizontalScrollbarProgress, 10),
	          left: 180 / 985 * w - 3,
	          width: (810 - 180) / 985 * w
	        })
	      )
	    );
	  },
	  renderCover: function renderCover() {
	    var imgURL = this.props.URL;
	    var measureW = 992;
	    var measureH = 404;
	    var coverLeft = 310;
	    var coverTop = 45;
	    var coverRight = 683;
	    var coverBottom = 337;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var ratioW = w / measureW;
	    var ratioH = h / measureH;
	    var style;
	    if (_.isEmpty(imgURL)) {
	      return;
	    }
	    style = {
	      position: 'absolute',
	      left: coverLeft * ratioW,
	      top: coverTop * ratioH,
	      width: (coverRight - coverLeft) * ratioW,
	      height: (coverBottom - coverTop) * ratioH
	    };
	    //todo: meng xiao jiang 07-20 这里还未作滤镜处理
	    return React.createElement('img', { style: style, src: projectLoadHelper.loadImage(imgURL), alt: '' });
	  }
	});
	
	module.exports = CoverFlow;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	var EditToolbar = React.createClass({
	  displayName: 'EditToolbar',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { style: {
	          width: '100%',
	          height: '100%',
	          border: '1px solid #000',
	          backgroundColor: '#fff'
	        } },
	      React.createElement('img', { src: assetsHelper.getComponentAsset('editToolbar'), alt: '' })
	    );
	  }
	});
	
	module.exports = EditToolbar;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var FormattingToolbar = React.createClass({
	  displayName: 'FormattingToolbar',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { style: {
	          width: '100%',
	          height: '100%',
	          border: '1px solid #000',
	          backgroundColor: '#fff'
	        } },
	      React.createElement('img', { src: assetsHelper.getComponentAsset('formatting'), alt: '' })
	    );
	  }
	});
	
	module.exports = FormattingToolbar;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	var HelpButton = React.createClass({
	  displayName: 'HelpButton',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      null,
	      React.createElement('img', { src: assetsHelper.getComponentAsset('helpButton') })
	    );
	  }
	});
	
	module.exports = HelpButton;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	/**
	 * 拨号页面
	 */
	var QuickContact = React.createClass({
	  displayName: 'QuickContact',
	
	  render: function render() {
	    return React.createElement('img', { className: 'component-SimpleCom',
	      src: assetsHelper.getComponentAsset('QuickContact')
	    });
	  }
	});
	
	module.exports = QuickContact;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	/**
	 * 联系人
	 */
	var AvatarMobile = React.createClass({
	  displayName: 'AvatarMobile',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'avatar-content' },
	      React.createElement(
	        'div',
	        { className: 'background' },
	        React.createElement('img', { src: assetsHelper.getComponentAsset('Avatar(Mobile)')
	        })
	      ),
	      React.createElement('div', { className: 'triangle' })
	    );
	  }
	});
	
	module.exports = AvatarMobile;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var _ = __webpack_require__(51);
	var util = __webpack_require__(116);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 字母导航，需要根据字母进行canvas绘制
	 */
	var LetterNavigation = React.createClass({
	  displayName: 'LetterNavigation',
	
	  render: function render() {
	    var charArray = util.Text.delimitToWords('A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z');
	    var h = styleHelper.getHeight(this.props);
	    var s = 1;
	    var labelStyle = {
	      height: h / 26,
	      fontSize: Math.round(h / 26 * 0.75),
	      color: styleHelper.getBackgroundColor(this.props)
	    };
	
	    if (labelStyle.fontSize < 12) {
	      s = labelStyle.fontSize / 12;
	      labelStyle.transform = 'scale(' + s + ',' + s + ')';
	      labelStyle.transformOrigin = 'center';
	      labelStyle.height /= s;
	    }
	    var currentStyle;
	    return React.createElement(
	      'div',
	      null,
	      charArray.map(function (text, index) {
	        currentStyle = _.extend({}, labelStyle, {
	          top: h / 26 * index
	        });
	        return React.createElement(
	          'label',
	          { key: index, style: currentStyle },
	          text
	        );
	      }, this)
	    );
	  }
	});
	
	module.exports = LetterNavigation;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	/**
	 * 时间选择器
	 */
	var TimePicker = React.createClass({
	  displayName: 'TimePicker',
	
	  render: function render() {
	    return React.createElement('img', { className: 'component-SimpleCom',
	      src: assetsHelper.getComponentAsset('TimePicker')
	    });
	  }
	});
	
	module.exports = TimePicker;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	/**
	 * 时间选择器
	 */
	var TimePicker2 = React.createClass({
	  displayName: 'TimePicker2',
	
	  render: function render() {
	    return React.createElement('img', { className: 'component-SimpleCom',
	      src: assetsHelper.getComponentAsset('TimePicker2')
	    });
	  }
	});
	
	module.exports = TimePicker2;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Border = __webpack_require__(168);
	var IconParts = __webpack_require__(233);
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	
	var IconButton = React.createClass({
	  displayName: 'IconButton',
	
	
	  _getBorderRadius: function _getBorderRadius(buttonStyle) {
	
	    switch (buttonStyle) {
	      case appTypes.IconButtonStyle.CIRCLE:
	        return '50%';
	        break;
	      case appTypes.IconButtonStyle.RECTANGLE:
	        return '0px';
	        break;
	      case appTypes.IconButtonStyle.ROUND_RECTANGLE:
	        return Math.round(8 * (styleHelper.getWidth(this.props) / 64)) + 'px';
	        break;
	    }
	  },
	
	  render: function render() {
	    var w = styleHelper.getWidth(this.props);
	    var borderStyle = {
	      borderStyle: styleHelper.getPropertyValue(this.props, propConst.BORDER_VISIBLE) ? 'solid' : 'none',
	      borderWidth: w < 48 ? 1 : 2,
	      borderRadius: this._getBorderRadius(this.props.buttonStyle),
	      boxSizing: 'border-box',
	      left: 0,
	      top: 0,
	      width: '100%',
	      height: '100%',
	      background: styleHelper.getBackgroundColor(this.props),
	      borderColor: styleHelper.getBorderColor(this.props)
	    };
	    var iconSize = Math.round(w * 0.6);
	    var iconPoint = Math.round(w * 0.2);
	    var props = _.extend({}, this.props);
	    delete props.currentX;
	    delete props.currentY;
	    delete props.currentW;
	    delete props.currentH;
	    props.x = props.y = iconPoint;
	    props.w = props.h = iconSize;
	    props.defaultIcon = 'Gt.png';
	    props.color = styleHelper.getPropertyValue(this.props, propConst.ICON_COLOR);
	
	    return React.createElement(
	      'div',
	      { style: borderStyle },
	      React.createElement(IconParts, props)
	    );
	  }
	});
	
	module.exports = IconButton;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var _ = __webpack_require__(51);
	var appTypes = __webpack_require__(115);
	var LabelParts = __webpack_require__(174);
	var IconParts = __webpack_require__(233);
	var styleHelper = __webpack_require__(145);
	var propConst = __webpack_require__(147);
	
	/**
	 * 图标按钮
	 */
	var IconLabel = React.createClass({
	  displayName: 'IconLabel',
	
	  render: function render() {
	    var props = _.extend({}, this.props);
	    props.x = props.y = 0;
	    delete props.currentX;
	    delete props.currentY;
	    delete props.currentW;
	    delete props.currentH;
	
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var backgroundStyle = {
	      width: '100%',
	      height: '100%'
	    };
	    var iconStyle;
	    var labelStyle;
	    var size = styleHelper.getInt(this.props, propConst.SIZE);
	    props.w = props.h = size;
	    switch (this.props.iconDirection) {
	      case appTypes.IconLabelDirection.TEXT_BOTTOM:
	        props.x = (w - size) / 2;
	        labelStyle = {
	          bottom: 0,
	          width: '100%',
	          textAlign: 'center'
	        };
	        break;
	      case appTypes.IconLabelDirection.TEXT_LEFT:
	        props.x = w - size;
	        labelStyle = {
	          height: '100%',
	          lineHeight: h + 'px',
	          left: 0
	        };
	
	        break;
	      case appTypes.IconLabelDirection.TEXT_RIGHT:
	        labelStyle = {
	          height: '100%',
	          lineHeight: h + 'px',
	          right: 0
	        };
	        break;
	    }
	    labelStyle.position = 'absolute';
	    labelStyle.overflow = 'none';
	    return React.createElement(
	      'div',
	      { style: backgroundStyle },
	      React.createElement(IconParts, props),
	      React.createElement(LabelParts, _extends({}, this.props, { partStyle: labelStyle }))
	    );
	  }
	});
	
	module.exports = IconLabel;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Border = __webpack_require__(168);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 顶部操作栏
	 */
	var TopActionBar = React.createClass({
	  displayName: 'TopActionBar',
	
	  render: function render() {
	    var size = 6;
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var bg = styleHelper.getBackgroundColor(this.props);
	    var fontStyle = styleHelper.StyleUtil(this.props).text().style;
	
	    var borderStyle = {
	      backgroundColor: bg
	    };
	
	    var menuStyle = {
	      top: (h - 24) / 2
	    };
	    var menuItemStyle = {
	      borderColor: this.props.iconColor
	    };
	
	    var backStyle = {
	      top: (h - 18) / 2,
	      borderColor: this.props.iconColor
	    };
	
	    var PHeight = 16;
	    var PStyle = $.extend({}, fontStyle, {
	      textAlign: 'center',
	      lineHeight: PHeight + 'px',
	      height: PHeight,
	      margin: (this.props.h - PHeight) / 2 + 'px' + ' 0',
	      fontSize: this.props.textSize
	    });
	
	    return React.createElement(
	      'div',
	      { className: 'component-TopActionBar', style: borderStyle },
	      this.props.showMenu && React.createElement(
	        'div',
	        { className: 'menu', style: menuStyle },
	        React.createElement('div', { className: 'menu-line', style: menuItemStyle }),
	        React.createElement('div', { className: 'menu-line', style: menuItemStyle }),
	        React.createElement('div', { className: 'menu-line', style: menuItemStyle })
	      ),
	      React.createElement(
	        'p',
	        { style: PStyle },
	        this.props.text
	      ),
	      this.props.showBack && React.createElement(
	        'div',
	        { className: 'back', style: { height: h } },
	        React.createElement('div', { className: 'back-icon', style: backStyle })
	      )
	    );
	  }
	});
	
	module.exports = TopActionBar;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var LabelParts = __webpack_require__(174);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	
	/**
	 * 上下文操作栏
	 */
	var ContextActionBar = React.createClass({
	  displayName: 'ContextActionBar',
	
	
	  render: function render() {
	    var size = styleHelper.getSize(this.props);
	    var backgroundStyle = {
	      width: size.width,
	      height: size.height,
	      backgroundColor: styleHelper.getBackgroundColor(this.props)
	    };
	
	    var margin = 8;
	    var imgWidth = 32;
	
	    var pasteImgStyle = {
	      position: 'absolute',
	      top: (size.height - imgWidth) / 2,
	      width: imgWidth,
	      height: imgWidth,
	      right: margin
	    };
	
	    var cutImgStyle = {
	      position: 'absolute',
	      top: (size.height - imgWidth) / 2,
	      width: imgWidth,
	      height: imgWidth,
	      right: margin * 2 + imgWidth
	    };
	
	    var selectAllImgStyle = {
	      position: 'absolute',
	      top: (size.height - imgWidth) / 2,
	      width: imgWidth,
	      height: imgWidth,
	      right: margin * 3 + imgWidth * 2
	    };
	
	    var checkMarkStyle = {
	      position: 'absolute',
	      top: (size.height - imgWidth) / 2,
	      width: imgWidth,
	      height: imgWidth,
	      left: margin
	    };
	
	    var lineStyle = {
	      position: 'absolute',
	      top: (size.height - imgWidth) / 2,
	      width: 2,
	      height: imgWidth,
	      left: margin * 2 + imgWidth,
	      backgroundColor: '#808080'
	    };
	
	    var textStyle = {
	      position: 'absolute',
	      top: (size.height - imgWidth) / 2,
	      width: size.width - (margin * 3 + imgWidth + 2) - (margin * 4 + imgWidth * 3),
	      height: imgWidth,
	      lineHeight: imgWidth + 'px',
	      left: margin * 3 + imgWidth + 2,
	      overflow: 'hidden',
	      fontFamily: this.props.textFontFamily || decodeURIComponent(this.props.font.family)
	    };
	
	    return React.createElement(
	      'div',
	      { style: backgroundStyle },
	      React.createElement('img', { src: assetsHelper.getComponentAsset('CheckMark'), style: checkMarkStyle }),
	      React.createElement('div', { style: lineStyle }),
	      React.createElement(LabelParts, _extends({}, this.props, { partStyle: textStyle })),
	      React.createElement('img', { src: assetsHelper.getComponentAsset('AndroidSelectedAll'), style: selectAllImgStyle }),
	      React.createElement('img', { src: assetsHelper.getComponentAsset('AndroidCut'), style: cutImgStyle }),
	      React.createElement('img', { src: assetsHelper.getComponentAsset('AndroidPaste'), style: pasteImgStyle })
	    );
	  }
	});
	
	module.exports = ContextActionBar;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var LabelParts = __webpack_require__(174);
	var styleHelper = __webpack_require__(145);
	var util = __webpack_require__(116);
	
	/**
	 * 弹出选择条
	 */
	var ControlPopOver = React.createClass({
	  displayName: 'ControlPopOver',
	
	
	  _getCharacterCount: function _getCharacterCount(textArray) {
	    var i = 0;
	    var characterCount = 0;
	
	    for (i = 0; i < textArray.length; i++) {
	      if (textArray[i] === '') {
	        characterCount = characterCount + 1;
	      } else {
	        characterCount = characterCount + textArray[i].length;
	      }
	    }
	
	    return characterCount;
	  },
	
	  _getCharacterFixedSize: function _getCharacterFixedSize(textArray) {
	    return textArray.length * (this.marginHorizontal * 2 + this.separatorWidth) + this.rightWidth;
	  },
	
	  _getCorrectItems: function _getCorrectItems(textArray) {
	    var textItems = [];
	    var i = 0;
	
	    for (i = 0; i < textArray.length; i++) {
	      textItems.push(textArray[i]);
	      textItems.push('_'); // separator
	    }
	
	    return textItems;
	  },
	
	  render: function render() {
	    this.rightWidth = 40;
	    this.marginHorizontal = 10;
	    this.marginVertical = 6;
	    this.selectThumbHeight = 8;
	    this.separatorWidth = 1;
	
	    var textArray = util.Text.delimitText(styleHelper.getText(this.props), util.Text.DM_COMMA);
	    var w = styleHelper.getWidth(this.props);
	    var h = styleHelper.getHeight(this.props);
	    var characterWidth = (w - this._getCharacterFixedSize(textArray)) / this._getCharacterCount(textArray);
	
	    var backgroundStyle = {
	      width: '100%',
	      height: '100%'
	    };
	
	    var topBackgroundStyle = {
	      width: w,
	      height: h - this.selectThumbHeight,
	      backgroundColor: '#000',
	      borderRadius: 8,
	      position: 'absolute',
	      top: 0
	    };
	
	    var bottomBackgroundStyle = {
	      width: w,
	      height: this.selectThumbHeight,
	      position: 'absolute',
	      top: topBackgroundStyle.height + topBackgroundStyle.top,
	      display: this.state.selectedIndex === -1 ? 'none' : 'block'
	    };
	
	    var itemStyle;
	    var separatorStyle;
	    var offset = 0;
	    var textItems = this._getCorrectItems(textArray);
	    var selectedIndexSize = {
	      left: 0,
	      width: 0
	    };
	    var rightStyle = {
	      right: 0,
	      width: this.rightWidth,
	      height: topBackgroundStyle.height,
	      position: 'absolute',
	      top: 0,
	      borderRadius: 8
	    };
	    var rightTriangleStyle = {
	      left: '50%',
	      top: '50%',
	      position: 'absolute',
	      transform: 'translate(-50%, -50%)',
	      width: 0,
	      height: 0,
	      borderTop: '6px solid transparent',
	      borderBottom: '6px solid transparent',
	      borderLeft: '12px solid #fff'
	    };
	
	    return React.createElement(
	      'div',
	      { style: backgroundStyle },
	      React.createElement(
	        'div',
	        { style: topBackgroundStyle },
	        React.createElement(
	          'div',
	          { style: rightStyle },
	          React.createElement('div', { style: rightTriangleStyle })
	        ),
	        textItems.map(function (text, index) {
	
	          if (index % 2 === 1) {
	            separatorStyle = {
	              width: this.separatorWidth,
	              height: topBackgroundStyle.height,
	              backgroundColor: '#fff',
	              left: offset,
	              position: 'absolute',
	              top: 0
	            };
	
	            offset = offset + this.separatorWidth;
	
	            return React.createElement('div', { key: 'ControlPopOver item' + index, style: separatorStyle });
	          }
	
	          itemStyle = {
	            position: 'absolute',
	            left: offset + this.marginHorizontal,
	            top: 0,
	            width: characterWidth * (text ? text.length : 1),
	            height: topBackgroundStyle.height,
	            lineHeight: topBackgroundStyle.height + 'px',
	            textAlign: 'center',
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            fontFamily: this.props.textFontFamily || decodeURIComponent(this.props.font.family)
	          };
	
	          if (index / 2 === this.state.selectedIndex) {
	            selectedIndexSize = {
	              left: itemStyle.left,
	              width: itemStyle.width
	            };
	          }
	
	          offset = offset + itemStyle.width + 2 * this.marginHorizontal;
	
	          return React.createElement(
	            'div',
	            {
	              style: itemStyle,
	              onClick: this.onItemClick.bind(this, null, index / 2) },
	            React.createElement(LabelParts, _extends({ key: 'ControlPopOver item' + index }, this.props, { text: text }))
	          );
	        }.bind(this))
	      ),
	      React.createElement(
	        'div',
	        { style: bottomBackgroundStyle },
	        React.createElement(
	          'div',
	          { style: {
	              position: 'absolute',
	              left: selectedIndexSize.left,
	              width: selectedIndexSize.width,
	              height: bottomBackgroundStyle.height
	            } },
	          React.createElement('div', { style: {
	              position: 'absolute',
	              width: 0,
	              height: 0,
	              left: (selectedIndexSize.width - 12) / 2,
	              borderLeft: '8px solid transparent',
	              borderRight: '8px solid transparent',
	              borderTop: '8px solid #000'
	            } })
	        )
	      )
	    );
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: this.props.selectedIndex
	    };
	  },
	
	  onItemClick: function onItemClick(e, index) {
	    this.setState({ selectedIndex: index });
	  },
	
	  componentDidMount: function componentDidMount() {
	    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
	  }
	});
	
	module.exports = ControlPopOver;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var Border = __webpack_require__(168);
	var i18n = __webpack_require__(46);
	var util = __webpack_require__(116);
	var styleHelper = __webpack_require__(145);
	var LinkHelper = __webpack_require__(158);
	var graphicsHelper = __webpack_require__(172);
	
	var Node = React.createClass({
	  displayName: 'Node',
	
	  render: function render() {
	    return React.createElement(
	      Border,
	      _extends({ key: 'border' }, {
	        borderWidth: 1,
	        borderColor: '#444',
	        borderVisible: true,
	        color: '#fff',
	        partStyle: {
	          width: this.props.rect.right - this.props.rect.left,
	          height: this.props.rect.bottom - this.props.rect.top,
	          left: this.props.rect.left,
	          top: this.props.rect.top,
	          textAlign: 'center',
	          textDecoration: 'inherit',
	          whiteSpace: 'pre',
	          position: 'absolute'
	        }
	      }),
	      React.createElement(
	        'p',
	        { ref: 'text' },
	        this.props.text
	      )
	    );
	  },
	
	  componentDidMount: function componentDidMount() {
	    var p = ReactDOM.findDOMNode(this.refs.text);
	    $(p).css({ 'margin-top': (this.props.rect.height - p.clientHeight) / 2 - 2, padding: 0 });
	  }
	});
	
	var SiteMap = React.createClass({
	  displayName: 'SiteMap',
	
	  parseTreeNode: function parseTreeNode(node, nodes, leave) {
	    var i = 0;
	    if (!leave) {
	      node = nodes[0];
	      leave = 1;
	    }
	    if (nodes.length) {
	      node.children = [];
	      i = node.index + 1;
	      for (i; i < nodes.length; i++) {
	        //查找下一级子节点
	        if (nodes[i].leave === leave + 1) {
	          node.children.push(nodes[i]);
	        }
	        //如果碰到与自己平级或高级的节点，结束当前循环
	        else if (nodes[i].leave <= leave) {
	            break;
	          }
	      }
	    }
	    if (node.children && node.children.length) {
	      i = 0;
	      for (i; i < node.children.length; i++) {
	        this.parseTreeNode(node.children[i], nodes, node.children[i].leave);
	      }
	    } else {
	      delete node.children;
	    }
	    return node;
	  },
	
	  parseToNodes: function parseToNodes() {
	    var nodes = [];
	    var textArr = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)), util.Text.DM_RETURN);
	    var item;
	    var leave;
	    var links = LinkHelper.tranItemRect(this.props.itemRect) || this.props.links.link;
	    try {
	      textArr.map(function (text, index) {
	        leave = 1;
	        item = {};
	        while (text.charAt(0) === '-') {
	          leave++;
	          text = text.substring(1);
	        }
	        text = util.Text.convertSpaceToNbsp(text);
	        item.text = text.trim().replace(/\\r/g, '\n');
	        item.leave = leave;
	        item.index = index;
	        item.rect = links[index].area ? links[index].area.coords : links[index];
	        util.Rect.init(item.rect);
	        nodes.push(item);
	      }, this);
	    } catch (e) {
	      this.isError = true;
	    }
	    return nodes;
	  },
	
	  render: function render() {
	    var nodes = this.parseToNodes();
	    var _nodes = nodes.slice();
	    var errorText;
	    var errorArr;
	
	    if (!this.isError) {
	      this.rootNode = this.parseTreeNode({}, nodes);
	    } else {
	      errorText = i18n.get('SITE_MAP_ERROR');
	      if (errorText) {
	        errorArr = util.Text.delimitText(errorText, util.Text.DM_RETURN);
	      }
	    }
	    return React.createElement(
	      'div',
	      { style: {
	          fontSize: this.props.textSize,
	          fontFamily: this.props.textFontFamily || decodeURIComponent(this.props.font.family),
	          color: this.props.textColor,
	          fontWeight: this.props.textStyles.fontWeight,
	          fontStyle: this.props.textStyles.fontStyle,
	          textDecoration: this.props.textStyles.textDecoration,
	          height: '100%',
	          width: '100%'
	        } },
	      this.isError && React.createElement(
	        'div',
	        { style: { width: '100%', height: '100%', textAlign: 'center', border: '1px solid #444', backgroundColor: '#fff' } },
	        React.createElement(
	          'div',
	          { ref: 'err', style: { width: '100%', height: 'auto', whiteSpace: 'nowrap', overflow: 'hidden' } },
	          errorArr && errorArr.map(function (err) {
	            return React.createElement(
	              'div',
	              { key: 'error' },
	              err
	            );
	          })
	        )
	      ),
	      !this.isError && React.createElement(
	        'div',
	        { style: { textDecoration: 'inherit' } },
	        _nodes.map(function (node, index) {
	          return React.createElement(Node, _extends({ key: index }, node));
	        }),
	        React.createElement('canvas', { ref: 'link', style: { width: '100%', height: '100%' }, width: styleHelper.getWidth(this.props), height: styleHelper.getHeight(this.props) })
	      )
	    );
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.requestID) {
	      cancelAnimationFrame(this.requestID);
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    var graphics;
	    var self;
	    var div;
	    if (this.isError) {
	      div = ReactDOM.findDOMNode(this.refs.err);
	      $(div).css({ 'padding-top': (this.props.h - div.clientHeight) / 2 + 'px' });
	      return;
	    }
	    self = this;
	    this.requestID = window.requestAnimationFrame(function () {
	      var canvas = ReactDOM.findDOMNode(self.refs.link);
	      if (!canvas) {
	        return;
	      }
	      var graphics = canvas.getContext('2d');
	      var ratio = graphicsHelper.applyDeviceRatio(graphics, styleHelper.getWidth(self.props), styleHelper.getHeight(self.props));
	      graphics.beginPath();
	      graphics.strokeStyle = '#444';
	      graphics.strokeWidth = ratio;
	      self.doPaintLine(self.rootNode, graphics, ratio);
	    });
	  },
	
	  getNodeRect: function getNodeRect(node, ratio) {
	    var rect = { left: node.rect.left, top: node.rect.top, right: node.rect.right, bottom: node.rect.bottom };
	    util.Rect.init(rect);
	    util.Rect.scale(rect, ratio, ratio, false);
	    return rect;
	  },
	
	  doPaintLine: function doPaintLine(node, graphics, ratio) {
	    var rect = this.getNodeRect(node, ratio); // {left:node.rect.left,top:node.rect.top,width:node.rect.width,height:node.rect.height};
	    var startPoint = {
	      x: (rect.left + rect.right) / 2,
	      y: rect.bottom
	    };
	    console.log(rect, graphics.canvas.width);
	    var child = node.children;
	    var crect;
	    var i = 0;
	    var cnode;
	    var endPoint;
	    var turnX;
	    var turnY;
	    var l = child.length;
	    for (i; i < l; i++) {
	      cnode = child[i];
	      crect = this.getNodeRect(cnode, ratio); // cnode.rect;
	      endPoint = {
	        x: (crect.left + crect.right) / 2,
	        y: crect.top
	      };
	      turnX = Math.round(startPoint.x) - graphics.strokeWidth / 2;
	      turnY = Math.round(startPoint.y) - graphics.strokeWidth / 2;
	      graphics.moveTo(turnX, turnY);
	      if (endPoint.x === startPoint.x || l === 1) {
	        turnX = Math.round(startPoint.x) - graphics.strokeWidth / 2;
	        turnY = Math.round(endPoint.y) - graphics.strokeWidth / 2;
	        graphics.lineTo(turnX, turnY);
	      } else {
	        //turnY = Math.round((startPoint.y + endPoint.y) / 2) - graphics.strokeWidth / 2;
	        turnY = endPoint.y - 25 * ratio - graphics.strokeWidth / 2;
	        graphics.lineTo(turnX, turnY);
	        turnX = Math.round(endPoint.x) - graphics.strokeWidth / 2;
	        graphics.lineTo(turnX, turnY);
	        turnY = Math.round(endPoint.y) - graphics.strokeWidth / 2;
	        graphics.lineTo(turnX, turnY);
	      }
	      graphics.stroke();
	      if (cnode.children) {
	        this.doPaintLine(cnode, graphics, ratio);
	      }
	    }
	  }
	});
	
	module.exports = SiteMap;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var CompositeIconBase = __webpack_require__(316);
	var IconButton2 = React.createClass({
	  displayName: 'IconButton2',
	
	  render: function render() {
	    return React.createElement(
	      CompositeIconBase,
	      _extends({}, this.props, {
	        borderVisible: true,
	        alarmVisible: this.props.showAlarm,
	        iconVisible: true,
	        labelVisible: this.props.showText }),
	      this.props.children
	    );
	  }
	});
	
	module.exports = IconButton2;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var Shape = __webpack_require__(210);
	var Label = __webpack_require__(194);
	var Icon = __webpack_require__(232);
	var _ = __webpack_require__(51);
	var styleHelper = __webpack_require__(145);
	
	var CompositeIconBase = React.createClass({
	  displayName: 'CompositeIconBase',
	
	  propTypes: {
	    borderVisible: React.PropTypes.bool,
	    labelVisible: React.PropTypes.bool,
	    alarmVisible: React.PropTypes.bool
	  },
	
	  render: function render() {
	    var itemProps = this.initItemProps();
	    var borderVisible = this.props.style !== 'ibsNone';
	    var iconStyle = this.initPointStyle(itemProps.icon, 1);
	    var iconBorderStyle = {};
	    if (borderVisible) {
	      iconBorderStyle = {
	        left: itemProps.border.x,
	        top: itemProps.border.y,
	        width: itemProps.border.w,
	        height: itemProps.border.h,
	        borderColor: itemProps.border.borderColor,
	        borderStyle: 'solid',
	        borderWidth: itemProps.border.borderVisible ? itemProps.border.thickness : 0,
	        boxSizing: 'border-box',
	        position: 'relative',
	        backgroundColor: itemProps.border.color
	      };
	      if (itemProps.border.shapeBorderType === 'SbEllipse') {
	        // 圆形
	        iconBorderStyle.borderRadius = '50%';
	      }
	      if (itemProps.border.shapeBorderType === 'SbRectangle') {
	        //矩形
	        if (itemProps.border.radiusIsPercent) {
	          var length = Math.min(itemProps.border.w, itemProps.border.h);
	          length = length * itemProps.border.radius / 200;
	          if (itemProps.border.borderVisible) {
	            length = length + itemProps.border.thickness;
	          } else {
	            length = length + itemProps.border.thickness * 2;
	          }
	          iconBorderStyle.borderRadius = length;
	        } else {
	          iconBorderStyle.borderRadius = itemProps.border.radius;
	        }
	      }
	    }
	
	    //特殊处理空图标情况，使用div的border代替图标。
	    var isEmpty = false;
	    if ((itemProps.icon.ID || _.isEmpty(itemProps.icon.ID)) && _.isEmpty(itemProps.icon.URL) && !itemProps.icon.defaultIcon) {
	      isEmpty = true;
	      var borderWidth = itemProps.icon.h > 64 ? 2 : 1;
	      var color = styleHelper.getBackgroundColor(this.props);
	      var radius = parseInt(itemProps.icon.h / 6, 10);
	      iconStyle.border = borderWidth + 'px solid ' + color;
	      iconStyle.borderRadius = radius + 'px';
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'contents-layout' },
	      borderVisible && React.createElement('div', { style: iconBorderStyle }),
	      React.createElement(
	        'div',
	        { style: iconStyle },
	        !isEmpty && React.createElement(Icon, _extends({ ref: 'icon', key: 'icon' }, itemProps.icon, { borderVisible: false }))
	      ),
	      this.props.labelVisible && React.createElement(
	        'div',
	        { style: this.initPointStyle(itemProps.label, 2) },
	        React.createElement(Label, _extends({ ref: 'label', key: 'label' }, itemProps.label))
	      ),
	      this.props.alarmVisible && React.createElement(
	        'div',
	        { style: this.initPointStyle(itemProps.alarm, 3) },
	        React.createElement(Shape, _extends({ ref: 'alarm', key: 'alarm' }, itemProps.alarm, { textWordWrap: false }))
	      )
	    );
	  },
	
	  initItemProps: function initItemProps() {
	    var alarm = _.extend({}, this.props.items[3]);
	    var border = _.extend({}, this.props.items[0]);
	    var label = _.extend({}, this.props.items[2]);
	    var icon = _.extend({}, this.props.items[1]);
	    if (this.props.currentTextColor) {
	      label.currentTextColor = this.props.currentTextColor;
	    } else {
	      delete label.currentTextColor;
	    }
	    if (this.props.currentColor) {
	      icon.currentColor = this.props.currentColor;
	    } else {
	      //此处颜色获取有问题，处理图标颜色应用错误的问题
	      //icon.currentColor = this.props.color;
	      icon.currentColor = icon.color;
	    }
	    var style = this.props.style;
	
	    //不明白为何要在这里重设以下属性
	    alarm.radiusIsPercent = false;
	    alarm.radius = alarm.h / 2;
	    alarm.textSize = alarm.textSize || 12; //为处理告警图标中文字大小问题，做兼容处理
	
	    if (style === 'ibsNone') {
	      border.borderVisible = false;
	      border.borderColor = 'transparent';
	      border.color = 'transparent';
	    }
	    return {
	      border: border,
	      icon: icon,
	      label: label,
	      alarm: alarm
	    };
	  },
	
	  initPointStyle: function initPointStyle(props, zIndex) {
	    if (!zIndex) {
	      zIndex = 0;
	    }
	    return {
	      left: props.x,
	      top: props.y,
	      width: props.w,
	      height: props.h,
	      position: 'absolute',
	      border: 'none',
	      pointerEvents: 'none',
	      zIndex: zIndex,
	      whiteSpace: 'nowrap'
	    };
	  }
	});
	
	module.exports = CompositeIconBase;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var CompositeIconBase = __webpack_require__(316);
	var IconLabel2 = React.createClass({
	  displayName: 'IconLabel2',
	
	  render: function render() {
	
	    return React.createElement(
	      CompositeIconBase,
	      _extends({}, this.props, {
	        borderVisible: false,
	        alarmVisible: this.props.showAlarm || false,
	        iconVisible: true,
	        labelVisible: this.props.showText }),
	      this.props.children
	    );
	  }
	});
	
	module.exports = IconLabel2;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var CompositeIconBase = __webpack_require__(316);
	/**
	 * AlarmIcon2
	 * 新告警图标
	 */
	var AlarmIcon2 = React.createClass({
	  displayName: 'AlarmIcon2',
	
	  render: function render() {
	    return React.createElement(
	      CompositeIconBase,
	      _extends({}, this.props, {
	        borderVisible: this.props.style !== 'ibsNone',
	        alarmVisible: this.props.showAlarm,
	        iconVisible: true,
	        labelVisible: this.props.showText }),
	      this.props.children
	    );
	  }
	});
	
	module.exports = AlarmIcon2;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(11);
	var CompositeIconBase = __webpack_require__(316);
	var IconButtonCommon = React.createClass({
	  displayName: 'IconButtonCommon',
	
	  render: function render() {
	    return React.createElement(
	      CompositeIconBase,
	      _extends({}, this.props, {
	        borderVisible: false,
	        alarmVisible: false,
	        iconVisible: true,
	        labelVisible: true }),
	      this.props.children
	    );
	  }
	});
	
	module.exports = IconButtonCommon;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var IconBar = React.createClass({
	  displayName: 'IconBar',
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'component component-iconbar contents-layout',
	        style: {
	          overflow: 'hidden'
	        } },
	      this.props.children
	    );
	  }
	});
	
	module.exports = IconBar;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var appTypes = __webpack_require__(115);
	var linkHelper = __webpack_require__(158);
	
	var Timer = React.createClass({
	  displayName: 'Timer',
	
	
	  propTypes: {
	    interval: React.PropTypes.number
	  },
	
	  componentDidMount: function componentDidMount() {
	    var self = this;
	    this.delayFun = setTimeout(function () {
	      self.parseInteractive();
	    }, this.props.interval || 1000);
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    // clearTimeout(this.delayFun);
	    // var self = this;
	    // this.delayFun = setTimeout(function() {
	    //   self.parseInteractive();
	    // }, this.props.interval || 1000);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.delayFun) {
	      clearTimeout(this.delayFun);
	    }
	  },
	
	  render: function render() {
	    return React.createElement('div', null);
	  },
	
	  parseInteractive: function parseInteractive() {
	    var k;
	    var actionData;
	
	    if (this.props.interactiveData || this.props.links) {
	      actionData = linkHelper.parseComInteractive(this.props)[0];
	    }
	    if (actionData) {
	      k = appTypes.ActionResponseType.NONE;
	      if (actionData.link) {
	        k = appTypes.ActionResponseType.LINK;
	        if (this.props.events && this.props.events.doSelfClick) {
	          this.props.events.doSelfClick({}, this.props, k, 0);
	        }
	      }
	    }
	  }
	});
	
	module.exports = Timer;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var RuntimeOptions = __webpack_require__(153);
	var linkHelper = __webpack_require__(158);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	var propConst = __webpack_require__(147);
	/*
	 @Author : allen
	 @CreateDate : 2017-8-21
	 @Descript : 格子组件
	 */
	var Group = React.createClass({
	  displayName: 'Group',
	
	  actionData: {},
	  render: function render() {
	    if (this.props.interactiveData || this.props.links) {
	      this.actionData = linkHelper.parseComInteractive(this.props)[0];
	    }
	    var haveAction = this.actionData.externalURL || this.actionData.link || this.actionData.entry;
	    var isLink = this.actionData.externalURL || this.actionData.link;
	    var className = 'no-link';
	    var linkStyle = {
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      userSelect: 'none',
	      position: 'absolute',
	      //此处链接区域应该置于上层
	      //注意检查：改动该属性是否有副作用
	      zIndex: 800,
	      pointerEvents: 'none'
	    };
	    if (haveAction) {
	      if (isLink) {
	        className = 'page-link';
	      } else {
	        className = 'interactive-link';
	      }
	    }
	    var style = {
	      cursor: haveAction ? 'pointer' : 'default',
	      overflow: 'hidden'
	    };
	    var borderLineWidth = this.props.thickness || 1;
	    var borderDashMode = styleHelper.parseDashMode(this.props.dashMode) || 'solid';
	    var borderColor = this.props.borderColor || '#000000';
	    if (this.props.borderVisible) {
	      style.border = borderLineWidth + 'px ' + borderDashMode + ' ' + borderColor;
	    }
	    return React.createElement(
	      'div',
	      {
	        className: 'component component-Group',
	        style: style,
	        onClick: this._onClick,
	        onMouseDown: this._onMouseDown,
	        onMouseUp: this._onMouseUp,
	        onDoubleClick: this._onDblClick,
	        onContextMenu: this._onContentMenu
	      },
	      this.renderDivision(),
	      haveAction && React.createElement('div', { className: className,
	        style: linkStyle
	
	      }),
	      React.createElement(
	        'div',
	        { style: { position: 'absolute', zIndex: 1 } },
	        this.props.children
	      )
	    );
	  },
	
	  //渲染分割线
	  renderDivision: function renderDivision() {
	    var style = {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      width: '100%',
	      height: '100%',
	      boxSizing: 'border-box'
	    };
	    this.currentW = styleHelper.getWidth(this.props);
	    this.currentH = styleHelper.getHeight(this.props);
	    style.zIndex = -1;
	    return React.createElement('canvas', {
	      ref: 'canvas',
	      style: style,
	      onChange: this.paint.bind(this, this.props),
	      width: this.currentW,
	      height: this.currentH });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.paint();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.paint();
	  },
	
	  paint: function paint() {
	    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    if (canvas === null) {
	      return;
	    }
	    var dashMode = styleHelper.parseDashMode(this.props.separatorDashMode);
	    //todo :PC上的形状的三角形的旋转方向居然与其它的旋转方向是相反的！！！
	    var ctx = canvas.getContext('2d');
	
	    var itemWidth = parseInt(this.props.itemWidth, 10);
	    var itemHeight = parseInt(this.props.itemHeight, 10);
	    var horiGap = parseInt(this.props.horiGap || 20, 10);
	    var vertGap = parseInt(this.props.vertGap || 20, 10);
	    graphicsHelper.drawDivision(ctx, {
	      width: this.currentW,
	      height: this.currentH,
	      dashMode: dashMode,
	      lineColor: this.props.separatorColor,
	      thickness: this.props.separatorThickness,
	      margin: this.props.separatorMargin,
	      itemWidth: itemWidth,
	      itemHeight: itemHeight,
	      horiGap: horiGap,
	      vertGap: vertGap,
	      showSeparator: this.props.showSeparator
	    });
	  },
	
	  _onContentMenu: function _onContentMenu(e) {
	    e.nativeEvent.returnValue = false;
	    return false;
	  },
	
	  _onLinkEvent: function _onLinkEvent(evt, linkKey) {
	    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
	    this.props.events.doSelfClick(evt, this.props, linkKey, 0);
	  },
	
	  _onClick: function _onClick(e) {
	    var key;
	    if (this.longPress) {
	      return;
	    }
	    if (e.button === 0) {
	      if (this.actionData.externalURL) {
	        key = appTypes.ActionResponseType.OUTER;
	      } else if (this.actionData.link) {
	        key = appTypes.ActionResponseType.LINK;
	      } else if (this.actionData.entry) {
	        key = appTypes.ActionResponseType.INTERACTIVE;
	      }
	      if (key) {
	        this._onLinkEvent(e, key);
	      }
	    } else if (e.button === 2) {
	      this._onRightClick(e);
	    }
	  },
	
	  _onLongPress: function _onLongPress(evt) {
	    if (this.props.events.doSelfLongPress) this.props.events.doSelfLongPress(evt, this.props, 0);
	  },
	
	  _onRightClick: function _onRightClick(evt) {
	    if (this.props.events.doSelfRightClick) {
	      this.props.events.doSelfRightClick(evt, this.props, 0);
	    }
	  },
	
	  _onDblClick: function _onDblClick(evt) {
	    if (this.props.events.doSelfDbClick) {
	      this.props.events.doSelfDbClick(evt, this.props, 0);
	    }
	  },
	
	  _onMouseDown: function _onMouseDown(e) {
	    if (e.button === 0) {
	      this.mousePress = true;
	      this._startLongPress(e);
	    }
	  },
	
	  _onMouseUp: function _onMouseUp(e) {
	    this.mousePress = false;
	    this._stopLongPress();
	  },
	  _startLongPress: function _startLongPress(e) {
	    var self = this;
	    self.longPress = false;
	    if (linkHelper.hasLongPressEvents(this.props.interactiveData, 0)) {
	      this.longPressTimeID = setTimeout(function () {
	        if (self.mousePress) {
	          self.longPress = true;
	          self._onLongPress(e);
	        }
	        self._stopLongPress();
	      }, 800);
	    }
	  },
	
	  _stopLongPress: function _stopLongPress() {
	    if (this.longPressTimeID) {
	      clearTimeout(this.longPressTimeID);
	    }
	    delete this.longPressTimeID;
	  }
	});
	
	module.exports = Group;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var RuntimeOptions = __webpack_require__(153);
	var linkHelper = __webpack_require__(158);
	var appTypes = __webpack_require__(115);
	var styleHelper = __webpack_require__(145);
	var graphicsHelper = __webpack_require__(172);
	var propConst = __webpack_require__(147);
	/*
	 @Author : allen
	 @CreateDate : 2017-8-21
	 @Descript : 格子中单个子项
	 */
	var Group = React.createClass({
	  displayName: 'Group',
	
	  actionData: {},
	  render: function render() {
	    if (this.props.interactiveData || this.props.links) {
	      this.actionData = linkHelper.parseComInteractive(this.props)[0];
	    }
	    var haveAction = this.actionData.externalURL || this.actionData.link || this.actionData.entry;
	    var isLink = this.actionData.externalURL || this.actionData.link;
	    var className = 'no-link';
	    var linkStyle = {
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      userSelect: 'none',
	      position: 'absolute',
	      //此处链接区域应该置于上层
	      //注意检查：改动该属性是否有副作用
	      zIndex: 800,
	      pointerEvents: 'none'
	    };
	    if (haveAction) {
	      if (isLink) {
	        className = 'page-link';
	      } else {
	        className = 'interactive-link';
	      }
	    }
	    return React.createElement(
	      'div',
	      {
	        className: 'component component-Group',
	        style: {
	          cursor: haveAction ? 'pointer' : 'default',
	          overflow: 'hidden'
	        },
	        onClick: this._onClick,
	        onMouseDown: this._onMouseDown,
	        onMouseUp: this._onMouseUp,
	        onDoubleClick: this._onDblClick,
	        onContextMenu: this._onContentMenu
	      },
	      haveAction && React.createElement('div', { className: className,
	        style: linkStyle
	
	      }),
	      React.createElement(
	        'div',
	        { style: { position: 'absolute', zIndex: 1 } },
	        this.props.children
	      )
	    );
	  },
	
	  _onContentMenu: function _onContentMenu(e) {
	    e.nativeEvent.returnValue = false;
	    return false;
	  },
	
	  _onLinkEvent: function _onLinkEvent(evt, linkKey) {
	    RuntimeOptions.eventTargetCom = ReactDOM.findDOMNode(this);
	    this.props.events.doSelfClick(evt, this.props, linkKey, 0);
	  },
	
	  _onClick: function _onClick(e) {
	    var key;
	    if (this.longPress) {
	      return;
	    }
	    if (e.button === 0) {
	      if (this.actionData.externalURL) {
	        key = appTypes.ActionResponseType.OUTER;
	      } else if (this.actionData.link) {
	        key = appTypes.ActionResponseType.LINK;
	      } else if (this.actionData.entry) {
	        key = appTypes.ActionResponseType.INTERACTIVE;
	      }
	      if (key) {
	        this._onLinkEvent(e, key);
	      }
	    } else if (e.button === 2) {
	      this._onRightClick(e);
	    }
	  },
	
	  _onLongPress: function _onLongPress(evt) {
	    if (this.props.events.doSelfLongPress) this.props.events.doSelfLongPress(evt, this.props, 0);
	  },
	
	  _onRightClick: function _onRightClick(evt) {
	    if (this.props.events.doSelfRightClick) {
	      this.props.events.doSelfRightClick(evt, this.props, 0);
	    }
	  },
	
	  _onDblClick: function _onDblClick(evt) {
	    if (this.props.events.doSelfDbClick) {
	      this.props.events.doSelfDbClick(evt, this.props, 0);
	    }
	  },
	
	  _onMouseDown: function _onMouseDown(e) {
	    if (e.button === 0) {
	      this.mousePress = true;
	      this._startLongPress(e);
	    }
	  },
	
	  _onMouseUp: function _onMouseUp(e) {
	    this.mousePress = false;
	    this._stopLongPress();
	  },
	  _startLongPress: function _startLongPress(e) {
	    var self = this;
	    self.longPress = false;
	    if (linkHelper.hasLongPressEvents(this.props.interactiveData, 0)) {
	      this.longPressTimeID = setTimeout(function () {
	        if (self.mousePress) {
	          self.longPress = true;
	          self._onLongPress(e);
	        }
	        self._stopLongPress();
	      }, 800);
	    }
	  },
	
	  _stopLongPress: function _stopLongPress() {
	    if (this.longPressTimeID) {
	      clearTimeout(this.longPressTimeID);
	    }
	    delete this.longPressTimeID;
	  }
	});
	
	module.exports = Group;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Components = __webpack_require__(142);
	var _ = __webpack_require__(51);
	
	var Bottom = React.createClass({
	  displayName: 'Bottom',
	
	  propTypes: {
	    components: React.PropTypes.array.isRequired,
	    pageSize: React.PropTypes.shape({
	      width: React.PropTypes.number,
	      height: React.PropTypes.number
	    }).isRequired,
	    bottom: React.PropTypes.number.isRequired,
	    events: React.PropTypes.object.isRequired,
	    onLinkClick: React.PropTypes.func.isRequired,
	    onLoad: React.PropTypes.func.isRequired
	  },
	  render: function render() {
	    var limit = this.props.pageSize.height - this.props.bottom;
	    var bottom = this.props.bottom;
	    var shouldRenderComponents = _.filter(this.props.components, function (item) {
	      return item.y + item.h > limit;
	    });
	    return React.createElement(
	      'div',
	      { key: 'bottom-page', className: 'page-bottom', style: {
	          width: '100%',
	          height: this.props.bottom,
	          bottom: 0,
	          position: 'absolute',
	          overflow: 'hidden'
	        } },
	      React.createElement(
	        'div',
	        { className: 'page-container', style: { marginTop: -this.props.pageSize.height + this.props.bottom } },
	        React.createElement(Components, {
	          components: shouldRenderComponents,
	          events: this.props.events,
	          onLoad: this.props.onLoad
	        })
	      )
	    );
	  }
	});
	
	module.exports = Bottom;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Components = __webpack_require__(142);
	var ScrollView = __webpack_require__(214);
	
	var Log = __webpack_require__(159);
	
	var tool = __webpack_require__(121);
	
	// 是否启用延迟加载, 启用后, 第一次只加载页面内能看到的内容, 稍后再加载所有内容
	var ENABLE_DELAY_RENDER = false;
	
	var Middle = React.createClass({
	  displayName: 'Middle',
	
	  propTypes: {
	    screenSize: React.PropTypes.shape({
	      width: React.PropTypes.string,
	      height: React.PropTypes.string
	    }).isRequired,
	    pageSize: React.PropTypes.shape({
	      width: React.PropTypes.number,
	      height: React.PropTypes.number
	    }).isRequired,
	    domSize: React.PropTypes.shape({
	      width: React.PropTypes.number,
	      height: React.PropTypes.number
	    }),
	    top: React.PropTypes.number.isRequired,
	    bottom: React.PropTypes.number.isRequired,
	    events: React.PropTypes.object.isRequired,
	    canFix: React.PropTypes.bool.isRequired,
	    onLinkClick: React.PropTypes.func.isRequired,
	    onLoad: React.PropTypes.func.isRequired,
	    onPageScroll: React.PropTypes.func.isRequired
	  },
	  getInitialState: function getInitialState() {
	    return this.getState(this.props);
	  },
	  getState: function getState(props) {
	    var renderComponents = [];
	    var delayRenderComponents = [];
	    var top = this.props.top;
	    var bottom = parseInt(this.props.screenSize.height, 10);
	
	    if (!ENABLE_DELAY_RENDER) {
	      return {
	        components: props.components,
	        delayRenderComponents: []
	      };
	    }
	    props.components.forEach(function (item) {
	      if (item.y >= top && item.y <= bottom) {
	        renderComponents.push(item);
	      } else {
	        delayRenderComponents.push(item);
	      }
	    });
	    return {
	      components: renderComponents,
	      delayRenderComponents: delayRenderComponents
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState(this.getState(nextProps));
	  },
	  componentDidMount: function componentDidMount() {
	    this.renderDelayedComponents();
	
	    tool.setThumbOpaicty(ReactDOM.findDOMNode(this), 0);
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.renderDelayedComponents();
	
	    var dom = ReactDOM.findDOMNode(this);
	    var vertThumb = tool.getVertThumb(dom);
	    var horiThumb = tool.getHoriThumb(dom);
	
	    if (this.timerId) {
	      clearTimeout(this.timerId);
	    }
	    $(vertThumb).css('opacity', 1);
	    $(horiThumb).css('opacity', 1);
	    this.timerId = setTimeout(function () {
	      if (vertThumb) {
	        $(vertThumb).animate({ opacity: "0" }, 600);
	      }
	      if (horiThumb) {
	        $(horiThumb).animate({ opacity: "0" }, 600);
	      }
	    }, 800);
	
	    if (this.hasShow) {
	      this.hasShow = false;
	    }
	  },
	  renderDelayedComponents: function renderDelayedComponents() {
	    if (this.state.delayRenderComponents.length > 0) {
	      this.setState({
	        components: this.state.components.concat(this.state.delayRenderComponents),
	        delayRenderComponents: []
	      });
	    }
	  },
	  render: function render() {
	    var scrollViewHeight;
	    var domSize = this.props.domSize;
	    if (domSize) {
	      scrollViewHeight = Math.min(domSize.height, this.props.screenSize.height) - this.props.top - this.props.bottom;
	    } else {
	      scrollViewHeight = this.props.screenSize.height - this.props.top - this.props.bottom;
	    }
	    var style = {
	      width: '100%',
	      height: scrollViewHeight,
	      overflow: 'auto',
	      top: this.props.top
	    };
	    if (!this.props.canFix) {
	      style.height = '100%';
	    }
	    return React.createElement(
	      'div',
	      { key: 'middle-page', className: 'page-middle', style: style },
	      React.createElement(
	        ScrollView,
	        {
	          onScroll: this.onScroll
	        },
	        React.createElement(
	          'div',
	          { className: 'page-container',
	            style: {
	              marginTop: -this.props.top,
	              height: this.props.pageSize.height - this.props.bottom,
	              width: this.props.pageSize.width
	            } },
	          React.createElement(Components, {
	            components: this.state.components,
	            events: this.props.events,
	            onLoad: this.props.onLoad })
	        )
	      )
	    );
	  },
	
	  onScroll: function onScroll(top, left) {
	    this.props.onPageScroll(top, left);
	
	    if (!this.hasShow) {
	
	      tool.setThumbOpaicty(ReactDOM.findDOMNode(this), 1);
	
	      this.hasShow = true;
	    }
	  }
	});
	
	module.exports = Middle;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Components = __webpack_require__(142);
	var appTypes = __webpack_require__(115);
	
	var Popup = React.createClass({
	  displayName: 'Popup',
	
	  propTypes: {
	    components: React.PropTypes.array.isRequired,
	    height: React.PropTypes.string.isRequired,
	    events: React.PropTypes.object.isRequired,
	    onLinkClick: React.PropTypes.func.isRequired,
	    onLoad: React.PropTypes.func.isRequired,
	    pageScrollTop: React.PropTypes.number.isRequired
	  },
	
	  offsetY: function offsetY(comps, scrollTop) {
	    var _this = this;
	
	    if (!comps || !scrollTop) {
	      return;
	    }
	    var cloneComps = JSON.parse(JSON.stringify(comps));
	    return cloneComps.map(function (comp) {
	      return Object.assign(comp, {}, {
	        y: comp.y - scrollTop,
	        items: _this.offsetY(comp.items, scrollTop)
	      });
	    });
	  },
	
	  // getInitialState: function() {
	  //   //处理拉长页面下，弹出面板的显示位置
	  //   var scrollTop = this.props.pageScrollTop;
	  //   var comps = this.offsetY(this.props.components, scrollTop);
	  //   return {
	  //     comps: comps || this.props.components
	  //   }
	  // },
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { key: 'popup-page', className: 'page-popup', style: {
	          height: 0,
	          zIndex: 20,
	          position: 'absolute',
	          left: 0,
	          top: 0,
	          width: 0
	        } },
	      React.createElement(Components, {
	        components: this.props.components,
	        events: this.props.events,
	        onLoad: this.props.onLoad
	      })
	    );
	  },
	
	  isCanEvents: function isCanEvents() {
	    var r = false;
	    var i = 0;
	    var item;
	    for (i; i < this.props.components.length; i++) {
	      item = this.props.components[i];
	      if (item.closeByClickMode !== appTypes.PopupPanelClosePolicy.NONE) {
	        r = true;
	        break;
	      }
	    }
	    return r;
	  }
	});
	
	module.exports = Popup;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var appTypes = __webpack_require__(115);
	var _ = __webpack_require__(51);
	
	exports.getLinkAnimateBySaveLinkAnimate = function (animateType) {
	  switch (animateType) {
	    case appTypes.PageLinkAnimateType.NONE:
	      return '';
	    case appTypes.PageLinkAnimateType.PUSH_LEFT:
	      return 'push-left';
	    case appTypes.PageLinkAnimateType.PUSH_RIGHT:
	      return 'push-right';
	    case appTypes.PageLinkAnimateType.PUSH_UP:
	      return 'push-up';
	    case appTypes.PageLinkAnimateType.PUSH_DOWN:
	      return 'push-down';
	    case appTypes.PageLinkAnimateType.SLIDE_LEFT:
	      return 'slide-left';
	    case appTypes.PageLinkAnimateType.SLIDE_RIGHT:
	      return 'slide-right';
	    case appTypes.PageLinkAnimateType.SLIDE_UP:
	      return 'slide-up';
	    case appTypes.PageLinkAnimateType.SLIDE_DOWN:
	      return 'slide-down';
	    case appTypes.PageLinkAnimateType.FADE:
	      return 'fade';
	    case appTypes.PageLinkAnimateType.IRIS:
	      return '';
	  }
	  return '';
	};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Tree = __webpack_require__(329);
	var envHelper = __webpack_require__(48);
	
	var MobilePreviewPanel = React.createClass({
	  displayName: 'MobilePreviewPanel',
	
	  propTypes: {
	    app: React.PropTypes.object,
	    current: React.PropTypes.object,
	    showPanel: React.PropTypes.bool.isRequired,
	    onOpenPage: React.PropTypes.func.isRequired
	  },
	  getInitialState: function getInitialState() {
	    var queryHeight = location.search;
	    var statusBarHeight = 30; //默认边距
	    var isWxMiniApp = false;
	    if (envHelper.isWxMiniApp()) {
	      //是微信小程序环境
	      isWxMiniApp = true;
	      if (queryHeight.length > 1) {
	        //高度未初始化且小程序传递了手机状态栏的高度
	        queryHeight.substr(1).split('&').forEach(function (item) {
	          var queryItemArr = item.split('=');
	          if (queryItemArr[0] === 'statusbarheight') {
	            statusBarHeight = queryItemArr[1]; //设置状态栏上边距
	          }
	        });
	      }
	    }
	    return {
	      isWxMiniApp: isWxMiniApp,
	      statusBarHeight: statusBarHeight
	    };
	  },
	  render: function render() {
	    var app = this.props.app;
	    var style = {
	      paddingTop: this.state.statusBarHeight,
	      paddingBottom: 10,
	      paddingLeft: 10,
	      paddingRight: 10
	    };
	    if (this.props.showPanel) {
	      style.marginLeft = 0;
	    } else {
	      style.marginLeft = -200;
	    }
	
	    var modules = this.filterHiddenPage();
	    return React.createElement(
	      'div',
	      { className: 'mobile-preview-panel preview-panel', style: style },
	      React.createElement(
	        'div',
	        { className: 'mobile-panel-wrap' },
	        React.createElement(
	          'div',
	          { className: 'header' },
	          React.createElement(
	            'h1',
	            null,
	            app.name
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'pages', style: { bottom: this.state.isWxMiniApp ? '50px' : 0 } },
	          React.createElement(Tree, {
	            name: this.props.app.name,
	            current: this.props.current,
	            modules: modules,
	            onSelectPage: this.props.onOpenPage })
	        ),
	        this.state.isWxMiniApp && React.createElement(
	          'button',
	          { className: 'back-btn', onClick: this.miniProgramGoBack },
	          '\u8FD4\xA0\u56DE'
	        )
	      )
	    );
	  },
	  // 返回小程序
	  miniProgramGoBack: function miniProgramGoBack() {
	    wx.miniProgram.navigateBack();
	  },
	  filterHiddenPage: function filterHiddenPage() {
	    var isShowTitleIndex = this.props.app.params.projectParam.isShowTitleIndex;
	    var isShowAllPageNode = this.props.isShowAllPageNode; //是否显示所有隐藏页面
	    var modules = JSON.parse(JSON.stringify(this.props.app.modules));
	
	    var filter = function filter(pages, preIndex) {
	      var count = 0;
	      var page;
	      var index;
	
	      for (var i = pages.length - 1; i >= 0; i--) {
	        var childs = 0;
	        page = pages[i];
	        if (page.isshownode === undefined) {
	          //兼容旧版本
	          return this.props.app.modules;
	        }
	        if (!page.isshownode && !isShowAllPageNode) {
	          pages.splice(i, 1);
	        } else {
	          if (isShowTitleIndex) {
	            index = preIndex ? preIndex + '.' + (i + 1) : i + 1 + '';
	            page.name = index + ' ' + page.name;
	          }
	          if (page._pages && page._pages.length > 0) {
	            childs = filter(page._pages, index);
	            count += childs;
	          }
	          if (page.isModule) {
	            page.childCount = childs;
	          } else {
	            count++;
	          }
	        }
	      }
	      return count;
	    };
	
	    if (isShowTitleIndex !== undefined) {
	      //兼容旧版本
	      modules.childCount = filter(modules._pages);
	    }
	    return modules;
	  }
	});
	
	module.exports = MobilePreviewPanel;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var envHelper = __webpack_require__(48);
	var ScrollNavigationBar = __webpack_require__(330);
	var IS_LION_SCROLLBAR = /Android|webOS|iPhone|iPad|iPod|OS X|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
	
	var PageIcons = {
	  'psWhite': assetsHelper.getAsset('page_white.png'),
	  'psBlue': assetsHelper.getAsset('page_blue.png'),
	  'psGreen': assetsHelper.getAsset('page_green.png'),
	  'psRed': assetsHelper.getAsset('page_red.png'),
	  'psYellow': assetsHelper.getAsset('page_yellow.png'),
	  'psGray': assetsHelper.getAsset('page_gray.png')
	};
	
	var CurrentPageIcons = {
	  'psWhite': assetsHelper.getAsset('page_white2.png'),
	  'psBlue': assetsHelper.getAsset('page_blue2.png'),
	  'psGreen': assetsHelper.getAsset('page_green2.png'),
	  'psRed': assetsHelper.getAsset('page_red2.png'),
	  'psYellow': assetsHelper.getAsset('page_yellow2.png'),
	  'psGray': assetsHelper.getAsset('page_gray2.png')
	};
	
	var FolderIcons = {
	  'psWhite': assetsHelper.getAsset('folder_icon2.png'),
	  'psBlue': assetsHelper.getAsset('folder_blue2.png'),
	  'psGreen': assetsHelper.getAsset('folder_green2.png'),
	  'psRed': assetsHelper.getAsset('folder_red2.png'),
	  'psYellow': assetsHelper.getAsset('folder_yellow2.png'),
	  'psGray': assetsHelper.getAsset('folder_gray2.png')
	};
	
	var OpenFolderIcons = {
	  'psWhite': assetsHelper.getAsset('folder_icon.png'),
	  'psBlue': assetsHelper.getAsset('folder_blue.png'),
	  'psGreen': assetsHelper.getAsset('folder_green.png'),
	  'psRed': assetsHelper.getAsset('folder_red.png'),
	  'psYellow': assetsHelper.getAsset('folder_yellow.png'),
	  'psGray': assetsHelper.getAsset('folder_gray.png')
	};
	
	var ModuleIcon = {
	  'open': assetsHelper.getAsset('folder_icon2.png'),
	  'closed': assetsHelper.getAsset('folder_icon.png')
	};
	
	var ParentIcon = {
	  'open': assetsHelper.getAsset('tree_open.png'),
	  'closed': assetsHelper.getAsset('tree_closed.png')
	};
	
	/**
	 * 获取页面的图标 psWhite, psBlue, psGreen, psRed, psYellow, psGray
	 * @param status
	 * @param isCurrent 是否是当前选中页面
	 * @returns {*|string}
	 */
	function getIcon(status, isCurrent) {
	  if (isCurrent) {
	    return PageIcons[status] || PageIcons.psWhite;
	  }
	  return CurrentPageIcons[status] || CurrentPageIcons.psWhite;
	}
	
	/**
	 * 获取模块的图标 psWhite, psBlue, psGreen, psRed, psYellow, psGray
	 * @param status 状态
	 * @param isOpen 是否展开
	 * @returns {*|string}
	 */
	function getFolderIcon(status, isOpen) {
	  if (isOpen) {
	    return FolderIcons[status] || FolderIcons.psWhite;
	  }
	  return OpenFolderIcons[status] || OpenFolderIcons.psWhite;
	}
	
	/**
	 * 判断某根节点是否在当前页面的路径上
	 * @param node 要判断的根节点
	 * @param targetId 目标节点的id
	 * @returns {*|bool}
	 */
	function isCurrentPath(node, current) {
	  if (node._pages && node._pages.length > 0) {
	    var children = node._pages;
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].ID === current) {
	        return true;
	      }
	      if (isCurrentPath(children[i], current)) {
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	function toggleScrollBar() {
	  var item = $('.node-name')[0];
	  var width = $(item).offset().left + item.clientWidth;
	  if (width > 260) {
	    //水平方向需滚动
	    var scrollContent = $(item).closest('.scroll-content');
	    var left = $(scrollContent).scrollLeft();
	    $(scrollContent).scrollLeft(left + 1);
	  }
	}
	
	/**
	 * 页面
	 */
	var Page = React.createClass({
	  displayName: 'Page',
	
	  propTypes: {
	    node: React.PropTypes.object.isRequired,
	    show: React.PropTypes.bool.isRequired,
	    current: React.PropTypes.string.isRequired
	  },
	  render: function render() {
	    var node = this.props.node;
	    var current = this.props.current;
	    var className = '';
	    var style = {};
	    var isCurrent = node.ID === current;
	    if (isCurrent) {
	      className = 'current';
	    }
	    if (!this.props.show) {
	      style.display = 'none';
	    }
	    return React.createElement(
	      'li',
	      { className: className,
	        key: node.ID,
	        style: style,
	        onClick: this.onSelectPage },
	      React.createElement(
	        'span',
	        { className: 'node-name' },
	        React.createElement('img', { width: '10', height: '14',
	          src: getIcon(node.status, isCurrent) }),
	        node.name
	      ),
	      node._pages && node._pages.length > 0 && React.createElement(
	        'ul',
	        null,
	        node._pages.map(function (subNode) {
	          return React.createElement(Page, { node: subNode,
	            current: current,
	            onSelectPage: this.props.onSelectPage });
	        }, this)
	      )
	    );
	  },
	  onSelectPage: function onSelectPage(e) {
	    this.props.onSelectPage(this.props.node.ID);
	    e.stopPropagation();
	  }
	});
	
	/**
	 * 模块
	 */
	var Module = React.createClass({
	  displayName: 'Module',
	
	  propTypes: {
	    root: React.PropTypes.bool,
	    node: React.PropTypes.object.isRequired,
	    show: React.PropTypes.bool.isRequired,
	    current: React.PropTypes.string.isRequired
	  },
	  getInitialState: function getInitialState() {
	    var flag = isCurrentPath(this.props.node, this.props.current);
	    return {
	      expand: flag
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var flag = isCurrentPath(nextProps.node, nextProps.current);
	    //节点处于收起状态时，根据是否当前路径决定节点的expand标志
	    if (!this.state.expand) {
	      this.setState({ expand: flag });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    toggleScrollBar();
	  },
	  componentDidMount: function componentDidMount() {
	    toggleScrollBar();
	  },
	
	  render: function render() {
	    var showItem = this.state.expand || false;
	    var style = {};
	    var statusPath;
	    var currentClassName = 'module';
	    var statusClassName = 'status';
	    var pages;
	
	    if (this.props.root) {
	      currentClassName += ' root';
	    }
	
	    if (!this.props.show) {
	      style.display = 'none';
	    }
	
	    if (this.state.expand) {
	      statusPath = ParentIcon.open;
	    } else {
	      statusPath = ParentIcon.closed;
	      statusClassName += ' closed';
	    }
	
	    if (envHelper.isMobileDevice()) {
	      statusClassName += ' mobile';
	    }
	
	    pages = this.props.node._pages;
	
	    if (!pages) {
	      currentClassName += ' module-without-children';
	    }
	
	    return React.createElement(
	      'li',
	      { className: currentClassName, style: style },
	      pages && pages.length > 0 && React.createElement(
	        'i',
	        { className: statusClassName, onClick: this.onToggleExpand },
	        React.createElement('img', { src: statusPath })
	      ),
	      this.renderNameWithIcon(),
	      React.createElement(
	        'ul',
	        null,
	        pages && pages.length > 0 && pages.map(function (node) {
	          if (node.isModule || node._pages && node._pages.length > 0) {
	            return React.createElement(Module, { node: node,
	              key: node.ID,
	              show: showItem,
	              current: this.props.current,
	              onSelectPage: this.props.onSelectPage });
	          }
	          return React.createElement(Page, { key: node.ID,
	            show: showItem,
	            node: node,
	            current: this.props.current,
	            onSelectPage: this.props.onSelectPage });
	        }, this)
	      )
	    );
	  },
	  renderNameWithIcon: function renderNameWithIcon() {
	    var iconPath;
	    var nodeNameClassName = 'node-name';
	    var iconSize;
	    var nodeName = this.props.node.name;
	    var status = this.props.node.status;
	    var pages = this.props.node.pages;
	    if (this.props.node.isModule && this.props.node.childCount > 0) {
	      nodeName += ' (' + this.props.node.childCount + ')';
	    }
	
	    if (this.props.node.isModule) {
	      // 是模块
	      if (status === undefined) {
	        iconPath = ModuleIcon[this.state.expand ? 'open' : 'closed'];
	      } else {
	        iconPath = getFolderIcon(status, this.state.expand);
	      }
	      iconSize = {
	        width: 16,
	        height: 16
	      };
	    } else {
	      iconPath = getIcon(this.props.node.status, this.props.node.ID === this.props.current);
	      iconSize = {
	        width: 10,
	        height: 14
	      };
	    }
	
	    if (this.props.node.ID === this.props.current) {
	      nodeNameClassName += ' current';
	    }
	    return React.createElement(
	      'span',
	      { className: nodeNameClassName,
	        onClick: this.onClick,
	        onDoubleClick: this.onToggleExpand },
	      React.createElement('img', { width: iconSize.width, height: iconSize.height, src: iconPath }),
	      nodeName
	    );
	  },
	  /**
	   * 切换子项是否展开
	   */
	  onClick: function onClick(e) {
	    if (this.props.node.isModule) {
	      this.onToggleExpand(e);
	    } else {
	      this.props.onSelectPage(this.props.node.ID);
	    }
	    e.stopPropagation();
	  },
	  onToggleExpand: function onToggleExpand(e) {
	    this.setState({
	      expand: !this.state.expand
	    });
	    e.stopPropagation();
	  }
	});
	
	/**
	 * 项目树
	 */
	var Tree = React.createClass({
	  displayName: 'Tree',
	
	  propTypes: {
	    name: React.PropTypes.string.isRequired,
	    modules: React.PropTypes.object.isRequired,
	    current: React.PropTypes.object.isRequired,
	    onSelectPage: React.PropTypes.func.isRequired,
	    scrollBarShow: React.PropTypes.bool
	  },
	  getInitialState: function getInitialState() {
	    return {
	      scrollBarShow: true,
	      Scroll: "scroll",
	      scrollBar: "scrollBar",
	      moveMain: "tree"
	    };
	  },
	  render: function render() {
	    var style = {
	      width: '240px',
	      height: '100%',
	      overflow: 'auto',
	      paddingRight: 20,
	      position: 'relative',
	      overflowX: 'auto'
	    };
	    if (IS_LION_SCROLLBAR) {
	      return React.createElement(
	        'div',
	        { onClick: this.scrollEvent, style: style },
	        React.createElement(
	          'div',
	          { className: 'tree', ref: 'treeNode' },
	          React.createElement(
	            'ul',
	            null,
	            React.createElement(Module, {
	              root: true,
	              node: {
	                isModule: true,
	                name: this.props.name,
	                _pages: this.props.modules._pages,
	                childCount: this.props.modules.childCount
	              },
	              show: true,
	              current: this.props.current.ID,
	              onSelectPage: this.props.onSelectPage })
	          )
	        )
	      );
	    }
	    return React.createElement(
	      'div',
	      { onClick: this.scrollEvent, style: style },
	      React.createElement(
	        ScrollNavigationBar,
	        null,
	        React.createElement(
	          'div',
	          { className: 'tree', ref: 'treeNode' },
	          React.createElement(
	            'ul',
	            null,
	            React.createElement(Module, {
	              root: true,
	              node: {
	                isModule: true,
	                name: this.props.name,
	                _pages: this.props.modules._pages,
	                childCount: this.props.modules.childCount
	              },
	              show: true,
	              current: this.props.current.ID,
	              onSelectPage: this.props.onSelectPage })
	          )
	        )
	      )
	    );
	  },
	  scrollEvent: function scrollEvent() {
	    document.addEventListener('onMouseOver', this.onScrollPlay);
	  },
	  onScrollPlay: function onScrollPlay(e) {
	    console.log("hello");
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    toggleScrollBar();
	  },
	  componentDidMount: function componentDidMount() {
	    toggleScrollBar();
	  }
	});
	
	module.exports = Tree;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var findDOMNode = __webpack_require__(12).findDOMNode;
	
	var ScrollNavigationBar = React.createClass({
	    displayName: 'ScrollNavigationBar',
	
	    getInitialState: function getInitialState() {
	        return {
	            loaded: false,
	            vSize: 0,
	            vPosition: 0,
	            hSize: 0,
	            hPosition: 0
	        };
	    },
	    onScroll: function onScroll() {
	        this.onUpdate();
	    },
	    onUpdate: function onUpdate() {
	        var node = findDOMNode(this.refs.content);
	        this.setState({
	            vSize: node.offsetHeight / node.scrollHeight,
	            vPosition: node.scrollTop / node.scrollHeight,
	            hSize: node.offsetWidth / node.scrollWidth,
	            hPosition: node.scrollLeft / node.scrollWidth,
	            loaded: true
	        });
	    },
	    onMouseMove: function onMouseMove(e) {
	        var node = findDOMNode(this.refs.content);
	        var delta, newPosition;
	        if (this.direction === 'vertical') {
	            delta = (e.pageY - this.start) / node.offsetHeight;
	            newPosition = Math.min(Math.max(0, this.startPosition + delta), this.max);
	            node.scrollTop = node.scrollHeight * newPosition;
	        } else {
	            delta = (e.pageX - this.start) / node.offsetWidth;
	            newPosition = Math.min(Math.max(0, this.startPosition + delta), this.max);
	            node.scrollLeft = node.scrollWidth * newPosition;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	    },
	    onMouseUp: function onMouseUp(e) {
	        document.body.removeEventListener('mousemove', this.onMouseMove);
	        document.body.removeEventListener('mouseup', this.onMouseUp);
	        e.stopPropagation();
	        e.preventDefault();
	    },
	    onVerticalThumbMouseDown: function onVerticalThumbMouseDown(e) {
	        this.direction = 'vertical';
	        var node = findDOMNode(this.refs.content);
	        this.start = e.pageY;
	        this.startPosition = this.state.vPosition;
	        this.max = (node.scrollHeight - node.offsetHeight) / node.scrollHeight;
	        document.body.addEventListener('mousemove', this.onMouseMove);
	        document.body.addEventListener('mouseup', this.onMouseUp);
	        e.stopPropagation();
	        e.preventDefault();
	    },
	    onHorizontalThumbMouseDown: function onHorizontalThumbMouseDown(e) {
	        this.direction = 'horizontal';
	        var node = findDOMNode(this.refs.content);
	        this.start = e.pageX;
	        this.startPosition = this.state.hPosition;
	        this.max = (node.scrollWidth - node.offsetWidth) / node.scrollWidth;
	        document.body.addEventListener('mousemove', this.onMouseMove);
	        document.body.addEventListener('mouseup', this.onMouseUp);
	        e.stopPropagation();
	        e.preventDefault();
	    },
	    verticalThumbStyle: function verticalThumbStyle() {
	        return {
	            height: this.state.vSize * 100 + '%',
	            top: this.state.vPosition * 100 + '%',
	            display: this.state.vSize < 1 && this.state.vSize > 0 && this.state.loaded ? 'block' : 'none'
	        };
	    },
	    horizontalThumbStyle: function horizontalThumbStyle() {
	        return {
	            width: this.state.hSize * 100 + '%',
	            left: this.state.hPosition * 100 + '%',
	            display: this.state.hSize < 1 && this.state.hSize > 0 && this.state.loaded ? 'block' : 'none'
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var self = this;
	        setTimeout(function () {
	            self.onUpdate();
	        }, 200);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {},
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'scroll-view', onScroll: this.onScroll },
	            React.createElement(
	                'div',
	                { ref: 'content', className: 'scroll-content', style: { overflowX: 'auto', overflowY: 'auto' } },
	                this.props.children
	            ),
	            React.createElement(
	                'div',
	                {
	                    className: 'track scroll-bar-vertical',
	                    onMouseDown: this.onVerticalThumbMouseDown },
	                React.createElement('div', { className: 'thumb', onMouseDown: this.onBarClick, style: this.verticalThumbStyle() })
	            ),
	            React.createElement(
	                'div',
	                {
	                    className: 'track scroll-bar-horizontal',
	                    onMouseDown: this.onHorizontalThumbMouseDown },
	                React.createElement('div', { className: 'thumb', style: this.horizontalThumbStyle() })
	            )
	        );
	    }
	});
	
	module.exports = ScrollNavigationBar;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var BallSize = 80;
	var HalfBallSize = 40;
	var _ = __webpack_require__(51);
	var storeHelper = __webpack_require__(49);
	var assetsHelper = __webpack_require__(65);
	
	var ControlBall = React.createClass({
	  displayName: 'ControlBall',
	
	  propTypes: {
	    onTogglePanel: React.PropTypes.func.isRequired,
	    domSize: React.PropTypes.shape({
	      width: React.PropTypes.number.isRequired,
	      height: React.PropTypes.number.isRequried
	    }).isRequired
	  },
	  getInitialState: function getInitialState() {
	    var store = storeHelper.get('ball_position');
	    var domSize;
	    if (store) {
	      return this.fitBallPosition(JSON.parse(store));
	    }
	    domSize = this.props.domSize;
	    return {
	      left: domSize.width - HalfBallSize,
	      top: domSize.height - BallSize,
	      edge: true
	    };
	  },
	  render: function render() {
	    var style;
	    var className = 'control-ball';
	    style = {
	      left: this.state.left,
	      top: this.state.top
	    };
	    if (this.state.finishing) {
	      className += ' finishing';
	    }
	    if (this.state.edge) {
	      className += ' edge';
	    }
	    return React.createElement(
	      'div',
	      { className: className,
	        style: style
	        // onClick={this.props.onTogglePanel}
	        , onTouchStart: this.onTouchStart,
	        onTouchMove: this.onTouchMove,
	        onTouchEnd: this.onTouchEnd },
	      React.createElement('img', { src: assetsHelper.getAsset('m.png') })
	    );
	  },
	  onTouchStart: function onTouchStart(e) {
	    var touch = e.touches[0];
	    this.start = {
	      left: touch.pageX - HalfBallSize,
	      top: touch.pageY - HalfBallSize
	    };
	    this.moving = false;
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  onTouchMove: function onTouchMove(e) {
	    var touch = e.touches[0];
	    var newPosition = {
	      left: touch.pageX - HalfBallSize,
	      top: Math.min(Math.max(touch.pageY - HalfBallSize, 0), this.props.domSize.height - BallSize)
	    };
	    if (Math.max(Math.abs(newPosition.left - this.start.left), Math.abs(newPosition.top - this.start.top)) > 10) {
	      this.moving = true;
	      newPosition.isMoved = true;
	      newPosition.moved = true;
	      this.setState(newPosition);
	    }
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  onTouchEnd: function onTouchEnd(e) {
	    if (!this.moving) {
	      this.props.onTogglePanel();
	      return;
	    }
	    var self = this;
	    var width = this.props.domSize.width;
	    var height = this.props.domSize.height;
	    var top = this.state.top;
	    var left = this.state.left;
	    var bottom = height - top - BallSize;
	    var right = width - left - BallSize;
	    var toTop = 0;
	    var toLeft = 0;
	    var newPosition;
	
	    var centerLeft = left + HalfBallSize;
	
	    if (centerLeft > width / 4 && centerLeft < width * 3 / 4) {
	      this.setState({
	        edge: false
	      }, function () {
	        storeHelper.set('ball_position', JSON.stringify({
	          left: this.state.left,
	          top: this.state.top,
	          edge: false
	        }));
	      });
	      return;
	    }
	
	    if (centerLeft <= width / 4) {
	      toLeft = -HalfBallSize;
	    } else {
	      toLeft = this.props.domSize.width - HalfBallSize;
	    }
	
	    newPosition = this.fitBallPosition({
	      left: toLeft,
	      top: top
	    });
	    this.setState({
	      finishing: true,
	      edge: true,
	      left: newPosition.left,
	      top: newPosition.top
	    }, function () {
	      setTimeout(function () {
	        storeHelper.set('ball_position', JSON.stringify({
	          left: newPosition.left,
	          top: newPosition.top,
	          edge: true
	        }));
	        self.setState({
	          finishing: false
	        });
	      }, 200);
	    });
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  fitBallPosition: function fitBallPosition(position) {
	    var domSize = this.props.domSize;
	    return {
	      left: Math.min(position.left, domSize.width - HalfBallSize),
	      top: Math.min(position.top, domSize.height - HalfBallSize),
	      edge: position.edge
	    };
	  }
	});
	
	module.exports = ControlBall;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var connect = __webpack_require__(13).connect;
	var PreviewMixin = __webpack_require__(137);
	var storeHelper = __webpack_require__(49);
	
	var Actions = __webpack_require__(133);
	
	var PreviewPanel = __webpack_require__(333);
	var Workspace = __webpack_require__(337);
	var RenderTimePanel = __webpack_require__(355);
	var TestProjects = __webpack_require__(356);
	var NavigationBar = __webpack_require__(357);
	var PageRemark = __webpack_require__(358);
	var PagePaint = __webpack_require__(362);
	var PageLinkCopiedAlert = __webpack_require__(365);
	var ErrorMessage = __webpack_require__(354);
	var AppReviews = __webpack_require__(366);
	var UX2017Work = __webpack_require__(367);
	
	var deviceShellHelper = __webpack_require__(120);
	var domHelper = __webpack_require__(135);
	var cacheHelper = __webpack_require__(125);
	var urlHelper = __webpack_require__(122);
	var runtimeHelper = __webpack_require__(47);
	var envHelper = __webpack_require__(48);
	var i18nHelper = __webpack_require__(46);
	
	var PCPreview = React.createClass({
	  displayName: 'PCPreview',
	
	  propTypes: {
	    app: React.PropTypes.object,
	    current: React.PropTypes.object,
	    target: React.PropTypes.object,
	    path: React.PropTypes.string.isRequired,
	    animation: React.PropTypes.object,
	    pages: React.PropTypes.object,
	    review: React.PropTypes.array,
	    comments: React.PropTypes.array,
	    onLoadApp: React.PropTypes.func.isRequired,
	    onFinishOpenPage: React.PropTypes.func.isRequired,
	    onLoadReviewData: React.PropTypes.func.isRequired,
	    onAddReview: React.PropTypes.func.isRequired
	  },
	  mixins: [PreviewMixin],
	  getInitialState: function getInitialState() {
	    var config = this.props.config;
	    var platform = this.props.app.params.projectParam.platform;
	    var isSign = false;
	    var author = '';
	    if (storeHelper.get('sign') && storeHelper.get('sign') !== 'null') {
	      isSign = true;
	      author = storeHelper.get('sign');
	    }
	
	    var t = urlHelper.getQueryString('t'); // 模式，如果 t=r 显示评论和备注，如果 t=c 自动进入批注模式
	
	    return _.extend(config, {
	      scale: 1,
	      canFix: platform === 'MtMobile' || platform === 'MtPad',
	      shell: deviceShellHelper.getShellInfoByPlatform(this.props.app.params.projectParam.platform, config.shell),
	      controlPanel: config.showControlPanel,
	      domSize: domHelper.getDocumentSize(),
	      showRemark: t === 'r',
	      isCommentMode: t === 'c', //是否批注模式
	      showAppReviews: false, // 是否显示项目批注
	      isShowPaint: true,
	      isSign: isSign,
	      author: author,
	      pageNeedRerender: true, // 只有该值为 true 时页面内容才会得到更新，这不是一个好办法，但是目前来说，页面内的数据不能轻易被刷新，否则会引起交互错误，必须这样处理
	      showCopiedAlert: false //是否显示已经复制了页面链接提示
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.props.onLoadApp(this.props.app);
	    domHelper.onDocumentResize(this.onDomSizeChange);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    domHelper.offDocumentResize(this.onDomSizeChange);
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.state.pageNeedRerender) {
	      // 如果该值为 true, 渲染完成后立即重置为 false
	
	      this.wantToOpenOrRedirect = false;
	      this.setState({
	        pageNeedRerender: false
	      });
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextState) {
	    if (this.wantToOpenOrRedirect) {
	      this.setState({
	        pageNeedRerender: true
	      });
	    } else {
	      var currentID = this.props.current && this.props.current.ID;
	      var nextID = nextProps && nextProps.target && nextProps.target.ID;
	      this.setState({
	        pageNeedRerender: currentID !== nextID
	      }); // 当页面ID不同时才重新渲染
	    }
	  },
	  getClassNameOfWrapper: function getClassNameOfWrapper() {
	    var className = 'app';
	
	    if (this.state.alwaysShowLinks) {
	      className += ' always-show-links';
	    } else if (this.state.hoverShowLinks) {
	      className += ' hover-show-links';
	    }
	    if (this.state.hoverShowRemarks) {
	      className += ' hover-show-remarks';
	    }
	
	    if (this.state.showRemarkFlag) {
	      className += ' show-remark-flag';
	    }
	    return className;
	  },
	  /**
	   * 获取当前页面的备注信息
	   * @returns {string}
	   */
	  getCurrentPageRemark: function getCurrentPageRemark() {
	    var current;
	    var param;
	    var text;
	    current = this.props.current;
	    if (!current) {
	      return i18nHelper.get('NO_REMARK');
	    }
	    param = current.param;
	    if (!param || !param[0]) {
	      return i18nHelper.get('NO_REMARK');
	    }
	    text = param[0].remark;
	    if (typeof text !== 'string') {
	      return i18nHelper.get('NO_REMARK');
	    }
	    return decodeURI(text);
	  },
	  render: function render() {
	
	    var className;
	    var syncID = window.reviewID || '';
	    var syncRevision = window.revision || '';
	    if (!this.props.current) {
	      return this.renderLoading();
	    }
	    var pageNameTree = this.getPageName();
	    if (this.state.isCommentMode) {
	      // 进入了批注模式
	      return this.renderCommentMode(pageNameTree);
	    }
	    className = this.getClassNameOfWrapper();
	
	    if (this.onClearErrorProxy === null) {
	      this.onClearErrorProxy = this.props.onClearError;
	    }
	
	    return React.createElement(
	      'div',
	      { className: className, style: {
	          backgroundColor: this.state.background
	        } },
	      runtimeHelper.canReview() && React.createElement(ErrorMessage, { error: this.props.error,
	        onClearError: this.onClearErrorProxy
	      }),
	      this.state.showCopiedAlert && React.createElement(PageLinkCopiedAlert, {
	        onCloseCopiedAlert: this.onCloseCopiedAlert
	      }),
	      runtimeHelper.canReview() && this.state.showAppReviews && React.createElement(AppReviews, {
	        name: this.props.app.name,
	        syncID: syncID,
	        projectReviews: this.props.appReviews,
	        onLoadProjecReviews: this.props.onLoadProjectReviews,
	        onCloseAppReviews: this.onToggleAppReviews
	      }),
	      this.props.config.isShowPreviewTools && React.createElement(NavigationBar, {
	        domSize: this.state.domSize,
	        onOpenHome: this.onOpenHome,
	        onOpenNext: this.onOpenNext,
	        onOpenPrev: this.onOpenPrev,
	        onPlayback: this.onPlayback,
	        controlPanel: this.state.controlPanel,
	        onTogglePanelVisibility: this.onTogglePanelVisibility,
	        onToggleRemarkVisibility: this.onToggleRemarkVisibility,
	        onToggleCommentMode: this.onToggleCommentMode,
	        onToggleShowPaint: this.onToggleShowPaint,
	        isShowPaint: this.state.isShowPaint
	      }),
	      window.isDev && React.createElement(TestProjects, { openApp: this.openApp }),
	      this.state.controlPanel && React.createElement(PreviewPanel, {
	        domSize: this.state.domSize,
	        app: this.props.app,
	        current: this.props.current,
	        scale: this.state.scale,
	        shell: this.state.shell,
	        showComments: this.state.showComments,
	        alwaysShowLinks: this.state.alwaysShowLinks,
	        hoverShowLinks: this.state.hoverShowLinks,
	        hoverShowRemarks: this.state.hoverShowRemarks,
	        showPanel: this.state.showControlPanel,
	        showQRCode: this.state.showQRCode,
	        onOpenPage: this.onOpenPage,
	        onScaleChange: this.onScaleChange,
	        onShowComments: this._onShowComments,
	        onShowReview: this._onShowReview,
	        onAlwaysShowLinks: this.onAlwaysShowLinks,
	        onHoverShowLinks: this.onHoverShowLinks,
	        onHoverShowRemarks: this.onHoverShowRemarks,
	        onSetPanelVisibility: this.onSetPanelVisibility,
	        onCopyPageLink: this.onCopyPageLink,
	        showCommentsBoard: this.onToggleAppReviews,
	        showQrCode: this.props.config.showQRCode,
	        isShowAllPageNode: this.props.config.isShowAllPageNode
	      }),
	      this.props.current && React.createElement(Workspace, {
	        domSize: this.state.domSize,
	        meta: this.props.meta,
	        pages: this.props.pages,
	        current: this.props.current,
	        target: this.props.target,
	        animation: this.props.animation,
	        app: this.props.app,
	        scale: this.state.scale,
	        shell: this.state.shell,
	        showComments: this.state.showComments,
	        canFix: this.state.canFix,
	        onShowRemark: this.onShowRemark,
	        onRedirectTo: this.redirectTo,
	        onOpenPage: this.openPage,
	        onFinishOpenPage: this.onFinishOpenPage,
	        alwaysShowLinks: this.state.alwaysShowLinks,
	        hintLinks: this.state.hintLinks,
	        scrollRemarks: this.state.scrollRemarks,
	        pageNeedRerender: this.state.pageNeedRerender,
	        isCommentMode: false,
	        review: this.props.review,
	        isShowPaint: this.state.isShowPaint,
	        onLoadReviewData: this.props.onLoadReviewData,
	        isShowControlPanel: this.state.controlPanel
	      }),
	      React.createElement('div', { className: 'remark', ref: 'remark' }),
	      React.createElement(PageRemark, { name: this.props.current.title,
	        syncID: syncID,
	        syncVersion: syncRevision,
	        page: this.props.current,
	        pageName: pageNameTree,
	        remark: this.getCurrentPageRemark(),
	        show: this.state.showRemark,
	        onClose: this.onToggleRemarkVisibility,
	        onAddComment: this.props.onAddComment,
	        onLoadComment: this.props.onLoadComment,
	        isSign: this.state.isSign,
	        author: this.state.author,
	        sign: this.sign,
	        removeSign: this.removeSign,
	        comments: this.props.comments,
	        onError: this.onErrorFilter,
	        onClearError: this.props.onClearError
	      }),
	      window.debug && React.createElement(RenderTimePanel, null),
	      envHelper.isUX2017Work() && React.createElement(UX2017Work, null)
	    );
	  },
	
	  renderLoading: function renderLoading() {
	    var logoPath = this.state.logo;
	    return React.createElement(
	      'div',
	      { className: 'preview-loading' },
	      React.createElement('img', { width: '120', height: '120', src: logoPath, alt: 'Mockplus' })
	    );
	  },
	
	  renderCommentMode: function renderCommentMode(pageNameTree) {
	    var syncID = window.reviewID || '';
	    var syncRevision = window.revision || '-1';
	    return React.createElement(PagePaint, {
	      syncID: syncID,
	      syncVersion: syncRevision,
	      pageName: pageNameTree,
	      review: this.props.review,
	      shell: this.state.shell,
	      domSize: this.state.domSize,
	      meta: this.props.meta,
	      scale: this.state.scale,
	      page: this.props.current,
	      onExitPaint: this.onToggleCommentMode,
	      isSign: this.state.isSign,
	      sign: this.sign,
	      onLoadReviewData: this.props.onLoadReviewData,
	      onAddReview: this.props.onAddReview,
	      onUpdateReview: this.props.onUpdateReview,
	      onRemoveReview: this.props.onRemoveReview,
	      error: this.props.error,
	      onError: this.props.onError,
	      onClearError: this.props.onClearError,
	      background: this.state.background
	    });
	  },
	
	  getPageName: function getPageName() {
	    var pages = this.props.app.pages;
	    var current = this.props.current;
	    var result = this.searchTree(pages, current.ID);
	    return result;
	  },
	  searchTree: function searchTree(root, ID) {
	    if (!root || !root._pages) {
	      return '';
	    }
	    for (var i = 0; i < root._pages.length; i++) {
	      var page = root._pages[i];
	      if (ID === page.ID) {
	        return page.name;
	      }
	      var result = this.searchTree(page, ID);
	      if (result) {
	        return page.name + '/' + result;
	      }
	    }
	    return '';
	  },
	
	  onClearErrorProxy: null,
	  //此处加入error消息确定后的回调
	  onErrorFilter: function onErrorFilter(msg, clearCallback) {
	    if (clearCallback) {
	      this.onClearErrorProxy = clearCallback;
	    } else {
	      this.onClearErrorProxy = this.props.onClearError;
	    }
	    this.props.onError(msg);
	  },
	
	  openApp: function openApp(p) {
	    storeHelper.set('path', p);
	    window.location.reload();
	  },
	
	  onDomSizeChange: function onDomSizeChange() {
	    this.setState({
	      domSize: domHelper.getDocumentSize()
	    });
	  },
	  _onShowComments: function _onShowComments(show) {
	    this.setState({
	      showComments: show
	    });
	  },
	  _onShowReview: function _onShowReview(show) {
	    this.setState({
	      showReview: show
	    });
	  },
	  onCopyPageLink: function onCopyPageLink() {
	    var currentID = this.props.current && this.props.current.ID;
	    var url = window.location.href;
	    if (url.indexOf('?')) {
	      url = url.split('?')[0];
	    }
	    var txt = url + '?to=' + currentID;
	    window.location.href = txt;
	    //var self = this;
	    //var save = function (e){
	    //  e.clipboardData.setData('text/plain',txt);//下面会说到clipboardData对象
	    //  e.preventDefault();//阻止默认行为
	    //  self.setState({showCopiedAlert: true});
	    //}
	    //document.addEventListener('copy',save);
	    //if (!document.execCommand("copy")) { //使文档处于可编辑状态，否则无效
	    //  window.open(txt);
	    //}
	  },
	  onCloseCopiedAlert: function onCloseCopiedAlert() {
	    this.setState({ showCopiedAlert: false });
	  },
	  onScaleChange: function onScaleChange(scale) {
	    this.setState({
	      scale: scale
	    });
	  },
	  onAlwaysShowLinks: function onAlwaysShowLinks(show) {
	    this.setState({
	      alwaysShowLinks: show
	    });
	  },
	  onHoverShowLinks: function onHoverShowLinks(show) {
	    this.setState({
	      hoverShowLinks: show
	    });
	  },
	  onHoverShowRemarks: function onHoverShowRemarks(show) {
	    this.setState({
	      hoverShowRemarks: show
	    });
	  },
	  onShowRemark: function onShowRemark(x, y, remark) {
	    if (this.state.hoverShowRemarks) {
	      var dom = ReactDOM.findDOMNode(this.refs.remark);
	      if (remark) {
	        dom.style.left = x + 12 + 'px';
	        dom.style.top = y + 12 + 'px';
	        dom.style.display = 'block';
	        dom.innerHTML = remark.replace(/\n/g, '<br/>');
	      } else {
	        dom.style.display = 'none';
	      }
	    }
	  },
	  onSetPanelVisibility: function onSetPanelVisibility(visible) {
	    this.setState({
	      showControlPanel: visible
	    });
	  },
	  onTogglePanelVisibility: function onTogglePanelVisibility() {
	    this.setState({
	      showControlPanel: !this.state.showControlPanel
	    });
	  },
	  onToggleRemarkVisibility: function onToggleRemarkVisibility() {
	    this.setState({
	      showRemark: !this.state.showRemark
	    });
	  },
	  onToggleCommentMode: function onToggleCommentMode() {
	    this.setState({
	      isCommentMode: !this.state.isCommentMode
	    });
	  },
	  onToggleShowPaint: function onToggleShowPaint() {
	    this.setState({ isShowPaint: !this.state.isShowPaint });
	  },
	  sign: function sign(author) {
	    storeHelper.set('sign', author);
	    this.setState({
	      isSign: true,
	      author: author
	    });
	  },
	  removeSign: function removeSign() {
	    storeHelper.set("sign", 'null');
	    this.setState({
	      isSign: false
	    });
	  },
	  onToggleAppReviews: function onToggleAppReviews() {
	    this.setState({
	      showAppReviews: !this.state.showAppReviews
	    });
	  },
	  onFinishOpenPage: function onFinishOpenPage() {
	    this.props.onFinishOpenPage(this.props.target);
	  }
	});
	
	function mapStateToProps(state) {
	  cacheHelper.cache(cacheHelper.keys.PROJECT_VERSION, state.app && state.app.params.projectParam.version);
	  cacheHelper.cache(cacheHelper.keys.PAGE_VERSION, state.app && state.app.params.pageParam.version);
	  cacheHelper.cache(cacheHelper.keys.PLATFORM, state.app && state.app.params.projectParam.platform);
	  return {
	    app: state.app,
	    meta: state.app && state.app.params.projectParam,
	    current: state.current,
	    target: state.target,
	    animation: state.animation,
	    config: state.config,
	    projectVersion: state.app && state.app.params.projectParam.version,
	    pageVersion: state.current && state.current.version,
	    review: state.review,
	    comments: state.comments,
	    error: state.error,
	    appReviews: state.appReviews,
	    rnd: Math.random() //FIXME: damn it, there is a bug, clone project cannot trigger component update, I have to add this random number to fix it
	  };
	}
	
	function pushState(id) {
	  try {
	    window.history.pushState({}, "", "?to=" + id);
	  } catch (e) {
	    console.error(e);
	  }
	}
	
	var isSkiping = false; //标志在执行页面跳转中
	function mapDispatchToProps(dispatch) {
	  return {
	    onLoadApp: function onLoadApp(app) {
	      dispatch(Actions.loadApp(app));
	    },
	
	    onOpenPage: function onOpenPage(id) {
	      if (!isSkiping) {
	        dispatch(Actions.openPage(id));
	        pushState(id);
	      }
	    },
	    onFinishOpenPage: function onFinishOpenPage(targetPage) {
	      isSkiping = false;
	      dispatch(Actions.finishOpenPage(targetPage));
	    },
	    onRedirectTo: function onRedirectTo(id, animation) {
	      //只响应一次切换页面请求
	      //必须保证调用onFinishOpenPage形成isSkiping闭环
	      if (!isSkiping) {
	        isSkiping = true;
	        dispatch(Actions.redirectPage(id, animation));
	        pushState(id);
	      }
	    },
	    onLoadReviewData: function onLoadReviewData(syncID, syncVersion, pageID) {
	      dispatch(Actions.loadReviewData(syncID, syncVersion, pageID));
	    },
	    onAddReview: function onAddReview(syncID, syncVersion, pageID, pageName, author, data) {
	      dispatch(Actions.addReview(syncID, syncVersion, pageID, pageName, author, data));
	    },
	    onAddComment: function onAddComment(syncID, syncVersion, pageID, pageName, author, content) {
	      dispatch(Actions.addComment(syncID, syncVersion, pageID, pageName, author, content));
	    },
	    onLoadComment: function onLoadComment(syncID, syncVersion, pageID) {
	      dispatch(Actions.loadComment(syncID, syncVersion, pageID));
	    },
	    onUpdateReview: function onUpdateReview(syncID, syncVersion, pageID, author, id, data) {
	      dispatch(Actions.updateReview(syncID, syncVersion, pageID, author, id, data));
	    },
	    onRemoveReview: function onRemoveReview(syncID, syncVersion, pageID, author, id) {
	      dispatch(Actions.removeReview(syncID, syncVersion, pageID, author, id));
	    },
	    onError: function onError(error) {
	      dispatch(Actions.showError(error));
	    },
	    onClearError: function onClearError() {
	      dispatch(Actions.clearError());
	    },
	    onLoadProjectReviews: function onLoadProjectReviews(syncID) {
	      dispatch(Actions.loadProjectReviews(syncID));
	    }
	  };
	}
	
	module.exports = connect(mapStateToProps, mapDispatchToProps)(PCPreview);

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var Tree = __webpack_require__(329);
	var Options = __webpack_require__(334);
	var i18n = __webpack_require__(46);
	
	var assetsHelper = __webpack_require__(65);
	var dataHelper = __webpack_require__(113);
	var Resizer = __webpack_require__(335);
	var QrCode = __webpack_require__(336);
	var runtimeHelper = __webpack_require__(47);
	var envHelper = __webpack_require__(48);
	
	var PreviewPanel = React.createClass({
	  displayName: 'PreviewPanel',
	
	  propTypes: {
	    app: React.PropTypes.object,
	    domSize: React.PropTypes.object,
	    current: React.PropTypes.object.isRequired,
	    showComments: React.PropTypes.bool.isRequired,
	    alwaysShowLinks: React.PropTypes.bool.isRequired,
	    hoverShowLinks: React.PropTypes.bool.isRequired,
	    hoverShowRemarks: React.PropTypes.bool.isRequired,
	    showPanel: React.PropTypes.bool.isRequired,
	    showQRCode: React.PropTypes.bool.isRequired,
	    onOpenPage: React.PropTypes.func.isRequired,
	    onScaleChange: React.PropTypes.func.isRequired,
	    onShowComments: React.PropTypes.func.isRequired,
	    onShowReview: React.PropTypes.func.isRequired,
	    onAlwaysShowLinks: React.PropTypes.func.isRequired,
	    onHoverShowLinks: React.PropTypes.func.isRequired,
	    onHoverShowRemarks: React.PropTypes.func.isRequired,
	    onSetPanelVisibility: React.PropTypes.func.isRequired,
	    onCopyPageLink: React.PropTypes.func.isRequired,
	    showCommentsBoard: React.PropTypes.func.isRequired,
	    showQrCode: React.PropTypes.bool.isRequired,
	    isShowAllPageNode: React.PropTypes.bool.isRequired
	  },
	  getInitialState: function getInitialState() {
	    return {
	      showOptions: true,
	      showQRCode: true
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.setPagesHeight();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.setPagesHeight();
	  },
	  setPagesHeight: function setPagesHeight() {
	    var size = this.props.domSize;
	    var remainHeight = size.height - this.getHeight('header') - this.getHeight('name') - this.getHeight('options') - this.getHeight('control') - this.getHeight('qrcode') - 60;
	    if (remainHeight > 0) {
	      ReactDOM.findDOMNode(this.refs.pages).style.height = remainHeight + 'px';
	    }
	  },
	  getHeight: function getHeight(ref) {
	    return ReactDOM.findDOMNode(this.refs[ref]).getBoundingClientRect().height;
	  },
	  render: function render() {
	    var app = this.props.app;
	    var style = {};
	    var optionStyle = {};
	    var toggleButtonStyle = {};
	
	    style.marginLeft = this.props.showPanel ? 0 : -260;
	
	    if (!this.state.showOptions) {
	      optionStyle.display = 'none';
	      toggleButtonStyle.transform = 'rotate(180deg)';
	    }
	
	    var modules = this.filterHiddenPage();
	
	    return React.createElement(
	      'div',
	      { className: 'pc-preview-panel preview-panel', style: style },
	      React.createElement(
	        'div',
	        { ref: 'header', className: 'header' },
	        React.createElement(
	          'h2',
	          { className: 'app-name' },
	          app.name
	        ),
	        runtimeHelper.canReview() && React.createElement('img', { onClick: this.props.showCommentsBoard, className: 'message', src: assetsHelper.getAsset('review/show_comments.png') }),
	        React.createElement('img', { onClick: this.onClosePanel, className: 'close', src: assetsHelper.getAsset('close-30.png') })
	      ),
	      React.createElement(
	        'div',
	        { className: 'page-name-box' },
	        React.createElement('img', { className: 'copy-page-link', src: assetsHelper.getAsset('page_link.png'), onClick: this.props.onCopyPageLink }),
	        React.createElement(
	          'h3',
	          { ref: 'name', className: 'page-name' },
	          this.currentPageName()
	        )
	      ),
	      React.createElement(
	        'div',
	        { ref: 'control', className: 'scale-and-control' },
	        React.createElement(Resizer, { value: this.props.scale, onChange: this.onScaleChange }),
	        React.createElement(
	          'span',
	          { className: 'reset', onClick: this.onScaleReset },
	          React.createElement('img', { width: '16', height: '16',
	            src: assetsHelper.getAsset('reset.png') })
	        ),
	        React.createElement(
	          'span',
	          { className: 'toggle-options', onClick: this.toggleOptions },
	          React.createElement('img', { src: assetsHelper.getAsset('expand.png'), style: toggleButtonStyle })
	        )
	      ),
	      React.createElement(
	        'div',
	        { ref: 'options', className: 'preview-options-section', style: optionStyle },
	        React.createElement(Options, {
	          showComments: this.props.showComments,
	          alwaysShowLinks: this.props.alwaysShowLinks,
	          hoverShowLinks: this.props.hoverShowLinks,
	          hoverShowRemarks: this.props.hoverShowRemarks,
	          onShowComments: this.props.onShowComments,
	          onAlwaysShowLinks: this.props.onAlwaysShowLinks,
	          onHoverShowLinks: this.props.onHoverShowLinks,
	          onHoverShowRemarks: this.props.onHoverShowRemarks
	        })
	      ),
	      React.createElement(
	        'div',
	        { className: 'pages', ref: 'pages' },
	        React.createElement(Tree, {
	          name: this.props.app.name,
	          current: this.props.current,
	          modules: modules,
	          onSelectPage: this.props.onOpenPage
	        })
	      ),
	      this.renderQrCode(),
	      envHelper.isCn && React.createElement(
	        'div',
	        { className: 'advertisement' },
	        React.createElement(
	          'a',
	          { className: 'link_home', href: ' https://www.mockplus.cn', target: '_blank' },
	          'Mockplus'
	        ),
	        React.createElement(
	          'span',
	          null,
	          ' \u505A\u539F\u578B\uFF0C\u66F4\u5FEB\u66F4\u7B80\u5355'
	        )
	      )
	    );
	  },
	  renderQrCode: function renderQrCode() {
	    var QRCodeStyle = { display: "none" };
	    var toggleQRCodeStyle = {};
	    var showQrCode = this.state.showQRCode && dataHelper.isHttpURL();
	    var platform = this.props.app.params.projectParam.platform;
	
	    if (showQrCode) {
	      QRCodeStyle.display = 'block';
	      toggleQRCodeStyle.transform = 'rotate(180deg)';
	    }
	
	    if (this.props.showQrCode && dataHelper.isHttpURL() && (platform === 'MtMobile' || platform === 'MtPad')) {
	      return React.createElement(
	        'div',
	        { className: 'my-qr-code', ref: 'qrcode' },
	        React.createElement(
	          'div',
	          { className: 'toggle-qr-box' },
	          React.createElement(
	            'span',
	            { className: 'toggle-QRCode', onClick: this.toggleQRCode },
	            React.createElement('img', { src: assetsHelper.getAsset('expand.png'), style: toggleQRCodeStyle })
	          )
	        ),
	        React.createElement(
	          'div',
	          { style: QRCodeStyle },
	          React.createElement(QrCode, { URL: window.location.href, width: 80, height: 80 }),
	          React.createElement(
	            'p',
	            { className: 'desc' },
	            i18n.get('QRCODE')
	          )
	        )
	      );
	    }
	    return React.createElement('div', { ref: 'qrcode' });
	  },
	  onScaleChange: function onScaleChange(value) {
	    this.props.onScaleChange(value);
	  },
	  onScaleReset: function onScaleReset() {
	    this.props.onScaleChange(1);
	  },
	  toggleOptions: function toggleOptions() {
	    this.setState({
	      showOptions: !this.state.showOptions
	    });
	  },
	  toggleQRCode: function toggleQRCode() {
	    this.setState({
	      showQRCode: !this.state.showQRCode
	    });
	  },
	  onClosePanel: function onClosePanel() {
	    this.props.onSetPanelVisibility(false);
	  },
	  currentPageName: function currentPageName() {
	    return this.props.current.title;
	  },
	
	  filterHiddenPage: function filterHiddenPage() {
	    var isShowTitleIndex = this.props.app.params.projectParam.isShowTitleIndex;
	    var isShowAllPageNode = this.props.isShowAllPageNode; //是否显示所有隐藏页面
	    var modules = JSON.parse(JSON.stringify(this.props.app.modules));
	
	    var filter = function filter(pages, preIndex) {
	      var count = 0;
	      var page;
	      var index;
	
	      for (var i = pages.length - 1; i >= 0; i--) {
	        var childs = 0;
	        page = pages[i];
	        if (page.isshownode === undefined) {
	          //兼容旧版本
	          return this.props.app.modules;
	        }
	        if (!page.isshownode && !isShowAllPageNode) {
	          pages.splice(i, 1);
	        } else {
	          if (isShowTitleIndex) {
	            index = preIndex ? preIndex + '.' + (i + 1) : i + 1 + '';
	            page.name = index + ' ' + page.name;
	          }
	          if (page._pages && page._pages.length > 0) {
	            childs = filter(page._pages, index);
	            count += childs;
	          }
	          if (page.isModule) {
	            page.childCount = childs;
	          } else {
	            count++;
	          }
	        }
	      }
	      return count;
	    };
	
	    if (isShowTitleIndex !== undefined) {
	      //兼容旧版本
	      modules.childCount = filter(modules._pages);
	    }
	    return modules;
	  }
	});
	
	module.exports = PreviewPanel;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var i18n = __webpack_require__(46);
	
	/**
	 * 预览选项
	 */
	var Options = React.createClass({
	  displayName: 'Options',
	
	  propTypes: {
	    showComments: React.PropTypes.bool.isRequired,
	    alwaysShowLinks: React.PropTypes.bool.isRequired,
	    hoverShowLinks: React.PropTypes.bool.isRequired,
	    hoverShowRemarks: React.PropTypes.bool.isRequired,
	    onShowComments: React.PropTypes.func.isRequired,
	    onAlwaysShowLinks: React.PropTypes.func.isRequired,
	    onHoverShowLinks: React.PropTypes.func.isRequired,
	    onHoverShowRemarks: React.PropTypes.func.isRequired
	  },
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'preview-options' },
	      React.createElement(
	        'div',
	        { className: 'option' },
	        React.createElement(
	          'div',
	          null,
	          React.createElement(
	            'span',
	            { onClick: this._onAlwaysShowLinks },
	            React.createElement(
	              'div',
	              { className: 'checkbox-control' },
	              React.createElement('input', { type: 'checkbox', className: 'checkbox-control-input', id: 'link', value: '1',
	                checked: this.props.alwaysShowLinks, readOnly: true }),
	              React.createElement('label', { htmlFor: 'link' }),
	              i18n.get('ALWAYS_SHOW_LINK')
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          null,
	          React.createElement(
	            'span',
	            { onClick: this._onHoverShowLinks },
	            React.createElement(
	              'div',
	              { className: 'checkbox-control' },
	              React.createElement('input', { type: 'checkbox', className: 'checkbox-control-input', id: 'hoverlink', value: '1',
	                checked: this.props.hoverShowLinks, readOnly: true }),
	              React.createElement('label', { htmlFor: 'hoverlink' }),
	              i18n.get('HOVER_SHOW_LINK')
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          null,
	          React.createElement(
	            'span',
	            { onClick: this._onHoverShowRemarks },
	            React.createElement(
	              'div',
	              { className: 'checkbox-control' },
	              React.createElement('input', { type: 'checkbox', className: 'checkbox-control-input', id: 'remarks', value: '1',
	                checked: this.props.hoverShowRemarks, readOnly: true }),
	              React.createElement('label', { htmlFor: 'remarks' }),
	              i18n.get('HOVER_SHOW_REMARK')
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          null,
	          React.createElement(
	            'span',
	            { onClick: this._onShowComments },
	            React.createElement(
	              'div',
	              { className: 'checkbox-control' },
	              React.createElement('input', { type: 'checkbox', className: 'checkbox-control-input', id: 'comments', value: '1',
	                checked: this.props.showComments, readOnly: true }),
	              React.createElement('label', { htmlFor: 'comments' }),
	              i18n.get('SHOW_REMARKS')
	            )
	          )
	        )
	      )
	    );
	  },
	  _onShowComments: function _onShowComments(e) {
	    this.props.onShowComments(!this.props.showComments);
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  _onAlwaysShowLinks: function _onAlwaysShowLinks(e) {
	    this.props.onAlwaysShowLinks(!this.props.alwaysShowLinks);
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  _onHoverShowLinks: function _onHoverShowLinks(e) {
	    this.props.onHoverShowLinks(!this.props.hoverShowLinks);
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  _onHoverShowRemarks: function _onHoverShowRemarks(e) {
	    this.props.onHoverShowRemarks(!this.props.hoverShowRemarks);
	    e.stopPropagation();
	    e.preventDefault();
	  }
	});
	
	module.exports = Options;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	var Resizer = React.createClass({
	  displayName: 'Resizer',
	
	  propTypes: {
	    value: React.PropTypes.number.isRequired,
	    onChange: React.PropTypes.func.isRequired
	  },
	  getInitialState: function getInitialState() {
	    return {
	      value: this.props.value
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState({
	      value: nextProps.value
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.$deviceDom = $('#device');
	    var range = $(".custom-resizer > input");
	    range.change(this.onChange);
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.$deviceDom.css('transform', 'scale(' + this.state.value + ')');
	  },
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'custom-resizer' },
	      React.createElement('input', { type: 'range', value: this.state.value * 100, min: '30', max: '300', onChange: this.onChange })
	    );
	  },
	  onChange: function onChange(e) {
	    clearTimeout(this.timer);
	    var val = parseFloat(parseInt(e.target.value, 10) / 100);
	    this.$deviceDom.css('transform', 'scale(' + val + ')');
	    this.setState({
	      value: val
	    });
	    var self = this;
	    this.timer = setTimeout(function () {
	      self.props.onChange(val);
	    }, 200);
	  }
	});
	
	module.exports = Resizer;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	
	var QrCode = React.createClass({
	    displayName: 'QrCode',
	
	    propTypes: {
	        URL: React.PropTypes.string.isRequired,
	        width: React.PropTypes.number.isRequired,
	        height: React.PropTypes.number.isRequired,
	        hide: React.PropTypes.bool
	    },
	    getInitialState: function getInitialState() {
	        /*二维码默认显示*/
	        return {
	            showQRCode: true
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var element = ReactDOM.findDOMNode(this.refs.code);
	        new QRCode(element, {
	            text: this.props.URL,
	            width: this.props.width,
	            height: this.props.height
	        });
	    },
	    render: function render() {
	        var style;
	        style = {
	            width: this.props.width + 10,
	            height: this.props.height + 10,
	            padding: 5,
	            display: 'inline-block',
	            boxSizing: 'border-box',
	            background: '#fff'
	        };
	        if (this.props.hide) {
	            style.display = 'none';
	        }
	        return React.createElement(
	            'div',
	            { className: 'qr-code', style: style },
	            React.createElement('div', { ref: 'code' })
	        );
	    }
	});
	
	module.exports = QrCode;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var _ = __webpack_require__(51);
	var Shell = __webpack_require__(338);
	var DesktopShell = __webpack_require__(339);
	var MainStage = __webpack_require__(138);
	var pageHelper = __webpack_require__(119);
	var Comments = __webpack_require__(340);
	
	var CommentCover = __webpack_require__(341);
	
	var Workspace = React.createClass({
	  displayName: 'Workspace',
	
	  propTypes: {
	    domSize: React.PropTypes.object.isRequired,
	    meta: React.PropTypes.object.isRequired,
	    pages: React.PropTypes.object,
	    current: React.PropTypes.object.isRequired,
	    target: React.PropTypes.object,
	    animation: React.PropTypes.object,
	    app: React.PropTypes.object.isRequired,
	    showComments: React.PropTypes.bool.isRequired,
	    scale: React.PropTypes.number.isRequired,
	    shell: React.PropTypes.string.isRequired,
	    canFix: React.PropTypes.bool.isRequired,
	    onRedirectTo: React.PropTypes.func.isRequired,
	    onOpenPage: React.PropTypes.func.isRequired,
	    onFinishOpenPage: React.PropTypes.func.isRequired,
	    onShowRemark: React.PropTypes.func.isRequired,
	    alwaysShowLinks: React.PropTypes.bool.isRequired,
	    hintLinks: React.PropTypes.bool.isRequired,
	    scrollRemarks: React.PropTypes.bool.isRequired,
	    pageNeedRerender: React.PropTypes.bool.isRequired,
	    isCommentMode: React.PropTypes.bool.isRequired,
	    review: React.PropTypes.array.isRequired,
	    isShowPaint: React.PropTypes.bool.isRequired,
	    onLoadReviewData: React.PropTypes.func.isRequired
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.current.ID !== nextProps.current.ID) {
	      var scrollDom = ReactDOM.findDOMNode(this.refs.scroll);
	      if (scrollDom) {
	        scrollDom.scrollTop = 0;
	        scrollDom.scrollLeft = 0;
	      }
	      this._onPageScroll(0);
	      this.setState({ pageScrollTop: 0, isNeedReloadReview: true });
	    } else {
	      this.setState({ isNeedReloadReview: false });
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.commentsScroller = $("#comments-scroller");
	    this.doReloadReviewData();
	
	    var scrollContentDom = ReactDOM.findDOMNode(this.refs.scrollContent);
	    console.log(scrollContentDom.clientWidth);
	    var scrollContent = {
	      width: scrollContentDom.clientWidth,
	      height: scrollContentDom.clientHeight
	    };
	    console.log(scrollContent);
	    this.setState({
	      scrollContent: scrollContent
	    });
	  },
	
	  doReloadReviewData: function doReloadReviewData() {
	    if (this.state.isNeedReloadReview) {
	      var syncID = window.reviewID || '';
	      var syncRevision = window.revision || '-1';
	      this.props.onLoadReviewData(syncID, syncRevision, this.props.current.ID);
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    var pageOffset = $('.stage-container').offset();
	    var coverOffset = $('.paint-stage').offset();
	
	    if (pageOffset && coverOffset) {
	      var offset = {
	        left: pageOffset.left - coverOffset.left,
	        top: pageOffset.top - coverOffset.top - (this.state.pageScrollTop || 0)
	      };
	      if (!this.state.offset || offset.left !== this.state.offset.left || offset.top !== this.state.offset.top) {
	        this.setState({ offset: offset });
	      }
	    }
	
	    this.doReloadReviewData();
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      offset: null,
	      pageScrollTop: 0,
	      isNeedReloadReview: true,
	      scrollContent: {
	        width: 0,
	        height: 0
	      }
	    };
	  },
	
	  render: function render() {
	
	    var page = this.props.current;
	    var target = this.props.target;
	    var commentComponents;
	    var pageInfo = pageHelper.getPageDeviceMetaInfo(page, this.props.meta, this.props.shell);
	    var deviceStyle = {
	      width: pageInfo.width,
	      height: pageInfo.height,
	      transform: 'scale(' + this.props.scale + ')'
	    };
	
	    var screenSize = {
	      width: pageInfo.pageSize.x,
	      height: pageInfo.pageSize.y
	    };
	
	    var deviceScrollStyle = {
	      width: Math.round(6000 * this.props.scale), // 设置为 6000 让滚动条显示到上面
	      height: Math.round(pageInfo.height * this.props.scale)
	    };
	
	    var deviceScrollViewStyle = {};
	    if (pageInfo.height * this.props.scale < this.props.domSize.height) {
	      if (this.props.meta.platform === 'MtWeb') {
	        // 网页项目，垂直使用居顶
	        deviceScrollViewStyle.alignItems = 'flex-start';
	      } else {
	        deviceScrollViewStyle.alignItems = 'center';
	      }
	    } else {
	      deviceStyle.transformOrigin = 'top left'; // 此时从左上角放大
	    }
	
	    commentComponents = _.filter(page.controls.control, function (comp) {
	      return comp.isCommentCom;
	    });
	
	    var className = 'preview-container';
	
	    /*显示类型检测*/
	    var shellType = this.props.shell;
	    if (shellType === 'iPad') {
	      deviceStyle.transformOrigin = 'left top';
	    } else if (shellType === 'iPhone') {
	      deviceStyle.transformOrigin = 'center top';
	    } else if (shellType === 'desktop') {
	      deviceStyle.transformOrigin = 'left top';
	    } else {
	      deviceStyle.transformOrigin = 'left top';
	    }
	    if (this.props.meta.platform === 'MtWeb') {
	      //网页项目，顶部居中放缩
	      deviceStyle.transformOrigin = 'center top';
	    }
	
	    var syncID = window.reviewID || '';
	    var syncRevision = window.revision || '-1';
	    return React.createElement(
	      'div',
	      { className: className, onClick: this._onWorkspaceClick },
	      React.createElement(
	        'div',
	        { className: 'device-scroll-view', ref: 'scroll', style: deviceScrollViewStyle },
	        React.createElement(
	          'div',
	          { className: 'device-scroll-content', ref: 'scrollContent', style: deviceScrollStyle },
	          React.createElement(
	            'div',
	            { id: 'device', className: 'device', style: deviceStyle },
	            ['iPhone', 'Android', 'iPad', 'Tablet'].indexOf(this.props.shell) !== -1 && React.createElement(Shell, {
	              size: {
	                width: pageInfo.width,
	                height: pageInfo.height,
	                left: pageInfo.position.x,
	                top: pageInfo.position.y
	              },
	              shell: this.props.shell,
	              isHorizontal: pageInfo.isHorizontal
	            }),
	            this.props.shell === 'desktop' && React.createElement(DesktopShell, {
	              size: {
	                width: pageInfo.width,
	                height: pageInfo.height
	              },
	              title: page.title
	            }),
	            React.createElement(MainStage, _defineProperty({
	              position: pageInfo.position,
	              size: screenSize,
	              current: page,
	              target: target,
	              animation: this.props.animation,
	              pages: this.props.pages,
	              showComments: this.props.showComments,
	              canFix: this.props.canFix,
	              onRedirectTo: this.props.onRedirectTo,
	              onOpenPage: this.props.onOpenPage,
	              onFinishOpenPage: this.props.onFinishOpenPage,
	              onPageScroll: this._onPageScroll,
	              onShowRemark: this.props.onShowRemark,
	              orientation: this.props.meta.orientation,
	              onClick: this.handleClick,
	              pageNeedRerender: this.props.pageNeedRerender
	            }, 'onPageScroll', this.onPageScroll)),
	            React.createElement(Comments, {
	              position: pageInfo.position,
	              components: commentComponents,
	              show: this.props.showComments,
	              pageScrollTop: this.state.pageScrollTop
	            })
	          ),
	          this.props.isShowPaint && React.createElement(CommentCover, {
	
	            scrollLeft: 0,
	            review: this.props.review,
	            fullPageLocation: this.state.offset,
	
	            syncID: syncID,
	            syncVersion: syncRevision,
	            ID: this.props.current.ID,
	
	            onLoadReviewData: this.props.onLoadReviewData,
	            scrollContent: this.state.scrollContent
	          })
	        )
	      )
	    );
	  },
	
	  onPageScroll: function onPageScroll(top, left) {
	    this.setState({ pageScrollTop: top });
	  },
	
	  _onPageScroll: function _onPageScroll(scrollTop) {
	    if (this.props.scrollRemarks) {
	      // 只有当设置中允许滚动批注组件，才滚动批注组件
	      this.commentsScroller && this.commentsScroller.css('top', -scrollTop);
	    }
	  },
	
	  _onWorkspaceClick: function _onWorkspaceClick(e) {
	    if (!this.props.alwaysShowLinks && this.props.hintLinks) {
	      $('.preview-container').addClass('click-show-links');
	      setTimeout(function () {
	        $('.preview-container').removeClass('click-show-links');
	      }, 800);
	    }
	    e.stopPropagation();
	    e.preventDefault();
	    $('.page').trigger('onScreenClick', e);
	  },
	
	  onClickUp: function onClickUp(e) {
	    document.body.removeEventListener('click', this._onWorkspaceClick);
	  }
	
	});
	
	module.exports = Workspace;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	var deviceShellHelper = __webpack_require__(120);
	
	var Shell = React.createClass({
	  displayName: 'Shell',
	
	  propTypes: {
	    size: React.PropTypes.object.isRequired,
	    shell: React.PropTypes.string.isRequired,
	    isHorizontal: React.PropTypes.bool.isRequired
	  },
	  render: function render() {
	    var components;
	    var style;
	    var bottomAndTopStyle;
	    var shell;
	    var isHorizontal;
	    var className;
	    var isMobile;
	
	    shell = this.props.shell;
	    isMobile = shell === 'iPhone' || shell === 'Android';
	    isHorizontal = this.props.isHorizontal;
	    components = deviceShellHelper.getShellComponents({
	      type: 'real',
	      name: shell
	    }, isHorizontal);
	    style = {
	      width: parseInt(this.props.size.width, 10),
	      height: parseInt(this.props.size.height, 10)
	    };
	    className = 'shell';
	    if (isHorizontal) {
	      className += ' horizontal';
	
	      bottomAndTopStyle = {
	        width: this.props.size.left,
	        height: 'auto'
	      };
	    } else {
	      bottomAndTopStyle = {
	        width: 'auto',
	        height: this.props.size.top
	      };
	    }
	
	    return React.createElement(
	      'div',
	      { className: className, style: style },
	      components.whole && React.createElement('img', { className: 'shell-whole', src: components.whole }),
	      isMobile && React.createElement('img', { className: 'shell-top', style: bottomAndTopStyle, src: components.top }),
	      isMobile && React.createElement('img', { className: 'shell-home', style: bottomAndTopStyle, src: components.bottom })
	    );
	  }
	});
	
	module.exports = Shell;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	var DesktopShell = React.createClass({
	  displayName: 'DesktopShell',
	
	  propTypes: {
	    title: React.PropTypes.string.isRequired,
	    size: React.PropTypes.object.isRequired
	  },
	  render: function render() {
	    var shell = 'desktop-shell';
	    var style = {
	      width: this.props.size.width,
	      height: this.props.size.height
	    };
	    var desktopContentStyle = {
	      width: this.props.size.width - 2 * 8,
	      height: this.props.size.height - 30 - 8
	    };
	
	    var desktopTitleStyle = {
	      width: desktopContentStyle.width - 30,
	      height: 30,
	      position: 'absolute',
	      left: 8,
	      top: 0,
	      lineHeight: '30px',
	      color: '#FFFFFF',
	      fontSize: 14
	    };
	
	    var desktopCloseStyle = {
	      width: 20,
	      height: 20,
	      position: 'absolute',
	      left: style.width - 28,
	      top: 5
	    };
	
	    return React.createElement(
	      'div',
	      { className: 'desktop-shell', style: style },
	      React.createElement(
	        'div',
	        { className: 'page-title', style: desktopTitleStyle },
	        this.props.title
	      ),
	      React.createElement('img', { className: 'close-btn', style: desktopCloseStyle, src: assetsHelper.getAsset('shell/close.png') }),
	      React.createElement('div', { className: 'content-area', style: desktopContentStyle })
	    );
	  }
	});
	
	module.exports = DesktopShell;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * 内容容器
	 * */
	
	'use strict';
	
	var React = __webpack_require__(11);
	var compHelper = __webpack_require__(143);
	
	var Comments = React.createClass({
	  displayName: 'Comments',
	
	  propTypes: {
	    position: React.PropTypes.shape({
	      x: React.PropTypes.number,
	      y: React.PropTypes.number
	    }).isRequired,
	    components: React.PropTypes.array
	  },
	  render: function render() {
	    var offset = 0;
	    if (this.props.pageScrollTop) {
	      offset = -this.props.pageScrollTop;
	    }
	    return React.createElement(
	      'div',
	      { className: 'comments', key: 'components' + this.props.controlID, style: {
	          left: this.props.position.x,
	          top: this.props.position.y,
	          display: this.props.show ? 'block' : 'none'
	        } },
	      React.createElement(
	        'div',
	        {
	          id: 'comments-scroller',
	          style: {
	            position: 'relative',
	            top: offset
	          } },
	        this.props.components.map(compHelper.makeComp)
	      )
	    );
	  }
	});
	
	module.exports = Comments;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var i18nHelper = __webpack_require__(46);
	var storeHelper = __webpack_require__(49);
	var appTypes = __webpack_require__(115);
	
	var StylePicker = __webpack_require__(342);
	var SaveAlert = __webpack_require__(343);
	var ProcessAlert = __webpack_require__(344);
	var SignCheckAlert = __webpack_require__(345);
	var PaintToolbar = __webpack_require__(346);
	
	var graphicsHelper = __webpack_require__(172);
	
	var Mediator = __webpack_require__(347);
	var Opreations = __webpack_require__(348);
	var Events = __webpack_require__(349);
	var LayerManager = __webpack_require__(350);
	var Data = __webpack_require__(351);
	var Tool = __webpack_require__(352);
	var InputText = __webpack_require__(353);
	var ErrorMessage = __webpack_require__(354);
	
	var optimizeCall = __webpack_require__(136);
	var optimizedResizeCall = optimizeCall();
	
	var BUTTON_KEY = {
	  'PENCIL': 'pencil', 'RECT': 'rect', 'ARROW': 'arrow', 'ARC': 'arc',
	  'TEXT': 'text', 'MOUSE': 'mouse'
	};
	
	var CommentCover = React.createClass({
	  displayName: 'CommentCover',
	
	
	  propTypes: {
	    scrollLeft: React.PropTypes.number.isRequired,
	    review: React.PropTypes.array.isRequired,
	
	    fullPageLocation: React.PropTypes.object,
	    onLoadReviewData: React.PropTypes.func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      checkedKey: BUTTON_KEY.MOUSE
	    };
	  },
	
	  canvas: null,
	  canvasWidth: 0,
	  canvasHeight: 0,
	
	  translateY: 0,
	  translateX: 0,
	  scrollTop: 0,
	  scrollLeft: 0,
	
	  adjustCanvas: function adjustCanvas() {
	    // var ctx = this.canvas.getContext('2d');
	    // ctx.translate(this.translateX - this.scrollLeft, this.translateY - this.scrollTop);
	    // this.translateY = this.scrollTop;
	    // this.translateX = this.scrollLeft;
	    Data.loadData2();
	  },
	
	  componentWillMount: function componentWillMount() {
	    //初始化
	    Mediator.init(this, Opreations, Events, LayerManager, Data, Tool, InputText);
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.canvas = ReactDOM.findDOMNode(this.refs.canvas);
	
	    // var self = this;
	    // optimizedResizeCall.add(this.adjustCanvas);
	    // var documentEl;
	    // if (document.documentElement) {
	    //   documentEl = document.documentElement;
	    // } else if (document.body) {
	    //   documentEl = document.body;
	    // }
	    // window.onscroll = function () {
	    //   self.scrollTop = documentEl.scrollTop;
	    //   optimizedResizeCall.call();
	    // };
	    this.adjustCanvas();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    //this.scrollLeft = this.props.scrollLeft;
	    this.adjustCanvas();
	    if (this.props.fullPageLocation) {
	      Data.loadData2();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    Data.currentState = null;
	    window.onbeforeunload = null;
	    window.onScroll = null;
	    optimizedResizeCall.remove(this.adjustCanvas);
	  },
	
	  render: function render() {
	    // var className = 'commentMode-popWindow';
	    // if(document.body.clientWidth !== this.canvasWidth || document.body.clientHeight !== this.canvasHeight) {
	    //   this.canvasWidth = document.body.clientWidth;
	    //   this.canvasHeight = document.body.clientHeight;
	    // }
	    // // var w = Math.min(this.props.deviceScrollStyle.width, this.canvasWidth);
	    // // var h = Math.min(this.props.deviceScrollStyle.height, this.canvasHeight - 15);
	    // var w = this.props.deviceScrollStyle.width;
	    // var h = this.props.deviceScrollStyle.height;
	    //
	    // if(this.props.deviceStyle.width < this.canvasWidth) {
	    //   w = this.canvasWidth - (this.props.isShowControlPanel ? 260 : 0);
	    // }
	
	    var w = this.props.scrollContent.width;
	    var h = this.props.scrollContent.height;
	    var canvasStyle = {
	      height: h,
	      width: w,
	      pointerEvents: 'none'
	    };
	    return React.createElement('canvas', { ref: 'canvas',
	      width: w,
	      height: h,
	      style: canvasStyle,
	      className: 'paint-stage'
	    });
	  }
	});
	
	module.exports = CommentCover;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var storeHelper = __webpack_require__(49);
	var appTypes = __webpack_require__(115);
	var Resizer = __webpack_require__(335);
	
	var graphicsHelper = __webpack_require__(172);
	
	var StylePicker = React.createClass({
	    displayName: 'StylePicker',
	
	
	    propTypes: {
	        checkedTool: React.PropTypes.string.isRequired,
	        colorChecked: React.PropTypes.func.isRequired,
	        backColorChecked: React.PropTypes.func.isRequired,
	        backAlphaCheck: React.PropTypes.func.isRequired,
	        lineWidthChecked: React.PropTypes.func.isRequired,
	        fontSizeChecked: React.PropTypes.func.isRequired,
	        isBackColor: React.PropTypes.bool.isRequired,
	        location: React.PropTypes.object.isRequired
	    },
	
	    tool: ['RectTool', 'FilledRectTool', 'EllipseTool', 'FilledEllipseTool', 'ArrowTool', 'PencilTool', 'TextTool'],
	
	    frontColorArray: ['#000000', '#808080', '#800000', '#f7883a', '#308430', '#385ad3', '#800080', '#009999', '#ffffff', '#c0c0c0', '#fb3838', '#ffff00', '#99cc00', '#3894e4', '#f31bf3', '#16dcdc'],
	    backColorArray: ['#000000', '#fb3838', '#ffff00', '#f31bf3', '#ffffff', '#3894e4', '#99cc00', '#16dcdc'],
	    lineWidthArray: [2, 4, 6],
	    fontSizeArray: [12, 14, 16, 18, 20, 22, 24, 26, 28, 32, 36, 48, 72],
	    boxStyle: null,
	    styleObj: null,
	    render: function render() {
	        this.styleObj = JSON.parse(storeHelper.get(this.props.checkedTool));
	        var i = this.tool.indexOf(this.props.checkedTool);
	        this.boxStyle = {
	            left: this.props.location.left + i * 44 + 8
	        };
	
	        switch (this.props.checkedTool) {
	            case 'RectTool':
	            case 'EllipseTool':
	            case 'ArrowTool':
	            case 'PencilTool':
	                return this.getStrokeRender();
	            case 'TextTool':
	                return this.getTextRender();
	            case 'FilledRectTool':
	            case 'FilledEllipseTool':
	                return this.getFillRender();
	
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        var range = $("input[type='range']");
	        range.change(this.updateSlider);
	    },
	
	    getTextRender: function getTextRender() {
	        var reactContext = this;
	        var colorArray = this.frontColorArray;
	        if (this.props.isBackColor) {
	            colorArray = this.backColorArray;
	        }
	        return React.createElement(
	            'div',
	            { className: 'style-picker-box', style: this.boxStyle },
	            React.createElement(
	                'div',
	                { className: 'font-box' },
	                React.createElement(
	                    'span',
	                    { className: 'font-icon-style' },
	                    'A'
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'font-check-box' },
	                    React.createElement(
	                        'select',
	                        { className: 'font-check-style', value: reactContext.styleObj.fontSize, onChange: this.fontSizeChecked },
	                        this.fontSizeArray.map(function (fontSize, index) {
	
	                            return React.createElement(
	                                'option',
	                                { value: fontSize },
	                                fontSize
	                            );
	                        })
	                    )
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'color-box' },
	                React.createElement(
	                    'div',
	                    { className: 'checked-color-box' },
	                    React.createElement('div', { className: 'front-checked-color', style: {
	                            backgroundColor: this.styleObj.color,
	                            border: this.props.isBackColor ? '' : '1px solid black',
	                            zIndex: this.props.isBackColor ? 10003 : 10004
	                        }, onClick: this.props.switchToFront }),
	                    React.createElement('div', { className: 'back-checked-color', style: {
	                            backgroundColor: this.styleObj.backColor,
	                            left: this.props.isBackColor ? 6 : 8,
	                            border: this.props.isBackColor ? '1px solid black' : '',
	                            zIndex: this.props.isBackColor ? 10004 : 10003
	                        }, onClick: this.props.switchToBack })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'color-check-box', style: { width: this.props.isBackColor ? 64 : 128 } },
	                    colorArray.map(function (color, index) {
	                        return React.createElement('div', { className: 'color-item', style: {
	                                backgroundColor: color
	                            }, onClick: reactContext.textColorChecked });
	                    })
	                ),
	                this.props.isBackColor && React.createElement(
	                    'div',
	                    { className: 'range-box' },
	                    React.createElement('input', { type: 'range', min: '1', max: '100', value: this.styleObj.backColorAlpha * 100,
	                        step: '5', onChange: this.updateSlider })
	                )
	            )
	        );
	    },
	
	    getFillRender: function getFillRender() {
	        var reactContext = this;
	        this.boxStyle['width'] = 170;
	        return React.createElement(
	            'div',
	            { className: 'style-picker-box', style: this.boxStyle },
	            React.createElement(
	                'div',
	                { className: 'color-box' },
	                React.createElement('div', { className: 'checked-color', style: {
	                        backgroundColor: this.styleObj.backColor
	                    } }),
	                React.createElement(
	                    'div',
	                    { className: 'color-check-box', style: { width: 64 } },
	                    this.backColorArray.map(function (color, index) {
	                        return React.createElement('div', { className: 'color-item', style: {
	                                backgroundColor: color
	                            }, onClick: reactContext.backColorChecked });
	                    })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'range-box' },
	                    React.createElement('input', { type: 'range', min: '1', max: '100', value: this.styleObj.backColorAlpha * 100,
	                        step: '5', onChange: this.updateSlider })
	                )
	            )
	        );
	    },
	
	    getStrokeRender: function getStrokeRender() {
	        var reactContext = this;
	        return React.createElement(
	            'div',
	            { className: 'style-picker-box', style: this.boxStyle },
	            React.createElement(
	                'div',
	                { className: 'line-width-check' },
	                this.lineWidthArray.map(function (lineWidth) {
	                    return React.createElement(
	                        'div',
	                        { className: 'line-check-box', name: lineWidth, onClick: this.lineWidthChecked,
	                            style: {
	                                width: 23 - (lineWidth === this.styleObj.strokeWidth ? 2 : 0),
	                                height: 23 - (lineWidth === this.styleObj.strokeWidth ? 2 : 0),
	                                border: lineWidth === this.styleObj.strokeWidth ? '1px solid gray' : ''
	                            } },
	                        React.createElement('div', { style: {
	                                width: lineWidth,
	                                height: lineWidth,
	                                marginTop: (23 - lineWidth) / 2 - (lineWidth === this.styleObj.strokeWidth ? 1 : 0),
	                                marginLeft: (23 - lineWidth) / 2 - (lineWidth === this.styleObj.strokeWidth ? 1 : 0)
	                            }, className: 'line-width', name: lineWidth, onClick: this.lineWidthChecked })
	                    );
	                }, this)
	            ),
	            React.createElement(
	                'div',
	                { className: 'color-box' },
	                React.createElement('div', { className: 'checked-color', style: {
	                        backgroundColor: this.styleObj.color
	                    } }),
	                React.createElement(
	                    'div',
	                    { className: 'color-check-box' },
	                    this.frontColorArray.map(function (color, index) {
	                        return React.createElement('div', { className: 'color-item', style: {
	                                backgroundColor: color
	                            }, onClick: reactContext.colorChecked });
	                    })
	                )
	            )
	        );
	    },
	
	    updateSlider: function updateSlider(e) {
	        var value = e.target.value;
	        this.props.backAlphaCheck(value);
	    },
	
	    textColorChecked: function textColorChecked(e) {
	        var node = e.target;
	        var value = $(node).css("background-color");
	        if (this.props.isBackColor) {
	            this.props.backColorChecked(value);
	        } else {
	            this.props.colorChecked(value);
	        }
	    },
	
	    colorChecked: function colorChecked(e) {
	        var node = e.target;
	        var value = $(node).css("background-color");
	        this.props.colorChecked(value);
	    },
	
	    backColorChecked: function backColorChecked(e) {
	        var node = e.target;
	        var value = $(node).css("background-color");
	        this.props.backColorChecked(value);
	    },
	
	    lineWidthChecked: function lineWidthChecked(e) {
	        var lineWidth = parseInt($(e.target).attr('name'), 10);
	        this.props.lineWidthChecked(lineWidth);
	    },
	
	    fontSizeChecked: function fontSizeChecked(e) {
	        var select = e.target;
	        $(select).blur();
	        var index = select.selectedIndex;
	        var value = parseInt(select.options[index].value);
	        this.props.fontSizeChecked(value);
	    }
	
	});
	
	module.exports = StylePicker;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var i18nHelper = __webpack_require__(46);
	
	var SaveAlert = React.createClass({
	    displayName: 'SaveAlert',
	
	
	    propTypes: {
	        registKeyEvent: React.PropTypes.func.isRequired,
	        onDismissSaveAlert: React.PropTypes.func.isRequired,
	        onSave: React.PropTypes.func.isRequired
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'pop-alert-cover' },
	            React.createElement(
	                'div',
	                { className: 'pop-alert' },
	                React.createElement('img', { className: 'close', src: assetsHelper.getAsset('close2.png'), onClick: this.props.onDismissSaveAlert }),
	                React.createElement(
	                    'p',
	                    { className: 'content' },
	                    i18nHelper.get('SAVE_ALERT_MSG')
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'btns' },
	                    React.createElement('input', { className: 'save', type: 'button', onClick: this.sureSave, value: i18nHelper.get('BUTTON_SAVE') }),
	                    React.createElement('input', { className: 'cancel', type: 'button', onClick: this.noSave, value: i18nHelper.get('BUTTON_CANCEL') })
	                )
	            )
	        );
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        var context = this;
	        this.props.registKeyEvent(13, function () {
	            context.sureSave();
	        });
	    },
	
	    componentDidMount: function componentDidMount() {
	        var context = this;
	        this.props.registKeyEvent(13, function () {
	            context.sureSave();
	        });
	    },
	
	    sureSave: function sureSave() {
	        this.props.onSave(true);
	    },
	
	    noSave: function noSave() {
	        this.props.onSave(false);
	    }
	
	});
	
	module.exports = SaveAlert;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var i18nHelper = __webpack_require__(46);
	
	var ProcessAlert = React.createClass({
	    displayName: 'ProcessAlert',
	
	
	    propTypes: {
	        max: React.PropTypes.string.isRequired,
	        value: React.PropTypes.string.isRequired
	    },
	
	    render: function render() {
	        var max = this.props.max;
	        var value = this.props.value;
	        var w = value / max * 100 + '%';
	        return React.createElement(
	            'div',
	            { className: 'pop-alert-cover' },
	            React.createElement(
	                'div',
	                { className: 'pop-alert' },
	                React.createElement(
	                    'p',
	                    { className: 'content' },
	                    i18nHelper.get('SAVING')
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'process-back' },
	                    React.createElement('div', { className: 'process-value', style: { width: w } })
	                )
	            )
	        );
	    }
	
	});
	
	module.exports = ProcessAlert;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var assetsHelper = __webpack_require__(65);
	var i18nHelper = __webpack_require__(46);
	var appTypes = __webpack_require__(115);
	
	var SignCheckAlert = React.createClass({
	    displayName: 'SignCheckAlert',
	
	
	    propTypes: {
	        registKeyEvent: React.PropTypes.func.isRequired,
	        onExitPaint: React.PropTypes.func.isRequired,
	        sign: React.PropTypes.func.isRequired
	    },
	
	    render: function render() {
	
	        return React.createElement(
	            'div',
	            { className: 'pop-alert-cover', onClick: this.onBackFocus },
	            React.createElement(
	                'div',
	                { className: 'sign-alert' },
	                React.createElement('img', { className: 'close', src: assetsHelper.getAsset('close2.png'), onClick: this.props.onExitPaint }),
	                React.createElement(
	                    'div',
	                    { className: 'top-box' },
	                    React.createElement(
	                        'p',
	                        { className: 'text' },
	                        i18nHelper.get('SIGN_ALERT_MSG')
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'bottom-box' },
	                    React.createElement('input', { type: 'text', id: 'text_name', ref: 'sign', className: 'sign-text' }),
	                    React.createElement('input', { type: 'button', className: 'sign-button', onClick: this.sign, value: i18nHelper.get('BUTTON_SURE') })
	                ),
	                React.createElement(
	                    'span',
	                    { className: 'msg' },
	                    i18nHelper.get('SIGN_TIP')
	                )
	            )
	        );
	    },
	
	    onBackFocus: function onBackFocus() {
	        document.getElementById("text_name").focus();
	    },
	
	    componentDidMount: function componentDidMount() {
	        var node = ReactDOM.findDOMNode(this.refs.sign);
	        var context = this;
	        $(node).focus();
	        this.props.registKeyEvent(13, function () {
	            context.sign();
	        });
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        var context = this;
	        this.props.registKeyEvent(13, function () {
	            context.sign();
	        });
	    },
	
	    sign: function sign() {
	        var node = ReactDOM.findDOMNode(this.refs.sign);
	        var value = $(node).val();
	        if (value) {
	            this.props.sign(value);
	        } else {
	            $(node).focus();
	        }
	    }
	
	});
	
	module.exports = SignCheckAlert;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	
	var PaintToolbar = React.createClass({
	  displayName: 'PaintToolbar',
	
	  propTypes: {
	    page: React.PropTypes.object.isRequired,
	    onMouseClick: React.PropTypes.func.isRequired,
	    onRectangleClick: React.PropTypes.func.isRequired,
	    onFilledRectangleClick: React.PropTypes.func.isRequired,
	    onEllipseClick: React.PropTypes.func.isRequired,
	    onFilledEllipseClick: React.PropTypes.func.isRequired,
	    onArrowClick: React.PropTypes.func.isRequired,
	    onPencilClick: React.PropTypes.func.isRequired,
	    onTextClick: React.PropTypes.func.isRequired,
	    onSaveClick: React.PropTypes.func.isRequired,
	    onUndoClick: React.PropTypes.func.isRequired,
	    onRedoClick: React.PropTypes.func.isRequired,
	    onDeleteClick: React.PropTypes.func.isRequired,
	    onHiddenClick: React.PropTypes.func.isRequired,
	    onClearClick: React.PropTypes.func.isRequired,
	    onExitClick: React.PropTypes.func.isRequired,
	    checkTool: React.PropTypes.string.isRequired,
	    saveDisabled: React.PropTypes.bool.isRequired,
	    redoDisabled: React.PropTypes.bool.isRequired,
	    undoDisabled: React.PropTypes.bool.isRequired,
	    isVisible: React.PropTypes.bool.isRequired,
	    isClearable: React.PropTypes.bool.isRequired,
	    onToolbarMountDone: React.PropTypes.func.isRequired
	  },
	  getBoxStyle: function getBoxStyle(tool) {
	    if (tool === this.props.checkTool) {
	      return {
	        border: '1px solid #707070',
	        borderRadius: '4px'
	      };
	    }
	    return {};
	  },
	
	  location: null,
	  getLocation: function getLocation() {
	    var location = $('.tools-left').offset();
	    if (location && (!this.location || location.left !== this.location.left || location.top !== this.location.top)) {
	      this.location = location;
	      this.props.onToolbarMountDone(location);
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    this.getLocation();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.getLocation();
	  },
	
	  render: function render() {
	    var page = this.props.page;
	    var saveButtonStyle = { opacity: this.props.saveDisabled ? 0.5 : 1 };
	    var redoButtonStyle = { opacity: this.props.redoDisabled ? 0.5 : 1 };
	    var undoButtonStyle = { opacity: this.props.undoDisabled ? 0.5 : 1 };
	    var clearButtonStyle = { opacity: this.props.isClearable ? 1 : 0.5 };
	    var hiddenBackClass = '';
	    if (this.props.isVisible) {
	      hiddenBackClass = 'tool-background';
	    }
	    return React.createElement(
	      'div',
	      { className: 'paint-toolbar' },
	      React.createElement(
	        'h6',
	        { className: 'page-title' },
	        page.title
	      ),
	      React.createElement(
	        'div',
	        { className: 'tools' },
	        React.createElement(
	          'div',
	          { className: 'tools tools-left' },
	          React.createElement(
	            'span',
	            { style: this.getBoxStyle('RectTool'), onClick: this.props.onRectangleClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_empty_rect.png') })
	          ),
	          React.createElement(
	            'span',
	            { style: this.getBoxStyle('FilledRectTool'), onClick: this.props.onFilledRectangleClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_filled_rect2.png') })
	          ),
	          React.createElement(
	            'span',
	            { style: this.getBoxStyle('EllipseTool'), onClick: this.props.onEllipseClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_empty_ellipse.png') })
	          ),
	          React.createElement(
	            'span',
	            { style: this.getBoxStyle('FilledEllipseTool'), onClick: this.props.onFilledEllipseClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_filled_ellipse2.png') })
	          ),
	          React.createElement(
	            'span',
	            { style: this.getBoxStyle('ArrowTool'), onClick: this.props.onArrowClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_arrow.png') })
	          ),
	          React.createElement(
	            'span',
	            { style: this.getBoxStyle('PencilTool'), onClick: this.props.onPencilClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_pencil.png') })
	          ),
	          React.createElement(
	            'span',
	            { style: this.getBoxStyle('TextTool'), onClick: this.props.onTextClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_text.png') })
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'tools tools-right' },
	          React.createElement(
	            'span',
	            { onClick: this.props.onSaveClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_save.png'), style: saveButtonStyle })
	          ),
	          React.createElement(
	            'span',
	            { className: hiddenBackClass, onClick: this.props.onHiddenClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_hidden.png') })
	          ),
	          React.createElement(
	            'span',
	            { onClick: this.props.onUndoClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_undo.png'), style: undoButtonStyle })
	          ),
	          React.createElement(
	            'span',
	            { onClick: this.props.onRedoClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_redo.png'), style: redoButtonStyle })
	          ),
	          React.createElement(
	            'span',
	            { onClick: this.props.onDeleteClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_delete.png') })
	          ),
	          React.createElement(
	            'span',
	            { style: clearButtonStyle, onClick: this.props.onClearClick },
	            React.createElement('img', { src: assetsHelper.getAsset('review/icon_clear.png') })
	          )
	        )
	      ),
	      React.createElement('img', { className: 'tool-exit', src: assetsHelper.getAsset('review/icon_close.png'),
	        onClick: this.props.onExitClick })
	    );
	  }
	});
	
	module.exports = PaintToolbar;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var envHelper = __webpack_require__(48);
	
	/**
	 * 中介者对象，管理Paint各部分之间的交互，降低耦合性
	 */
	var Mediator = {
	
	  reactComp: null,
	  Opreations: null,
	  Events: null,
	  LayerManager: null,
	  Data: null,
	  InputText: null,
	
	  toolKey: null,
	  initNum: 0, //该变量临时写在这里，处理光标在canvas上的显示问题
	
	  init: function init(reactComp, opreations, events, layerManager, data, tool, inputText) {
	    this.reactComp = reactComp;
	    this.Opreations = opreations;
	    this.Events = events;
	    this.LayerManager = layerManager;
	    this.Data = data;
	    this.Tool = tool;
	    this.InputText = inputText;
	  },
	
	  //此方法临时处理光标不正常问题，待优化
	  resetEvents: function resetEvents() {
	    if (this.toolKey && this.initNum < 1) {
	      this.initEvents(this.toolKey);
	      this.initNum++;
	    }
	  },
	
	  //传入选中工具
	  initEvents: function initEvents(toolKey) {
	    this.toolKey = toolKey;
	    var setCanvasEvents = function setCanvasEvents() {
	      var canvasEvents = Mediator.Tool[toolKey].canvasEvents;
	      for (var key in canvasEvents) {
	        if (canvasEvents[key]) {
	          Mediator.getCanvas()[key] = Mediator.Events[canvasEvents[key]];
	        } else {
	          Mediator.getCanvas()[key] = null;
	        }
	      }
	    };
	
	    setCanvasEvents();
	    this.Events.clearKeyEvents();
	
	    //mac下快捷键设置
	    if (envHelper.isMac()) {
	      this.registKeyEvent(8, function () {
	        Mediator.deleteLayer();
	      });
	      this.registKeyEvent(90, function () {
	        Mediator.reactComp.rollBack();
	      }, 'metaKey');
	      this.registKeyEvent(89, function () {
	        Mediator.reactComp.reRollBack();
	      }, 'metaKey');
	    } else {
	      //加载delete按下删除选中图层事件
	      this.registKeyEvent(46, function () {
	        Mediator.deleteLayer();
	      });
	      this.registKeyEvent(90, function () {
	        Mediator.reactComp.rollBack();
	      }, 'ctrlKey');
	      this.registKeyEvent(89, function () {
	        Mediator.reactComp.reRollBack();
	      }, 'ctrlKey');
	    }
	
	    this.Events.initFlags();
	  },
	
	  setLayerEvents: function setLayerEvents() {
	    var getLayerEvents = function getLayerEvents(layer) {
	      if (!layer.data.tool) {
	        return;
	      }
	      var layerEventKeys = Mediator.Tool[layer.data.tool].layerEvents;
	      var layerEvents = {};
	      for (var key in layerEventKeys) {
	        if (layer.data.author === Mediator.Data.getAuthor()) {
	          layerEvents[key] = Mediator.Events[layerEventKeys[key]];
	        } else {
	          layerEvents[key] = null;
	        }
	      }
	      return layerEvents;
	    };
	    var layers = $(Mediator.getCanvas()).getLayers();
	    for (var i = 0; i < layers.length; i++) {
	      var layer = layers[i];
	      if (layer.groups[0] === 'points') {
	        continue;
	      }
	      var layerEvents = getLayerEvents(layer);
	      $(Mediator.getCanvas()).setLayer(layer, layerEvents);
	    }
	  },
	
	  switchToEdit: function switchToEdit() {
	    var layer = this.getCurrentLayer();
	    this.initLayerEvents(layer);
	    Mediator.checkCurrent();
	  },
	
	  registKeyEvent: function registKeyEvent(code, func, combo) {
	    Mediator.Events.registKeyEvent(code, func, combo);
	  },
	
	  initLayerEvents: function initLayerEvents(layer) {
	    var eventKeys = this.Tool[layer.data.tool].layerEvents;
	    var obj = {};
	    for (var key in eventKeys) {
	      obj[key] = this.Events[eventKeys[key]];
	    }
	    $(this.reactComp.canvas).setLayer(layer, obj);
	  },
	
	  getCanvas: function getCanvas() {
	    return this.reactComp.canvas;
	  },
	
	  adapteText: function adapteText(text) {
	    var layer = this.getCurrentLayer();
	    var relativeLayers = this.getBindLayers(layer);
	    this.InputText.adapteText(text, relativeLayers[0]);
	  },
	  doMoveLayer: function doMoveLayer(dx, dy) {
	    var target = this.getCurrentLayer();
	    if (!target) {
	      return null;
	    }
	    var key = this.Tool[target.data.tool].moveLayer;
	    var result = this.Opreations[key](target, dx, dy);
	    this.loadCheckPoint();
	    return result;
	  },
	
	  //鼠标按下图层后调用，加载选择点
	  loadCheckPoint: function loadCheckPoint() {
	    var templete = this.Tool.templetePoint;
	    templete.mousedown = this.Events['pointMouseDown'];
	    templete.mousemove = this.Events['pointMouseMove'];
	    templete.mouseover = this.Events['pointMouseOver'];
	    templete.mouseout = this.Events['pointMouseOut'];
	    templete.mouseup = this.Events['pointMouseUp'];
	
	    var target = this.getCurrentLayer();
	    //this.LayerManager.pushToTop(target);
	
	    var key = this.Tool[target.data.tool].initCheckPoint;
	    var objs = this.Opreations[key](templete, target);
	    this.LayerManager.drawPoint(objs);
	  },
	
	  doDragBorder: function doDragBorder(dx, dy, mx, my) {
	    var target = this.getCurrentLayer();
	    if (!target) {
	      return null;
	    }
	    var point = this.Events.data.checkedPoint;
	    var key = this.Tool[target.data.tool].dragBorder;
	    var result = this.Opreations[key](target, point, dx, dy, mx, my);
	    this.loadCheckPoint();
	    return result;
	  },
	
	  getRef: function getRef(key) {
	    return this.reactComp.refs[key];
	  },
	
	  getProps: function getProps(key) {
	    return this.reactComp.props[key];
	  },
	
	  setState: function setState(state) {
	    this.reactComp.setState(state);
	  },
	
	  save: function save() {
	    var add = this.reactComp.props.onAddReview;
	    var update = this.reactComp.props.onUpdateReview;
	    var remove = this.reactComp.props.onRemoveReview;
	    this.Data.save(add, update, remove);
	  },
	
	  sendRequest: function sendRequest() {
	    var add = this.reactComp.props.onAddReview;
	    var update = this.reactComp.props.onUpdateReview;
	    var remove = this.reactComp.props.onRemoveReview;
	    this.Data.sendRequest2(add, update, remove);
	  },
	
	  checkCurrent: function checkCurrent() {
	    var current = this.getCurrentLayer();
	    if (current) {
	      if (this.InputText.isInput) {
	        //输入状态，不加载选择点
	        return;
	      }
	      this.loadCheckPoint();
	    }
	  },
	
	  reset: function reset() {
	    if (this.getCurrentLayer()) {
	      if (this.InputText.isInput) {
	        this.InputText.saveTextData();
	      }
	
	      this.LayerManager.clearPoints();
	      this.Events.data.currentCid = null;
	    }
	  },
	
	  clearAll: function clearAll() {
	    this.LayerManager.clearAll();
	  },
	
	  clearSelf: function clearSelf() {
	    this.reset();
	    var ids = this.LayerManager.clearSelf();
	    this.Data.deleteLayer(ids);
	  },
	
	  clearPoints: function clearPoints() {
	    this.Events.flags.onPoint = false;
	    this.LayerManager.clearPoints();
	  },
	
	  isClearable: function isClearable() {
	    return this.LayerManager.isClearable();
	  },
	
	  deleteLayer: function deleteLayer() {
	    if (!this.InputText.isInput) {
	      var layer = this.getCurrentLayer();
	      this.reset();
	      var ids = this.LayerManager.deleteLayer(layer);
	      this.Data.deleteLayer(ids);
	    }
	  },
	
	  setVisible: function setVisible(isVisible) {
	    this.LayerManager.setVisible(isVisible);
	  },
	
	  addNewLayer: function addNewLayer(e, canvasContext, state) {
	    var x = e.pageX - $(canvasContext).offset().left + Mediator.reactComp.scrollLeft;
	    var y = e.pageY - $(canvasContext).offset().top + Mediator.reactComp.scrollTop;
	    var tool = this.Tool[this.toolKey];
	    if (tool) {
	      var obj = tool.drawingData(x, y, state);
	      if (obj) {
	        return this.LayerManager.addLayer(obj);
	      }
	      return -1;
	    }
	  },
	
	  replaceOldLayer: function replaceOldLayer(e, canvasContext, state) {
	
	    if (this.getCurrentLayer()) {
	      var currentIndex = this.getCurrentLayer().index;
	      $(Mediator.getCanvas()).removeLayer(currentIndex);
	    }
	    return this.addNewLayer(e, canvasContext, state);
	  },
	
	  //获取与图层绑定的所有图层
	  getBindLayers: function getBindLayers(layer) {
	    return this.LayerManager.getBindLayers(layer);
	  },
	
	  //选中的文本背景添加文本
	  appendTextLayer: function appendTextLayer(value) {
	    var backLayer = this.getCurrentLayer();
	    var tool = this.Tool[backLayer.data.tool];
	    if (tool && tool.appendText) {
	      var obj = tool.appendText(backLayer, value);
	      return this.LayerManager.addLayer(obj);
	    }
	  },
	
	  restore: function restore() {
	    this.Data.restore2();
	    this.updateReact();
	  },
	
	  figureTextWidth: function figureTextWidth(textValue, obj, backLayer) {
	    return this.InputText.figureTextWidth(textValue, obj, backLayer);
	  },
	
	  getToolByLayer: function getToolByLayer(layer) {
	    if (layer) {
	      if (this.Tool[layer.data.tool]) {
	        return this.Tool[layer.data.tool];
	      }
	    }
	    return null;
	  },
	
	  getStyle: function getStyle(tool, key) {
	    return this.Tool.getStyle(tool, key);
	  },
	
	  flipPoints: function flipPoints(checkPoint, axis) {
	    this.Events.data.checkedPoint = this.LayerManager.flipPoints(checkPoint, axis);
	  },
	
	  updateReact: function updateReact() {
	    this.reactComp.update();
	  },
	
	  getCid: function getCid() {
	    var id = this.LayerManager.getCid();
	    return id;
	  },
	
	  getCurrentLayer: function getCurrentLayer() {
	    var layerCid = this.Events.data.currentCid;
	    var layer = this.LayerManager.getLayerByCid(layerCid);
	    if (layer) {
	      return this.LayerManager.getBindLayers(layer)[0];
	    }
	    return null;
	  },
	
	  getLayerByCid: function getLayerByCid(layerCid) {
	    return this.LayerManager.getLayerByCid(layerCid);
	  },
	
	  getCursorStyle: function getCursorStyle(layer) {
	    return this.LayerManager.getCursorStyle(layer);
	  },
	
	  getAuthor: function getAuthor() {
	    return this.Data.getAuthor();
	  },
	
	  setArrowSize: function setArrowSize(target) {
	    this.Opreations.setArrowSize(target);
	  },
	
	  setCurrentCid: function setCurrentCid(cid) {
	    this.Events.data.currentCid = cid;
	  },
	
	  hiddenLayer: function hiddenLayer(layer) {
	    this.LayerManager.hiddenLayer(layer);
	  },
	
	  showLayer: function showLayer(layer) {
	    this.LayerManager.showLayer(layer);
	  },
	
	  openTextArea: function openTextArea() {
	    if (this.getCurrentLayer() !== null) {
	      this.InputText.openTextArea();
	    }
	  },
	
	  isOnArrow: function isOnArrow(x, y) {
	    return this.LayerManager.isOnArrow(x, y);
	  }
	};
	
	module.exports = Mediator;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Mediator = __webpack_require__(347);
	
	/**
	 * 操作jcanvas图层
	 */
	var Opreations = {
	
	  //根据圆心与旋转角算出新坐标
	  //x1、y1是点坐标，x0、y0是圆心坐标
	  rotate: function rotate(x1, y1, x0, y0, angle) {
	    //获取点到圆心距离
	    var d1 = Math.sqrt(Math.pow(y0 - y1, 2) + Math.pow(x0 - x1, 2));
	    //根据角度和点心距离，求未知点到点心线的距离
	    var d2 = d1 * Math.sin(angle * 2 * Math.PI / 360);
	    var d3 = d1 * Math.cos(angle * 2 * Math.PI / 360);
	
	    //4、求过未知点垂直于点心线的交点
	    var dx = x0 - x1;
	    var dy = y0 - y1;
	    var x2 = x1 + (d1 - d3) / d1 * dx;
	    var y2 = y1 + (d1 - d3) / d1 * dy;
	
	    var getQuadrant = function getQuadrant() {
	      var quadrant;
	      if (x1 === x0 && y1 === y0) {
	        quadrant = '0';
	      }
	      if (y1 === y0) {
	        if (x1 < x0) {
	          quadrant = '1';
	        } else {
	          quadrant = '3';
	        }
	      } else if (x1 === x0) {
	        if (y1 < y0) {
	          quadrant = '2';
	        } else {
	          quadrant = '4';
	        }
	      } else {
	        if (x1 < x0 && y1 < y0) {
	          quadrant = '5';
	        }
	        if (x1 > x0 && y1 < y0) {
	          quadrant = '6';
	        }
	        if (x1 > x0 && y1 > y0) {
	          quadrant = '7';
	        }
	        if (x1 < x0 && y1 > y0) {
	          quadrant = '8';
	        }
	      }
	      return quadrant;
	    };
	    //根据象限和旋转角度选择位置
	    var choicePoint = function choicePoint() {
	      var quadrant = getQuadrant();
	      if (quadrant === '0') {
	        return { 'x': x1, 'y': y1 };
	      }
	      if (quadrant === '1' || quadrant === '4') {
	        return { 'x': location.x2, 'y': location.y2 };
	      }
	      if (quadrant === '2' || quadrant === '3') {
	        return { 'x': location.x1, 'y': location.y1 };
	      }
	      if (quadrant === '5' || quadrant === '6') {
	        if (angle > 180) {
	          return { 'x': location.x1, 'y': location.y1 };
	        } else {
	          return { 'x': location.x2, 'y': location.y2 };
	        }
	      }
	      if (quadrant === '7' || quadrant === '8') {
	        if (angle > 180) {
	          return { 'x': location.x2, 'y': location.y2 };
	        } else {
	          return { 'x': location.x1, 'y': location.y1 };
	        }
	      }
	    };
	
	    var location;
	    if (y1 === y0) {
	      location = { 'x1': x2, 'y1': y1 + d2, 'x2': x2, 'y2': y1 - d2 };
	    } else if (x1 === x0) {
	      location = { 'x1': x2 + d2, 'y1': y2, 'x2': x2 - d2, 'y2': y2 };
	    } else {
	      var k1 = (y0 - y1) / (x0 - x1);
	      var k2 = 0 - 1 / k1;
	
	      location = Opreations.getLocation(k2, x2, y2, d2);
	    }
	    return choicePoint();
	  },
	  lineRotate: function lineRotate(x1, y1, x0, y0, angle, newAngle) {
	    //获取点到圆心距离
	    var d1 = Math.sqrt(Math.pow(y0 - y1, 2) + Math.pow(x0 - x1, 2));
	    //根据角度和点心距离，求未知点到点心线的距离
	    var d2 = d1 * Math.sin(angle * 2 * Math.PI / 360);
	    var d3 = d1 * Math.cos(angle * 2 * Math.PI / 360);
	
	    //4、求过未知点垂直于点心线的交点
	    var dx = x0 - x1;
	    var dy = y0 - y1;
	    var x2 = x1 + (d1 - d3) / d1 * dx;
	    var y2 = y1 + (d1 - d3) / d1 * dy;
	
	    var getQuadrant = function getQuadrant() {
	      var quadrant;
	      if (x1 === x0 && y1 === y0) {
	        quadrant = '0';
	        return quadrant;
	      }
	      if (y1 === y0) {
	        if (x1 < x0) {
	          quadrant = '1';
	        } else {
	          quadrant = '3';
	        }
	      } else if (x1 === x0) {
	        if (y1 < y0) {
	          quadrant = '2';
	        } else {
	          quadrant = '4';
	        }
	      } else {
	        if (x1 < x0 && y1 < y0) {
	          quadrant = '5';
	        }
	        if (x1 > x0 && y1 < y0) {
	          quadrant = '6';
	        }
	        if (x1 > x0 && y1 > y0) {
	          quadrant = '7';
	        }
	        if (x1 < x0 && y1 > y0) {
	          quadrant = '8';
	        }
	      }
	      return quadrant;
	    };
	    //根据象限和旋转角度选择位置
	    var choicePoint = function choicePoint() {
	      var quadrant = getQuadrant();
	      if (quadrant === '0') {
	        return { 'x': x1, 'y': y1 };
	      }
	      if (quadrant === '1' || quadrant === '4') {
	        return { 'x': location.x2, 'y': location.y2 };
	      }
	      if (quadrant === '2' || quadrant === '3') {
	        return { 'x': location.x1, 'y': location.y1 };
	      }
	      if (quadrant === '5' || quadrant === '6') {
	        if (angle < 0) {
	          return { 'x': location.x1, 'y': location.y1 };
	        } else {
	          return { 'x': location.x2, 'y': location.y2 };
	        }
	      }
	      if (quadrant === '7' || quadrant === '8') {
	        if (angle < 0) {
	          return { 'x': location.x2, 'y': location.y2 };
	        } else {
	          return { 'x': location.x1, 'y': location.y1 };
	        }
	      }
	    };
	
	    var location;
	
	    if (angle === 0 || angle === 360 || angle === -360) {
	      return { 'x': x1, 'y': y1 };
	    }
	    if (y1 === y0) {
	      location = { 'x1': x2, 'y1': y1 + d2, 'x2': x2, 'y2': y1 - d2 };
	    } else if (x1 === x0) {
	      location = { 'x1': x2 + d2, 'y1': y2, 'x2': x2 - d2, 'y2': y2 };
	    } else {
	      var k1 = (y0 - y1) / (x0 - x1);
	      var k2 = 0 - 1 / k1;
	      location = Opreations.getLocation(k2, x2, y2, d2);
	    }
	    var test = choicePoint();
	    return test;
	  },
	  getAngle: function getAngle(centerX, centerY, mx, my) {
	    //获得人物中心和鼠标坐标连线，与y轴正半轴之间的夹角
	    var x = Math.abs(centerX - mx);
	    var y = Math.abs(centerY - my);
	    var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
	    var cos = y / z;
	    var radina = Math.acos(cos); //用反三角函数求弧度
	    var angle = Math.floor(180 / (Math.PI / radina)); //将弧度转换成角度
	
	    if (mx > centerX && my > centerY) {
	      //鼠标在第四象限
	      angle = 180 - angle;
	    }
	    if (mx == centerX && my > centerY) {
	      //鼠标在y轴负方向上
	      angle = 180;
	    }
	    if (mx > centerX && my == centerY) {
	      //鼠标在x轴正方向上
	      angle = 90;
	    }
	    if (mx < centerX && my > centerY) {
	      //鼠标在第三象限
	      angle = 180 + angle;
	    }
	    if (mx < centerX && my == centerY) {
	      //鼠标在x轴负方向
	      angle = 270;
	    }
	    if (mx < centerX && my < centerY) {
	      //鼠标在第二象限
	      angle = 360 - angle;
	    }
	    return angle;
	  },
	  getLocation: function getLocation(k, centerX, centerY, d) {
	    var b = centerY - centerX * k;
	    var A = b - centerY;
	    var B = 0 - centerX;
	    var o = k * k + 1;
	    var p = 2 * A * k + 2 * B;
	    var q = A * A + B * B - d * d;
	
	    var x1 = (0 - p - Math.sqrt(p * p - 4 * o * q)) / (2 * o);
	    var x2 = (0 - p + Math.sqrt(p * p - 4 * o * q)) / (2 * o);
	    var y1 = k * x1 + b;
	    var y2 = k * x2 + b;
	    return { 'x1': x1, 'y1': y1, 'x2': x2, 'y2': y2 };
	  },
	  getRotatePointLocation: function getRotatePointLocation(x1, x2, y1, y2) {
	    //计算用来控制旋转的悬停点位置
	    var x, y;
	    var midX = (x1 + x2) / 2;
	    var midY = (y1 + y2) / 2;
	    if (x1 === x2) {
	      x = x1 + 30;
	      y = midY;
	    } else if (y1 === y2) {
	      x = midX;
	      y = y1 - 30;
	    } else {
	      var k = 0 - (x2 - x1) / (y2 - y1);
	      var location = Opreations.getLocation(k, midX, midY, 30);
	      if (y2 < y1) {
	        x = location.x1;
	        y = location.y1;
	      } else {
	        x = location.x2;
	        y = location.y2;
	      }
	    }
	    return { name: 'pointRotate', x: x, y: y };
	  },
	
	  initRectanglePoint: function initRectanglePoint(x, y, w, h, templete, angle) {
	
	    var left = { 'x': x, 'y': y + h / 2 };
	    var top = { 'x': x + w / 2, 'y': y };
	    var right = { 'x': x + w, 'y': y + h / 2 };
	    var bottom = { 'x': x + w / 2, 'y': y + h };
	
	    var leftTop = { 'x': x, 'y': y };
	    var rightTop = { 'x': x + w, 'y': y };
	    var rightBottom = { 'x': x + w, 'y': y + h };
	    var leftBottom = { 'x': x, 'y': y + h };
	    if (angle && angle != 0 && angle != 180) {
	      left = Opreations.rotate(left.x, left.y, x + w / 2, y + h / 2, angle);
	      top = Opreations.rotate(top.x, top.y, x + w / 2, y + h / 2, angle);
	      right = Opreations.rotate(right.x, right.y, x + w / 2, y + h / 2, angle);
	      bottom = Opreations.rotate(bottom.x, bottom.y, x + w / 2, y + h / 2, angle);
	      leftTop = Opreations.rotate(leftTop.x, leftTop.y, x + w / 2, y + h / 2, angle);
	      rightTop = Opreations.rotate(rightTop.x, rightTop.y, x + w / 2, y + h / 2, angle);
	      rightBottom = Opreations.rotate(rightBottom.x, rightBottom.y, x + w / 2, y + h / 2, angle);
	      leftBottom = Opreations.rotate(leftBottom.x, leftBottom.y, x + w / 2, y + h / 2, angle);
	    }
	    var pointLeft = $.extend({}, templete, {
	      name: 'pointLeft',
	      x: left.x, y: left.y
	    });
	    var pointTop = $.extend({}, templete, {
	      name: 'pointTop',
	      x: top.x, y: top.y
	    });
	    var pointRight = $.extend({}, templete, {
	      name: 'pointRight',
	      x: right.x, y: right.y
	    });
	    var pointBottom = $.extend({}, templete, {
	      name: 'pointBottom',
	      x: bottom.x, y: bottom.y
	    });
	    var pointLeftTop = $.extend({}, templete, {
	      name: 'pointLeftTop',
	      x: leftTop.x, y: leftTop.y
	    });
	    var pointRightTop = $.extend({}, templete, {
	      name: 'pointRightTop',
	      x: rightTop.x, y: rightTop.y
	    });
	    var pointRightBottom = $.extend({}, templete, {
	      name: 'pointRightBottom',
	      x: rightBottom.x, y: rightBottom.y
	    });
	    var pointLeftBottom = $.extend({}, templete, {
	      name: 'pointLeftBottom',
	      x: leftBottom.x, y: leftBottom.y
	    });
	    //var rotatePoint = Opreations.getRotatePointLocation(leftTop.x, rightTop.x, leftTop.y, rightTop.y);
	    //var pointRotate = $.extend({}, templete, rotatePoint);
	    return [pointLeft, pointTop, pointRight, pointBottom, pointLeftTop, pointRightTop, pointRightBottom, pointLeftBottom];
	  },
	  initShapePoint: function initShapePoint(templete, layer) {
	    var x = layer.x;
	    var y = layer.y;
	    var w = layer.width;
	    var h = layer.height;
	    return Opreations.initRectanglePoint(x, y, w, h, templete, layer.rotate);
	  },
	  initPencilPoint: function initPencilPoint(templete, layer) {
	    var angle = layer.data.angle;
	    var box = Opreations.figureLineBox(layer);
	    return Opreations.initRectanglePoint(box.x, box.y, box.w, box.h, templete, angle);
	  },
	  initArrowPoint: function initArrowPoint(templete, layer) {
	    var x1 = layer.x1;
	    var x2 = layer.x2;
	    var y1 = layer.y1;
	    var y2 = layer.y2;
	    var w = layer.strokeWidth;
	
	    //centerX = (x1 + x2)/2;
	    //centerY = (y1 + y2)/2;
	
	    var d = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
	    var a = (w + d) / d;
	    var offX = (x2 - x1) * a + x1;
	    var offY = (y2 - y1) * a + y1;
	
	    var rotatePoint = Opreations.getRotatePointLocation(x1, x2, y1, y2);
	
	    var pointBegin = $.extend({}, templete, {
	      name: 'pointBegin',
	      x: layer.x1,
	      y: layer.y1
	    });
	    var pointEnd = $.extend({}, templete, {
	      name: 'pointEnd',
	      x: offX,
	      y: offY
	    });
	    //var pointRotate = $.extend({}, templete, rotatePoint);
	
	    return [pointBegin, pointEnd];
	  },
	  initTextPoint: function initTextPoint(templete, layer) {
	    var target = Mediator.getBindLayers(layer)[0];
	    var x = target.x;
	    var y = target.y;
	    var w = target.width;
	    var h = target.height;
	    return Opreations.initRectanglePoint(x, y, w, h, templete, target.rotate);
	  },
	
	  moveShapeLayer: function moveShapeLayer(target, dx, dy) {
	    if (target != null && (dx !== 0 || dy !== 0)) {
	      target.x += dx;
	      target.y += dy;
	      target.data.isChanged = true;
	      return true;
	    }
	  },
	  moveLineLayer: function moveLineLayer(target, dx, dy) {
	    if (target != null && (dx !== 0 || dy !== 0)) {
	      var box = Opreations.figureLineBox(target);
	      var i = 1;
	      while (true) {
	        var x = target['x' + i];
	        var y = target['y' + i];
	        if (x === undefined || y === undefined) {
	          break;
	        }
	        target['x' + i] += dx;
	        target['y' + i] += dy;
	        i++;
	      }
	      target.data.isChanged = true;
	      return true;
	    }
	    return false;
	  },
	  moveTextLayer: function moveTextLayer(target, dx, dy) {
	    if (target != null && (dx !== 0 || dy !== 0)) {
	      var layers = Mediator.getBindLayers(target);
	      for (var i = 0; i < layers.length; i++) {
	        layers[i].x += dx;
	        layers[i].y += dy;
	        layers[i].data.isChanged = true;
	      }
	      return true;
	    }
	    return false;
	  },
	
	  filledTools: ['FilledRectTool', 'FilledEllipseTool', 'TextTool'],
	  dragShapeBorder: function dragShapeBorder(target, checkedPoint, dx, dy, mx, my) {
	    var result = false;
	    var minValue = target.strokeWidth; //线框工具最小值为线宽，实心工具最小值为5
	    if (target && Opreations.filledTools.indexOf(target.data.tool) !== -1) {
	      minValue = 5;
	    }
	    var left = function left() {
	      if (dx === 0 || Math.abs(target.width - dx) < minValue) {
	        return;
	      }
	
	      target.width -= dx;
	      target.x += dx;
	      target.data.isChanged = true;
	      result = true;
	    };
	    var top = function top() {
	      if (dy === 0 || Math.abs(target.height - dy) < minValue) {
	        return;
	      }
	      target.height -= dy;
	      target.y += dy;
	      target.data.isChanged = true;
	      result = true;
	    };
	    var right = function right() {
	      if (dx === 0 || Math.abs(target.width + dx) < minValue) {
	        return;
	      }
	      target.width += dx;
	      target.data.isChanged = true;
	      result = true;
	    };
	    var bottom = function bottom() {
	      if (dy === 0 || Math.abs(target.height + dy) < minValue) {
	        return;
	      }
	      target.height += dy;
	      target.data.isChanged = true;
	      result = true;
	    };
	
	    if (checkedPoint.name === 'pointLeft') {
	      left();
	    }
	    if (checkedPoint.name === 'pointTop') {
	      top();
	    }
	    if (checkedPoint.name === 'pointRight') {
	      right();
	    }
	    if (checkedPoint.name === 'pointBottom') {
	      bottom();
	    }
	    if (checkedPoint.name === 'pointLeftTop') {
	      left();
	      top();
	    }
	    if (checkedPoint.name === 'pointRightTop') {
	      right();
	      top();
	    }
	    if (checkedPoint.name === 'pointRightBottom') {
	      right();
	      bottom();
	    }
	    if (checkedPoint.name === 'pointLeftBottom') {
	      left();
	      bottom();
	    }
	    if (checkedPoint.name === 'pointRotate') {
	      var centerX = target.x + target.width / 2;
	      var centerY = target.y + target.height / 2;
	      var angle = Opreations.getAngle(centerX, centerY, mx, my);
	      target.rotate = angle;
	    }
	
	    return result;
	  },
	  dragPencilBorder: function dragPencilBorder(target, checkedPoint, dx, dy, mx, my) {
	    var box = Opreations.figureLineBox(target);
	    var toLeftRatio = (box.w - dx) / box.w;
	    var toTopRatio = (box.h - dy) / box.h;
	    var toRightRatio = (box.w + dx) / box.w;
	    var toBottomRatio = (box.h + dy) / box.h;
	    var i = 1;
	    var result = false;
	    var minValue = 10;
	    var left = function left(x, y) {
	      if (dx === 0 || Math.abs(box.w * toLeftRatio) <= minValue || !isFinite(toLeftRatio)) {
	        return;
	      }
	      target['x' + i] = (x - box.x) * toLeftRatio + box.x + dx;
	      target.data.isChanged = true;
	      result = true;
	      if (toLeftRatio < 0) {
	        Mediator.flipPoints(checkedPoint, 'LR');
	      }
	    };
	    var top = function top(x, y) {
	      if (dy === 0 || Math.abs(box.h * toTopRatio) <= minValue || !isFinite(toTopRatio)) {
	        return;
	      }
	      target['y' + i] = (y - box.y) * toTopRatio + box.y + dy;
	      target.data.isChanged = true;
	      result = true;
	      if (toTopRatio < 0) {
	        Mediator.flipPoints(checkedPoint, 'TB');
	      }
	    };
	    var right = function right(x, y) {
	      if (dx === 0 || Math.abs(box.w * toRightRatio) <= minValue || !isFinite(toRightRatio)) {
	        return;
	      }
	      target['x' + i] = (x - box.x) * toRightRatio + box.x;
	      target.data.isChanged = true;
	      result = true;
	      if (toRightRatio < 0) {
	        Mediator.flipPoints(checkedPoint, 'LR');
	      }
	    };
	    var bottom = function bottom(x, y) {
	      if (dy === 0 || Math.abs(box.h * toBottomRatio) <= minValue || !isFinite(toBottomRatio)) {
	        return;
	      }
	      target['y' + i] = (y - box.y) * toBottomRatio + box.y;
	      target.data.isChanged = true;
	      result = true;
	      if (toBottomRatio < 0) {
	        Mediator.flipPoints(checkedPoint, 'TB');
	      }
	    };
	
	    /*var x0 = box.x + box.w / 2;
	     var y0 = box.y + box.h / 2;
	       var a = Opreations.getAngle(x0, y0, rpX, rpY);
	     if(!target.data.oldAngle) {
	     target.data.oldAngle = a;
	     }
	     var newAngle = Opreations.getAngle(x0, y0, mx, my);
	     var angle = newAngle - target.data.oldAngle;
	     target.data.oldAngle = newAngle;
	     target.data.angle = newAngle - a;*/
	
	    while (true) {
	      var x = target['x' + i];
	      var y = target['y' + i];
	      if (x === undefined || y === undefined) {
	        break;
	      }
	      if (checkedPoint.name === 'pointLeft') {
	        left(x, y);
	      }
	      if (checkedPoint.name === 'pointTop') {
	        top(x, y);
	      }
	      if (checkedPoint.name === 'pointRight') {
	        right(x, y);
	      }
	      if (checkedPoint.name === 'pointBottom') {
	        bottom(x, y);
	      }
	      if (checkedPoint.name === 'pointLeftTop') {
	        left(x, y);
	        top(x, y);
	      }
	      if (checkedPoint.name === 'pointRightTop') {
	        right(x, y);
	        top(x, y);
	      }
	      if (checkedPoint.name === 'pointRightBottom') {
	        right(x, y);
	        bottom(x, y);
	      }
	      if (checkedPoint.name === 'pointLeftBottom') {
	        left(x, y);
	        bottom(x, y);
	      }
	      if (checkedPoint.name === 'pointRotate') {
	        /*var location = Opreations.lineRotate(x, y, x0, y0, angle, newAngle);
	         target['x' + i] = location.x;
	         target['y' + i] = location.y;*/
	      }
	      i++;
	    }
	    return result;
	  },
	  dragArrowBorder: function dragArrowBorder(target, checkedPoint, dx, dy, mx, my) {
	    var result = false;
	    if (dx === 0 && dy === 0) {
	      return false;
	    }
	    if (checkedPoint.name === 'pointBegin') {
	      //箭头工具最小值为10，不支持过小箭头
	      if (Math.sqrt(Math.pow(target.x2 - target.x1 - dx, 2) + Math.pow(target.y2 - target.y1 - dy, 2)) < 10) {
	        return;
	      }
	      target.x1 += dx;
	      target.y1 += dy;
	      target.data.isChanged = true;
	      result = true;
	    }
	    if (checkedPoint.name === 'pointEnd') {
	      if (Math.sqrt(Math.pow(target.x2 - target.x1 + dx, 2) + Math.pow(target.y2 - target.y1 + dy, 2)) < 10) {
	        return;
	      }
	      target.x2 += dx;
	      target.y2 += dy;
	      target.data.isChanged = true;
	      result = true;
	    }
	    if (checkedPoint.name === 'pointRotate') {
	      var centerX = (target.x1 + target.x2) / 2;
	      var centerY = (target.y1 + target.y2) / 2;
	      if (!target.data.oldAngle) {
	        target.data.oldAngle = Opreations.getAngle(centerX, centerY, rpX, rpY);
	      }
	      var newAngle = Opreations.getAngle(centerX, centerY, mx, my);
	      var angle = newAngle - target.data.oldAngle;
	      target.data.oldAngle = newAngle;
	      target.data.angle = angle;
	      var location = Opreations.lineRotate(target.x1, target.y1, centerX, centerY, angle, newAngle);
	      target['x1'] = location.x;
	      target['y1'] = location.y;
	
	      var location = Opreations.lineRotate(target.x2, target.y2, centerX, centerY, angle, newAngle);
	      target['x2'] = location.x;
	      target['y2'] = location.y;
	
	      /*var centerX = (target.x1 + target.x2) / 2;
	       var centerY = (target.y1 + target.y2) / 2;
	       var d = Math.sqrt(Math.pow(target.x2 - target.x1, 2) + Math.pow(target.y2 - target.y1, 2)) / 2;
	       var angle = Opreations.getAngle(centerX, centerY, mx, my);
	       var k = Math.tan(angle * 2 * Math.PI / 360);
	         var location = Opreations.getLocation(k, centerX, centerY, d);
	           if (90 < angle && angle < 270) {
	       target.x1 = location.x2;
	       target.y1 = location.y2;
	       target.x2 = location.x1;
	       target.y2 = location.y1;
	       } else {
	       target.x1 = location.x1;
	       target.y1 = location.y1;
	       target.x2 = location.x2;
	       target.y2 = location.y2;
	       }*/
	    }
	    Opreations.setArrowSize(target);
	
	    return result;
	  },
	  dragTextBorder: function dragTextBorder(target, checkedPoint, dx, dy, mx, my) {
	    var relativeLayers = Mediator.getBindLayers(target);
	    var wrapLayer = relativeLayers[0];
	    var contentLayer = relativeLayers[1];
	    var result = false;
	    if (wrapLayer) {
	      result = Opreations.dragShapeBorder(wrapLayer, checkedPoint, dx, dy, mx, my);
	      if (contentLayer && result) {
	        contentLayer.x = Math.min(wrapLayer.x, wrapLayer.x + wrapLayer.width) + 10;
	        contentLayer.y = Math.min(wrapLayer.y, wrapLayer.y + wrapLayer.height) + 10;
	        contentLayer.text = Mediator.figureTextWidth(contentLayer.data.text, contentLayer._args, wrapLayer);
	        contentLayer.data.isChanged = true;
	      }
	    }
	    return result;
	  },
	
	  figureLineBox: function figureLineBox(layer) {
	    var i = 1;
	    var minX = Number.MAX_VALUE;
	    var minY = Number.MAX_VALUE;
	    var maxX = 0,
	        maxY = 0;
	    while (true) {
	      var x = layer['x' + i];
	      var y = layer['y' + i];
	      if (x === undefined || y === undefined) {
	        break;
	      }
	      if (x < minX) {
	        minX = x;
	      }
	      if (x > maxX) {
	        maxX = x;
	      }
	      if (y < minY) {
	        minY = y;
	      }
	      if (y > maxY) {
	        maxY = y;
	      }
	      i++;
	    }
	    return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
	  },
	  setArrowSize: function setArrowSize(target) {
	    var arrowLen = Math.sqrt(Math.pow(target.x2 - target.x1, 2) + Math.pow(target.y2 - target.y1, 2));
	    if (arrowLen < 80) {
	      target.arrowRadius = 7;
	      target.arrowAngle = 80;
	    } else if (arrowLen < 200) {
	      target.arrowRadius = 10;
	      target.arrowAngle = 60;
	    } else {
	      target.arrowRadius = 15;
	      target.arrowAngle = 40;
	    }
	  }
	};
	
	module.exports = Opreations;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Mediator = __webpack_require__(347);
	var MOUSE_STATE = { 'DOWN': 'down', 'MOVE': 'move', 'RELEASE': 'release' };
	
	/**
	 * 管理批注过程中各种绘制及编辑的事件
	 */
	var Events = {
	
	  flags: {
	    canvasPressed: false,
	    pointPressed: false,
	    layerPressed: false,
	
	    isMove: false,
	    onLayer: false
	  },
	
	  data: {
	    lastPointX: -1,
	    lastPointY: -1,
	    lastLayerX: -1,
	    lastLayerY: -1,
	
	    currentCid: -1,
	    checkedPoint: null,
	    keyEvents: [],
	    documentClickHandlers: [],
	    delayInit: null
	  },
	
	  initFlags: function initFlags() {
	    Events.flags.canvasPressed = false;
	    Events.flags.pointPressed = false;
	    Events.flags.layerPressed = false;
	
	    Events.flags.isMove = false;
	    Events.flags.isEditMode = false;
	  },
	
	  execDelay: function execDelay() {
	    if (Events.data.delayInit && Events.flags.canvasPressed) {
	      //延迟初始化
	      Events.data.delayInit();
	      Events.data.delayInit = null;
	    }
	  },
	
	  canvasMouseDown: function canvasMouseDown(e) {
	    if (e.button !== 0) {
	      return;
	    }
	    if (!Events.flags.canvasPressed) {
	
	      Events.checkArrowClick.call(this, e);
	
	      //做好绘制准备
	      Events.flags.canvasPressed = true;
	      Mediator.addNewLayer(e, this, MOUSE_STATE.DOWN);
	      //延迟初始化，根据isEditMode值决定是否调用，且只调用一次（调用完后置空）
	      Events.data.delayInit = function () {
	        Mediator.reset();
	        Mediator.setState({ isShowStylePicker: false });
	      };
	    }
	  },
	  canvasMouseMove: function canvasMouseMove(e) {
	
	    if (!Events.flags.canvasPressed) {
	      //切入扩大箭头选择
	      if (Events.checkArrowMove.call(this, e)) {
	        return;
	      }
	      if (!Events.flags.onLayer) {
	        $(Mediator.getCanvas()).css({
	          cursor: "crosshair"
	        });
	      }
	      Events.flags.onLayer = false;
	    }
	    //Mediator.getCanvas().style.cursor = 'crosshair';
	
	    if (Events.flags.isEditMode) {
	      Events.editMouseMove.call(this, e);
	    } else {
	      Events.execDelay();
	      Events.drawMouseMove.call(this, e);
	    }
	
	    e.stopPropagation();
	    e.preventDefault();
	    return false;
	  },
	  canvasMouseUp: function canvasMouseUp(e) {
	    if (Events.flags.isEditMode) {
	      Events.editMouseUp.call(this, e);
	    } else {
	      Events.execDelay();
	      Events.drawMouseUp.call(this, e);
	    }
	    Events.initFlags();
	  },
	
	  drawUpWithText: function drawUpWithText(e) {
	    if (Events.flags.isEditMode) {
	      Events.editMouseUp.call(this, e);
	    } else {
	      Events.execDelay();
	      Events.drawMouseUp.call(this, e);
	      Mediator.openTextArea();
	    }
	    Events.initFlags();
	  },
	
	  drawMouseMove: function drawMouseMove(e) {
	    if (Events.flags.canvasPressed) {
	      Events.data.currentCid = Mediator.replaceOldLayer(e, this, MOUSE_STATE.MOVE);
	    }
	  },
	  drawMouseUp: function drawMouseUp(e) {
	    if (Events.flags.canvasPressed) {
	      Events.data.currentCid = Mediator.replaceOldLayer(e, this, MOUSE_STATE.RELEASE);
	      //绘画完成后，产出新数据，默认选中并做保存
	      if (Events.data.currentCid !== -1) {
	        Mediator.switchToEdit();
	        Mediator.restore();
	      }
	    }
	  },
	
	  //暂时写成这样，特殊处理箭头和选择点
	  checkArrowMove: function checkArrowMove(e) {
	    var x = e.pageX - $(this).offset().left + Mediator.reactComp.scrollLeft;
	    var y = e.pageY - $(this).offset().top + Mediator.reactComp.scrollTop;
	
	    var layer = Mediator.isOnArrow(x, y);
	    if (layer !== null) {
	      Mediator.resetEvents();
	      $(Mediator.getCanvas()).triggerLayerEvent(layer, 'mousemove');
	      //Events.layerMouseMove();
	      return true;
	    }
	  },
	
	  //暂时写成这样，特殊处理箭头和选择点
	  checkArrowClick: function checkArrowClick(e) {
	    var x = e.pageX - $(this).offset().left + Mediator.reactComp.scrollLeft;
	    var y = e.pageY - $(this).offset().top + Mediator.reactComp.scrollTop;
	
	    var layer = Mediator.isOnArrow(x, y);
	    if (layer !== null) {
	      $(Mediator.getCanvas()).triggerLayerEvent(layer, 'mousedown');
	    }
	  },
	
	  editMouseMove: function editMouseMove(e) {
	    var x = e.pageX - $(this).offset().left + Mediator.reactComp.scrollLeft;
	    var y = e.pageY - $(this).offset().top + Mediator.reactComp.scrollTop;
	
	    //鼠标按下图层后，实现拖拽
	    if (Events.flags.layerPressed) {
	      var dx = x - Events.data.lastLayerX;
	      var dy = y - Events.data.lastLayerY;
	      if (dx === 0 && dy === 0) {
	        return;
	      }
	      Events.flags.isMove = true;
	      Events.data.lastLayerX = x;
	      Events.data.lastLayerY = y;
	      Mediator.doMoveLayer(dx, dy);
	      return;
	    }
	    //鼠标按下选择点后，拖动改变边框
	    if (Events.flags.pointPressed) {
	      var dx = x - Events.data.lastPointX;
	      var dy = y - Events.data.lastPointY;
	      if (dx === 0 && dy === 0) {
	        return;
	      }
	      Events.data.lastPointX = x;
	      Events.data.lastPointY = y;
	
	      //拖拽边框将图层缩小到最小值后，不再拖动
	      var isDraged = Mediator.doDragBorder(dx, dy, x, y);
	      if (!Events.flags.isMoved && isDraged) {
	        Events.flags.isMove = true;
	      }
	      return;
	    }
	  },
	  editMouseUp: function editMouseUp(e) {
	    //按下图层或选择点移动，必然导致数据改变，做保存
	    if ((Events.flags.layerPressed || Events.flags.pointPressed) && Events.flags.isMove) {
	      Mediator.restore();
	      Events.flags.isMove = false;
	    }
	  },
	
	  layerMouseDown: function layerMouseDown(layer) {
	    if (layer.event.button !== 0) {
	      return;
	    }
	    Mediator.reset();
	    Events.data.currentCid = layer.data.cid;
	    Mediator.loadCheckPoint();
	    Events.flags.layerPressed = true;
	    Events.data.lastLayerX = layer.eventX + Mediator.reactComp.scrollLeft;
	    Events.data.lastLayerY = layer.eventY + Mediator.reactComp.scrollTop;
	    Events.flags.isEditMode = true;
	  },
	  layerMouseMove: function layerMouseMove(layer) {
	    $(Mediator.getCanvas()).css({
	      cursor: "move"
	    });
	    Events.flags.onLayer = true;
	  },
	  layerDblClick: function layerDblClick(layer) {
	    Mediator.openTextArea();
	  },
	
	  pointMouseDown: function pointMouseDown(layer) {
	    if (layer.event.button !== 0) {
	      return;
	    }
	    Events.flags.pointPressed = true;
	    Events.data.checkedPoint = layer;
	    Events.data.lastPointX = layer.eventX + Mediator.reactComp.scrollLeft;
	    Events.data.lastPointY = layer.eventY + Mediator.reactComp.scrollTop;
	    Events.flags.isEditMode = true;
	  },
	  pointMouseMove: function pointMouseMove(layer) {
	    Mediator.getCanvas().style.cursor = Mediator.getCursorStyle(layer);
	  },
	
	  registKeyEvent: function registKeyEvent(code, func, combo) {
	    var events = Events.data.keyEvents;
	    for (var i = 0; i < events.length; i++) {
	      var event = Events.data.keyEvents[i];
	      if (event.code === code && event.combo === combo) {
	        event.func = func;
	        return;
	      }
	    }
	    events.push({ code: code, func: func, combo: combo });
	    Events.setKeyEvents();
	  },
	  clearKeyEvents: function clearKeyEvents() {
	    Events.data.keyEvents = [];
	  },
	  setKeyEvents: function setKeyEvents() {
	    window.onkeydown = function (event) {
	      if (Events.flags.canvasPressed || Events.flags.layerPressed || Events.flags.pointPressed) {
	        return;
	      }
	      var e = event ? event : window.event;
	      var keyEvents = Events.data.keyEvents;
	      for (var i = 0; i < keyEvents.length; i++) {
	        var keyEvent = keyEvents[i];
	        if (keyEvent.code === e.keyCode) {
	          if (!keyEvent.combo || keyEvent.combo && e[keyEvent.combo]) {
	            keyEvent.func();
	          }
	        }
	      }
	    };
	  }
	};
	
	module.exports = Events;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Mediator = __webpack_require__(347);
	
	/**
	 * 管理图层相关操作
	 */
	var LayerManager = {
	
	  stylePicker: null,
	
	  addLayer: function addLayer(obj) {
	    $(Mediator.getCanvas()).addLayer(obj).drawLayers();
	    return obj.data.cid;
	  },
	
	  getBindLayers: function getBindLayers(layer) {
	    var results = [];
	    if (!layer) {
	      return [];
	    }
	    if (layer.data.tool !== 'TextTool') {
	      return [layer];
	    }
	    var layers = $(Mediator.getCanvas()).getLayers();
	    for (var i = 0; i < layers.length; i++) {
	      var l = layers[i];
	      if (l.data.tool !== layer.data.tool) {
	        continue;
	      }
	      if (l.data.bindId === layer.data.bindId) {
	        results[l.data.relativeIndex] = l;
	      }
	    }
	    return results;
	  },
	
	  deleteLayer: function deleteLayer(layer) {
	    var ids = [];
	    if (layer) {
	      var relativeLayers = this.getBindLayers(layer);
	      //从外层往里删除，避免里面层删除后造成的索引错位
	      for (var i = relativeLayers.length - 1; i >= 0; i--) {
	        var l = relativeLayers[i];
	        ids.push(l.data.id);
	        $(Mediator.getCanvas()).removeLayer(l.index);
	      }
	      $(Mediator.getCanvas()).drawLayers();
	    }
	    return ids;
	  },
	  hiddenLayer: function hiddenLayer(layer) {
	    var relativeLayers = this.getBindLayers(layer);
	    for (var i = 0; i < relativeLayers.length; i++) {
	      relativeLayers[i].visible = false;
	    }
	    $(Mediator.getCanvas()).drawLayers();
	  },
	  showLayer: function showLayer(layer) {
	    var relativeLayers = this.getBindLayers(layer);
	    for (var i = 0; i < relativeLayers.length; i++) {
	      relativeLayers[i].visible = true;
	    }
	    $(Mediator.getCanvas()).drawLayers();
	  },
	  setVisible: function setVisible(isVisible) {
	    $(Mediator.getCanvas()).setLayers({ visible: isVisible });
	    $(Mediator.getCanvas()).drawLayers();
	  },
	  clearAll: function clearAll() {
	    $(Mediator.getCanvas()).removeLayers();
	    $(Mediator.getCanvas()).drawLayers();
	  },
	
	  clearSelf: function clearSelf() {
	    var layers = $(Mediator.getCanvas()).getLayers();
	    var index = [];
	    for (var i = layers.length - 1; i >= 0; i--) {
	      var layer = layers[i];
	      if (layer.data.author !== Mediator.getAuthor()) {
	        continue;
	      }
	      index.push({ index: layer.index, id: layer.data.id });
	    }
	    //从大到小排序
	    index.sort(function (a, b) {
	      return b.index - a.index;
	    });
	    var result = [];
	    for (var i = 0; i < index.length; i++) {
	      result.push(index[i].id);
	      $(Mediator.getCanvas()).removeLayer(index[i].index);
	    }
	    return result;
	  },
	
	  clearPoints: function clearPoints() {
	    $(Mediator.getCanvas()).removeLayerGroup('points').drawLayers();
	  },
	
	  isClearable: function isClearable() {
	    var layers = $(Mediator.getCanvas()).getLayers();
	    for (var i = 0; i < layers.length; i++) {
	      var layer = layers[i];
	      if (layer.data.author === Mediator.getAuthor()) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  getCid: function getCid() {
	    var cid = -1;
	    var layers = $(Mediator.getCanvas()).getLayers();
	    for (var i = 0; i < layers.length; i++) {
	      var layer = layers[i];
	      if (layer.data.cid > cid) {
	        cid = layer.data.cid;
	      }
	    }
	    cid++;
	    return cid;
	  },
	
	  getLayerByCid: function getLayerByCid(layerCid) {
	    var layers = $(Mediator.getCanvas()).getLayers();
	    for (var i = 0; i < layers.length; i++) {
	      var layer = layers[i];
	      if (layer.data.cid === layerCid) {
	        return layer;
	      }
	    }
	    return null;
	  },
	
	  getCursorStyle: function getCursorStyle(layer) {
	    if (layer.name === 'pointBegin' || layer.name === 'pointEnd') {
	      return 'pointer';
	    }
	    var pointLeftTop = $(Mediator.getCanvas()).getLayer('pointLeftTop');
	    var pointRightTop = $(Mediator.getCanvas()).getLayer('pointRightTop');
	    var pointLeftBottom = $(Mediator.getCanvas()).getLayer('pointLeftBottom');
	    var dx = pointRightTop.x - pointLeftTop.x;
	    var dy = pointLeftBottom.y - pointLeftTop.y;
	    var isReverse = false;
	    if (dx * dy < 0) {
	      isReverse = true;
	    }
	    if (layer.name === 'pointLeft' || layer.name === 'pointRight') {
	      return 'ew-resize';
	    } else if (layer.name === 'pointTop' || layer.name === 'pointBottom') {
	      return 'ns-resize';
	    } else if (layer.name === 'pointLeftTop' || layer.name === 'pointRightBottom') {
	      if (isReverse) {
	        return 'nesw-resize';
	      } else {
	        return 'nwse-resize';
	      }
	    } else if (layer.name === 'pointRightTop' || layer.name === 'pointLeftBottom') {
	      if (isReverse) {
	        return 'nwse-resize';
	      } else {
	        return 'nesw-resize';
	      }
	    }
	  },
	  flipPoints: function flipPoints(checkPoint, axis) {
	    var points = $(Mediator.getCanvas()).getLayerGroup('points');
	    var pName = checkPoint.name;
	    var key;
	    if (axis === 'LR') {
	      if (pName.indexOf('Left') !== -1) {
	        key = pName.replace('Left', 'Right');
	      }
	      if (pName.indexOf('Right') !== -1) {
	        key = pName.replace('Right', 'Left');
	      }
	    }
	    if (axis === 'TB') {
	      if (pName.indexOf('Top') !== -1) {
	        key = pName.replace('Top', 'Bottom');
	      }
	      if (pName.indexOf('Bottom') !== -1) {
	        key = pName.replace('Bottom', 'Top');
	      }
	    }
	    if (key) {
	      for (var i = 0; i < points.length; i++) {
	        if (points[i].name === key) {
	          return points[i];
	        }
	      }
	    }
	  },
	
	  drawPoint: function drawPoint(objs) {
	    this.clearPoints();
	    for (var i = 0; i < objs.length; i++) {
	      $(Mediator.getCanvas()).addLayer(objs[i]);
	    }
	    $(Mediator.getCanvas()).drawLayers();
	  },
	
	  isOnArrow: function isOnArrow(x, y) {
	    var lineLayers = $(Mediator.getCanvas()).getLayers();
	    for (var i = lineLayers.length - 1; i >= 0; i--) {
	      var layer = lineLayers[i];
	      if (layer.data.tool === 'ArrowTool') {
	        if (this.isClearLine(layer, x, y)) {
	          return layer;
	        }
	      }
	      if (layer.groups[0] === 'points') {
	        if (this.isClearPoint(layer, x, y)) {
	          return layer;
	        }
	      }
	    }
	    return null;
	  },
	
	  isClearPoint: function isClearPoint(layer, x, y) {
	    if (Math.sqrt(Math.pow(layer.x - x, 2) + Math.pow(layer.y - y, 2)) < 10) {
	      return true;
	    }
	    return false;
	  },
	
	  isClearLine: function isClearLine(layer, x, y) {
	    //先求出箭头首尾两点构成的直线
	    var k = (layer.y2 - layer.y1) / (layer.x2 - layer.x1);
	    var b = layer.y1 - layer.x1 * k;
	
	    var d = Math.abs((k * x - y + b) / Math.sqrt(Math.pow(k, 2) + 1));
	    var minX = Math.min(layer.x1, layer.x2);
	    var minY = Math.min(layer.y1, layer.y2);
	    var maxX = Math.max(layer.x1, layer.x2);
	    var maxY = Math.max(layer.y1, layer.y2);
	    if (d < layer.strokeWidth + 10 && x < maxX && x > minX && minY < y && maxY > y) {
	      return true;
	    }
	    return false;
	  }
	
	};
	
	module.exports = LayerManager;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Mediator = __webpack_require__(347);
	var util = __webpack_require__(116);
	var storeHelper = __webpack_require__(49);
	var i18nHelper = __webpack_require__(46);
	var MOUSE_STATE = { 'DOWN': 'down', 'MOVE': 'move', 'RELEASE': 'release' };
	
	function compare(propertyName) {
	  return function (object1, object2) {
	    var value1 = object1.data[propertyName];
	    var value2 = object2.data[propertyName];
	    if (value2 < value1) {
	      return 1;
	    } else if (value2 > value1) {
	      return -1;
	    } else {
	      return 0;
	    }
	  };
	}
	
	/**
	 * 管理撤销、反撤销、保存、加载等数据操作
	 */
	var Data = {
	  states: [],
	  recycler: [],
	
	  isSavable: function isSavable() {
	    var localData = this.getLocalData2();
	    var layers = localData.localLayers;
	    var ids = localData.localIds;
	    if (ids.length > 0) {
	      return true;
	    }
	    for (var i = 0; i < layers.length; i++) {
	      var layer = layers[i];
	      if (layer.data.id === -1) {
	        return true;
	      }
	      if (layer.data.isChanged) {
	        return true;
	      }
	    }
	    return false;
	  },
	  isUndoable: function isUndoable() {
	    if (this.states.length > 1) {
	      return true;
	    }
	    return false;
	  },
	  isRedoable: function isRedoable() {
	    if (this.recycler.length > 0) {
	      return true;
	    }
	    return false;
	  },
	
	  initStates: function initStates() {
	    var init = function init() {
	      Data.states = [];
	      Data.recycler = [];
	      Data.restore2();
	    };
	    //从服务器加载完毕初始化数据
	    if (storeHelper.get('loadState') === 'done' || storeHelper.get('loadState') === 'failed') {
	      init();
	      storeHelper.set('loadState', 'init');
	    }
	    //所有数据保存完毕，重新初始化回退栈
	    if (this.saveDone && storeHelper.get('saveState') === 'done') {
	      init();
	      storeHelper.set('saveState', 'init');
	    }
	  },
	  rollBack2: function rollBack2() {
	    //只剩下初始化时的状态时，不进行撤销
	    if (this.states.length <= 1) {
	      return;
	    }
	    //最多支持撤销20个操作
	    if (this.states.length > 20) {
	      this.states.splice(0, 1);
	    }
	    var state = this.states.pop();
	    if (state) {
	      Mediator.reset();
	      this.recycler.push(state);
	      var drawData = this.states[this.states.length - 1].layers;
	      var ids = this.states[this.states.length - 1].ids;
	      this.setLocalData2(drawData, ids);
	    }
	  },
	  reRollBack2: function reRollBack2() {
	    Mediator.reset();
	    var state = this.recycler.pop();
	    if (state) {
	      this.states.push(state);
	      var drawData = state.layers;
	      var ids = state.ids;
	      this.setLocalData2(drawData, ids);
	    }
	  },
	  restore2: function restore2() {
	    var localLayers = [];
	    var layers = $(Mediator.getCanvas()).getLayers();
	    for (var i = 0; i < layers.length; i++) {
	      //将所有数据放在本地，用以load时合并到服务器数据
	      var layer = layers[i];
	      if (layer.groups[0] === 'points') {
	        continue;
	      }
	      var data = Mediator.getToolByLayer(layers[i]).exportData(layers[i]);
	      if (data) {
	        localLayers.push(data);
	      }
	    }
	    var localIds = this.getLocalData2().localIds;
	    //当前状态数据放到本地
	    this.setLocalData2(localLayers, null);
	    //保存一个当前快照，清空Redo栈
	    this.states.push({ layers: localLayers, ids: localIds });
	    this.recycler = [];
	  },
	  loadData2: function loadData2() {
	    var review = Mediator.getProps('review');
	    var layerObjs = [];
	    for (var i = 0; i < review.length; i++) {
	      var layerStr = review[i].data;
	      var layerObj = null;
	      try {
	        layerObj = JSON.parse(layerStr);
	      } catch (err) {
	        console.log('json解析错误!');
	      }
	      layerObj.data.id = review[i].id;
	      layerObj.data.isChanged = false;
	      layerObjs.push(layerObj);
	    }
	    var drawData = this.mergeData2(layerObjs);
	    this.reDraw2(drawData);
	  },
	  //将本地数据合并到服务器数据
	  mergeData2: function mergeData2(layerObjs) {
	    var localData = this.getLocalData2();
	    var layers = localData.localLayers;
	    var ids = localData.localIds;
	    for (var i = 0; i < layers.length; i++) {
	      var failedLayer = layers[i];
	      if (failedLayer.data.id === -1) {
	        //新增数据
	        layerObjs.push(failedLayer);
	      } else if (failedLayer.data.isChanged) {
	        //修改数据
	        for (var j = 0; j < layerObjs.length; j++) {
	          var layer = layerObjs[j];
	          if (failedLayer.data.id === layer.data.id) {
	            layerObjs[j] = failedLayer;
	            break;
	          }
	        }
	      }
	    }
	    for (var i = 0; i < ids.length; i++) {
	      //去掉已经删除的数据
	      var failedId = ids[i];
	      for (var j = 0; j < layerObjs.length; j++) {
	        var layer = layerObjs[j];
	        if (failedId === layer.data.id) {
	          layerObjs.splice(j, 1);
	          break;
	        }
	      }
	    }
	    return layerObjs;
	  },
	  reDraw2: function reDraw2(drawData) {
	    var location = Mediator.getProps('fullPageLocation');
	    Mediator.clearAll();
	    if (drawData) {
	      //按照索引排序，保证图层间顺序
	      drawData.sort(compare("index"));
	      for (var i = 0; i < drawData.length; i++) {
	        var data = drawData[i];
	        //以页面左上角为基准，偏移图层
	        Mediator.getToolByLayer(data).reloadData(data, location);
	        $(Mediator.getCanvas()).addLayer(data);
	      }
	
	      Mediator.setLayerEvents();
	      $(Mediator.getCanvas()).drawLayers();
	      Mediator.checkCurrent();
	    }
	  },
	  getLocalData2: function getLocalData2() {
	    var syncID = Mediator.getProps('syncID');
	    var syncVersion = Mediator.getProps('syncVersion');
	    var ID = Mediator.getProps('ID');
	    var local = storeHelper.get('local');
	    var result = {
	      localLayers: [],
	      localIds: []
	    };
	    if (local) {
	      var obj = JSON.parse(local);
	      for (var i = 0; i < obj.length; i++) {
	        var pageData = obj[i];
	        if (pageData.syncID === syncID && pageData.syncVersion === syncVersion && pageData.ID === ID) {
	          result = { localLayers: pageData.localLayers, localIds: pageData.localIds };
	        }
	      }
	    }
	    return result;
	  },
	  setLocalData2: function setLocalData2(layers, ids) {
	    var syncID = Mediator.getProps('syncID');
	    var syncVersion = Mediator.getProps('syncVersion');
	    var ID = Mediator.getProps('ID');
	    var local = storeHelper.get('local');
	    var obj = [];
	    if (local) {
	      obj = JSON.parse(local);
	    }
	    var data = {
	      syncID: syncID,
	      syncVersion: syncVersion,
	      ID: ID,
	      localLayers: layers ? layers : [],
	      localIds: ids ? ids : []
	    };
	    var isNew = true;
	    for (var i = 0; i < obj.length; i++) {
	      var pageData = obj[i];
	      if (pageData.syncID === syncID && pageData.syncVersion === syncVersion && pageData.ID === ID) {
	        if (layers) {
	          obj[i].localLayers = layers;
	        }
	        if (ids) {
	          obj[i].localIds = ids;
	        }
	        isNew = false;
	      }
	    }
	    if (isNew) {
	      obj.push(data);
	    }
	    storeHelper.set('local', JSON.stringify(obj));
	  },
	
	  addLayers: [],
	  updateLayers: [],
	  deleteIds: [],
	  failedLayers: [],
	  failedIds: [],
	  savingLayer: null,
	  deletingId: null,
	  saveDone: true,
	  saveTotal: 0,
	  doneNum: 0,
	  startSave2: function startSave2() {
	    this.saveDone = false;
	
	    //正在保存的图层和id，用以保存失败的时候获取
	    this.savingLayer = null;
	    this.deletingId = null;
	
	    //保存失败的图层和ids，成功的数据从本地清除
	    this.failedLayers = [];
	    this.failedIds = [];
	
	    var localData = this.getLocalData2();
	    for (var i = 0; i < localData.localLayers.length; i++) {
	      var layer = localData.localLayers[i];
	      if (layer.data.author !== Data.getAuthor()) {
	        continue;
	      }
	      if (layer.data.id === -1) {
	        this.addLayers.push(layer);
	        this.saveTotal++;
	      } else if (layer.data.isChanged) {
	        this.updateLayers.push(layer);
	        this.saveTotal++;
	      }
	    }
	    this.deleteIds = localData.localIds;
	    this.saveTotal += this.deleteIds.length;
	    Mediator.sendRequest();
	  },
	  handleSave2: function handleSave2() {
	    //记录下保存失败的数据，放在本地
	    if (storeHelper.get('saveState') === 'failed') {
	      if (this.savingLayer) {
	        this.failedLayers.push(this.savingLayer);
	        this.savingLayer = null;
	      }
	      if (this.deletingId) {
	        this.failedIds.push(this.deletingId);
	        this.deletingId = null;
	      }
	      storeHelper.set('saveState', 'done');
	    }
	    //保存一个数据，更新一次本地数据。本地数据用以修正服务器数据。
	    if (storeHelper.get('saveState') === 'done') {
	      var layers = [];
	      var ids = [];
	      for (var i = 0; i < this.addLayers.length; i++) {
	        layers.push(this.addLayers[i]);
	      }
	      for (var i = 0; i < this.updateLayers.length; i++) {
	        layers.push(this.updateLayers[i]);
	      }
	      for (var i = 0; i < this.deleteIds.length; i++) {
	        ids.push(this.deleteIds[i]);
	      }
	      for (var i = 0; i < this.failedLayers.length; i++) {
	        layers.push(this.failedLayers[i]);
	      }
	      for (var i = 0; i < this.failedIds.length; i++) {
	        ids.push(this.failedIds[i]);
	      }
	      this.setLocalData2(layers, ids);
	
	      this.doneNum++;
	      //上一条数据请求完且还有待处理数据，开始请求下一条数据（一条数据一个请求）
	      if (!this.saveDone) {
	        Mediator.sendRequest();
	      }
	    }
	  },
	  sendRequest2: function sendRequest2(add, update, remove) {
	    while (true) {
	      if (this.addLayers.length === 0) {
	        break;
	      }
	      var layer = this.addLayers.pop();
	      this.savingLayer = layer;
	      add(layer);
	      return;
	    }
	    while (true) {
	      if (this.updateLayers.length === 0) {
	        break;
	      }
	      var layer = this.updateLayers.pop();
	      this.savingLayer = layer;
	      update(layer.data.id, layer.data.author, layer);
	      return;
	    }
	    while (true) {
	      if (this.deleteIds.length === 0) {
	        break;
	      }
	      var id = this.deleteIds.pop();
	      if (id) {
	        this.deletingId = id;
	        remove(Data.getAuthor(), id);
	        return;
	      }
	    }
	
	    this.setSaveResult();
	    this.saveDone = true;
	  },
	
	  saveSuccess: true,
	  saveErrMsg: '',
	  setSaveResult: function setSaveResult() {
	    if (this.failedIds.length === 0 && this.failedLayers.length === 0) {
	      this.saveErrMsg = '';
	      this.saveSuccess = true;
	    } else {
	      this.saveErrMsg = this.failedIds.length + this.failedLayers.length + i18nHelper.get('SAVE_FAILED_MSG');
	      this.saveSuccess = false;
	    }
	  },
	
	  deleteLayer: function deleteLayer(ids) {
	    if (ids.length > 0) {
	      var newIds = this.getLocalData2().localIds;
	      for (var i = 0; i < ids.length; i++) {
	        if (ids[i] !== -1) {
	          if (newIds.indexOf(ids[i]) === -1) {
	            newIds.push(ids[i]);
	          }
	        }
	      }
	      this.setLocalData2(null, newIds);
	      Mediator.restore();
	    }
	  },
	
	  clearLocal: function clearLocal() {
	    if (this.saveSuccess) {
	      this.setLocalData2([], []);
	    }
	  },
	
	  getAuthor: function getAuthor() {
	    return storeHelper.get('sign');
	  }
	};
	
	module.exports = Data;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Mediator = __webpack_require__(347);
	var util = __webpack_require__(116);
	var storeHelper = __webpack_require__(49);
	var MOUSE_STATE = { 'DOWN': 'down', 'MOVE': 'move', 'RELEASE': 'release' };
	
	var layerEventsTemp = {
	  mousedown: 'layerMouseDown',
	  mousemove: 'layerMouseMove'
	};
	var canvasEventsTemp = {
	  onmousedown: 'canvasMouseDown',
	  onmousemove: 'canvasMouseMove',
	  onmouseup: 'canvasMouseUp'
	};
	var beginX = -1;
	var beginY = -1;
	var filledMin = 5;
	
	/**
	 * 管理各个工具的绘制数据
	 */
	var Tool = {
	
	  templetePoint: {
	    strokeWidth: 1,
	    strokeStyle: '#000',
	    fillStyle: '#fff',
	    groups: ['points'],
	    fromCenter: true,
	    type: 'ellipse',
	    width: 6,
	    height: 6
	  },
	
	  initStyle: function initStyle() {
	    var strokeStyle = { color: '#fb3838', strokeWidth: 2 };
	    var fillStyle = { backColor: '#fb3838', backColorAlpha: 0.3 };
	    var textStyle = { backColor: '#fff29f', color: '#fb3838', fontSize: 16, backColorAlpha: 1 };
	    if (!storeHelper.get('RectTool')) {
	      storeHelper.set('RectTool', JSON.stringify(strokeStyle));
	    }
	    if (!storeHelper.get('EllipseTool')) {
	      storeHelper.set('EllipseTool', JSON.stringify(strokeStyle));
	    }
	    if (!storeHelper.get('ArrowTool')) {
	      storeHelper.set('ArrowTool', JSON.stringify(strokeStyle));
	    }
	    if (!storeHelper.get('PencilTool')) {
	      storeHelper.set('PencilTool', JSON.stringify(strokeStyle));
	    }
	    if (!storeHelper.get('FilledRectTool')) {
	      storeHelper.set('FilledRectTool', JSON.stringify(fillStyle));
	    }
	    if (!storeHelper.get('FilledEllipseTool')) {
	      storeHelper.set('FilledEllipseTool', JSON.stringify(fillStyle));
	    }
	    if (!storeHelper.get('TextTool')) {
	      storeHelper.set('TextTool', JSON.stringify(textStyle));
	    }
	  },
	  setStyle: function setStyle(tool, styleKey, value) {
	    var style = JSON.parse(storeHelper.get(tool));
	    style[styleKey] = value;
	    storeHelper.set(tool, JSON.stringify(style));
	  },
	
	  getStyle: function getStyle(tool, styleKey) {
	    var style = JSON.parse(storeHelper.get(tool));
	    return style[styleKey];
	  },
	  getBackColor: function getBackColor(tool) {
	    var style = JSON.parse(storeHelper.get(tool));
	    var rgb = util.Color.toRGB(style.backColor);
	    return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + style.backColorAlpha + ')';
	  },
	
	  RectTool: {
	
	    layerEvents: layerEventsTemp,
	    canvasEvents: canvasEventsTemp,
	
	    moveLayer: 'moveShapeLayer',
	    dragBorder: 'dragShapeBorder',
	    initCheckPoint: 'initShapePoint',
	
	    templete: { type: 'rectangle', fromCenter: false },
	    data: { tool: 'RectTool' },
	
	    //响应鼠标动作，生成图层数据
	    drawingData: function drawingData(newX, newY, state) {
	      var strokeWidth = Tool.getStyle('RectTool', 'strokeWidth');
	      var obj = $.extend({}, this.templete, {
	        strokeStyle: Tool.getStyle('RectTool', 'color'),
	        strokeWidth: strokeWidth
	      });
	      var data = $.extend({}, this.data, {
	        author: storeHelper.get('sign'),
	        id: -1,
	        cid: Mediator.getCid(),
	        pageX: Mediator.getProps('fullPageLocation').left,
	        pageY: Mediator.getProps('fullPageLocation').top
	      });
	      obj.data = data;
	
	      var pxOff = strokeWidth % 2 / 2;
	      var draw = function draw(beginX, beginY, newX, newY) {
	        obj.x = Math.min(beginX, newX) + pxOff;
	        obj.y = Math.min(beginY, newY) + pxOff;
	        obj.width = Math.abs(newX - beginX);
	        obj.height = Math.abs(newY - beginY);
	      };
	      if (state === MOUSE_STATE.DOWN) {
	        beginX = newX;
	        beginY = newY;
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.MOVE) {
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.RELEASE) {
	        draw(beginX, beginY, newX, newY);
	      }
	      if (obj.width < strokeWidth / 2 || obj.height < strokeWidth / 2) {
	        return null;
	      }
	
	      return obj;
	    },
	
	    exportData: function exportData(layer) {
	      var obj = $.extend({}, this.templete, {
	        data: layer.data,
	        strokeStyle: layer.strokeStyle,
	        strokeWidth: layer.strokeWidth,
	        width: layer.width,
	        height: layer.height,
	        x: layer.x, y: layer.y
	      });
	      obj.data.index = layer.index;
	      return obj;
	    },
	
	    reloadData: function reloadData(obj, pageLocation) {
	      if (pageLocation) {
	        var dx = pageLocation.left - obj.data.pageX;
	        var dy = pageLocation.top - obj.data.pageY;
	        obj.x += dx;
	        obj.y += dy;
	        obj.data.pageX = pageLocation.left;
	        obj.data.pageY = pageLocation.top;
	      }
	    }
	  },
	
	  FilledRectTool: {
	
	    layerEvents: layerEventsTemp,
	    canvasEvents: canvasEventsTemp,
	
	    moveLayer: 'moveShapeLayer',
	    dragBorder: 'dragShapeBorder',
	    initCheckPoint: 'initShapePoint',
	
	    templete: { type: 'rectangle', fromCenter: false },
	    data: { tool: 'FilledRectTool' },
	
	    //响应鼠标动作，生成图层数据
	    drawingData: function drawingData(newX, newY, state) {
	      var obj = $.extend({}, this.templete, {
	        fillStyle: Tool.getBackColor('FilledRectTool')
	      });
	      var data = $.extend({}, this.data, {
	        author: storeHelper.get('sign'),
	        id: -1,
	        cid: Mediator.getCid(),
	        pageX: Mediator.getProps('fullPageLocation').left,
	        pageY: Mediator.getProps('fullPageLocation').top
	      });
	      obj.data = data;
	
	      var draw = function draw(beginX, beginY, newX, newY) {
	        obj.x = Math.min(beginX, newX);
	        obj.y = Math.min(beginY, newY);
	        obj.width = Math.abs(newX - beginX);
	        obj.height = Math.abs(newY - beginY);
	      };
	      if (state === MOUSE_STATE.DOWN) {
	        beginX = newX;
	        beginY = newY;
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.MOVE) {
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.RELEASE) {
	        draw(beginX, beginY, newX, newY);
	      }
	      if (obj.width < filledMin && obj.height < filledMin) {
	        return null;
	      }
	
	      return obj;
	    },
	
	    exportData: function exportData(layer) {
	      var obj = $.extend({}, this.templete, {
	        data: layer.data,
	        fillStyle: layer.fillStyle,
	        width: layer.width,
	        height: layer.height,
	        x: layer.x, y: layer.y
	      });
	      obj.data.index = layer.index;
	      return obj;
	    },
	
	    reloadData: function reloadData(obj, pageLocation) {
	      if (pageLocation) {
	        var dx = pageLocation.left - obj.data.pageX;
	        var dy = pageLocation.top - obj.data.pageY;
	        obj.x += dx;
	        obj.y += dy;
	        obj.data.pageX = pageLocation.left;
	        obj.data.pageY = pageLocation.top;
	      }
	    }
	  },
	
	  EllipseTool: {
	
	    layerEvents: layerEventsTemp,
	    canvasEvents: canvasEventsTemp,
	
	    moveLayer: 'moveShapeLayer',
	    dragBorder: 'dragShapeBorder',
	    initCheckPoint: 'initShapePoint',
	
	    templete: { type: 'ellipse', fromCenter: false },
	    data: { tool: 'EllipseTool' },
	
	    //响应鼠标动作，生成图层数据
	    drawingData: function drawingData(newX, newY, state) {
	      var strokeWidth = Tool.getStyle('EllipseTool', 'strokeWidth');
	      var obj = $.extend({}, this.templete, {
	        strokeStyle: Tool.getStyle('EllipseTool', 'color'),
	        strokeWidth: strokeWidth
	      });
	      var data = $.extend({}, this.data, {
	        author: storeHelper.get('sign'),
	        id: -1,
	        cid: Mediator.getCid(),
	        pageX: Mediator.getProps('fullPageLocation').left,
	        pageY: Mediator.getProps('fullPageLocation').top
	      });
	      obj.data = data;
	      var draw = function draw(beginX, beginY, newX, newY) {
	        obj.x = Math.min(beginX, newX);
	        obj.y = Math.min(beginY, newY);
	        obj.width = Math.abs(newX - beginX);
	        obj.height = Math.abs(newY - beginY);
	      };
	      if (state === MOUSE_STATE.DOWN) {
	        beginX = newX;
	        beginY = newY;
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.MOVE) {
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.RELEASE) {
	        draw(beginX, beginY, newX, newY);
	      }
	      if (obj.width < strokeWidth / 2 && obj.height < strokeWidth / 2) {
	        return null;
	      }
	
	      return obj;
	    },
	
	    exportData: function exportData(layer) {
	      var obj = $.extend({}, this.templete, {
	        data: layer.data,
	        strokeStyle: layer.strokeStyle,
	        strokeWidth: layer.strokeWidth,
	        width: layer.width,
	        height: layer.height,
	        x: layer.x, y: layer.y
	      });
	      obj.data.index = layer.index;
	      return obj;
	    },
	
	    reloadData: function reloadData(obj, pageLocation) {
	      if (pageLocation) {
	        var dx = pageLocation.left - obj.data.pageX;
	        var dy = pageLocation.top - obj.data.pageY;
	        obj.x += dx;
	        obj.y += dy;
	        obj.data.pageX = pageLocation.left;
	        obj.data.pageY = pageLocation.top;
	      }
	    }
	  },
	
	  FilledEllipseTool: {
	
	    layerEvents: layerEventsTemp,
	    canvasEvents: canvasEventsTemp,
	
	    moveLayer: 'moveShapeLayer',
	    dragBorder: 'dragShapeBorder',
	    initCheckPoint: 'initShapePoint',
	
	    templete: { type: 'ellipse', fromCenter: false },
	    data: { tool: 'FilledEllipseTool' },
	
	    //响应鼠标动作，生成图层数据
	    drawingData: function drawingData(newX, newY, state) {
	      var obj = $.extend({}, this.templete, {
	        fillStyle: Tool.getBackColor('FilledEllipseTool')
	      });
	      var data = $.extend({}, this.data, {
	        author: storeHelper.get('sign'),
	        id: -1,
	        cid: Mediator.getCid(),
	        pageX: Mediator.getProps('fullPageLocation').left,
	        pageY: Mediator.getProps('fullPageLocation').top
	      });
	      obj.data = data;
	      var draw = function draw(beginX, beginY, newX, newY) {
	        obj.x = Math.min(beginX, newX);
	        obj.y = Math.min(beginY, newY);
	        obj.width = Math.abs(newX - beginX);
	        obj.height = Math.abs(newY - beginY);
	      };
	      if (state === MOUSE_STATE.DOWN) {
	        beginX = newX;
	        beginY = newY;
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.MOVE) {
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.RELEASE) {
	        draw(beginX, beginY, newX, newY);
	      }
	      if (obj.width < filledMin && obj.height < filledMin) {
	        return null;
	      }
	
	      return obj;
	    },
	
	    exportData: function exportData(layer) {
	      var obj = $.extend({}, this.templete, {
	        data: layer.data,
	        fillStyle: layer.fillStyle,
	        width: layer.width,
	        height: layer.height,
	        x: layer.x, y: layer.y
	      });
	      obj.data.index = layer.index;
	      return obj;
	    },
	
	    reloadData: function reloadData(obj, pageLocation) {
	      if (pageLocation) {
	        var dx = pageLocation.left - obj.data.pageX;
	        var dy = pageLocation.top - obj.data.pageY;
	        obj.x += dx;
	        obj.y += dy;
	        obj.data.pageX = pageLocation.left;
	        obj.data.pageY = pageLocation.top;
	      }
	    }
	  },
	
	  ArrowTool: {
	
	    layerEvents: layerEventsTemp,
	    canvasEvents: canvasEventsTemp,
	
	    moveLayer: 'moveLineLayer',
	    dragBorder: 'dragArrowBorder',
	    initCheckPoint: 'initArrowPoint',
	
	    templete: {
	      type: 'line',
	      fromCenter: false,
	      rounded: true,
	      endArrow: true
	    },
	    data: { tool: 'ArrowTool' },
	
	    //响应鼠标动作，生成图层数据
	    drawingData: function drawingData(newX, newY, state) {
	      var strokeWidth = Tool.getStyle('ArrowTool', 'strokeWidth');
	      var obj = $.extend({}, this.templete, {
	        strokeStyle: Tool.getStyle('ArrowTool', 'color'),
	        strokeWidth: strokeWidth
	      });
	      var data = $.extend({}, this.data, {
	        author: storeHelper.get('sign'),
	        id: -1,
	        cid: Mediator.getCid(),
	        pageX: Mediator.getProps('fullPageLocation').left,
	        pageY: Mediator.getProps('fullPageLocation').top
	      });
	      obj.data = data;
	      var draw = function draw(beginX, beginY, newX, newY) {
	        obj.x1 = beginX;
	        obj.y1 = beginY;
	        obj.x2 = newX;
	        obj.y2 = newY;
	      };
	      if (state === MOUSE_STATE.DOWN) {
	        beginX = newX;
	        beginY = newY;
	        obj.visible = false;
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.MOVE) {
	        obj.visible = true;
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.RELEASE) {
	        draw(beginX, beginY, newX, newY);
	      }
	      Mediator.setArrowSize(obj);
	      var d = Math.sqrt(Math.pow(newX - beginX, 2) + Math.pow(newY - beginY, 2));
	      if (d < 10) {
	        return null;
	      }
	
	      return obj;
	    },
	
	    exportData: function exportData(layer) {
	      var obj = $.extend({}, this.templete, {
	        data: layer.data,
	        strokeStyle: layer.strokeStyle,
	        strokeWidth: layer.strokeWidth,
	        arrowRadius: layer.arrowRadius,
	        arrowAngle: layer.arrowAngle,
	        x1: layer.x1, y1: layer.y1,
	        x2: layer.x2, y2: layer.y2
	      });
	      obj.data.index = layer.index;
	      return obj;
	    },
	
	    reloadData: function reloadData(obj, pageLocation) {
	      if (pageLocation) {
	        var dx = pageLocation.left - obj.data.pageX;
	        var dy = pageLocation.top - obj.data.pageY;
	        obj.x1 += dx;
	        obj.y1 += dy;
	        obj.x2 += dx;
	        obj.y2 += dy;
	        obj.data.pageX = pageLocation.left;
	        obj.data.pageY = pageLocation.top;
	      }
	    }
	  },
	
	  PencilTool: {
	    path: [],
	
	    layerEvents: layerEventsTemp,
	    canvasEvents: canvasEventsTemp,
	
	    moveLayer: 'moveLineLayer',
	    dragBorder: 'dragPencilBorder',
	    initCheckPoint: 'initPencilPoint',
	
	    templete: {
	      type: 'line',
	      fromCenter: false,
	      rounded: true
	    },
	
	    data: { tool: 'PencilTool' },
	
	    //响应鼠标动作，生成图层数据
	    drawingData: function drawingData(newX, newY, state) {
	      var obj = $.extend({}, this.templete, {
	        strokeStyle: Tool.getStyle('PencilTool', 'color'),
	        strokeWidth: Tool.getStyle('PencilTool', 'strokeWidth')
	      });
	      var data = $.extend({}, this.data, {
	        author: storeHelper.get('sign'),
	        id: -1,
	        cid: Mediator.getCid(),
	        rowWidth: Tool.getStyle('PencilTool', 'strokeWidth'),
	        pageX: Mediator.getProps('fullPageLocation').left,
	        pageY: Mediator.getProps('fullPageLocation').top
	      });
	      obj.data = data;
	
	      if (state === MOUSE_STATE.DOWN) {
	        this.path = [];
	      }
	      this.path.push([newX, newY]);
	      for (var i = 0; i < this.path.length; i++) {
	        obj['x' + (i + 1)] = this.path[i][0];
	        obj['y' + (i + 1)] = this.path[i][1];
	      }
	      if (state === MOUSE_STATE.MOVE) {
	        obj.visible = true;
	      }
	      var len = this.path.length;
	      if (state === MOUSE_STATE.RELEASE) {
	        this.path = [];
	      }
	      if (len <= 5) {
	        return null;
	      }
	      return obj;
	    },
	
	    exportData: function exportData(layer) {
	      var obj = $.extend({}, this.templete, {
	        strokeStyle: layer.strokeStyle,
	        strokeWidth: layer.strokeWidth,
	        data: layer.data
	      });
	
	      var j = 1;
	      while (true) {
	        var x = layer['x' + j];
	        var y = layer['y' + j];
	        if (x === undefined || y === undefined) {
	          break;
	        }
	        obj['x' + j] = x;
	        obj['y' + j] = y;
	        j++;
	      }
	      obj.data.index = layer.index;
	      return obj;
	    },
	
	    reloadData: function reloadData(obj, pageLocation) {
	      if (pageLocation) {
	        var dx = pageLocation.left - obj.data.pageX;
	        var dy = pageLocation.top - obj.data.pageY;
	        var j = 1;
	        while (true) {
	          var x = obj['x' + j];
	          var y = obj['y' + j];
	          if (x === undefined || y === undefined) {
	            break;
	          }
	          obj['x' + j] += dx;
	          obj['y' + j] += dy;
	          j++;
	        }
	        obj.data.pageX = pageLocation.left;
	        obj.data.pageY = pageLocation.top;
	      }
	    }
	  },
	
	  TextTool: {
	    bindId: 1,
	
	    layerEvents: $.extend({}, layerEventsTemp, {
	      dblclick: 'layerDblClick'
	    }),
	    canvasEvents: {
	      onmousedown: 'canvasMouseDown', onmousemove: 'canvasMouseMove',
	      onmouseup: 'drawUpWithText'
	    },
	
	    moveLayer: 'moveTextLayer',
	    dragBorder: 'dragTextBorder',
	    initCheckPoint: 'initTextPoint',
	
	    wrapTemplete: {
	      type: 'rectangle',
	      fromCenter: false
	    },
	
	    textTemplete: {
	      type: 'text',
	      fromCenter: false,
	      align: 'left',
	      fontFamily: '微软雅黑'
	    },
	    wrapData: {
	      tool: 'TextTool',
	      relativeIndex: 0
	    },
	    textData: {
	      tool: 'TextTool',
	      relativeIndex: 1
	    },
	
	    drawingData: function drawingData(newX, newY, state) {
	      var obj = $.extend({}, this.wrapTemplete, {});
	      var data = $.extend({}, this.wrapData, {
	        author: storeHelper.get('sign'),
	        id: -1,
	        cid: Mediator.getCid(),
	        bindId: this.bindId,
	        pageX: Mediator.getProps('fullPageLocation').left,
	        pageY: Mediator.getProps('fullPageLocation').top
	      });
	      obj.data = data;
	
	      var draw = function draw(beginX, beginY, newX, newY) {
	        obj.x = Math.min(beginX, newX);
	        obj.y = Math.min(beginY, newY);
	        obj.width = Math.abs(newX - beginX);
	        obj.height = Math.abs(newY - beginY);
	      };
	      if (state === MOUSE_STATE.DOWN) {
	        obj.strokeDash = [5];
	        obj.strokeDashOffset = 0;
	        obj.strokeStyle = '#606060';
	        beginX = newX;
	        beginY = newY;
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.MOVE) {
	        obj.strokeDash = [5];
	        obj.strokeDashOffset = 0;
	        obj.strokeStyle = '#606060';
	        draw(beginX, beginY, newX, newY);
	      }
	      if (state === MOUSE_STATE.RELEASE) {
	        obj.strokeDash = undefined;
	        obj.strokeDashOffset = undefined;
	        obj.strokeStyle = undefined;
	        obj.fillStyle = Tool.getBackColor('TextTool');
	        draw(beginX, beginY, newX, newY);
	        this.bindId++;
	      }
	      if (obj.width < filledMin && obj.height < filledMin) {
	        return null;
	      }
	
	      return obj;
	    },
	
	    appendText: function appendText(backLayer, value) {
	      var obj = $.extend({}, this.textTemplete, {
	        fillStyle: Tool.getStyle('TextTool', 'color'),
	        fontSize: Tool.getStyle('TextTool', 'fontSize'),
	        x: Math.min(backLayer.x, backLayer.x + backLayer.width) + 10,
	        y: Math.min(backLayer.y, backLayer.y + backLayer.height) + 10
	      });
	      var data = $.extend({}, this.textData, {
	        author: storeHelper.get('sign'),
	        id: -1,
	        cid: Mediator.getCid(),
	        bindId: backLayer.data.bindId,
	        text: value,
	        pageX: Mediator.getProps('fullPageLocation').left,
	        pageY: Mediator.getProps('fullPageLocation').top
	      });
	      obj.data = data;
	
	      obj.text = Mediator.figureTextWidth(value, obj, backLayer);
	      return obj;
	    },
	
	    exportData: function exportData(layer) {
	      var obj;
	      if (layer.data.relativeIndex === 0) {
	        //背景矩形
	        obj = $.extend({}, this.wrapTemplete, {
	          data: layer.data,
	          fillStyle: layer.fillStyle,
	          width: layer.width,
	          height: layer.height,
	          x: layer.x, y: layer.y
	        });
	      } else {
	        obj = $.extend({}, this.textTemplete, {
	          data: layer.data,
	          fillStyle: layer.fillStyle,
	          fontSize: layer.fontSize,
	          fontFamily: layer.fontFamily,
	          text: layer.text,
	          x: layer.x, y: layer.y
	        });
	      }
	      obj.data.index = layer.index;
	      return obj;
	    },
	
	    reloadData: function reloadData(obj, pageLocation) {
	      //刚加载时，要考虑bindId已经被使用
	      if (obj.data.bindId >= this.bindId) {
	        this.bindId = obj.data.bindId + 1;
	      }
	      if (pageLocation) {
	        var dx = pageLocation.left - obj.data.pageX;
	        var dy = pageLocation.top - obj.data.pageY;
	        obj.x += dx;
	        obj.y += dy;
	        obj.data.pageX = pageLocation.left;
	        obj.data.pageY = pageLocation.top;
	      }
	    }
	  }
	};
	
	module.exports = Tool;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Mediator = __webpack_require__(347);
	
	/**
	 * 管理输入框TextArea
	 */
	var InputText = {
	  isInput: false,
	
	  textNode: null,
	  textPadding: 10,
	  font: null,
	  box: null,
	
	  backLayerCid: -1,
	  textLayerCid: -1,
	
	  figureTextWidth: function figureTextWidth(text, obj, boxLayer) {
	    var maxWidth = Math.abs(boxLayer.width) - 20;
	    var maxHeight = Math.abs(boxLayer.height) - 20;
	    var context = Mediator.getCanvas().getContext('2d');
	    context.font = parseInt(obj.fontSize, 10) + 'px ' + obj.fontFamily;
	    var len = 0;
	    var tempStr = '';
	    var strs = [];
	    var result = [];
	    for (var i = 0; i < text.length; i++) {
	      if (text[i] === '\n') {
	        strs.push(tempStr);
	        tempStr = '';
	        len = 0;
	        continue;
	      }
	      var l = context.measureText(text[i]).width;
	      if (len + l > maxWidth) {
	        strs.push(tempStr);
	        if (l <= maxWidth) {
	          tempStr = text[i];
	        }
	        len = l;
	        continue;
	      }
	
	      tempStr += text[i];
	      len = len + l;
	    }
	    strs.push(tempStr);
	    var h = 0;
	    for (var i = 0; i < strs.length; i++) {
	      if (h + parseInt(obj.fontSize, 10) > maxHeight) {
	        break;
	      }
	      result.push(strs[i]);
	      h += parseInt(obj.fontSize, 10);
	    }
	    return result.join('\n');
	  },
	
	  isChange: false,
	  saveTextData: function saveTextData() {
	    if (this.isInput) {
	      this.isInput = false;
	
	      var textValue = $(this.textNode).val();
	      var backLayer = Mediator.getLayerByCid(this.backLayerCid);
	      var textLayer = Mediator.getLayerByCid(this.textLayerCid);
	      if (backLayer) {
	        if (!textLayer) {
	          Mediator.appendTextLayer(textValue);
	          this.isChange = true; //添加了新图层，做保存。（有没有文字都应该保存）
	        }
	        Mediator.showLayer(backLayer);
	        Mediator.setCurrentCid(backLayer.data.cid);
	        Mediator.switchToEdit();
	      }
	
	      if (this.isChange) {
	        this.isChange = false;
	        Mediator.restore();
	      }
	    }
	    $(this.textNode).val('');
	    $(this.textNode).css('display', 'none');
	  },
	
	  openTextArea: function openTextArea() {
	    InputText.isInput = true;
	    this.isChange = false;
	    var relativeLayers = Mediator.getBindLayers(Mediator.getCurrentLayer());
	    this.backLayerCid = -1;
	    this.textLayerCid = -1;
	    var backLayer = relativeLayers[0];
	    var textLayer = relativeLayers[1];
	
	    if (backLayer) {
	      this.backLayerCid = backLayer.data.cid;
	      Mediator.hiddenLayer(backLayer);
	      this.box = { x: backLayer.x, y: backLayer.y, height: backLayer.height, width: backLayer.width };
	      this.font = {
	        fontSize: Mediator.getStyle('TextTool', 'fontSize'),
	        fontFamily: '微软雅黑',
	        color: Mediator.getStyle('TextTool', 'color'),
	        text: ''
	      };
	      if (textLayer) {
	        this.textLayerCid = textLayer.data.cid;
	        this.font.fontSize = textLayer.fontSize;
	        this.font.fontFamily = textLayer.fontFamily;
	        this.font.color = textLayer.fillStyle;
	        this.font.text = textLayer.data.text;
	      }
	      InputText.editText();
	      //暂定策略，输入状态下不加载选择点，看起来很怪异
	      Mediator.clearPoints();
	    }
	  },
	
	  editText: function editText() {
	    //首先更新宽度，宽度会影响到高度的计算
	    InputText.updateLayerWidth();
	    var height = InputText.figureTextHeight();
	    InputText.updateLayerHeight(height);
	    //更新文本应放在更新背景之后，显示多少文字由宽度、高度控制
	    InputText.updateLayerText();
	    InputText.adjustTextArea();
	  },
	
	  figureTextHeight: function figureTextHeight() {
	    var text = this.font.text;
	    var fontSize = parseInt(this.font.fontSize, 10);
	    var fontFamily = this.font.fontFamily;
	    var box = this.box;
	    if (!text || text === '') {
	      return 0;
	    }
	    var maxWidth = box.width - this.textPadding * 2;
	    var context = Mediator.getCanvas().getContext('2d');
	    context.font = fontSize + 'px ' + fontFamily;
	    var len = 0;
	    var tempStr;
	    var strs = [];
	    for (var i = 0; i < text.length; i++) {
	      if (text[i] === '\n') {
	        strs.push(tempStr);
	        tempStr = '';
	        len = 0;
	        continue;
	      }
	      var l = context.measureText(text[i]).width;
	      if (len + l > maxWidth) {
	        if (tempStr !== undefined) {
	          strs.push(tempStr);
	        }
	        tempStr = text[i];
	        len = l;
	        continue;
	      }
	
	      if (tempStr === undefined) {
	        tempStr = '';
	      }
	      tempStr += text[i];
	      len = len + l;
	    }
	    strs.push(tempStr);
	
	    return strs.length * fontSize;
	  },
	
	  updateLayerText: function updateLayerText() {
	    var textLayer = Mediator.getLayerByCid(this.textLayerCid);
	    var backLayer = Mediator.getLayerByCid(this.backLayerCid);
	    if (textLayer) {
	      if (textLayer.data.text !== this.font.text) {
	        //文本改变，应该保存一次状态
	        this.isChange = true;
	        textLayer.data.isChanged = true;
	        backLayer.data.isChanged = true;
	      }
	      //背景宽高改变后，文字的坐标响应改变
	      textLayer.x = Math.min(this.box.x, this.box.x + this.box.width) + this.textPadding;
	      textLayer.y = Math.min(this.box.y, this.box.y + this.box.height) + this.textPadding;
	      textLayer.data.text = this.font.text;
	      //此处计算显示多少文字，计算时需要依赖背景高度和宽度
	      textLayer.text = InputText.figureTextWidth(this.font.text, this.font, this.box);
	    }
	  },
	
	  updateLayerWidth: function updateLayerWidth() {
	    var backLayer = Mediator.getLayerByCid(this.backLayerCid);
	    if (Math.abs(backLayer.width) <= this.textPadding * 2 + parseInt(this.font.fontSize)) {
	
	      backLayer.x = Math.min(backLayer.x, backLayer.x + backLayer.width);
	      backLayer.width = this.textPadding * 2 + parseInt(this.font.fontSize);
	      //更新背景时，同步更新文字工具的大小
	      this.box.x = backLayer.x;
	      this.box.width = backLayer.width;
	      //背景大小改变，应该保存状态
	      this.isChange = true;
	    }
	    $(Mediator.getCanvas()).drawLayers();
	  },
	
	  updateLayerHeight: function updateLayerHeight(height) {
	    var backLayer = Mediator.getLayerByCid(this.backLayerCid);
	
	    if (height > Math.abs(backLayer.height) - this.textPadding * 2) {
	
	      backLayer.y = Math.min(backLayer.y, backLayer.y + backLayer.height);
	      backLayer.height = height + this.textPadding * 2;
	      //更新背景时，同步更新文字工具的大小
	      this.box.y = backLayer.y;
	      this.box.height = backLayer.height;
	      //背景大小改变，应该保存状态
	      this.isChange = true;
	    }
	  },
	
	  //根据背景图层数据矫正textArea(频繁更新)
	  adjustTextArea: function adjustTextArea() {
	    var backLayer = Mediator.getLayerByCid(this.backLayerCid);
	    var textAreaStyle = {
	      display: 'block',
	      left: Math.min(backLayer.x, backLayer.x + backLayer.width),
	      top: Math.min(backLayer.y, backLayer.y + backLayer.height),
	      width: Math.abs(backLayer.width) - this.textPadding * 2,
	      height: Math.abs(backLayer.height) - this.textPadding * 2,
	      background: backLayer.fillStyle,
	      fontSize: this.font.fontSize,
	      color: this.font.color
	    };
	    this.textNode = ReactDOM.findDOMNode(Mediator.getRef('text'));
	    $(this.textNode).css(textAreaStyle);
	    $(this.textNode).focus();
	    $(this.textNode).val(this.font.text);
	  },
	
	  adapteText: function adapteText(text, backLayer) {
	    if (text && text !== '') {
	      this.font.text = text;
	      InputText.editText();
	    }
	  }
	};
	
	module.exports = InputText;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var i18nHelper = __webpack_require__(46);
	
	var ErrorMessage = React.createClass({
	  displayName: 'ErrorMessage',
	
	  propTypes: {
	    error: React.PropTypes.string,
	    onClearError: React.PropTypes.func
	  },
	  render: function render() {
	    if (this.props.error) {
	      return React.createElement(
	        'div',
	        { className: 'error-message' },
	        React.createElement(
	          'div',
	          { className: 'error-message-dialog' },
	          React.createElement('img', { onClick: this.props.onClearError, className: 'close', src: assetsHelper.getAsset('close2.png'), alt: 'close' }),
	          React.createElement(
	            'div',
	            { className: 'content' },
	            this.props.error
	          ),
	          React.createElement(
	            'button',
	            { onClick: this.props.onClearError },
	            i18nHelper.get('BUTTON_SURE')
	          )
	        )
	      );
	    }
	    return React.createElement('div', { className: 'error-message error-message-nothing' });
	  }
	});
	
	module.exports = ErrorMessage;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	* 性能监控
	* */
	
	'use strict';
	
	var React = __webpack_require__(11);
	var timeLogHelper = __webpack_require__(134);
	
	var RenderTimePanel = React.createClass({
	  displayName: 'RenderTimePanel',
	
	  getInitialState: function getInitialState() {
	    return {
	      selected: 0,
	      componentRenderLogs: [],
	      pageRenderLogs: [],
	      pageReadLogs: []
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var self = this;
	    timeLogHelper.addCallback(function (componentRenderLogs, pageRenderLogs, pageReadLogs) {
	      self.setState({
	        componentRenderLogs: componentRenderLogs,
	        pageRenderLogs: pageRenderLogs,
	        pageReadLogs: pageReadLogs
	      });
	    });
	  },
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'logs', draggable: 'true' },
	      React.createElement(
	        'h3',
	        null,
	        '\u6027\u80FD\u76D1\u63A7'
	      ),
	      React.createElement(
	        'ul',
	        { className: 'segment' },
	        React.createElement(
	          'li',
	          { onClick: this.onSelect.bind(this, 0), className: this.state.selected === 0 ? 'current' : '' },
	          '\u9875\u9762\u8BFB\u53D6'
	        ),
	        React.createElement(
	          'li',
	          { onClick: this.onSelect.bind(this, 1), className: this.state.selected === 1 ? 'current' : '' },
	          '\u9875\u9762\u6E32\u67D3'
	        ),
	        React.createElement(
	          'li',
	          { onClick: this.onSelect.bind(this, 2), className: this.state.selected === 2 ? 'current' : '' },
	          '\u7EC4\u4EF6\u6E32\u67D3'
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'scroll-area' },
	        React.createElement(
	          'div',
	          {
	            style: {
	              display: this.state.selected === 0 ? 'block' : 'none'
	            }
	          },
	          React.createElement(
	            'table',
	            null,
	            React.createElement(
	              'thead',
	              null,
	              React.createElement(
	                'tr',
	                null,
	                React.createElement(
	                  'td',
	                  null,
	                  '\u540D\u79F0'
	                ),
	                React.createElement(
	                  'td',
	                  null,
	                  '\u8017\u65F6'
	                )
	              )
	            ),
	            React.createElement(
	              'tbody',
	              null,
	              this.state.pageReadLogs.map(function (item) {
	                return React.createElement(
	                  'tr',
	                  { key: item[0] },
	                  React.createElement(
	                    'td',
	                    null,
	                    item[3]
	                  ),
	                  React.createElement(
	                    'td',
	                    null,
	                    item[2],
	                    'ms'
	                  )
	                );
	              })
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          {
	            style: {
	              display: this.state.selected === 1 ? 'block' : 'none'
	            }
	          },
	          React.createElement(
	            'table',
	            null,
	            React.createElement(
	              'thead',
	              null,
	              React.createElement(
	                'tr',
	                null,
	                React.createElement(
	                  'td',
	                  null,
	                  '\u540D\u79F0'
	                ),
	                React.createElement(
	                  'td',
	                  null,
	                  '\u6B21\u6570'
	                ),
	                React.createElement(
	                  'td',
	                  null,
	                  '\u5E73\u5747\u8017\u65F6'
	                )
	              )
	            ),
	            React.createElement(
	              'tbody',
	              null,
	              this.state.pageRenderLogs.map(function (item) {
	                return React.createElement(
	                  'tr',
	                  { key: item[0] },
	                  React.createElement(
	                    'td',
	                    { title: item[0] },
	                    item[3]
	                  ),
	                  React.createElement(
	                    'td',
	                    null,
	                    item[1]
	                  ),
	                  React.createElement(
	                    'td',
	                    null,
	                    item[2],
	                    'ms'
	                  )
	                );
	              })
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          {
	            style: {
	              display: this.state.selected === 2 ? 'block' : 'none'
	            }
	          },
	          React.createElement(
	            'table',
	            null,
	            React.createElement(
	              'thead',
	              null,
	              React.createElement(
	                'tr',
	                null,
	                React.createElement(
	                  'td',
	                  null,
	                  '\u7EC4\u4EF6'
	                ),
	                React.createElement(
	                  'td',
	                  null,
	                  '\u6B21\u6570'
	                ),
	                React.createElement(
	                  'td',
	                  null,
	                  '\u5E73\u5747\u8017\u65F6'
	                )
	              )
	            ),
	            React.createElement(
	              'tbody',
	              null,
	              this.state.componentRenderLogs.map(function (item) {
	                return React.createElement(
	                  'tr',
	                  { key: item[0] },
	                  React.createElement(
	                    'td',
	                    null,
	                    item[0]
	                  ),
	                  React.createElement(
	                    'td',
	                    null,
	                    item[1]
	                  ),
	                  React.createElement(
	                    'td',
	                    null,
	                    item[2],
	                    'ms'
	                  )
	                );
	              })
	            )
	          )
	        )
	      ),
	      React.createElement(
	        'span',
	        { className: 'reset', onClick: this.onReset },
	        '\u91CD\u7F6E'
	      )
	    );
	  },
	  onSelect: function onSelect(idx) {
	    this.setState({
	      selected: idx
	    });
	  },
	  onReset: function onReset() {
	    timeLogHelper.reset();
	  }
	});
	
	module.exports = RenderTimePanel;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * 右侧 测试项目板块
	 * */
	
	'use strict';
	
	var React = __webpack_require__(11);
	
	var TestProjects = React.createClass({
	  displayName: 'TestProjects',
	
	  propTypes: {
	    openApp: React.PropTypes.func.isRequired
	  },
	  render: function render() {
	    var projects = ['data/丫美券demo.mp'];
	
	    return React.createElement(
	      'div',
	      { className: 'projects-list' },
	      React.createElement(
	        'h4',
	        null,
	        '\u6D4B\u8BD5\u9879\u76EE'
	      ),
	      React.createElement(
	        'ul',
	        null,
	        projects.map(function (project) {
	          return React.createElement(
	            'li',
	            { key: project, onClick: this.openApp.bind(this, project) },
	            project.replace('data/', '')
	          );
	        }, this)
	      )
	    );
	  },
	  openApp: function openApp(app) {
	    this.props.openApp(app);
	  }
	});
	
	module.exports = TestProjects;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * 拖拽控制条
	 * */
	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var assetsHelper = __webpack_require__(65);
	var i18nHelper = __webpack_require__(46);
	var runtimeHelper = __webpack_require__(47);
	
	var NavigationBar = React.createClass({
	  displayName: 'NavigationBar',
	
	  propTypes: {
	    domSize: React.PropTypes.object.isRequired,
	    onOpenNext: React.PropTypes.func.isRequired,
	    onOpenPrev: React.PropTypes.func.isRequired,
	    onOpenHome: React.PropTypes.func.isRequired,
	    onPlayback: React.PropTypes.func.isRequired,
	    controlPanel: React.PropTypes.bool.isRequired,
	    onTogglePanelVisibility: React.PropTypes.func.isRequired,
	    onToggleRemarkVisibility: React.PropTypes.func.isRequired
	  },
	  getInitialState: function getInitialState() {
	    return {
	      top: 50,
	      right: 350, // FIXME: 恢复该值
	      moved: false,
	      expand: true
	    };
	  },
	  render: function render() {
	    var style = {
	      top: this.state.top,
	      right: this.state.right
	    };
	    var panelStyle = {};
	    if (!this.state.expand) {
	      panelStyle.borderRight = 'none';
	    } else {
	      panelStyle.borderRight = '1px solid #666';
	    }
	    var paintIcon, paintHint;
	    if (this.props.isShowPaint) {
	      paintIcon = 'hidden_paint.png';
	      paintHint = 'HIDDEN_MARK';
	    } else {
	      paintIcon = 'view_paint.png';
	      paintHint = 'VIEW_MARK';
	    }
	    var expandIcon = this.state.expand ? assetsHelper.getAsset('shrink.png') : assetsHelper.getAsset('blowup.png');
	    return React.createElement(
	      'div',
	      { className: 'navigation-bar', style: style, onMouseDown: this.onTitleClick },
	      React.createElement(
	        'div',
	        { className: 'navigation-bar-title', onDoubleClick: this.onToggleExpand },
	        React.createElement('img', { onClick: this.onToggleExpand, width: '11', height: '11',
	          src: expandIcon })
	      ),
	      React.createElement(
	        'div',
	        { className: 'navigation-actions' },
	        this.props.controlPanel && React.createElement(
	          'div',
	          { className: 'panel panel-left', style: panelStyle },
	          React.createElement(
	            'span',
	            { className: 'action', onClick: this.props.onTogglePanelVisibility },
	            React.createElement('img', { src: assetsHelper.getAsset('menu.png'), alt: '' }),
	            React.createElement(
	              'span',
	              { className: 'tooltip' },
	              i18nHelper.get('SETTINGS')
	            )
	          )
	        ),
	        this.state.expand && React.createElement(
	          'div',
	          { className: 'navs' },
	          React.createElement(
	            'span',
	            { className: 'action', onClick: this.props.onOpenHome },
	            React.createElement('img', { src: assetsHelper.getAsset('home.png') }),
	            React.createElement(
	              'span',
	              { className: 'tooltip' },
	              i18nHelper.get('HOME')
	            )
	          ),
	          React.createElement(
	            'span',
	            { className: 'action', onClick: this.props.onOpenPrev },
	            React.createElement('img', { src: assetsHelper.getAsset('prev.png') }),
	            React.createElement(
	              'span',
	              { className: 'tooltip' },
	              i18nHelper.get('PREV')
	            )
	          ),
	          React.createElement(
	            'span',
	            { className: 'action', onClick: this.props.onOpenNext },
	            React.createElement('img', { src: assetsHelper.getAsset('next.png') }),
	            React.createElement(
	              'span',
	              { className: 'tooltip' },
	              i18nHelper.get('NEXT')
	            )
	          ),
	          React.createElement(
	            'span',
	            { className: 'action', onClick: this.props.onPlayback },
	            React.createElement('img', { src: assetsHelper.getAsset('playback.png') }),
	            React.createElement(
	              'span',
	              { className: 'tooltip' },
	              i18nHelper.get('PLAYBACK')
	            )
	          )
	        ),
	        this.state.expand && runtimeHelper.canReview() && React.createElement(
	          'div',
	          { className: 'panel panel-right' },
	          React.createElement(
	            'span',
	            { className: 'action', onClick: this.props.onToggleShowPaint },
	            React.createElement('img', { src: assetsHelper.getAsset(paintIcon), alt: '' }),
	            React.createElement(
	              'span',
	              { className: 'tooltip' },
	              i18nHelper.get(paintHint)
	            )
	          ),
	          React.createElement(
	            'span',
	            { className: 'action', onClick: this.props.onToggleCommentMode },
	            React.createElement('img', { src: assetsHelper.getAsset('comment.png'), alt: '' }),
	            React.createElement(
	              'span',
	              { className: 'tooltip' },
	              i18nHelper.get('MARK')
	            )
	          )
	        ),
	        this.state.expand && React.createElement(
	          'div',
	          { className: 'panel panel-right' },
	          React.createElement(
	            'span',
	            { className: 'action', onClick: this.props.onToggleRemarkVisibility },
	            React.createElement('img', { src: assetsHelper.getAsset('remark.png'), alt: '' }),
	            React.createElement(
	              'span',
	              { className: 'tooltip' },
	              i18nHelper.get('RIGHT_PANEL')
	            )
	          )
	        )
	      )
	    );
	  },
	  onToggleExpand: function onToggleExpand() {
	    this.setState({
	      expand: !this.state.expand
	    });
	  },
	  onTitleClick: function onTitleClick(e) {
	    var dom = ReactDOM.findDOMNode(this);
	    this.startPosition = {
	      top: this.state.top,
	      right: this.state.right
	    };
	    this.dom = dom;
	    this.width = dom.offsetWidth;
	    this.height = dom.offsetHeight;
	    document.addEventListener('mousemove', this.onMove);
	    document.addEventListener('mouseup', this.onEnd);
	    e.stopPropagation();
	    e.preventDefault();
	    this.startInfo = {
	      x: e.pageX,
	      y: e.pageY
	    };
	  },
	  onMove: function onMove(e) {
	    var deltaX = e.pageX - this.startInfo.x;
	    var deltaY = e.pageY - this.startInfo.y;
	    var dom = this.dom;
	    var top = this.startPosition.top + deltaY;
	    var right = this.startPosition.right - deltaX;
	    top = Math.min(Math.max(0, top), this.props.domSize.height - this.height);
	    right = Math.min(Math.max(0, right), this.props.domSize.width - this.width);
	    dom.style.top = top + 'px';
	    dom.style.right = right + 'px';
	
	    this.deltaX = deltaX;
	    this.deltaY = deltaY;
	    e.stopPropagation();
	    e.preventDefault();
	  },
	  onEnd: function onEnd(e) {
	    this.startInfo = null;
	    var self = this;
	    this.setState({
	      top: parseInt(this.dom.style.top, 10),
	      right: parseInt(this.dom.style.right, 10)
	    }, function () {
	      document.removeEventListener('mousemove', self.onMove);
	      document.removeEventListener('mouseup', self.onEnd);
	    });
	    e.stopPropagation();
	    e.preventDefault();
	  }
	});
	
	module.exports = NavigationBar;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var MultilineText = __webpack_require__(359);
	var PageComments = __webpack_require__(360);
	var runtimeHelper = __webpack_require__(47);
	var i18nHelper = __webpack_require__(46);
	var storeHelper = __webpack_require__(49);
	
	var PageRemark = React.createClass({
	  displayName: 'PageRemark',
	
	  propTypes: {
	    name: React.PropTypes.string.isRequired,
	    page: React.PropTypes.object.isRequired,
	    remark: React.PropTypes.string,
	    show: React.PropTypes.bool.isRequired,
	    onClose: React.PropTypes.func.isRequired,
	    isSign: React.PropTypes.bool.isRequired,
	    author: React.PropTypes.string.isRequired,
	    sign: React.PropTypes.func.isRequired,
	    syncID: React.PropTypes.string.isRequired,
	    syncVersion: React.PropTypes.string.isRequired,
	    pageName: React.PropTypes.string.isRequired,
	    comments: React.PropTypes.array,
	    onAddComment: React.PropTypes.func.isRequired,
	    onLoadComment: React.PropTypes.func.isRequired,
	    onError: React.PropTypes.func.isRequired,
	    onClearError: React.PropTypes.func.isRequired
	  },
	  getInitialState: function getInitialState() {
	    var current = 'remark';
	    if (runtimeHelper.canReview()) {
	      current = storeHelper.get('remarkTab') || 'comment';
	    }
	    return {
	      show: this.props.show,
	      author: null,
	      current: current
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState({
	      show: nextProps.show,
	      update: false
	    });
	    if (nextProps.page.ID !== this.props.page.ID && runtimeHelper.canReview()) {
	      this.props.onLoadComment(this.props.syncID, this.props.syncVersion, nextProps.page.ID);
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    runtimeHelper.canReview() && this.props.onLoadComment(this.props.syncID, this.props.syncVersion, this.props.page.ID);
	  },
	  render: function render() {
	    var style = {};
	    if (this.state.show && this.props.remark) {
	      style.right = 0;
	    } else {
	      style.right = -320;
	    }
	    var className = 'page-remark';
	    if (!runtimeHelper.canReview()) {
	      className += ' no-comments';
	    }
	    return React.createElement(
	      'div',
	      { className: className, style: style },
	      React.createElement('img', { onClick: this.onCloseRemark, className: 'close', src: assetsHelper.getAsset('close-30.png') }),
	      React.createElement(
	        'div',
	        { className: 'tab-bar' },
	        runtimeHelper.canReview() && React.createElement(
	          'span',
	          { className: this.state.current === 'comment' && 'current', onClick: this.onSwitchToComment },
	          i18nHelper.get('COMMENT')
	        ),
	        React.createElement(
	          'span',
	          { className: this.state.current === 'remark' && 'current', onClick: this.onSwitchToRemark },
	          i18nHelper.get('REMARK')
	        )
	      ),
	      this.state.current === 'remark' && React.createElement(
	        'div',
	        { className: 'page-remark-content' },
	        React.createElement(MultilineText, { text: this.props.remark })
	      ),
	      this.state.current === 'comment' && React.createElement(PageComments, {
	        comments: this.props.comments,
	        onAddComment: this.onAddComment,
	        onLoadComment: this.props.onLoadComment,
	        onError: this.props.onError,
	        onClearError: this.props.onClearError,
	        sign: this.props.sign
	      })
	    );
	  },
	
	  onSwitchToComment: function onSwitchToComment() {
	    storeHelper.set('remarkTab', 'comment');
	    this.setState({
	      current: 'comment'
	    });
	  },
	  onSwitchToRemark: function onSwitchToRemark() {
	    storeHelper.set('remarkTab', 'remark');
	    this.setState({
	      current: 'remark'
	    });
	  },
	
	  onCloseRemark: function onCloseRemark() {
	    this.props.onClose();
	  },
	
	  removeSign: function removeSign() {
	    this.props.removeSign();
	  },
	
	  onAddComment: function onAddComment(author, content) {
	    this.props.onAddComment(this.props.syncID, this.props.syncVersion, this.props.page.ID, this.props.pageName, author, content);
	  }
	});
	
	module.exports = PageRemark;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var dataHelper = __webpack_require__(113);
	var util = __webpack_require__(116);
	
	/**
	 * 显示处理多行文字
	 */
	var MultilineText = React.createClass({
	  displayName: 'MultilineText',
	
	  propTypes: {
	    text: React.PropTypes.string.isRequired
	  },
	
	  render: function render() {
	    var text = dataHelper.decodeURIComponent(this.props.text.replace(/\+/g, '%20'));
	    return React.createElement(
	      'div',
	      { className: 'common-multi-line-text' },
	      text && text.split('\n').map(function (line, index) {
	        if (line.trim()) {
	          return React.createElement(
	            'p',
	            { key: index },
	            util.Text.convertSpaceToNbsp(line)
	          );
	        }
	        return React.createElement('br', { key: index });
	      })
	    );
	  }
	});
	
	module.exports = MultilineText;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var storeHelper = __webpack_require__(49);
	var assetsHelper = __webpack_require__(65);
	var i18nHelper = __webpack_require__(46);
	var dateTimeHelper = __webpack_require__(361);
	var ScrollView = __webpack_require__(214);
	
	var testData = '[{"id":548,"content":"dsfcsd","addtime":"2017-05-04T06:40:36.000Z","author":"sdvgf"},{"id":549,"content":"dxvcs","addtime":"2017-05-04T06:40:43.000Z","author":"sdvgf"},{"id":550,"content":"zxvcd","addtime":"2017-05-04T06:40:48.000Z","author":"sdvgf"},{"id":551,"content":"dvc","addtime":"2017-05-04T06:40:49.000Z","author":"sdvgf"},{"id":552,"content":"sd","addtime":"2017-05-04T06:40:50.000Z","author":"sdvgf"},{"id":553,"content":"svcd","addtime":"2017-05-04T06:40:52.000Z","author":"sdvgf"},{"id":554,"content":"dsv","addtime":"2017-05-04T06:40:52.000Z","author":"sdvgf"},{"id":555,"content":"v","addtime":"2017-05-04T06:40:54.000Z","author":"sdvgf"},{"id":566,"content":"sdv","addtime":"2017-05-04T06:40:55.000Z","author":"sdvgf"},{"id":574,"content":"xzvc","addtime":"2017-05-04T06:40:57.000Z","author":"sdvgf"},{"id":575,"content":"ds","addtime":"2017-05-04T06:41:01.000Z","author":"sdvgf"},{"id":576,"content":"sdv","addtime":"2017-05-04T06:41:02.000Z","author":"sdvgf"},{"id":577,"content":"dsvsdf","addtime":"2017-05-04T06:41:05.000Z","author":"sdvgf"}]';
	var testComments = JSON.parse(testData);
	
	function convertToReadableDate(datestr) {
	  return datestr.substring(0, datestr.length - 8).replace('T', ' ');
	}
	
	var PageComments = React.createClass({
	  displayName: 'PageComments',
	
	  propTypes: {
	    comments: React.PropTypes.array,
	    onAddComment: React.PropTypes.func.isRequired,
	    onLoadComment: React.PropTypes.func.isRequired,
	    onError: React.PropTypes.func.isRequired,
	    sign: React.PropTypes.func.isRequired,
	    onClearError: React.PropTypes.func.isRequired
	  },
	  getInitialState: function getInitialState() {
	    return {
	      content: '',
	      hasSign: !!storeHelper.get('sign'),
	      sign: storeHelper.get('sign')
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.comments.length !== this.props.comments.length) {
	      this.setState({
	        content: ''
	      });
	    }
	  },
	  focusReset: false,
	  adjustCommentList: function adjustCommentList() {
	    var scroll = ReactDOM.findDOMNode(this.refs.flex);
	    var scrollContent = $(scroll).find('.scroll-content');
	    $(scrollContent).scrollTop(10000);
	
	    var height = $('.comment-list').height();
	    var width = $('.comment-list').width();
	    $(scroll).css({ position: 'absolute', right: 10, height: height, width: width });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (!this.state.hasSign && this.focusReset) {
	      var node = ReactDOM.findDOMNode(this.refs.signName);
	      var text = $(node).val();
	      $(node).val("").focus().val(text);
	      this.focusReset = false;
	    }
	    this.adjustCommentList();
	  },
	  componentDidMount: function componentDidMount() {
	    var reactContext = this;
	    window.onkeydown = function (e) {
	      if (e.keyCode == 13 && e.ctrlKey) {
	        reactContext.onSubmitComment();
	      }
	    };
	    this.adjustCommentList();
	  },
	  render: function render() {
	    var comments = this.props.comments;
	    //var comments = testComments;
	    //console.log(comments);
	    var sign = storeHelper.get('sign');
	    return React.createElement(
	      'div',
	      { className: 'page-comments' },
	      React.createElement(
	        'div',
	        { className: 'comment-list', ref: 'list' },
	        React.createElement(
	          ScrollView,
	          { ref: 'flex' },
	          comments.map(function (item) {
	            if (item.author === sign) {
	              return React.createElement(
	                'div',
	                { className: 'item item-mine', key: item.id },
	                React.createElement(
	                  'p',
	                  { className: 'content content-mine' },
	                  item.content
	                ),
	                React.createElement(
	                  'div',
	                  { className: 'right-time' },
	                  dateTimeHelper.readableTime(item.addtime)
	                )
	              );
	            }
	            return React.createElement(
	              'div',
	              { className: 'item', key: item.id },
	              React.createElement(
	                'div',
	                { className: 'title' },
	                React.createElement(
	                  'span',
	                  { className: 'author' },
	                  item.author
	                ),
	                React.createElement(
	                  'span',
	                  { className: 'time' },
	                  convertToReadableDate(item.addtime)
	                )
	              ),
	              React.createElement(
	                'div',
	                { className: 'content' },
	                item.content
	              )
	            );
	          }, this)
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'new-comment' },
	        React.createElement('textarea', { onChange: this.onCommentChange, placeholder: i18nHelper.get('COMMENT_HINT'), value: this.state.content }),
	        React.createElement(
	          'div',
	          { className: 'submit' },
	          React.createElement(
	            'div',
	            { className: 'sign' },
	            React.createElement(
	              'span',
	              { className: 'lab' },
	              i18nHelper.get('SIGN_LABEL')
	            ),
	            this.state.hasSign && React.createElement(
	              'span',
	              { className: 'name' },
	              this.state.sign
	            ),
	            this.state.hasSign && React.createElement('img', { onClick: this.onResetSign, src: assetsHelper.getAsset('/review/icon_edit_name.png'),
	              alt: 'reset name' }),
	            this.state.hasSign || React.createElement('input', { ref: 'signName', type: 'text', value: this.state.sign, onChange: this.setSign, placeholder: i18nHelper.get('SIGN_HINT') })
	          ),
	          React.createElement(
	            'button',
	            { className: this.state.sign && this.state.sign.trim() && this.state.content.trim() ? '' : 'disabled',
	              onClick: this.onSubmitComment },
	            i18nHelper.get('SUBMIT')
	          )
	        )
	      )
	    );
	  },
	  setSign: function setSign(e) {
	    this.setState({
	      sign: e.target.value
	    });
	  },
	  onResetSign: function onResetSign() {
	    this.focusReset = true;
	    this.setState({
	      hasSign: false
	    });
	  },
	  onCommentChange: function onCommentChange(e) {
	    this.setState({
	      content: e.target.value
	    });
	  },
	  clearErrorCallback: function clearErrorCallback() {
	    this.props.onClearError();
	    this.onResetSign();
	  },
	  onSubmitComment: function onSubmitComment() {
	    if (!this.state.sign || !this.state.sign.trim()) {
	      return this.props.onError(i18nHelper.get('ENTER_SIGN'), this.clearErrorCallback);
	    }
	    this.props.sign(this.state.sign.trim());
	    if (this.state.sign.trim() && this.state.content.trim()) {
	      this.props.onAddComment(this.state.sign.trim(), this.state.content.trim());
	    }
	    this.setState({
	      content: '',
	      hasSign: true
	    });
	  }
	});
	
	module.exports = PageComments;

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	'use strict';
	
	function padLeft(str, length, prefix) {
	  str = str.toString();
	  if (str.length >= length) {
	    return str;
	  }
	  for (var i = 0; i < length - str.length; i++) {
	    str = prefix + str;
	  }
	  return str;
	}
	
	exports.readableTime = function (datestr) {
	  var date = new Date(datestr);
	  return date.getFullYear() + '-' + padLeft(date.getMonth() + 1, 2, '0') + '-' + padLeft(date.getDate(), 2, '0') + ' ' + padLeft(date.getHours(), 2, '0') + ':' + padLeft(date.getMinutes(), 2, '0');
	};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	var CommentTool = __webpack_require__(363);
	var FullPage = __webpack_require__(364);
	var ErrorMessage = __webpack_require__(354);
	
	var PagePaint = React.createClass({
	  displayName: 'PagePaint',
	
	  propTypes: {
	    background: React.PropTypes.string.isRequired,
	    domSize: React.PropTypes.object.isRequired,
	    meta: React.PropTypes.object.isRequired,
	    page: React.PropTypes.object.isRequired,
	    syncID: React.PropTypes.string.isRequired,
	    syncVersion: React.PropTypes.string.isRequired,
	    pageName: React.PropTypes.string.isRequired,
	    review: React.PropTypes.array,
	    onExitPaint: React.PropTypes.func.isRequired,
	    sign: React.PropTypes.func.isRequired,
	    isSign: React.PropTypes.bool.isRequired,
	    onLoadReviewData: React.PropTypes.func.isRequired,
	    onAddReview: React.PropTypes.func.isRequired,
	    onUpdateReview: React.PropTypes.func.isRequired,
	    onRemoveReview: React.PropTypes.func.isRequired,
	    error: React.PropTypes.string,
	    onClearError: React.PropTypes.func.isRequired,
	    onError: React.PropTypes.func.isRequired
	  },
	  getInitialState: function getInitialState() {
	    return {
	      fullPageLocation: null,
	      scrollLeft: 0
	    };
	  },
	  render: function render() {
	    var page = this.props.page;
	    var pageWidth = parseInt(page.measureW, 10);
	    var pageHeight = parseInt(page.measureH, 10);
	    var domSize = this.props.domSize;
	    return React.createElement(
	      'div',
	      { className: 'paint', style: {
	          background: this.props.background
	        } },
	      React.createElement(ErrorMessage, { error: this.props.error,
	        onClearError: this.myOnClearError
	      }),
	      React.createElement(
	        'div',
	        { className: 'paint-wrapper', onScroll: this.scroll },
	        React.createElement(CommentTool, {
	          page: page,
	          onToggleCommentMode: this.props.onToggleCommentMode,
	          deviceScrollStyle: {
	            width: Math.max(domSize.width, parseInt(page.measureW, 10)),
	            height: pageHeight + 80 + 30
	          },
	          scrollLeft: this.state.scrollLeft,
	          review: this.props.review,
	          onExitPaint: this.props.onExitPaint,
	          onAddReview: this.onAddReview,
	          onUpdateReview: this.onUpdateReview,
	          onRemoveReview: this.onRemoveReview,
	          fullPageLocation: this.state.fullPageLocation,
	          sign: this.props.sign,
	          isSign: this.props.isSign,
	          onError: this.myOnError,
	          onClearError: this.props.onClearError,
	          syncID: this.props.syncID,
	          syncVersion: this.props.syncVersion,
	          ID: this.props.page.ID
	        }),
	        React.createElement(FullPage, {
	          page: page,
	          pageDidLoad: this.pageDidLoad,
	          fullPageLocation: this.state.fullPageLocation
	        })
	      )
	    );
	  },
	  scroll: function scroll(e) {
	    this.setState({ scrollLeft: e.target.scrollLeft });
	  },
	  componentDidMount: function componentDidMount() {
	    this.props.onLoadReviewData(this.props.syncID, this.props.syncVersion, this.props.page.ID);
	    var self = this;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    window.onScroll = null;
	  },
	  pageDidLoad: function pageDidLoad(location) {
	    this.setState({ fullPageLocation: location });
	  },
	  onAddReview: function onAddReview(layer) {
	    this.props.onAddReview(this.props.syncID, this.props.syncVersion, this.props.page.ID, this.props.pageName, layer.data.author, JSON.stringify(layer));
	  },
	  onUpdateReview: function onUpdateReview(id, author, data) {
	    this.props.onUpdateReview(this.props.syncID, this.props.syncVersion, this.props.page.ID, author, id, JSON.stringify(data));
	  },
	  onRemoveReview: function onRemoveReview(author, id) {
	    this.props.onRemoveReview(this.props.syncID, this.props.syncVersion, this.props.page.ID, author, id);
	  },
	  myOnClearError: null,
	  myOnError: function myOnError(error, myOnClearError) {
	    if (myOnClearError) {
	      this.myOnClearError = myOnClearError;
	    } else {
	      this.myOnClearError = this.props.onClearError;
	    }
	    this.props.onError(error);
	  }
	});
	
	module.exports = PagePaint;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var assetsHelper = __webpack_require__(65);
	var styleHelper = __webpack_require__(145);
	var i18nHelper = __webpack_require__(46);
	var storeHelper = __webpack_require__(49);
	var appTypes = __webpack_require__(115);
	
	var StylePicker = __webpack_require__(342);
	var SaveAlert = __webpack_require__(343);
	var ProcessAlert = __webpack_require__(344);
	var SignCheckAlert = __webpack_require__(345);
	var PaintToolbar = __webpack_require__(346);
	
	var graphicsHelper = __webpack_require__(172);
	
	var Mediator = __webpack_require__(347);
	var Opreations = __webpack_require__(348);
	var Events = __webpack_require__(349);
	var LayerManager = __webpack_require__(350);
	var Data = __webpack_require__(351);
	var Tool = __webpack_require__(352);
	var InputText = __webpack_require__(353);
	var ErrorMessage = __webpack_require__(354);
	
	var optimizeCall = __webpack_require__(136);
	var optimizedResizeCall = optimizeCall();
	
	var BUTTON_KEY = {
	  'PENCIL': 'pencil', 'RECT': 'rect', 'ARROW': 'arrow', 'ARC': 'arc',
	  'TEXT': 'text', 'MOUSE': 'mouse'
	};
	
	var CommentTool = React.createClass({
	  displayName: 'CommentTool',
	
	
	  propTypes: {
	    page: React.PropTypes.object.isRequired,
	    deviceScrollStyle: React.PropTypes.object.isRequired,
	    scrollLeft: React.PropTypes.number.isRequired,
	    review: React.PropTypes.array.isRequired,
	    onExitPaint: React.PropTypes.func.isRequired,
	    onAddReview: React.PropTypes.func.isRequired,
	    onUpdateReview: React.PropTypes.func.isRequired,
	    onRemoveReview: React.PropTypes.func.isRequired,
	    fullPageLocation: React.PropTypes.object,
	    sign: React.PropTypes.func.isRequired,
	    isSign: React.PropTypes.bool.isRequired,
	    onError: React.PropTypes.func.isRequired,
	    onClearError: React.PropTypes.func.isRequired,
	    syncID: React.PropTypes.string.isRequired,
	    syncVersion: React.PropTypes.string.isRequired,
	    ID: React.PropTypes.string.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      checkedKey: BUTTON_KEY.MOUSE,
	      isShowStylePicker: false,
	      checkedTool: 'ArrowTool',
	      isShowSaveAlert: false,
	      isVisible: true,
	      update: true,
	      isBackColor: false,
	      isSaveError: false,
	      saveErrMsg: '',
	      saveDisabled: true,
	      undoDisabled: true,
	      redoDisabled: true,
	      onExit: false,
	      isToolbarMountDone: false,
	      location: null,
	
	      cursor: 'crosshair'
	    };
	  },
	
	  canvas: null,
	
	  componentWillMount: function componentWillMount() {
	    //初始化
	    Mediator.init(this, Opreations, Events, LayerManager, Data, Tool, InputText);
	    Data.isSaved = true;
	    this.checkData();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.canvas = ReactDOM.findDOMNode(this.refs.canvas);
	    Mediator.initEvents(this.state.checkedTool);
	    Mediator.setVisible(this.state.isVisible);
	    Tool.initStyle();
	
	    window.onbeforeunload = function () {
	      var warning = "确认退出?";
	      return warning;
	    };
	    var self = this;
	    optimizedResizeCall.add(this.adjustCanvas);
	    var documentEl;
	    if (document.documentElement) {
	      documentEl = document.documentElement;
	    } else if (document.body) {
	      documentEl = document.body;
	    }
	    window.onscroll = function () {
	      self.scrollTop = documentEl.scrollTop;
	      optimizedResizeCall.call();
	    };
	  },
	  cursorStyle: null,
	  componentWillUpdate: function componentWillUpdate() {
	    this.cursorStyle = this.canvas.style.cursor;
	    this.checkData();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.scrollLeft = this.props.scrollLeft;
	    this.adjustCanvas();
	    if (this.props.fullPageLocation) {
	      Data.loadData2();
	    }
	    this.canvas.style.cursor = this.cursorStyle;
	    Mediator.setVisible(this.state.isVisible);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    Data.currentState = null;
	    window.onbeforeunload = null;
	    window.onScroll = null;
	    optimizedResizeCall.remove(this.adjustCanvas);
	  },
	
	  translateY: 0,
	  translateX: 0,
	  scrollTop: 0,
	  scrollLeft: 0,
	  adjustCanvas: function adjustCanvas() {
	    var ctx = this.canvas.getContext('2d');
	    ctx.translate(this.translateX - this.scrollLeft, this.translateY - this.scrollTop);
	    this.translateY = this.scrollTop;
	    this.translateX = this.scrollLeft;
	    Data.loadData2();
	  },
	
	  catchError: false,
	  checkData: function checkData() {
	    if (storeHelper.get('netState') === 'failed') {
	      storeHelper.set('netState', 'init');
	      storeHelper.set('loadState', 'init');
	      this.props.onError(i18nHelper.get('NET_ERROR'), this.onClearNetError);
	    }
	    if (storeHelper.get('loadState') === 'failed') {
	      storeHelper.set('loadState', 'init');
	      this.props.onError(i18nHelper.get('LOAD_REVIEW_FAILED'));
	    }
	
	    Data.handleSave2();
	    //在已经加载目标页面的情况下。加载数据
	    if (this.props.fullPageLocation) {
	      Data.loadData2();
	    }
	    Data.initStates();
	
	    //当前处于退出批注状态，全部数据保存完毕，且无保存失败数据
	    if (this.state.onExit && Data.saveDone && Data.saveSuccess) {
	      this.props.onExitPaint();
	    }
	    if (!Data.saveSuccess && !this.catchError) {
	      //有数据保存失败，且未被用户确认
	      this.props.onError(Data.saveErrMsg, this.onClearError);
	      this.catchError = true;
	    }
	  },
	  canvasWidth: 0,
	  canvasHeight: 0,
	  render: function render() {
	    var page = this.props.page;
	    var saveSuccess = storeHelper.get('saveSuccess');
	    var className = 'commentMode-popWindow';
	    if (document.body.clientWidth !== this.canvasWidth || document.body.clientHeight !== this.canvasHeight) {
	      this.canvasWidth = document.body.clientWidth;
	      this.canvasHeight = document.body.clientHeight;
	      this.translateX = 0;
	      this.translateY = 0;
	    }
	    var w = Math.min(this.props.deviceScrollStyle.width, this.canvasWidth);
	    var h = Math.min(this.props.deviceScrollStyle.height, this.canvasHeight - 15);
	    var canvasStyle = {
	      position: 'fixed',
	      left: 0,
	      top: 0,
	      cursor: this.state.cursor,
	      height: h,
	      width: w
	    };
	    return React.createElement(
	      'div',
	      { className: className, style: this.props.deviceScrollStyle },
	      React.createElement(PaintToolbar, {
	        page: page,
	        onMouseClick: this.changeToMouse,
	        onRectangleClick: this.changeToRect,
	        onFilledRectangleClick: this.changeToFilledRect,
	        onEllipseClick: this.changeToArc,
	        onFilledEllipseClick: this.changeToFilledArc,
	        onArrowClick: this.changeToArrow,
	        onPencilClick: this.changeToPencil,
	        onTextClick: this.changeToText,
	        onSaveClick: this.save,
	        onUndoClick: this.rollBack,
	        onRedoClick: this.reRollBack,
	        onDeleteClick: this.deleteLayer,
	        onHiddenClick: this.hidden,
	        onClearClick: this.clearSelf,
	        onExitClick: this.exit,
	        checkTool: this.state.checkedTool,
	        saveDisabled: !Data.isSavable(),
	        undoDisabled: !Data.isUndoable(),
	        redoDisabled: !Data.isRedoable(),
	        isVisible: this.state.isVisible,
	        isClearable: Mediator.isClearable(),
	        onToolbarMountDone: this.onToolbarMountDone
	      }),
	      React.createElement(
	        'div',
	        null,
	        React.createElement('canvas', { ref: 'canvas',
	          width: w,
	          height: h,
	          style: canvasStyle
	        })
	      ),
	      this.state.isShowStylePicker && this.state.isToolbarMountDone && React.createElement(StylePicker, {
	        checkedTool: this.state.checkedTool,
	        colorChecked: this.colorChecked,
	        backColorChecked: this.backColorChecked,
	        backAlphaCheck: this.backAlphaCheck,
	        lineWidthChecked: this.lineWidthChecked,
	        fontSizeChecked: this.fontSizeChecked,
	        isBackColor: this.state.isBackColor,
	        switchToFront: this.switchToFront,
	        switchToBack: this.switchToBack,
	        location: this.state.location
	      }),
	      !this.props.isSign && React.createElement(SignCheckAlert, {
	        registKeyEvent: Mediator.registKeyEvent,
	        onExitPaint: this.props.onExitPaint,
	        sign: this.props.sign
	      }),
	      this.state.isShowSaveAlert && React.createElement(SaveAlert, {
	        registKeyEvent: Mediator.registKeyEvent,
	        onDismissSaveAlert: this.onDismissSaveAlert,
	        onSave: this.onSave
	      }),
	      !Data.saveDone && React.createElement(ProcessAlert, {
	        max: Data.saveTotal,
	        value: Data.doneNum
	      }),
	      React.createElement(
	        'form',
	        null,
	        React.createElement('textArea', {
	          ref: 'text',
	          className: 'input-text',
	          onChange: this.handleChange
	        })
	      ),
	      storeHelper.get('loadState') === 'wait' && React.createElement(
	        'div',
	        { className: 'pop-alert-cover' },
	        React.createElement(
	          'div',
	          { className: 'pop-alert' },
	          React.createElement(
	            'span',
	            { className: 'loading' },
	            i18nHelper.get('REVIEW_LOADING')
	          )
	        )
	      )
	    );
	  },
	
	  handleChange: function handleChange(event) {
	    var text = event.target.value;
	    Mediator.adapteText(text);
	  },
	
	  update: function update() {
	    this.setState({ update: !this.state.update });
	  },
	
	  switchToFront: function switchToFront() {
	    this.setState({ isBackColor: false });
	  },
	
	  switchToBack: function switchToBack() {
	    this.setState({ isBackColor: true });
	  },
	  colorChecked: function colorChecked(value) {
	    var key = this.state.checkedTool;
	    Tool.setStyle(key, 'color', value);
	    this.update();
	  },
	  backColorChecked: function backColorChecked(value) {
	    var key = this.state.checkedTool;
	    Tool.setStyle(key, 'backColor', value);
	    this.update();
	  },
	  backAlphaCheck: function backAlphaCheck(value) {
	    var key = this.state.checkedTool;
	    Tool.setStyle(key, 'backColorAlpha', value / 100);
	    this.setState({ backAlpha: value });
	  },
	  lineWidthChecked: function lineWidthChecked(value) {
	    var key = this.state.checkedTool;
	    Tool.setStyle(key, 'strokeWidth', value);
	    this.update();
	  },
	  fontSizeChecked: function fontSizeChecked(value) {
	    var key = this.state.checkedTool;
	    Tool.setStyle(key, 'fontSize', value);
	    this.update();
	  },
	  onDismissSaveAlert: function onDismissSaveAlert() {
	    this.setState({ isShowSaveAlert: false });
	  },
	  onClearError: function onClearError() {
	    //重置默认值
	    this.catchError = false;
	    Data.saveSuccess = true;
	    Data.saveErrMsg = '';
	    this.props.onClearError();
	  },
	  onClearNetError: function onClearNetError() {
	    storeHelper.get('netState') === 'init';
	    this.props.onExitPaint();
	    this.props.onClearError();
	  },
	  deleteLayer: function deleteLayer() {
	    Mediator.deleteLayer();
	    this.setState({ isShowStylePicker: false });
	  },
	  hidden: function hidden() {
	    this.setState({ isShowStylePicker: false, isVisible: !this.state.isVisible });
	  },
	  clearSelf: function clearSelf() {
	    Mediator.clearSelf();
	  },
	  rollBack: function rollBack() {
	    if (!Data.isUndoable()) {
	      return;
	    }
	    Data.rollBack2();
	    this.setState({ isShowStylePicker: false, update: !this.state.update });
	  },
	  reRollBack: function reRollBack() {
	    if (!Data.isRedoable()) {
	      return;
	    }
	    Data.reRollBack2();
	    this.setState({ isShowStylePicker: false, update: !this.state.update });
	  },
	  onSave: function onSave(isSave) {
	    if (isSave) {
	      Mediator.reset();
	      Data.startSave2(true);
	      this.setState({ isShowSaveAlert: false, onExit: true });
	    } else {
	      Data.clearLocal();
	      this.props.onExitPaint();
	    }
	  },
	  save: function save() {
	    if (!Data.isSavable()) {
	      return;
	    }
	    Mediator.reset();
	    Data.startSave2();
	    this.setState({ isShowStylePicker: false });
	  },
	  exit: function exit() {
	    if (Data.isSavable()) {
	      this.setState({ isShowSaveAlert: true });
	    } else {
	      this.props.onExitPaint();
	    }
	  },
	
	  onToolbarMountDone: function onToolbarMountDone(location) {
	    if (location) {
	      this.setState({ isToolbarMountDone: true, location: location });
	    }
	  },
	  changeToRect: function changeToRect(e) {
	    Mediator.reset();
	    Mediator.initEvents('RectTool');
	    this.setState({ isShowStylePicker: true, checkedTool: 'RectTool', isVisible: true });
	  },
	  changeToFilledRect: function changeToFilledRect() {
	    Mediator.reset();
	    Mediator.initEvents('FilledRectTool');
	    this.setState({ isShowStylePicker: true, checkedTool: 'FilledRectTool', isVisible: true });
	  },
	  changeToPencil: function changeToPencil() {
	    Mediator.reset();
	    Mediator.initEvents('PencilTool');
	    this.setState({ isShowStylePicker: true, checkedTool: 'PencilTool', isVisible: true });
	  },
	  changeToArrow: function changeToArrow() {
	    Mediator.reset();
	    Mediator.initEvents('ArrowTool');
	    this.setState({ isShowStylePicker: true, checkedTool: 'ArrowTool', isVisible: true });
	  },
	  changeToArc: function changeToArc() {
	    Mediator.reset();
	    Mediator.initEvents('EllipseTool');
	    this.setState({ isShowStylePicker: true, checkedTool: 'EllipseTool', isVisible: true });
	  },
	  changeToFilledArc: function changeToFilledArc() {
	    Mediator.reset();
	    Mediator.initEvents('FilledEllipseTool');
	    this.setState({ isShowStylePicker: true, checkedTool: 'FilledEllipseTool', isVisible: true });
	  },
	  changeToText: function changeToText() {
	    Mediator.reset();
	    Mediator.initEvents('TextTool');
	    this.setState({ isShowStylePicker: true, checkedTool: 'TextTool', isVisible: true });
	  },
	  changeToMouse: function changeToMouse() {
	    Mediator.reset();
	    Mediator.initEvents('MouseTool');
	    this.setState({ isShowStylePicker: false, checkedTool: 'MouseTool', isVisible: true });
	  }
	});
	
	module.exports = CommentTool;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var Components = __webpack_require__(142);
	var pageHelper = __webpack_require__(119);
	
	var FullPage = React.createClass({
	  displayName: 'FullPage',
	
	  propTypes: {
	    page: React.PropTypes.object.isRequired,
	    pageDidLoad: React.PropTypes.func.isRequired,
	    fullPageLocation: React.PropTypes.object
	  },
	  componentDidMount: function componentDidMount() {
	    var offset = $('.full-page').offset();
	    this.props.pageDidLoad(offset);
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    var oldLocation = nextProps.fullPageLocation;
	    var newLocation = $('.full-page').offset();
	    //终止update死循环
	    if (oldLocation.left === newLocation.left && oldLocation.top === newLocation.top) {
	      return false;
	    }
	    return true;
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var offset = $('.full-page').offset();
	    this.props.pageDidLoad(offset);
	  },
	
	  render: function render() {
	    var page = JSON.parse(JSON.stringify(this.props.page));
	    var backgroundColor = page.param[0].backgroundColor;
	    var components = page.controls.control || [];
	    //批注里面过滤掉不可使组件
	    for (var i = components.length - 1; i >= 0; i--) {
	      if (pageHelper.IsInvisualInteractiveCom(components[i].controlTypeID)) {
	        components.splice(i, 1);
	      }
	    }
	    return React.createElement(
	      'div',
	      { className: 'full-page', style: {
	          width: page.measureW,
	          height: page.measureH,
	          background: backgroundColor
	        } },
	      React.createElement(Components, { components: components })
	    );
	  }
	});
	
	module.exports = FullPage;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var assetsHelper = __webpack_require__(65);
	var i18nHelper = __webpack_require__(46);
	
	var SaveAlert = React.createClass({
	    displayName: 'SaveAlert',
	
	
	    propTypes: {
	        onCloseCopiedAlert: React.PropTypes.func
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'pop-alert-cover' },
	            React.createElement(
	                'div',
	                { className: 'pop-alert' },
	                React.createElement('img', { className: 'close', src: assetsHelper.getAsset('close2.png'), onClick: this.props.onCloseCopiedAlert }),
	                React.createElement(
	                    'p',
	                    { className: 'content' },
	                    i18nHelper.get('COPIED_PAGE_LINK')
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'btns' },
	                    React.createElement('input', { className: 'save', type: 'button', onClick: this.props.onCloseCopiedAlert, value: i18nHelper.get('BUTTON_SURE') })
	                )
	            )
	        );
	    },
	
	    componentDidUpdate: function componentDidUpdate() {},
	
	    componentDidMount: function componentDidMount() {}
	
	});
	
	module.exports = SaveAlert;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	var ReactDOM = __webpack_require__(12);
	var dateTimeHelper = __webpack_require__(361);
	var assetsHelper = __webpack_require__(65);
	var ScrollView = __webpack_require__(214);
	var storeHelper = __webpack_require__(49);
	var i18nHelper = __webpack_require__(46);
	
	var testData = '[{"name":"最新版本","revision":29,"addtime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html",' + '"reviews":[' + '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","author":"qwe","data":"rtyaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' + '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' + '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' + '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' + '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' + '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' + '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' + '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' + '{"id":324,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"rty","type":"comment","addtime":"2017-05-03T11:01:41.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' + '{"id":322,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"qwe","data":"sd","type":"comment","addtime":"2017-05-03T10:50:14.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"},' + '{"id":305,"projectid":"BVAe614eWI","revision":29,"pageid":"21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2","pagename":"页面","author":"撒发射点发阿萨德发送到发生大幅阿斯蒂芬阿萨德发生大幅阿萨德发生的发生大幅阿斯蒂芬阿斯蒂芬阿斯蒂芬撒旦","data":"去","type":"comment","addtime":"2017-05-03T10:35:20.000Z","revisiontime":"2017-05-03T09:47:13.000Z","URL":"https://share.mockplus.cn/go/QAFGBCJ8RHMFUNE4/index.html?to=21D735C0-ED7D-42FE-9BF3-A3D0838FE7C2&t=r"}' + ']' + '}]';
	var testReviews = JSON.parse(testData);
	
	var AppReviews = React.createClass({
	  displayName: 'AppReviews',
	
	  propTypes: {
	    name: React.PropTypes.string.isRequired,
	    projectReviews: React.PropTypes.array,
	    syncID: React.PropTypes.string.isRequired,
	    onLoadProjecReviews: React.PropTypes.func.isRequired,
	    onCloseAppReviews: React.PropTypes.func.isRequired
	  },
	  getInitialState: function getInitialState() {
	    return {
	      currentRevision: -1
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.state.currentRevision === -1 && nextProps.projectReviews.length > 0) {
	      this.setState({
	        currentRevision: nextProps.projectReviews[0].revision
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    this.props.onLoadProjecReviews(this.props.syncID);
	    this.adjustScroll();
	  },
	
	  isBad: false,
	  adjustScroll: function adjustScroll() {
	    var h = $('.scroll-view').height();
	    if (!this.isBad && h === 0) {
	      this.isBad = true;
	    }
	    //兼容部分浏览器不识别flex布局生成的高度
	    if (this.isBad) {
	      var box = $('.revisions-and-reviews');
	      var height = box.height();
	      box.find('.scroll-view').css({ height: height });
	      box.find('.thumb').css({ height: 0 });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var dom = ReactDOM.findDOMNode(this.refs.reviews);
	    if (dom) {
	      dom.scrollTop = 1;
	      dom.scrollTop = 0;
	    }
	
	    this.adjustScroll();
	  },
	  render: function render() {
	    var reviews = this.props.projectReviews;
	    var currentRevision = this.state.currentRevision;
	    //var reviews = testReviews;
	    //var currentRevision = 29;
	    return React.createElement(
	      'div',
	      { className: 'app-reviews' },
	      React.createElement(
	        'div',
	        { className: 'app-reviews-dialog' },
	        React.createElement(
	          'h2',
	          null,
	          this.props.name
	        ),
	        React.createElement('img', { onClick: this.props.onCloseAppReviews, className: 'close', src: assetsHelper.getAsset('close-30.png') }),
	        reviews.length > 0 && React.createElement(
	          'div',
	          { className: 'revisions-and-reviews' },
	          React.createElement(
	            'div',
	            { className: 'revisions' },
	            React.createElement(
	              ScrollView,
	              null,
	              reviews.map(function (review) {
	                return React.createElement(
	                  'div',
	                  { className: review.revision === currentRevision ? 'revision current' : 'revision',
	                    onClick: this.onSwitchRevision.bind(this, review.revision) },
	                  React.createElement(
	                    'p',
	                    { className: 'title' },
	                    review.name
	                  ),
	                  React.createElement(
	                    'p',
	                    { className: 'time' },
	                    dateTimeHelper.readableTime(review.addtime)
	                  )
	                );
	              }, this)
	            )
	          ),
	          React.createElement(
	            'div',
	            { className: 'reviews', ref: 'reviews' },
	            React.createElement(
	              ScrollView,
	              null,
	              reviews.map(function (revision) {
	                return revision.reviews.filter(function (item) {
	                  return item.revision === currentRevision;
	                }).map(function (review) {
	
	                  if (review.type === 'comment') {
	                    return React.createElement(
	                      'div',
	                      { className: 'review comment' },
	                      React.createElement(
	                        'div',
	                        { className: 'title' },
	                        React.createElement(
	                          'span',
	                          { className: 'name' },
	                          review.author
	                        ),
	                        React.createElement(
	                          'span',
	                          { className: 'time' },
	                          dateTimeHelper.readableTime(review.addtime)
	                        )
	                      ),
	                      React.createElement(
	                        'p',
	                        { className: 'content' },
	                        review.data
	                      ),
	                      React.createElement(
	                        'div',
	                        null,
	                        React.createElement(
	                          'a',
	                          { href: review.URL },
	                          review.pagename || i18nHelper.get('VIEW_COMMENT')
	                        )
	                      )
	                    );
	                  }
	                  return React.createElement(
	                    'div',
	                    { className: 'review notation' },
	                    React.createElement(
	                      'div',
	                      { className: 'title' },
	                      React.createElement(
	                        'span',
	                        { className: 'name' },
	                        review.author
	                      ),
	                      React.createElement(
	                        'span',
	                        { className: 'time' },
	                        dateTimeHelper.readableTime(review.addtime)
	                      )
	                    ),
	                    React.createElement(
	                      'p',
	                      { className: 'content' },
	                      i18nHelper.get('PAINT_TIP')
	                    ),
	                    React.createElement(
	                      'div',
	                      null,
	                      React.createElement(
	                        'a',
	                        { href: review.URL },
	                        review.pagename || i18nHelper.get('VIEW_MARK')
	                      )
	                    )
	                  );
	                });
	              })
	            )
	          )
	        ),
	        reviews.length === 0 && React.createElement(
	          'p',
	          { className: 'no-data' },
	          i18nHelper.get('NO_REVIEW')
	        )
	      )
	    );
	  },
	  onSwitchRevision: function onSwitchRevision(revision) {
	    this.setState({
	      currentRevision: revision
	    });
	  }
	});
	
	module.exports = AppReviews;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(11);
	
	var UX2017Work = React.createClass({
	  displayName: 'UX2017Work',
	
	  getInitialState: function getInitialState() {
	    return {
	      showAd: true
	    };
	  },
	  render: function render() {
	    var style = {
	      display: this.state.showAd ? 'block' : 'none'
	    };
	    return React.createElement(
	      'div',
	      { className: 'ux2017-work', style: style },
	      React.createElement('div', { onClick: this.onClose, className: 'close' }),
	      React.createElement(
	        'p',
	        null,
	        '\u8FD9\u4E2A\u539F\u578B\u6B63\u5728\u53C2\u52A0Mockplus\u539F\u578B\u8BBE\u8BA1\u5927\u8D5B\u3002'
	      ),
	      React.createElement(
	        'p',
	        null,
	        '\u53C2\u8D5B\u53EF\u8D62\u53D6 iPhone 8\uFF01'
	      ),
	      React.createElement(
	        'p',
	        null,
	        '\u4E86\u89E3\u5927\u8D5B\u8BE6\u60C5\uFF0C',
	        React.createElement(
	          'a',
	          { href: 'https://www.mockplus.cn/ux2017' },
	          '\u8BF7\u731B\u6233\u8FD9\u91CC>>'
	        )
	      )
	    );
	  },
	  onClose: function onClose() {
	    this.setState({
	      showAd: false
	    });
	  }
	});
	
	module.exports = UX2017Work;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js